import * as i0 from '@angular/core';
import { Component, Input, NgModule, InjectionToken, Injectable, EventEmitter, Inject, Output, Directive, HostListener, Pipe, ViewChild, HostBinding, Injector, ViewChildren, forwardRef, ChangeDetectionStrategy } from '@angular/core';
import * as i1 from 'ngx-avatar-2';
import { AvatarModule } from 'ngx-avatar-2';
export * from 'ngx-avatar-2';
import * as i1$2 from '@angular/common';
import { CommonModule, DOCUMENT } from '@angular/common';
import { faJsSquare, faGoogle } from '@fortawesome/free-brands-svg-icons';
import { faUpRightFromSquare, faChartSimple, faStopCircle, faHome, faFilePdf, faRetweet, faUndo, faEdit, faArchive, faBox, faPlay, faAtlas, faCaretRight, faCaretLeft, faCaretUp, faCaretDown, faPaperPlane, faHdd, faCalendarMinus, faSearchPlus, faGavel, faChartLine, faCheckSquare, faHeartbeat, faChevronLeft, faChevronUp, faMousePointer, faDownload, faTimesCircle, faAlignJustify, faBell, faExclamation, faBug, faGraduationCap, faEyeSlash, faFilter, faFire, faRedoAlt, faInfoCircle, faArrowUp, faSpinner, faSearch, faExternalLinkAlt, faCopy, faSync, faChevronRight, faClock, faFileImport, faBars, faInfo, faPlus, faLink, faChevronDown, faBookmark, faFrown, faMeh, faSmile, faQuestionCircle, faTags, faTag, faWindowRestore, faCalendarAlt, faNewspaper, faUniversity, faTasks, faBook, faClipboardCheck, faUserSecret, faBan, faClone, faEye, faUniversalAccess, faChartPie, faPencilAlt, faSyncAlt, faCode, faExclamationTriangle, faComment, faGlobeAmericas, faGlobe, faTimes, faBuilding, faArrowDown, faCheck, faPause, faSpider, faTrashAlt, faCog, faFileAlt, faLock, faFileInvoice, faUsers, faUser } from '@fortawesome/free-solid-svg-icons';
import * as i1$1 from '@fortawesome/angular-fontawesome';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import * as i1$4 from '@ng-bootstrap/ng-bootstrap';
import { NgbDropdownModule, NgbPaginationModule, NgbModule, NgbTooltipModule, NgbDropdown, NgbProgressbarModule, NgbActiveModal, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import * as i1$5 from '@angular/forms';
import { Validators, NG_VALIDATORS, NG_VALUE_ACCESSOR, FormsModule, ReactiveFormsModule, NgForm, ControlContainer } from '@angular/forms';
import * as i5 from 'ng-click-outside2';
import { NgClickOutsideDirective } from 'ng-click-outside2';
import * as i1$3 from 'ngx-toastr';
import { ToastrModule } from 'ngx-toastr';
import * as i2 from 'ngx-color/chrome';
import { ColorChromeModule } from 'ngx-color/chrome';
import { trigger, state, transition, style, animate } from '@angular/animations';
import * as i3 from '@angular/cdk/a11y';
import { A11yModule } from '@angular/cdk/a11y';
import { isEqual, cloneDeep, debounce, merge } from 'lodash';
import { __decorate, __param } from 'tslib';
import { BehaviorSubject, Observable } from 'rxjs';
import { TranslateService as TranslateService$1 } from '@monsido_services/services/mon-translate/dist/translate.service';
import moment from 'moment';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import 'daterangepicker';
import $ from 'jquery';
import Rollbar from 'rollbar';
import * as i1$6 from 'ngx-select-ex';
import { NgxSelectModule } from 'ngx-select-ex';
import throttle from 'lodash/throttle';
import { MonEventsServiceFactory } from '@monsido_services/services/mon-events/dist/mon-events.service';
import { BrowserModule } from '@angular/platform-browser';
import * as i3$1 from 'ng2-charts';
import { BaseChartDirective, NgChartsModule } from 'ng2-charts';
export { BaseChartDirective } from 'ng2-charts';
import 'chartjs-adapter-moment';
import { Chart } from 'chart.js';
export * from 'chart.js';
import * as i3$2 from 'ngx-clipboard';
import { ClipboardModule } from 'ngx-clipboard';
import * as i1$7 from 'ngx-device-detector';
import { LitElement, css, html } from 'lit';
import { property, state as state$1, customElement } from 'lit/decorators.js';
import { createRef, ref } from 'lit/directives/ref.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import '@a11y/focus-trap';

class StringService {
    static capitalize(word) {
        if (word) {
            return word.charAt(0).toUpperCase() + word.slice(1);
        }
        return word;
    }
    static camelize(str) {
        const arr = str.split('_');
        const capital = arr.map((item, index) => index
            ? item.charAt(0).toUpperCase() + item.slice(1).toLowerCase()
            : item);
        return capital.join('');
    }
    static removeWhiteSpaces(input) {
        return input.replace(/\s+/g, '');
    }
    static escapeRegExp(input) {
        return input ? input.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') : '';
    }
}

class AvatarEmailComponent {
    constructor() {
        this.round = true;
    }
    getName() {
        let name = StringService.capitalize(this.user.first_name);
        if (this.user.last_name) {
            name += ' ' + StringService.capitalize(this.user.last_name);
        }
        return name;
    }
    getAvatarInitials() {
        let name = StringService.capitalize(this.user.first_name || '').split(' ')[0];
        if (this.user.last_name) {
            name +=
                ' ' +
                    StringService.capitalize(this.user.last_name).split(' ')[0];
        }
        return [name].join(' ').trim();
    }
    static { this.ɵfac = function AvatarEmailComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AvatarEmailComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AvatarEmailComponent, selectors: [["mon-email-avatar"]], inputs: { user: "user", round: "round" }, decls: 10, vars: 7, consts: [[1, "text-nowrap"], ["size", "30", 1, "inline-block-important", 3, "name", "round", "textSizeRatio"], [1, "inline-block-important", "outer-l-small"], [1, "fas", "fa-envelope", "mr-1", 3, "href"], [1, "text-grey"]], template: function AvatarEmailComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵelement(1, "ngx-avatar", 1);
            i0.ɵɵelementStart(2, "div", 2)(3, "span");
            i0.ɵɵtext(4);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(5, "br");
            i0.ɵɵelementStart(6, "span");
            i0.ɵɵelement(7, "a", 3);
            i0.ɵɵelementStart(8, "span", 4);
            i0.ɵɵtext(9);
            i0.ɵɵelementEnd()()()();
        } if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("name", ctx.getAvatarInitials())("round", ctx.round)("textSizeRatio", 2);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", ctx.getName(), " ");
            i0.ɵɵadvance(3);
            i0.ɵɵpropertyInterpolate1("href", "mailto:", ctx.user.email, "", i0.ɵɵsanitizeUrl);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.user.email);
        } }, dependencies: [i1.AvatarComponent], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AvatarEmailComponent, [{
        type: Component,
        args: [{ selector: 'mon-email-avatar', template: "<div class=\"text-nowrap\">\n    <ngx-avatar\n            class=\"inline-block-important\"\n            [name]=\"getAvatarInitials()\"\n            [round]=\"round\"\n            [textSizeRatio]=\"2\"\n            size=\"30\">\n    </ngx-avatar>\n    <div class=\"inline-block-important outer-l-small\">\n        <span>\n           {{ getName() }}\n        </span><br/>\n        <span>\n            <a href=\"mailto:{{ user.email }}\" class=\"fas fa-envelope mr-1\"></a>\n            <span class=\"text-grey\">{{ user.email }}</span>\n        </span>\n    </div>\n</div>\n\n" }]
    }], null, { user: [{
            type: Input
        }], round: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(AvatarEmailComponent, { className: "AvatarEmailComponent" }); })();

class MonAvatarModule {
    static { this.ɵfac = function MonAvatarModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MonAvatarModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: MonAvatarModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [AvatarModule, CommonModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MonAvatarModule, [{
        type: NgModule,
        args: [{
                imports: [AvatarModule, CommonModule],
                exports: [AvatarEmailComponent],
                declarations: [AvatarEmailComponent],
                providers: [],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(MonAvatarModule, { declarations: [AvatarEmailComponent], imports: [AvatarModule, CommonModule], exports: [AvatarEmailComponent] }); })();

const TranslateServiceInjectionToken = new InjectionToken('TranslateService');

/* eslint-disable max-len */
const CUSTOM_ICONS = {
    mobileEye: {
        icon: [
            320,
            512,
            [],
            '',
            [
                'M160,179.1c-30.4,0-55,24.6-55,55c0,30.4,24.6,55,55,55c0,0,0,0,0.1,0c30.4,0,55-24.6,54.9-55 C215,203.8,190.4,179.1,160,179.1z M195.4,243.6c-5.3,19.5-25.4,31-44.9,25.7s-31-25.4-25.7-44.9c6.4,4.7,15.2,4.7,21.7,0 c8.1-6,9.9-17.4,3.9-25.6c3.1-0.9,6.4-1.4,9.7-1.4c3.3,0,6.5,0.4,9.7,1.3C189.2,204,200.7,224.1,195.4,243.6z',
                'M272,0H48C21.5,0,0,21.5,0,48v416c0,26.5,21.5,48,48,48h224c26.5,0,48-21.5,48-48V48C320,21.5,298.5,0,272,0z M160,480 c-17.7,0-32-14.3-32-32s14.3-32,32-32s32,14.3,32,32S177.7,480,160,480z M268.7,239.7C248,280.1,207,307.5,160,307.5 c-47,0-88-27.3-108.7-67.8c-1.8-3.5-1.8-7.6,0-11.1C72,188.2,113,160.8,160,160.8c47,0,88,27.3,108.7,67.8 C270.4,232.1,270.4,236.2,268.7,239.7z',
            ],
        ],
        iconName: 'mobile-eye',
        prefix: 'fas',
    },
    mobileBell: {
        icon: [
            320,
            512,
            [],
            '',
            'M272,0H48C21.5,0,0,21.5,0,48v416c0,26.5,21.5,48,48,48h224c26.5,0,48-21.5,48-48V48C320,21.5,298.5,0,272,0z M160,480 c-17.7,0-32-14.3-32-32s14.3-32,32-32s32,14.3,32,32S177.7,480,160,480z M130.7,322.1h58.6c0,16.2-13.1,29.3-29.3,29.3 S130.7,338.3,130.7,322.1z M247.9,307.5H72.1c-8.8,0-14.7-7.1-14.7-14.7c0-3.5,1.2-7,3.9-9.9c8.9-9.5,25.4-23.8,25.4-70.7 c0-35.6,25-64.1,58.6-71.1v-9.5c0-8.1,6.6-14.7,14.7-14.7s14.7,6.6,14.7,14.7v9.5c33.7,7,58.6,35.5,58.6,71.1 c0,46.9,16.6,61.2,25.4,70.7c2.7,3,4,6.5,3.9,9.9C262.6,300.3,256.7,307.5,247.9,307.5z',
        ],
        iconName: 'mobile-bell',
        prefix: 'fas',
    },
    mobileBug: {
        icon: [
            320,
            512,
            [],
            '',
            [
                'M268.7,228.6C248,188.2,207,160.9,160,160.9s-88,27.4-108.7,67.8c-1.8,3.5-1.8,7.6,0,11.1 C72,280.2,113,307.6,160,307.6s88-27.4,108.7-67.8C270.4,236.3,270.4,232.2,268.7,228.6z M160,289.2c-30.4,0-55-24.6-55-55 c0-30.4,24.6-55,55-55s55,24.6,55,55C215,264.6,190.4,289.2,160,289.2C160,289.2,160,289.2,160,289.2z M160,197.6 c-3.3,0-6.5,0.5-9.7,1.4c6,8.1,4.2,19.6-3.9,25.6c-6.4,4.7-15.2,4.7-21.7,0c-5.3,19.5,6.2,39.6,25.7,44.9s39.6-6.2,44.9-25.7 c5.3-19.5-6.2-39.6-25.7-44.9C166.5,198,163.3,197.5,160,197.6z',
                'M272,0H48C21.5,0,0,21.5,0,48v416c0,26.5,21.5,48,48,48h224c26.5,0,48-21.5,48-48V48C320,21.5,298.5,0,272,0z M160.4,123.7 c25.7,0,46.6,20.9,46.6,46.6h-93.2C113.8,144.6,134.7,123.7,160.4,123.7z M160,480c-17.7,0-32-14.3-32-32s14.3-32,32-32 s32,14.3,32,32S177.7,480,160,480z M252.9,256.9h-23v6.7c0,9.1-2,17.7-5.7,25.4l25.1,25.1c5.2,5.2,5.2,13.6,0,18.8 c-5.2,5.2-13.6,5.2-18.8,0l-22.8-22.8c-10.3,8.4-23.4,13.4-37.7,13.4V221.9c0-2.8-2.2-5-5-5h-10c-2.8,0-5,2.2-5,5v101.5 c-14.3,0-27.4-5-37.7-13.4l-22.8,22.8c-5.2,5.2-13.6,5.2-18.8,0c-5.2-5.2-5.2-13.6,0-18.8L95.8,289c-3.6-7.7-5.7-16.3-5.7-25.4v-6.7 h-23c-7.3,0-13.4-5.7-13.6-12.9c-0.2-7.5,5.8-13.7,13.3-13.7h23.3v-24.4l-19.4-19.4c-5.2-5.2-5.2-13.6,0-18.8 c5.2-5.2,13.6-5.2,18.8,0l22.7,22.7h95.5l22.7-22.7c5.2-5.2,13.6-5.2,18.8,0c5.2,5.2,5.2,13.6,0,18.8l-19.4,19.4v24.4h23.3 c7.5,0,13.5,6.2,13.3,13.7C266.3,251.2,260.2,256.9,252.9,256.9z',
            ],
        ],
        iconName: 'mobile-bug',
        prefix: 'fas',
    },
    arrowsRotate: {
        icon: [
            320,
            512,
            [],
            '',
            'M464 16c-17.67 0-32 14.31-32 32v74.09C392.1 66.52 327.4 32 256 32C161.5 32 78.59 92.34 49.58 182.2c-5.438 16.81 3.797 34.88 20.61 40.28c16.89 5.5 34.88-3.812 40.3-20.59C130.9 138.5 189.4 96 256 96c50.5 0 96.26 24.55 124.4 64H336c-17.67 0-32 14.31-32 32s14.33 32 32 32h128c17.67 0 32-14.31 32-32V48C496 30.31 481.7 16 464 16zM441.8 289.6c-16.92-5.438-34.88 3.812-40.3 20.59C381.1 373.5 322.6 416 256 416c-50.5 0-96.25-24.55-124.4-64H176c17.67 0 32-14.31 32-32s-14.33-32-32-32h-128c-17.67 0-32 14.31-32 32v144c0 17.69 14.33 32 32 32s32-14.31 32-32v-74.09C119.9 445.5 184.6 480 255.1 480c94.45 0 177.4-60.34 206.4-150.2C467.9 313 458.6 294.1 441.8 289.6z',
        ],
        iconName: 'arrows-rotate',
        prefix: 'fas',
    },
};

const PRO_ICONS = {
    "faCircle": {
        "icon": [
            512,
            512,
            [],
            "f111",
            "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm216 248c0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216z"
        ],
        "iconName": "circle",
        "prefix": "fal"
    },
    "faShieldCheck": {
        "icon": [
            512,
            512,
            [],
            "f2f7",
            "M466.5 83.7l-192-80a48.15 48.15 0 0 0-36.9 0l-192 80C27.7 91.1 16 108.6 16 128c0 198.5 114.5 335.7 221.5 380.3 11.8 4.9 25.1 4.9 36.9 0C360.1 472.6 496 349.3 496 128c0-19.4-11.7-36.9-29.5-44.3zm-47.2 114.2l-184 184c-6.2 6.2-16.4 6.2-22.6 0l-104-104c-6.2-6.2-6.2-16.4 0-22.6l22.6-22.6c6.2-6.2 16.4-6.2 22.6 0l70.1 70.1 150.1-150.1c6.2-6.2 16.4-6.2 22.6 0l22.6 22.6c6.3 6.3 6.3 16.4 0 22.6z"
        ],
        "iconName": "shield-check",
        "prefix": "fas"
    },
    "faBooks": {
        "icon": [
            576,
            512,
            [],
            "f5db",
            "M575.11 443.25L461.51 19.06C458.2 6.7 445.61-3.18 430.15.96L414.7 5.1c-6.18 1.66-11.53 6.4-16.06 14.24-14.03 6.94-52.3 17.21-68 18.22-7.84-4.53-14.85-5.96-21.03-4.3l-15.46 4.14c-2.42.65-4.2 1.95-6.15 3.08V32c0-17.67-14.33-32-32-32h-64c-17.67 0-32 14.33-32 32v64h128l101.66 396.94c3.31 12.36 15.9 22.24 31.36 18.1l15.45-4.14c6.18-1.66 11.53-6.4 16.06-14.24 13.91-6.88 52.18-17.2 68-18.22 7.84 4.53 14.85 5.96 21.03 4.3l15.46-4.14c15.45-4.14 21.41-18.99 18.09-31.35zm-134.4-7.06L348.64 92.37l61.82-16.56 92.07 343.82-61.82 16.56zM0 384h128V128H0v256zM96 0H32C14.33 0 0 14.33 0 32v64h128V32c0-17.67-14.33-32-32-32zM0 480c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64H0v64zm160-96h128V128H160v256zm0 96c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64H160v64z"
        ],
        "iconName": "books",
        "prefix": "fas"
    },
    "faWindow": {
        "icon": [
            512,
            512,
            [],
            "f40e",
            "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-336 96c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm96 0c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm96 0c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32z"
        ],
        "iconName": "window",
        "prefix": "fas"
    },
    "faFileMinus": {
        "icon": [
            384,
            512,
            [],
            "f318",
            "M377,105,279.1,7a24,24,0,0,0-17-7H256V128H384v-6.1A23.92,23.92,0,0,0,377,105ZM224,136V0H24A23.94,23.94,0,0,0,0,24V488a23.94,23.94,0,0,0,24,24H360a23.94,23.94,0,0,0,24-24V160H248A24.07,24.07,0,0,1,224,136Zm72,176v16a16,16,0,0,1-16,16H104a16,16,0,0,1-16-16V312a16,16,0,0,1,16-16H280A16,16,0,0,1,296,312Z"
        ],
        "iconName": "file-minus",
        "prefix": "fas"
    },
    "faVideo": {
        "icon": [
            576,
            512,
            [],
            "f03d",
            "M336.2 64H47.8C21.4 64 0 85.4 0 111.8v288.4C0 426.6 21.4 448 47.8 448h288.4c26.4 0 47.8-21.4 47.8-47.8V111.8c0-26.4-21.4-47.8-47.8-47.8zm189.4 37.7L416 177.3v157.4l109.6 75.5c21.2 14.6 50.4-.3 50.4-25.8V127.5c0-25.4-29.1-40.4-50.4-25.8z"
        ],
        "iconName": "video",
        "prefix": "fas"
    },
    "faPalette": {
        "icon": [
            512,
            512,
            [],
            "f53f",
            "M204.3 5C104.9 24.4 24.8 104.3 5.2 203.4c-37 187 131.7 326.4 258.8 306.7 41.2-6.4 61.4-54.6 42.5-91.7-23.1-45.4 9.9-98.4 60.9-98.4h79.7c35.8 0 64.8-29.6 64.9-65.3C511.5 97.1 368.1-26.9 204.3 5zM96 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm32-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128-64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
        ],
        "iconName": "palette",
        "prefix": "fas"
    },
    "faBrowser": {
        "icon": [
            512,
            512,
            [],
            "f37e",
            "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM128 148c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm320 0c0 6.6-5.4 12-12 12H188c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h248c6.6 0 12 5.4 12 12v40z"
        ],
        "iconName": "browser",
        "prefix": "fas"
    },
    "faSparkles": {
        "icon": [
            512,
            512,
            [],
            "f890",
            "M324.42 103.15L384 128l24.84 59.58a8 8 0 0 0 14.32 0L448 128l59.58-24.85a8 8 0 0 0 0-14.31L448 64 423.16 4.42a8 8 0 0 0-14.32 0L384 64l-59.58 24.84a8 8 0 0 0 0 14.31zm183.16 305.69L448 384l-24.84-59.58a8 8 0 0 0-14.32 0L384 384l-59.58 24.84a8 8 0 0 0 0 14.32L384 448l24.84 59.58a8 8 0 0 0 14.32 0L448 448l59.58-24.84a8 8 0 0 0 0-14.32zM384 255.64a16.06 16.06 0 0 0-8.84-14.33l-112.57-56.39-56.28-112.77c-5.44-10.87-23.19-10.87-28.62 0l-56.28 112.77L8.84 241.31a16 16 0 0 0 0 28.67l112.57 56.39 56.28 112.77a16 16 0 0 0 28.62 0l56.28-112.77L375.16 270a16.07 16.07 0 0 0 8.84-14.36z"
        ],
        "iconName": "sparkles",
        "prefix": "fas"
    }
};

const MON_DIRECT_ICONS = {
    faGoogle,
    faJsSquare,
    faUser,
    faUsers,
    faFileInvoice,
    faLock,
    faFileAlt,
    faCog,
    faTrashAlt,
    faSpider,
    faPause,
    faCheck,
    faArrowDown,
    faBuilding,
    faTimes,
    faGlobe,
    faGlobeAmericas,
    faComment,
    faExclamationTriangle,
    faCode,
    faSyncAlt,
    faPencilAlt,
    faChartPie,
    faUniversalAccess,
    faEye,
    faClone,
    faBan,
    faUserSecret,
    faClipboardCheck,
    faBook,
    faTasks,
    faUniversity,
    faNewspaper,
    faCalendarAlt,
    faWindowRestore,
    faTag,
    faTags,
    faQuestionCircle,
    faSmile,
    faMeh,
    faFrown,
    faBookmark,
    faChevronDown,
    faLink,
    faPlus,
    faInfo,
    faBars,
    faFileImport,
    faClock,
    faChevronRight,
    faSync,
    faCopy,
    /* @deprecated Use faUpRightFromSquare instead */
    faExternalLinkAlt,
    faSearch,
    faSpinner,
    faArrowUp,
    faInfoCircle,
    faRedoAlt,
    faFire,
    faFilter,
    faEyeSlash,
    faGraduationCap,
    faBug,
    faExclamation,
    faBell,
    faAlignJustify,
    faTimesCircle,
    faDownload,
    faMousePointer,
    faChevronUp,
    faChevronLeft,
    faHeartbeat,
    faCheckSquare,
    faChartLine,
    faGavel,
    faSearchPlus,
    faCalendarMinus,
    faHdd,
    faPaperPlane,
    faCaretDown,
    faCaretUp,
    faCaretLeft,
    faCaretRight,
    faAtlas,
    faPlay,
    faBox,
    faArchive,
    faEdit,
    faUndo,
    faRetweet,
    faFilePdf,
    faHome,
    faStopCircle,
    faChartSimple,
    faUpRightFromSquare,
    mobileEye: CUSTOM_ICONS.mobileEye,
    mobileBell: CUSTOM_ICONS.mobileBell,
    mobileBug: CUSTOM_ICONS.mobileBug,
    arrowsRotate: CUSTOM_ICONS.arrowsRotate,
    faWindow: PRO_ICONS.faWindow,
    faCircle: PRO_ICONS.faCircle,
    faShieldCheck: PRO_ICONS.faShieldCheck,
    faBooks: PRO_ICONS.faBooks,
    faFileMinus: PRO_ICONS.faFileMinus,
    faBrowser: PRO_ICONS.faBrowser,
    faPalette: PRO_ICONS.faPalette,
    faVideo: PRO_ICONS.faVideo,
};

/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
const MON_ICONS = {
    CRAWLERS: {
        ICON: MON_DIRECT_ICONS.faSpider,
        PAUSED: MON_DIRECT_ICONS.faPause,
        NOT_PAUSED: MON_DIRECT_ICONS.faCheck,
        STATE_UP: MON_DIRECT_ICONS.faArrowUp,
        STATE_DOWN: MON_DIRECT_ICONS.faChevronDown,
    },
    CUSTOMERS: {
        ICON: MON_DIRECT_ICONS.faBuilding,
        PLAN_TRAITS: {
            ACTIVE: MON_DIRECT_ICONS.faCheck,
            INACTIVE: MON_DIRECT_ICONS.faTimes,
        },
        FEATURES: {
            ACTIVE: MON_DIRECT_ICONS.faCheck,
            INACTIVE: MON_DIRECT_ICONS.faTimes,
        },
        SCAN: {
            ACTIVE: MON_DIRECT_ICONS.faCheck,
            INACTIVE: MON_DIRECT_ICONS.faTimes,
        },
    },
    DATA_PRIVACY_CHECKS: {
        ICON: MON_DIRECT_ICONS.faLock,
    },
    GLOBAL_POLICY_OVERVIEW: {
        POLICY_EXCHANGE_CENTER: {
            PAGE: MON_DIRECT_ICONS.faGlobe,
            PAGE_HTML: MON_DIRECT_ICONS.faCopy,
            PAGE_DOCUMENT: MON_DIRECT_ICONS.faFileAlt,
            LINK: MON_DIRECT_ICONS.faLink,
        },
        POLICY_INFORMATION: {
            INFO: MON_DIRECT_ICONS.faInfoCircle,
            CLOCK: MON_DIRECT_ICONS.faClock,
            BAN: MON_DIRECT_ICONS.faBan,
            SYNC: MON_DIRECT_ICONS.faSync,
            COMMENT: MON_DIRECT_ICONS.faComment,
        },
        POLICY_TYPE: {
            UNWANTED: MON_DIRECT_ICONS.faBan,
            REQUIRED: MON_DIRECT_ICONS.faExclamationTriangle,
            SEARCH: MON_DIRECT_ICONS.faSearch,
            TEXT: MON_DIRECT_ICONS.faBug,
            SEO: MON_DIRECT_ICONS.faExclamation,
            ERROR: MON_DIRECT_ICONS.faBug,
            WARNING: MON_DIRECT_ICONS.faBell,
            REVIEW: MON_DIRECT_ICONS.faEye,
            CONTENT: MON_DIRECT_ICONS.faAlignJustify,
        },
    },
    DOMAINS: {
        ICON: MON_DIRECT_ICONS.faGlobeAmericas,
        NOTES: MON_DIRECT_ICONS.faComment,
        INACTIVE: MON_DIRECT_ICONS.faExclamationTriangle,
        CONSTRAINTS: MON_DIRECT_ICONS.faCode,
        RESCAN: MON_DIRECT_ICONS.faSyncAlt,
        REWRITE_URL: MON_DIRECT_ICONS.faPencilAlt,
        SCAN: {
            SCAN_DOCUMENTS: MON_DIRECT_ICONS.faFileAlt,
            ENABLE_JAVASCRIPT: MON_DIRECT_ICONS.faJsSquare,
            SCAN_SUBDOMAIN: MON_DIRECT_ICONS.faGlobeAmericas,
        },
        FEATURES: {
            STATISTICS: MON_DIRECT_ICONS.faChartPie,
            ACCESSIBILITY: MON_DIRECT_ICONS.faUniversalAccess,
            READABILITY_TEST: MON_DIRECT_ICONS.faEye,
            PAGE_CORRECT: MON_DIRECT_ICONS.faShieldCheck,
        },
    },
    DOMAIN_GROUPS: {
        ICON: MON_DIRECT_ICONS.faClone,
    },
    USERS: {
        ICON: MON_DIRECT_ICONS.faUsers,
        SINGLE_ICON: MON_DIRECT_ICONS.faUser,
        ADMIN: MON_DIRECT_ICONS.faCheck,
        NOT_ADMIN: MON_DIRECT_ICONS.faBan,
        SUDO: MON_DIRECT_ICONS.faUserSecret,
        CONFIRMED: MON_DIRECT_ICONS.faClipboardCheck,
        DICTIONARY: MON_DIRECT_ICONS.faBook,
    },
    CRAWL_QUEUE: {
        ICON: MON_DIRECT_ICONS.faTasks,
    },
    SOURCE_CODE_EXCLUDES: {
        ICON: MON_DIRECT_ICONS.faCode,
    },
    PARTNERS: {
        ICON: MON_DIRECT_ICONS.faUniversity,
    },
    PLANS: {
        ICON: MON_DIRECT_ICONS.faFileAlt,
        ACTIVE: MON_DIRECT_ICONS.faCheck,
    },
    WORKER_QUEUE: {
        ICON: MON_DIRECT_ICONS.faFileAlt,
    },
    PRODUCT_UPDATES: {
        ICON: MON_DIRECT_ICONS.faNewspaper,
        DATE: MON_DIRECT_ICONS.faCalendarAlt,
    },
    ACCESSIBILITY_CHECKS: {
        ICON: MON_DIRECT_ICONS.faUniversalAccess,
        MOBILE_REVIEW: MON_DIRECT_ICONS.mobileEye,
        MOBILE_WARNING: MON_DIRECT_ICONS.mobileBell,
        MOBILE_ERROR: MON_DIRECT_ICONS.mobileBug,
    },
    AGENCY: {
        ICON: MON_DIRECT_ICONS.faWindowRestore,
    },
    SUPPORT: {
        HEATMAPS: {
            ICON: MON_DIRECT_ICONS.faFire,
        },
    },
    SUPPORT_CENTER: {
        TAGS: {
            ICON: MON_DIRECT_ICONS.faTags,
            SINGLE_ICON: MON_DIRECT_ICONS.faTag,
        },
        ARTICLES: {
            ICON: MON_DIRECT_ICONS.faQuestionCircle,
            TITLE: MON_DIRECT_ICONS.faBook,
            PROMOTED: MON_DIRECT_ICONS.faCheck,
            NOT_PROMOTED: MON_DIRECT_ICONS.faTimes,
            SMILEYS: {
                GOOD: MON_DIRECT_ICONS.faSmile,
                AVERAGE: MON_DIRECT_ICONS.faMeh,
                BAD: MON_DIRECT_ICONS.faFrown,
            },
        },
        CATEGORIES: {
            ICON: MON_DIRECT_ICONS.faBookmark,
        },
    },
    ACTIONS: {
        ICON: MON_DIRECT_ICONS.faChevronDown,
        ADD: MON_DIRECT_ICONS.faPlus,
        REMOVE: MON_DIRECT_ICONS.faTrashAlt,
        DELETE: MON_DIRECT_ICONS.faTrashAlt,
        EDIT: MON_DIRECT_ICONS.faCog,
        CLOSE: MON_DIRECT_ICONS.faTimes,
        DETAILS: MON_DIRECT_ICONS.faInfo,
        CLONE: MON_DIRECT_ICONS.faClone,
        HANDLE: MON_DIRECT_ICONS.faBars,
        IMPORT: MON_DIRECT_ICONS.faFileImport,
        HANDLES: {
            SHOW: MON_DIRECT_ICONS.faChevronDown,
            HIDE: MON_DIRECT_ICONS.faChevronRight,
        },
        APPROVE: MON_DIRECT_ICONS.faCheck,
        DISAPPROVE: MON_DIRECT_ICONS.faBan,
        STUCK: MON_DIRECT_ICONS.faInfoCircle,
        REDO: MON_DIRECT_ICONS.faRedoAlt,
        FILTER: MON_DIRECT_ICONS.faFilter,
        IGNORE: MON_DIRECT_ICONS.faEyeSlash,
        UNIGNORE: MON_DIRECT_ICONS.faEye,
        ARROW_POINTER: MON_DIRECT_ICONS.faMousePointer,
    },
    SPINNER: {
        ICON: MON_DIRECT_ICONS.faSpinner,
        SYNC: MON_DIRECT_ICONS.faSyncAlt,
        REFRESH: MON_DIRECT_ICONS.faSync,
    },
    PROFILE: {
        ICON: MON_DIRECT_ICONS.faCopy,
    },
    DASHBOARD: {
        ICON: MON_DIRECT_ICONS.faCopy,
    },
    LINKS: {
        EXTERNAL: MON_DIRECT_ICONS.faExternalLinkAlt,
    },
    SEARCH: {
        ICON: MON_DIRECT_ICONS.faSearch,
    },
    GOOGLE: {
        ICON: MON_DIRECT_ICONS.faGoogle,
    },
    HELPCENTER: {
        ICON: MON_DIRECT_ICONS.faGraduationCap,
    },
    TABLES: {
        PAGEDETAILS: MON_DIRECT_ICONS.faWindow,
    },
    REPORT_CENTER: {
        DASHBOARD: {
            ACCESSIBILITY: MON_DIRECT_ICONS.faUniversalAccess,
            QA: MON_DIRECT_ICONS.faCheckSquare,
            SEO: MON_DIRECT_ICONS.faChartLine,
            POLICIES: MON_DIRECT_ICONS.faGavel,
            STATISTICS: MON_DIRECT_ICONS.faChartPie,
            INVENTORY: MON_DIRECT_ICONS.faBooks,
            HEARTBEAT: MON_DIRECT_ICONS.faHeartbeat,
            HEATMAPS: MON_DIRECT_ICONS.faFire,
            DATA_PRIVACY: MON_DIRECT_ICONS.faLock,
            OTHER: MON_DIRECT_ICONS.faGlobe,
        },
        BUTTONS: {
            STOP_SENDING_REPORT: MON_DIRECT_ICONS.faCalendarMinus,
            SEND_REPORT: MON_DIRECT_ICONS.faCalendarAlt,
            REPORT_ADMINISTRATION: MON_DIRECT_ICONS.faCog,
            OPEN_REPORT: MON_DIRECT_ICONS.faEye,
            RECEIVE_REPORT: MON_DIRECT_ICONS.faHdd,
        },
        ACCORDION: {
            STATE_OPENED: MON_DIRECT_ICONS.faChevronUp,
            STATE_CLOSED: MON_DIRECT_ICONS.faChevronDown,
        },
    },
    STATISTICS: {
        SIDE_MENU: {
            SITE_SEARCH: MON_DIRECT_ICONS.faSearchPlus,
        },
    },
};

class IconsService {
    getIcon(path) {
        let i;
        let result;
        let icons = MON_ICONS;
        for (i = 0; i < path.length; i++) {
            const level = icons[path[i]];
            if (Array.isArray(level.icon)) {
                result = level;
                return result;
            }
            else {
                icons = icons[path[i]];
            }
        }
        return result;
    }
    static { this.ɵfac = function IconsService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || IconsService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: IconsService, factory: IconsService.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IconsService, [{
        type: Injectable
    }], null, null); })();

class IconComponent {
    constructor(iconsService) {
        this.iconsService = iconsService;
        this.spin = false;
    }
    ngOnInit() {
        if (this.monIconDirect) {
            this.iconObj = MON_DIRECT_ICONS[this.monIconDirect];
        }
        else {
            this.iconObj = this.iconsService.getIcon(this.icon);
        }
    }
    static { this.ɵfac = function IconComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || IconComponent)(i0.ɵɵdirectiveInject(IconsService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: IconComponent, selectors: [["mon-icon"]], inputs: { size: "size", styles: "styles", icon: "icon", monIconDirect: "monIconDirect", stackItemSize: "stackItemSize", spin: "spin" }, decls: 1, vars: 4, consts: [["aria-hidden", "true", 3, "styles", "icon", "size", "spin"]], template: function IconComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelement(0, "fa-icon", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("styles", ctx.styles)("icon", ctx.iconObj)("size", ctx.size)("spin", ctx.spin);
        } }, dependencies: [i1$1.FaIconComponent], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IconComponent, [{
        type: Component,
        args: [{ selector: 'mon-icon', template: "<fa-icon [styles]=\"styles\"\n         [icon]=\"iconObj\"\n         [size]=\"size\"\n         [spin]=\"spin\"\n         aria-hidden=\"true\">\n</fa-icon>" }]
    }], () => [{ type: IconsService }], { size: [{
            type: Input
        }], styles: [{
            type: Input
        }], icon: [{
            type: Input
        }], monIconDirect: [{
            type: Input
        }], stackItemSize: [{
            type: Input
        }], spin: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(IconComponent, { className: "IconComponent" }); })();

const _c0$P = a0 => ({ active: a0 });
const _c1$q = () => ["ACTIONS", "FILTER"];
function FilterButtonComponent_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 2);
    i0.ɵɵlistener("click", function FilterButtonComponent_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.toggleShowFilters()); });
    i0.ɵɵelement(1, "mon-icon", 3);
    i0.ɵɵelementStart(2, "span", 4);
    i0.ɵɵtext(3, "Toggle show filters");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c0$P, ctx_r1.isFiltersOpen));
    i0.ɵɵattribute("aria-label", ctx_r1.getFiltersTranslation());
    i0.ɵɵadvance();
    i0.ɵɵproperty("icon", i0.ɵɵpureFunction0(5, _c1$q));
} }
class FilterButtonComponent {
    constructor(translateService) {
        this.translateService = translateService;
        this.isFiltersOpenChange = new EventEmitter();
    }
    toggleShowFilters() {
        this.isFiltersOpen = !this.isFiltersOpen;
        this.isFiltersOpenChange.emit(this.isFiltersOpen);
    }
    getFiltersTranslation() {
        if (this.isFiltersOpen) {
            return this.translateService.getString('Close filters');
        }
        else {
            return this.translateService.getString('Open filters');
        }
    }
    static { this.ɵfac = function FilterButtonComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FilterButtonComponent)(i0.ɵɵdirectiveInject(TranslateServiceInjectionToken)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FilterButtonComponent, selectors: [["mon-filter-button"]], inputs: { showFiltersBtn: "showFiltersBtn", isFiltersOpen: "isFiltersOpen" }, outputs: { isFiltersOpenChange: "isFiltersOpenChange" }, decls: 2, vars: 1, consts: [[1, "filter-button"], ["role", "button", 3, "ngClass", "click", 4, "ngIf"], ["role", "button", 3, "click", "ngClass"], [3, "icon"], ["translate", "", 1, "sr-only"]], template: function FilterButtonComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, FilterButtonComponent_button_1_Template, 4, 6, "button", 1);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.showFiltersBtn);
        } }, dependencies: [i1$2.NgClass, i1$2.NgIf, IconComponent], styles: [".filter-button[_ngcontent-%COMP%]{margin:0 8px}.filter-button[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{background:none;border:none;height:35px;width:35px;padding:7px 8px;color:#299bf7;outline:none}.filter-button[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:focus-visible{outline:#004AC1 auto 5px;background-color:#d4dce3;border-radius:50%;color:#299bf7}.filter-button[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:hover, .filter-button[_ngcontent-%COMP%]   button.active[_ngcontent-%COMP%]{background-color:#d4dce3;border-radius:50%;color:#299bf7}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FilterButtonComponent, [{
        type: Component,
        args: [{ selector: 'mon-filter-button', template: "<div class=\"filter-button\">\n    <button *ngIf=\"showFiltersBtn\"\n       role=\"button\"\n       [attr.aria-label]=\"getFiltersTranslation()\"\n       (click)=\"toggleShowFilters()\"\n       [ngClass]=\"{active: isFiltersOpen}\"\n    >\n        <mon-icon [icon]=\"['ACTIONS', 'FILTER']\"></mon-icon>\n        <span class=\"sr-only\" translate>Toggle show filters</span>\n    </button>\n</div>\n", styles: [".filter-button{margin:0 8px}.filter-button button{background:none;border:none;height:35px;width:35px;padding:7px 8px;color:#299bf7;outline:none}.filter-button button:focus-visible{outline:#004AC1 auto 5px;background-color:#d4dce3;border-radius:50%;color:#299bf7}.filter-button button:hover,.filter-button button.active{background-color:#d4dce3;border-radius:50%;color:#299bf7}\n"] }]
    }], () => [{ type: undefined, decorators: [{
                type: Inject,
                args: [TranslateServiceInjectionToken]
            }] }], { showFiltersBtn: [{
            type: Input
        }], isFiltersOpen: [{
            type: Input
        }], isFiltersOpenChange: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FilterButtonComponent, { className: "FilterButtonComponent" }); })();

// https://fontawesome.com/how-to-use/on-the-web/styling/stacking-icons
class StackedIconComponent {
    constructor() {
        this.spin = false;
        this.circle = PRO_ICONS.faCircle;
    }
    static { this.ɵfac = function StackedIconComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || StackedIconComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: StackedIconComponent, selectors: [["mon-stacked-icon"]], inputs: { iconFront: "iconFront", iconColor: "iconColor", spin: "spin" }, decls: 3, vars: 10, consts: [[3, "icon", "stackItemSize"], [3, "icon", "spin", "stackItemSize"]], template: function StackedIconComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "fa-stack");
            i0.ɵɵelement(1, "fa-icon", 0)(2, "fa-icon", 1);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵclassMapInterpolate1("fa-stack-", ctx.iconColor, "");
            i0.ɵɵadvance();
            i0.ɵɵproperty("icon", ctx.circle)("stackItemSize", "2x");
            i0.ɵɵattribute("aria-hidden", true);
            i0.ɵɵadvance();
            i0.ɵɵproperty("icon", ctx.iconFront)("spin", ctx.spin)("stackItemSize", "1x");
            i0.ɵɵattribute("aria-hidden", true);
        } }, dependencies: [i1$1.FaIconComponent, i1$1.FaStackComponent, i1$1.FaStackItemSizeDirective], styles: [".fa-stack-red[_ngcontent-%COMP%]{color:#d6347b}.fa-stack-green[_ngcontent-%COMP%]{color:#3a853a}.fa-stack-high[_ngcontent-%COMP%]{color:#d43f3a}.fa-stack-medium[_ngcontent-%COMP%]{color:#efc271}.fa-stack-low[_ngcontent-%COMP%]{color:#299bf7}.fa-stack-technical[_ngcontent-%COMP%]{color:#555557}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StackedIconComponent, [{
        type: Component,
        args: [{ selector: 'mon-stacked-icon', template: "<fa-stack class=\"fa-stack-{{iconColor}}\">\n    <fa-icon [icon]=\"circle\" [stackItemSize]=\"'2x'\" [attr.aria-hidden]=\"true\"></fa-icon>\n    <fa-icon [icon]=\"iconFront\" [spin]=\"spin\" [stackItemSize]=\"'1x'\" [attr.aria-hidden]=\"true\"></fa-icon>\n</fa-stack>\n", styles: [".fa-stack-red{color:#d6347b}.fa-stack-green{color:#3a853a}.fa-stack-high{color:#d43f3a}.fa-stack-medium{color:#efc271}.fa-stack-low{color:#299bf7}.fa-stack-technical{color:#555557}\n"] }]
    }], null, { iconFront: [{
            type: Input
        }], iconColor: [{
            type: Input
        }], spin: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(StackedIconComponent, { className: "StackedIconComponent" }); })();

const _c0$O = a0 => ({ "color": a0 });
const _c1$p = a0 => ({ "background-color": a0, "color": "white" });
class IconCircleComponent {
    constructor(iconsService) {
        this.iconsService = iconsService;
        this.color = 'black';
        this.filled = false;
        this.monAriaText = 'an icon';
    }
    ngOnInit() {
        if (this.monIconDirect) {
            this.iconObj = MON_DIRECT_ICONS[this.monIconDirect];
        }
        else {
            this.iconObj = this.iconsService.getIcon(this.icon);
        }
    }
    static { this.ɵfac = function IconCircleComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || IconCircleComponent)(i0.ɵɵdirectiveInject(IconsService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: IconCircleComponent, selectors: [["mon-icon-circle"]], inputs: { color: "color", filled: "filled", monAriaText: "monAriaText", icon: "icon", monIconDirect: "monIconDirect" }, decls: 4, vars: 10, consts: [[1, "icon-circle", 3, "ngStyle"], [1, "icon", 3, "icon"], ["tabindex", "0", 1, "sr-only"]], template: function IconCircleComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵelement(1, "fa-icon", 1);
            i0.ɵɵelementStart(2, "span", 2);
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵstyleMap(i0.ɵɵpureFunction1(6, _c0$O, ctx.color));
            i0.ɵɵproperty("ngStyle", ctx.filled === true && i0.ɵɵpureFunction1(8, _c1$p, ctx.color));
            i0.ɵɵadvance();
            i0.ɵɵproperty("icon", ctx.iconObj);
            i0.ɵɵattribute("aria-hidden", true);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.monAriaText);
        } }, dependencies: [i1$1.FaIconComponent, i1$2.NgStyle], styles: [".icon-circle[_ngcontent-%COMP%]{text-align:center;border:2px solid;display:inline-block;position:relative;width:1.9em;height:1.9em;border-radius:50%}.icon-circle[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.icon-circle[_ngcontent-%COMP%]   .fa-2x[_ngcontent-%COMP%]{font-size:24px}.icon-circle[_ngcontent-%COMP%]   .fa-3x[_ngcontent-%COMP%]{font-size:30px}.icon-circle[_ngcontent-%COMP%]   .fa-4x[_ngcontent-%COMP%]{font-size:36px}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IconCircleComponent, [{
        type: Component,
        args: [{ selector: 'mon-icon-circle', template: "<div class=\"icon-circle\" [style]=\"{'color': color}\"\n    [ngStyle]=\"filled === true && {'background-color': color, 'color': 'white'}\">\n    <fa-icon class=\"icon\" [icon]=\"iconObj\" [attr.aria-hidden]=\"true\"></fa-icon>\n    <span tabindex=\"0\" class=\"sr-only\">{{monAriaText}}</span>\n</div>\n", styles: [".icon-circle{text-align:center;border:2px solid;display:inline-block;position:relative;width:1.9em;height:1.9em;border-radius:50%}.icon-circle .icon{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.icon-circle .fa-2x{font-size:24px}.icon-circle .fa-3x{font-size:30px}.icon-circle .fa-4x{font-size:36px}\n"] }]
    }], () => [{ type: IconsService }], { color: [{
            type: Input
        }], filled: [{
            type: Input
        }], monAriaText: [{
            type: Input
        }], icon: [{
            type: Input
        }], monIconDirect: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(IconCircleComponent, { className: "IconCircleComponent" }); })();

// https://github.com/FortAwesome/angular-fontawesome/blob/master/docs/usage/icon-library.md
class IconsModule {
    constructor(library) {
        library.addIcons(faUser, faUsers, faLock, faFileAlt, faCog, faTrashAlt, faSpider, faPause, faCheck, faArrowDown, faBuilding, faTimes, faGlobeAmericas, faComment, faExclamationTriangle, faCode, faSyncAlt, faPencilAlt, faChartPie, faUniversalAccess, faEye, faClone, faBan, faUserSecret, faClipboardCheck, faBook, faTasks, faUniversity, faNewspaper, faCalendarAlt, faWindowRestore, faTag, faTags, faQuestionCircle, faSmile, faMeh, faFrown, faBookmark, faChevronDown, faPlus, faInfo, faBars, faFileImport, faChevronRight, faSync, faCopy, 
        /* @deprecated Use faUpRightFromSquare instead */
        faExternalLinkAlt, faSearch, faSpinner, faArrowUp, faGoogle, faJsSquare, faDownload, faHeartbeat, faCheckSquare, faFire, faChartLine, faGavel, faChartSimple, faUpRightFromSquare, PRO_ICONS.faBooks);
    }
    static { this.ɵfac = function IconsModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || IconsModule)(i0.ɵɵinject(i1$1.FaIconLibrary)); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: IconsModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [IconsService], imports: [FontAwesomeModule, CommonModule, FontAwesomeModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IconsModule, [{
        type: NgModule,
        args: [{
                imports: [FontAwesomeModule, CommonModule],
                exports: [FontAwesomeModule, IconComponent, StackedIconComponent, IconCircleComponent],
                declarations: [IconComponent, StackedIconComponent, IconCircleComponent],
                providers: [IconsService],
            }]
    }], () => [{ type: i1$1.FaIconLibrary }], null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(IconsModule, { declarations: [IconComponent, StackedIconComponent, IconCircleComponent], imports: [FontAwesomeModule, CommonModule], exports: [FontAwesomeModule, IconComponent, StackedIconComponent, IconCircleComponent] }); })();

class FilterButtonModule {
    static { this.ɵfac = function FilterButtonModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FilterButtonModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: FilterButtonModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, IconsModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FilterButtonModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, IconsModule],
                exports: [FilterButtonComponent],
                declarations: [FilterButtonComponent],
                providers: [],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(FilterButtonModule, { declarations: [FilterButtonComponent], imports: [CommonModule, IconsModule], exports: [FilterButtonComponent] }); })();

class ToastService {
    constructor(toastr) {
        this.toastr = toastr;
    }
    success(message, title, override) {
        return this.toastr.success(message, title, override);
    }
    warning(message, title, override) {
        return this.toastr.warning(message, title, override);
    }
    error(message, title, override) {
        return this.toastr.error(message, title, override);
    }
    info(message, title, override) {
        return this.toastr.info(message, title, override);
    }
    static { this.ɵfac = function ToastService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ToastService)(i0.ɵɵinject(i1$3.ToastrService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ToastService, factory: ToastService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ToastService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], () => [{ type: i1$3.ToastrService }], null); })();

class ActiveDialog {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    close(...args) { }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setForm(form) { }
}

class MockActiveDialogService {
    constructor() {
        this.close = () => Promise.resolve();
        this.setForm = () => Promise.resolve();
    }
}

class ContentRef {
    constructor(nodes, viewRef, componentRef) {
        this.nodes = nodes;
        this.viewRef = viewRef;
        this.componentRef = componentRef;
    }
}

var DIALOG_STATE;
(function (DIALOG_STATE) {
    DIALOG_STATE["closed"] = "closed";
    DIALOG_STATE["open"] = "open";
})(DIALOG_STATE || (DIALOG_STATE = {}));

class TranslateDirective {
    constructor(element, translateService) {
        this.element = element;
        this.translateService = translateService;
    }
    ngOnInit() {
        if (this.attr) {
            this.msgid = this.element.nativeElement.getAttribute(this.attr);
        }
        else {
            this.msgid = this.element.nativeElement.innerHTML;
        }
        if (this.n && !Number.isFinite(this.n)) {
            throw new Error('Attribute \'translate-n\' must be a number');
        }
        this.subscription = this.translateService.onLanguageChange$().subscribe({
            next: () => {
                this.update();
            },
        });
    }
    ngOnChanges(changes) {
        if (this.msgid &&
            ((changes.args && !changes.args.firstChange) ||
                (changes.plural && changes.plural.firstChange) ||
                (changes.n && !changes.n.firstChange))) {
            this.update();
        }
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
    setContent(message) {
        if (this.attr) {
            this.element.nativeElement.setAttribute(this.attr, message);
        }
        else {
            this.element.nativeElement.innerHTML = message;
        }
    }
    update() {
        if (this.n && this.plural) {
            this.setContent(this.translateService.getPlural(Number(this.n), this.msgid, this.plural, this.args, this.context));
        }
        else {
            this.setContent(this.translateService.getString(this.msgid, this.args, this.context));
        }
    }
    static { this.ɵfac = function TranslateDirective_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TranslateDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(TranslateServiceInjectionToken)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: TranslateDirective, selectors: [["", "translate", ""], ["", "translate-attr", ""]], inputs: { attr: [0, "translate-attr", "attr"], n: [0, "translate-n", "n"], plural: [0, "translate-plural", "plural"], args: [0, "translate-args", "args"], context: [0, "translate-context", "context"] }, features: [i0.ɵɵNgOnChangesFeature] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TranslateDirective, [{
        type: Directive,
        args: [{
                // currently disabling this because of the functionality in our extractor 'angular-gettext-cli'
                // eslint-disable-next-line @angular-eslint/directive-selector
                selector: '[translate],[translate-attr]',
            }]
    }], () => [{ type: i0.ElementRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [TranslateServiceInjectionToken]
            }] }], { attr: [{
            type: Input,
            args: ['translate-attr']
        }], n: [{
            type: Input,
            args: ['translate-n']
        }], plural: [{
            type: Input,
            args: ['translate-plural']
        }], args: [{
            type: Input,
            args: ['translate-args']
        }], context: [{
            type: Input,
            args: ['translate-context']
        }] }); })();

const _c0$N = ["*"];
const _c1$o = a0 => ({ "has-subheader": a0 });
function PageHeaderComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵelement(1, "mon-icon", 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c1$o, ctx_r0.subHeader));
    i0.ɵɵadvance();
    i0.ɵɵproperty("monIconDirect", ctx_r0.monIconDirect)("icon", ctx_r0.monIcon);
} }
function PageHeaderComponent_h1_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h1", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.header, " ");
} }
function PageHeaderComponent_h2_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.header, " ");
} }
function PageHeaderComponent_h1_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "h1", 17);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", ctx_r0.header, i0.ɵɵsanitizeHtml);
} }
function PageHeaderComponent_h2_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "h2", 18);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", ctx_r0.header, i0.ɵɵsanitizeHtml);
} }
function PageHeaderComponent_p_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("placement", ctx_r0.subHeaderTooltipPlacement)("disableTooltip", ctx_r0.subHeaderTooltipEnable)("ngbTooltip", ctx_r0.subHeader);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.subHeader, " ");
} }
function PageHeaderComponent_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate(ctx_r0.subHeader);
} }
function PageHeaderComponent_p_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p", 20);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const tipContent_r2 = i0.ɵɵreference(10);
    i0.ɵɵproperty("placement", ctx_r0.subHeaderTooltipPlacement)("disableTooltip", ctx_r0.subHeaderTooltipEnable)("ngbTooltip", tipContent_r2)("innerHTML", ctx_r0.subHeader, i0.ɵɵsanitizeHtml);
} }
function PageHeaderComponent_a_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 21);
    i0.ɵɵelement(1, "span", 22);
    i0.ɵɵelementStart(2, "span", 23);
    i0.ɵɵtext(3, "Google");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("href", "https://www.google.com/search?q=" + ctx_r0.getWord(), i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("ngbTooltip", "Lookup in Google");
} }
class PageHeaderComponent {
    constructor(element) {
        this.element = element;
        this.headerType = '1';
        this.panelClass = '';
        this.trustAsHtml = true;
        this.subHeaderTooltipPlacement = 'top'; // https://angular-ui.github.io/bootstrap/#!#tooltip - 'tooltip-placement' attribute
    }
    ngOnInit() {
        if (typeof this.subHeaderTooltipPlacement !== 'string' ||
            this.subHeaderTooltipPlacement.trim().length === 0) {
            this.subHeaderTooltipPlacement = 'bottom';
        }
        if (typeof this.subHeaderTooltipEnable !== 'boolean') {
            this.subHeaderTooltipEnable = false;
        }
    }
    getLeftClass() {
        if (typeof this.panelLeftClass === 'string' &&
            this.panelLeftClass.length > 0) {
            return this.panelLeftClass;
        }
        return '';
    }
    getRightClass() {
        if (!this.isFilled()) {
            return 'hidden';
        }
        if (typeof this.panelRightClass === 'string' &&
            this.panelRightClass.length > 0) {
            return this.panelRightClass;
        }
        return '';
    }
    isFilled() {
        const rightSection = this.element.nativeElement.querySelector('.mon-page-header-right-section');
        return Boolean(rightSection?.children?.length);
    }
    getWord() {
        const headerWord = this.header.split('- ');
        return headerWord[1];
    }
    static { this.ɵfac = function PageHeaderComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PageHeaderComponent)(i0.ɵɵdirectiveInject(i0.ElementRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PageHeaderComponent, selectors: [["mon-page-header"]], inputs: { headerType: "headerType", monIcon: "monIcon", monIconDirect: "monIconDirect", panelClass: "panelClass", header: "header", subHeader: "subHeader", panelLeftClass: "panelLeftClass", panelRightClass: "panelRightClass", trustAsHtml: "trustAsHtml", subHeaderTooltipPlacement: "subHeaderTooltipPlacement", subHeaderTooltipEnable: "subHeaderTooltipEnable" }, ngContentSelectors: _c0$N, decls: 17, vars: 11, consts: [["tipContent", ""], [1, "page-header", "d-flex", 3, "ngClass"], [1, "mr-auto", "d-flex", "text-ellipsis", 3, "ngClass"], ["class", "icon-container pr-1", 3, "ngClass", 4, "ngIf"], [1, "text-ellipsis"], ["data-test", "page-h1", "class", "font-weight-300 text-ellipsis", 4, "ngIf"], ["data-test", "page-h2", "class", "font-weight-300 text-ellipsis", 4, "ngIf"], ["data-test", "page-h1", "class", "font-weight-300 text-ellipsis", 3, "innerHTML", 4, "ngIf"], ["data-test", "page-h2", "class", "font-weight-300 text-ellipsis", 3, "innerHTML", 4, "ngIf"], ["class", "header-sub text-gray-small text-ellipsis", 3, "placement", "disableTooltip", "ngbTooltip", 4, "ngIf"], ["class", "header-sub text-gray-small text-ellipsis", 3, "placement", "disableTooltip", "ngbTooltip", "innerHTML", 4, "ngIf"], ["class", "btn cursor-pointer", "target", "_blank", "aria-describedby", "linkOpensInNewTab", 3, "href", 4, "ngIf"], [1, "mon-page-header-right-section", "flex-grow-1", 3, "ngClass"], [1, "icon-container", "pr-1", 3, "ngClass"], [1, "text-link", "mr-1", 3, "monIconDirect", "icon"], ["data-test", "page-h1", 1, "font-weight-300", "text-ellipsis"], ["data-test", "page-h2", 1, "font-weight-300", "text-ellipsis"], ["data-test", "page-h1", 1, "font-weight-300", "text-ellipsis", 3, "innerHTML"], ["data-test", "page-h2", 1, "font-weight-300", "text-ellipsis", 3, "innerHTML"], [1, "header-sub", "text-gray-small", "text-ellipsis", 3, "placement", "disableTooltip", "ngbTooltip"], [1, "header-sub", "text-gray-small", "text-ellipsis", 3, "placement", "disableTooltip", "ngbTooltip", "innerHTML"], ["target", "_blank", "aria-describedby", "linkOpensInNewTab", 1, "btn", "cursor-pointer", 3, "href"], ["aria-hidden", "true", "placement", "bottom", 1, "fab", "fa-google", 3, "ngbTooltip"], ["translate", "", 1, "sr-only"]], template: function PageHeaderComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 1)(1, "div", 2);
            i0.ɵɵtemplate(2, PageHeaderComponent_div_2_Template, 2, 5, "div", 3);
            i0.ɵɵelementStart(3, "div", 4);
            i0.ɵɵtemplate(4, PageHeaderComponent_h1_4_Template, 2, 1, "h1", 5)(5, PageHeaderComponent_h2_5_Template, 2, 1, "h2", 6)(6, PageHeaderComponent_h1_6_Template, 1, 1, "h1", 7)(7, PageHeaderComponent_h2_7_Template, 1, 1, "h2", 8)(8, PageHeaderComponent_p_8_Template, 2, 4, "p", 9)(9, PageHeaderComponent_ng_template_9_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(11, PageHeaderComponent_p_11_Template, 1, 4, "p", 10);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(12, "div");
            i0.ɵɵtext(13, " \u00A0\u00A0 ");
            i0.ɵɵtemplate(14, PageHeaderComponent_a_14_Template, 4, 2, "a", 11);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(15, "div", 12);
            i0.ɵɵprojection(16);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵproperty("ngClass", ctx.panelClass);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", ctx.getLeftClass());
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.monIcon || ctx.monIconDirect);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.headerType === "1" && !ctx.trustAsHtml);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.headerType === "2" && !ctx.trustAsHtml);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.headerType === "1" && ctx.trustAsHtml);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.headerType === "2" && ctx.trustAsHtml);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.trustAsHtml);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.trustAsHtml);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.panelClass === "row" && ctx.trustAsHtml && ctx.header.substr(0, 5) !== "Edit:" && ctx.header.includes("-"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", ctx.getRightClass());
        } }, dependencies: [i1$2.NgClass, i1$2.NgIf, i1$4.NgbTooltip, TranslateDirective, IconComponent], styles: [".page-header[_ngcontent-%COMP%]{margin-bottom:20px;border-bottom:none!important}.page-header[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%], .page-header[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%]{color:#555557;margin:0;line-height:1.11;width:100%;max-width:100%;padding-top:1px}.page-header[_ngcontent-%COMP%]   .position-relative[_ngcontent-%COMP%]{position:static}.page-header[_ngcontent-%COMP%]   .has-subheader[_ngcontent-%COMP%]{padding-top:3px}.page-header[_ngcontent-%COMP%]   .icon-container[_ngcontent-%COMP%]{font-size:24px}.page-header[_ngcontent-%COMP%]   .icon-container.header-two[_ngcontent-%COMP%], .page-header[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%]{font-size:18px}.page-header[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%]{font-size:24px}.page-header[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:#555557;font-weight:400}.page-header[_ngcontent-%COMP%]   .page-header-icon[_ngcontent-%COMP%]{margin-right:10px}.page-header[_ngcontent-%COMP%]   .page-header-icon[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{color:#1c86db;font-size:2.3em}.page-header[_ngcontent-%COMP%]   .page-header-icon.push-down[_ngcontent-%COMP%]{margin-top:8px}.page-header[_ngcontent-%COMP%]   .header-sub[_ngcontent-%COMP%]{font-weight:400;margin-top:1px;margin-bottom:14px}.page-header[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%] + .header-sub[_ngcontent-%COMP%]{font-size:12.96px}.page-header[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%] + .header-sub[_ngcontent-%COMP%]{font-size:11.7px}.page-header[_ngcontent-%COMP%]   .position-static[_ngcontent-%COMP%]{position:static!important}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PageHeaderComponent, [{
        type: Component,
        args: [{ selector: 'mon-page-header', template: "<div class=\"page-header d-flex\" [ngClass]=\"panelClass\">\n    <div class=\"mr-auto d-flex text-ellipsis\" [ngClass]=\"getLeftClass()\">\n        <div class=\"icon-container pr-1\"  [ngClass]=\"{'has-subheader': subHeader}\" *ngIf=\"monIcon || monIconDirect\">\n            <mon-icon [monIconDirect]=\"monIconDirect\" [icon]=\"monIcon\" class=\"text-link mr-1\"></mon-icon>\n        </div>\n        <div class=\"text-ellipsis\">\n            <h1 data-test=\"page-h1\" *ngIf=\"headerType === '1' && !trustAsHtml\" class=\"font-weight-300 text-ellipsis\">\n                {{header}}\n            </h1>\n            <h2 data-test=\"page-h2\" *ngIf=\"headerType === '2' && !trustAsHtml\" class=\"font-weight-300 text-ellipsis\">\n                {{header}}\n            </h2>\n            <h1 data-test=\"page-h1\" *ngIf=\"headerType === '1' && trustAsHtml\" class=\"font-weight-300 text-ellipsis\" [innerHTML]=\"header\">\n            </h1>\n            <h2 data-test=\"page-h2\" *ngIf=\"headerType === '2' && trustAsHtml\" class=\"font-weight-300 text-ellipsis\" [innerHTML]=\"header\">\n            </h2>\n            <p class=\"header-sub text-gray-small text-ellipsis\"\n               *ngIf=\"!trustAsHtml\"\n               [placement]=\"subHeaderTooltipPlacement\"\n               [disableTooltip]=\"subHeaderTooltipEnable\"\n               [ngbTooltip]=\"subHeader\">\n                {{subHeader}}\n            </p>\n            <ng-template #tipContent >{{ subHeader}}</ng-template>\n            <p class=\"header-sub text-gray-small text-ellipsis\"\n               *ngIf=\"trustAsHtml\"\n               [placement]=\"subHeaderTooltipPlacement\"\n               [disableTooltip]=\"subHeaderTooltipEnable\"\n               [ngbTooltip]=\"tipContent\"\n               [innerHTML]=\"subHeader\">\n            </p>\n        </div>\n        <div>\n            &nbsp;&nbsp;\n            <a\n                    *ngIf=\"panelClass === 'row' && trustAsHtml && header.substr(0, 5) !== 'Edit:' && header.includes('-')\"\n                    class=\"btn cursor-pointer\"\n                    target=\"_blank\" aria-describedby=\"linkOpensInNewTab\"\n                    [href]=\"'https://www.google.com/search?q=' + getWord()\"\n            >\n                <span class=\"fab fa-google\" aria-hidden=\"true\" placement=\"bottom\" ngbTooltip=\"{{'Lookup in Google' }}\"></span>\n                <span class=\"sr-only\" translate>Google</span>\n            </a>\n        </div>\n    </div>\n    <div class=\"mon-page-header-right-section flex-grow-1\" [ngClass]=\"getRightClass()\">\n        <ng-content></ng-content>\n    </div>\n</div>\n", styles: [".page-header{margin-bottom:20px;border-bottom:none!important}.page-header h1,.page-header h2{color:#555557;margin:0;line-height:1.11;width:100%;max-width:100%;padding-top:1px}.page-header .position-relative{position:static}.page-header .has-subheader{padding-top:3px}.page-header .icon-container{font-size:24px}.page-header .icon-container.header-two,.page-header h2{font-size:18px}.page-header h1{font-size:24px}.page-header p{color:#555557;font-weight:400}.page-header .page-header-icon{margin-right:10px}.page-header .page-header-icon i{color:#1c86db;font-size:2.3em}.page-header .page-header-icon.push-down{margin-top:8px}.page-header .header-sub{font-weight:400;margin-top:1px;margin-bottom:14px}.page-header h1+.header-sub{font-size:12.96px}.page-header h2+.header-sub{font-size:11.7px}.page-header .position-static{position:static!important}\n"] }]
    }], () => [{ type: i0.ElementRef }], { headerType: [{
            type: Input
        }], monIcon: [{
            type: Input
        }], monIconDirect: [{
            type: Input
        }], panelClass: [{
            type: Input
        }], header: [{
            type: Input
        }], subHeader: [{
            type: Input
        }], panelLeftClass: [{
            type: Input
        }], panelRightClass: [{
            type: Input
        }], trustAsHtml: [{
            type: Input
        }], subHeaderTooltipPlacement: [{
            type: Input
        }], subHeaderTooltipEnable: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(PageHeaderComponent, { className: "PageHeaderComponent" }); })();

/* eslint-disable @angular-eslint/directive-class-suffix */
/**
 * required @Directive decorator so that angular knows there are other angular decorators within this class
 * https://github.com/angular/angular/issues/35295
 */
class BaseFieldComponent {
    getLabelForId(label) {
        if (this.monId) {
            return this.monId;
        }
        if (!label) {
            return Math.random().toString(16)
                .slice(2);
        }
        return StringService.removeWhiteSpaces(label);
    }
    static { this.ɵfac = function BaseFieldComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || BaseFieldComponent)(); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: BaseFieldComponent, inputs: { monId: "monId", name: "name" } }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BaseFieldComponent, [{
        type: Directive
    }], null, { monId: [{
            type: Input
        }], name: [{
            type: Input
        }] }); })();

/**
 * required @Directive decorator so that angular knows there are other angular decorators within this class
 * https://github.com/angular/angular/issues/35295
 */
class AbstractControlValueAccessor extends BaseFieldComponent {
    constructor() {
        super(...arguments);
        this.isRequired = false;
        this.isDisabled = false;
        /**
         * * The registered callback function called when a blur event occurs on the input element.
         */
        this.onTouch = () => { };
        /**
         * The registered callback function called when a change or input event occurs on the input
         */
        this.onChange = () => { };
    }
    /*
     * @deprecated Should only be used in angularjs code when trying to pass an expression to the ng-required attribute
     * Example:
     * <mon-form-field [ng-required]="expression"></mon-form-field>
     */
    set ngRequired(value) {
        this.isRequired = this.getValue(value);
    }
    set required(value) {
        this.isRequired = this.getValue(value);
    }
    get required() {
        return this.isRequired;
    }
    /*
     * @deprecated Should only be used in angularjs code when trying to pass an expression to the ng-disabled attribute
     * Example:
     * <mon-form-field [ng-disabled]="expression"></mon-form-field>
     */
    set ngDisabled(value) {
        this.isDisabled = this.getValue(value);
    }
    set disabled(value) {
        this.isDisabled = this.getValue(value);
    }
    get disabled() {
        return this.isDisabled;
    }
    get value() {
        return this.modelValue;
    }
    set value(v) {
        if (v !== this.modelValue) {
            this.modelValue = v;
            this.onChange(v);
        }
    }
    /** *************************************************
     * Implementation of ControlValueAccessor
     */
    writeValue(value) {
        /**
         * https://github.com/angular/angular/issues/29218
         *
         * This will let us avoid a wrong state of dirty/pristine properties in a form.
         * That can be important for validation, but we still can use an empty value if we need it.
         */
        if (value !== undefined && value !== null) {
            this.modelValue = value;
            this.onChange(value);
        }
    }
    /**
     * Registers a callback function that is called when the control's value changes in the UI.
     */
    registerOnChange(fn) {
        this.onChange = fn;
    }
    /**
     * Registers a function called when the control is touched.
     */
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    setDisabledState(disabled) {
        this.disabled = disabled;
    }
    // **************************************************
    getValue(input) {
        return typeof input === 'boolean' ? input : true;
    }
    static { this.ɵfac = /*@__PURE__*/ (() => { let ɵAbstractControlValueAccessor_BaseFactory; return function AbstractControlValueAccessor_Factory(__ngFactoryType__) { return (ɵAbstractControlValueAccessor_BaseFactory || (ɵAbstractControlValueAccessor_BaseFactory = i0.ɵɵgetInheritedFactory(AbstractControlValueAccessor)))(__ngFactoryType__ || AbstractControlValueAccessor); }; })(); }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: AbstractControlValueAccessor, inputs: { ngRequired: "ngRequired", required: "required", ngDisabled: "ngDisabled", disabled: "disabled" }, features: [i0.ɵɵInheritDefinitionFeature] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AbstractControlValueAccessor, [{
        type: Directive
    }], null, { ngRequired: [{
            type: Input
        }], required: [{
            type: Input
        }], ngDisabled: [{
            type: Input
        }], disabled: [{
            type: Input
        }] }); })();

function ErrorMessagesAcComponent_div_0_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵtext(1, "This field is required");
    i0.ɵɵelementEnd();
} }
function ErrorMessagesAcComponent_div_0_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵtext(1, "Too few characters");
    i0.ɵɵelementEnd();
} }
function ErrorMessagesAcComponent_div_0_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵtext(1, "Too many characters");
    i0.ɵɵelementEnd();
} }
function ErrorMessagesAcComponent_div_0_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.patternMsg);
} }
function ErrorMessagesAcComponent_div_0_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵtext(1, "Invalid email, example: name@domain.com");
    i0.ɵɵelementEnd();
} }
function ErrorMessagesAcComponent_div_0_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵtext(1, "Number too low");
    i0.ɵɵelementEnd();
} }
function ErrorMessagesAcComponent_div_0_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵtext(1, "Number too high");
    i0.ɵɵelementEnd();
} }
function ErrorMessagesAcComponent_div_0_span_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵtext(1, "URL needs to be valid, include http:// or https://");
    i0.ɵɵelementEnd();
} }
function ErrorMessagesAcComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, ErrorMessagesAcComponent_div_0_span_1_Template, 2, 0, "span", 1)(2, ErrorMessagesAcComponent_div_0_span_2_Template, 2, 0, "span", 1)(3, ErrorMessagesAcComponent_div_0_span_3_Template, 2, 0, "span", 1)(4, ErrorMessagesAcComponent_div_0_span_4_Template, 2, 1, "span", 2)(5, ErrorMessagesAcComponent_div_0_span_5_Template, 2, 0, "span", 1)(6, ErrorMessagesAcComponent_div_0_span_6_Template, 2, 0, "span", 1)(7, ErrorMessagesAcComponent_div_0_span_7_Template, 2, 0, "span", 1)(8, ErrorMessagesAcComponent_div_0_span_8_Template, 2, 0, "span", 1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate2("invalid-feedback block col-sm-", ctx_r0.gridSize, " col-sm-offset-", ctx_r0.offset, "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.formElementControl.errors.required && ctx_r0.formElementControl.touched);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.formElementControl.errors.minlength);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.formElementControl.errors.maxlength);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.formElementControl.errors.pattern);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.formElementControl.errors.email);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.formElementControl.errors.min);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.formElementControl.errors.max);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.formElementControl.errors.invalidUrl && ctx_r0.formElementControl.touched);
} }
class ErrorMessagesAcComponent {
    constructor() {
        this.offsetValue = 8;
        this.gridSize = 48 - this.offsetValue;
    }
    set offset(offset) {
        this.offsetValue = offset;
        this.gridSize = 48 - this.offsetValue;
    }
    get offset() {
        return this.offsetValue;
    }
    static { this.ɵfac = function ErrorMessagesAcComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ErrorMessagesAcComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ErrorMessagesAcComponent, selectors: [["mon-form-field-errors-ac"]], inputs: { offset: "offset", patternMsg: "patternMsg", formElementControl: "formElementControl" }, decls: 1, vars: 1, consts: [[3, "class", 4, "ngIf"], ["class", "help-block", "translate", "", "aria-live", "polite", 4, "ngIf"], ["class", "help-block", "aria-live", "polite", 4, "ngIf"], ["translate", "", "aria-live", "polite", 1, "help-block"], ["aria-live", "polite", 1, "help-block"]], template: function ErrorMessagesAcComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ErrorMessagesAcComponent_div_0_Template, 9, 12, "div", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.formElementControl.invalid);
        } }, dependencies: [i1$2.NgIf], styles: [".invalid-feedback[_ngcontent-%COMP%]{display:flex;flex-direction:column}.invalid-feedback[_ngcontent-%COMP%]   .help-block[_ngcontent-%COMP%]{color:#ba322d}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ErrorMessagesAcComponent, [{
        type: Component,
        args: [{ selector: 'mon-form-field-errors-ac', template: "<div class=\"invalid-feedback block col-sm-{{ gridSize }} col-sm-offset-{{ offset }}\" *ngIf=\"formElementControl.invalid\">\n    <span class=\"help-block\" *ngIf=\"formElementControl.errors.required && formElementControl.touched\" translate aria-live=\"polite\">This field is required</span>\n    <span class=\"help-block\" *ngIf=\"formElementControl.errors.minlength\" translate aria-live=\"polite\">Too few characters</span>\n    <span class=\"help-block\" *ngIf=\"formElementControl.errors.maxlength\" translate aria-live=\"polite\">Too many characters</span>\n    <span class=\"help-block\" *ngIf=\"formElementControl.errors.pattern\" aria-live=\"polite\">{{ patternMsg }}</span>\n    <span class=\"help-block\" *ngIf=\"formElementControl.errors.email\" translate aria-live=\"polite\">Invalid email, example: name&#64;domain.com</span>\n    <span class=\"help-block\" *ngIf=\"formElementControl.errors.min\" translate aria-live=\"polite\">Number too low</span>\n    <span class=\"help-block\" *ngIf=\"formElementControl.errors.max\" translate aria-live=\"polite\">Number too high</span>\n    <span class=\"help-block\" *ngIf=\"formElementControl.errors.invalidUrl && formElementControl.touched\" translate aria-live=\"polite\">URL needs to be valid, include http:// or https://</span>\n</div>\n", styles: [".invalid-feedback{display:flex;flex-direction:column}.invalid-feedback .help-block{color:#ba322d}\n"] }]
    }], null, { offset: [{
            type: Input
        }], patternMsg: [{
            type: Input
        }], formElementControl: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ErrorMessagesAcComponent, { className: "ErrorMessagesAcComponent" }); })();

class MonMinDirective {
    validate(control) {
        return Validators.min(this.monMin)(control);
    }
    static { this.ɵfac = function MonMinDirective_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MonMinDirective)(); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: MonMinDirective, selectors: [["", "monMin", ""]], inputs: { monMin: "monMin" }, features: [i0.ɵɵProvidersFeature([{ provide: NG_VALIDATORS, useExisting: MonMinDirective, multi: true }])] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MonMinDirective, [{
        type: Directive,
        args: [{
                selector: '[monMin]',
                providers: [{ provide: NG_VALIDATORS, useExisting: MonMinDirective, multi: true }],
            }]
    }], null, { monMin: [{
            type: Input
        }] }); })();

class MonMaxDirective {
    validate(control) {
        return Validators.max(this.monMax)(control);
    }
    static { this.ɵfac = function MonMaxDirective_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MonMaxDirective)(); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: MonMaxDirective, selectors: [["", "monMax", ""]], inputs: { monMax: "monMax" }, features: [i0.ɵɵProvidersFeature([{ provide: NG_VALIDATORS, useExisting: MonMaxDirective, multi: true }])] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MonMaxDirective, [{
        type: Directive,
        args: [{
                selector: '[monMax]',
                providers: [{ provide: NG_VALIDATORS, useExisting: MonMaxDirective, multi: true }],
            }]
    }], null, { monMax: [{
            type: Input
        }] }); })();

const _c0$M = (a0, a1) => ({ "col-sm-40": a0, "col-sm-48": a1 });
function InputComponent_label_1_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function InputComponent_label_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 7);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, InputComponent_label_1_span_2_Template, 2, 0, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("for", ctx_r1.computedId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.monLabel, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.required);
} }
function InputComponent_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.monHelpText);
} }
function InputComponent_mon_form_field_errors_ac_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mon-form-field-errors-ac", 10);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const inputElement_r3 = i0.ɵɵreference(4);
    i0.ɵɵproperty("offset", ctx_r1.errorMsgOffset)("formElementControl", inputElement_r3.control)("patternMsg", ctx_r1.patternMsg);
} }
class InputComponent extends AbstractControlValueAccessor {
    constructor() {
        super();
        this.errorMsgOffset = 8;
        this.useCustomError = true;
        this.type = 'text';
    }
    ngOnInit() {
        this.computedId = this.getLabelForId(this.monLabel);
    }
    static { this.ɵfac = function InputComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || InputComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: InputComponent, selectors: [["mon-form-field-input"]], inputs: { monLabel: "monLabel", monHelpText: "monHelpText", monPlaceholder: "monPlaceholder", monMin: "monMin", monMax: "monMax", patternMsg: "patternMsg", errorMsgOffset: "errorMsgOffset", useCustomError: "useCustomError", type: "type", minlength: "minlength", maxlength: "maxlength", min: "min", max: "max", pattern: "pattern" }, features: [i0.ɵɵProvidersFeature([{
                    provide: NG_VALUE_ACCESSOR,
                    useExisting: InputComponent,
                    multi: true,
                }]), i0.ɵɵInheritDefinitionFeature], decls: 7, vars: 22, consts: [["inputElement", "ngModel"], [1, "form-group", "row", "mb-1"], ["class", "col-sm-8 col-form-label text-bold capitalize-first-letter text-right separator", 4, "ngIf"], [3, "ngClass"], [1, "form-control", 3, "ngModelChange", "blur", "ngModel", "type", "name", "required", "pattern", "minlength", "maxlength", "email", "min", "max", "monMin", "monMax", "id", "placeholder", "disabled"], ["class", "form-text text-muted", 4, "ngIf"], [3, "offset", "formElementControl", "patternMsg", 4, "ngIf"], [1, "col-sm-8", "col-form-label", "text-bold", "capitalize-first-letter", "text-right", "separator"], [4, "ngIf"], [1, "form-text", "text-muted"], [3, "offset", "formElementControl", "patternMsg"]], template: function InputComponent_Template(rf, ctx) { if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵtemplate(1, InputComponent_label_1_Template, 3, 3, "label", 2);
            i0.ɵɵelementStart(2, "div", 3)(3, "input", 4, 0);
            i0.ɵɵtwoWayListener("ngModelChange", function InputComponent_Template_input_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r1); i0.ɵɵtwoWayBindingSet(ctx.value, $event) || (ctx.value = $event); return i0.ɵɵresetView($event); });
            i0.ɵɵlistener("blur", function InputComponent_Template_input_blur_3_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.onTouch()); });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(5, InputComponent_span_5_Template, 2, 1, "span", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, InputComponent_mon_form_field_errors_ac_6_Template, 1, 3, "mon-form-field-errors-ac", 6);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.monLabel);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(19, _c0$M, ctx.monLabel, !ctx.monLabel));
            i0.ɵɵadvance();
            i0.ɵɵtwoWayProperty("ngModel", ctx.value);
            i0.ɵɵproperty("type", ctx.type)("name", ctx.name)("required", ctx.required)("pattern", ctx.pattern)("minlength", ctx.minlength)("maxlength", ctx.maxlength)("email", ctx.type === "email")("min", ctx.min)("max", ctx.max)("monMin", ctx.monMin)("monMax", ctx.monMax)("id", ctx.computedId)("placeholder", ctx.monPlaceholder)("disabled", ctx.disabled);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.monHelpText);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.useCustomError);
        } }, dependencies: [i1$5.DefaultValueAccessor, i1$5.NgControlStatus, i1$5.RequiredValidator, i1$5.MinLengthValidator, i1$5.MaxLengthValidator, i1$5.PatternValidator, i1$5.EmailValidator, i1$5.NgModel, i1$2.NgClass, i1$2.NgIf, ErrorMessagesAcComponent, MonMinDirective, MonMaxDirective], styles: [".select-grey[_ngcontent-%COMP%]   .ngx-select__toggle[_ngcontent-%COMP%]{display:block;margin:0;position:relative;overflow:hidden;cursor:pointer;border:1px solid #bbb;box-shadow:0 1px #0000000d,inset 0 1px #fffc;box-sizing:border-box;border-radius:3px;font-weight:inherit}.col-form-label[_ngcontent-%COMP%]{padding-top:7px}input.ng-invalid.ng-touched[_ngcontent-%COMP%]{border:1px solid #BA322D}input.ng-valid.ng-touched[_ngcontent-%COMP%]{border:1px solid #3a853a}.form-text[_ngcontent-%COMP%]{display:block;margin-top:5px;color:#9a9d9e}.separator[_ngcontent-%COMP%]{margin-bottom:10px}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InputComponent, [{
        type: Component,
        args: [{ selector: 'mon-form-field-input', providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: InputComponent,
                        multi: true,
                    }], template: "<div class=\"form-group row mb-1\">\n    <label *ngIf=\"monLabel\" [attr.for]=\"computedId\" class=\"col-sm-8 col-form-label text-bold capitalize-first-letter text-right separator\">\n        {{ monLabel }}\n        <span *ngIf=\"required\">*</span>\n    </label>\n    <div [ngClass]=\"{'col-sm-40' : monLabel, 'col-sm-48': !monLabel}\">\n        <input [(ngModel)]=\"value\"\n               [type]=\"type\"\n               (blur)=\"onTouch()\"\n               [name]=\"name\"\n               #inputElement=\"ngModel\"\n               [required]=\"required\"\n               [pattern]=\"pattern\"\n               [minlength]=\"minlength\"\n               [maxlength]=\"maxlength\"\n               [email]=\"type === 'email'\"\n               [min]=\"min\"\n               [max]=\"max\"\n               [monMin]=\"monMin\"\n               [monMax]=\"monMax\"\n               class=\"form-control\"\n               [id]=\"computedId\"\n               [placeholder]=\"monPlaceholder\"\n               [disabled]=\"disabled\"/>\n        <span *ngIf=\"monHelpText\" class=\"form-text text-muted\">{{ monHelpText }}</span>\n    </div>\n    <mon-form-field-errors-ac\n        *ngIf=\"!useCustomError\"\n        [offset]=\"errorMsgOffset\"\n        [formElementControl]=\"inputElement.control\"\n        [patternMsg]=\"patternMsg\"\n    ></mon-form-field-errors-ac>\n</div>\n", styles: [".select-grey .ngx-select__toggle{display:block;margin:0;position:relative;overflow:hidden;cursor:pointer;border:1px solid #bbb;box-shadow:0 1px #0000000d,inset 0 1px #fffc;box-sizing:border-box;border-radius:3px;font-weight:inherit}.col-form-label{padding-top:7px}input.ng-invalid.ng-touched{border:1px solid #BA322D}input.ng-valid.ng-touched{border:1px solid #3a853a}.form-text{display:block;margin-top:5px;color:#9a9d9e}.separator{margin-bottom:10px}\n"] }]
    }], () => [], { monLabel: [{
            type: Input
        }], monHelpText: [{
            type: Input
        }], monPlaceholder: [{
            type: Input
        }], monMin: [{
            type: Input
        }], monMax: [{
            type: Input
        }], patternMsg: [{
            type: Input
        }], errorMsgOffset: [{
            type: Input
        }], useCustomError: [{
            type: Input
        }], type: [{
            type: Input
        }], minlength: [{
            type: Input
        }], maxlength: [{
            type: Input
        }], min: [{
            type: Input
        }], max: [{
            type: Input
        }], pattern: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(InputComponent, { className: "InputComponent" }); })();

const _c0$L = a0 => ({ "active": a0 });
const _c1$n = a0 => ({ "background-color": a0 });
function ColorPickerComponent_div_8_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵlistener("click", function ColorPickerComponent_div_8_div_2_Template_div_click_0_listener() { const newColor_r3 = i0.ɵɵrestoreView(_r2).$implicit; const ctx_r3 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r3.color = newColor_r3); });
    i0.ɵɵelement(1, "span", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const newColor_r3 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵstyleMap(i0.ɵɵpureFunction1(2, _c1$n, newColor_r3));
} }
function ColorPickerComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9)(1, "div", 10);
    i0.ɵɵtemplate(2, ColorPickerComponent_div_8_div_2_Template, 2, 4, "div", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 12)(4, "color-chrome", 13);
    i0.ɵɵlistener("onChangeComplete", function ColorPickerComponent_div_8_Template_color_chrome_onChangeComplete_4_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.selectColor($event)); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r3.presetColors);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("color", ctx_r3.color);
} }
function ColorPickerComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵlistener("click", function ColorPickerComponent_div_9_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.displayColorSelector = false); });
    i0.ɵɵelementEnd();
} }
class ColorPickerComponent {
    constructor() {
        this.init = '#fff';
        this.colorChange = new EventEmitter();
        this.colorValue = '';
        this.displayColorSelector = false;
        this.presetColors = [];
    }
    get color() {
        return this.colorValue;
    }
    set color(val) {
        this.colorValue = val;
        this.colorChange.emit(this.colorValue);
    }
    ngOnInit() {
        for (let i = 0; i < 9; i++) {
            this.presetColors.push('#' + this.getRandomColor());
        }
    }
    selectColor(color) {
        this.color = color.color.hex;
    }
    getRandomColor() {
        return this.fullColorHex(this.getRandomInt(0, 255), this.getRandomInt(0, 255), this.getRandomInt(0, 255));
    }
    rgbToHex(rgb) {
        let hex = Number(rgb).toString(16);
        if (hex.length < 2) {
            hex = '0' + hex;
        }
        return hex;
    }
    fullColorHex(r, g, b) {
        const red = this.rgbToHex(r);
        const green = this.rgbToHex(g);
        const blue = this.rgbToHex(b);
        return red + green + blue;
    }
    getRandomInt(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }
    static { this.ɵfac = function ColorPickerComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ColorPickerComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ColorPickerComponent, selectors: [["mon-color-picker"]], inputs: { color: "color", init: "init" }, outputs: { colorChange: "colorChange" }, decls: 10, vars: 11, consts: [[1, "color-picker-container"], [1, "input-group", "mb-3"], ["id", "color_picker", "translate", "", 1, "sr-only"], ["type", "text", "aria-labelledby", "color_picker", 1, "form-control", 3, "ngModelChange", "ngModel"], [1, "input-group-append"], [1, "input-group-text", 3, "click"], [1, "color-preview"], ["class", "angular-color-picker", 4, "ngIf"], ["class", "color-picker-overlay", 3, "click", 4, "ngIf"], [1, "angular-color-picker"], [1, "color-preset-container"], ["class", "color-preset-column", 3, "click", 4, "ngFor", "ngForOf"], [1, "color-picker-position"], [3, "onChangeComplete", "color"], [1, "color-preset-column", 3, "click"], [1, "color-preset"], [1, "color-picker-overlay", 3, "click"]], template: function ColorPickerComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "label", 2);
            i0.ɵɵtext(3, "Choose a Label Color");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "input", 3);
            i0.ɵɵtwoWayListener("ngModelChange", function ColorPickerComponent_Template_input_ngModelChange_4_listener($event) { i0.ɵɵtwoWayBindingSet(ctx.color, $event) || (ctx.color = $event); return $event; });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "div", 4)(6, "span", 5);
            i0.ɵɵlistener("click", function ColorPickerComponent_Template_span_click_6_listener() { return ctx.displayColorSelector = !ctx.displayColorSelector; });
            i0.ɵɵelement(7, "span", 6);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(8, ColorPickerComponent_div_8_Template, 5, 2, "div", 7)(9, ColorPickerComponent_div_9_Template, 1, 0, "div", 8);
            i0.ɵɵelementEnd()()();
        } if (rf & 2) {
            i0.ɵɵadvance(4);
            i0.ɵɵtwoWayProperty("ngModel", ctx.color);
            i0.ɵɵadvance(2);
            i0.ɵɵclassMap(i0.ɵɵpureFunction1(7, _c0$L, ctx.displayColorSelector));
            i0.ɵɵadvance();
            i0.ɵɵstyleMap(i0.ɵɵpureFunction1(9, _c1$n, ctx.color));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.displayColorSelector);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.displayColorSelector);
        } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, i2.ChromeComponent, i1$5.DefaultValueAccessor, i1$5.NgControlStatus, i1$5.NgModel, TranslateDirective], styles: [".color-picker-container[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]{position:relative;display:flex;flex-wrap:nowrap;align-items:stretch;width:100%}.color-picker-container[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]   .input-group-append[_ngcontent-%COMP%]   .input-group-text[_ngcontent-%COMP%]{align-items:center;padding:5px 10px;margin-bottom:0;font-size:12px;font-weight:400;line-height:1.42857143;color:#555557;text-align:center;white-space:nowrap;background-color:#e6e6e6;border:1px solid #9A9D9E;display:flex}.color-picker-container[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]   .input-group-append[_ngcontent-%COMP%]   .input-group-text.active[_ngcontent-%COMP%]{background-color:#9a9d9e}.color-picker-container[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]   .input-group-append[_ngcontent-%COMP%]   .color-preview[_ngcontent-%COMP%]{width:20px;height:20px}.color-picker-container[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]   .input-group-append[_ngcontent-%COMP%]   .color-preview[_ngcontent-%COMP%]:before{content:\" \"}.color-picker-container[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]   .input-group-append[_ngcontent-%COMP%]   .color-preset-container[_ngcontent-%COMP%]{height:25px;width:282px;margin-top:-20px;margin-left:-22px;padding-top:10px}.color-picker-container[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]   .input-group-append[_ngcontent-%COMP%]   .color-preset-container[_ngcontent-%COMP%]   .color-preset-column[_ngcontent-%COMP%]{display:inline-block;width:30px;height:15px;padding-left:5px;padding-right:5px}.color-picker-container[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]   .input-group-append[_ngcontent-%COMP%]   .color-preset-container[_ngcontent-%COMP%]   .color-preset-column[_ngcontent-%COMP%]   .color-preset[_ngcontent-%COMP%]{display:inline-block;height:100%;width:100%;border-radius:3px}.color-picker-container[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]   .input-group-append[_ngcontent-%COMP%]   .color-picker-position[_ngcontent-%COMP%]{width:225px;margin:20px auto 0}.color-picker-container[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]   .input-group-append[_ngcontent-%COMP%]   .angular-color-picker[_ngcontent-%COMP%]{position:fixed;z-index:10002;padding-top:20px;margin-top:28px}.color-picker-container[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]   .input-group-append[_ngcontent-%COMP%]   .color-picker-overlay[_ngcontent-%COMP%]{position:fixed;inset:0;width:100%;height:100%;z-index:10001}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ColorPickerComponent, [{
        type: Component,
        args: [{ selector: 'mon-color-picker', template: "<div class=\"color-picker-container\">\n    <div class=\"input-group mb-3\">\n        <label id=\"color_picker\" class=\"sr-only\" translate>Choose a Label Color</label>\n        <input type=\"text\" [(ngModel)]=\"color\" aria-labelledby=\"color_picker\" class=\"form-control\"/>\n        <div class=\"input-group-append\">\n            <span class=\"input-group-text\"\n                  (click)=\"displayColorSelector = !displayColorSelector\"\n                  [class]=\"{'active': displayColorSelector}\">\n                <span class=\"color-preview\" [style]=\"{'background-color': color}\"></span>\n            </span>\n            <div class=\"angular-color-picker\" *ngIf=\"displayColorSelector\">\n                <div class=\"color-preset-container\">\n                    <div class=\"color-preset-column\" *ngFor=\"let newColor of presetColors\" (click)=\"color = newColor\">\n                        <span [style]=\"{'background-color': newColor}\" class=\"color-preset\"></span>\n                    </div>\n                </div>\n                <div class=\"color-picker-position\">\n                    <color-chrome [color]=\"color\" (onChangeComplete)=\"selectColor($event)\"></color-chrome>\n                </div>\n            </div>\n            <div class=\"color-picker-overlay\" *ngIf=\"displayColorSelector\" (click)=\"displayColorSelector = false\"></div>\n        </div>\n    </div>\n</div>\n", styles: [".color-picker-container .input-group{position:relative;display:flex;flex-wrap:nowrap;align-items:stretch;width:100%}.color-picker-container .input-group .input-group-append .input-group-text{align-items:center;padding:5px 10px;margin-bottom:0;font-size:12px;font-weight:400;line-height:1.42857143;color:#555557;text-align:center;white-space:nowrap;background-color:#e6e6e6;border:1px solid #9A9D9E;display:flex}.color-picker-container .input-group .input-group-append .input-group-text.active{background-color:#9a9d9e}.color-picker-container .input-group .input-group-append .color-preview{width:20px;height:20px}.color-picker-container .input-group .input-group-append .color-preview:before{content:\" \"}.color-picker-container .input-group .input-group-append .color-preset-container{height:25px;width:282px;margin-top:-20px;margin-left:-22px;padding-top:10px}.color-picker-container .input-group .input-group-append .color-preset-container .color-preset-column{display:inline-block;width:30px;height:15px;padding-left:5px;padding-right:5px}.color-picker-container .input-group .input-group-append .color-preset-container .color-preset-column .color-preset{display:inline-block;height:100%;width:100%;border-radius:3px}.color-picker-container .input-group .input-group-append .color-picker-position{width:225px;margin:20px auto 0}.color-picker-container .input-group .input-group-append .angular-color-picker{position:fixed;z-index:10002;padding-top:20px;margin-top:28px}.color-picker-container .input-group .input-group-append .color-picker-overlay{position:fixed;inset:0;width:100%;height:100%;z-index:10001}\n"] }]
    }], null, { color: [{
            type: Input
        }], init: [{
            type: Input
        }], colorChange: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ColorPickerComponent, { className: "ColorPickerComponent" }); })();

const MonEventServiceInjectionToken = new InjectionToken('MonEventService');

class EventTriggerDirective {
    constructor(element, eventService) {
        this.element = element;
        this.eventService = eventService;
    }
    onChange() {
        if (this.monEventParams) {
            this.eventService.run(this.monEventTrigger, this.monEventParams);
        }
        else {
            this.eventService.run(this.monEventTrigger);
        }
    }
    onClick() {
        if (!this.element.nativeElement.matches('input') ||
            !this.element.nativeElement.matches('form-field-input')) {
            if (this.monEventParams) {
                this.eventService.run(this.monEventTrigger, this.monEventParams);
            }
            else {
                this.eventService.run(this.monEventTrigger);
            }
        }
    }
    static { this.ɵfac = function EventTriggerDirective_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || EventTriggerDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(MonEventServiceInjectionToken)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: EventTriggerDirective, selectors: [["", "monEventTrigger", ""]], hostBindings: function EventTriggerDirective_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("change", function EventTriggerDirective_change_HostBindingHandler() { return ctx.onChange(); })("click", function EventTriggerDirective_click_HostBindingHandler() { return ctx.onClick(); });
        } }, inputs: { monEventTrigger: "monEventTrigger", monEventParams: "monEventParams" } }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EventTriggerDirective, [{
        type: Directive,
        args: [{
                selector: '[monEventTrigger]',
            }]
    }], () => [{ type: i0.ElementRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [MonEventServiceInjectionToken]
            }] }], { monEventTrigger: [{
            type: Input
        }], monEventParams: [{
            type: Input
        }], onChange: [{
            type: HostListener,
            args: ['change']
        }], onClick: [{
            type: HostListener,
            args: ['click']
        }] }); })();

class LabelColorInverter {
    /**
     * @memberOf LabelColorInverter
     * @param hexColor - Hexadecimal color
     * @desc Return the appropriate inverted hexadecimal color according to WCAG 2.0 level AA
     * @return
     */
    static getTextColor(hexColor) {
        const background = this.getLuminance(hexColor);
        const foreground = this.getLuminance('#000000');
        const ratio = (background + 0.05) / (foreground + 0.05); // ratio between foreground and background luminance
        if (ratio >= 4.5) {
            return '#000000'; // ratio needs to be at least 4.5 according to WCAG 2.0 level AA
        }
        return '#FFFFFF';
    }
    // PROTECTED
    /**
     * @memberOf LabelColorInverter
     * @param c - A hex value of an hex color code
     * @return
     * @desc Return the decimal value of a hex value
     */
    static getRGB(c) {
        const colorDecimal = parseInt(c, 16) / 255;
        if (colorDecimal <= 0.03928) {
            return colorDecimal / 12.92;
        }
        else {
            return Math.pow((colorDecimal + 0.055) / 1.055, 2.4);
        }
    }
    /**
     * @memberOf LabelColorInverter
     * @param hexColor - Hexadecimal color
     * @return
     * @desc Return the luminance brightness number, ranging from 0 - 255
     */
    static getLuminance(hexColor) {
        return (0.2126 * this.getRGB(hexColor.substr(1, 2)) +
            0.7152 * this.getRGB(hexColor.substr(3, 2)) +
            0.0722 * this.getRGB(hexColor.substr(-2)));
    }
    static { this.ɵfac = function LabelColorInverter_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || LabelColorInverter)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: LabelColorInverter, factory: LabelColorInverter.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LabelColorInverter, [{
        type: Injectable
    }], null, null); })();

class InverseColorCode {
    transform(hex) {
        return LabelColorInverter.getTextColor(hex);
    }
    static { this.ɵfac = function InverseColorCode_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || InverseColorCode)(); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "monInverseColorCode", type: InverseColorCode, pure: true }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InverseColorCode, [{
        type: Pipe,
        args: [{
                name: 'monInverseColorCode',
            }]
    }], null, null); })();

const _c0$K = ["labelForm"];
const _c1$m = (a0, a1) => ({ "background-color": a0, color: a1 });
const _c2$e = () => ({ action: "label-form-save" });
const _c3$8 = a0 => ({ "fas fa-spinner fa-spin fa-fw ": a0 });
class FormLabelComponent {
    constructor(translateService, toastService, activeDialog) {
        this.translateService = translateService;
        this.toastService = toastService;
        this.activeDialog = activeDialog;
        this.label = { name: '', color: '' };
        this.defaultColor = '#57b2b7';
        this.onSubmit = new EventEmitter();
    }
    ngOnInit() {
        if (this.isNewLabel()) {
            this.title = this.translateService.getString('Create label');
            this.label.color = this.defaultColor;
        }
        else {
            this.title = this.translateService.getString('Edit label');
        }
    }
    async submit() {
        this.onSave = true;
        const params = {
            name: this.label.name,
            color: this.label.color,
        };
        if (this.isNewLabel()) {
            if (this.createLabel) {
                try {
                    const result = await this.createLabel(params);
                    this.toastService.success(this.translateService.getString('Label created'));
                    this.close(result);
                }
                catch (e) {
                    this.onSave = false;
                }
            }
            else {
                this.onSubmit.emit(params);
            }
        }
        else {
            if (this.updateLabel) {
                try {
                    const result = await this.updateLabel(params);
                    this.toastService.success(this.translateService.getString('Label updated'));
                    this.close(result);
                }
                catch (e) {
                    this.onSave = false;
                }
            }
            else {
                this.onSubmit.emit(params);
            }
        }
    }
    close(data) {
        this.activeDialog.close(data);
    }
    isNewLabel() {
        return this.label.id === undefined || this.label.id === null;
    }
    static { this.ɵfac = function FormLabelComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FormLabelComponent)(i0.ɵɵdirectiveInject(TranslateServiceInjectionToken), i0.ɵɵdirectiveInject(ToastService), i0.ɵɵdirectiveInject(ActiveDialog)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FormLabelComponent, selectors: [["mon-form-label"]], viewQuery: function FormLabelComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$K, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.labelForm = _t.first);
        } }, inputs: { label: "label", createLabel: "createLabel", updateLabel: "updateLabel", defaultColor: "defaultColor" }, outputs: { onSubmit: "onSubmit" }, decls: 20, vars: 19, consts: [["labelForm", "ngForm"], ["name", "labelForm", 1, "mon-form-label-container", 3, "ngSubmit"], [1, "mon-dialog-header"], [1, "mon-form-label-header", 3, "header"], [1, "mon-dialog-body-with-footer", "bg-white"], [1, "mon-form-label-content"], [1, "mon-form-label-content-column"], ["monLabel", "", "name", "name", 3, "ngModelChange", "ngModel", "monPlaceholder", "required"], [3, "colorChange", "color"], ["translate", ""], [1, "label", "mon-form-label-preview", 3, "ngStyle"], [1, "mon-dialog-footer", "text-right"], [1, "btn", "btn-border-radius", "btn-marine-blue", 3, "click", "disabled", "monEventTrigger", "monEventParams"], ["aria-hidden", "true", 3, "ngClass"]], template: function FormLabelComponent_Template(rf, ctx) { if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "form", 1, 0);
            i0.ɵɵlistener("ngSubmit", function FormLabelComponent_Template_form_ngSubmit_0_listener() { i0.ɵɵrestoreView(_r1); const labelForm_r2 = i0.ɵɵreference(1); return i0.ɵɵresetView(!ctx.onSave && labelForm_r2.valid && ctx.submit()); });
            i0.ɵɵelementStart(2, "div", 2);
            i0.ɵɵelement(3, "mon-page-header", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "div", 4)(5, "div", 5)(6, "div", 6)(7, "mon-form-field-input", 7);
            i0.ɵɵtwoWayListener("ngModelChange", function FormLabelComponent_Template_mon_form_field_input_ngModelChange_7_listener($event) { i0.ɵɵrestoreView(_r1); i0.ɵɵtwoWayBindingSet(ctx.label.name, $event) || (ctx.label.name = $event); return i0.ɵɵresetView($event); });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "mon-color-picker", 8);
            i0.ɵɵtwoWayListener("colorChange", function FormLabelComponent_Template_mon_color_picker_colorChange_8_listener($event) { i0.ɵɵrestoreView(_r1); i0.ɵɵtwoWayBindingSet(ctx.label.color, $event) || (ctx.label.color = $event); return i0.ɵɵresetView($event); });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(9, "div", 6)(10, "div", 9);
            i0.ɵɵtext(11, " Label preview ");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(12, "div", 10);
            i0.ɵɵpipe(13, "monInverseColorCode");
            i0.ɵɵtext(14);
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(15, "div", 11)(16, "button", 12);
            i0.ɵɵlistener("click", function FormLabelComponent_Template_button_click_16_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.submit()); });
            i0.ɵɵelementStart(17, "span", 9);
            i0.ɵɵtext(18, "Save");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(19, "span", 13);
            i0.ɵɵelementEnd()()();
        } if (rf & 2) {
            const labelForm_r2 = i0.ɵɵreference(1);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("header", ctx.title);
            i0.ɵɵadvance(4);
            i0.ɵɵtwoWayProperty("ngModel", ctx.label.name);
            i0.ɵɵproperty("monPlaceholder", ctx.translateService.getString("Label name"))("required", true);
            i0.ɵɵadvance();
            i0.ɵɵtwoWayProperty("color", ctx.label.color);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction2(13, _c1$m, ctx.label.color, i0.ɵɵpipeBind1(13, 11, ctx.label.color)));
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.label.name, " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("disabled", ctx.onSave || !labelForm_r2.valid)("monEventTrigger", "actionTrigger")("monEventParams", i0.ɵɵpureFunction0(16, _c2$e));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(17, _c3$8, ctx.onSave));
        } }, dependencies: [PageHeaderComponent, i1$5.ɵNgNoValidate, i1$5.NgControlStatus, i1$5.NgControlStatusGroup, i1$5.RequiredValidator, i1$5.NgModel, i1$5.NgForm, i1$2.NgClass, i1$2.NgStyle, InputComponent, ColorPickerComponent, EventTriggerDirective, InverseColorCode], styles: [".mon-form-label-container[_ngcontent-%COMP%]{height:326px}.mon-form-label-container[_ngcontent-%COMP%]   .mon-form-label-content[_ngcontent-%COMP%]{display:flex;padding:20px}.mon-form-label-container[_ngcontent-%COMP%]   .mon-form-label-content[_ngcontent-%COMP%]   .mon-form-label-content-column[_ngcontent-%COMP%]{flex:1}.mon-form-label-container[_ngcontent-%COMP%]   .mon-form-label-content[_ngcontent-%COMP%]   .mon-form-label-content-column[_ngcontent-%COMP%]:first-child{padding-right:15px}.mon-form-label-container[_ngcontent-%COMP%]   .mon-form-label-content[_ngcontent-%COMP%]   .mon-form-label-content-column[_ngcontent-%COMP%]:first-child   mon-form-field-input[_ngcontent-%COMP%]   .form-group[_ngcontent-%COMP%]{margin-left:0;margin-right:0}.mon-form-label-container[_ngcontent-%COMP%]   .mon-form-label-content[_ngcontent-%COMP%]   .mon-form-label-content-column[_ngcontent-%COMP%]:first-child   mon-form-field-input[_ngcontent-%COMP%]   .form-group[_ngcontent-%COMP%] > .col-sm-48[_ngcontent-%COMP%]{padding-left:0;padding-right:0}.mon-form-label-container[_ngcontent-%COMP%]   .mon-form-label-content[_ngcontent-%COMP%]   .mon-form-label-content-column[_ngcontent-%COMP%]:last-child{padding-left:15px}.mon-form-label-container[_ngcontent-%COMP%]   .mon-dialog-header[_ngcontent-%COMP%]{background-color:#fff;position:absolute;top:0;height:116px;width:100%;padding:5px 20px 8px 63px;border-bottom:1px solid hsl(0,0%,90%)!important}.mon-form-label-container[_ngcontent-%COMP%]   .mon-dialog-body-with-footer[_ngcontent-%COMP%]{position:absolute;top:116px;background:#f3f5f7;overflow-y:scroll;overflow-x:hidden;width:100%;bottom:70px}.mon-form-label-container[_ngcontent-%COMP%]   .mon-dialog-footer[_ngcontent-%COMP%]{background-color:#fff;position:absolute;bottom:0;width:100%;height:70px;border-top:3px solid hsl(0,0%,90%);padding-top:23px;padding-right:23px}.mon-form-label-container[_ngcontent-%COMP%]   .text-right[_ngcontent-%COMP%]{text-align:right}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormLabelComponent, [{
        type: Component,
        args: [{ selector: 'mon-form-label', template: "<form class=\"mon-form-label-container\" name=\"labelForm\" #labelForm=\"ngForm\" (ngSubmit)=\"!onSave && labelForm.valid && submit()\">\n    <div class=\"mon-dialog-header\">\n        <mon-page-header class=\"mon-form-label-header\" [header]=\"title\"></mon-page-header>\n    </div>\n    <div class=\"mon-dialog-body-with-footer bg-white\">\n        <div class=\"mon-form-label-content\">\n            <div class=\"mon-form-label-content-column\">\n                <mon-form-field-input\n                    monLabel=\"\"\n                    [(ngModel)]=\"label.name\"\n                    [monPlaceholder]=\"translateService.getString('Label name')\"\n                    name=\"name\"\n                    [required]=\"true\">\n                </mon-form-field-input>\n                <mon-color-picker [(color)]=\"label.color\"></mon-color-picker>\n            </div>\n            <div class=\"mon-form-label-content-column\">\n                <div translate>\n                    Label preview\n                </div>\n                <div class=\"label mon-form-label-preview\"\n                     [ngStyle]=\"{'background-color': label.color, color: (label.color | monInverseColorCode)}\">\n                    {{label.name}}\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"mon-dialog-footer text-right\">\n        <button class=\"btn btn-border-radius btn-marine-blue\"\n                [disabled]=\"onSave || !labelForm.valid\"\n                [monEventTrigger]=\"'actionTrigger'\"\n                [monEventParams]=\"{action: 'label-form-save'}\"\n                (click)=\"submit()\">\n            <span translate>Save</span>\n            <span [ngClass]=\"{'fas fa-spinner fa-spin fa-fw ': onSave}\" aria-hidden=\"true\"></span>\n        </button>\n    </div>\n</form>\n", styles: [".mon-form-label-container{height:326px}.mon-form-label-container .mon-form-label-content{display:flex;padding:20px}.mon-form-label-container .mon-form-label-content .mon-form-label-content-column{flex:1}.mon-form-label-container .mon-form-label-content .mon-form-label-content-column:first-child{padding-right:15px}.mon-form-label-container .mon-form-label-content .mon-form-label-content-column:first-child mon-form-field-input .form-group{margin-left:0;margin-right:0}.mon-form-label-container .mon-form-label-content .mon-form-label-content-column:first-child mon-form-field-input .form-group>.col-sm-48{padding-left:0;padding-right:0}.mon-form-label-container .mon-form-label-content .mon-form-label-content-column:last-child{padding-left:15px}.mon-form-label-container .mon-dialog-header{background-color:#fff;position:absolute;top:0;height:116px;width:100%;padding:5px 20px 8px 63px;border-bottom:1px solid hsl(0,0%,90%)!important}.mon-form-label-container .mon-dialog-body-with-footer{position:absolute;top:116px;background:#f3f5f7;overflow-y:scroll;overflow-x:hidden;width:100%;bottom:70px}.mon-form-label-container .mon-dialog-footer{background-color:#fff;position:absolute;bottom:0;width:100%;height:70px;border-top:3px solid hsl(0,0%,90%);padding-top:23px;padding-right:23px}.mon-form-label-container .text-right{text-align:right}\n"] }]
    }], () => [{ type: undefined, decorators: [{
                type: Inject,
                args: [TranslateServiceInjectionToken]
            }] }, { type: ToastService }, { type: ActiveDialog }], { label: [{
            type: Input
        }], createLabel: [{
            type: Input
        }], updateLabel: [{
            type: Input
        }], defaultColor: [{
            type: Input
        }], onSubmit: [{
            type: Output
        }], labelForm: [{
            type: ViewChild,
            args: ['labelForm', { static: false }]
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormLabelComponent, { className: "FormLabelComponent" }); })();

const dialogAnimations = () => {
    return {
        animations: [
            trigger('openClose', [
                state(DIALOG_STATE.open, style({
                    transform: 'translateX(0)',
                })),
                state(DIALOG_STATE.closed, style({
                    transform: 'translateX(100%)',
                })),
                transition(`${DIALOG_STATE.open} <=> ${DIALOG_STATE.closed}`, [animate('0.4s')]),
            ]),
        ],
    };
};

class TranslatePipe {
    constructor(translateService) {
        this.translateService = translateService;
        /**
         * {value} is used to store the result from the transform method after translations are applied
         *
         * @private
         */
        this.value = '';
        this.onLangChange = this.translateService.onLanguageChange$().subscribe({
            next: () => {
                if (this.lastText) {
                    this.lastText = null;
                    this.updateValue(this.text = '', this.args, this.context);
                }
            },
        });
    }
    ngOnDestroy() {
        this.dispose();
    }
    /**
     * Translate string
     *
     * @param text - string to be translated
     * @param context - string - the context of the string
     * @param args - ArgsInterface - arguments passed for interpolation
     */
    transform(text, context, args) {
        if (!text) {
            return text;
        }
        // capturing values here to use in the constructor subscription
        this.args = args;
        this.context = context;
        this.text = text;
        // if we ask another time for the same text, return the last value
        if (isEqual(args, this.lastArgs) && this.lastText === text) {
            return this.value;
        }
        // store the text, in case it changes
        this.lastText = text;
        // store args, in case they change
        this.lastArgs = args;
        this.updateValue(text, args, context);
        return this.value;
    }
    /**
     * update the text to be translated, stored in the {value} prop
     *
     * @param text
     * @param args
     * @param context
     *
     * @private
     */
    updateValue(text, args, context) {
        const res = this.translateService.getString(text, args, context);
        this.value = res !== undefined ? res : text;
        this.lastText = text;
    }
    /**
     * Clean existing subscriptions
     *
     * @private
     */
    dispose() {
        if (typeof this.onLangChange !== 'undefined') {
            this.onLangChange.unsubscribe();
            this.onLangChange = undefined;
        }
    }
    static { this.ɵfac = function TranslatePipe_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TranslatePipe)(i0.ɵɵdirectiveInject(TranslateServiceInjectionToken, 16)); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "translate", type: TranslatePipe, pure: false }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TranslatePipe, [{
        type: Pipe,
        args: [{
                name: 'translate',
                pure: false, // needs to be false to perform further updates when fx - changing language
            }]
    }], () => [{ type: undefined, decorators: [{
                type: Inject,
                args: [TranslateServiceInjectionToken]
            }] }], null); })();

const _c0$J = ["*"];
const { animations: animations$1 } = dialogAnimations();
class DialogComponent {
    get classes() {
        return [
            'mon-dialog-container',
            ...this.overlayClass?.split(' ') || '',
        ];
    }
    get role() {
        return 'dialog';
    }
    get ariaModal() {
        return true;
    }
    get labelBy() {
        return this.ariaLabelledBy;
    }
    get describedBy() {
        return this.ariaDescribedBy;
    }
    get openClose() {
        return this.getState();
    }
    get done() {
        return this.animationDone();
    }
    constructor(activeDialog, elRef, dialogService, configFocusTrapFactory) {
        this.activeDialog = activeDialog;
        this.elRef = elRef;
        this.dialogService = dialogService;
        this.manualFocus = false;
        this.componentClosed = new EventEmitter();
        this.overlayClass = null;
        this.focusTrap = null;
        this.currentState = DIALOG_STATE.closed;
        this.previouslyFocusedElement = null;
        this.configFocusTrap = configFocusTrapFactory;
    }
    click(e) {
        if (e.target && this.currentState === DIALOG_STATE.open) {
            const el = e.target;
            if (el.tagName && el.tagName.toUpperCase() === 'MON-BACKDROP') {
                let closestDialog = el.nextElementSibling;
                if (closestDialog !== this.elRef.nativeElement) {
                    closestDialog = closestDialog?.nextElementSibling;
                }
                // ensures that this instanse of dialog belongs to clicked backdrop ("next sibling" or "next next sibling")
                if (closestDialog === this.elRef.nativeElement) {
                    this.close();
                }
            }
        }
    }
    keydownEscape(e) {
        if (e.target) {
            const el = e.target;
            if (this.elRef.nativeElement.contains(el)) {
                this.close();
            }
            else if (el === document.body) {
                const activeDialogs = this.dialogService.getActiveDialogs();
                activeDialogs[activeDialogs.length - 1]?.close();
            }
        }
    }
    ngOnInit() {
        setTimeout(() => this.setState(DIALOG_STATE.open));
    }
    ngDoCheck() {
        if (this.manualFocus !== true && !this.focusTrap?.hasAttached()) {
            this.focusTrap?.attachAnchors();
        }
    }
    async ngAfterContentInit() {
        if (this.manualFocus !== true) {
            this.focusTrap = this.configFocusTrap.create(this.elRef.nativeElement, { defer: true });
            this.focusTrap.attachAnchors();
            this.previouslyFocusedElement = document.activeElement;
            await this.focusTrap.focusInitialElementWhenReady();
        }
    }
    ngOnDestroy() {
        if (this.focusTrap) {
            this.focusTrap.destroy();
        }
        // If we stored a previously focused element when using autoCapture, return focus to that
        // element now that the trapped region is being destroyed.
        if (this.previouslyFocusedElement) {
            this.previouslyFocusedElement.focus();
            this.previouslyFocusedElement = null;
        }
    }
    getFocusTrap() {
        return this.focusTrap;
    }
    setState(newState) {
        this.currentState = newState;
    }
    getState() {
        return this.currentState;
    }
    animationDone() {
        if (this.currentState === DIALOG_STATE.open) {
            this.componentClosed.emit(false);
        }
        else {
            this.componentClosed.emit(true);
        }
    }
    close() {
        this.activeDialog?.close();
    }
    static { this.ɵfac = function DialogComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DialogComponent)(i0.ɵɵdirectiveInject(ActiveDialog), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(DialogService), i0.ɵɵdirectiveInject(i3.ConfigurableFocusTrapFactory)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DialogComponent, selectors: [["mon-dialog"]], hostVars: 8, hostBindings: function DialogComponent_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("click", function DialogComponent_click_HostBindingHandler($event) { return ctx.click($event); }, false, i0.ɵɵresolveDocument)("keydown.escape", function DialogComponent_keydown_escape_HostBindingHandler($event) { return ctx.keydownEscape($event); }, false, i0.ɵɵresolveDocument);
        } if (rf & 2) {
            i0.ɵɵhostProperty("[attr.aria-modal]", ctx.ariaModal)("[attr.aria-labelledby]", ctx.labelBy)("[attr.aria-describedby]", ctx.describedBy);
            i0.ɵɵsyntheticHostProperty("@openClose", ctx.openClose);
            i0.ɵɵhostProperty("(@openClose.done)", ctx.done);
            i0.ɵɵattribute("role", ctx.role);
            i0.ɵɵclassMap(ctx.classes);
        } }, inputs: { manualFocus: "manualFocus" }, ngContentSelectors: _c0$J, decls: 4, vars: 3, consts: [["type", "button", 1, "mon-dialog-close", 3, "click"], [1, "fas", "fa-times", "cursor-pointer"]], template: function DialogComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "button", 0);
            i0.ɵɵpipe(1, "translate");
            i0.ɵɵlistener("click", function DialogComponent_Template_button_click_0_listener() { return ctx.close(); });
            i0.ɵɵelement(2, "span", 1);
            i0.ɵɵelementEnd();
            i0.ɵɵprojection(3);
        } if (rf & 2) {
            i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 1, "Exit overlay"));
        } }, dependencies: [TranslatePipe], styles: ["[_nghost-%COMP%]{position:fixed;right:0;top:0;z-index:10000;bottom:0;background-color:var(--mon-dialog-background-color, #fff)}.mon-dialog-size-xs[_nghost-%COMP%]{width:30%}.mon-dialog-size-xs.center[_nghost-%COMP%]{right:35%}.mon-dialog-size-xs.middle[_nghost-%COMP%]{top:35%;bottom:auto}.mon-dialog-size-sm[_nghost-%COMP%]{width:50%}.mon-dialog-size-sm.center[_nghost-%COMP%]{right:25%}.mon-dialog-size-sm.middle[_nghost-%COMP%]{top:25%;bottom:auto}.mon-dialog-size-md[_nghost-%COMP%]{width:65%}.mon-dialog-size-md.center[_nghost-%COMP%]{right:17.5%}.mon-dialog-size-md.middle[_nghost-%COMP%]{top:17.5%;bottom:auto}.mon-dialog-size-lg[_nghost-%COMP%]{width:85%}.mon-dialog-size-lg.center[_nghost-%COMP%]{right:7.5%}.mon-dialog-size-lg.middle[_nghost-%COMP%]{top:7.5%;bottom:auto}.mon-dialog-size-xl[_nghost-%COMP%]{width:100%}.mon-dialog-size-xl.center[_nghost-%COMP%]{right:0%}.mon-dialog-size-xl.middle[_nghost-%COMP%]{top:0%;bottom:auto}.mon-dialog-size-fw[_nghost-%COMP%]{width:99%}.mon-dialog-size-fw.center[_nghost-%COMP%]{right:.5%}.mon-dialog-size-fw.middle[_nghost-%COMP%]{top:.5%;bottom:auto}.mon-dialog-close[_ngcontent-%COMP%]{position:absolute;top:35px;left:30px;border:none;z-index:10000;background-color:transparent;font-size:20px}"], data: { animation: animations$1 } }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DialogComponent, [{
        type: Component,
        args: [{ selector: 'mon-dialog', animations: animations$1, template: "<button type=\"button\"\n        attr.aria-label=\"{{ 'Exit overlay' | translate }}\"\n        (click)=\"close()\"\n        class=\"mon-dialog-close\">\n        <span class=\"fas fa-times cursor-pointer\"></span>\n</button>\n\n\n<ng-content></ng-content>\n", styles: [":host{position:fixed;right:0;top:0;z-index:10000;bottom:0;background-color:var(--mon-dialog-background-color, #fff)}:host.mon-dialog-size-xs{width:30%}:host.mon-dialog-size-xs.center{right:35%}:host.mon-dialog-size-xs.middle{top:35%;bottom:auto}:host.mon-dialog-size-sm{width:50%}:host.mon-dialog-size-sm.center{right:25%}:host.mon-dialog-size-sm.middle{top:25%;bottom:auto}:host.mon-dialog-size-md{width:65%}:host.mon-dialog-size-md.center{right:17.5%}:host.mon-dialog-size-md.middle{top:17.5%;bottom:auto}:host.mon-dialog-size-lg{width:85%}:host.mon-dialog-size-lg.center{right:7.5%}:host.mon-dialog-size-lg.middle{top:7.5%;bottom:auto}:host.mon-dialog-size-xl{width:100%}:host.mon-dialog-size-xl.center{right:0%}:host.mon-dialog-size-xl.middle{top:0%;bottom:auto}:host.mon-dialog-size-fw{width:99%}:host.mon-dialog-size-fw.center{right:.5%}:host.mon-dialog-size-fw.middle{top:.5%;bottom:auto}.mon-dialog-close{position:absolute;top:35px;left:30px;border:none;z-index:10000;background-color:transparent;font-size:20px}\n"] }]
    }], () => [{ type: ActiveDialog }, { type: i0.ElementRef }, { type: DialogService }, { type: i3.ConfigurableFocusTrapFactory }], { manualFocus: [{
            type: Input
        }], classes: [{
            type: HostBinding,
            args: ['class']
        }], role: [{
            type: HostBinding,
            args: ['attr.role']
        }], ariaModal: [{
            type: HostBinding,
            args: ['[attr.aria-modal]']
        }], labelBy: [{
            type: HostBinding,
            args: ['[attr.aria-labelledby]']
        }], describedBy: [{
            type: HostBinding,
            args: ['[attr.aria-describedby]']
        }], openClose: [{
            type: HostBinding,
            args: ['@openClose']
        }], done: [{
            type: HostBinding,
            args: ['(@openClose.done)']
        }], click: [{
            type: HostListener,
            args: ['document:click', ['$event']]
        }], keydownEscape: [{
            type: HostListener,
            args: ['document:keydown.escape', ['$event']]
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DialogComponent, { className: "DialogComponent" }); })();

class MockDialogService {
    constructor() {
        this.open = () => Promise.resolve(new MockActiveDialogService());
        this.closeAll = () => Promise.resolve();
    }
}

let DialogRef = class DialogRef {
    constructor(backdropRef, overlayRef, contentRef, monPromptService, translateService, dialogOptions) {
        this.backdropRef = backdropRef;
        this.overlayRef = overlayRef;
        this.contentRef = contentRef;
        this.monPromptService = monPromptService;
        this.translateService = translateService;
        this.dialogOptions = dialogOptions;
        this.focusTrap = null;
        this.beforeClosedCallback = null;
        this.isClosing = false;
    }
    /**
     * @desc Get the Component instance (not the HTML element)
     */
    get componentInstance() {
        if (this.contentRef && this.contentRef.componentRef) {
            return this.contentRef.componentRef.instance;
        }
    }
    setForm(form) {
        this.form = form;
    }
    setFocusTrap(focusTrap) {
        this.focusTrap = focusTrap;
    }
    /**
     * @desc Trigger close Dialog
     * @param args Arguments
     */
    async close(...args) {
        // If the dialog is a form, & edited, confirm with the user, if the for should close...
        if (this.form && this.form.dirty) {
            let msg = this.dialogOptions.confirmMessage;
            if (!msg) {
                msg = this.translateService.getString('Are you sure you want to close this form without saving your changes?');
            }
            const formConfirmPromptOptions = {
                size: 'md',
                title: this.translateService.getString('Unsaved changes'),
            };
            if (this.dialogOptions.formConfirmPromptParentSelector) {
                formConfirmPromptOptions.parentSelector = this.dialogOptions.formConfirmPromptParentSelector;
            }
            else {
                formConfirmPromptOptions.parentElement = this.overlayRef.location.nativeElement;
            }
            return this.monPromptService
                .confirm(msg, formConfirmPromptOptions)
                .then(() => this.closeDialog(...args), () => { });
        }
        else {
            return this.closeDialog(...args);
        }
    }
    setBeforeClosedCallback(callback) {
        this.beforeClosedCallback = callback;
    }
    async closeDialog(...args) {
        if (this.isClosing) {
            return;
        }
        this.isClosing = true;
        if (typeof this.beforeClosedCallback === 'function') {
            try {
                const response = await this.beforeClosedCallback();
                if (response) {
                    await this.cleanup(...args);
                }
            }
            catch (e) {
            }
        }
        else {
            await this.cleanup(...args);
        }
        this.isClosing = false;
    }
    /**
     * @desc Cleanup the DOM, of all component elements created for dialog.
     */
    async cleanupDOM() {
        await Promise.all([this.backdropAnimation(), this.contentAnimation()]);
        const backdropEl = this.backdropRef?.location.nativeElement;
        const contentEl = this.overlayRef?.location.nativeElement;
        backdropEl.parentNode.removeChild(backdropEl);
        this.backdropRef.destroy();
        contentEl.parentNode.removeChild(contentEl);
        this.overlayRef.destroy();
        if (this.contentRef && this.contentRef.viewRef) {
            this.contentRef.viewRef.destroy();
        }
        this.backdropRef = null;
        this.overlayRef = null;
        this.contentRef = null;
    }
    /**
     * @desc Await backdrop Animation
     */
    async backdropAnimation() {
        return new Promise(resolve => {
            const subscribe = this.backdropRef.instance.componentClosed.subscribe((val) => {
                if (val) {
                    subscribe.unsubscribe();
                    resolve();
                }
            });
        });
    }
    async contentAnimation() {
        return new Promise((resolve) => {
            const subscribe = this.overlayRef.instance.componentClosed.subscribe((val) => {
                if (val) {
                    subscribe.unsubscribe();
                    resolve();
                }
            });
        });
    }
    async cleanup(...args) {
        this.overlayRef.instance.setState(DIALOG_STATE.closed);
        this.backdropRef.instance.setState(DIALOG_STATE.closed);
        await this.cleanupDOM();
        if (this.dialogOptions.cb !== undefined) {
            this.dialogOptions.cb(...args);
        }
    }
};
DialogRef = __decorate([
    __param(4, Inject(TranslateServiceInjectionToken))
], DialogRef);

const _c0$I = ["*"];
const { animations } = dialogAnimations();
class FormStyledDialogComponent extends DialogComponent {
    constructor(activeDialog, elRef, dialogService, configFocusTrapFactory) {
        super(activeDialog, elRef, dialogService, configFocusTrapFactory);
        this.activeDialog = activeDialog;
        this.elRef = elRef;
    }
    ngOnInit() {
        super.ngOnInit();
    }
    async ngAfterContentInit() {
        await super.ngAfterContentInit();
    }
    ngDoCheck() {
        super.ngDoCheck();
    }
    ngOnDestroy() {
        super.ngOnDestroy();
    }
    static { this.ɵfac = function FormStyledDialogComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FormStyledDialogComponent)(i0.ɵɵdirectiveInject(ActiveDialog), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(DialogService), i0.ɵɵdirectiveInject(i3.ConfigurableFocusTrapFactory)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FormStyledDialogComponent, selectors: [["mon-form-styled-dialog"]], features: [i0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c0$I, decls: 4, vars: 3, consts: [["type", "button", 1, "mon-dialog-close", 3, "click"], [1, "fas", "fa-times", "cursor-pointer"]], template: function FormStyledDialogComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "button", 0);
            i0.ɵɵpipe(1, "translate");
            i0.ɵɵlistener("click", function FormStyledDialogComponent_Template_button_click_0_listener() { return ctx.close(); });
            i0.ɵɵelement(2, "span", 1);
            i0.ɵɵelementEnd();
            i0.ɵɵprojection(3);
        } if (rf & 2) {
            i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 1, "Exit overlay"));
        } }, dependencies: [TranslatePipe], styles: ["[_nghost-%COMP%]{position:fixed;right:0;top:0;z-index:10000;bottom:0;background-color:var(--mon-dialog-background-color, #fff)}.mon-dialog-size-xs[_nghost-%COMP%]{width:30%}.mon-dialog-size-xs.center[_nghost-%COMP%]{right:35%}.mon-dialog-size-xs.middle[_nghost-%COMP%]{top:35%;bottom:auto}.mon-dialog-size-sm[_nghost-%COMP%]{width:50%}.mon-dialog-size-sm.center[_nghost-%COMP%]{right:25%}.mon-dialog-size-sm.middle[_nghost-%COMP%]{top:25%;bottom:auto}.mon-dialog-size-md[_nghost-%COMP%]{width:65%}.mon-dialog-size-md.center[_nghost-%COMP%]{right:17.5%}.mon-dialog-size-md.middle[_nghost-%COMP%]{top:17.5%;bottom:auto}.mon-dialog-size-lg[_nghost-%COMP%]{width:85%}.mon-dialog-size-lg.center[_nghost-%COMP%]{right:7.5%}.mon-dialog-size-lg.middle[_nghost-%COMP%]{top:7.5%;bottom:auto}.mon-dialog-size-xl[_nghost-%COMP%]{width:100%}.mon-dialog-size-xl.center[_nghost-%COMP%]{right:0%}.mon-dialog-size-xl.middle[_nghost-%COMP%]{top:0%;bottom:auto}.mon-dialog-size-fw[_nghost-%COMP%]{width:99%}.mon-dialog-size-fw.center[_nghost-%COMP%]{right:.5%}.mon-dialog-size-fw.middle[_nghost-%COMP%]{top:.5%;bottom:auto}.mon-dialog-close[_ngcontent-%COMP%]{position:absolute;top:35px;left:30px;border:none;z-index:10000;background-color:transparent;font-size:20px}"], data: { animation: animations } }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormStyledDialogComponent, [{
        type: Component,
        args: [{ selector: 'mon-form-styled-dialog', animations: animations, template: "<button type=\"button\"\n        attr.aria-label=\"{{ 'Exit overlay' | translate }}\"\n        (click)=\"close()\"\n        class=\"mon-dialog-close\">\n        <span class=\"fas fa-times cursor-pointer\"></span>\n</button>\n\n\n<ng-content></ng-content>\n", styles: [":host{position:fixed;right:0;top:0;z-index:10000;bottom:0;background-color:var(--mon-dialog-background-color, #fff)}:host.mon-dialog-size-xs{width:30%}:host.mon-dialog-size-xs.center{right:35%}:host.mon-dialog-size-xs.middle{top:35%;bottom:auto}:host.mon-dialog-size-sm{width:50%}:host.mon-dialog-size-sm.center{right:25%}:host.mon-dialog-size-sm.middle{top:25%;bottom:auto}:host.mon-dialog-size-md{width:65%}:host.mon-dialog-size-md.center{right:17.5%}:host.mon-dialog-size-md.middle{top:17.5%;bottom:auto}:host.mon-dialog-size-lg{width:85%}:host.mon-dialog-size-lg.center{right:7.5%}:host.mon-dialog-size-lg.middle{top:7.5%;bottom:auto}:host.mon-dialog-size-xl{width:100%}:host.mon-dialog-size-xl.center{right:0%}:host.mon-dialog-size-xl.middle{top:0%;bottom:auto}:host.mon-dialog-size-fw{width:99%}:host.mon-dialog-size-fw.center{right:.5%}:host.mon-dialog-size-fw.middle{top:.5%;bottom:auto}.mon-dialog-close{position:absolute;top:35px;left:30px;border:none;z-index:10000;background-color:transparent;font-size:20px}\n"] }]
    }], () => [{ type: ActiveDialog }, { type: i0.ElementRef }, { type: DialogService }, { type: i3.ConfigurableFocusTrapFactory }], null); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormStyledDialogComponent, { className: "FormStyledDialogComponent" }); })();

class BackdropComponent {
    constructor() {
        // Event triggered after the animation closed
        this.componentClosed = new EventEmitter();
        this.currentState = DIALOG_STATE.closed;
    }
    ngOnInit() {
        // Add timeout, so that Angular has time to register that the state changed.
        setTimeout(() => this.setState(DIALOG_STATE.open));
    }
    setState(newState) {
        this.currentState = newState;
    }
    getState() {
        return this.currentState;
    }
    animationDone() {
        if (this.currentState === DIALOG_STATE.open) {
            this.componentClosed.emit(false);
        }
        else {
            this.componentClosed.emit(true);
        }
    }
    static { this.ɵfac = function BackdropComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || BackdropComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BackdropComponent, selectors: [["mon-backdrop"]], hostVars: 1, hostBindings: function BackdropComponent_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵsyntheticHostListener("@openClose.done", function BackdropComponent_animation_openClose_done_HostBindingHandler() { return ctx.animationDone(); });
        } if (rf & 2) {
            i0.ɵɵsyntheticHostProperty("@openClose", ctx.getState());
        } }, decls: 0, vars: 0, template: function BackdropComponent_Template(rf, ctx) { }, styles: ["[_nghost-%COMP%]{position:fixed;top:0;z-index:10000;left:0;width:100vw;height:100vh;background-color:var(--dialog-backdrop-background-color, #000)}"], data: { animation: [
                trigger('openClose', [
                    state(DIALOG_STATE.open, style({
                        opacity: 0.6,
                    })),
                    state(DIALOG_STATE.closed, style({
                        opacity: 0,
                    })),
                    transition(`${DIALOG_STATE.open} <=> ${DIALOG_STATE.closed}`, [animate('0.4s')]),
                ]),
            ] } }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BackdropComponent, [{
        type: Component,
        args: [{ selector: 'mon-backdrop', template: '', animations: [
                    trigger('openClose', [
                        state(DIALOG_STATE.open, style({
                            opacity: 0.6,
                        })),
                        state(DIALOG_STATE.closed, style({
                            opacity: 0,
                        })),
                        transition(`${DIALOG_STATE.open} <=> ${DIALOG_STATE.closed}`, [animate('0.4s')]),
                    ]),
                ], host: {
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    '[@openClose]': 'getState()',
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    '(@openClose.done)': 'animationDone()',
                }, styles: [":host{position:fixed;top:0;z-index:10000;left:0;width:100vw;height:100vh;background-color:var(--dialog-backdrop-background-color, #000)}\n"] }]
    }], null, null); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(BackdropComponent, { className: "BackdropComponent" }); })();

function MonPromptComponent_h4_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h4", 14);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵattribute("id", ctx_r0.options.title ? "modal-title" : "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.options.title);
} }
function MonPromptComponent_h4_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "h4", 15);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", ctx_r0.options.titleHTML, i0.ɵɵsanitizeHtml);
    i0.ɵɵattribute("id", ctx_r0.options.titleHTML ? "modal-title" : "");
} }
function MonPromptComponent_p_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.options.message);
} }
function MonPromptComponent_p_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p", 17);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", ctx_r0.options.messageHTML, i0.ɵɵsanitizeHtml);
} }
function MonPromptComponent_input_10_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 18);
    i0.ɵɵtwoWayListener("ngModelChange", function MonPromptComponent_input_10_Template_input_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r0 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r0.inputValue, $event) || (ctx_r0.inputValue = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵtwoWayProperty("ngModel", ctx_r0.inputValue);
} }
function MonPromptComponent_button_12_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 19);
    i0.ɵɵlistener("click", function MonPromptComponent_button_12_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.closePrompt()); });
    i0.ɵɵtext(1, "Cancel");
    i0.ɵɵelementEnd();
} }
function MonPromptComponent_button_13_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 20);
    i0.ɵɵlistener("click", function MonPromptComponent_button_13_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.closePrompt(ctx_r0.inputValue)); });
    i0.ɵɵtext(1, "Ok");
    i0.ɵɵelementEnd();
} }
function MonPromptComponent_ng_container_14_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 22);
    i0.ɵɵlistener("click", function MonPromptComponent_ng_container_14_button_1_Template_button_click_0_listener() { const button_r6 = i0.ɵɵrestoreView(_r5).$implicit; return i0.ɵɵresetView(button_r6.callback(button_r6.value)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const button_r6 = ctx.$implicit;
    i0.ɵɵclassMap(button_r6.className);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(button_r6.label);
} }
function MonPromptComponent_ng_container_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MonPromptComponent_ng_container_14_button_1_Template, 2, 3, "button", 21);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.options.buttons);
} }
class MonPromptComponent {
    constructor(modal) {
        this.modal = modal;
        this.inputValue = '';
    }
    ngAfterViewInit() {
        if (this.options.type === 'custom') {
            this.options.buttons.forEach((button) => {
                const cb = button.callback;
                button.callback = () => {
                    cb(button.value);
                    this.options.callback(button.value);
                    this.modal.close();
                };
            });
        }
    }
    closePrompt(result = null) {
        this.options.callback(result);
        this.modal.close();
    }
    static { this.ɵfac = function MonPromptComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MonPromptComponent)(i0.ɵɵdirectiveInject(i1$4.NgbActiveModal)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MonPromptComponent, selectors: [["mon-prompt"]], inputs: { options: "options" }, decls: 15, vars: 8, consts: [[1, "mon-prompt"], ["data-test", "modal-header", 1, "modal-header"], ["class", "modal-title", 4, "ngIf"], ["class", "modal-title", 3, "innerHTML", 4, "ngIf"], ["type", "button", "aria-describedby", "modal-title", "data-test", "close-button", 1, "close", 3, "click"], ["aria-hidden", "true"], [1, "modal-body"], ["class", "mon-prompt-message", 4, "ngIf"], ["class", "mon-prompt-message", 3, "innerHTML", 4, "ngIf"], ["type", "text", "name", "input", "class", "form-control", "data-test", "input-id-field", 3, "ngModel", "ngModelChange", 4, "ngIf"], [1, "modal-footer"], ["type", "button", "class", "btn btn-default btn-secondary", "data-test", "cancel-button", "translate", "", 3, "click", 4, "ngIf"], ["type", "button", "class", "btn btn-mon-primary", "data-test", "ok-button", "translate", "", 3, "click", 4, "ngIf"], [4, "ngIf"], [1, "modal-title"], [1, "modal-title", 3, "innerHTML"], [1, "mon-prompt-message"], [1, "mon-prompt-message", 3, "innerHTML"], ["type", "text", "name", "input", "data-test", "input-id-field", 1, "form-control", 3, "ngModelChange", "ngModel"], ["type", "button", "data-test", "cancel-button", "translate", "", 1, "btn", "btn-default", "btn-secondary", 3, "click"], ["type", "button", "data-test", "ok-button", "translate", "", 1, "btn", "btn-mon-primary", 3, "click"], ["type", "button", 3, "class", "click", 4, "ngFor", "ngForOf"], ["type", "button", 3, "click"]], template: function MonPromptComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵtemplate(2, MonPromptComponent_h4_2_Template, 2, 2, "h4", 2)(3, MonPromptComponent_h4_3_Template, 1, 2, "h4", 3);
            i0.ɵɵelementStart(4, "button", 4);
            i0.ɵɵlistener("click", function MonPromptComponent_Template_button_click_4_listener() { return ctx.closePrompt(); });
            i0.ɵɵelementStart(5, "span", 5);
            i0.ɵɵtext(6, "\u00D7");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(7, "div", 6);
            i0.ɵɵtemplate(8, MonPromptComponent_p_8_Template, 2, 1, "p", 7)(9, MonPromptComponent_p_9_Template, 1, 1, "p", 8)(10, MonPromptComponent_input_10_Template, 1, 1, "input", 9);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(11, "div", 10);
            i0.ɵɵtemplate(12, MonPromptComponent_button_12_Template, 2, 0, "button", 11)(13, MonPromptComponent_button_13_Template, 2, 0, "button", 12)(14, MonPromptComponent_ng_container_14_Template, 2, 1, "ng-container", 13);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.options.title);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.options.titleHTML);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("ngIf", ctx.options.message);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.options.messageHTML);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.options.type === "prompt");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.options.type === "confirm" || ctx.options.type === "prompt");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.options.type !== "custom");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.options.type === "custom");
        } }, dependencies: [TranslateDirective, i1$2.NgForOf, i1$2.NgIf, i1$5.DefaultValueAccessor, i1$5.NgControlStatus, i1$5.NgModel], styles: [".btn-mon-primary[_ngcontent-%COMP%]{color:#fff;background-color:#299bf7}.btn-secondary[_ngcontent-%COMP%]{color:#299bf7;background-color:#fff;border-color:#e4e4e4}.mon-prompt-message[_ngcontent-%COMP%]{margin:0;white-space:pre-wrap}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MonPromptComponent, [{
        type: Component,
        args: [{ selector: 'mon-prompt', template: "<div class=\"mon-prompt\">\n    <div class=\"modal-header\" data-test=\"modal-header\">\n        <h4 *ngIf=\"options.title\" class=\"modal-title\" [attr.id]=\"options.title ? 'modal-title' : ''\">{{options.title}}</h4>\n        <h4 *ngIf=\"options.titleHTML\" class=\"modal-title\" [attr.id]=\"options.titleHTML ? 'modal-title' : ''\" [innerHTML]=\"options.titleHTML\"></h4>\n        <button type=\"button\" class=\"close\" aria-describedby=\"modal-title\" (click)=\"closePrompt()\" data-test=\"close-button\">\n            <span aria-hidden=\"true\" >&times;</span>\n        </button>\n    </div>\n    <div class=\"modal-body\">\n        <p class=\"mon-prompt-message\" *ngIf=\"options.message\">{{options.message}}</p>\n        <p class=\"mon-prompt-message\" *ngIf=\"options.messageHTML\" [innerHTML]=\"options.messageHTML\"></p>\n        <input type=\"text\" name=\"input\" [(ngModel)]=\"inputValue\" class=\"form-control\" *ngIf=\"options.type === 'prompt'\" data-test=\"input-id-field\">\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-default btn-secondary\" *ngIf=\"options.type === 'confirm' || options.type === 'prompt'\" (click)=\"closePrompt()\" data-test=\"cancel-button\" translate>Cancel</button>\n        <button type=\"button\" class=\"btn btn-mon-primary\" *ngIf=\"options.type !== 'custom'\" (click)=\"closePrompt(inputValue)\" data-test=\"ok-button\" translate>Ok</button>\n        <ng-container *ngIf=\"options.type === 'custom'\">\n            <button *ngFor='let button of options.buttons' type=\"button\" [class]=\"button.className\" (click)=\"button.callback(button.value)\">{{button.label}}</button>\n        </ng-container>\n    </div>\n</div>\n", styles: [".btn-mon-primary{color:#fff;background-color:#299bf7}.btn-secondary{color:#299bf7;background-color:#fff;border-color:#e4e4e4}.mon-prompt-message{margin:0;white-space:pre-wrap}\n"] }]
    }], () => [{ type: i1$4.NgbActiveModal }], { options: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(MonPromptComponent, { className: "MonPromptComponent" }); })();

// service for window.bootbox. Documentation can be found here http://bootboxjs.com/documentation.html
class MonPromptService {
    constructor(translateService, modalService, activeModal) {
        this.translateService = translateService;
        this.modalService = modalService;
        this.activeModal = activeModal;
    }
    alert(message, options) {
        return new Promise((resolve, reject) => {
            const promptOptions = this.getPromptOptions({
                type: 'alert',
                message,
                resolve,
                reject,
            }, options);
            this.openPrompt(promptOptions);
        });
    }
    confirm(message, options) {
        return new Promise((resolve, reject) => {
            const promptOptions = this.getPromptOptions({
                type: 'confirm',
                title: '',
                message,
                resolve,
                reject,
            }, options);
            this.openPrompt(promptOptions);
        });
    }
    prompt(title, options) {
        return new Promise((resolve, reject) => {
            const promptOptions = this.getPromptOptions({
                type: 'prompt',
                title,
                resolve,
                reject,
            }, options);
            this.openPrompt(promptOptions);
        });
    }
    custom(params, options) {
        return new Promise((resolve, reject) => {
            const promptOptions = this.getPromptOptions({
                type: 'custom',
                title: this.translateService.getString('[[title]]', { title: params.title }),
                message: this.translateService.getString('[[message]]', { message: params.message }),
                resolve,
                reject,
            }, { type: 'custom', buttons: params.buttons, ...options });
            this.openPrompt(promptOptions);
        });
    }
    customComponentPrompt(component, componentOptions = {}, options) {
        const modalRef = this.modalService.open(component, { ...options });
        modalRef.componentInstance.modal = modalRef;
        Object.keys(componentOptions).forEach((key) => {
            modalRef.componentInstance[key] = componentOptions[key];
        });
        return modalRef;
    }
    openPrompt(options) {
        const modalRef = this.modalService.open(MonPromptComponent, {
            ...options,
            container: options.parentSelector || options.parentElement,
        });
        modalRef.componentInstance.options = options;
    }
    getPromptOptions(params, options) {
        const size = 'md';
        const { title, type, message, resolve, reject } = params;
        const newOptions = options ? Object.assign({}, options) : { size };
        const callback = newOptions.callback;
        delete newOptions.callback;
        const defaultOptions = {
            size,
            type,
            callback: (result) => {
                if (typeof result === 'string') {
                    if (typeof callback === 'function') {
                        callback(result);
                    }
                    return resolve(result);
                }
                else {
                    return reject(result);
                }
            },
        };
        if (typeof title === 'string') {
            defaultOptions.title = title;
        }
        if (typeof message === 'string') {
            defaultOptions.message = message;
        }
        if (defaultOptions.type === 'custom' && 'buttons' in newOptions) {
            defaultOptions.buttons = newOptions.buttons;
        }
        return Object.assign(defaultOptions, newOptions);
    }
    static { this.ɵfac = function MonPromptService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MonPromptService)(i0.ɵɵinject(TranslateServiceInjectionToken), i0.ɵɵinject(i1$4.NgbModal), i0.ɵɵinject(i1$4.NgbActiveModal)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MonPromptService, factory: MonPromptService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MonPromptService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], () => [{ type: undefined, decorators: [{
                type: Inject,
                args: [TranslateServiceInjectionToken]
            }] }, { type: i1$4.NgbModal }, { type: i1$4.NgbActiveModal }], null); })();

class DialogService {
    constructor(moduleCFR, contentInjector, applicationRef, monPromptService, translateService, rendererFactory, document) {
        this.moduleCFR = moduleCFR;
        this.contentInjector = contentInjector;
        this.applicationRef = applicationRef;
        this.monPromptService = monPromptService;
        this.translateService = translateService;
        this.document = document;
        this.activeDialogs = [];
        this.dialogRefsWeakMap = new WeakMap();
        this.renderer = rendererFactory.createRenderer(null, null);
    }
    /**
     * @desc Open target component in dialog
     * @param component - Component to add to the dom
     * @param options - Settings to use on the dialog
     */
    open(component, options = { defaultWrapper: true, manualFocus: false }) {
        const activeDialog = new ActiveDialog();
        const componentRef = this.getComponentRef(component, activeDialog);
        const backdropRef = this.attachBackdrop(options.parentSelector);
        const contentRef = this.attachOverlayContent(componentRef, options, activeDialog);
        contentRef.instance.manualFocus = options.manualFocus !== undefined ? options.manualFocus : false;
        const dialogRef = new DialogRef(backdropRef, contentRef, componentRef, this.monPromptService, this.translateService, options);
        const focusTrap = contentRef.instance.getFocusTrap();
        if (options.manualFocus !== true && focusTrap) {
            dialogRef.setFocusTrap(focusTrap);
        }
        this.addActiveListeners(activeDialog, dialogRef);
        // Register components to the dialog stack
        this.activeDialogs.push(activeDialog);
        this.dialogRefsWeakMap.set(activeDialog, dialogRef);
        return dialogRef;
    }
    getDialogRef(activeDialog) {
        return this.dialogRefsWeakMap.get(activeDialog) || null;
    }
    getActiveDialogs() {
        return this.activeDialogs.slice();
    }
    closeAll(...args) {
        this.activeDialogs.forEach(activeDialog => activeDialog.close(...args));
    }
    /**
     * @desc Attaches Backdrop component
     */
    attachBackdrop(parentSelector) {
        const backdropCmptFactory = this.moduleCFR.resolveComponentFactory(BackdropComponent);
        const backdropContentInjector = Injector.create({
            providers: [],
            parent: this.contentInjector,
        });
        const backdropRef = backdropCmptFactory.create(backdropContentInjector);
        this.applicationRef.attachView(backdropRef.hostView);
        this.attachComponentToParent(backdropRef, parentSelector);
        return backdropRef;
    }
    /**
     * @desc Attaches Overlay component
     */
    attachOverlayContent(contentRef, options, activeDialog) {
        const isDefaultWrapper = options.defaultWrapper !== undefined ? options.defaultWrapper : true;
        const wrapperComp = isDefaultWrapper ? DialogComponent : FormStyledDialogComponent;
        const contentCmptFactory = this.moduleCFR
            .resolveComponentFactory(wrapperComp);
        const modalContentInjector = Injector.create({
            providers: [{ provide: ActiveDialog, useValue: activeDialog }],
            parent: this.contentInjector,
        });
        const overlayRef = contentCmptFactory.create(modalContentInjector, contentRef.nodes);
        this.applicationRef.attachView(overlayRef.hostView);
        this.attachComponentToParent(overlayRef, options.parentSelector);
        overlayRef.instance.overlayClass = 'mon-dialog-size-sm';
        if (options.size) {
            overlayRef.instance.overlayClass = 'mon-dialog-size-' + options.size;
        }
        if (options.classes) {
            overlayRef.instance.overlayClass += ' ' + options.classes;
        }
        return overlayRef;
    }
    /**
     * @desc Attaches Content component
     */
    getComponentRef(component, activeDialog) {
        const componentCmptFactory = this.moduleCFR.resolveComponentFactory(component);
        const componentContentInjector = Injector.create({
            providers: [{ provide: ActiveDialog, useValue: activeDialog }],
            parent: this.contentInjector,
        });
        const componentRef = componentCmptFactory.create(componentContentInjector);
        this.applicationRef.attachView(componentRef.hostView);
        return new ContentRef([[componentRef.location.nativeElement]], componentRef.hostView, componentRef);
    }
    addActiveListeners(activeDialog, dialogRef) {
        activeDialog.close = (...args) => {
            dialogRef.close(...args).then(() => {
                // Removes Dialog Reference on close
                // NB! Consider moving this to a more event related location
                const index = this.activeDialogs.indexOf(activeDialog);
                if (index > -1) {
                    this.activeDialogs.splice(index, 1);
                }
                if (this.dialogRefsWeakMap.has(activeDialog)) {
                    this.dialogRefsWeakMap.delete(activeDialog);
                }
            });
        };
        activeDialog.setForm = (f) => dialogRef.setForm(f);
    }
    attachComponentToParent(componentRef, parentSelector) {
        if (parentSelector) {
            const element = this.document.querySelector(parentSelector);
            if (element) {
                this.renderer.appendChild(element, componentRef.location.nativeElement);
            }
            else {
                this.renderer.appendChild(this.document.body, componentRef.location.nativeElement);
            }
        }
        else {
            this.renderer.appendChild(this.document.body, componentRef.location.nativeElement);
        }
    }
    static { this.ɵfac = function DialogService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DialogService)(i0.ɵɵinject(i0.ComponentFactoryResolver), i0.ɵɵinject(i0.Injector), i0.ɵɵinject(i0.ApplicationRef), i0.ɵɵinject(MonPromptService), i0.ɵɵinject(TranslateServiceInjectionToken), i0.ɵɵinject(i0.RendererFactory2), i0.ɵɵinject(DOCUMENT)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: DialogService, factory: DialogService.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DialogService, [{
        type: Injectable
    }], () => [{ type: i0.ComponentFactoryResolver }, { type: i0.Injector }, { type: i0.ApplicationRef }, { type: MonPromptService }, { type: undefined, decorators: [{
                type: Inject,
                args: [TranslateServiceInjectionToken]
            }] }, { type: i0.RendererFactory2 }, { type: Document, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }], null); })();

class FilterByLabelNamePipe {
    transform(value, key, term) {
        if (!term) {
            return value;
        }
        return (value || [])
            .filter((item) => item[term].toLowerCase().includes(key.toLocaleLowerCase()));
    }
    static { this.ɵfac = function FilterByLabelNamePipe_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FilterByLabelNamePipe)(); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "filterByLabelName", type: FilterByLabelNamePipe, pure: true }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FilterByLabelNamePipe, [{
        type: Pipe,
        args: [{
                name: 'filterByLabelName',
            }]
    }], null, null); })();

const _c0$H = a0 => ({ "active": a0 });
const _c1$l = a0 => ({ "background": a0 });
function LabelContainerSelectorComponent_li_19_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 12);
    i0.ɵɵlistener("click", function LabelContainerSelectorComponent_li_19_Template_li_click_0_listener() { const option_r2 = i0.ɵɵrestoreView(_r1).$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.updateLabel(option_r2)); });
    i0.ɵɵelementStart(1, "div", 13);
    i0.ɵɵelement(2, "span", 14)(3, "span", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "div", 16);
    i0.ɵɵelementStart(5, "div", 17);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const option_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", option_r2);
    i0.ɵɵattribute("aria-checked", ctx_r2.hasLabel(option_r2));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c0$H, ctx_r2.hasLabel(option_r2)));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(7, _c1$l, option_r2.color));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(option_r2.name);
} }
class LabelContainerSelectorComponent {
    constructor(dialogService) {
        this.dialogService = dialogService;
        this.onUpdateLabel = new EventEmitter();
        this.getLabels = new EventEmitter();
        this.createOrUpdateLabel = new EventEmitter();
        this.search = '';
        this.labelContainerSearchDescribeRandomId = `labelContainerSearchDescribe + ${this.guidGenerator()}`;
    }
    ngOnInit() {
        this.randomId = this.guidGenerator();
    }
    hasLabel(option) {
        return (Array.isArray(this.currentLabels) &&
            this.currentLabels.length > 0 &&
            this.currentLabels.some((label) => label.id === option.id));
    }
    updateLabel(label) {
        if (this.currentLabels.length > 0 && this.hasLabel(label)) {
            this.currentLabels.splice(this.labelIndex(label), 1);
        }
        else {
            this.currentLabels.push(label);
        }
        this.onUpdateLabel.emit();
    }
    clearLabel() {
        this.currentLabels.length = 0;
        this.onUpdateLabel.emit();
    }
    openLabelForm() {
        const dialogRef = this.dialogService.open(FormLabelComponent, {
            size: 'xs',
            classes: 'middle center',
            parentSelector: '#common-dialog-wrapper',
            cb: (label) => {
                this.getLabels.emit();
                if (label && label.id) {
                    this.updateLabel(label);
                }
            },
        });
        const componentInstance = dialogRef.componentInstance;
        componentInstance.createLabel = async (params) => {
            return await new Promise((resolve) => {
                this.createOrUpdateLabel.emit(params);
                setTimeout(() => {
                    resolve(params);
                    this.getLabels.emit();
                }, 0);
            });
        };
    }
    // PROTECTED
    guidGenerator() {
        // eslint-disable-next-line no-bitwise
        const S4 = () => (((1 + Math.random()) * 0x10000) | 0)
            .toString(16)
            .substring(1);
        return (S4() +
            S4() +
            '-' +
            S4() +
            '-' +
            S4() +
            '-' +
            S4() +
            '-' +
            S4() +
            S4() +
            S4());
    }
    labelIndex(selectedLabel) {
        for (let i = 0; i < this.currentLabels.length; i++) {
            if (selectedLabel.id === this.currentLabels[i].id) {
                return i;
            }
        }
        return -1;
    }
    static { this.ɵfac = function LabelContainerSelectorComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || LabelContainerSelectorComponent)(i0.ɵɵdirectiveInject(DialogService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LabelContainerSelectorComponent, selectors: [["mon-label-container-selector"]], inputs: { monShow: "monShow", currentLabels: "currentLabels", allLabels: "allLabels" }, outputs: { onUpdateLabel: "onUpdateLabel", getLabels: "getLabels", createOrUpdateLabel: "createOrUpdateLabel" }, decls: 21, vars: 8, consts: [[1, "mon-label-container-selector"], [1, "label-selector", 3, "clickOutside", "click", "hidden"], [1, "label-search-box"], ["for", "labelContainerSearchDescribeRandomId", "translate", "", 1, "sr-only"], ["type", "search", "id", "labelContainerSearchDescribeRandomId", 3, "ngModelChange", "ngModel"], ["id", "labelContainerSearchDescribeRandomId", "translate", "", 1, "sr-only"], [1, "clear-label", 3, "click"], [1, "label-name", "text-link", "cursor-pointer"], ["aria-hidden", "true", 1, "fas", "fa-times"], ["translate", "", 1, "label-option"], ["aria-hidden", "true", 1, "fas", "fa-plus"], ["role", "menuitemcheckbox", 3, "value", "click", 4, "ngFor", "ngForOf"], ["role", "menuitemcheckbox", 3, "click", "value"], ["aria-hidden", "true", 1, "indicators", 3, "ngClass"], [1, "indicator", "selected", "fas", "fa-check"], [1, "indicator", "remove", "fas", "fa-times"], ["aria-hidden", "true", 1, "label-color-box", 3, "ngStyle"], [1, "label-name"]], template: function LabelContainerSelectorComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵlistener("clickOutside", function LabelContainerSelectorComponent_Template_div_clickOutside_1_listener() { return ctx.monShow = false; })("click", function LabelContainerSelectorComponent_Template_div_click_1_listener($event) { return $event.stopPropagation(); });
            i0.ɵɵelementStart(2, "ul")(3, "li", 2)(4, "label", 3);
            i0.ɵɵtext(5, " Search label ");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "input", 4);
            i0.ɵɵtwoWayListener("ngModelChange", function LabelContainerSelectorComponent_Template_input_ngModelChange_6_listener($event) { i0.ɵɵtwoWayBindingSet(ctx.search, $event) || (ctx.search = $event); return $event; });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "span", 5);
            i0.ɵɵtext(8, " Filter labels list ");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(9, "li", 6);
            i0.ɵɵlistener("click", function LabelContainerSelectorComponent_Template_li_click_9_listener() { return ctx.clearLabel(); });
            i0.ɵɵelementStart(10, "span", 7);
            i0.ɵɵelement(11, "span", 8);
            i0.ɵɵelementStart(12, "span", 9);
            i0.ɵɵtext(13, "Clear all labels");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(14, "li", 6);
            i0.ɵɵlistener("click", function LabelContainerSelectorComponent_Template_li_click_14_listener() { return ctx.openLabelForm(); });
            i0.ɵɵelementStart(15, "span", 7);
            i0.ɵɵelement(16, "span", 10);
            i0.ɵɵelementStart(17, "span", 9);
            i0.ɵɵtext(18, "Add new label");
            i0.ɵɵelementEnd()()();
            i0.ɵɵtemplate(19, LabelContainerSelectorComponent_li_19_Template, 7, 9, "li", 11);
            i0.ɵɵpipe(20, "filterByLabelName");
            i0.ɵɵelementEnd()()();
        } if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", !ctx.monShow);
            i0.ɵɵadvance(5);
            i0.ɵɵtwoWayProperty("ngModel", ctx.search);
            i0.ɵɵattribute("aria-describedby", ctx.labelContainerSearchDescribeRandomId);
            i0.ɵɵadvance(13);
            i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind3(20, 4, ctx.allLabels, ctx.search, "name"));
        } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgStyle, TranslateDirective, i1$5.DefaultValueAccessor, i1$5.NgControlStatus, i1$5.NgModel, i5.NgClickOutsideDirective, FilterByLabelNamePipe], styles: [".label-dialog[_ngcontent-%COMP%]{min-height:320px}.mon-label-container-selector[_ngcontent-%COMP%]   .label-selector[_ngcontent-%COMP%]{overflow-y:auto;position:absolute;top:100%;left:0;z-index:2;width:200px;background-color:#fff;box-shadow:0 1px 4px #0000002e;border:0;padding-left:0;margin-left:-60px;margin-top:1px;margin-bottom:30px}.mon-label-container-selector[_ngcontent-%COMP%]   .label-selector[_ngcontent-%COMP%]:focus-visible{outline:none;box-shadow:0 0 0 1px #4976b9}.mon-label-container-selector[_ngcontent-%COMP%]   .label-selector[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{overflow-y:auto;background:#fff;box-shadow:0 1px 4px #0000002e;border:0;list-style:none;padding-left:0;text-align:left;margin-bottom:0;max-height:496px}.mon-label-container-selector[_ngcontent-%COMP%]   .label-selector[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{position:relative;padding:10px 12px}.mon-label-container-selector[_ngcontent-%COMP%]   .label-selector[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li.label-search-box[_ngcontent-%COMP%]{background:#f3f5f7;box-shadow:1px 1px #00000014 inset,-1px -1px #00000014 inset}.mon-label-container-selector[_ngcontent-%COMP%]   .label-selector[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li.label-search-box[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:100%;background-color:#fff;padding:0 .4em;line-height:1.5em;border:1px solid #ccc}.mon-label-container-selector[_ngcontent-%COMP%]   .label-selector[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li.label-search-box[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus-visible{outline:none;box-shadow:0 0 0 1px #4976b9}.mon-label-container-selector[_ngcontent-%COMP%]   .label-selector[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:hover{background:#f3f5f7;color:#555557;cursor:pointer}.mon-label-container-selector[_ngcontent-%COMP%]   .label-selector[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:focus-visible{outline:none;box-shadow:0 0 0 1px #4976b9}.mon-label-container-selector[_ngcontent-%COMP%]   .label-selector[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   .indicators[_ngcontent-%COMP%]{opacity:0;display:inline-block;width:12px;height:12px;margin-right:5px;color:#555557}.mon-label-container-selector[_ngcontent-%COMP%]   .label-selector[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   .indicators[_ngcontent-%COMP%]   .remove[_ngcontent-%COMP%]{display:none}.mon-label-container-selector[_ngcontent-%COMP%]   .label-selector[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   .indicators.active[_ngcontent-%COMP%]{opacity:1}.mon-label-container-selector[_ngcontent-%COMP%]   .label-selector[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   .label-color-box[_ngcontent-%COMP%]{width:15px;height:15px;display:inline-block;vertical-align:middle;margin-left:.2em}.mon-label-container-selector[_ngcontent-%COMP%]   .label-selector[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   .label-name[_ngcontent-%COMP%]{display:inline-block;padding-left:7px;vertical-align:middle;color:#555557}.mon-label-container-selector[_ngcontent-%COMP%]   .label-selector[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   .label-name[_ngcontent-%COMP%]   .label-option[_ngcontent-%COMP%]{margin-left:5px}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LabelContainerSelectorComponent, [{
        type: Component,
        args: [{ selector: 'mon-label-container-selector', template: "<div class=\"mon-label-container-selector\">\n    <div class=\"label-selector\" (clickOutside)=\"monShow = false\" [hidden]=\"!monShow\" (click)=\"$event.stopPropagation()\">\n        <ul>\n            <li class=\"label-search-box\">\n                <label for=\"labelContainerSearchDescribeRandomId\"\n                    class=\"sr-only\"\n                    translate>\n                    Search label\n                </label>\n                <input type=\"search\" [(ngModel)]=\"search\" id=\"labelContainerSearchDescribeRandomId\" [attr.aria-describedby]=\"labelContainerSearchDescribeRandomId\">\n                <span id=\"labelContainerSearchDescribeRandomId\" class=\"sr-only\" translate>\n                    Filter labels list\n                </span>\n            </li>\n            <li class=\"clear-label\" (click)=\"clearLabel()\">\n                <span class=\"label-name text-link cursor-pointer\">\n                    <span class=\"fas fa-times\" aria-hidden=\"true\"></span>\n                    <span class=\"label-option\" translate>Clear all labels</span>\n                </span>\n            </li>\n            <li class=\"clear-label\" (click)=\"openLabelForm()\">\n                <span class=\"label-name text-link cursor-pointer\">\n                    <span class=\"fas fa-plus\" aria-hidden=\"true\"></span>\n                    <span class=\"label-option\" translate>Add new label</span>\n                </span>\n            </li>\n            <li *ngFor=\"let option of allLabels | filterByLabelName:search:'name'\"\n                role=\"menuitemcheckbox\"\n                [attr.aria-checked]=\"hasLabel(option)\"\n                [value]=\"option\"\n                (click)=\"updateLabel(option)\">\n                <div class=\"indicators\" [ngClass]=\"{'active': hasLabel(option)}\" aria-hidden=\"true\">\n                    <span class=\"indicator selected fas fa-check\"></span>\n                    <span class=\"indicator remove fas fa-times\"></span>\n                </div>\n                <div aria-hidden=\"true\" class=\"label-color-box\" [ngStyle]=\"{'background': option.color}\"></div>\n                <div class=\"label-name\">{{option.name}}</div>\n            </li>\n        </ul>\n    </div>\n</div>\n", styles: [".label-dialog{min-height:320px}.mon-label-container-selector .label-selector{overflow-y:auto;position:absolute;top:100%;left:0;z-index:2;width:200px;background-color:#fff;box-shadow:0 1px 4px #0000002e;border:0;padding-left:0;margin-left:-60px;margin-top:1px;margin-bottom:30px}.mon-label-container-selector .label-selector:focus-visible{outline:none;box-shadow:0 0 0 1px #4976b9}.mon-label-container-selector .label-selector ul{overflow-y:auto;background:#fff;box-shadow:0 1px 4px #0000002e;border:0;list-style:none;padding-left:0;text-align:left;margin-bottom:0;max-height:496px}.mon-label-container-selector .label-selector ul li{position:relative;padding:10px 12px}.mon-label-container-selector .label-selector ul li.label-search-box{background:#f3f5f7;box-shadow:1px 1px #00000014 inset,-1px -1px #00000014 inset}.mon-label-container-selector .label-selector ul li.label-search-box input{width:100%;background-color:#fff;padding:0 .4em;line-height:1.5em;border:1px solid #ccc}.mon-label-container-selector .label-selector ul li.label-search-box input:focus-visible{outline:none;box-shadow:0 0 0 1px #4976b9}.mon-label-container-selector .label-selector ul li:hover{background:#f3f5f7;color:#555557;cursor:pointer}.mon-label-container-selector .label-selector ul li:focus-visible{outline:none;box-shadow:0 0 0 1px #4976b9}.mon-label-container-selector .label-selector ul .indicators{opacity:0;display:inline-block;width:12px;height:12px;margin-right:5px;color:#555557}.mon-label-container-selector .label-selector ul .indicators .remove{display:none}.mon-label-container-selector .label-selector ul .indicators.active{opacity:1}.mon-label-container-selector .label-selector ul .label-color-box{width:15px;height:15px;display:inline-block;vertical-align:middle;margin-left:.2em}.mon-label-container-selector .label-selector ul .label-name{display:inline-block;padding-left:7px;vertical-align:middle;color:#555557}.mon-label-container-selector .label-selector ul .label-name .label-option{margin-left:5px}\n"] }]
    }], () => [{ type: DialogService }], { monShow: [{
            type: Input
        }], currentLabels: [{
            type: Input
        }], allLabels: [{
            type: Input
        }], onUpdateLabel: [{
            type: Output
        }], getLabels: [{
            type: Output
        }], createOrUpdateLabel: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(LabelContainerSelectorComponent, { className: "LabelContainerSelectorComponent" }); })();

const _c0$G = a0 => ({ "background-color": a0 });
const _c1$k = a0 => ({ "color": a0 });
const _c2$d = a0 => ({ "active": a0 });
function LabelContainerComponent_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵpipe(1, "monInverseColorCode");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const label_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(4, _c1$k, i0.ɵɵpipeBind1(1, 2, label_r1.color)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", label_r1.name, " ");
} }
function LabelContainerComponent_div_2_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 8);
} if (rf & 2) {
    const label_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngbTooltip", label_r1.name);
} }
function LabelContainerComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtemplate(1, LabelContainerComponent_div_2_div_1_Template, 3, 6, "div", 5)(2, LabelContainerComponent_div_2_div_2_Template, 1, 1, "div", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const label_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(3, _c0$G, label_r1.color));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.currentLabels.length <= ctx_r1.labelsNoBeforeMinimize);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.currentLabels.length > ctx_r1.labelsNoBeforeMinimize);
} }
function LabelContainerComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("click", function LabelContainerComponent_div_3_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.showLabelSelector = !ctx_r1.showLabelSelector); });
    i0.ɵɵelement(2, "span", 10);
    i0.ɵɵelementStart(3, "mon-label-container-selector", 11);
    i0.ɵɵlistener("onUpdateLabel", function LabelContainerComponent_div_3_Template_mon_label_container_selector_onUpdateLabel_3_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.onUpdateLabel.emit()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c2$d, ctx_r1.showLabelSelector));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 5, "Edit labels"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("allLabels", ctx_r1.allLabels)("monShow", ctx_r1.showLabelSelector)("currentLabels", ctx_r1.currentLabels);
} }
class LabelContainerComponent {
    constructor() {
        this.onUpdateLabel = new EventEmitter();
        this.getLabels = new EventEmitter();
        this.showLabelSelector = false;
        this.search = '';
    }
    ngOnInit() {
        this.currentLabels = this.currentLabels || [];
        this.allLabels = this.allLabels || [];
        this.labelsNoBeforeMinimize = this.labelsNoBeforeMinimize || 2;
    }
    static { this.ɵfac = function LabelContainerComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || LabelContainerComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LabelContainerComponent, selectors: [["mon-label-container"]], inputs: { currentLabels: "currentLabels", allLabels: "allLabels", allowEdit: "allowEdit", labelsNoBeforeMinimize: "labelsNoBeforeMinimize" }, outputs: { onUpdateLabel: "onUpdateLabel", getLabels: "getLabels" }, decls: 4, vars: 2, consts: [[1, "label-container"], [1, "label-list"], ["class", "label", 3, "ngStyle", 4, "ngFor", "ngForOf"], ["class", "label-btn", 3, "ngClass", "click", 4, "ngIf"], [1, "label", 3, "ngStyle"], ["class", "label-text", 3, "ngStyle", 4, "ngIf"], ["class", "label-without-text", 3, "ngbTooltip", 4, "ngIf"], [1, "label-text", 3, "ngStyle"], [1, "label-without-text", 3, "ngbTooltip"], [1, "label-btn", 3, "click", "ngClass"], ["aria-hidden", "true", 1, "label-btn-icon", "fas", "fa-tag", "fa-lg"], [3, "onUpdateLabel", "allLabels", "monShow", "currentLabels"]], template: function LabelContainerComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵtemplate(2, LabelContainerComponent_div_2_Template, 3, 5, "div", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(3, LabelContainerComponent_div_3_Template, 4, 9, "div", 3);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.currentLabels);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.allowEdit);
        } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, i1$2.NgStyle, i1$4.NgbTooltip, LabelContainerSelectorComponent, TranslatePipe, InverseColorCode], styles: [".label-container[_ngcontent-%COMP%]{position:relative}.label-container[_ngcontent-%COMP%]   .label-list[_ngcontent-%COMP%]{width:calc(100% - 30px);margin-right:5px;display:inline-block;vertical-align:middle}.label-container[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{margin-right:5px;margin-top:3px;display:inline-block}.label-container[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]:empty{display:inline-block}.label-container[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]   .label-text[_ngcontent-%COMP%]{padding:4px 8px;font-size:1.2em}.label-container[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]   .label-without-text[_ngcontent-%COMP%]{width:14px;height:10px}.label-container[_ngcontent-%COMP%]   .label-btn[_ngcontent-%COMP%]{background-color:#d4dce3;color:#9a9d9e;border-radius:3px;padding:3px 6px;display:inline-block;position:relative;margin-top:3px;opacity:0;width:25px;height:25px;vertical-align:middle}.label-container[_ngcontent-%COMP%]   .label-btn.active[_ngcontent-%COMP%]{opacity:1}.label-container[_ngcontent-%COMP%]   .label-btn[_ngcontent-%COMP%]   .label-btn-icon[_ngcontent-%COMP%]{padding-top:4px}.label-container[_ngcontent-%COMP%]:hover   .label-btn[_ngcontent-%COMP%]{opacity:1;cursor:pointer;color:#299bf7}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LabelContainerComponent, [{
        type: Component,
        args: [{ selector: 'mon-label-container', template: "<div class=\"label-container\">\n    <div class=\"label-list\">\n        <div class=\"label\" *ngFor=\"let label of currentLabels\" [ngStyle]=\"{'background-color': label.color}\">\n            <div class=\"label-text\"\n                 [ngStyle]=\"{'color': (label.color | monInverseColorCode)}\"\n                 *ngIf=\"currentLabels.length <= labelsNoBeforeMinimize\">\n                {{label.name}}\n            </div>\n            <div class=\"label-without-text\" [ngbTooltip]=\"label.name\" *ngIf=\"currentLabels.length > labelsNoBeforeMinimize\"></div>\n        </div>\n    </div>\n    <div class=\"label-btn\"\n         *ngIf=\"allowEdit\"\n         [attr.aria-label]=\"'Edit labels' | translate\"\n         (click)=\"showLabelSelector = !showLabelSelector\"\n         [ngClass]=\"{'active': showLabelSelector}\">\n        <span class=\"label-btn-icon fas fa-tag fa-lg\" aria-hidden=\"true\">\n        </span>\n        <mon-label-container-selector [allLabels]=\"allLabels\" [monShow]=\"showLabelSelector\" (onUpdateLabel)=\"onUpdateLabel.emit()\" [currentLabels]=\"currentLabels\">\n        </mon-label-container-selector>\n    </div>\n</div>\n", styles: [".label-container{position:relative}.label-container .label-list{width:calc(100% - 30px);margin-right:5px;display:inline-block;vertical-align:middle}.label-container .label{margin-right:5px;margin-top:3px;display:inline-block}.label-container .label:empty{display:inline-block}.label-container .label .label-text{padding:4px 8px;font-size:1.2em}.label-container .label .label-without-text{width:14px;height:10px}.label-container .label-btn{background-color:#d4dce3;color:#9a9d9e;border-radius:3px;padding:3px 6px;display:inline-block;position:relative;margin-top:3px;opacity:0;width:25px;height:25px;vertical-align:middle}.label-container .label-btn.active{opacity:1}.label-container .label-btn .label-btn-icon{padding-top:4px}.label-container:hover .label-btn{opacity:1;cursor:pointer;color:#299bf7}\n"] }]
    }], null, { currentLabels: [{
            type: Input
        }], allLabels: [{
            type: Input
        }], allowEdit: [{
            type: Input
        }], labelsNoBeforeMinimize: [{
            type: Input
        }], onUpdateLabel: [{
            type: Output
        }], getLabels: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(LabelContainerComponent, { className: "LabelContainerComponent" }); })();

class LabelTableService {
    constructor() {
        this.labelTxtVisibility = new BehaviorSubject(false);
        this.editable = true;
    }
    hideLabelTxt() {
        this.labelTxtVisibility.next(false);
    }
    /**
     * @memberof LabelTableService
     * @desc Shows the Label text in the Label Table Container
     * @return
     */
    showLabelTxt() {
        this.labelTxtVisibility.next(true);
    }
    /**
     * @memberof LabelTableService
     * @desc Set editable variable
     * @return
     */
    setEditable(bool) {
        this.editable = Boolean(bool);
    }
    static { this.ɵfac = function LabelTableService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || LabelTableService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: LabelTableService, factory: LabelTableService.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LabelTableService, [{
        type: Injectable
    }], null, null); })();

const _c0$F = a0 => ({ "no-labels": a0 });
function LabelTableComponent_span_3_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵelement(1, "span", 7);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const label_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(label_r1.name);
} }
function LabelTableComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 4);
    i0.ɵɵtemplate(1, LabelTableComponent_span_3_span_1_Template, 4, 1, "span", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const label_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngbTooltip", label_r1.name)("ngStyle", ctx_r1.getColorStyles(label_r1));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showTxt);
} }
function LabelTableComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 8);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("click", function LabelTableComponent_span_4_Template_span_click_0_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.toggleEdit($event)); })("keydown", function LabelTableComponent_span_4_Template_span_keydown_0_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.toggleEdit($event)); });
    i0.ɵɵelement(2, "span", 9);
    i0.ɵɵelementStart(3, "mon-label-container-selector", 10);
    i0.ɵɵlistener("onUpdateLabel", function LabelTableComponent_span_4_Template_mon_label_container_selector_onUpdateLabel_3_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.onUpdateLabel.emit()); })("getLabels", function LabelTableComponent_span_4_Template_mon_label_container_selector_getLabels_3_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.getLabels.emit()); })("createOrUpdateLabel", function LabelTableComponent_span_4_Template_mon_label_container_selector_createOrUpdateLabel_3_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.createOrUpdateLabel.emit($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c0$F, ctx_r1.assignedLabels.length === 0));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 5, "Edit Labels"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("allLabels", ctx_r1.existingLabels)("monShow", ctx_r1.showLabelSelector)("currentLabels", ctx_r1.assignedLabels);
} }
class LabelTableComponent {
    constructor(labelTableService) {
        this.labelTableService = labelTableService;
        this.onUpdateLabel = new EventEmitter();
        this.getLabels = new EventEmitter();
        this.createOrUpdateLabel = new EventEmitter();
        this.showTxt = false;
        this.showLabelSelector = false;
    }
    ngOnInit() {
        this.noLabelSelector = this.noLabelSelector || false;
        this.labelTableService.labelTxtVisibility.subscribe((visibility) => {
            this.showTxt = visibility;
        });
    }
    toggleTxtVisibility(event) {
        if (event.type === 'click' ||
            event.key === 'Enter' ||
            event.key === ' ') {
            event.preventDefault();
            event.stopImmediatePropagation();
            if (this.showTxt) {
                this.labelTableService.hideLabelTxt();
            }
            else {
                this.labelTableService.showLabelTxt();
            }
        }
    }
    getColorStyles(label) {
        let backgroundString = label.color;
        if (label.excluded && !this.showTxt) {
            backgroundString =
                'repeating-linear-gradient(to right, ' + label.color + ', ' + label.color + ' 4px' + ', white 4px, white 6px)';
        }
        return {
            background: backgroundString,
            color: LabelColorInverter.getTextColor(label.color),
        };
    }
    canEdit() {
        return !this.noLabelSelector && this.labelTableService.editable;
    }
    toggleEdit(event) {
        if (event.type === 'click' ||
            event.key === 'Enter' ||
            event.key === ' ') {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.showLabelSelector = !this.showLabelSelector;
        }
    }
    static { this.ɵfac = function LabelTableComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || LabelTableComponent)(i0.ɵɵdirectiveInject(LabelTableService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LabelTableComponent, selectors: [["mon-label-table"]], inputs: { existingLabels: "existingLabels", assignedLabels: "assignedLabels", noLabelSelector: "noLabelSelector" }, outputs: { onUpdateLabel: "onUpdateLabel", getLabels: "getLabels", createOrUpdateLabel: "createOrUpdateLabel" }, decls: 5, vars: 5, consts: [[1, "label-table", "d-flex"], ["role", "button", 1, "d-flex", "flex-wrap", "align-items-center", "non-stick", "label-btn", 3, "click", "keydown"], ["class", "label text-ellipsis", 3, "ngbTooltip", "ngStyle", 4, "ngFor", "ngForOf"], ["role", "button", "class", "btn btn-xs btn-label-edit", "tabindex", "0", 3, "ngClass", "click", "keydown", 4, "ngIf"], [1, "label", "text-ellipsis", 3, "ngbTooltip", "ngStyle"], ["class", "d-flex align-items-center", 4, "ngIf"], [1, "d-flex", "align-items-center"], ["ng-if", "label.excluded", "aria-hidden", "true", 1, "fas", "fa-ban", "icon-mr-margin"], ["role", "button", "tabindex", "0", 1, "btn", "btn-xs", "btn-label-edit", 3, "click", "keydown", "ngClass"], ["aria-hidden", "true", 1, "fas", "fa-tag"], [3, "onUpdateLabel", "getLabels", "createOrUpdateLabel", "allLabels", "monShow", "currentLabels"]], template: function LabelTableComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "span", 1);
            i0.ɵɵpipe(2, "translate");
            i0.ɵɵlistener("click", function LabelTableComponent_Template_span_click_1_listener($event) { return ctx.toggleTxtVisibility($event); })("keydown", function LabelTableComponent_Template_span_keydown_1_listener($event) { return ctx.toggleTxtVisibility($event); });
            i0.ɵɵtemplate(3, LabelTableComponent_span_3_Template, 2, 3, "span", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, LabelTableComponent_span_4_Template, 4, 9, "span", 3);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 3, "Toggle label text"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.assignedLabels);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.canEdit());
        } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, i1$2.NgStyle, i1$4.NgbTooltip, LabelContainerSelectorComponent, TranslatePipe], styles: [".label-table[_ngcontent-%COMP%]   .non-stick[_ngcontent-%COMP%]{margin-right:auto}.label-table[_ngcontent-%COMP%]   .icon-mr-margin[_ngcontent-%COMP%]{margin-right:5px}.label-table[_ngcontent-%COMP%]   .label-btn[_ngcontent-%COMP%]{border:0;border-color:transparent;background-color:transparent}.label-table[_ngcontent-%COMP%]   .label-btn[_ngcontent-%COMP%]:focus-visible{outline:none;box-shadow:0 0 0 1px #4976b9}.label-table[_ngcontent-%COMP%]   .label-btn[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{display:inline-block;min-width:28px;min-height:8px;padding:2px 7px;font-size:11px;line-height:11px;margin:3px 5px 3px 0;border-radius:3px}.label-table[_ngcontent-%COMP%]   .label-btn[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{overflow:hidden}.label-table[_ngcontent-%COMP%]   .label-btn[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]   span.ng-enter[_ngcontent-%COMP%], .label-table[_ngcontent-%COMP%]   .label-btn[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]   span.ng-leave.ng-leave-active[_ngcontent-%COMP%]{animation:.5s _ngcontent-%COMP%_label_text_disappear linear}.label-table[_ngcontent-%COMP%]   .label-btn[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]   span.ng-leave[_ngcontent-%COMP%], .label-table[_ngcontent-%COMP%]   .label-btn[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]   span.ng-enter.ng-enter-active[_ngcontent-%COMP%]{animation:.5s _ngcontent-%COMP%_label_text_appear linear}.btn-label-edit[_ngcontent-%COMP%]{opacity:0;padding:2px 5px;line-height:11px;font-size:11px;position:relative;color:#647187;background-color:#ebecf0;border-color:#ebecf0}.btn-label-edit[_ngcontent-%COMP%]:focus, .btn-label-edit.focus[_ngcontent-%COMP%]{color:#555557;background-color:#d4dce3;border-color:#a7b5c4}.btn-label-edit[_ngcontent-%COMP%]:hover{color:#555557;background-color:#d4dce3;border-color:#ced6df}.btn-label-edit[_ngcontent-%COMP%]:focus, .btn-label-edit[_ngcontent-%COMP%]:hover, .btn-label-edit[_ngcontent-%COMP%]:active, .btn-label-edit[_ngcontent-%COMP%]:focus-within{opacity:1}.btn-label-edit[_ngcontent-%COMP%]:focus-visible{opacity:1;outline:0;box-shadow:0 0 0 1px #4976b9}.btn-label-edit.no-labels[_ngcontent-%COMP%]{margin-top:-20px}tr[_ngcontent-%COMP%]:hover   .btn-label-edit[_ngcontent-%COMP%]{opacity:1}@keyframes _ngcontent-%COMP%_label_text_appear{0%{width:28px;height:8px;color:transparent}25%{width:fit-content;height:8px}45%{height:8px}53%{height:8px}75%{height:12px;color:transparent}}@keyframes _ngcontent-%COMP%_label_text_disappear{0%{height:12px;width:fit-content}33%{color:transparent;height:12px;width:fit-content}66%{height:8px;width:fit-content;color:transparent}to{color:transparent;height:8px;width:28px}}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LabelTableComponent, [{
        type: Component,
        args: [{ selector: 'mon-label-table', template: "<div class=\"label-table d-flex\">\n    <span role=\"button\"\n          class=\"d-flex flex-wrap align-items-center non-stick label-btn\"\n          [attr.aria-label]=\"'Toggle label text' | translate\"\n          (click)=\"toggleTxtVisibility($event)\" \n          (keydown)=\"toggleTxtVisibility($event)\">\n        <span [ngbTooltip]=\"label.name\"\n              class=\"label text-ellipsis\"\n              [ngStyle]=\"getColorStyles(label)\"\n              *ngFor=\"let label of assignedLabels\">\n              <span *ngIf=\"showTxt\" class=\"d-flex align-items-center\">\n                <span ng-if=\"label.excluded\" aria-hidden=\"true\" class=\"fas fa-ban icon-mr-margin\"></span>\n                <span>{{label.name}}</span>\n            </span>\n        </span>\n    </span>\n    <span role=\"button\"\n          *ngIf=\"canEdit()\"\n          class=\"btn btn-xs btn-label-edit\"\n          [ngClass]=\"{'no-labels': assignedLabels.length === 0}\"\n          [attr.aria-label]=\"'Edit Labels' | translate\"\n          (click)=\"toggleEdit($event)\"\n          (keydown)=\"toggleEdit($event)\"\n          tabindex=\"0\">\n        <span class=\"fas fa-tag\" aria-hidden=\"true\"></span>\n        <mon-label-container-selector [allLabels]=\"existingLabels\"\n                                      [monShow]=\"showLabelSelector\"\n                                      (onUpdateLabel)=\"onUpdateLabel.emit()\"\n                                      (getLabels)=\"getLabels.emit()\"\n                                      (createOrUpdateLabel)=\"createOrUpdateLabel.emit($event)\"\n                                      [currentLabels]=\"assignedLabels\">\n        </mon-label-container-selector>\n    </span>\n</div>\n", styles: [".label-table .non-stick{margin-right:auto}.label-table .icon-mr-margin{margin-right:5px}.label-table .label-btn{border:0;border-color:transparent;background-color:transparent}.label-table .label-btn:focus-visible{outline:none;box-shadow:0 0 0 1px #4976b9}.label-table .label-btn .label{display:inline-block;min-width:28px;min-height:8px;padding:2px 7px;font-size:11px;line-height:11px;margin:3px 5px 3px 0;border-radius:3px}.label-table .label-btn .label span{overflow:hidden}.label-table .label-btn .label span.ng-enter,.label-table .label-btn .label span.ng-leave.ng-leave-active{animation:.5s label_text_disappear linear}.label-table .label-btn .label span.ng-leave,.label-table .label-btn .label span.ng-enter.ng-enter-active{animation:.5s label_text_appear linear}.btn-label-edit{opacity:0;padding:2px 5px;line-height:11px;font-size:11px;position:relative;color:#647187;background-color:#ebecf0;border-color:#ebecf0}.btn-label-edit:focus,.btn-label-edit.focus{color:#555557;background-color:#d4dce3;border-color:#a7b5c4}.btn-label-edit:hover{color:#555557;background-color:#d4dce3;border-color:#ced6df}.btn-label-edit:focus,.btn-label-edit:hover,.btn-label-edit:active,.btn-label-edit:focus-within{opacity:1}.btn-label-edit:focus-visible{opacity:1;outline:0;box-shadow:0 0 0 1px #4976b9}.btn-label-edit.no-labels{margin-top:-20px}tr:hover .btn-label-edit{opacity:1}@keyframes label_text_appear{0%{width:28px;height:8px;color:transparent}25%{width:fit-content;height:8px}45%{height:8px}53%{height:8px}75%{height:12px;color:transparent}}@keyframes label_text_disappear{0%{height:12px;width:fit-content}33%{color:transparent;height:12px;width:fit-content}66%{height:8px;width:fit-content;color:transparent}to{color:transparent;height:8px;width:28px}}\n"] }]
    }], () => [{ type: LabelTableService }], { existingLabels: [{
            type: Input
        }], assignedLabels: [{
            type: Input
        }], noLabelSelector: [{
            type: Input
        }], onUpdateLabel: [{
            type: Output
        }], getLabels: [{
            type: Output
        }], createOrUpdateLabel: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(LabelTableComponent, { className: "LabelTableComponent" }); })();

class GettextPluralsService {
    constructor() {
        this.languageCodes = {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            pt_BR: 'pt_BR',
            // eslint-disable-next-line @typescript-eslint/naming-convention
            'pt-BR': 'pt_BR',
        };
    }
    getPlurals(langCode, n) {
        switch (this.getLanguageCode(langCode)) {
            case 'ay': // Aymará
            case 'bo': // Tibetan
            case 'cgg': // Chiga
            case 'dz': // Dzongkha
            case 'fa': // Persian
            case 'id': // Indonesian
            case 'ja': // Japanese
            case 'jbo': // Lojban
            case 'ka': // Georgian
            case 'kk': // Kazakh
            case 'km': // Khmer
            case 'ko': // Korean
            case 'ky': // Kyrgyz
            case 'lo': // Lao
            case 'ms': // Malay
            case 'my': // Burmese
            case 'sah': // Yakut
            case 'su': // Sundanese
            case 'th': // Thai
            case 'tt': // Tatar
            case 'ug': // Uyghur
            case 'vi': // Vietnamese
            case 'wo': // Wolof
                // 1 form
                return 0;
            case 'is': // Icelandic
                // 2 forms
                return n % 10 !== 1 || n % 100 === 11 ? 1 : 0;
            case 'jv': // Javanese
                // 2 forms
                return n !== 0 ? 1 : 0;
            case 'mk': // Macedonian
                // 2 forms
                return n === 1 || n % 10 === 1 ? 0 : 1;
            case 'ach': // Acholi
            case 'ak': // Akan
            case 'am': // Amharic
            case 'arn': // Mapudungun
            case 'br': // Breton
            case 'fil': // Filipino
            case 'fr': // French
            case 'gun': // Gun
            case 'ln': // Lingala
            case 'mfe': // Mauritian Creole
            case 'mg': // Malagasy
            case 'mi': // Maori
            case 'oc': // Occitan
            case 'pt_BR': // Brazilian Portuguese
            case 'tg': // Tajik
            case 'ti': // Tigrinya
            case 'tr': // Turkish
            case 'uz': // Uzbek
            case 'wa': // Walloon
            case 'zh': // Chinese
                // 2 forms
                return n > 1 ? 1 : 0;
            case 'lv': // Latvian
                // 3 forms
                return n % 10 === 1 && n % 100 !== 11 ? 0 : n !== 0 ? 1 : 2;
            case 'lt': // Lithuanian
                // 3 forms
                return n % 10 === 1 && n % 100 !== 11
                    ? 0
                    : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20)
                        ? 1
                        : 2;
            case 'be': // Belarusian
            case 'bs': // Bosnian
            case 'hr': // Croatian
            case 'ru': // Russian
            case 'sr': // Serbian
            case 'uk': // Ukrainian
                // 3 forms
                return n % 10 === 1 && n % 100 !== 11
                    ? 0
                    : n % 10 >= 2 &&
                        n % 10 <= 4 &&
                        (n % 100 < 10 || n % 100 >= 20)
                        ? 1
                        : 2;
            case 'mnk': // Mandinka
                // 3 forms
                return n === 0 ? 0 : n === 1 ? 1 : 2;
            case 'ro': // Romanian
                // 3 forms
                return n === 1
                    ? 0
                    : n === 0 || (n % 100 > 0 && n % 100 < 20)
                        ? 1
                        : 2;
            case 'pl': // Polish
                // 3 forms
                return n === 1
                    ? 0
                    : n % 10 >= 2 &&
                        n % 10 <= 4 &&
                        (n % 100 < 10 || n % 100 >= 20)
                        ? 1
                        : 2;
            case 'cs': // Czech
            case 'sk': // Slovak
                // 3 forms
                return n === 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2;
            case 'sl': // Slovenian
                // 4 forms
                return n % 100 === 1
                    ? 1
                    : n % 100 === 2
                        ? 2
                        : n % 100 === 3 || n % 100 === 4
                            ? 3
                            : 0;
            case 'mt': // Maltese
                // 4 forms
                return n === 1
                    ? 0
                    : n === 0 || (n % 100 > 1 && n % 100 < 11)
                        ? 1
                        : n % 100 > 10 && n % 100 < 20
                            ? 2
                            : 3;
            case 'gd': // Scottish Gaelic
                // 4 forms
                return n === 1 || n === 11
                    ? 0
                    : n === 2 || n === 12
                        ? 1
                        : n > 2 && n < 20
                            ? 2
                            : 3;
            case 'cy': // Welsh
                // 4 forms
                return n === 1 ? 0 : n === 2 ? 1 : n !== 8 && n !== 11 ? 2 : 3;
            case 'kw': // Cornish
                // 4 forms
                return n === 1 ? 0 : n === 2 ? 1 : n === 3 ? 2 : 3;
            case 'ga': // Irish
                // 5 forms
                return n === 1 ? 0 : n === 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4;
            case 'ar': // Arabic
                // 6 forms
                return n === 0
                    ? 0
                    : n === 1
                        ? 1
                        : n === 2
                            ? 2
                            : n % 100 >= 3 && n % 100 <= 10
                                ? 3
                                : n % 100 >= 11
                                    ? 4
                                    : 5;
            default:
                // Everything else
                return n !== 1 ? 1 : 0;
        }
    }
    getLanguageCode(langCode) {
        if (!this.languageCodes[langCode]) {
            this.languageCodes[langCode] = langCode.split(/-|_/).shift();
        }
        return this.languageCodes[langCode];
    }
    static { this.ɵfac = function GettextPluralsService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || GettextPluralsService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: GettextPluralsService, factory: GettextPluralsService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GettextPluralsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], () => [], null); })();

class FallbackLanguageService {
    getLanguage(langCode) {
        const cache = {};
        const pattern = /([^_]+)_[^_]+$/;
        if (cache[langCode]) {
            return cache[langCode];
        }
        const matches = pattern.exec(langCode);
        if (matches) {
            cache[langCode] = matches[1];
            return matches[1];
        }
        return null;
    }
    static { this.ɵfac = function FallbackLanguageService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FallbackLanguageService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: FallbackLanguageService, factory: FallbackLanguageService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FallbackLanguageService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], null, null); })();

class TranslateService {
    constructor() {
        this.service = new TranslateService$1();
    }
    get baseLanguage() {
        return this.service.baseLanguage;
    }
    onLanguageChange$() {
        return this.service.onLanguageChange$();
    }
    getString(text, args = {}, context) {
        return this.service.getString(text, args, context);
    }
    getPlural(n, text, textPlural, args, context) {
        return this.service.getPlural(n, text, textPlural, args, context);
    }
    setCurrentLanguage(lang) {
        this.service.setCurrentLanguage(lang);
    }
    setStrings(language, strings) {
        this.service.setStrings(language, strings);
    }
    static { this.ɵfac = function TranslateService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TranslateService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: TranslateService, factory: TranslateService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TranslateService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], null, null); })();

class TranslateModule {
    static { this.ɵfac = function TranslateModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TranslateModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: TranslateModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [
            {
                provide: TranslateServiceInjectionToken,
                useClass: TranslateService,
            },
            GettextPluralsService,
            FallbackLanguageService,
        ], imports: [CommonModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TranslateModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                exports: [TranslatePipe, TranslateDirective],
                declarations: [TranslatePipe, TranslateDirective],
                providers: [
                    {
                        provide: TranslateServiceInjectionToken,
                        useClass: TranslateService,
                    },
                    GettextPluralsService,
                    FallbackLanguageService,
                ],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(TranslateModule, { declarations: [TranslatePipe, TranslateDirective], imports: [CommonModule], exports: [TranslatePipe, TranslateDirective] }); })();

/**
 * This pipe is used particularly with input element for the `pattern` property to escape
 * special characters that one might use in a password in order to correctly verify the repeated password
 * is the same as the password;
 *
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#escaping
 *
 * @example
 * <mon-form-field-input
 *      type="password"
 *      name="password"
 *      ngModel
 *      #password>
 * </mon-form-field-input>
 *
 * <mon-form-field-input
 *      type="password"
 *      [pattern]="password.value | monEscapeRegExp"
 *      patternMsg="{{ 'Passwords do not match' | translate }}"
 *      name="confirm_password"
 *      ngModel>
 * </mon-form-field-input>
 */
class EscapeRegExpPipe {
    transform(input) {
        if (typeof input === 'number') {
            return String(input).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        }
        return input ? input.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') : '';
    }
    static { this.ɵfac = function EscapeRegExpPipe_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || EscapeRegExpPipe)(); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "monEscapeRegExp", type: EscapeRegExpPipe, pure: true }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EscapeRegExpPipe, [{
        type: Pipe,
        args: [{
                name: 'monEscapeRegExp',
            }]
    }], null, null); })();

class CapitalizePipe {
    transform(value) {
        return StringService.capitalize(value);
    }
    static { this.ɵfac = function CapitalizePipe_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CapitalizePipe)(); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "capitalize", type: CapitalizePipe, pure: true }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CapitalizePipe, [{
        type: Pipe,
        args: [{
                name: 'capitalize',
            }]
    }], null, null); })();

class PipesModule {
    static { this.ɵfac = function PipesModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PipesModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: PipesModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({}); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PipesModule, [{
        type: NgModule,
        args: [{
                imports: [],
                exports: [InverseColorCode, EscapeRegExpPipe, CapitalizePipe],
                declarations: [InverseColorCode, EscapeRegExpPipe, CapitalizePipe],
                providers: [],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(PipesModule, { declarations: [InverseColorCode, EscapeRegExpPipe, CapitalizePipe], exports: [InverseColorCode, EscapeRegExpPipe, CapitalizePipe] }); })();

class LabelModule {
    static { this.ɵfac = function LabelModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || LabelModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: LabelModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [LabelTableService], imports: [CommonModule,
            TranslateModule,
            NgbDropdownModule,
            NgbPaginationModule,
            NgbModule,
            FormsModule,
            NgbTooltipModule,
            PipesModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LabelModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    TranslateModule,
                    NgbDropdownModule,
                    NgbPaginationModule,
                    NgbModule,
                    FormsModule,
                    NgbTooltipModule,
                    NgClickOutsideDirective,
                    PipesModule,
                ],
                exports: [
                    LabelContainerSelectorComponent,
                    LabelContainerComponent,
                    LabelTableComponent,
                ],
                declarations: [
                    LabelContainerSelectorComponent,
                    LabelContainerComponent,
                    LabelTableComponent,
                    FilterByLabelNamePipe,
                ],
                providers: [LabelTableService],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LabelModule, { declarations: [LabelContainerSelectorComponent,
        LabelContainerComponent,
        LabelTableComponent,
        FilterByLabelNamePipe], imports: [CommonModule,
        TranslateModule,
        NgbDropdownModule,
        NgbPaginationModule,
        NgbModule,
        FormsModule,
        NgbTooltipModule,
        NgClickOutsideDirective,
        PipesModule], exports: [LabelContainerSelectorComponent,
        LabelContainerComponent,
        LabelTableComponent] }); })();

class RemovePlaceholderDirective {
    constructor(element) {
        this.element = element;
        this.placeholderText = '';
    }
    ngOnInit() {
        this.element.nativeElement.addEventListener('focus', (e) => {
            this.placeholderText = e.target.placeholder;
            e.target.placeholder = '';
        });
        this.element.nativeElement.addEventListener('focusout', (e) => {
            e.target.placeholder =
                this.placeholderText;
        });
    }
    static { this.ɵfac = function RemovePlaceholderDirective_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || RemovePlaceholderDirective)(i0.ɵɵdirectiveInject(i0.ElementRef)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: RemovePlaceholderDirective, selectors: [["", "monRemovePlaceholder", ""]] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RemovePlaceholderDirective, [{
        type: Directive,
        args: [{ selector: '[monRemovePlaceholder]' }]
    }], () => [{ type: i0.ElementRef }], null); })();

const _c0$E = (a0, a1) => ({ "lg": a0, "xs": a1 });
const _c1$j = (a0, a1) => ({ "fa-lg": a0, "fa-xs": a1 });
const _c2$c = a0 => ({ "btn-hide": a0 });
const _c3$7 = (a0, a1, a2) => ({ "v-none": a0, "fa-lg": a1, "fa-xs": a2 });
class TableSearchComponent {
    constructor(translateService) {
        this.translateService = translateService;
        this.getPage = new EventEmitter();
        this.theme = 'white-theme';
        this.size = 'lg';
        this.placeholderTxt = this.placeholderTxt || this.translateService.getString('Search...');
    }
    ngOnInit() {
        this.minSearchLength = this.minSearchLength || 3;
    }
    changeSearch() {
        if (this.searchDelay !== null) {
            clearTimeout(this.searchDelay);
        }
        this.searchDelay = window.setTimeout(() => {
            if (this.model.length >= this.minSearchLength || this.model.length === 0) {
                this.getPage.emit(this.model);
            }
        }, 400);
    }
    onClearAction(e) {
        if (this.showClearBtn()) {
            this.model = '';
            this.changeSearch();
        }
        e.currentTarget.parentElement.querySelector('input').focus();
    }
    showClearBtn() {
        return typeof this.model === 'string' && this.model.length > 0;
    }
    static { this.ɵfac = function TableSearchComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TableSearchComponent)(i0.ɵɵdirectiveInject(TranslateServiceInjectionToken)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TableSearchComponent, selectors: [["mon-table-search"]], inputs: { model: "model", theme: "theme", containerClass: "containerClass", placeholderTxt: "placeholderTxt", minSearchLength: "minSearchLength", size: "size" }, outputs: { getPage: "getPage" }, decls: 10, vars: 34, consts: [[1, "form-group", "has-feedback", "has-feedback-left", "search-input", 3, "ngClass"], [1, "input-group"], [1, "input-group-prepend"], [1, "input-group-text"], ["aria-hidden", "true", 1, "fas", "fa-search"], ["monRemovePlaceholder", "", "type", "search", 1, "form-control", 3, "ngModelChange", "placeholder", "ngModel"], ["role", "button", 1, "input-group-append", 3, "click"], ["aria-hidden", "true", 1, "fas", "fa-times", "pr-2"]], template: function TableSearchComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "span", 3);
            i0.ɵɵelement(4, "span", 4);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(5, "input", 5);
            i0.ɵɵtwoWayListener("ngModelChange", function TableSearchComponent_Template_input_ngModelChange_5_listener($event) { i0.ɵɵtwoWayBindingSet(ctx.model, $event) || (ctx.model = $event); return $event; });
            i0.ɵɵlistener("ngModelChange", function TableSearchComponent_Template_input_ngModelChange_5_listener() { return ctx.changeSearch(); });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "div", 6);
            i0.ɵɵpipe(7, "translate");
            i0.ɵɵlistener("click", function TableSearchComponent_Template_div_click_6_listener($event) { return ctx.onClearAction($event); });
            i0.ɵɵelementStart(8, "span", 3);
            i0.ɵɵelement(9, "span", 7);
            i0.ɵɵelementEnd()()()();
        } if (rf & 2) {
            i0.ɵɵclassMap(ctx.containerClass);
            i0.ɵɵproperty("ngClass", ctx.theme);
            i0.ɵɵadvance();
            i0.ɵɵclassMap(i0.ɵɵpureFunction2(19, _c0$E, ctx.size === "lg", ctx.size === "xs"));
            i0.ɵɵadvance(3);
            i0.ɵɵclassMap(i0.ɵɵpureFunction2(22, _c1$j, ctx.size === "lg", ctx.size === "xs"));
            i0.ɵɵadvance();
            i0.ɵɵclassMap(i0.ɵɵpureFunction2(25, _c0$E, ctx.size === "lg", ctx.size === "xs"));
            i0.ɵɵproperty("placeholder", ctx.placeholderTxt);
            i0.ɵɵtwoWayProperty("ngModel", ctx.model);
            i0.ɵɵattribute("aria-label", ctx.placeholderTxt);
            i0.ɵɵadvance();
            i0.ɵɵclassMap(i0.ɵɵpureFunction1(28, _c2$c, !ctx.showClearBtn()));
            i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(7, 17, "Clear search"));
            i0.ɵɵadvance(3);
            i0.ɵɵclassMap(i0.ɵɵpureFunction3(30, _c3$7, !ctx.showClearBtn(), ctx.size === "lg", ctx.size === "xs"));
        } }, dependencies: [i1$2.NgClass, i1$5.DefaultValueAccessor, i1$5.NgControlStatus, i1$5.NgModel, RemovePlaceholderDirective, TranslatePipe], styles: [".search-input[_ngcontent-%COMP%]{margin-bottom:0}.search-input[_ngcontent-%COMP%]   input[type=search][_ngcontent-%COMP%]::-webkit-search-decoration, .search-input[_ngcontent-%COMP%]   input[type=search][_ngcontent-%COMP%]::-webkit-search-cancel-button, .search-input[_ngcontent-%COMP%]   input[type=search][_ngcontent-%COMP%]::-webkit-search-results-button, .search-input[_ngcontent-%COMP%]   input[type=search][_ngcontent-%COMP%]::-webkit-search-results-decoration{display:none}.search-input[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]{display:flex;align-items:center;background-color:#fff;border:1px solid #E6E6E6;border-radius:4px}.search-input[_ngcontent-%COMP%]   .input-group.xs[_ngcontent-%COMP%]{height:30px}.search-input[_ngcontent-%COMP%]   .input-group.lg[_ngcontent-%COMP%]{height:40px}.search-input[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]   .input-group-append.btn-hide[_ngcontent-%COMP%]{cursor:text}.search-input[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]   .input-group-append[_ngcontent-%COMP%]   .input-group-text[_ngcontent-%COMP%]{padding-top:6px;border-left-color:transparent}.search-input[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]   .input-group-prepend[_ngcontent-%COMP%]{padding-left:8px;padding-top:4px}.search-input[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]   .input-group-prepend[_ngcontent-%COMP%]   .input-group-text[_ngcontent-%COMP%]{padding-top:6px;border-right-color:transparent}.search-input[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]   input.form-control[type=search][_ngcontent-%COMP%]{border:none;padding:0 10px;box-shadow:none;font-size:12px}.search-input[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]   input.form-control[type=search].xs[_ngcontent-%COMP%]{height:28px}.search-input[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]   input.form-control[type=search].lg[_ngcontent-%COMP%]{height:38px}.search-input[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]   .v-none[_ngcontent-%COMP%]{visibility:hidden}.search-input[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]   .input-group-prepend[_ngcontent-%COMP%]   .input-group-text[_ngcontent-%COMP%]{background-color:#fff;color:#7b7b7b;border-left-color:#e6e6e6;border-bottom-color:#e6e6e6;border-top-color:#e6e6e6;border:none}.search-input[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]   .input-group-append[_ngcontent-%COMP%]   .input-group-text[_ngcontent-%COMP%]{background-color:#fff;color:#7b7b7b;border-right-color:#e6e6e6;border-bottom-color:#e6e6e6;border-top-color:#e6e6e6;border:none}.search-input[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]   input.form-control[type=search][_ngcontent-%COMP%]{background-color:#fff;color:#7b7b7b;border-bottom-color:#e6e6e6;border-top-color:#e6e6e6}.search-input[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]   input.form-control[type=search][_ngcontent-%COMP%]::-webkit-input-placeholder{color:#7b7b7b}.search-input[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]   input.form-control[type=search][_ngcontent-%COMP%]:-moz-placeholder{color:#7b7b7b}.search-input[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]   input.form-control[type=search][_ngcontent-%COMP%]::-moz-placeholder{color:#7b7b7b}.search-input[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]   input.form-control[type=search][_ngcontent-%COMP%]:-ms-input-placeholder{color:#7b7b7b}.search-input.white-theme[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]   .input-group-prepend[_ngcontent-%COMP%]   .input-group-text[_ngcontent-%COMP%]{background-color:#fff;color:#7b7b7b;border-left-color:#e6e6e6;border-bottom-color:#e6e6e6;border-top-color:#e6e6e6;border:none}.search-input.white-theme[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]   .input-group-append[_ngcontent-%COMP%]   .input-group-text[_ngcontent-%COMP%]{background-color:#fff;color:#7b7b7b;border-right-color:#e6e6e6;border-bottom-color:#e6e6e6;border-top-color:#e6e6e6;border:none}.search-input.white-theme[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]   input.form-control[type=search][_ngcontent-%COMP%]{background-color:#fff;color:#7b7b7b;border-bottom-color:#e6e6e6;border-top-color:#e6e6e6}.search-input.white-theme[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]   input.form-control[type=search][_ngcontent-%COMP%]::-webkit-input-placeholder{color:#7b7b7b}.search-input.white-theme[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]   input.form-control[type=search][_ngcontent-%COMP%]:-moz-placeholder{color:#7b7b7b}.search-input.white-theme[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]   input.form-control[type=search][_ngcontent-%COMP%]::-moz-placeholder{color:#7b7b7b}.search-input.white-theme[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]   input.form-control[type=search][_ngcontent-%COMP%]:-ms-input-placeholder{color:#7b7b7b}.search-input.grey-theme[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]   .input-group-prepend[_ngcontent-%COMP%]   .input-group-text[_ngcontent-%COMP%]{background-color:#ebebec;color:#7b7b7b;border-left-color:#ebebec;border-bottom-color:#ebebec;border-top-color:#ebebec;border:none}.search-input.grey-theme[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]   .input-group-append[_ngcontent-%COMP%]   .input-group-text[_ngcontent-%COMP%]{background-color:#ebebec;color:#7b7b7b;border-right-color:#ebebec;border-bottom-color:#ebebec;border-top-color:#ebebec;border:none}.search-input.grey-theme[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]   input.form-control[type=search][_ngcontent-%COMP%]{background-color:#ebebec;color:#7b7b7b;border-bottom-color:#ebebec;border-top-color:#ebebec}.search-input.grey-theme[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]   input.form-control[type=search][_ngcontent-%COMP%]::-webkit-input-placeholder{color:#7b7b7b}.search-input.grey-theme[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]   input.form-control[type=search][_ngcontent-%COMP%]:-moz-placeholder{color:#7b7b7b}.search-input.grey-theme[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]   input.form-control[type=search][_ngcontent-%COMP%]::-moz-placeholder{color:#7b7b7b}.search-input.grey-theme[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]   input.form-control[type=search][_ngcontent-%COMP%]:-ms-input-placeholder{color:#7b7b7b}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TableSearchComponent, [{
        type: Component,
        args: [{ selector: 'mon-table-search', template: "<div class=\"form-group has-feedback has-feedback-left search-input\"\n     [ngClass]=\"theme\"\n     [class]=\"containerClass\">\n    <div class=\"input-group\" [class]=\"{'lg': size === 'lg', 'xs': size === 'xs'}\">\n        <div class=\"input-group-prepend\">\n            <span class=\"input-group-text\">\n                <span class=\"fas fa-search\" [class]=\"{'fa-lg': size === 'lg', 'fa-xs': size === 'xs'}\" aria-hidden=\"true\"></span>\n            </span>\n        </div>\n        <input [placeholder]=\"placeholderTxt\"\n               monRemovePlaceholder\n               type=\"search\"\n               [attr.aria-label]=\"placeholderTxt\"\n               class=\"form-control\"\n               [(ngModel)]=\"model\"\n               [class]=\"{'lg': size === 'lg', 'xs': size === 'xs'}\"\n               (ngModelChange)=\"changeSearch()\">\n        <div role=\"button\"\n             class=\"input-group-append\"\n             [attr.aria-label]=\"'Clear search' | translate\"\n             [class]=\"{'btn-hide': !showClearBtn()}\"\n             (click)=\"onClearAction($event)\">\n            <span class=\"input-group-text\">\n                <span class=\"fas fa-times pr-2\" [class]=\"{'v-none': !showClearBtn(), 'fa-lg': size === 'lg', 'fa-xs': size === 'xs'}\" aria-hidden=\"true\"></span>\n            </span>\n        </div>\n    </div>\n</div>\n", styles: [".search-input{margin-bottom:0}.search-input input[type=search]::-webkit-search-decoration,.search-input input[type=search]::-webkit-search-cancel-button,.search-input input[type=search]::-webkit-search-results-button,.search-input input[type=search]::-webkit-search-results-decoration{display:none}.search-input .input-group{display:flex;align-items:center;background-color:#fff;border:1px solid #E6E6E6;border-radius:4px}.search-input .input-group.xs{height:30px}.search-input .input-group.lg{height:40px}.search-input .input-group .input-group-append.btn-hide{cursor:text}.search-input .input-group .input-group-append .input-group-text{padding-top:6px;border-left-color:transparent}.search-input .input-group .input-group-prepend{padding-left:8px;padding-top:4px}.search-input .input-group .input-group-prepend .input-group-text{padding-top:6px;border-right-color:transparent}.search-input .input-group input.form-control[type=search]{border:none;padding:0 10px;box-shadow:none;font-size:12px}.search-input .input-group input.form-control[type=search].xs{height:28px}.search-input .input-group input.form-control[type=search].lg{height:38px}.search-input .input-group .v-none{visibility:hidden}.search-input .input-group .input-group-prepend .input-group-text{background-color:#fff;color:#7b7b7b;border-left-color:#e6e6e6;border-bottom-color:#e6e6e6;border-top-color:#e6e6e6;border:none}.search-input .input-group .input-group-append .input-group-text{background-color:#fff;color:#7b7b7b;border-right-color:#e6e6e6;border-bottom-color:#e6e6e6;border-top-color:#e6e6e6;border:none}.search-input .input-group input.form-control[type=search]{background-color:#fff;color:#7b7b7b;border-bottom-color:#e6e6e6;border-top-color:#e6e6e6}.search-input .input-group input.form-control[type=search]::-webkit-input-placeholder{color:#7b7b7b}.search-input .input-group input.form-control[type=search]:-moz-placeholder{color:#7b7b7b}.search-input .input-group input.form-control[type=search]::-moz-placeholder{color:#7b7b7b}.search-input .input-group input.form-control[type=search]:-ms-input-placeholder{color:#7b7b7b}.search-input.white-theme .input-group .input-group-prepend .input-group-text{background-color:#fff;color:#7b7b7b;border-left-color:#e6e6e6;border-bottom-color:#e6e6e6;border-top-color:#e6e6e6;border:none}.search-input.white-theme .input-group .input-group-append .input-group-text{background-color:#fff;color:#7b7b7b;border-right-color:#e6e6e6;border-bottom-color:#e6e6e6;border-top-color:#e6e6e6;border:none}.search-input.white-theme .input-group input.form-control[type=search]{background-color:#fff;color:#7b7b7b;border-bottom-color:#e6e6e6;border-top-color:#e6e6e6}.search-input.white-theme .input-group input.form-control[type=search]::-webkit-input-placeholder{color:#7b7b7b}.search-input.white-theme .input-group input.form-control[type=search]:-moz-placeholder{color:#7b7b7b}.search-input.white-theme .input-group input.form-control[type=search]::-moz-placeholder{color:#7b7b7b}.search-input.white-theme .input-group input.form-control[type=search]:-ms-input-placeholder{color:#7b7b7b}.search-input.grey-theme .input-group .input-group-prepend .input-group-text{background-color:#ebebec;color:#7b7b7b;border-left-color:#ebebec;border-bottom-color:#ebebec;border-top-color:#ebebec;border:none}.search-input.grey-theme .input-group .input-group-append .input-group-text{background-color:#ebebec;color:#7b7b7b;border-right-color:#ebebec;border-bottom-color:#ebebec;border-top-color:#ebebec;border:none}.search-input.grey-theme .input-group input.form-control[type=search]{background-color:#ebebec;color:#7b7b7b;border-bottom-color:#ebebec;border-top-color:#ebebec}.search-input.grey-theme .input-group input.form-control[type=search]::-webkit-input-placeholder{color:#7b7b7b}.search-input.grey-theme .input-group input.form-control[type=search]:-moz-placeholder{color:#7b7b7b}.search-input.grey-theme .input-group input.form-control[type=search]::-moz-placeholder{color:#7b7b7b}.search-input.grey-theme .input-group input.form-control[type=search]:-ms-input-placeholder{color:#7b7b7b}\n"] }]
    }], () => [{ type: undefined, decorators: [{
                type: Inject,
                args: [TranslateServiceInjectionToken]
            }] }], { getPage: [{
            type: Output
        }], model: [{
            type: Input
        }], theme: [{
            type: Input
        }], containerClass: [{
            type: Input
        }], placeholderTxt: [{
            type: Input
        }], minSearchLength: [{
            type: Input
        }], size: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(TableSearchComponent, { className: "TableSearchComponent" }); })();

class RemovePlaceholderModule {
    static { this.ɵfac = function RemovePlaceholderModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || RemovePlaceholderModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: RemovePlaceholderModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({}); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RemovePlaceholderModule, [{
        type: NgModule,
        args: [{
                imports: [],
                exports: [RemovePlaceholderDirective],
                declarations: [RemovePlaceholderDirective],
                providers: [],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(RemovePlaceholderModule, { declarations: [RemovePlaceholderDirective], exports: [RemovePlaceholderDirective] }); })();

class TableSearchModule {
    static { this.ɵfac = function TableSearchModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TableSearchModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: TableSearchModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, TranslateModule, FormsModule, RemovePlaceholderModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TableSearchModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, TranslateModule, FormsModule, RemovePlaceholderModule],
                exports: [TableSearchComponent],
                declarations: [TableSearchComponent],
                providers: [],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(TableSearchModule, { declarations: [TableSearchComponent], imports: [CommonModule, TranslateModule, FormsModule, RemovePlaceholderModule], exports: [TableSearchComponent] }); })();

const _c0$D = a0 => ({ active: a0 });
function PageSizeComponent_div_0_label_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 3);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementStart(2, "input", 4);
    i0.ɵɵlistener("change", function PageSizeComponent_div_0_label_1_Template_input_change_2_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.stateChange($event)); })("click", function PageSizeComponent_div_0_label_1_Template_input_click_2_listener() { const size_r4 = i0.ɵɵrestoreView(_r3).$implicit; const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.sizeChange(size_r4)); });
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const size_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c0$D, ctx_r1.activeState.get(size_r4)));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 4, "Page size") + size_r4);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("value", size_r4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", size_r4, " ");
} }
function PageSizeComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtwoWayListener("ngModelChange", function PageSizeComponent_div_0_Template_div_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r1.pageSize, $event) || (ctx_r1.pageSize = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵtemplate(1, PageSizeComponent_div_0_label_1_Template, 4, 8, "label", 2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.pageSize);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.pageSizes);
} }
class PageSizeComponent {
    constructor() {
        this.pageSize = 10; // TODO set form default constant https://zube.io/monsido/monsido/c/23723
        this.pageSizes = [10, 25, 50];
        this.totalItems = 0;
        this.perPageChange = new EventEmitter();
        this.orgPageSizes = [];
        this.activeState = new Map();
    }
    ngOnInit() {
        Object.assign(this.orgPageSizes, this.pageSizes.sort((a, b) => a - b));
        for (const pageSize of this.pageSizes) {
            this.activeState.set(pageSize, pageSize === this.pageSize ? true : false);
        }
    }
    showPaginate() {
        return Number(this.pageSizes[0]) < Number(this.totalItems);
    }
    sizeChange(size) {
        this.perPageChange.emit(size);
    }
    stateChange(event) {
        const value = Number(event.target.value);
        for (const key of this.activeState.keys()) {
            if (value === key) {
                this.activeState.set(key, true);
            }
            else {
                this.activeState.set(key, false);
            }
        }
    }
    static { this.ɵfac = function PageSizeComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PageSizeComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PageSizeComponent, selectors: [["mon-table-page-size"]], inputs: { pageSize: "pageSize", pageSizes: "pageSizes", totalItems: "totalItems" }, outputs: { perPageChange: "perPageChange" }, decls: 1, vars: 1, consts: [["class", "btn-group btn-group-toggle", "name", "page_size", "ngDefaultControl", "", 3, "ngModel", "ngModelChange", 4, "ngIf"], ["name", "page_size", "ngDefaultControl", "", 1, "btn-group", "btn-group-toggle", 3, "ngModelChange", "ngModel"], ["class", "btn btn-default btn-secondary", 3, "ngClass", 4, "ngFor", "ngForOf"], [1, "btn", "btn-default", "btn-secondary", 3, "ngClass"], ["type", "radio", "name", "page_size", 3, "change", "click", "value"]], template: function PageSizeComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, PageSizeComponent_div_0_Template, 2, 2, "div", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.showPaginate());
        } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, i1$5.DefaultValueAccessor, i1$5.NgControlStatus, i1$5.NgModel, TranslatePipe], styles: [".btn-secondary[_ngcontent-%COMP%]{color:#299bf7;background-color:#fff;border-color:#e4e4e4;padding:5.5px 12px}.btn-secondary[_ngcontent-%COMP%]   input[type=radio][_ngcontent-%COMP%], .btn-secondary[_ngcontent-%COMP%]   input[type=checkbox][_ngcontent-%COMP%]{display:none}.btn-secondary.active[_ngcontent-%COMP%]{color:#299bf7;background-color:#e6e6e6;background-image:none;border-color:#c5c5c5}label[_ngcontent-%COMP%]{margin-bottom:0}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PageSizeComponent, [{
        type: Component,
        args: [{ selector: 'mon-table-page-size', template: "<div class=\"btn-group btn-group-toggle\"\n     *ngIf=\"showPaginate()\"\n     name=\"page_size\"\n     ngDefaultControl\n     [(ngModel)]=\"pageSize\"\n     >\n    <label *ngFor=\"let size of pageSizes\"\n           class=\"btn btn-default btn-secondary\"\n           [ngClass]=\"{active: activeState.get(size)}\"\n           [attr.aria-label]=\"('Page size' | translate) + size\">\n        <input type=\"radio\" name=\"page_size\" (change)=\"stateChange($event)\" (click)=\"sizeChange(size)\" [value]=\"size\"> {{size}}\n    </label>\n</div>\n", styles: [".btn-secondary{color:#299bf7;background-color:#fff;border-color:#e4e4e4;padding:5.5px 12px}.btn-secondary input[type=radio],.btn-secondary input[type=checkbox]{display:none}.btn-secondary.active{color:#299bf7;background-color:#e6e6e6;background-image:none;border-color:#c5c5c5}label{margin-bottom:0}\n"] }]
    }], () => [], { pageSize: [{
            type: Input
        }], pageSizes: [{
            type: Input
        }], totalItems: [{
            type: Input
        }], perPageChange: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(PageSizeComponent, { className: "PageSizeComponent" }); })();

const _c0$C = [[["div", 8, "table-container-top"]], [["div", 8, "table-container-body"]]];
const _c1$i = ["div.table-container-top", "div.table-container-body"];
function ContainerComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵprojection(1, 1);
    i0.ɵɵelementContainerEnd();
} }
function ContainerComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "p", 7);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.noResultMessage);
} }
function ContainerComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵelement(1, "span", 9);
    i0.ɵɵelementEnd();
} }
function ContainerComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "mon-table-page-size", 10);
    i0.ɵɵlistener("perPageChange", function ContainerComponent_ng_container_6_Template_mon_table_page_size_perPageChange_1_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.pageSizeChange($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("totalItems", ctx_r0.collection.total)("pageSize", ctx_r0.getPageSize())("pageSizes", ctx_r0.pageSizes);
} }
function ContainerComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11)(1, "ngb-pagination", 12);
    i0.ɵɵtwoWayListener("pageChange", function ContainerComponent_div_7_Template_ngb_pagination_pageChange_1_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r0 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r0.collection.currentPage, $event) || (ctx_r0.collection.currentPage = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("pageChange", function ContainerComponent_div_7_Template_ngb_pagination_pageChange_1_listener() { i0.ɵɵrestoreView(_r3); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.pageChange()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("hidden", ctx_r0.disablePagination);
    i0.ɵɵadvance();
    i0.ɵɵproperty("maxSize", 7)("rotate", true)("collectionSize", ctx_r0.collection.total);
    i0.ɵɵtwoWayProperty("page", ctx_r0.collection.currentPage);
    i0.ɵɵproperty("pageSize", ctx_r0.getPageSize());
} }
class ContainerComponent {
    constructor(translateService) {
        this.translateService = translateService;
        this.disablePagination = false;
        this.pageSizes = [10, 25, 50];
        this.pageChangeEvent = new EventEmitter();
        this.perPageChange = new EventEmitter();
        this.showProgress = false;
        this.showTable = true;
        this.defaultPageSize = 10; // TODO add from default constant
    }
    ngOnInit() {
        this.noResultMessage =
            this.noResultMessage ||
                this.translateService.getString('No content was found');
    }
    pageChange() {
        this.pageChangeEvent.emit(this.collection.currentPage);
    }
    pageSizeChange(size) {
        this.perPageChange.emit(size);
    }
    shownNoResultMessage() {
        return (!this.showProgress &&
            !this.loading &&
            this.collection.total === 0 &&
            this.noResultMessage.length > 0);
    }
    showPagination() {
        return (Number(this.collection ? this.collection.total : 0) >
            this.getPageSize());
    }
    getPageSize() {
        let pageSize = this.defaultPageSize;
        if (typeof this.collection === 'object') {
            pageSize = this.collection.perPage || pageSize;
        }
        return Number(pageSize);
    }
    static { this.ɵfac = function ContainerComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ContainerComponent)(i0.ɵɵdirectiveInject(TranslateServiceInjectionToken)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ContainerComponent, selectors: [["mon-table-container"]], inputs: { disablePagination: "disablePagination", collection: "collection", pageSizes: "pageSizes", progress: "progress", noResultMessage: "noResultMessage", loading: "loading" }, outputs: { pageChangeEvent: "pageChangeEvent", perPageChange: "perPageChange" }, ngContentSelectors: _c1$i, decls: 8, vars: 5, consts: [[1, "table-container"], [4, "ngIf"], ["class", "no-result-message-container", 4, "ngIf"], ["class", "table-spinner", 4, "ngIf"], [1, "table-container-paginate"], ["class", "float-right", 3, "hidden", 4, "ngIf"], [1, "no-result-message-container"], [1, "font-weight-300", "text-grey", "table-spinner"], [1, "table-spinner"], ["aria-hidden", "true", 1, "fas", "fa-spinner", "fa-spin", "fa-3x", "fa-fw"], [1, "pull-left", 3, "perPageChange", "totalItems", "pageSize", "pageSizes"], [1, "float-right", 3, "hidden"], ["aria-label", "Default pagination", 1, "table-pagination", 3, "pageChange", "maxSize", "rotate", "collectionSize", "page", "pageSize"]], template: function ContainerComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c0$C);
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵprojection(1);
            i0.ɵɵtemplate(2, ContainerComponent_ng_container_2_Template, 2, 0, "ng-container", 1)(3, ContainerComponent_div_3_Template, 3, 1, "div", 2)(4, ContainerComponent_div_4_Template, 2, 0, "div", 3);
            i0.ɵɵelementStart(5, "div", 4);
            i0.ɵɵtemplate(6, ContainerComponent_ng_container_6_Template, 2, 3, "ng-container", 1)(7, ContainerComponent_div_7_Template, 2, 6, "div", 5);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.showTable && !ctx.loading);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.shownNoResultMessage());
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.showProgress || ctx.loading);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.loading);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.showPagination() && !ctx.loading);
        } }, dependencies: [i1$2.NgIf, i1$4.NgbPagination, PageSizeComponent], styles: [".table-container[_ngcontent-%COMP%]   .table-container-paginate[_ngcontent-%COMP%]{display:flex;justify-content:space-between;width:100%}.table-container[_ngcontent-%COMP%]   ul.pagination[_ngcontent-%COMP%]{margin:0 0 0 20px}.table-container[_ngcontent-%COMP%]   ul.pagination[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{cursor:pointer}.table-container[_ngcontent-%COMP%]   .pagination-wrapper[_ngcontent-%COMP%]{display:inline-block}.table-container[_ngcontent-%COMP%]   .pagination-info[_ngcontent-%COMP%]{padding:8px 0}.table-container[_ngcontent-%COMP%]   .table-spinner[_ngcontent-%COMP%]{text-align:center;padding:70px 0}.table-container[_ngcontent-%COMP%]   .no-result-message-container[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{font-size:21px}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ContainerComponent, [{
        type: Component,
        args: [{ selector: 'mon-table-container', template: "<div class=\"table-container\">\n    <ng-content select=\"div.table-container-top\"></ng-content>\n    <ng-container *ngIf=\"showTable && !loading\">\n        <ng-content select=\"div.table-container-body\"></ng-content>\n    </ng-container>\n    <div class=\"no-result-message-container\" *ngIf=\"shownNoResultMessage()\">\n        <p class=\"font-weight-300 text-grey table-spinner\">{{ noResultMessage }}</p>\n    </div>\n    <div *ngIf=\"showProgress || loading\" class=\"table-spinner\">\n        <span class=\"fas fa-spinner fa-spin fa-3x fa-fw\" aria-hidden=\"true\"></span>\n    </div>\n    <div class=\"table-container-paginate\">\n        <ng-container *ngIf=\"!loading\">\n            <mon-table-page-size\n                    [totalItems]=\"collection.total\"\n                    (perPageChange)=\"pageSizeChange($event)\"\n                    [pageSize]=\"getPageSize()\"\n                    [pageSizes]=\"pageSizes\"\n                    class=\"pull-left\"\n            ></mon-table-page-size>\n        </ng-container>\n        <div class=\"float-right\"\n             *ngIf=\"showPagination() && !loading\"\n             [hidden]=\"disablePagination\">\n            <ngb-pagination\n                    [maxSize]=\"7\"\n                    [rotate]=\"true\"\n                    class=\"table-pagination\"\n                    [collectionSize]=\"collection.total\"\n                    [(page)]=\"collection.currentPage\"\n                    [pageSize]=\"getPageSize()\"\n                    (pageChange)=\"pageChange()\"\n                    aria-label=\"Default pagination\">\n            </ngb-pagination>\n        </div>\n    </div>\n</div>\n", styles: [".table-container .table-container-paginate{display:flex;justify-content:space-between;width:100%}.table-container ul.pagination{margin:0 0 0 20px}.table-container ul.pagination li a{cursor:pointer}.table-container .pagination-wrapper{display:inline-block}.table-container .pagination-info{padding:8px 0}.table-container .table-spinner{text-align:center;padding:70px 0}.table-container .no-result-message-container p{font-size:21px}\n"] }]
    }], () => [{ type: undefined, decorators: [{
                type: Inject,
                args: [TranslateServiceInjectionToken]
            }] }], { disablePagination: [{
            type: Input
        }], collection: [{
            type: Input
        }], pageSizes: [{
            type: Input
        }], pageChangeEvent: [{
            type: Output
        }], perPageChange: [{
            type: Output
        }], progress: [{
            type: Input
        }], noResultMessage: [{
            type: Input
        }], loading: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ContainerComponent, { className: "ContainerComponent" }); })();

const _c0$B = ["*"];
class TableDropdownComponent {
    constructor(translateService) {
        this.translateService = translateService;
    }
    ngOnInit() {
        this.title = this.title || this.translateService.getString('Action');
    }
    onDropMenuClicked() {
        this.dropdown.close();
    }
    static { this.ɵfac = function TableDropdownComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TableDropdownComponent)(i0.ɵɵdirectiveInject(TranslateServiceInjectionToken)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TableDropdownComponent, selectors: [["mon-table-dropdown"]], viewQuery: function TableDropdownComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(NgbDropdown, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dropdown = _t.first);
        } }, inputs: { title: "title" }, ngContentSelectors: _c0$B, decls: 6, vars: 1, consts: [["ngbDropdown", "", 1, "d-inline-block"], ["ngbDropdownToggle", "", 1, "btn", "btn-default", "btn-secondary"], [1, "fas", "fa-chevron-down"], ["ngbDropdownMenu", "", "role", "menu", 3, "click"]], template: function TableDropdownComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0)(1, "button", 1);
            i0.ɵɵtext(2);
            i0.ɵɵelement(3, "span", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "ul", 3);
            i0.ɵɵlistener("click", function TableDropdownComponent_Template_ul_click_4_listener() { return ctx.onDropMenuClicked(); });
            i0.ɵɵprojection(5);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.title, " ");
        } }, dependencies: [i1$4.NgbDropdown, i1$4.NgbDropdownToggle, i1$4.NgbDropdownMenu], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TableDropdownComponent, [{
        type: Component,
        args: [{ selector: 'mon-table-dropdown', template: "<div ngbDropdown class=\"d-inline-block\">\n\n    <button class=\"btn btn-default btn-secondary\" ngbDropdownToggle>\n        {{ title }}\n        <span class=\"fas fa-chevron-down\"></span>\n    </button>\n\n    <ul ngbDropdownMenu role=\"menu\" (click)=\"onDropMenuClicked()\">\n        <ng-content></ng-content>\n    </ul>\n</div>\n" }]
    }], () => [{ type: undefined, decorators: [{
                type: Inject,
                args: [TranslateServiceInjectionToken]
            }] }], { title: [{
            type: Input
        }], dropdown: [{
            type: ViewChild,
            args: [NgbDropdown]
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(TableDropdownComponent, { className: "TableDropdownComponent" }); })();

class UidService {
    static generateUid() {
        // eslint-disable-next-line no-bitwise
        const S4 = () => (((1 + Math.random()) * 0x10000) | 0)
            .toString(16)
            .substring(1);
        return (S4() +
            S4() +
            '-' +
            S4() +
            '-' +
            S4() +
            '-' +
            S4() +
            '-' +
            S4() +
            S4() +
            S4());
    }
}

class SearchService {
    /**
     * @desc Fuzzy string matching function. Sample taken from https://gist.github.com/dtjm/3961452
     * @link https://gist.github.com/dtjm/3961452
     * @param needle - String to look for
     * @param haystack - String to match
     * @return Boolean
     */
    fuzzy(needle, haystack) {
        if (needle === '' || haystack === '') {
            return true;
        }
        needle = needle.toLowerCase().replace(/ /g, '');
        haystack = haystack.toLowerCase();
        // All characters in needle must be present in haystack
        let j = 0; // haystack position
        for (const character of needle) {
            // Go down the haystack until we find the current needle character
            while (character !== haystack[j]) {
                j++;
                // If we reached the end of the haystack, then this is not a match
                if (j === haystack.length) {
                    return false;
                }
            }
        }
        // At this point, we have matched every single letter in the needle without returning false
        return true;
    }
    static { this.ɵfac = function SearchService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SearchService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SearchService, factory: SearchService.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SearchService, [{
        type: Injectable
    }], null, null); })();

class FilterByStringPipe {
    constructor(searchService) {
        this.searchService = searchService;
    }
    transform(value, term) {
        const indexedFilters = value.map((item, index) => ({ ...item, index }));
        if (!term) {
            return indexedFilters;
        }
        return indexedFilters.filter((item) => {
            const filterName = item.name;
            if (filterName) {
                return this.searchService.fuzzy(term, filterName);
            }
        });
    }
    static { this.ɵfac = function FilterByStringPipe_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FilterByStringPipe)(i0.ɵɵdirectiveInject(SearchService, 16)); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "filterByString", type: FilterByStringPipe, pure: true }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FilterByStringPipe, [{
        type: Pipe,
        args: [{
                name: 'filterByString',
            }]
    }], () => [{ type: SearchService }], null); })();

const _c0$A = ["categoriesDropdown"];
const _c1$h = ["filtersDropdown"];
const _c2$b = ["filtersDropdownButton"];
const _c3$6 = ["filterButtons"];
const _c4$2 = ["categoryButtons"];
const _c5$1 = ["*"];
const _c6$1 = a0 => ({ "selected": a0 });
const _c7 = a0 => ({ filterName: a0 });
const _c8 = a0 => ({ currentFilterCategory: a0 });
const _c9 = a0 => ({ "background": a0 });
function FiltersDropdownComponent_ul_4_li_5_div_9_div_15_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵlistener("click", function FiltersDropdownComponent_ul_4_li_5_div_9_div_15_Template_div_click_0_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r2 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r2.preventPropagationForCloseFiltersListButton($event)); })("keydown", function FiltersDropdownComponent_ul_4_li_5_div_9_div_15_Template_div_keydown_0_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r2 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r2.preventPropagationForCloseFiltersListButton($event)); });
    i0.ɵɵelement(1, "mon-icon", 16);
    i0.ɵɵelementStart(2, "input", 23);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵtwoWayListener("ngModelChange", function FiltersDropdownComponent_ul_4_li_5_div_9_div_15_Template_input_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r2 = i0.ɵɵnextContext(4); i0.ɵɵtwoWayBindingSet(ctx_r2.searchString, $event) || (ctx_r2.searchString = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("monIconDirect", "faSearch");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(3, 3, "Search"));
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.searchString);
} }
function FiltersDropdownComponent_ul_4_li_5_div_9_div_17_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 31);
} }
function FiltersDropdownComponent_ul_4_li_5_div_9_div_17_mon_icon_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mon-icon", 16);
} if (rf & 2) {
    i0.ɵɵproperty("monIconDirect", "faCheck");
} }
function FiltersDropdownComponent_ul_4_li_5_div_9_div_17_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 32);
} if (rf & 2) {
    const filter_r10 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵstyleMap(i0.ɵɵpureFunction1(2, _c9, filter_r10.color));
} }
function FiltersDropdownComponent_ul_4_li_5_div_9_div_17_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 24, 4);
    i0.ɵɵlistener("click", function FiltersDropdownComponent_ul_4_li_5_div_9_div_17_Template_div_click_0_listener($event) { const filter_r10 = i0.ɵɵrestoreView(_r9).$implicit; const ctx_r2 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r2.onClickByFilter(filter_r10.value, $event)); })("focus", function FiltersDropdownComponent_ul_4_li_5_div_9_div_17_Template_div_focus_0_listener() { const filterIndex_r11 = i0.ɵɵrestoreView(_r9).index; const ctx_r2 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r2.focusedFilter = filterIndex_r11); })("keydown", function FiltersDropdownComponent_ul_4_li_5_div_9_div_17_Template_div_keydown_0_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r2 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r2.handlePressKeyOnFilter($event)); });
    i0.ɵɵelementStart(2, "div");
    i0.ɵɵtemplate(3, FiltersDropdownComponent_ul_4_li_5_div_9_div_17_div_3_Template, 1, 0, "div", 25);
    i0.ɵɵelementStart(4, "span", 26);
    i0.ɵɵtemplate(5, FiltersDropdownComponent_ul_4_li_5_div_9_div_17_mon_icon_5_Template, 1, 1, "mon-icon", 27);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 28);
    i0.ɵɵtemplate(7, FiltersDropdownComponent_ul_4_li_5_div_9_div_17_div_7_Template, 1, 4, "div", 29);
    i0.ɵɵelementStart(8, "span", 30);
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵpipe(11, "capitalize");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const filter_r10 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵattribute("aria-selected", ctx_r2.filters[ctx_r2.currentFilterCategory.value][filter_r10.index].active ? true : false);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r2.filters[ctx_r2.currentFilterCategory.value][filter_r10.index].active);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.filters[ctx_r2.currentFilterCategory.value][filter_r10.index].active);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", filter_r10.color);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(11, 9, i0.ɵɵpipeBind3(10, 5, "[[filterName]]", "", i0.ɵɵpureFunction1(11, _c7, filter_r10.name))));
} }
function FiltersDropdownComponent_ul_4_li_5_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14, 3)(2, "div", 15)(3, "div");
    i0.ɵɵelement(4, "mon-icon", 16);
    i0.ɵɵelementStart(5, "span");
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "span", 17);
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵpipe(11, "capitalize");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "button", 18);
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵlistener("click", function FiltersDropdownComponent_ul_4_li_5_div_9_Template_button_click_12_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r2 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r2.closeFilterCategory($event)); })("keydown", function FiltersDropdownComponent_ul_4_li_5_div_9_Template_button_keydown_12_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r2 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r2.preventPropagationForCloseFiltersListButton($event)); });
    i0.ɵɵelement(14, "mon-icon", 16);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(15, FiltersDropdownComponent_ul_4_li_5_div_9_div_15_Template, 4, 5, "div", 19);
    i0.ɵɵelementStart(16, "div", 20);
    i0.ɵɵtemplate(17, FiltersDropdownComponent_ul_4_li_5_div_9_div_17_Template, 12, 13, "div", 21);
    i0.ɵɵpipe(18, "filterByString");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("id", ctx_r2.filtersLabelId);
    i0.ɵɵadvance();
    i0.ɵɵproperty("monIconDirect", "faFilter");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("\u00A0", i0.ɵɵpipeBind1(7, 9, "Filter by:"), "\u00A0");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(11, 15, i0.ɵɵpipeBind3(10, 11, "[[currentFilterCategory]]", "", i0.ɵɵpureFunction1(22, _c8, ctx_r2.currentFilterCategory.value))));
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(13, 17, "Close submenu"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("monIconDirect", "faTimes");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.model[ctx_r2.currentFilterCategory.value].length >= 5);
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-labelledby", ctx_r2.filtersLabelId);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind2(18, 19, ctx_r2.model[ctx_r2.currentFilterCategory.value], ctx_r2.searchString));
} }
function FiltersDropdownComponent_ul_4_li_5_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 10)(1, "button", 11, 2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵlistener("keydown", function FiltersDropdownComponent_ul_4_li_5_Template_button_keydown_1_listener($event) { const filterCategory_r5 = i0.ɵɵrestoreView(_r4).$implicit; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.handlePressArrowOnCategory(filterCategory_r5.key, $event)); })("focus", function FiltersDropdownComponent_ul_4_li_5_Template_button_focus_1_listener() { const categoryIndex_r6 = i0.ɵɵrestoreView(_r4).index; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.focusedCategory = categoryIndex_r6); })("click", function FiltersDropdownComponent_ul_4_li_5_Template_button_click_1_listener($event) { const filterCategory_r5 = i0.ɵɵrestoreView(_r4).$implicit; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.onClickByCategory(filterCategory_r5.key, $event)); });
    i0.ɵɵelementStart(4, "div", 12)(5, "span");
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵpipe(8, "capitalize");
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(9, FiltersDropdownComponent_ul_4_li_5_div_9_Template, 19, 24, "div", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const filterCategory_r5 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵclassMap(i0.ɵɵpureFunction1(14, _c6$1, filterCategory_r5.key === ctx_r2.currentFilterCategory.value));
    i0.ɵɵattribute("aria-description", i0.ɵɵpipeBind1(3, 6, "Open submenu with filters"))("aria-expanded", filterCategory_r5.key === ctx_r2.currentFilterCategory.value);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 12, i0.ɵɵpipeBind3(7, 8, "[[filterName]]", "", i0.ɵɵpureFunction1(16, _c7, filterCategory_r5.key))));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r2.currentFilterCategory.value === filterCategory_r5.key);
} }
function FiltersDropdownComponent_ul_4_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ul", 7, 1);
    i0.ɵɵlistener("clickOutside", function FiltersDropdownComponent_ul_4_Template_ul_clickOutside_0_listener() { i0.ɵɵrestoreView(_r2); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.close()); });
    i0.ɵɵelementStart(2, "li", 8);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, FiltersDropdownComponent_ul_4_li_5_Template, 10, 18, "li", 9);
    i0.ɵɵpipe(6, "keyvalue");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("delayClickOutsideInit", true)("@openClose", ctx_r2.animationState);
    i0.ɵɵattribute("aria-labelledby", ctx_r2.selectFiltersLabelId);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("id", ctx_r2.selectFiltersLabelId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 6, "Select filters"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(6, 8, ctx_r2.model));
} }
class FiltersDropdownComponent {
    constructor() {
        this.position = {
            right: true,
            bottom: true,
        };
        this.filtersChange = new EventEmitter();
        this.showChange = new EventEmitter();
        this.currentFilterCategory = new BehaviorSubject(null);
        this.searchString = '';
        this.focusedCategory = 0;
        this.focusedFilter = 0;
        this.selectFiltersLabelId = `select-filters-label-${UidService.generateUid()}`;
        this.filtersLabelId = `filters-label-${UidService.generateUid()}`;
        this.animationState = 'close';
        this.dropdownOpened = false;
    }
    closeByEsc($event) {
        if ($event.key === 'Escape' && this.show) {
            $event.preventDefault();
            this.close();
        }
    }
    ngOnInit() {
        this.currentFilterCategory.subscribe(() => {
            this.focusedFilter = 0;
            this.searchString = '';
        });
    }
    ngOnDestroy() {
        this.currentFilterCategory.unsubscribe();
    }
    ngOnChanges(changes) {
        if (changes.filters && changes.filters.currentValue && !changes.filters.previousValue) {
            this.model = JSON.parse(JSON.stringify(changes.filters.currentValue));
        }
        if (changes.show?.currentValue && !changes.show?.previousValue) {
            // It is necessary for the correct opening animation to be triggered when the component is initially opened
            this.dropdownOpened = true;
            this.elementForReturningFocus = document.activeElement;
            setTimeout(() => {
                this.categoryButtons.first?.nativeElement.focus();
                this.focusedCategory = 0;
                this.animationState = 'open';
            });
        }
        if (!changes.show?.currentValue && changes.show?.previousValue) {
            this.animationState = 'close';
            // delay for closing animation
            setTimeout(() => {
                this.dropdownOpened = false;
                this.elementForReturningFocus.focus();
            }, 150);
        }
    }
    ngAfterViewChecked() {
        const { right: bodyRight, bottom: bodyBottom, } = document.body.getBoundingClientRect();
        const SCROLLBAR_WIDTH = 15;
        this.bindDropdownToTheButton();
        if (this.categoriesDropdown) {
            const { x: categoriesX, y: categoriesY, width: categoriesWidth, height: categoriesHeight } = this.categoriesDropdown.nativeElement.getBoundingClientRect();
            const rightPoint = categoriesX + categoriesWidth;
            if (rightPoint > bodyRight) {
                this.categoriesDropdown.nativeElement.style.left = `${bodyRight - rightPoint - SCROLLBAR_WIDTH}px`;
            }
            const bottomPoint = categoriesY + categoriesHeight;
            if (bottomPoint > bodyBottom) {
                this.categoriesDropdown.nativeElement.style.top = `${bodyBottom - bottomPoint - SCROLLBAR_WIDTH}px`;
            }
            if (categoriesX < 0) {
                this.categoriesDropdown.nativeElement.style.left = `${-categoriesX}px`;
            }
        }
        if (this.filtersDropdown) {
            const { x: filtersX, y: filtersY, width: filtersWidth, height: filtersHeight } = this.filtersDropdown.nativeElement.getBoundingClientRect();
            const rightPoint = filtersX + filtersWidth;
            if (rightPoint > bodyRight) {
                this.categoriesDropdown.nativeElement.style.left = `${bodyRight - rightPoint - SCROLLBAR_WIDTH}px`;
            }
            const bottomPoint = filtersY + filtersHeight;
            if (bottomPoint > bodyBottom) {
                this.filtersDropdown.nativeElement.style.top = `${bodyBottom - bottomPoint - SCROLLBAR_WIDTH}px`;
            }
        }
    }
    handlePressArrowOnCategory(filterCategory, event) {
        switch (event.key) {
            case 'ArrowUp':
                event.preventDefault();
                this.handlePressUpForCategory();
                break;
            case 'ArrowDown':
                event.preventDefault();
                this.handlePressDownForCategory();
                break;
            case 'ArrowRight':
                event.preventDefault();
                this.handlePressRightForCategory(filterCategory);
                break;
            case 'ArrowLeft':
                event.preventDefault();
                this.handlePressLeftForCategory();
                break;
            case 'Enter':
            case ' ':
                event.stopPropagation();
                event.preventDefault();
                if (this.currentFilterCategory.value) {
                    this.handlePressLeftForCategory();
                }
                else {
                    this.handlePressRightForCategory(filterCategory);
                }
        }
    }
    handlePressKeyOnFilter(event) {
        switch (event.key) {
            case 'ArrowUp':
                event.preventDefault();
                this.handlePressUpForFilter();
                break;
            case 'ArrowDown':
                event.preventDefault();
                this.handlePressDownForFilter();
                break;
            case 'ArrowLeft':
                event.preventDefault();
                this.handlePressLeftForFilter();
                break;
            case 'Enter':
            case ' ':
                const filterValue = this.filters[this.currentFilterCategory.value][this.focusedFilter].value;
                this.onClickByFilter(filterValue, event);
                break;
        }
    }
    onClickByCategory(filterCategory, event) {
        event.stopPropagation();
        if (this.currentFilterCategory.value === filterCategory) {
            this.closeFilterCategory(event);
        }
        else {
            this.openFilterCategory(filterCategory);
        }
    }
    onClickByFilter(filterValue, event) {
        event.stopPropagation();
        this.filters[this.currentFilterCategory.value] = this.filters[this.currentFilterCategory.value].map((filter) => {
            if (filter.value === filterValue) {
                return {
                    ...filter,
                    active: !filter.active,
                };
            }
            return filter;
        });
        this.filtersChange.emit(this.filters);
    }
    closeFilterCategory(event) {
        event.stopPropagation();
        this.currentFilterCategory.next(null);
        this.findAndFocusCategory();
    }
    handlePressButton($event) {
        this.closeByEsc($event);
        this.openBySpaceOrEnter($event);
    }
    preventPropagationForCloseFiltersListButton(event) {
        if (event instanceof KeyboardEvent && event.key === 'Escape') {
            return;
        }
        event.stopPropagation();
    }
    openBySpaceOrEnter($event) {
        $event.stopPropagation();
        if ($event.key === 'Enter' || $event.key === ' ') {
            $event.preventDefault();
            this.toggleShow();
        }
    }
    close() {
        this.show = false;
        this.currentFilterCategory.next(null);
        this.showChange.emit(this.show);
    }
    toggleShow() {
        this.show = !this.show;
        this.showChange.emit(this.show);
    }
    bindDropdownToTheButton() {
        const dropdownOnTheScreen = this.categoriesDropdown && this.filtersDropdownButton;
        if (!dropdownOnTheScreen) {
            return;
        }
        if (this.position.top) {
            this.categoriesDropdown.nativeElement.style.top = '0px';
        }
        if (this.position.bottom) {
            this.categoriesDropdown.nativeElement.style.top =
                `${this.filtersDropdownButton.nativeElement.getBoundingClientRect().height}px`;
        }
        if (this.position.left) {
            this.categoriesDropdown.nativeElement.style.left = '0px';
        }
        if (this.position.right) {
            this.categoriesDropdown.nativeElement.style.left =
                `${this.filtersDropdownButton.nativeElement.getBoundingClientRect().width}px`;
        }
    }
    openFilterCategory(filterCategory) {
        this.currentFilterCategory.next(filterCategory);
        // we have to wait for filters to be rendered
        setTimeout(() => {
            this.findAndFocusFilter();
        });
    }
    findAndFocusCategory() {
        this.categoryButtons.get(this.focusedCategory).nativeElement.focus();
    }
    findAndFocusFilter() {
        this.filterButtons.get(this.focusedFilter).nativeElement.focus();
    }
    handlePressUpForCategory() {
        if (this.focusedCategory === 0) {
            return;
        }
        this.focusedCategory = this.focusedCategory - 1;
        this.findAndFocusCategory();
    }
    handlePressDownForCategory() {
        if (this.focusedCategory === this.categoryButtons.length - 1) {
            return;
        }
        this.focusedCategory = this.focusedCategory + 1;
        this.findAndFocusCategory();
    }
    handlePressRightForCategory(filterCategory) {
        this.openFilterCategory(filterCategory);
    }
    handlePressLeftForCategory() {
        this.currentFilterCategory.next(null);
    }
    handlePressUpForFilter() {
        if (this.focusedFilter === 0) {
            return;
        }
        this.focusedFilter = this.focusedFilter - 1;
        this.findAndFocusFilter();
    }
    handlePressDownForFilter() {
        if (this.focusedFilter === this.filterButtons.length - 1) {
            return;
        }
        this.focusedFilter = this.focusedFilter + 1;
        this.findAndFocusFilter();
    }
    handlePressLeftForFilter() {
        this.currentFilterCategory.next(null);
        this.findAndFocusCategory();
    }
    static { this.ɵfac = function FiltersDropdownComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FiltersDropdownComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FiltersDropdownComponent, selectors: [["mon-filters-dropdown"]], viewQuery: function FiltersDropdownComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$A, 5);
            i0.ɵɵviewQuery(_c1$h, 5);
            i0.ɵɵviewQuery(_c2$b, 5);
            i0.ɵɵviewQuery(_c3$6, 5);
            i0.ɵɵviewQuery(_c4$2, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.categoriesDropdown = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.filtersDropdown = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.filtersDropdownButton = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.filterButtons = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.categoryButtons = _t);
        } }, hostBindings: function FiltersDropdownComponent_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("keydown", function FiltersDropdownComponent_keydown_HostBindingHandler($event) { return ctx.closeByEsc($event); }, false, i0.ɵɵresolveDocument);
        } }, inputs: { filters: "filters", show: "show", position: "position" }, outputs: { filtersChange: "filtersChange", showChange: "showChange" }, features: [i0.ɵɵNgOnChangesFeature], ngContentSelectors: _c5$1, decls: 5, vars: 5, consts: [["filtersDropdownButton", ""], ["categoriesDropdown", ""], ["categoryButtons", ""], ["filtersDropdown", ""], ["filterButtons", ""], ["role", "button", "tabindex", "0", 1, "filters-dropdown-container", 3, "keydown", "click"], ["role", "menu", "class", "dropdown list-of-filter-categories", 3, "delayClickOutsideInit", "clickOutside", 4, "ngIf"], ["role", "menu", 1, "dropdown", "list-of-filter-categories", 3, "clickOutside", "delayClickOutsideInit"], [1, "dropdown-field", "list-of-filter-categories-label"], ["class", "dropdown-field", 4, "ngFor", "ngForOf"], [1, "dropdown-field"], ["type", "button", "role", "menuitem", 1, "category", 3, "keydown", "focus", "click"], [1, "category-name-with-mark"], ["class", "dropdown list-of-filters-container", 4, "ngIf"], [1, "dropdown", "list-of-filters-container"], [1, "dropdown-field", "list-of-filters-label"], [3, "monIconDirect"], [1, "category-name"], ["type", "button", 1, "close-icon", 3, "click", "keydown"], ["class", "dropdown-field search-box", 3, "click", "keydown", 4, "ngIf"], ["role", "listbox", 1, "list-of-filters"], ["tabindex", "0", "class", "dropdown-field filter", "role", "option", 3, "click", "focus", "keydown", 4, "ngFor", "ngForOf"], [1, "dropdown-field", "search-box", 3, "click", "keydown"], ["type", "search", 3, "ngModelChange", "ngModel", "placeholder"], ["tabindex", "0", "role", "option", 1, "dropdown-field", "filter", 3, "click", "focus", "keydown"], ["aria-hidden", "true", "class", "filler", 4, "ngIf"], ["aria-hidden", "true", 1, "icon-check-container"], [3, "monIconDirect", 4, "ngIf"], [1, "filter-name-container"], ["aria-hidden", "true", "class", "color-box", 3, "style", 4, "ngIf"], [1, "filter-name"], ["aria-hidden", "true", 1, "filler"], ["aria-hidden", "true", 1, "color-box"]], template: function FiltersDropdownComponent_Template(rf, ctx) { if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 5, 0);
            i0.ɵɵpipe(2, "translate");
            i0.ɵɵlistener("keydown", function FiltersDropdownComponent_Template_div_keydown_0_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.handlePressButton($event)); })("click", function FiltersDropdownComponent_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.toggleShow()); });
            i0.ɵɵprojection(3);
            i0.ɵɵtemplate(4, FiltersDropdownComponent_ul_4_Template, 7, 10, "ul", 6);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵattribute("aria-expanded", ctx.show)("aria-label", i0.ɵɵpipeBind1(2, 3, "Open dropdown with filters"));
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngIf", ctx.dropdownOpened);
        } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, IconComponent, i1$5.DefaultValueAccessor, i1$5.NgControlStatus, i1$5.NgModel, i5.NgClickOutsideDirective, i1$2.KeyValuePipe, TranslatePipe, CapitalizePipe, FilterByStringPipe], styles: ["mon-filters-dropdown[_ngcontent-%COMP%]{width:fit-content}.filters-dropdown-container[_ngcontent-%COMP%]{cursor:pointer;position:relative;width:fit-content;display:inline-block;border:none;background:none}.dropdown-field[_ngcontent-%COMP%]{display:flex;align-items:center;position:relative;border:1px solid transparent}.category-name-with-mark[_ngcontent-%COMP%]{display:flex;justify-content:flex-start;gap:10px;align-items:center;height:100%}.category[_ngcontent-%COMP%]{display:flex;position:relative;justify-content:space-between;align-items:center;padding:10px 15px;width:100%;height:100%;background:transparent;border:none}.category[_ngcontent-%COMP%]:last-of-type{border-radius:0 0 3px 3px}.category[_ngcontent-%COMP%]:hover, .category.selected[_ngcontent-%COMP%]{background:#e3e3e3}.list-of-filter-categories[_ngcontent-%COMP%]{list-style:none;position:absolute}.dropdown[_ngcontent-%COMP%]{font-size:12px;line-height:20px;z-index:3;position:absolute;min-width:320px;padding:0;border:1px solid #E6E6E6;border-radius:3px;box-shadow:0 0 6px #00000029;background:#fff;margin:0}.list-of-filter-categories-label[_ngcontent-%COMP%]{padding:10px 15px;border-bottom:1px solid #E6E6E6;cursor:default}.list-of-filters-container[_ngcontent-%COMP%]{position:absolute;left:calc(100% + 1px);top:0}.list-of-filters[_ngcontent-%COMP%]{margin:0;padding:0;overflow-y:auto;max-height:280px}.list-of-filters-label[_ngcontent-%COMP%]{font-size:12px;background:#0074e6;color:#fff;padding:9px 15px;border-radius:3px 3px 0 0;display:flex;align-items:center;justify-content:space-between;cursor:default}.category-name[_ngcontent-%COMP%]{font-weight:700}.close-icon[_ngcontent-%COMP%]{background:transparent;border:none;color:inherit}.filler[_ngcontent-%COMP%]{width:12px;height:12px}.color-box[_ngcontent-%COMP%]{width:15px;height:15px}.filter-name[_ngcontent-%COMP%]{margin-left:10px}.icon-check-container[_ngcontent-%COMP%]{background:#dddddf}.search-box[_ngcontent-%COMP%]{border-bottom:1px solid #E6E6E6;display:flex;align-items:center;padding:0 15px 0 40px;gap:5px;cursor:default;background:#fff}.search-box[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{padding:13px 10px;width:100%;border:none;background-color:#fff;font-size:12px;height:calc(100% - 2px)}.focused[_ngcontent-%COMP%]{box-shadow:0 0 0 2px #4976b9}.filter-name-container[_ngcontent-%COMP%]{display:flex;align-items:center}.filter[_ngcontent-%COMP%]{width:100%;gap:15px;background:transparent;border:none;height:100%;display:flex;align-items:center;justify-content:flex-start;padding:10px 15px}.filter[_ngcontent-%COMP%]:hover{background:#f5fafd}"], data: { animation: [
                trigger('openClose', [
                    state('open', style({
                        opacity: 1,
                        transform: 'translateY(0)',
                    })),
                    state('close', style({
                        opacity: 0,
                        transform: 'translateY(-20px)',
                    })),
                    transition('open => close', [
                        animate('100ms'),
                    ]),
                    transition('close => open', [
                        animate('100ms'),
                    ]),
                ]),
            ] } }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FiltersDropdownComponent, [{
        type: Component,
        args: [{ selector: 'mon-filters-dropdown', animations: [
                    trigger('openClose', [
                        state('open', style({
                            opacity: 1,
                            transform: 'translateY(0)',
                        })),
                        state('close', style({
                            opacity: 0,
                            transform: 'translateY(-20px)',
                        })),
                        transition('open => close', [
                            animate('100ms'),
                        ]),
                        transition('close => open', [
                            animate('100ms'),
                        ]),
                    ]),
                ], template: "<div role=\"button\"\n     #filtersDropdownButton\n     [attr.aria-expanded]=\"show\"\n     [attr.aria-label]=\"'Open dropdown with filters' | translate\"\n     tabindex=\"0\"\n     class=\"filters-dropdown-container\"\n     (keydown)=\"handlePressButton($event)\"\n     (click)=\"toggleShow()\"\n>\n    <ng-content></ng-content>\n    <ul\n        #categoriesDropdown\n        (clickOutside)=\"close()\"\n        [delayClickOutsideInit]=\"true\"\n        [@openClose]=\"animationState\"\n        role=\"menu\"\n        [attr.aria-labelledby]=\"selectFiltersLabelId\"\n        class=\"dropdown list-of-filter-categories\"\n        *ngIf=\"dropdownOpened\"\n    >\n        <li [attr.id]=\"selectFiltersLabelId\" class=\"dropdown-field list-of-filter-categories-label\">\n            {{'Select filters' | translate}}\n        </li>\n        <li class=\"dropdown-field\" *ngFor=\"let filterCategory of model | keyvalue; let categoryIndex = index\">\n            <button (keydown)=\"handlePressArrowOnCategory(filterCategory.key, $event)\"\n                    #categoryButtons\n                    type=\"button\"\n                    role=\"menuitem\"\n                    class=\"category\"\n                    (focus)=\"focusedCategory = categoryIndex\"\n                    [attr.aria-description]=\"'Open submenu with filters' | translate\"\n                    (click)=\"onClickByCategory(filterCategory.key, $event)\"\n                    [attr.aria-expanded]=\"filterCategory.key === currentFilterCategory.value\"\n                    [class]=\"{'selected': filterCategory.key === currentFilterCategory.value}\"\n            >\n                <div class=\"category-name-with-mark\">\n                    <span>{{'[[filterName]]' | translate:'':{filterName: filterCategory.key} | capitalize}}</span>\n                </div>\n            </button>\n\n            <!-- It's placed here because it gives good navigation from keyboard with TAB -->\n            <div\n                #filtersDropdown\n                class=\"dropdown list-of-filters-container\"\n                *ngIf=\"currentFilterCategory.value === filterCategory.key\"\n            >\n                <div class=\"dropdown-field list-of-filters-label\">\n                    <div [attr.id]=\"filtersLabelId\">\n                        <mon-icon [monIconDirect]=\"'faFilter'\"></mon-icon>\n                        <span>&nbsp;{{'Filter by:' | translate}}&nbsp;</span>\n                        <span class=\"category-name\">{{'[[currentFilterCategory]]' | translate:'':{currentFilterCategory: currentFilterCategory.value} | capitalize}}</span>\n                    </div>\n                    <button [attr.aria-label]=\"'Close submenu' | translate\"\n                            class=\"close-icon\"\n                            (click)=\"closeFilterCategory($event)\"\n                            (keydown)=\"preventPropagationForCloseFiltersListButton($event)\"\n                            type=\"button\"\n                    >\n                        <mon-icon [monIconDirect]=\"'faTimes'\"></mon-icon>\n                    </button>\n                </div>\n                <div class=\"dropdown-field search-box\" *ngIf=\"model[currentFilterCategory.value].length >= 5\" (click)=\"preventPropagationForCloseFiltersListButton($event)\" (keydown)=\"preventPropagationForCloseFiltersListButton($event)\">\n                    <mon-icon [monIconDirect]=\"'faSearch'\"></mon-icon>\n                    <input type=\"search\" [(ngModel)]=\"searchString\" placeholder=\"{{ 'Search' | translate }}\">\n                </div>\n                <div [attr.aria-labelledby]=\"filtersLabelId\" role=\"listbox\" class=\"list-of-filters\">\n                    <div\n                        tabindex=\"0\"\n                        class=\"dropdown-field filter\"\n                        *ngFor=\"let filter of model[currentFilterCategory.value] | filterByString:searchString; let filterIndex = index\"\n                        (click)=\"onClickByFilter(filter.value, $event)\"\n                        [attr.aria-selected]=\"filters[currentFilterCategory.value][filter.index].active ? true : false\"\n                        role=\"option\"\n                        #filterButtons\n                        (focus)=\"focusedFilter = filterIndex\"\n                        (keydown)=\"handlePressKeyOnFilter($event)\"\n                    >\n                        <div>\n                            <div aria-hidden=\"true\" class=\"filler\" *ngIf=\"!filters[currentFilterCategory.value][filter.index].active\"></div>\n                            <span aria-hidden=\"true\" class=\"icon-check-container\">\n                                <mon-icon [monIconDirect]=\"'faCheck'\" *ngIf=\"filters[currentFilterCategory.value][filter.index].active\"></mon-icon>\n                            </span>\n                        </div>\n                        <div class=\"filter-name-container\">\n                            <div aria-hidden=\"true\" class=\"color-box\" *ngIf=\"filter.color\" [style]=\"{'background': filter.color}\"></div>\n                            <span class=\"filter-name\">{{'[[filterName]]' | translate:'':{filterName: filter.name} | capitalize}}</span>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </li>\n    </ul>\n</div>\n", styles: ["mon-filters-dropdown{width:fit-content}.filters-dropdown-container{cursor:pointer;position:relative;width:fit-content;display:inline-block;border:none;background:none}.dropdown-field{display:flex;align-items:center;position:relative;border:1px solid transparent}.category-name-with-mark{display:flex;justify-content:flex-start;gap:10px;align-items:center;height:100%}.category{display:flex;position:relative;justify-content:space-between;align-items:center;padding:10px 15px;width:100%;height:100%;background:transparent;border:none}.category:last-of-type{border-radius:0 0 3px 3px}.category:hover,.category.selected{background:#e3e3e3}.list-of-filter-categories{list-style:none;position:absolute}.dropdown{font-size:12px;line-height:20px;z-index:3;position:absolute;min-width:320px;padding:0;border:1px solid #E6E6E6;border-radius:3px;box-shadow:0 0 6px #00000029;background:#fff;margin:0}.list-of-filter-categories-label{padding:10px 15px;border-bottom:1px solid #E6E6E6;cursor:default}.list-of-filters-container{position:absolute;left:calc(100% + 1px);top:0}.list-of-filters{margin:0;padding:0;overflow-y:auto;max-height:280px}.list-of-filters-label{font-size:12px;background:#0074e6;color:#fff;padding:9px 15px;border-radius:3px 3px 0 0;display:flex;align-items:center;justify-content:space-between;cursor:default}.category-name{font-weight:700}.close-icon{background:transparent;border:none;color:inherit}.filler{width:12px;height:12px}.color-box{width:15px;height:15px}.filter-name{margin-left:10px}.icon-check-container{background:#dddddf}.search-box{border-bottom:1px solid #E6E6E6;display:flex;align-items:center;padding:0 15px 0 40px;gap:5px;cursor:default;background:#fff}.search-box input{padding:13px 10px;width:100%;border:none;background-color:#fff;font-size:12px;height:calc(100% - 2px)}.focused{box-shadow:0 0 0 2px #4976b9}.filter-name-container{display:flex;align-items:center}.filter{width:100%;gap:15px;background:transparent;border:none;height:100%;display:flex;align-items:center;justify-content:flex-start;padding:10px 15px}.filter:hover{background:#f5fafd}\n"] }]
    }], null, { categoriesDropdown: [{
            type: ViewChild,
            args: ['categoriesDropdown']
        }], filtersDropdown: [{
            type: ViewChild,
            args: ['filtersDropdown']
        }], filtersDropdownButton: [{
            type: ViewChild,
            args: ['filtersDropdownButton']
        }], filterButtons: [{
            type: ViewChildren,
            args: ['filterButtons']
        }], categoryButtons: [{
            type: ViewChildren,
            args: ['categoryButtons']
        }], filters: [{
            type: Input
        }], show: [{
            type: Input
        }], position: [{
            type: Input
        }], filtersChange: [{
            type: Output
        }], showChange: [{
            type: Output
        }], closeByEsc: [{
            type: HostListener,
            args: ['document:keydown', ['$event']]
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FiltersDropdownComponent, { className: "FiltersDropdownComponent" }); })();

class FiltersDropdownModule {
    static { this.ɵfac = function FiltersDropdownModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FiltersDropdownModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: FiltersDropdownModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            TranslateModule,
            IconsModule,
            FormsModule,
            PipesModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FiltersDropdownModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    FiltersDropdownComponent,
                    FilterByStringPipe,
                ],
                imports: [
                    CommonModule,
                    TranslateModule,
                    IconsModule,
                    FormsModule,
                    PipesModule,
                    NgClickOutsideDirective,
                ],
                exports: [
                    FiltersDropdownComponent,
                    FilterByStringPipe,
                ],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(FiltersDropdownModule, { declarations: [FiltersDropdownComponent,
        FilterByStringPipe], imports: [CommonModule,
        TranslateModule,
        IconsModule,
        FormsModule,
        PipesModule,
        NgClickOutsideDirective], exports: [FiltersDropdownComponent,
        FilterByStringPipe] }); })();

class FilterActiveFiltersPipe {
    transform(value) {
        return value.filter(item => item.active);
    }
    static { this.ɵfac = function FilterActiveFiltersPipe_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FilterActiveFiltersPipe)(); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "filterActiveFilters", type: FilterActiveFiltersPipe, pure: true }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FilterActiveFiltersPipe, [{
        type: Pipe,
        args: [{
                name: 'filterActiveFilters',
            }]
    }], null, null); })();

const _c0$z = a0 => ({ "background-color": a0 });
function TableFiltersSelectorComponent_div_4_li_2_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 5);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "capitalize");
    i0.ɵɵelementStart(4, "button", 6);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵlistener("click", function TableFiltersSelectorComponent_div_4_li_2_Template_button_click_4_listener($event) { const item_r2 = i0.ɵɵrestoreView(_r1).$implicit; const entry_r3 = i0.ɵɵnextContext().$implicit; const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.toggleFilter($event, entry_r3.key, item_r2)); });
    i0.ɵɵelement(6, "mon-icon", 7);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r2 = ctx.$implicit;
    const entry_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵstyleMap(i0.ɵɵpureFunction1(13, _c0$z, item_r2.color));
    i0.ɵɵattribute("aria-label", entry_r3.key + ":" + item_r2.name);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(3, 9, i0.ɵɵpipeBind1(2, 7, entry_r3.key)), ": ", item_r2.name, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(5, 11, "Close"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("monIconDirect", "faTimesCircle");
} }
function TableFiltersSelectorComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "ul");
    i0.ɵɵtemplate(2, TableFiltersSelectorComponent_div_4_li_2_Template, 7, 15, "li", 4);
    i0.ɵɵpipe(3, "filterActiveFilters");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const entry_r3 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(3, 1, entry_r3.value));
} }
class TableFiltersSelectorComponent {
    constructor() {
        this.filtersChange = new EventEmitter();
    }
    toggleFilter(ev, category, item) {
        ev.stopPropagation();
        if (this.filters[category] === undefined) {
            return;
        }
        this.filter(category, item);
        this.filtersChange.emit(this.filters);
    }
    filter(category, item) {
        this.filters[category] = this.filters[category].map(filterItem => filterItem.value === item.value ? {
            ...filterItem,
            active: false,
        } : filterItem);
    }
    static { this.ɵfac = function TableFiltersSelectorComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TableFiltersSelectorComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TableFiltersSelectorComponent, selectors: [["mon-table-filters-selector"]], inputs: { filters: "filters", show: "show", type: "type" }, outputs: { filtersChange: "filtersChange" }, decls: 6, vars: 6, consts: [[1, "table-filters-selector"], [1, "selected-filters-container"], [1, "input", "clearfix"], [4, "ngFor", "ngForOf"], ["class", "tag-selector", 3, "style", 4, "ngFor", "ngForOf"], [1, "tag-selector"], [3, "click"], [3, "monIconDirect"]], template: function TableFiltersSelectorComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵpipe(2, "translate");
            i0.ɵɵelementStart(3, "div", 2);
            i0.ɵɵtemplate(4, TableFiltersSelectorComponent_div_4_Template, 4, 3, "div", 3);
            i0.ɵɵpipe(5, "keyvalue");
            i0.ɵɵelementEnd()()();
        } if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 2, "Show labels"));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(5, 4, ctx.filters));
        } }, dependencies: [i1$2.NgForOf, IconComponent, i1$2.KeyValuePipe, TranslatePipe, CapitalizePipe, FilterActiveFiltersPipe], styles: ["ul[_ngcontent-%COMP%]{margin:5px 0 0;padding:0}button[_ngcontent-%COMP%]{border:none;background:none;color:#fff;padding:0}.tag-selector[_ngcontent-%COMP%]{display:inline-block;background-color:#4385f5;border-radius:20px;padding:5px 10px;color:#fff!important;margin-left:10px;font-weight:400}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TableFiltersSelectorComponent, [{
        type: Component,
        args: [{ selector: 'mon-table-filters-selector', template: "<div class=\"table-filters-selector\">\n    <div class=\"selected-filters-container\" [attr.aria-label]=\"'Show labels' | translate\">\n        <div class=\"input clearfix\">\n            <div *ngFor=\"let entry of filters | keyvalue\" >\n                <ul>\n                    <li class=\"tag-selector\" *ngFor=\"let item of entry.value | filterActiveFilters\" [style]=\"{'background-color': item.color}\" [attr.aria-label]=\"entry.key + ':' + item.name\">\n                        {{ entry.key | translate | capitalize  }}: {{ item.name }}\n                        <button [attr.aria-label]=\"'Close' | translate\" (click)=\"toggleFilter($event, entry.key, item)\">\n                            <mon-icon [monIconDirect]=\"'faTimesCircle'\"></mon-icon>\n                        </button>\n                    </li>\n                </ul>\n            </div>\n        </div>\n    </div>\n</div>\n", styles: ["ul{margin:5px 0 0;padding:0}button{border:none;background:none;color:#fff;padding:0}.tag-selector{display:inline-block;background-color:#4385f5;border-radius:20px;padding:5px 10px;color:#fff!important;margin-left:10px;font-weight:400}\n"] }]
    }], null, { filters: [{
            type: Input
        }], show: [{
            type: Input
        }], type: [{
            type: Input
        }], filtersChange: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(TableFiltersSelectorComponent, { className: "TableFiltersSelectorComponent" }); })();

class TableFiltersSelectorModule {
    static { this.ɵfac = function TableFiltersSelectorModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TableFiltersSelectorModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: TableFiltersSelectorModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [
            SearchService,
        ], imports: [CommonModule,
            TranslateModule,
            FormsModule,
            IconsModule,
            PipesModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TableFiltersSelectorModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    TranslateModule,
                    FormsModule,
                    IconsModule,
                    PipesModule,
                ],
                exports: [TableFiltersSelectorComponent],
                declarations: [TableFiltersSelectorComponent, FilterActiveFiltersPipe],
                providers: [
                    SearchService,
                ],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(TableFiltersSelectorModule, { declarations: [TableFiltersSelectorComponent, FilterActiveFiltersPipe], imports: [CommonModule,
        TranslateModule,
        FormsModule,
        IconsModule,
        PipesModule], exports: [TableFiltersSelectorComponent] }); })();

function TableFiltersComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "div", 3)(3, "mon-filters-dropdown", 4);
    i0.ɵɵlistener("filtersChange", function TableFiltersComponent_div_0_Template_mon_filters_dropdown_filtersChange_3_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.filtersChange.emit($event)); });
    i0.ɵɵtwoWayListener("showChange", function TableFiltersComponent_div_0_Template_mon_filters_dropdown_showChange_3_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r1.isDropdownOpened, $event) || (ctx_r1.isDropdownOpened = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelement(4, "span", 5);
    i0.ɵɵtext(5, " \u00A0\u00A0 ");
    i0.ɵɵelementStart(6, "span");
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(9, "div", 6)(10, "mon-table-filters-selector", 7);
    i0.ɵɵlistener("filtersChange", function TableFiltersComponent_div_0_Template_mon_table_filters_selector_filtersChange_10_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.filtersChange.emit($event)); });
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(11, "button", 8);
    i0.ɵɵlistener("click", function TableFiltersComponent_div_0_Template_button_click_11_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.clear()); });
    i0.ɵɵelement(12, "mon-icon", 9);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("filters", ctx_r1.filters);
    i0.ɵɵtwoWayProperty("show", ctx_r1.isDropdownOpened);
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-label", ctx_r1.showHideFilterSelector);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 10, "Filter"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("filters", ctx_r1.filters)("type", ctx_r1.type)("show", ctx_r1.open);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngbTooltip", ctx_r1.clearAndCloseFilters);
    i0.ɵɵattribute("aria-label", ctx_r1.clearAndCloseFilters);
    i0.ɵɵadvance();
    i0.ɵɵproperty("monIconDirect", "faTimes");
} }
class TableFiltersComponent {
    constructor(translateService) {
        this.translateService = translateService;
        this.open = false;
        this.filtersChange = new EventEmitter();
        this.openChange = new EventEmitter();
        this.isDropdownOpened = true;
        this.showHideFilterSelector = this.translateService.getString('Show/Hide filter selector');
        this.clearAndCloseFilters = this.translateService.getString('Clear and close filters');
    }
    ngOnChanges(changes) {
        if (!changes.open?.currentValue && changes.open?.previousValue) {
            // we have to display the dropdown every time this component is opened
            this.isDropdownOpened = true;
        }
    }
    clear() {
        Object.keys(this.filters).forEach((key) => {
            this.filters[key] = this.filters[key].map((filter) => ({
                ...filter,
                active: false,
            }));
        });
        this.filtersChange.emit(this.filters);
        this.openChange.emit(false);
    }
    static { this.ɵfac = function TableFiltersComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TableFiltersComponent)(i0.ɵɵdirectiveInject(TranslateServiceInjectionToken)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TableFiltersComponent, selectors: [["mon-table-filters"]], inputs: { filters: "filters", open: "open", type: "type" }, outputs: { filtersChange: "filtersChange", openChange: "openChange" }, features: [i0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["class", "table-filters", 4, "ngIf"], [1, "table-filters"], [1, "left-part-wrapper"], [1, "filter-label"], [3, "filtersChange", "showChange", "filters", "show"], [1, "fas", "fa-filter"], [1, "table-filters-selector-container", "mr-auto"], [3, "filtersChange", "filters", "type", "show"], [1, "table-filters-clear", 3, "click", "ngbTooltip"], [3, "monIconDirect"]], template: function TableFiltersComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, TableFiltersComponent_div_0_Template, 13, 12, "div", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.open);
        } }, dependencies: [i1$2.NgIf, i1$4.NgbTooltip, TableFiltersSelectorComponent, IconComponent, FiltersDropdownComponent, TranslatePipe], styles: [".table-filters[_ngcontent-%COMP%]{padding:0 20px;font-size:12px;min-height:50px;box-sizing:content-box;justify-content:space-between;align-items:center;border-bottom:1px solid #f3f5f7;border-top:1px solid #f3f5f7;display:flex}.table-filters[_ngcontent-%COMP%]   .filter-label[_ngcontent-%COMP%]{padding-right:5px}.table-filters[_ngcontent-%COMP%]   .left-part-wrapper[_ngcontent-%COMP%]{display:flex;align-items:center}.table-filters[_ngcontent-%COMP%]   .selector-input[_ngcontent-%COMP%]{border:none;box-shadow:none!important}.table-filters[_ngcontent-%COMP%] > p[_ngcontent-%COMP%]{margin:0 15px 0 0}.table-filters[_ngcontent-%COMP%]   .table-filters-selector-container[_ngcontent-%COMP%]   .selector-dropdown[_ngcontent-%COMP%]{border-top:1px solid #d4dce3}.table-filters[_ngcontent-%COMP%]   .table-filters-clear[_ngcontent-%COMP%]{cursor:pointer;margin-left:10px;padding:0;border:none;background:none}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TableFiltersComponent, [{
        type: Component,
        args: [{ selector: 'mon-table-filters', template: "<div class=\"table-filters\" *ngIf=\"open\">\n    <div class=\"left-part-wrapper\">\n        <div class=\"filter-label\">\n            <mon-filters-dropdown [filters]=\"filters\" (filtersChange)=\"filtersChange.emit($event)\" [(show)]=\"isDropdownOpened\">\n            <span [attr.aria-label]=\"showHideFilterSelector\" class=\"fas fa-filter\"></span> &nbsp;&nbsp;\n            <span>\n                {{'Filter' | translate}}\n            </span>\n            </mon-filters-dropdown>\n        </div>\n        <div class=\"table-filters-selector-container mr-auto\">\n            <mon-table-filters-selector [filters]=\"filters\"\n                                        (filtersChange)=\"filtersChange.emit($event)\"\n                                        [type]=\"type\"\n                                        [show]=\"open\"\n            >\n            </mon-table-filters-selector>\n        </div>\n    </div>\n    <button (click)=\"clear()\"\n         [attr.aria-label]=\"clearAndCloseFilters\"\n         [ngbTooltip]=\"clearAndCloseFilters\"\n         class=\"table-filters-clear\">\n        <mon-icon [monIconDirect]=\"'faTimes'\"></mon-icon>\n    </button>\n</div>\n", styles: [".table-filters{padding:0 20px;font-size:12px;min-height:50px;box-sizing:content-box;justify-content:space-between;align-items:center;border-bottom:1px solid #f3f5f7;border-top:1px solid #f3f5f7;display:flex}.table-filters .filter-label{padding-right:5px}.table-filters .left-part-wrapper{display:flex;align-items:center}.table-filters .selector-input{border:none;box-shadow:none!important}.table-filters>p{margin:0 15px 0 0}.table-filters .table-filters-selector-container .selector-dropdown{border-top:1px solid #d4dce3}.table-filters .table-filters-clear{cursor:pointer;margin-left:10px;padding:0;border:none;background:none}\n"] }]
    }], () => [{ type: undefined, decorators: [{
                type: Inject,
                args: [TranslateServiceInjectionToken]
            }] }], { filters: [{
            type: Input
        }], open: [{
            type: Input
        }], type: [{
            type: Input
        }], filtersChange: [{
            type: Output
        }], openChange: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(TableFiltersComponent, { className: "TableFiltersComponent" }); })();

class TableFiltersModule {
    static { this.ɵfac = function TableFiltersModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TableFiltersModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: TableFiltersModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            NgbTooltipModule,
            TranslateModule,
            TableFiltersSelectorModule,
            FormsModule,
            IconsModule,
            FiltersDropdownModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TableFiltersModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    NgbTooltipModule,
                    TranslateModule,
                    TableFiltersSelectorModule,
                    FormsModule,
                    IconsModule,
                    FiltersDropdownModule,
                ],
                exports: [TableFiltersComponent],
                declarations: [TableFiltersComponent],
                providers: [],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(TableFiltersModule, { declarations: [TableFiltersComponent], imports: [CommonModule,
        NgbTooltipModule,
        TranslateModule,
        TableFiltersSelectorModule,
        FormsModule,
        IconsModule,
        FiltersDropdownModule], exports: [TableFiltersComponent] }); })();

const _c0$y = ["*"];
const _c1$g = a0 => ({ disabled: a0 });
function ContainerPagerComponent_ng_content_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵprojection(0, 0, ["*ngIf", "!showProgress && showTable"]);
} }
function ContainerPagerComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵelement(1, "span", 10);
    i0.ɵɵelementEnd();
} }
function ContainerPagerComponent_mon_table_page_size_9_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mon-table-page-size", 11);
    i0.ɵɵlistener("perPageChange", function ContainerPagerComponent_mon_table_page_size_9_Template_mon_table_page_size_perPageChange_0_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.perPageChange($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("totalItems", 50)("pageSize", ctx_r1.pageSize);
} }
function ContainerPagerComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "ul", 12)(2, "li", 13)(3, "button", 14);
    i0.ɵɵlistener("click", function ContainerPagerComponent_div_10_Template_button_click_3_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.pageChange(ctx_r1.page - 1)); });
    i0.ɵɵtext(4, " \u00AB ");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "li", 13)(6, "button", 14);
    i0.ɵɵlistener("click", function ContainerPagerComponent_div_10_Template_button_click_6_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.pageChange(ctx_r1.page + 1)); });
    i0.ɵɵtext(7, " \u00BB ");
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c1$g, ctx_r1.noPrevious));
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r1.noPrevious);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c1$g, ctx_r1.noNext));
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r1.noNext);
} }
class ContainerPagerComponent {
    constructor() {
        this.onPageChange = new EventEmitter();
        this.onPerPageChange = new EventEmitter();
        this.noResultMessage = 'No content was found';
        this.pageSize = 10; // TODO: Use constant here instead https://zube.io/monsido/monsido/c/23723
        this.page = 1;
        this.showTable = true;
        this.showProgress = true;
        this.noPrevious = true;
        this.noNext = true;
        this._progress = false;
        this._collection = [];
    }
    get collection() {
        return this._collection;
    }
    set collection(collection) {
        this._collection = collection;
    }
    get progress() {
        return this._progress;
    }
    set progress(progress) {
        this._progress = progress;
        this.isProgressRunning();
    }
    pageChange(page) {
        this.onPageChange.emit(page);
    }
    perPageChange(pageSize) {
        this.onPerPageChange.emit(pageSize);
    }
    isProgressRunning() {
        if (typeof this.progress === 'boolean') {
            this.showProgress = this.progress;
            this.setShowTable();
            return;
        }
        this.showProgress = true;
        this.setShowTable();
        Promise.resolve(this.progress).finally(() => {
            this.showProgress = false;
            this.setShowTable();
        });
    }
    setShowTable() {
        this.showTable =
            !this.showProgress &&
                Array.isArray(this.collection) &&
                this.collection.total > 0;
        this.noPrevious = !Array.isArray(this.collection) || this.page <= 1;
        this.noNext = !Array.isArray(this.collection) || this.collection.length < this.pageSize;
    }
    static { this.ɵfac = function ContainerPagerComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ContainerPagerComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ContainerPagerComponent, selectors: [["mon-table-container-pager"]], inputs: { collection: "collection", progress: "progress", noResultMessage: "noResultMessage", pageSize: "pageSize", page: "page" }, outputs: { onPageChange: "onPageChange", onPerPageChange: "onPerPageChange" }, ngContentSelectors: _c0$y, decls: 11, vars: 6, consts: [[1, "table-container-pager"], [4, "ngIf"], [1, "row", "table-spinner", 3, "hidden"], [1, "col-48", "no-result-message-container"], [1, "font-weight-300", "text-grey"], ["class", "table-spinner", 4, "ngIf"], [1, "table-container-paginate"], [1, "d-flex", "align-items-center", "justify-content-between", "w-100"], ["class", "mr-auto", 3, "totalItems", "pageSize", "perPageChange", 4, "ngIf"], [1, "table-spinner"], ["aria-hidden", "true", 1, "fas", "fa-spinner", "fa-spin", "fa-3x", "fa-fw"], [1, "mr-auto", 3, "perPageChange", "totalItems", "pageSize"], [1, "pagination"], [1, "page-item", 3, "ngClass"], [1, "page-link", 3, "click", "disabled"]], template: function ContainerPagerComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, ContainerPagerComponent_ng_content_1_Template, 1, 0, "ng-content", 1);
            i0.ɵɵelementStart(2, "div", 2)(3, "div", 3)(4, "p", 4);
            i0.ɵɵtext(5);
            i0.ɵɵelementEnd()()();
            i0.ɵɵtemplate(6, ContainerPagerComponent_div_6_Template, 2, 0, "div", 5);
            i0.ɵɵelementStart(7, "div", 6)(8, "div", 7);
            i0.ɵɵtemplate(9, ContainerPagerComponent_mon_table_page_size_9_Template, 1, 2, "mon-table-page-size", 8)(10, ContainerPagerComponent_div_10_Template, 8, 8, "div", 1);
            i0.ɵɵelementEnd()()();
        } if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.showProgress && ctx.showTable);
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.showProgress || ctx.showTable);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.noResultMessage);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.showProgress);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.onPerPageChange.observers.length > 0);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.onPageChange.observers.length > 0);
        } }, dependencies: [i1$2.NgClass, i1$2.NgIf, PageSizeComponent], styles: [".table-container-pager[_ngcontent-%COMP%]{min-height:200px}.table-container-pager[_ngcontent-%COMP%]   .table-container-paginate[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:space-between;width:100%}.table-container-pager[_ngcontent-%COMP%]   .pager[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%], .table-container-pager[_ngcontent-%COMP%]   .pager[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{border-radius:4px}.table-container-pager[_ngcontent-%COMP%]   .table-spinner[_ngcontent-%COMP%]{text-align:center;padding-top:70px;padding-bottom:70px}.table-container-pager[_ngcontent-%COMP%]   .no-result-message-container[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{font-size:21px}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ContainerPagerComponent, [{
        type: Component,
        args: [{ selector: 'mon-table-container-pager', template: "<div class=\"table-container-pager\">\n    <ng-content *ngIf=\"!showProgress && showTable\"></ng-content>\n    <div class=\"row table-spinner\" [hidden]=\"showProgress || showTable\">\n        <div class=\"col-48 no-result-message-container\">\n            <p class=\"font-weight-300 text-grey\">{{ noResultMessage }}</p>\n        </div>\n    </div>\n    <div *ngIf=\"showProgress\" class=\"table-spinner\">\n            <span class=\"fas fa-spinner fa-spin fa-3x fa-fw\" aria-hidden=\"true\"></span>\n        </div>\n    <div class=\"table-container-paginate\">\n        <div class=\"d-flex align-items-center justify-content-between w-100\">\n            <mon-table-page-size\n                *ngIf=\"onPerPageChange.observers.length > 0\"\n                [totalItems]=\"50\"\n                [pageSize]=\"pageSize\"\n                (perPageChange)=\"perPageChange($event)\"\n                class=\"mr-auto\">\n            </mon-table-page-size>\n            <div *ngIf=\"onPageChange.observers.length > 0\">\n                <ul class=\"pagination\">\n                    <li class=\"page-item\" [ngClass]=\"{disabled: noPrevious}\">\n                        <button class=\"page-link\"\n                           (click)=\"pageChange(page - 1)\"\n                           [disabled]=\"noPrevious\">\n                           \u00AB\n                        </button>\n                    </li>\n                    <li class=\"page-item\" [ngClass]=\"{disabled: noNext}\">\n                        <button class=\"page-link\"\n                           (click)=\"pageChange(page + 1)\"\n                           [disabled]=\"noNext\">\n                           \u00BB\n                        </button>\n                    </li>\n                </ul>\n            </div>\n        </div>\n    </div>\n</div>\n", styles: [".table-container-pager{min-height:200px}.table-container-pager .table-container-paginate{display:flex;align-items:center;justify-content:space-between;width:100%}.table-container-pager .pager li>a,.table-container-pager .pager li>span{border-radius:4px}.table-container-pager .table-spinner{text-align:center;padding-top:70px;padding-bottom:70px}.table-container-pager .no-result-message-container p{font-size:21px}\n"] }]
    }], null, { collection: [{
            type: Input
        }], onPageChange: [{
            type: Output
        }], onPerPageChange: [{
            type: Output
        }], progress: [{
            type: Input
        }], noResultMessage: [{
            type: Input
        }], pageSize: [{
            type: Input
        }], page: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ContainerPagerComponent, { className: "ContainerPagerComponent" }); })();

function TableDateComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "span", 2);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 3);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 4);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.month);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.day);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.year);
} }
class TableDateComponent {
    constructor() {
        this.isValid = false;
    }
    set date(date) {
        this.isValid = moment(date).isValid();
        this._date = date;
        if (this._date) {
            const newDate = moment(this._date);
            this.day = newDate.format('DD');
            this.month = newDate.format('MMM').toUpperCase();
            this.year = newDate.format('YYYY');
        }
    }
    get date() {
        return this._date;
    }
    static { this.ɵfac = function TableDateComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TableDateComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TableDateComponent, selectors: [["mon-table-date"]], inputs: { date: "date" }, decls: 1, vars: 1, consts: [["class", "table-date", 4, "ngIf"], [1, "table-date"], [1, "month"], [1, "day"], [1, "year"]], template: function TableDateComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, TableDateComponent_div_0_Template, 7, 3, "div", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.isValid);
        } }, dependencies: [i1$2.NgIf], styles: [".table-date[_ngcontent-%COMP%]{text-align:center;padding-top:2px;font-size:11px}.table-date[_ngcontent-%COMP%]   .month[_ngcontent-%COMP%]{text-transform:uppercase;display:block;font-size:1.1em}.table-date[_ngcontent-%COMP%]   .day[_ngcontent-%COMP%]{font-weight:300;font-size:1.8em;display:block;margin-top:-4px}.table-date[_ngcontent-%COMP%]   .year[_ngcontent-%COMP%]{display:block;margin-top:-4px}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TableDateComponent, [{
        type: Component,
        args: [{ selector: 'mon-table-date', template: "<div *ngIf=\"isValid\" class=\"table-date\">\n    <span class=\"month\">{{ month }}</span>\n    <span class=\"day\">{{ day }}</span>\n    <span class=\"year\">{{ year }}</span>\n</div>\n", styles: [".table-date{text-align:center;padding-top:2px;font-size:11px}.table-date .month{text-transform:uppercase;display:block;font-size:1.1em}.table-date .day{font-weight:300;font-size:1.8em;display:block;margin-top:-4px}.table-date .year{display:block;margin-top:-4px}\n"] }]
    }], null, { date: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(TableDateComponent, { className: "TableDateComponent" }); })();

function TableComplianceComponent_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 5);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleMap(ctx_r0.fullComplianceStyle);
} }
class TableComplianceComponent {
    constructor(translateService) {
        this.translateService = translateService;
        this.colors = ['#4dc0bd', '#dcdcdc'];
        this.options = {
            cutout: '60%',
            maintainAspectRatio: false,
            responsive: false,
            plugins: {
                tooltip: {
                    enabled: false,
                },
            },
        };
    }
    ngOnInit() {
        this.btnWord = this.btnWord || this.translateService.getString('Compliance');
        this.size = this.size || '46';
        this.fullComplianceStyle = 'font-size: ' + (parseInt(this.size, 10) - 3) + 'px';
        this.dataArray = this.dataArray || [];
        this.evaluate();
    }
    evaluate() {
        let num = 0;
        let collectedNumber = 0;
        this.dataArray.forEach((data, index) => {
            if (index === this.indexNumber) {
                num = data;
            }
            collectedNumber += data;
        });
        this.calculatedNumber = this.calculate((num / collectedNumber) * 100 || 0);
        this.doughnutData = [
            this.calculatedNumber,
            100 - this.calculatedNumber,
        ];
        return this.calculatedNumber;
    }
    calculate(num) {
        let multiplied = num * 100;
        multiplied =
            num < 1
                ? Math.ceil(multiplied)
                : num > 99
                    ? Math.floor(multiplied)
                    : Math.round(multiplied);
        return multiplied / 100;
    }
    static { this.ɵfac = function TableComplianceComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TableComplianceComponent)(i0.ɵɵdirectiveInject(TranslateServiceInjectionToken)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TableComplianceComponent, selectors: [["mon-table-compliance"]], inputs: { size: "size", btnWord: "btnWord", dataArray: "dataArray", labels: "labels", indexNumber: "indexNumber" }, decls: 7, vars: 3, consts: [[1, "text-nowrap", "align-middle", "table-compliance"], ["tabindex", "0", 1, "btn", "button-monsido-icon", "nohover", "pt-2", "inner-l-none", "inner-r-small", "text-right", "col-top"], [1, "page-count"], [1, "compliance-text"], ["class", "fas fa-check-circle text-light-green inline-block hidden-print", 3, "style", 4, "ngIf"], [1, "fas", "fa-check-circle", "text-light-green", "inline-block", "hidden-print"]], template: function TableComplianceComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "span", 1)(2, "div", 2);
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "div", 3);
            i0.ɵɵtext(5);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(6, TableComplianceComponent_span_6_Template, 1, 3, "span", 4);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", ctx.calculatedNumber, "% ");
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.btnWord, " ");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.calculatedNumber === 100);
        } }, dependencies: [i1$2.NgIf], styles: [".table-compliance[_ngcontent-%COMP%]   span.btn.button-monsido-icon.nohover[_ngcontent-%COMP%]   .compliance-text[_ngcontent-%COMP%]{font-size:.9em;color:#555557}.table-compliance[_ngcontent-%COMP%]   span.btn.button-monsido-icon.nohover[_ngcontent-%COMP%]:hover{cursor:default;border-color:transparent}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TableComplianceComponent, [{
        type: Component,
        args: [{ selector: 'mon-table-compliance', template: "<div class=\"text-nowrap align-middle table-compliance\">\n    <span class=\"btn button-monsido-icon nohover pt-2 inner-l-none inner-r-small text-right col-top\" tabindex=\"0\">\n        <div class=\"page-count\">\n            {{ calculatedNumber }}%\n        </div>\n        <div class=\"compliance-text\">\n            {{ btnWord }}\n        </div>\n    </span>\n    <!-- <mon-doughnut-chart *ngIf=\"calculatedNumber < 100\"\n                        [data]=\"doughnutData\"\n                        [labels]=\"['']\"\n                        [colors]=\"colors\"\n                        [options]=\"options\"\n                        [height]=\"46\"\n                        [width]=\"46\"\n                        class=\"inline-block\">\n    </mon-doughnut-chart> -->\n    <span class=\"fas fa-check-circle text-light-green inline-block hidden-print\"\n          *ngIf=\"calculatedNumber === 100\"\n          style=\"{{ fullComplianceStyle }}\">\n    </span>\n</div>\n", styles: [".table-compliance span.btn.button-monsido-icon.nohover .compliance-text{font-size:.9em;color:#555557}.table-compliance span.btn.button-monsido-icon.nohover:hover{cursor:default;border-color:transparent}\n"] }]
    }], () => [{ type: undefined, decorators: [{
                type: Inject,
                args: [TranslateServiceInjectionToken]
            }] }], { size: [{
            type: Input
        }], btnWord: [{
            type: Input
        }], dataArray: [{
            type: Input
        }], labels: [{
            type: Input
        }], indexNumber: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(TableComplianceComponent, { className: "TableComplianceComponent" }); })();

class SelectItemComponent {
    constructor(translateService) {
        this.translateService = translateService;
        this.selectedItems = [];
        this.monLabel = this.translateService.getString('Select item');
        this.disable = false;
    }
    hasItem() {
        return this.indexOfItem() > -1;
    }
    toggleItem() {
        const index = this.indexOfItem();
        if (index === -1) {
            this.selectedItems.push(this.item);
        }
        else {
            this.selectedItems.splice(index, 1);
        }
    }
    indexOfItem() {
        const stringified = this.stringify(this.item);
        for (let i = 0; i < this.selectedItems.length; i++) {
            if (this.stringify(this.selectedItems[i]) === stringified) {
                return i;
            }
        }
        return -1;
    }
    stringify(val) {
        return JSON.stringify(val, (key, value) => {
            let newVal = value;
            if (typeof key === 'string' && key.charAt(0) === '$' && key.charAt(1) === '$') {
                // Remove $$ key names
                newVal = undefined;
            }
            return newVal;
        });
    }
    static { this.ɵfac = function SelectItemComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SelectItemComponent)(i0.ɵɵdirectiveInject(TranslateServiceInjectionToken)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SelectItemComponent, selectors: [["mon-table-select-item"]], inputs: { item: "item", selectedItems: "selectedItems", monLabel: "monLabel", disable: "disable" }, decls: 1, vars: 3, consts: [["type", "checkbox", 3, "click", "disabled", "checked"]], template: function SelectItemComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "input", 0);
            i0.ɵɵlistener("click", function SelectItemComponent_Template_input_click_0_listener() { return ctx.toggleItem(); });
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("disabled", ctx.disable)("checked", ctx.hasItem());
            i0.ɵɵattribute("aria-label", ctx.monLabel);
        } }, encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SelectItemComponent, [{
        type: Component,
        args: [{ selector: 'mon-table-select-item', template: "<input [attr.aria-label]=\"monLabel\"\n       [disabled]=\"disable\"\n       [checked]=\"hasItem()\"\n       (click)=\"toggleItem()\"\n       type=\"checkbox\"/>\n" }]
    }], () => [{ type: undefined, decorators: [{
                type: Inject,
                args: [TranslateServiceInjectionToken]
            }] }], { item: [{
            type: Input
        }], selectedItems: [{
            type: Input
        }], monLabel: [{
            type: Input
        }], disable: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(SelectItemComponent, { className: "SelectItemComponent" }); })();

class SelectItemAllComponent {
    constructor(translateService) {
        this.translateService = translateService;
        this.items = [];
        this.selectedItems = [];
        this.monLabel = this.translateService.getString('Select all items');
        this.disable = false;
    }
    haveAllItems() {
        if (this.selectedItems.length !== 0) {
            return true;
        }
        const filteredItems = this.selectedItems.filter((item) => {
            return this.indexOfItem(this.items, item) > -1;
        });
        return filteredItems.length === this.items.length;
    }
    toggleItems() {
        if (!this.haveAllItems()) {
            this.items.forEach((item) => {
                if (this.indexOfItem(this.selectedItems, item) === -1) {
                    this.selectedItems.push(item);
                }
            });
        }
        else {
            this.items.forEach((item) => {
                const index = this.indexOfItem(this.selectedItems, item);
                if (index > -1) {
                    this.selectedItems.splice(index, 1);
                }
            });
        }
    }
    // PROTECTED
    indexOfItem(collection, val) {
        const stringified = this.stringify(val);
        for (let i = 0; i < collection.length; i++) {
            if (this.stringify(collection[i]) === stringified) {
                return i;
            }
        }
        return -1;
    }
    stringify(val) {
        return JSON.stringify(val, (key, value) => {
            let newVal = value;
            if (typeof key === 'string' && key.charAt(0) === '$' && key.charAt(1) === '$') {
                // Remove $$ key names
                newVal = undefined;
            }
            return newVal;
        });
    }
    static { this.ɵfac = function SelectItemAllComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SelectItemAllComponent)(i0.ɵɵdirectiveInject(TranslateServiceInjectionToken)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SelectItemAllComponent, selectors: [["mon-table-select-item-all"]], inputs: { items: "items", selectedItems: "selectedItems", monLabel: "monLabel", disable: "disable" }, decls: 1, vars: 4, consts: [["type", "checkbox", 3, "click", "disabled", "indeterminate", "checked"]], template: function SelectItemAllComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "input", 0);
            i0.ɵɵlistener("click", function SelectItemAllComponent_Template_input_click_0_listener() { return ctx.toggleItems(); });
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("disabled", ctx.disable)("indeterminate", ctx.selectedItems.length > 0 && ctx.selectedItems.length < ctx.items.length)("checked", ctx.haveAllItems());
            i0.ɵɵattribute("aria-label", ctx.monLabel);
        } }, encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SelectItemAllComponent, [{
        type: Component,
        args: [{ selector: 'mon-table-select-item-all', template: "<input [attr.aria-label]=\"monLabel\"\n       [disabled]=\"disable\"\n       type=\"checkbox\"\n       (click)=\"toggleItems()\"\n       [indeterminate]=\"selectedItems.length > 0 && selectedItems.length < items.length\"\n       [checked]=\"haveAllItems()\" />\n" }]
    }], () => [{ type: undefined, decorators: [{
                type: Inject,
                args: [TranslateServiceInjectionToken]
            }] }], { items: [{
            type: Input
        }], selectedItems: [{
            type: Input
        }], monLabel: [{
            type: Input
        }], disable: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(SelectItemAllComponent, { className: "SelectItemAllComponent" }); })();

class TableModule {
    static { this.ɵfac = function TableModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TableModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: TableModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [TableSearchModule,
            CommonModule,
            TranslateModule,
            NgbDropdownModule,
            NgbPaginationModule,
            NgbModule,
            FormsModule,
            NgbTooltipModule,
            TableFiltersModule,
            FiltersDropdownModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TableModule, [{
        type: NgModule,
        args: [{
                imports: [
                    TableSearchModule,
                    CommonModule,
                    TranslateModule,
                    NgbDropdownModule,
                    NgbPaginationModule,
                    NgbModule,
                    FormsModule,
                    NgbTooltipModule,
                    TableFiltersModule,
                    FiltersDropdownModule,
                ],
                exports: [
                    ContainerComponent,
                    TableDropdownComponent,
                    PageSizeComponent,
                    TableDateComponent,
                    ContainerPagerComponent,
                    TableComplianceComponent,
                    SelectItemComponent,
                    SelectItemAllComponent,
                ],
                declarations: [
                    ContainerComponent,
                    TableDropdownComponent,
                    PageSizeComponent,
                    ContainerPagerComponent,
                    TableDateComponent,
                    TableComplianceComponent,
                    SelectItemComponent,
                    SelectItemAllComponent,
                ],
                providers: [],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(TableModule, { declarations: [ContainerComponent,
        TableDropdownComponent,
        PageSizeComponent,
        ContainerPagerComponent,
        TableDateComponent,
        TableComplianceComponent,
        SelectItemComponent,
        SelectItemAllComponent], imports: [TableSearchModule,
        CommonModule,
        TranslateModule,
        NgbDropdownModule,
        NgbPaginationModule,
        NgbModule,
        FormsModule,
        NgbTooltipModule,
        TableFiltersModule,
        FiltersDropdownModule], exports: [ContainerComponent,
        TableDropdownComponent,
        PageSizeComponent,
        TableDateComponent,
        ContainerPagerComponent,
        TableComplianceComponent,
        SelectItemComponent,
        SelectItemAllComponent] }); })();

class ToastModule {
    static { this.ɵfac = function ToastModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ToastModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ToastModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [ToastrModule.forRoot(), BrowserAnimationsModule, CommonModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ToastModule, [{
        type: NgModule,
        args: [{
                imports: [ToastrModule.forRoot(), BrowserAnimationsModule, CommonModule],
                exports: [],
                declarations: [],
                providers: [],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ToastModule, { imports: [i1$3.ToastrModule, BrowserAnimationsModule, CommonModule] }); })();

const _c0$x = ["*"];
const _c1$f = a0 => ({ "mb-3": a0 });
const _c2$a = a0 => ({ "active": a0 });
const _c3$5 = a0 => ({ "inner-t-smurf": a0 });
const _c4$1 = a0 => [a0, "icon", "mr-1"];
function TabsComponent_li_3_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 14);
} if (rf & 2) {
    const option_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c4$1, option_r2.faIcon));
} }
function TabsComponent_li_3_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 15);
} if (rf & 2) {
    const option_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngbTooltip", option_r2.tooltip);
} }
function TabsComponent_li_3_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 9);
    i0.ɵɵpipe(1, "lowercase");
    i0.ɵɵelementStart(2, "a", 10);
    i0.ɵɵlistener("click", function TabsComponent_li_3_Template_a_click_2_listener($event) { const option_r2 = i0.ɵɵrestoreView(_r1).$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.callback(option_r2.value, $event)); });
    i0.ɵɵelementStart(3, "span", 11);
    i0.ɵɵtemplate(4, TabsComponent_li_3_span_4_Template, 1, 3, "span", 12);
    i0.ɵɵtext(5);
    i0.ɵɵtemplate(6, TabsComponent_li_3_span_6_Template, 1, 1, "span", 13);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const option_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c2$a, ctx_r2.status === option_r2.value));
    i0.ɵɵattribute("data-test", i0.ɵɵpipeBind1(1, 6, "tab-" + option_r2.name));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c3$5, !option_r2.faIcon));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", option_r2.faIcon);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", option_r2.name, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", option_r2.tooltip);
} }
function TabsComponent_li_4_li_5_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 21);
} if (rf & 2) {
    const moreOption_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵclassMap(moreOption_r5.faIcon);
} }
function TabsComponent_li_4_li_5_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 9)(1, "a", 10);
    i0.ɵɵlistener("click", function TabsComponent_li_4_li_5_Template_a_click_1_listener($event) { const moreOption_r5 = i0.ɵɵrestoreView(_r4).$implicit; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.callback(moreOption_r5.value, $event)); });
    i0.ɵɵtemplate(2, TabsComponent_li_4_li_5_span_2_Template, 1, 2, "span", 20);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const moreOption_r5 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c2$a, ctx_r2.status === moreOption_r5.value));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", moreOption_r5.faIcon);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", moreOption_r5.name, "");
} }
function TabsComponent_li_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 16)(1, "a", 17);
    i0.ɵɵelement(2, "span", 18);
    i0.ɵɵtext(3, "...");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "ul", 19);
    i0.ɵɵtemplate(5, TabsComponent_li_4_li_5_Template, 4, 5, "li", 3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c2$a, ctx_r2.moreActive));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngForOf", ctx_r2.moreOptions);
} }
function TabsComponent_mon_table_search_9_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mon-table-search", 22);
    i0.ɵɵlistener("getPage", function TabsComponent_mon_table_search_9_Template_mon_table_search_getPage_0_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.changeSearch($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("model", ctx_r2.search)("minSearchLength", ctx_r2.minSearchLength);
} }
class TabsComponent {
    constructor() {
        this.showSearch = false;
        this.showFiltersBtn = false;
        this.isFiltersOpen = false;
        this.options = [];
        this.maxOptionsDisplay = 4;
        this.onStatus = new EventEmitter();
        this.onSearch = new EventEmitter();
        this.moreOptions = [];
        this.moreActive = false;
    }
    ngOnChanges(changes) {
        if (changes?.options?.currentValue?.length > this.maxOptionsDisplay) {
            this.moreOptions = changes.options.currentValue.splice(this.maxOptionsDisplay);
            this.options = changes.options.currentValue.splice(0, this.maxOptionsDisplay);
        }
    }
    callback(tab, event) {
        event.preventDefault();
        if (this.status !== tab) {
            this.status = tab;
            this.moreActive = false;
            this.moreActive = !!this.moreOptions.find((option) => option.value === this.status);
        }
        this.onStatus.emit(this.status);
    }
    changeSearch(search) {
        this.search = search;
        this.onSearch.emit(search);
    }
    tabsCount() {
        return (this.options && Object.keys(this.options).length) || 0;
    }
    static { this.ɵfac = function TabsComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TabsComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TabsComponent, selectors: [["mon-tabs"]], inputs: { status: "status", showSearch: "showSearch", showFiltersBtn: "showFiltersBtn", isFiltersOpen: "isFiltersOpen", search: "search", options: "options", maxOptionsDisplay: "maxOptionsDisplay", minSearchLength: "minSearchLength" }, outputs: { onStatus: "onStatus", onSearch: "onSearch" }, features: [i0.ɵɵNgOnChangesFeature], ngContentSelectors: _c0$x, decls: 10, vars: 8, consts: [[1, "d-flex", 3, "ngClass"], [1, "mr-auto"], [1, "nav", "nav-tabs", "table-nav-tabs", "inner-t-smurf"], ["class", "cursor-pointer", 3, "ngClass", 4, "ngFor", "ngForOf"], ["class", "cursor-pointer", "ngbDropdown", "", "id", "tabs-dropdown", 3, "ngClass", 4, "ngIf"], [1, "d-none", "d-md-block", "tab-right-section"], [1, "align-items-center", "justify-content-end"], [3, "showFiltersBtn", "isFiltersOpen"], ["class", "flex-grow-1", 3, "model", "minSearchLength", "getPage", 4, "ngIf"], [1, "cursor-pointer", 3, "ngClass"], ["href", "", 3, "click"], [1, "inline-block", 3, "ngClass"], [3, "ngClass", 4, "ngIf"], ["placement", "bottom", "class", "fas fa-question-circle", 3, "ngbTooltip", 4, "ngIf"], [3, "ngClass"], ["placement", "bottom", 1, "fas", "fa-question-circle", 3, "ngbTooltip"], ["ngbDropdown", "", "id", "tabs-dropdown", 1, "cursor-pointer", 3, "ngClass"], ["href", "javascript:void(0)", "ngbDropdownToggle", ""], [1, "fas", "font-size-1-5", "fa-caret-down"], ["ngbDropdownMenu", "", "aria-labelledby", "tabs-dropdown", 1, "dropdown-menu"], ["class", "icon mr-1", 3, "class", 4, "ngIf"], [1, "icon", "mr-1"], [1, "flex-grow-1", 3, "getPage", "model", "minSearchLength"]], template: function TabsComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "ul", 2);
            i0.ɵɵtemplate(3, TabsComponent_li_3_Template, 7, 12, "li", 3)(4, TabsComponent_li_4_Template, 6, 4, "li", 4);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(5, "div", 5)(6, "div", 6);
            i0.ɵɵprojection(7);
            i0.ɵɵelement(8, "mon-filter-button", 7);
            i0.ɵɵtemplate(9, TabsComponent_mon_table_search_9_Template, 1, 2, "mon-table-search", 8);
            i0.ɵɵelementEnd()()();
        } if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c1$f, ctx.tabsCount() === 0 && ctx.showSearch));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngForOf", ctx.options);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.moreOptions.length > 0);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("showFiltersBtn", ctx.showFiltersBtn)("isFiltersOpen", ctx.isFiltersOpen);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.showSearch);
        } }, dependencies: [i1$4.NgbTooltip, i1$4.NgbDropdown, i1$4.NgbDropdownToggle, i1$4.NgbDropdownMenu, i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, TableSearchComponent, FilterButtonComponent, i1$2.LowerCasePipe], styles: [".nav.nav-tabs.table-nav-tabs[_ngcontent-%COMP%]{border-bottom:none}.nav.nav-tabs.table-nav-tabs[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]{cursor:pointer}.nav.nav-tabs.table-nav-tabs[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]:hover{background-color:#e6e6e6}.nav.nav-tabs.table-nav-tabs[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]:hover   a[_ngcontent-%COMP%]{color:#1c86db}.nav.nav-tabs.table-nav-tabs[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{padding:1px 2px 3px;line-height:1.2em;border-width:0;border-bottom-width:2px;border-radius:0;margin:10px 14px}.nav.nav-tabs.table-nav-tabs[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{font-size:1.5em;padding-right:10px}.nav.nav-tabs.table-nav-tabs[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover{background-color:inherit;border-bottom-color:transparent}.nav.nav-tabs.table-nav-tabs[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:focus-visible{outline:none;box-shadow:0 0 0 2px #4976b9}.nav.nav-tabs.table-nav-tabs[_ngcontent-%COMP%] > li.active[_ngcontent-%COMP%]{padding:0}.nav.nav-tabs.table-nav-tabs[_ngcontent-%COMP%] > li.active[_ngcontent-%COMP%] > a[_ngcontent-%COMP%], .nav.nav-tabs.table-nav-tabs[_ngcontent-%COMP%] > li.active[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover, .nav.nav-tabs.table-nav-tabs[_ngcontent-%COMP%] > li.active[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:focus{border-width:0;border-bottom-width:2px;border-color:#299bf7;border-style:solid;color:#299bf7;cursor:pointer;background-color:transparent}.nav.nav-tabs.table-nav-tabs[_ngcontent-%COMP%]   .open[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{background-color:transparent;border-bottom-width:2px;border-color:transparent}.nav.nav-tabs.table-nav-tabs[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%] > .active[_ngcontent-%COMP%] > a[_ngcontent-%COMP%], .nav.nav-tabs.table-nav-tabs[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%] > .active[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover, .nav.nav-tabs.table-nav-tabs[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%] > .active[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:focus{color:#f3f5f7}.nav.nav-tabs.table-nav-tabs[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:focus-visible{outline:none;box-shadow:0 0 0 2px #4976b9}.filters-button[_ngcontent-%COMP%]{font-size:1.5em;display:flex;align-items:center;margin-right:10px;padding:0 .75em;cursor:pointer}.filters-button[_ngcontent-%COMP%]:hover, .filters-button[_ngcontent-%COMP%]:focus, .filters-button[_ngcontent-%COMP%]:active{text-decoration:none}.tab-right-section[_ngcontent-%COMP%]   mon-table-search[_ngcontent-%COMP%]   .form-group[_ngcontent-%COMP%]{margin-bottom:0}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TabsComponent, [{
        type: Component,
        args: [{ selector: 'mon-tabs', template: "<div class=\"d-flex\" [ngClass]=\"{ 'mb-3': tabsCount() === 0 && showSearch}\">\n    <div class=\"mr-auto\">\n        <ul class=\"nav nav-tabs table-nav-tabs inner-t-smurf\">\n            <li class=\"cursor-pointer\" *ngFor=\"let option of options\" [ngClass]=\"{'active': status === option.value}\" [attr.data-test]=\"'tab-'+option.name | lowercase\">\n                <a href=\"\" (click)=\"callback(option.value, $event)\">\n                    <span class=\"inline-block\" [ngClass]=\"{'inner-t-smurf': !option.faIcon}\">\n                        <span *ngIf=\"option.faIcon\" [ngClass]=\"[option.faIcon, 'icon', 'mr-1']\"></span>\n                        {{ option.name }}\n                        <span [ngbTooltip]=\"option.tooltip\" placement=\"bottom\" class=\"fas fa-question-circle\" *ngIf=\"option.tooltip\"></span>\n                    </span>\n                </a>\n            </li>\n\n            <li class=\"cursor-pointer\" ngbDropdown id=\"tabs-dropdown\" *ngIf=\"moreOptions.length > 0\" [ngClass]=\"{'active': moreActive}\">\n                <a href=\"javascript:void(0)\" ngbDropdownToggle><span class=\"fas font-size-1-5 fa-caret-down\"></span>...</a>\n                <ul class=\"dropdown-menu\" ngbDropdownMenu aria-labelledby=\"tabs-dropdown\">\n                    <li class=\"cursor-pointer\" *ngFor=\"let moreOption of moreOptions\" [ngClass]=\"{'active': status === moreOption.value}\">\n                        <a href=\"\" (click)=\"callback(moreOption.value, $event)\"><span *ngIf=\"moreOption.faIcon\" [class]=\"moreOption.faIcon\" class=\"icon mr-1\"></span> {{ moreOption.name }}</a>\n                    </li>\n                </ul>\n            </li>\n        </ul>\n    </div>\n    <div class=\"d-none d-md-block tab-right-section\">\n        <div class=\"align-items-center justify-content-end\">\n            <ng-content></ng-content>\n            <mon-filter-button\n                [showFiltersBtn]=\"showFiltersBtn\"\n                [isFiltersOpen]=\"isFiltersOpen\">\n            </mon-filter-button>\n            <mon-table-search\n                class=\"flex-grow-1\"\n                *ngIf=\"showSearch\"\n                (getPage)=\"changeSearch($event)\"\n                [model]=\"search\"\n                [minSearchLength]=\"minSearchLength\">\n            </mon-table-search>\n        </div>\n    </div>\n</div>\n", styles: [".nav.nav-tabs.table-nav-tabs{border-bottom:none}.nav.nav-tabs.table-nav-tabs>li{cursor:pointer}.nav.nav-tabs.table-nav-tabs>li:hover{background-color:#e6e6e6}.nav.nav-tabs.table-nav-tabs>li:hover a{color:#1c86db}.nav.nav-tabs.table-nav-tabs>li>a{padding:1px 2px 3px;line-height:1.2em;border-width:0;border-bottom-width:2px;border-radius:0;margin:10px 14px}.nav.nav-tabs.table-nav-tabs>li>a .icon{font-size:1.5em;padding-right:10px}.nav.nav-tabs.table-nav-tabs>li>a:hover{background-color:inherit;border-bottom-color:transparent}.nav.nav-tabs.table-nav-tabs>li>a:focus-visible{outline:none;box-shadow:0 0 0 2px #4976b9}.nav.nav-tabs.table-nav-tabs>li.active{padding:0}.nav.nav-tabs.table-nav-tabs>li.active>a,.nav.nav-tabs.table-nav-tabs>li.active>a:hover,.nav.nav-tabs.table-nav-tabs>li.active>a:focus{border-width:0;border-bottom-width:2px;border-color:#299bf7;border-style:solid;color:#299bf7;cursor:pointer;background-color:transparent}.nav.nav-tabs.table-nav-tabs .open>a{background-color:transparent;border-bottom-width:2px;border-color:transparent}.nav.nav-tabs.table-nav-tabs .dropdown-menu>.active>a,.nav.nav-tabs.table-nav-tabs .dropdown-menu>.active>a:hover,.nav.nav-tabs.table-nav-tabs .dropdown-menu>.active>a:focus{color:#f3f5f7}.nav.nav-tabs.table-nav-tabs .dropdown-menu a:focus-visible{outline:none;box-shadow:0 0 0 2px #4976b9}.filters-button{font-size:1.5em;display:flex;align-items:center;margin-right:10px;padding:0 .75em;cursor:pointer}.filters-button:hover,.filters-button:focus,.filters-button:active{text-decoration:none}.tab-right-section mon-table-search .form-group{margin-bottom:0}\n"] }]
    }], null, { status: [{
            type: Input
        }], showSearch: [{
            type: Input
        }], showFiltersBtn: [{
            type: Input
        }], isFiltersOpen: [{
            type: Input
        }], search: [{
            type: Input
        }], options: [{
            type: Input
        }], maxOptionsDisplay: [{
            type: Input
        }], minSearchLength: [{
            type: Input
        }], onStatus: [{
            type: Output
        }], onSearch: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(TabsComponent, { className: "TabsComponent" }); })();

class TabsModule {
    static { this.ɵfac = function TabsModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TabsModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: TabsModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [NgbTooltipModule,
            NgbDropdownModule,
            CommonModule,
            TableSearchModule,
            FilterButtonModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TabsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    NgbTooltipModule,
                    NgbDropdownModule,
                    CommonModule,
                    TableSearchModule,
                    FilterButtonModule,
                ],
                exports: [TabsComponent],
                declarations: [TabsComponent],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(TabsModule, { declarations: [TabsComponent], imports: [NgbTooltipModule,
        NgbDropdownModule,
        CommonModule,
        TableSearchModule,
        FilterButtonModule], exports: [TabsComponent] }); })();

class DialogModule {
    static { this.ɵfac = function DialogModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DialogModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: DialogModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [DialogService], imports: [CommonModule,
            TranslateModule,
            BrowserAnimationsModule,
            A11yModule,
            FormsModule,
            ReactiveFormsModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DialogModule, [{
        type: NgModule,
        args: [{
                declarations: [FormStyledDialogComponent, DialogComponent, BackdropComponent],
                imports: [
                    CommonModule,
                    TranslateModule,
                    BrowserAnimationsModule,
                    A11yModule,
                    FormsModule,
                    ReactiveFormsModule,
                ],
                providers: [DialogService],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(DialogModule, { declarations: [FormStyledDialogComponent, DialogComponent, BackdropComponent], imports: [CommonModule,
        TranslateModule,
        BrowserAnimationsModule,
        A11yModule,
        FormsModule,
        ReactiveFormsModule] }); })();

class ConfirmDirective {
    constructor(monPromptService) {
        this.monPromptService = monPromptService;
        this.monConfirmAction = new EventEmitter();
    }
    async go(event) {
        event.preventDefault();
        return this.monPromptService.confirm(this.monConfirm, this.monPromptOptions)
            .then(() => this.monConfirmAction.emit())
            .catch(() => { });
    }
    static { this.ɵfac = function ConfirmDirective_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ConfirmDirective)(i0.ɵɵdirectiveInject(MonPromptService)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: ConfirmDirective, selectors: [["", "monConfirm", ""]], hostBindings: function ConfirmDirective_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("click", function ConfirmDirective_click_HostBindingHandler($event) { return ctx.go($event); });
        } }, inputs: { monConfirm: "monConfirm", monPromptOptions: "monPromptOptions" }, outputs: { monConfirmAction: "monConfirmAction" } }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConfirmDirective, [{
        type: Directive,
        args: [{ selector: '[monConfirm]' }]
    }], () => [{ type: MonPromptService }], { monConfirm: [{
            type: Input
        }], monPromptOptions: [{
            type: Input
        }], monConfirmAction: [{
            type: Output
        }], go: [{
            type: HostListener,
            args: ['click', ['$event']]
        }] }); })();

class ConfirmModule {
    static { this.ɵfac = function ConfirmModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ConfirmModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ConfirmModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({}); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConfirmModule, [{
        type: NgModule,
        args: [{
                imports: [],
                exports: [ConfirmDirective],
                declarations: [ConfirmDirective],
                providers: [],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ConfirmModule, { declarations: [ConfirmDirective], exports: [ConfirmDirective] }); })();

function MonSimpleDateRangeComponent_span_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.startDateError);
} }
function MonSimpleDateRangeComponent_span_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.endDateError);
} }
class MonSimpleDateRangeComponent {
    get model() {
        return this.modelValue;
    }
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    set model(val) {
        this.modelValue = val;
        this.startDate = (val.startDate) ? val.startDate.format(this.dateFormat) : null;
        this.endDate = (val.endDate) ? val.endDate.format(this.dateFormat) : null;
    }
    constructor(translateService, announcer) {
        this.translateService = translateService;
        this.announcer = announcer;
        this.notValidDateText = this.translateService.getString('Please enter a valid date!');
        this.notValidRangeText = this.translateService.getString('The end date cannot be before the start date');
        this.rangeUpdate = new EventEmitter();
        this.range = {
            startDate: null,
            endDate: null,
        };
        this.dateFormat = 'DD-MM-YYYY';
        this.startDateError = '';
        this.endDateError = '';
        this.modelValue = { startDate: null, endDate: null };
        this.componentId = UidService.generateUid();
        this.announceStartDateError = false;
        this.announceEndDateError = false;
    }
    ngOnInit() {
        this.startDate = this.modelValue.startDate?.format(this.dateFormat) || null;
        this.endDate = this.modelValue.endDate?.format(this.dateFormat) || null;
        this.validateDates();
    }
    onChange(event) {
        const input = event.target;
        const isDelete = event.inputType === 'deleteContentBackward';
        let newValue = input.value;
        let start = input.selectionStart;
        let end = input.selectionEnd;
        const [prevDay, prevMonth, prevYear] = newValue.split('-');
        let newDay = '';
        let newMonth = '';
        let newYear = '';
        newDay = prevDay;
        if (newDay?.length > 2) {
            newMonth = newDay.substring(2);
            newDay = newDay.substring(0, 2);
        }
        if (prevMonth?.length > 0) {
            newMonth += prevMonth;
        }
        if (newMonth?.length > 2) {
            newYear += newMonth.substring(2);
            newMonth = newMonth.substring(0, 2);
        }
        if (prevYear?.length > 0) {
            newYear += prevYear;
        }
        newValue = newDay;
        if (newMonth || newYear) {
            newValue += '-';
            newValue += newMonth;
        }
        if (newYear) {
            newValue += '-';
            newValue += newYear;
        }
        if (start === 3 && !isDelete) {
            start++;
            end++;
        }
        if (start === 6 && !isDelete) {
            start++;
            end++;
        }
        input.value = newValue;
        input.selectionStart = start;
        input.selectionEnd = end;
    }
    onBlur(event, type) {
        const value = event.target.value;
        const parsedDate = this.dateFromString(value);
        if (type === 'startdate') {
            this.model.startDate = parsedDate;
        }
        if (type === 'enddate') {
            this.model.endDate = parsedDate;
        }
        this.validateDates();
    }
    validateDates() {
        let isValid = this.checkRangeValidity();
        const startDateError = this.modelValue.startDate?.isValid &&
            this.validateStartDateCb &&
            this.validateStartDateCb(this.modelValue.startDate);
        const endDateError = this.modelValue.endDate?.isValid && this.validateEndDateCb && this.validateEndDateCb(this.modelValue.endDate);
        if (startDateError || endDateError) {
            isValid = false;
        }
        this.setErrorMessages(startDateError, endDateError);
        this.setDateRange(isValid);
    }
    setErrorMessages(startDateError, endDateError) {
        this.announceStartDateError = false;
        this.announceEndDateError = false;
        if (!this.modelValue) {
            return;
        }
        if ((this.startDate !== null && this.startDate !== '') && !this.modelValue.startDate?.isValid) {
            this.startDateError = this.notValidDateText;
        }
        else if (startDateError) {
            this.startDateError = startDateError;
        }
        else {
            this.startDateError = '';
        }
        if ((this.endDate !== null && this.endDate !== '') && !this.modelValue.endDate?.isValid) {
            this.endDateError = this.notValidDateText;
        }
        else if (endDateError) {
            this.endDateError = endDateError;
        }
        else {
            this.endDateError = '';
        }
        if (this.modelValue.startDate && this.modelValue.endDate && !this.checkRangeValidity()) {
            if (this.endDateError) {
                this.endDateError = `${this.endDateError}\r\n${this.notValidRangeText}`;
            }
            else {
                this.endDateError = this.notValidRangeText;
            }
        }
        setTimeout(() => {
            this.announceStartDateError = true;
            this.announceEndDateError = true;
        });
    }
    setDateRange(valid) {
        if (valid) {
            this.range.startDate = this.modelValue.startDate;
            this.range.endDate = this.modelValue.endDate;
        }
        else {
            this.range.startDate = null;
            this.range.endDate = null;
        }
        this.rangeUpdate.emit(this.range);
    }
    dateFromString(value) {
        if (moment(value, this.dateFormat, true).isValid()) {
            return moment(value, this.dateFormat);
        }
        else {
            return null;
        }
    }
    checkRangeValidity() {
        if (!this.modelValue?.startDate || !this.modelValue?.endDate) {
            return false;
        }
        if (this.modelValue.endDate.diff(this.modelValue.startDate, 'days') >= 0) {
            return true;
        }
        return false;
    }
    static { this.ɵfac = function MonSimpleDateRangeComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MonSimpleDateRangeComponent)(i0.ɵɵdirectiveInject(TranslateServiceInjectionToken), i0.ɵɵdirectiveInject(i3.LiveAnnouncer)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MonSimpleDateRangeComponent, selectors: [["mon-simple-date-range"]], inputs: { model: "model", notValidDateText: "notValidDateText", notValidRangeText: "notValidRangeText", validateStartDateCb: "validateStartDateCb", validateEndDateCb: "validateEndDateCb" }, outputs: { rangeUpdate: "rangeUpdate" }, decls: 21, vars: 18, consts: [[1, "date-range-container"], [1, "date-range-row"], [1, "date-range-date"], ["translate", "", 1, "date-range-label"], ["type", "text", "autocomplete", "off", 1, "date-range-input", 3, "ngModelChange", "blur", "input", "ngModel", "placeholder"], [1, "sr-only"], [1, "date-range-error"], ["aria-live", "polite", "aria-atomic", "true", 1, "sr-only"], [4, "ngIf"]], template: function MonSimpleDateRangeComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "label", 3);
            i0.ɵɵtext(4, "Start date ");
            i0.ɵɵelementStart(5, "input", 4);
            i0.ɵɵtwoWayListener("ngModelChange", function MonSimpleDateRangeComponent_Template_input_ngModelChange_5_listener($event) { i0.ɵɵtwoWayBindingSet(ctx.startDate, $event) || (ctx.startDate = $event); return $event; });
            i0.ɵɵlistener("blur", function MonSimpleDateRangeComponent_Template_input_blur_5_listener($event) { return ctx.onBlur($event, "startdate"); })("input", function MonSimpleDateRangeComponent_Template_input_input_5_listener($event) { return ctx.onChange($event); });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(6, "span", 5);
            i0.ɵɵtext(7);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "span", 6);
            i0.ɵɵtext(9);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(10, "div", 2)(11, "label", 3);
            i0.ɵɵtext(12, "End date ");
            i0.ɵɵelementStart(13, "input", 4);
            i0.ɵɵtwoWayListener("ngModelChange", function MonSimpleDateRangeComponent_Template_input_ngModelChange_13_listener($event) { i0.ɵɵtwoWayBindingSet(ctx.endDate, $event) || (ctx.endDate = $event); return $event; });
            i0.ɵɵlistener("blur", function MonSimpleDateRangeComponent_Template_input_blur_13_listener($event) { return ctx.onBlur($event, "enddate"); })("input", function MonSimpleDateRangeComponent_Template_input_input_13_listener($event) { return ctx.onChange($event); });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(14, "span", 5);
            i0.ɵɵtext(15);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(16, "span", 6);
            i0.ɵɵtext(17);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(18, "div", 7);
            i0.ɵɵtemplate(19, MonSimpleDateRangeComponent_span_19_Template, 2, 1, "span", 8)(20, MonSimpleDateRangeComponent_span_20_Template, 2, 1, "span", 8);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵadvance(5);
            i0.ɵɵtwoWayProperty("ngModel", ctx.startDate);
            i0.ɵɵproperty("placeholder", ctx.dateFormat);
            i0.ɵɵattribute("aria-describedby", "date-range-description-startdate-" + ctx.componentId + " date-range-startdate-error-" + ctx.componentId)("aria-invalid", !!ctx.startDateError);
            i0.ɵɵadvance();
            i0.ɵɵattribute("id", "date-range-description-startdate-" + ctx.componentId);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1("(date format: ", ctx.dateFormat, ")");
            i0.ɵɵadvance();
            i0.ɵɵattribute("id", "date-range-startdate-error-" + ctx.componentId);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.startDateError ? ctx.startDateError : "\u00A0");
            i0.ɵɵadvance(4);
            i0.ɵɵtwoWayProperty("ngModel", ctx.endDate);
            i0.ɵɵproperty("placeholder", ctx.dateFormat);
            i0.ɵɵattribute("aria-describedby", "date-range-description-enddate-" + ctx.componentId + " date-range-enddate-error-" + ctx.componentId)("aria-invalid", !!ctx.endDateError);
            i0.ɵɵadvance();
            i0.ɵɵattribute("id", "date-range-description-enddate-" + ctx.componentId);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1("(date format: ", ctx.dateFormat, ")");
            i0.ɵɵadvance();
            i0.ɵɵattribute("id", "date-range-enddate-error-" + ctx.componentId);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.endDateError ? ctx.endDateError : "\u00A0");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.startDateError && ctx.announceStartDateError);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.endDateError && ctx.announceEndDateError);
        } }, dependencies: [i1$2.NgIf, i1$5.DefaultValueAccessor, i1$5.NgControlStatus, i1$5.NgModel], styles: [".date-range-container[_ngcontent-%COMP%]   .date-range-row[_ngcontent-%COMP%]{display:flex}.date-range-container[_ngcontent-%COMP%]   .date-range-date[_ngcontent-%COMP%]{margin-right:20px}.date-range-container[_ngcontent-%COMP%]   .date-range-input[_ngcontent-%COMP%], .date-range-container[_ngcontent-%COMP%]   .date-range-label[_ngcontent-%COMP%]{display:block}.date-range-container[_ngcontent-%COMP%]   .date-range-error[_ngcontent-%COMP%]{color:#d43f3a;white-space:pre}.date-range-container[_ngcontent-%COMP%]   .date-range-input[_ngcontent-%COMP%]{width:180px;border-top:none;border-left:none;border-right:none;border-radius:0;line-height:1em;border-bottom:1px solid #E6E6E6}.date-range-container[_ngcontent-%COMP%]   .date-range-input[_ngcontent-%COMP%]   [_ngcontent-%COMP%]::placeholder{color:#9a9d9e;opacity:1}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MonSimpleDateRangeComponent, [{
        type: Component,
        args: [{ selector: 'mon-simple-date-range', template: "<div class=\"date-range-container\">\n    <div class=\"date-range-row\">\n        <div class=\"date-range-date\">\n            <label class=\"date-range-label\" translate>Start date\n                <input type=\"text\"\n                       [(ngModel)]=\"startDate\"\n                       (blur)=\"onBlur($event, 'startdate')\"\n                       (input)=\"onChange($event)\"\n                       class=\"date-range-input\"\n                       [placeholder]=\"dateFormat\"\n                       autocomplete=\"off\"\n                       [attr.aria-describedby]=\"'date-range-description-startdate-' + componentId + ' date-range-startdate-error-' + componentId\"\n                       [attr.aria-invalid]=\"!!startDateError\"\n                />\n            </label>\n            <span class=\"sr-only\" [attr.id]=\"'date-range-description-startdate-' + componentId\">(date format: {{ dateFormat }})</span>\n            <span [attr.id]=\"'date-range-startdate-error-' + componentId\" class=\"date-range-error\">{{ startDateError? startDateError : '&nbsp;' }}</span>\n        </div>\n        <div class=\"date-range-date\">\n            <label class=\"date-range-label\" translate>End date\n                <input type=\"text\"\n                       [(ngModel)]=\"endDate\"\n                       (blur)=\"onBlur($event, 'enddate')\"\n                       (input)=\"onChange($event)\"\n                       class=\"date-range-input\"\n                       [placeholder]=\"dateFormat\"\n                       autocomplete=\"off\"\n                       [attr.aria-describedby]=\"'date-range-description-enddate-' + componentId + ' date-range-enddate-error-' + componentId\"\n                       [attr.aria-invalid]=\"!!endDateError\"\n                />\n            </label>\n            <span class=\"sr-only\" [attr.id]=\"'date-range-description-enddate-' + componentId\">(date format: {{ dateFormat }})</span>\n            <span [attr.id]=\"'date-range-enddate-error-' + componentId\" class=\"date-range-error\">{{ endDateError ? endDateError : '&nbsp;' }}</span>\n        </div>\n    </div>\n    <div class=\"sr-only\" aria-live=\"polite\" aria-atomic=\"true\">\n        <span *ngIf=\"startDateError && announceStartDateError\">{{ startDateError }}</span>\n        <span *ngIf=\"endDateError && announceEndDateError\">{{ endDateError }}</span>\n    </div>    \n</div>\n", styles: [".date-range-container .date-range-row{display:flex}.date-range-container .date-range-date{margin-right:20px}.date-range-container .date-range-input,.date-range-container .date-range-label{display:block}.date-range-container .date-range-error{color:#d43f3a;white-space:pre}.date-range-container .date-range-input{width:180px;border-top:none;border-left:none;border-right:none;border-radius:0;line-height:1em;border-bottom:1px solid #E6E6E6}.date-range-container .date-range-input ::placeholder{color:#9a9d9e;opacity:1}\n"] }]
    }], () => [{ type: undefined, decorators: [{
                type: Inject,
                args: [TranslateServiceInjectionToken]
            }] }, { type: i3.LiveAnnouncer }], { model: [{
            type: Input
        }], notValidDateText: [{
            type: Input
        }], notValidRangeText: [{
            type: Input
        }], validateStartDateCb: [{
            type: Input
        }], validateEndDateCb: [{
            type: Input
        }], rangeUpdate: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(MonSimpleDateRangeComponent, { className: "MonSimpleDateRangeComponent" }); })();

class MonSimpleDateRangeModule {
    static { this.ɵfac = function MonSimpleDateRangeModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MonSimpleDateRangeModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: MonSimpleDateRangeModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, FormsModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MonSimpleDateRangeModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, FormsModule],
                exports: [MonSimpleDateRangeComponent],
                declarations: [MonSimpleDateRangeComponent],
                providers: [],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(MonSimpleDateRangeModule, { declarations: [MonSimpleDateRangeComponent], imports: [CommonModule, FormsModule], exports: [MonSimpleDateRangeComponent] }); })();

class DaterangepickerConfig {
    constructor() {
        this.settings = new Map();
    }
    static { this.ɵfac = function DaterangepickerConfig_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DaterangepickerConfig)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: DaterangepickerConfig, factory: DaterangepickerConfig.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DaterangepickerConfig, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], () => [], null); })();

class DaterangepickerDirective {
    constructor(input, config, differs) {
        this.input = input;
        this.config = config;
        this.differs = differs;
        this.targetOptions = {};
        this._differ = {};
        this.options = new Map();
        this.selected = new EventEmitter();
        this.cancelDaterangepicker = new EventEmitter();
        this.applyDaterangepicker = new EventEmitter();
        this.hideCalendarDaterangepicker = new EventEmitter();
        this.showCalendarDaterangepicker = new EventEmitter();
        this.hideDaterangepicker = new EventEmitter();
        this.showDaterangepicker = new EventEmitter();
        this._differ.options = this.differs.find(this.options).create();
        this._differ.settings = this.differs.find(this.config.settings).create();
    }
    ngAfterViewInit() {
        this.render();
        this.attachEvents();
    }
    ngDoCheck() {
        const optionsChanged = this._differ.options.diff(this.options);
        const settingsChanged = this._differ.settings.diff(this.config.settings);
        if (optionsChanged || settingsChanged) {
            this.render();
            this.attachEvents();
            if (this.activeRange && this.datePicker) {
                this.datePicker.setStartDate(this.activeRange.start);
                this.datePicker.setEndDate(this.activeRange.end);
            }
        }
    }
    ngOnDestroy() {
        this.destroyPicker();
    }
    render() {
        this.targetOptions = Object.assign({}, this.config.settings, this.options);
        $(this.input.nativeElement).daterangepicker(this.targetOptions, this.callback.bind(this));
        if (this.options.customClasses?.length) {
            for (const customClass of this.options.customClasses) {
                this.datePicker = ($(this.input.nativeElement)).data('daterangepicker').container.addClass(customClass);
            }
        }
        else {
            this.datePicker = ($(this.input.nativeElement)).data('daterangepicker');
        }
    }
    callback(start, end, label) {
        this.activeRange = {
            start,
            end,
            label,
        };
        this.selected.emit(this.activeRange);
    }
    destroyPicker() {
        try {
            $(this.input.nativeElement).data('daterangepicker')
                .remove();
        }
        catch (e) {
            // eslint-disable-next-line
            console.log(e.message);
        }
    }
    attachEvents() {
        $(this.input.nativeElement).on('cancel.daterangepicker', (e, picker) => {
            const event = { event: e, picker };
            this.cancelDaterangepicker.emit(event);
        });
        $(this.input.nativeElement).on('apply.daterangepicker', (e, picker) => {
            const event = { event: e, picker };
            this.applyDaterangepicker.emit(event);
        });
        $(this.input.nativeElement).on('hideCalendar.daterangepicker', (e, picker) => {
            const event = { event: e, picker };
            this.hideCalendarDaterangepicker.emit(event);
        });
        $(this.input.nativeElement).on('showCalendar.daterangepicker', (e, picker) => {
            const event = { event: e, picker };
            this.showCalendarDaterangepicker.emit(event);
        });
        $(this.input.nativeElement).on('hide.daterangepicker', (e, picker) => {
            const event = { event: e, picker };
            this.hideDaterangepicker.emit(event);
        });
        $(this.input.nativeElement).on('show.daterangepicker', (e, picker) => {
            const event = { event: e, picker };
            this.showDaterangepicker.emit(event);
        });
    }
    static { this.ɵfac = function DaterangepickerDirective_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DaterangepickerDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(DaterangepickerConfig), i0.ɵɵdirectiveInject(i0.KeyValueDiffers)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: DaterangepickerDirective, selectors: [["", "monDaterangePicker", ""]], inputs: { options: "options" }, outputs: { selected: "selected", cancelDaterangepicker: "cancelDaterangepicker", applyDaterangepicker: "applyDaterangepicker", hideCalendarDaterangepicker: "hideCalendarDaterangepicker", showCalendarDaterangepicker: "showCalendarDaterangepicker", hideDaterangepicker: "hideDaterangepicker", showDaterangepicker: "showDaterangepicker" } }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DaterangepickerDirective, [{
        type: Directive,
        args: [{
                selector: '[monDaterangePicker]',
            }]
    }], () => [{ type: i0.ElementRef }, { type: DaterangepickerConfig }, { type: i0.KeyValueDiffers }], { options: [{
            type: Input
        }], selected: [{
            type: Output
        }], cancelDaterangepicker: [{
            type: Output
        }], applyDaterangepicker: [{
            type: Output
        }], hideCalendarDaterangepicker: [{
            type: Output
        }], showCalendarDaterangepicker: [{
            type: Output
        }], hideDaterangepicker: [{
            type: Output
        }], showDaterangepicker: [{
            type: Output
        }] }); })();

const _c0$w = (a0, a1) => ({ "col-sm-40": a0, "col-sm-48": a1 });
function CheckboxComponent_label_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵattribute("for", ctx_r0.labelId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.monLabel);
} }
function CheckboxComponent_input_4_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 7);
    i0.ɵɵtwoWayListener("ngModelChange", function CheckboxComponent_input_4_Template_input_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r0 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r0.model, $event) || (ctx_r0.model = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("change", function CheckboxComponent_input_4_Template_input_change_0_listener() { i0.ɵɵrestoreView(_r2); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.ngOnChanges()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r0.monClass);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r0.model);
    i0.ɵɵproperty("id", ctx_r0.labelId)("disabled", ctx_r0.monDisabled)("required", ctx_r0.monRequired)("name", ctx_r0.monName);
} }
function CheckboxComponent_label_5_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 6)(1, "input", 7);
    i0.ɵɵtwoWayListener("ngModelChange", function CheckboxComponent_label_5_Template_input_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r0 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r0.model, $event) || (ctx_r0.model = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("change", function CheckboxComponent_label_5_Template_input_change_1_listener() { i0.ɵɵrestoreView(_r3); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.ngOnChanges()); });
    i0.ɵɵelementEnd();
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵattribute("for", ctx_r0.labelId);
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r0.monClass);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r0.model);
    i0.ɵɵproperty("id", ctx_r0.labelId)("disabled", ctx_r0.monDisabled)("required", ctx_r0.monRequired)("name", ctx_r0.monName);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.monLabel, " ");
} }
function CheckboxComponent_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.monHelpText);
} }
class CheckboxComponent extends BaseFieldComponent {
    get model() {
        return this.modelValue;
    }
    set model(val) {
        this.modelValue = val;
        this.modelChange.emit(this.modelValue);
    }
    constructor() {
        super();
        this.modelChange = new EventEmitter();
        this.monRequired = false;
        this.monLabelAtRight = false;
        this.monDisabled = false;
    }
    ngOnInit() {
        this.labelId = this.getLabelForId(this.monLabel);
    }
    ngOnChanges() {
        if (typeof this.modelChange !== 'undefined') {
            return this.modelChange.emit(this.modelValue);
        }
    }
    static { this.ɵfac = function CheckboxComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CheckboxComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CheckboxComponent, selectors: [["mon-form-field-checkbox"]], inputs: { model: "model", monLabel: "monLabel", monRequired: "monRequired", monLabelAtRight: "monLabelAtRight", monClass: "monClass", monHelpText: "monHelpText", monDisabled: "monDisabled", monName: "monName" }, outputs: { modelChange: "modelChange" }, features: [i0.ɵɵProvidersFeature([], [{ provide: ControlContainer, useExisting: NgForm }]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature], decls: 8, vars: 9, consts: [[1, "form-group", "row", "outer-b-none"], ["class", "col-form-label col-sm-8 capitalize-first-letter inner-t-mini text-right", 4, "ngIf"], [1, "form-group", "inner-l-medium", "outer-t-mini"], ["type", "checkbox", 3, "ngModel", "class", "id", "disabled", "required", "name", "ngModelChange", "change", 4, "ngIf"], ["class", "help-block pl-1", 4, "ngIf"], [1, "clearfix"], [1, "col-form-label", "col-sm-8", "capitalize-first-letter", "inner-t-mini", "text-right"], ["type", "checkbox", 3, "ngModelChange", "change", "ngModel", "id", "disabled", "required", "name"], [1, "help-block", "pl-1"]], template: function CheckboxComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, CheckboxComponent_label_1_Template, 2, 2, "label", 1);
            i0.ɵɵelementStart(2, "div")(3, "div", 2);
            i0.ɵɵtemplate(4, CheckboxComponent_input_4_Template, 1, 8, "input", 3)(5, CheckboxComponent_label_5_Template, 3, 10, "label", 1)(6, CheckboxComponent_span_6_Template, 2, 1, "span", 4);
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(7, "div", 5);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.monLabel && !ctx.monLabelAtRight);
            i0.ɵɵadvance();
            i0.ɵɵclassMap(i0.ɵɵpureFunction2(6, _c0$w, ctx.monLabel, !ctx.monLabel));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.monLabel || !ctx.monLabelAtRight);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.monLabel && ctx.monLabelAtRight);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.monHelpText);
        } }, dependencies: [i1$5.CheckboxControlValueAccessor, i1$5.NgControlStatus, i1$5.CheckboxRequiredValidator, i1$5.NgModel, i1$2.NgIf], styles: [".select-grey[_ngcontent-%COMP%]   .ngx-select__toggle[_ngcontent-%COMP%]{display:block;margin:0;position:relative;overflow:hidden;cursor:pointer;border:1px solid #bbb;box-shadow:0 1px #0000000d,inset 0 1px #fffc;box-sizing:border-box;border-radius:3px;font-weight:inherit}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CheckboxComponent, [{
        type: Component,
        args: [{ selector: 'mon-form-field-checkbox', viewProviders: [{ provide: ControlContainer, useExisting: NgForm }], template: "<div class=\"form-group row outer-b-none\">\n    <label *ngIf=\"monLabel && !monLabelAtRight\" [attr.for]=\"labelId\" class=\"col-form-label col-sm-8 capitalize-first-letter inner-t-mini text-right\">{{ monLabel }}</label>\n    <div [class]=\"{'col-sm-40' : monLabel, 'col-sm-48': !monLabel }\">\n        <div class=\"form-group inner-l-medium outer-t-mini\">\n            <input [(ngModel)]=\"model\"\n                   *ngIf=\"!monLabel || !monLabelAtRight\"\n                   type=\"checkbox\"\n                   class=\"{{ monClass }}\"\n                   [id]=\"labelId\"\n                   [disabled]=\"monDisabled\"\n                   [required]=\"monRequired\"\n                   (change)=\"ngOnChanges()\"\n                   [name]=\"monName\"/>\n            <label *ngIf=\"monLabel && monLabelAtRight\" [attr.for]=\"labelId\" class=\"col-form-label col-sm-8 capitalize-first-letter inner-t-mini text-right\">\n                <input [(ngModel)]=\"model\"\n                       type=\"checkbox\"\n                       class=\"{{ monClass }}\"\n                       [id]=\"labelId\"\n                       [disabled]=\"monDisabled\"\n                       [required]=\"monRequired\"\n                       (change)=\"ngOnChanges()\"\n                       [name]=\"monName\"/>\n                {{ monLabel }}\n            </label>\n            <span *ngIf=\"monHelpText\" class=\"help-block pl-1\">{{ monHelpText }}</span>\n        </div>\n    </div>\n    <div class=\"clearfix\"></div>\n</div>\n", styles: [".select-grey .ngx-select__toggle{display:block;margin:0;position:relative;overflow:hidden;cursor:pointer;border:1px solid #bbb;box-shadow:0 1px #0000000d,inset 0 1px #fffc;box-sizing:border-box;border-radius:3px;font-weight:inherit}\n"] }]
    }], () => [], { modelChange: [{
            type: Output
        }], model: [{
            type: Input
        }], monLabel: [{
            type: Input
        }], monRequired: [{
            type: Input
        }], monLabelAtRight: [{
            type: Input
        }], monClass: [{
            type: Input
        }], monHelpText: [{
            type: Input
        }], monDisabled: [{
            type: Input
        }], monName: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(CheckboxComponent, { className: "CheckboxComponent" }); })();

const _c0$v = ["daterangeTemplate"];
function MonDatePickerComponent_mon_icon_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mon-icon", 10);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("size", ctx_r0.iconSize)("monIconDirect", "arrowsRotate");
} }
function MonDatePickerComponent_span_9_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 11)(1, "span", 12)(2, "span", 3);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 4);
    i0.ɵɵtext(5, " to ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span", 3);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "a", 13);
    i0.ɵɵlistener("click", function MonDatePickerComponent_span_9_Template_a_click_8_listener() { i0.ɵɵrestoreView(_r2); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.onCompareClose()); });
    i0.ɵɵelement(9, "mon-icon", 8);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.currentSelectedRange.startDate ? ctx_r0.currentSelectedRange.startDate.format(ctx_r0.dateFormat) : "");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r0.currentSelectedRange.endDate ? ctx_r0.currentSelectedRange.endDate.format(ctx_r0.dateFormat) : "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("size", ctx_r0.iconSize)("monIconDirect", "faTimesCircle");
} }
function MonDatePickerComponent_div_14_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtext(1, "\n            ");
    i0.ɵɵelementStart(2, "mon-simple-date-range", 18);
    i0.ɵɵtwoWayListener("modelChange", function MonDatePickerComponent_div_14_div_5_Template_mon_simple_date_range_modelChange_2_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r0 = i0.ɵɵnextContext(2); i0.ɵɵtwoWayBindingSet(ctx_r0.monCompareDates, $event) || (ctx_r0.monCompareDates = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("rangeUpdate", function MonDatePickerComponent_div_14_div_5_Template_mon_simple_date_range_rangeUpdate_2_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r0 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r0.onRangeUpdated($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3, "\n        ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("model", ctx_r0.monCompareDates);
    i0.ɵɵproperty("validateStartDateCb", ctx_r0.monValidateStartDateCb ? ctx_r0.monValidateStartDateCb : null)("validateEndDateCb", ctx_r0.monValidateEndDateCb ? ctx_r0.monValidateEndDateCb : null);
} }
function MonDatePickerComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14, 0);
    i0.ɵɵtext(2, "\n        ");
    i0.ɵɵelementStart(3, "mon-form-field-checkbox", 15);
    i0.ɵɵlistener("modelChange", function MonDatePickerComponent_div_14_Template_mon_form_field_checkbox_modelChange_3_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.onCompareEnable($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4, "\n        ");
    i0.ɵɵtemplate(5, MonDatePickerComponent_div_14_div_5_Template, 4, 3, "div", 16);
    i0.ɵɵtext(6, "\n    ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("monLabel", "Compare")("monLabelAtRight", true)("monName", ctx_r0.cbName)("model", ctx_r0.expandComparisonRange);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.expandComparisonRange);
} }
class MonDatePickerComponent {
    get date() {
        return this.dateValue;
    }
    set date(val) {
        this.dateValue = val;
        this.dateChange.emit(this.dateValue);
    }
    constructor(translateService, changeDetectorRef) {
        this.translateService = translateService;
        this.changeDetectorRef = changeDetectorRef;
        this.options = {};
        this.unRestrictedMax = false;
        this.iconSize = 'lg';
        this.dateChange = new EventEmitter();
        this.comparisonUpdate = new EventEmitter();
        this.dateValue = { startDate: null, endDate: null };
        this.model = { startDate: null, endDate: null };
        this.compareRange = { startDate: null, endDate: null };
        this.currentSelectedRange = { startDate: null, endDate: null };
        this.dateFormat = 'DD/MM/YYYY';
        this.showSelectedRange = false;
    }
    ngOnInit() {
        const random = Math.random().toString(16).slice(2);
        this.elementRefId = 'id' + random;
        this.cbName = 'name' + random;
        this.applyBtnId = 'btnid' + random;
        if (!this.monCompareDates) {
            this.monCompareDates = { startDate: null, endDate: null };
        }
        else {
            this.currentSelectedRange = this.monCompareDates;
            this.showSelectedRange = true;
        }
        if (this.monDateFormat) {
            this.dateFormat = this.monDateFormat;
        }
        if (this.monExpandComparison) {
            this.expandComparisonRange = this.monExpandComparison;
        }
        this.setupOptions();
        this.model = cloneDeep(this.date);
    }
    ngAfterViewInit() {
        if (this.monEnableComparisonRange) {
            this.applyBtnEl = document.querySelector(`#${this.applyBtnId}`);
            this.applyBtnDisableState = this.applyBtnEl.disabled;
            this.applyBtnObserver = new MutationObserver(this.onApplyBtnDisableStateChange.bind(this));
            this.applyBtnObserver.observe(this.applyBtnEl, { attributes: true, childList: false, subtree: false });
            document.querySelector(`#${this.elementRefId}`)?.appendChild(this.daterangeTemplateRef.nativeElement);
            // Necessarry because we up dated the view in the render cycle
            this.changeDetectorRef.detectChanges();
        }
    }
    ngOnDestroy() {
        this.applyBtnObserver?.disconnect();
    }
    onApplyBtnDisableStateChange(mutationList) {
        if (mutationList[0].attributeName === 'disabled') {
            this.applyBtnDisableState = mutationList[0].target.disabled;
            if (this.expandComparisonRange && (this.compareRange.startDate === null || this.compareRange.endDate === null)) {
                this.setApplyButtonDisableState(true);
            }
        }
    }
    setApplyButtonDisableState(value) {
        if (this.applyBtnObserver) {
            this.applyBtnObserver.disconnect();
        }
        if (this.applyBtnEl) {
            this.applyBtnEl.disabled = value;
        }
        if (this.applyBtnObserver) {
            this.applyBtnObserver.observe(this.applyBtnEl, { attributes: true, childList: false, subtree: false });
        }
    }
    onCompareEnable(value) {
        this.expandComparisonRange = value;
        if (!value) {
            this.onCompareClose();
        }
    }
    onRangeUpdated(range) {
        if (range) {
            this.compareRange = { ...range };
            if (this.applyBtnEl && (this.compareRange.startDate === null || this.compareRange.endDate === null)) {
                this.setApplyButtonDisableState(true);
            }
            if (this.applyBtnEl && (this.compareRange.startDate !== null && this.compareRange.endDate !== null)) {
                this.setApplyButtonDisableState(this.applyBtnDisableState);
            }
        }
    }
    onCompareClose() {
        this.monCompareDates = { startDate: null, endDate: null };
        this.compareRange = { startDate: null, endDate: null };
        this.showSelectedRange = false;
        this.setApplyButtonDisableState(this.applyBtnDisableState);
        this.comparisonUpdate.emit(this.compareRange);
    }
    selectedDate(picker) {
        this.date.startDate = picker.start;
        this.date.endDate = picker.end;
        this.model = cloneDeep(this.date);
        this.dateChange.emit(this.date);
    }
    setVisibilityOfComparisonRange() {
        this.currentSelectedRange = { ...this.compareRange };
        this.comparisonUpdate.emit(this.compareRange);
        this.showSelectedRange = this.compareRange.startDate !== null &&
            this.compareRange.endDate !== null &&
            this.expandComparisonRange;
    }
    setupOptions() {
        const yesterday = moment().subtract(1, 'days').toDate();
        this.options = this.options || {};
        this.options.cancelOnOutsideClick = true;
        this.options.opens = this.options.opens || 'left'; // We would like to go left as default
        this.options.startDate = this.date?.startDate;
        this.options.endDate = this.date?.endDate;
        if (!this.isBoolean(this.options.alwaysShowCalendars)) {
            this.options.alwaysShowCalendars = true;
        }
        if (!this.isBoolean(this.options?.showCustomRangeLabel)) {
            this.options.showCustomRangeLabel = false;
        }
        if (!this.options.ranges) {
            this.options.ranges = {};
            this.options.ranges[this.translateService.getString('Last Week')] = [
                moment(yesterday).subtract(7, 'days').startOf('week'),
                moment(yesterday).subtract(7, 'days').endOf('week'),
            ];
            this.options.ranges[this.translateService.getString('Last Month')] = [
                moment(yesterday).subtract(1, 'month').startOf('month'),
                moment(yesterday).subtract(1, 'month').endOf('month'),
            ];
            this.options.ranges[this.translateService.getString('Last Quarter')] = [
                moment(yesterday).subtract(1, 'quarter').startOf('quarter'),
                moment(yesterday).subtract(1, 'quarter').endOf('quarter'),
            ];
            this.options.ranges[this.translateService.getString('Last Half Year')] = [
                moment(yesterday).subtract(2, 'quarter').startOf('quarter'),
                moment(yesterday).subtract(1, 'quarter').endOf('quarter'),
            ];
            this.options.ranges[this.translateService.getString('Last Year')] = [
                moment(yesterday).subtract(1, 'year').startOf('year'),
                moment(yesterday).subtract(1, 'year').endOf('year'),
            ];
        }
        this.options.locale = this.options.locale || {
            applyLabel: this.translateService.getString('Apply'),
            cancelLabel: this.translateService.getString('Cancel'),
            customRangeLabel: this.translateService.getString('Custom range'),
        };
        if (!this.unRestrictedMax && !this.options.maxDate) {
            this.options.maxDate = yesterday;
            const date = this.date?.endDate || moment();
            if (date.diff(moment(yesterday), 'days') > 0) {
                this.date.endDate = moment(yesterday);
            }
        }
        if (!this.options?.template && this.monEnableComparisonRange) {
            this.options.template = `
            <div class="daterangepicker">
                <div class="ranges"></div>
                <div class="drp-calendar left">
                    <div class="calendar-table"></div>
                    <div class="calendar-time"></div>
                </div>
                <div class="drp-calendar right">
                    <div class="calendar-table"></div>
                    <div class="calendar-time"></div>
                </div>
                <div class="drp-buttons">
                    <div id="${this.elementRefId}"></div>
                    <button class="cancelBtn" type="button"></button>
                    <button id="${this.applyBtnId}" class="applyBtn" disabled="disabled" type="button"></button>
                </div>
            </div>`;
        }
    }
    isBoolean(type) {
        return typeof type === 'boolean';
    }
    static { this.ɵfac = function MonDatePickerComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MonDatePickerComponent)(i0.ɵɵdirectiveInject(TranslateServiceInjectionToken), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MonDatePickerComponent, selectors: [["mon-date-picker"]], viewQuery: function MonDatePickerComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$v, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.daterangeTemplateRef = _t.first);
        } }, inputs: { date: "date", options: "options", unRestrictedMax: "unRestrictedMax", monEnableComparisonRange: "monEnableComparisonRange", monExpandComparison: "monExpandComparison", monDateFormat: "monDateFormat", monCompareDates: "monCompareDates", monValidateStartDateCb: "monValidateStartDateCb", monValidateEndDateCb: "monValidateEndDateCb", iconSize: "iconSize" }, outputs: { dateChange: "dateChange", comparisonUpdate: "comparisonUpdate" }, decls: 16, vars: 8, consts: [["daterangeTemplate", ""], [1, "font-weight-500", "font-size-1-1", "daterangepicker-date-range-container"], [1, "text-grey", "outer-l-mini", "outer-r-mini", "visibility-65"], [1, "daterangepicker-date-text"], [1, "daterangepicker-to-text"], ["class", "icon daterangepicker-icon-space", 3, "size", "monIconDirect", 4, "ngIf"], ["class", "daterangepicker-compare-date", 4, "ngIf"], ["type", "button", "monDaterangePicker", "", 1, "btn", "outer-r-small", "inner-none", "daterangepicker-calendar-btn-color", "pl-1", 3, "applyDaterangepicker", "selected", "options"], [1, "icon", 3, "size", "monIconDirect"], ["class", "daterangepicker-enable-compare-container", 4, "ngIf"], [1, "icon", "daterangepicker-icon-space", 3, "size", "monIconDirect"], [1, "daterangepicker-compare-date"], [1, "valign"], [1, "btn", "btn-link", "daterangepicker-compare-close", 3, "click"], [1, "daterangepicker-enable-compare-container"], [3, "modelChange", "monLabel", "monLabelAtRight", "monName", "model"], ["class", "daterangepicker-simple-date-range-container", 4, "ngIf"], [1, "daterangepicker-simple-date-range-container"], [3, "modelChange", "rangeUpdate", "model", "validateStartDateCb", "validateEndDateCb"]], template: function MonDatePickerComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵelement(1, "span", 2);
            i0.ɵɵelementStart(2, "span", 3);
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "span", 4);
            i0.ɵɵtext(5, " to ");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "span", 3);
            i0.ɵɵtext(7);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(8, MonDatePickerComponent_mon_icon_8_Template, 1, 2, "mon-icon", 5)(9, MonDatePickerComponent_span_9_Template, 10, 4, "span", 6);
            i0.ɵɵelementStart(10, "button", 7);
            i0.ɵɵlistener("applyDaterangepicker", function MonDatePickerComponent_Template_button_applyDaterangepicker_10_listener() { return ctx.setVisibilityOfComparisonRange(); })("selected", function MonDatePickerComponent_Template_button_selected_10_listener($event) { return ctx.selectedDate($event); });
            i0.ɵɵelement(11, "mon-icon", 8);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(12, "template");
            i0.ɵɵtext(13, "\n    ");
            i0.ɵɵtemplate(14, MonDatePickerComponent_div_14_Template, 7, 5, "div", 9);
            i0.ɵɵtext(15, "\n");
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.model.startDate ? ctx.model.startDate.format(ctx.dateFormat) : "");
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(ctx.model.endDate ? ctx.model.endDate.format(ctx.dateFormat) : "");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.showSelectedRange);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.showSelectedRange);
            i0.ɵɵadvance();
            i0.ɵɵproperty("options", ctx.options);
            i0.ɵɵadvance();
            i0.ɵɵproperty("size", ctx.iconSize)("monIconDirect", "faCalendarAlt");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.monEnableComparisonRange);
        } }, dependencies: [i1$2.NgIf, DaterangepickerDirective, IconComponent, MonSimpleDateRangeComponent, CheckboxComponent], styles: ["[_nghost-%COMP%]{--datepicker-date-text-fontweight: bold;--datepicker-date-text-color: #555557;--datepicker-to-text-color: #555557;--datepicker-to-text-fontweight: bold;--datepicker-calendar-btn-color: #299bf7;--datepicker-calendar-btn-hover-color: #E6E6E6;--datepicker-calendar-btn-active-color: #E6E6E6;--datepicker-comparedate-bgcolor: #299bf7;--datepicker-comparedate-color: #FFFFFF}.daterangepicker[_ngcontent-%COMP%]{z-index:var(--mon-z-index-highiest, 2147483647)}.daterangepicker[_ngcontent-%COMP%]   .drp-buttons[_ngcontent-%COMP%]   .drp-selected[_ngcontent-%COMP%]{visibility:hidden}.daterangepicker-date-range-container[_ngcontent-%COMP%]   .daterangepicker-to-text[_ngcontent-%COMP%]{color:var(--datepicker-to-text-color);font-weight:var(--datepicker-to-text-fontweight)}.daterangepicker-date-range-container[_ngcontent-%COMP%]   .daterangepicker-date-text[_ngcontent-%COMP%]{color:var(--datepicker-date-text-color);font-weight:var(--datepicker-date-text-fontweight)}.daterangepicker-calendar-btn-color[_ngcontent-%COMP%]{color:var(--datepicker-calendar-btn-color);padding:2px 6px;margin-left:5px;border-radius:50%;box-shadow:none;vertical-align:baseline}button.daterangepicker-calendar-btn-color[_ngcontent-%COMP%]:hover{background-color:var(--datepicker-calendar-btn-hover-color)}button.daterangepicker-calendar-btn-color[_ngcontent-%COMP%]:active{background-color:var(--datepicker-calendar-btn-active-color)}.daterangepicker-enable-compare-container[_ngcontent-%COMP%]{font-size:12px;text-align:left;line-height:2em;width:80%;margin:0 5px}.daterangepicker-icon-space[_ngcontent-%COMP%]{margin:0 20px}.daterangepicker-compare-date[_ngcontent-%COMP%]{padding:5px 5px 5px 10px;background-color:var(--datepicker-comparedate-bgcolor);border-radius:15px;vertical-align:middle}.daterangepicker-compare-date[_ngcontent-%COMP%]   .daterangepicker-date-text[_ngcontent-%COMP%], .daterangepicker-compare-date[_ngcontent-%COMP%]   .daterangepicker-to-text[_ngcontent-%COMP%]{color:var(--datepicker-comparedate-color)}.daterangepicker-compare-date[_ngcontent-%COMP%]   .valign[_ngcontent-%COMP%]{vertical-align:middle}.daterangepicker-compare-close[_ngcontent-%COMP%]{color:#fff;padding:2px}.daterangepicker-simple-date-range-container[_ngcontent-%COMP%]{margin-top:-8px}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MonDatePickerComponent, [{
        type: Component,
        args: [{ selector: 'mon-date-picker', template: "<div class=\"font-weight-500 font-size-1-1 daterangepicker-date-range-container\">\n    <span class=\"text-grey outer-l-mini outer-r-mini visibility-65\"></span>\n    <span class=\"daterangepicker-date-text\">{{ model.startDate ? model.startDate.format(dateFormat) : '' }}</span><span class=\"daterangepicker-to-text\"> to </span><span class=\"daterangepicker-date-text\">{{ model.endDate ? model.endDate.format(dateFormat) : '' }}</span>\n    <mon-icon [size]=\"iconSize\" *ngIf=\"showSelectedRange\" class=\"icon daterangepicker-icon-space\" [monIconDirect]=\"'arrowsRotate'\"></mon-icon>\n    <span *ngIf=\"showSelectedRange\" class=\"daterangepicker-compare-date\">\n        <span class=\"valign\">\n            <span class=\"daterangepicker-date-text\">{{ currentSelectedRange.startDate ? currentSelectedRange.startDate.format(dateFormat) : '' }}</span><span class=\"daterangepicker-to-text\"> to </span><span class=\"daterangepicker-date-text\">{{ currentSelectedRange.endDate ? currentSelectedRange.endDate.format(dateFormat) : '' }}</span>\n                <a class=\"btn btn-link daterangepicker-compare-close\" (click)=\"onCompareClose()\"><mon-icon [size]=\"iconSize\" class=\"icon\" [monIconDirect]=\"'faTimesCircle'\"></mon-icon></a>\n            </span>\n        </span>\n    <button type=\"button\" class=\"btn outer-r-small inner-none daterangepicker-calendar-btn-color pl-1\" monDaterangePicker (applyDaterangepicker)=\"setVisibilityOfComparisonRange()\" (selected)=\"selectedDate($event)\" [options]=\"options\">\n        <mon-icon [size]=\"iconSize\" class=\"icon\" [monIconDirect]=\"'faCalendarAlt'\"></mon-icon>\n    </button>\n</div>\n\n<template>\n    <div *ngIf=\"monEnableComparisonRange\" #daterangeTemplate class=\"daterangepicker-enable-compare-container\">\n        <mon-form-field-checkbox [monLabel]=\"'Compare'\" [monLabelAtRight]=\"true\" [monName]=\"cbName\" [model]=\"expandComparisonRange\" (modelChange)=\"onCompareEnable($event)\"></mon-form-field-checkbox>\n        <div *ngIf=\"expandComparisonRange\" class=\"daterangepicker-simple-date-range-container\">\n            <mon-simple-date-range [(model)]=\"monCompareDates\" (rangeUpdate)=\"onRangeUpdated($event)\" [validateStartDateCb]=\"monValidateStartDateCb ? monValidateStartDateCb : null\" [validateEndDateCb]=\"monValidateEndDateCb ? monValidateEndDateCb : null\"></mon-simple-date-range>\n        </div>\n    </div>\n</template>\n", styles: [":host{--datepicker-date-text-fontweight: bold;--datepicker-date-text-color: #555557;--datepicker-to-text-color: #555557;--datepicker-to-text-fontweight: bold;--datepicker-calendar-btn-color: #299bf7;--datepicker-calendar-btn-hover-color: #E6E6E6;--datepicker-calendar-btn-active-color: #E6E6E6;--datepicker-comparedate-bgcolor: #299bf7;--datepicker-comparedate-color: #FFFFFF}.daterangepicker{z-index:var(--mon-z-index-highiest, 2147483647)}.daterangepicker .drp-buttons .drp-selected{visibility:hidden}.daterangepicker-date-range-container .daterangepicker-to-text{color:var(--datepicker-to-text-color);font-weight:var(--datepicker-to-text-fontweight)}.daterangepicker-date-range-container .daterangepicker-date-text{color:var(--datepicker-date-text-color);font-weight:var(--datepicker-date-text-fontweight)}.daterangepicker-calendar-btn-color{color:var(--datepicker-calendar-btn-color);padding:2px 6px;margin-left:5px;border-radius:50%;box-shadow:none;vertical-align:baseline}button.daterangepicker-calendar-btn-color:hover{background-color:var(--datepicker-calendar-btn-hover-color)}button.daterangepicker-calendar-btn-color:active{background-color:var(--datepicker-calendar-btn-active-color)}.daterangepicker-enable-compare-container{font-size:12px;text-align:left;line-height:2em;width:80%;margin:0 5px}.daterangepicker-icon-space{margin:0 20px}.daterangepicker-compare-date{padding:5px 5px 5px 10px;background-color:var(--datepicker-comparedate-bgcolor);border-radius:15px;vertical-align:middle}.daterangepicker-compare-date .daterangepicker-date-text,.daterangepicker-compare-date .daterangepicker-to-text{color:var(--datepicker-comparedate-color)}.daterangepicker-compare-date .valign{vertical-align:middle}.daterangepicker-compare-close{color:#fff;padding:2px}.daterangepicker-simple-date-range-container{margin-top:-8px}\n"] }]
    }], () => [{ type: undefined, decorators: [{
                type: Inject,
                args: [TranslateServiceInjectionToken]
            }] }, { type: i0.ChangeDetectorRef }], { date: [{
            type: Input
        }], options: [{
            type: Input
        }], unRestrictedMax: [{
            type: Input
        }], monEnableComparisonRange: [{
            type: Input
        }], monExpandComparison: [{
            type: Input
        }], monDateFormat: [{
            type: Input
        }], monCompareDates: [{
            type: Input
        }], monValidateStartDateCb: [{
            type: Input
        }], monValidateEndDateCb: [{
            type: Input
        }], iconSize: [{
            type: Input
        }], dateChange: [{
            type: Output
        }], comparisonUpdate: [{
            type: Output
        }], daterangeTemplateRef: [{
            type: ViewChild,
            args: ['daterangeTemplate']
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(MonDatePickerComponent, { className: "MonDatePickerComponent" }); })();

function UrlTitleComponent_a_2_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 10);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("click", function UrlTitleComponent_a_2_Template_a_click_0_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.go($event)); })("keydown", function UrlTitleComponent_a_2_Template_a_keydown_0_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(($event.key === "Enter" || $event.key === " ") && ctx_r1.go($event)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 2, "Open details"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.currentTitle, " ");
} }
function UrlTitleComponent_a_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 11);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("title", ctx_r1.currentTitle);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.currentTitle, " ");
} }
function UrlTitleComponent_a_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("title", ctx_r1.currentTitle);
    i0.ɵɵproperty("href", ctx_r1.url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.currentTitle);
} }
class UrlTitleComponent {
    constructor(translateService) {
        this.translateService = translateService;
        this.title = '';
        this.url = '';
        this.active = true;
        this.useButton = false;
        this.goTo = new EventEmitter();
    }
    ngOnChanges(changes) {
        if (changes?.title?.currentValue) {
            this.currentTitle = changes.title.currentValue;
        }
        else if (changes?.missingTitleText?.currentValue) {
            this.currentTitle = changes.missingTitleText.currentValue;
        }
        else {
            this.currentTitle = this.translateService.getString('(No title found)');
        }
    }
    go(e) {
        e.preventDefault();
        this.goTo.emit();
    }
    static { this.ɵfac = function UrlTitleComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || UrlTitleComponent)(i0.ɵɵdirectiveInject(TranslateServiceInjectionToken)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: UrlTitleComponent, selectors: [["mon-url-title"]], inputs: { title: "title", url: "url", active: "active", missingTitleText: "missingTitleText", useButton: "useButton" }, outputs: { goTo: "goTo" }, features: [i0.ɵɵNgOnChangesFeature], decls: 12, vars: 7, consts: [[1, "page-title"], [1, "url-title-link", "outer-b-smurf", "text-nowrap", "text-ellipsis"], ["class", "cursor-pointer", "role", "button", "tabindex", "0", "e2e", "url-title-link-go-to", 3, "click", "keydown", 4, "ngIf"], [3, "title", 4, "ngIf"], ["target", "_blank", "class", "cursor-pointer", 3, "href", "title", 4, "ngIf"], [1, "tooltip_url", "text-nowrap", "text-ellipsis"], ["target", "_blank", "aria-describedby", "linkOpensInNewTab", "title", "Go to page", 3, "href"], [1, "fas", "icon", "fa-external-link-alt"], [1, "sr-only"], [1, "link-tooltip", "ml-1", 3, "title"], ["role", "button", "tabindex", "0", "e2e", "url-title-link-go-to", 1, "cursor-pointer", 3, "click", "keydown"], [3, "title"], ["target", "_blank", 1, "cursor-pointer", 3, "href", "title"]], template: function UrlTitleComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵtemplate(2, UrlTitleComponent_a_2_Template, 3, 4, "a", 2)(3, UrlTitleComponent_a_3_Template, 2, 2, "a", 3)(4, UrlTitleComponent_a_4_Template, 2, 3, "a", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "div", 5)(6, "a", 6);
            i0.ɵɵelement(7, "span", 7);
            i0.ɵɵelementStart(8, "span", 8);
            i0.ɵɵtext(9);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(10, "span", 9);
            i0.ɵɵtext(11);
            i0.ɵɵelementEnd()()();
        } if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.active && ctx.useButton);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.useButton && ctx.active);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.active);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("href", ctx.url, i0.ɵɵsanitizeUrl);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.url);
            i0.ɵɵadvance();
            i0.ɵɵpropertyInterpolate("title", ctx.url);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.url);
        } }, dependencies: [i1$2.NgIf, TranslatePipe], styles: ["[_nghost-%COMP%]{--mon-url-title-link-tooltip-color: #555557}[_nghost-%COMP%]   .link-tooltip[_ngcontent-%COMP%]{font-size:12px;color:var(--mon-url-title-link-tooltip-color)}[_nghost-%COMP%]   a.url-title-link[_ngcontent-%COMP%]{font-size:13px}[_nghost-%COMP%]   a.url-title-link[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{margin-left:2px;margin-right:2px}[_nghost-%COMP%]   a[_ngcontent-%COMP%]:focus-visible{outline:none;box-shadow:0 0 0 1px #4976b9}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UrlTitleComponent, [{
        type: Component,
        args: [{ selector: 'mon-url-title', template: "  <div class=\"page-title\">\n    <div class=\"url-title-link outer-b-smurf text-nowrap text-ellipsis\">\n        <a (click)=\"go($event)\"\n           (keydown)=\"($event.key === 'Enter' || $event.key === ' ') && go($event)\"\n           *ngIf=\"active && useButton\"\n           class=\"cursor-pointer\"\n           role=\"button\"\n           tabindex=\"0\"\n           [attr.aria-label]=\"'Open details' | translate\"\n           e2e=\"url-title-link-go-to\">\n           {{ currentTitle }}\n        </a>\n        <a  *ngIf=\"!useButton && active\" title=\"{{ currentTitle }}\">\n            {{ currentTitle }}\n        </a>\n        <a [href]=\"url\" target=\"_blank\" class=\"cursor-pointer\" *ngIf=\"!active\" title=\"{{ currentTitle }}\">{{ currentTitle }}</a>\n    </div>\n    <div class=\"tooltip_url text-nowrap text-ellipsis\">\n        <a [href]=\"url\" target=\"_blank\" aria-describedby=\"linkOpensInNewTab\" title=\"Go to page\"><span class=\"fas icon fa-external-link-alt\"></span>\n            <span class=\"sr-only\">{{ url }}</span>\n        </a>\n        <span class=\"link-tooltip ml-1\" title=\"{{ url }}\">{{ url }}</span>\n    </div>\n</div>\n", styles: [":host{--mon-url-title-link-tooltip-color: #555557}:host .link-tooltip{font-size:12px;color:var(--mon-url-title-link-tooltip-color)}:host a.url-title-link{font-size:13px}:host a.url-title-link .icon{margin-left:2px;margin-right:2px}:host a:focus-visible{outline:none;box-shadow:0 0 0 1px #4976b9}\n"] }]
    }], () => [{ type: undefined, decorators: [{
                type: Inject,
                args: [TranslateServiceInjectionToken]
            }] }], { title: [{
            type: Input
        }], url: [{
            type: Input
        }], active: [{
            type: Input
        }], missingTitleText: [{
            type: Input
        }], useButton: [{
            type: Input
        }], goTo: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(UrlTitleComponent, { className: "UrlTitleComponent" }); })();

const _c0$u = ["*"];
function MonSpinnerComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3);
    i0.ɵɵelement(2, "span", 4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-label", ctx_r0.translateLoadingData);
} }
class MonSpinnerComponent {
    constructor(translateService) {
        this.translateService = translateService;
        this.translateLoadingData = this.translateService.getString('Loading Data');
    }
    ngOnChanges() {
        this.runLoad();
    }
    runLoad() {
        if (this.progress instanceof Promise) {
            this.loading = true;
            this.progress.finally(() => {
                this.loading = false;
            });
        }
    }
    static { this.ɵfac = function MonSpinnerComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MonSpinnerComponent)(i0.ɵɵdirectiveInject(TranslateServiceInjectionToken)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MonSpinnerComponent, selectors: [["mon-spinner"]], inputs: { progress: "progress", loading: "loading" }, features: [i0.ɵɵNgOnChangesFeature], ngContentSelectors: _c0$u, decls: 3, vars: 2, consts: [["class", "mon-spinner", 4, "ngIf"], [3, "hidden"], [1, "mon-spinner"], [1, "text-center"], [1, "fas", "fa-spinner", "fa-spin", "fa-3x"]], template: function MonSpinnerComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, MonSpinnerComponent_div_0_Template, 3, 1, "div", 0);
            i0.ɵɵelementStart(1, "div", 1);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.loading);
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.loading);
        } }, dependencies: [i1$2.NgIf], styles: [".mon-spinner[_ngcontent-%COMP%]{height:100%;min-height:100%}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MonSpinnerComponent, [{
        type: Component,
        args: [{ selector: 'mon-spinner', template: "<div class=\"mon-spinner\" *ngIf=\"loading\">\n    <div class=\"text-center\">\n        <span class=\"fas fa-spinner fa-spin fa-3x\" [attr.aria-label]=\"translateLoadingData\"></span>\n    </div>\n</div> \n\n<div [hidden]=\"loading\">\n    <ng-content></ng-content>\n</div>\n", styles: [".mon-spinner{height:100%;min-height:100%}\n"] }]
    }], () => [{ type: undefined, decorators: [{
                type: Inject,
                args: [TranslateServiceInjectionToken]
            }] }], { progress: [{
            type: Input
        }], loading: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(MonSpinnerComponent, { className: "MonSpinnerComponent" }); })();

const _c0$t = ["*"];
const _c1$e = a0 => ({ "cursor-pointer": a0 });
const _c2$9 = (a0, a1) => ({ "col-sm-30": a0, "col-sm-48": a1 });
const _c3$4 = (a0, a1) => [a0, a1];
function NotificationChangeComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵelement(1, "span", 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(1, _c3$4, ctx_r0.digit > 0 ? ctx_r0.classColor : "text-link", ctx_r0.faIcon));
} }
function NotificationChangeComponent_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 15);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngbTooltip", ctx_r0.tooltipTitle);
} }
function NotificationChangeComponent_span_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.miniDigitsTextColor());
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.displayPositive(ctx_r0.miniDigits), " ");
} }
class NotificationChangeComponent {
    constructor() {
        this.onClick = new EventEmitter();
    }
    ngOnInit() {
        this.unit = this.unit || null;
    }
    displayPositive(num) {
        const result = parseInt(String(num), 10);
        return result !== 0 ? Number(Math.abs(result)).toLocaleString() : '';
    }
    miniDigitsTextColor() {
        if (Number(this.miniDigits) < 0) {
            return 'text-light-green';
        }
        else if (Number(this.miniDigits) > 0) {
            return 'text-danger';
        }
        else if (this.miniDigits === '0') {
            return 'text-grey';
        }
    }
    miniDigitsIcon() {
        if (Number(this.miniDigits) < 0) {
            return 'text-light-green fas fa-chevron-down';
        }
        else if (Number(this.miniDigits) > 0) {
            return 'fas fa-chevron-up text-danger';
        }
        else if (this.miniDigits === '0') {
            return 'fa-tilde text-grey';
        }
    }
    static { this.ɵfac = function NotificationChangeComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || NotificationChangeComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: NotificationChangeComponent, selectors: [["mon-notification-change"]], inputs: { params: "params", link: "link", faIcon: "faIcon", title: "title", digit: "digit", classColor: "classColor", miniDigits: "miniDigits", unit: "unit", tooltipTitle: "tooltipTitle" }, outputs: { onClick: "onClick" }, ngContentSelectors: _c0$t, decls: 18, vars: 18, consts: [[1, "notification-change", 3, "click", "ngClass"], ["class", "col-sm-18 text-right mt-2 pr-0", 4, "ngIf"], [1, "pl-1", 3, "ngClass"], [1, "list-group", "mb-0"], [1, "remove-background", "list-group-item", "py-0", "text-grey"], ["class", "fas fa-question-circle", 3, "ngbTooltip", 4, "ngIf"], [1, "py-0", "remove-background", "list-group-item", "font-size-1-5", "font-weight-500"], [1, "vtop", "font-size-1-5", "font-weight-400", "mt-1", "mr-1"], [1, "font-size-0-54", "text-v-middle", "pt-2", 3, "ngClass"], ["class", "inline-block mt-2 font-size-0-7 text-v-middle font-weight-500", 3, "ngClass", 4, "ngIf"], ["unit", "unit", 1, "font-size-0-7", "text-v-middle", "mt-1", 3, "ngClass"], [1, "remove-background", "list-group-item", "py-0", "text-grey", 2, "margin-top", "9px"], [1, "clear"], [1, "col-sm-18", "text-right", "mt-2", "pr-0"], [3, "ngClass"], [1, "fas", "fa-question-circle", 3, "ngbTooltip"], [1, "inline-block", "mt-2", "font-size-0-7", "text-v-middle", "font-weight-500", 3, "ngClass"]], template: function NotificationChangeComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵlistener("click", function NotificationChangeComponent_Template_div_click_0_listener() { return ctx.onClick.emit(ctx.params); });
            i0.ɵɵtemplate(1, NotificationChangeComponent_div_1_Template, 2, 4, "div", 1);
            i0.ɵɵelementStart(2, "div", 2)(3, "ul", 3)(4, "li", 4);
            i0.ɵɵtext(5);
            i0.ɵɵtemplate(6, NotificationChangeComponent_span_6_Template, 1, 1, "span", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "li", 6)(8, "span", 7);
            i0.ɵɵtext(9);
            i0.ɵɵpipe(10, "number");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(11, "span", 8);
            i0.ɵɵtemplate(12, NotificationChangeComponent_span_12_Template, 2, 2, "span", 9);
            i0.ɵɵelementStart(13, "span", 10);
            i0.ɵɵtext(14);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(15, "li", 11);
            i0.ɵɵprojection(16);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelement(17, "div", 12);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(13, _c1$e, ctx.link));
            i0.ɵɵattribute("aria-label", ctx.title);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.faIcon);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(15, _c2$9, ctx.faIcon, !ctx.faIcon));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", ctx.title, " ");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.tooltipTitle && ctx.tooltipTitle.length > 0);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(10, 11, ctx.digit));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngClass", ctx.miniDigitsIcon());
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.miniDigits);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", ctx.miniDigitsTextColor());
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.unit);
        } }, dependencies: [i1$2.NgClass, i1$2.NgIf, i1$4.NgbTooltip, i1$2.DecimalPipe], styles: [".fa-sm[_ngcontent-%COMP%]{font-size:.63em}.font-size-1-75[_ngcontent-%COMP%]{font-size:1.75em}.font-size-1-5[_ngcontent-%COMP%]{font-size:1.5em}.font-size-1-3[_ngcontent-%COMP%]{font-size:1.3em}.font-size-1-1[_ngcontent-%COMP%]{font-size:1.1em}.font-size-0-9[_ngcontent-%COMP%]{font-size:.9em}.font-size-0-7[_ngcontent-%COMP%]{font-size:.7em}.font-size-0-6[_ngcontent-%COMP%]{font-size:.6em}.font-size-0-54[_ngcontent-%COMP%]{font-size:.54em}.font-weight-300[_ngcontent-%COMP%]{font-weight:300}.font-weight-500[_ngcontent-%COMP%]{font-weight:500}.font-weight-400[_ngcontent-%COMP%]{font-weight:400}.notification-change[_ngcontent-%COMP%]   .fa-tilde[_ngcontent-%COMP%]:before{content:\"~\"}.notification-change[_ngcontent-%COMP%]   .list-group[_ngcontent-%COMP%] > li.list-group-item[_ngcontent-%COMP%]{border:none}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NotificationChangeComponent, [{
        type: Component,
        args: [{ selector: 'mon-notification-change', template: "<div class=\"notification-change\" [ngClass]=\"{'cursor-pointer': link}\" (click)=\"onClick.emit(params)\" [attr.aria-label]=\"title\">\n    <div class=\"col-sm-18 text-right mt-2 pr-0\" *ngIf=\"faIcon\">\n        <span [ngClass]=\"[(digit > 0 ? classColor : 'text-link'), faIcon]\"></span>\n    </div>\n    <div class=\"pl-1\" [ngClass]=\"{ 'col-sm-30': faIcon, 'col-sm-48': !faIcon}\">\n        <ul class=\"list-group mb-0\">\n            <li class=\"remove-background list-group-item py-0 text-grey\">\n                {{ title }}\n                <span *ngIf=\"tooltipTitle && tooltipTitle.length > 0\"\n                      class=\"fas fa-question-circle\"\n                      [ngbTooltip]=\"tooltipTitle\">\n                </span>\n            </li>\n            <li class=\"py-0 remove-background list-group-item font-size-1-5 font-weight-500\">\n                <span class=\"vtop font-size-1-5 font-weight-400 mt-1 mr-1\">{{ digit | number }}</span>\n                <span class=\"font-size-0-54 text-v-middle pt-2\" [ngClass]=\"miniDigitsIcon()\"></span>\n                <span class=\"inline-block mt-2 font-size-0-7 text-v-middle font-weight-500\" [ngClass]=\"miniDigitsTextColor()\" *ngIf=\"miniDigits\">\n                    <!-- TODO: Refactor this method call in the template https://monsido.atlassian.net/browse/MON-1883 -->\n                    {{ displayPositive(miniDigits) }}\n                </span>\n                <span class=\"font-size-0-7 text-v-middle mt-1\" [ngClass]=\"miniDigitsTextColor()\" unit=\"unit\">{{ unit }}</span>\n            </li>\n            <li class=\"remove-background list-group-item py-0 text-grey\" style=\"margin-top: 9px\">\n                <ng-content></ng-content>\n            </li>\n        </ul>\n    </div>\n    <div class=\"clear\"></div>\n</div>\n", styles: [".fa-sm{font-size:.63em}.font-size-1-75{font-size:1.75em}.font-size-1-5{font-size:1.5em}.font-size-1-3{font-size:1.3em}.font-size-1-1{font-size:1.1em}.font-size-0-9{font-size:.9em}.font-size-0-7{font-size:.7em}.font-size-0-6{font-size:.6em}.font-size-0-54{font-size:.54em}.font-weight-300{font-weight:300}.font-weight-500{font-weight:500}.font-weight-400{font-weight:400}.notification-change .fa-tilde:before{content:\"~\"}.notification-change .list-group>li.list-group-item{border:none}\n"] }]
    }], () => [], { params: [{
            type: Input
        }], link: [{
            type: Input
        }], faIcon: [{
            type: Input
        }], title: [{
            type: Input
        }], digit: [{
            type: Input
        }], classColor: [{
            type: Input
        }], miniDigits: [{
            type: Input
        }], unit: [{
            type: Input
        }], tooltipTitle: [{
            type: Input
        }], onClick: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(NotificationChangeComponent, { className: "NotificationChangeComponent" }); })();

function PriorityComponent_span_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 1)(1, "span", 2);
    i0.ɵɵtext(2, "Priority");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "titlecase");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.getClass());
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(4, 2, ctx_r0.priority), "\n");
} }
class PriorityComponent {
    constructor() {
        this.classes = {};
    }
    ngOnInit() {
        this.classes = {
            low: 'label-info',
            medium: 'label-warning',
            high: 'label-danger',
        };
    }
    getClass() {
        let returnValue;
        for (const key in this.classes) {
            if (key === this.priority) {
                returnValue = this.classes[key];
            }
        }
        return returnValue;
    }
    static { this.ɵfac = function PriorityComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PriorityComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PriorityComponent, selectors: [["mon-priority"]], inputs: { priority: "priority" }, decls: 1, vars: 1, consts: [["tabindex", "0", "class", "label text-center label-fixed", 3, "ngClass", 4, "ngIf"], ["tabindex", "0", 1, "label", "text-center", "label-fixed", 3, "ngClass"], ["translate", "", 1, "sr-only"]], template: function PriorityComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, PriorityComponent_span_0_Template, 5, 4, "span", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.classes.hasOwnProperty(ctx.priority));
        } }, dependencies: [i1$2.NgClass, i1$2.NgIf, TranslateDirective, i1$2.TitleCasePipe], styles: [".label-fixed[_ngcontent-%COMP%]{width:50px;display:block;padding:6px 0}.label-info[_ngcontent-%COMP%]{color:#4976b9}.label-warning[_ngcontent-%COMP%]{color:#ff6c00}.label-danger[_ngcontent-%COMP%]{color:#d43f3a}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PriorityComponent, [{
        type: Component,
        args: [{ selector: 'mon-priority', template: "<span tabindex=\"0\" class=\"label text-center label-fixed\" [ngClass]=\"getClass()\" *ngIf=\"classes.hasOwnProperty(priority)\">\n  <span class=\"sr-only\" translate>Priority</span>{{ priority  | titlecase }}\n</span>\n", styles: [".label-fixed{width:50px;display:block;padding:6px 0}.label-info{color:#4976b9}.label-warning{color:#ff6c00}.label-danger{color:#d43f3a}\n"] }]
    }], () => [], { priority: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(PriorityComponent, { className: "PriorityComponent" }); })();

const _c0$s = ["*"];
const _c1$d = a0 => ({ "notification-with-link": a0 });
const _c2$8 = a0 => ({ "pl-1": a0 });
const _c3$3 = (a0, a1) => [a0, a1];
function NotificationComponent_div_1_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 12);
    i0.ɵɵelement(1, "span", 13);
    i0.ɵɵelementStart(2, "span", 14);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "span", 15);
    i0.ɵɵelementStart(5, "span", 16);
    i0.ɵɵtext(6, "Check passed");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r0.faIcon);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.monAriaIconText);
} }
function NotificationComponent_div_1_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 12);
    i0.ɵɵelement(1, "span", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(1, _c3$3, ctx_r0.faIcon, ctx_r0.classColor));
} }
function NotificationComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtemplate(1, NotificationComponent_div_1_span_1_Template, 7, 2, "span", 11)(2, NotificationComponent_div_1_span_2_Template, 2, 4, "span", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.digit === 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.digit > 0);
} }
function NotificationComponent_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 18);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "number");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(2, 1, ctx_r0.digit, "1.0-0"));
} }
function NotificationComponent_span_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 18);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "number");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(2, 1, ctx_r0.digit, "1.2-2"));
} }
function NotificationComponent_span_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.setMiniDigitsColor());
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.displayPositive(ctx_r0.miniDigits), " ");
} }
class NotificationComponent {
    constructor() {
        this.allowDecimal = false;
        this.onClick = new EventEmitter();
    }
    ngOnInit() {
        this.unit = this.unit || null;
        if (this.digit < 1) {
            this.allowDecimal = true;
        }
    }
    setMiniDigitsColor() {
        let result = '';
        if (Number(this.miniDigits) < 0) {
            result = 'text-success';
        }
        else if (Number(this.miniDigits) > 0) {
            result = 'text-danger';
        }
        else if (this.miniDigits === '0') {
            result = 'text-grey';
        }
        return result;
    }
    displayPositive(num) {
        let result = num;
        if (Number(num) > 0) {
            result = '+' + result.toString();
        }
        return result !== '0' ? String(result) : '~';
    }
    static { this.ɵfac = function NotificationComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || NotificationComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: NotificationComponent, selectors: [["mon-notification"]], inputs: { priority: "priority", params: "params", link: "link", faIcon: "faIcon", title: "title", digit: "digit", classColor: "classColor", miniDigits: "miniDigits", unit: "unit", monAriaIconText: "monAriaIconText", monAriaButtonText: "monAriaButtonText", allowDecimal: "allowDecimal" }, outputs: { onClick: "onClick" }, ngContentSelectors: _c0$s, decls: 14, vars: 15, consts: [[1, "notification", "d-flex", 3, "click", "ngClass"], ["class", "mt-2 notification-icon pr-4", 4, "ngIf"], [3, "ngClass"], [1, "list-unstyled", "mb-0"], [1, "text-secondary-4"], [1, "font-size-1-5", "font-weight-300", "text-nowrap", "mt-1"], ["class", "vtop text-secondary-4", 4, "ngIf"], ["class", "font-size-0-6 vtop text-secondary-4", 3, "ngClass", 4, "ngIf"], ["unit", "unit", 1, "font-size-0-6", "vtop", "text-secondary-4", 3, "ngClass"], [1, "text-secondary-4", "mt-2"], [1, "mt-2", "notification-icon", "pr-4"], ["class", "fa-stack fa-xl", 4, "ngIf"], [1, "fa-stack", "fa-xl"], ["aria-hidden", "true", 1, "fa-stack-2x", "text-grey", "background-icon", 3, "ngClass"], [1, "sr-only"], ["aria-hidden", "true", 1, "fas", "fa-stack-1x", "check-passed"], ["translate", "", 1, "sr-only"], [1, "fa-stack-2x", 3, "ngClass"], [1, "vtop", "text-secondary-4"], [1, "font-size-0-6", "vtop", "text-secondary-4", 3, "ngClass"]], template: function NotificationComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵlistener("click", function NotificationComponent_Template_div_click_0_listener() { return ctx.onClick.emit(ctx.params); });
            i0.ɵɵtemplate(1, NotificationComponent_div_1_Template, 3, 2, "div", 1);
            i0.ɵɵelementStart(2, "div", 2)(3, "ul", 3)(4, "li", 4);
            i0.ɵɵtext(5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "li", 5);
            i0.ɵɵtemplate(7, NotificationComponent_span_7_Template, 3, 4, "span", 6)(8, NotificationComponent_span_8_Template, 3, 4, "span", 6)(9, NotificationComponent_span_9_Template, 2, 2, "span", 7);
            i0.ɵɵelementStart(10, "span", 8);
            i0.ɵɵtext(11);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(12, "li", 9);
            i0.ɵɵprojection(13);
            i0.ɵɵelementEnd()()()();
        } if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c1$d, ctx.link));
            i0.ɵɵattribute("role", ctx.link ? "button" : undefined)("aria-label", ctx.link ? ctx.monAriaButtonText : undefined);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.faIcon);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(13, _c2$8, ctx.faIcon));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.title);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.allowDecimal);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.allowDecimal);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.miniDigits);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", ctx.setMiniDigitsColor());
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", ctx.unit, " ");
        } }, dependencies: [i1$2.NgClass, i1$2.NgIf, TranslateDirective, i1$2.DecimalPipe], styles: [".fa-sm[_ngcontent-%COMP%]{font-size:.63em}.font-size-1-75[_ngcontent-%COMP%]{font-size:1.75em}.font-size-1-5[_ngcontent-%COMP%]{font-size:1.5em}.font-size-1-3[_ngcontent-%COMP%]{font-size:1.3em}.font-size-1-1[_ngcontent-%COMP%]{font-size:1.1em}.font-size-0-9[_ngcontent-%COMP%]{font-size:.9em}.font-size-0-7[_ngcontent-%COMP%]{font-size:.7em}.font-size-0-6[_ngcontent-%COMP%]{font-size:.6em}.font-size-0-54[_ngcontent-%COMP%]{font-size:.54em}.font-weight-300[_ngcontent-%COMP%]{font-weight:300}.font-weight-500[_ngcontent-%COMP%]{font-weight:500}.font-weight-400[_ngcontent-%COMP%]{font-weight:400}.notification[_ngcontent-%COMP%]{cursor:text}.notification[_ngcontent-%COMP%]   .notification-icon[_ngcontent-%COMP%]   .text-grey[_ngcontent-%COMP%]{color:#9a9d9e}.notification[_ngcontent-%COMP%]   .notification-icon[_ngcontent-%COMP%]   .check-passed[_ngcontent-%COMP%]{color:#3a853a;left:55%;top:35%;font-size:1.4em}.notification[_ngcontent-%COMP%]   .fa-xl[_ngcontent-%COMP%]{font-size:1.583em}.notification-with-link[_ngcontent-%COMP%]{cursor:pointer}.notification-with-link[_ngcontent-%COMP%]:hover, .notification-with-link[_ngcontent-%COMP%]:focus{background-color:#f3f5f7}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NotificationComponent, [{
        type: Component,
        args: [{ selector: 'mon-notification', template: "<div class=\"notification d-flex\" [ngClass]=\"{'notification-with-link' : link}\" (click)=\"onClick.emit(params)\" [attr.role]=\"link ? 'button' : undefined\" [attr.aria-label]=\"link ? monAriaButtonText : undefined\">\n    <div class=\"mt-2 notification-icon pr-4\" *ngIf=\"faIcon\">\n        <span class=\"fa-stack fa-xl\" *ngIf=\"digit === 0\">\n            <span class=\"fa-stack-2x text-grey background-icon\" [ngClass]=\"faIcon\" aria-hidden=\"true\"></span>\n            <span class=\"sr-only\">{{monAriaIconText}}</span>\n            <span class=\"fas fa-stack-1x check-passed\" aria-hidden=\"true\"></span>\n            <span class=\"sr-only\" translate>Check passed</span>\n        </span>\n\n        <span class=\"fa-stack fa-xl\" *ngIf=\"digit > 0\">\n            <span class=\"fa-stack-2x\" [ngClass]=\"[faIcon, classColor]\"></span>\n        </span>\n    </div>\n    <div [ngClass]=\"{ 'pl-1': faIcon}\">\n        <ul class=\"list-unstyled mb-0\">\n            <li class=\"text-secondary-4\">{{ title }}</li>\n            <li class=\"font-size-1-5 font-weight-300 text-nowrap mt-1\">\n                <span *ngIf=\"!this.allowDecimal\" class=\"vtop text-secondary-4\">{{ digit | number : '1.0-0' }}</span>\n                <span *ngIf=\"this.allowDecimal\" class=\"vtop text-secondary-4\">{{ digit | number : '1.2-2' }}</span>\n                <span class=\"font-size-0-6 vtop text-secondary-4\" [ngClass]=\"setMiniDigitsColor()\" *ngIf=\"miniDigits\">\n                    <!-- TODO: Refactor this method call in the template https://monsido.atlassian.net/browse/MON-1883 -->\n                    {{ displayPositive(miniDigits) }}\n                </span>\n                <span class=\"font-size-0-6 vtop text-secondary-4\" [ngClass]=\"setMiniDigitsColor()\" unit=\"unit\">\n                    {{ unit }}\n                </span>\n            </li>\n            <li class=\"text-secondary-4 mt-2\">\n                <ng-content></ng-content>\n            </li>\n        </ul>\n    </div>\n</div>\n", styles: [".fa-sm{font-size:.63em}.font-size-1-75{font-size:1.75em}.font-size-1-5{font-size:1.5em}.font-size-1-3{font-size:1.3em}.font-size-1-1{font-size:1.1em}.font-size-0-9{font-size:.9em}.font-size-0-7{font-size:.7em}.font-size-0-6{font-size:.6em}.font-size-0-54{font-size:.54em}.font-weight-300{font-weight:300}.font-weight-500{font-weight:500}.font-weight-400{font-weight:400}.notification{cursor:text}.notification .notification-icon .text-grey{color:#9a9d9e}.notification .notification-icon .check-passed{color:#3a853a;left:55%;top:35%;font-size:1.4em}.notification .fa-xl{font-size:1.583em}.notification-with-link{cursor:pointer}.notification-with-link:hover,.notification-with-link:focus{background-color:#f3f5f7}\n"] }]
    }], null, { priority: [{
            type: Input
        }], params: [{
            type: Input
        }], link: [{
            type: Input
        }], faIcon: [{
            type: Input
        }], title: [{
            type: Input
        }], digit: [{
            type: Input
        }], classColor: [{
            type: Input
        }], miniDigits: [{
            type: Input
        }], unit: [{
            type: Input
        }], monAriaIconText: [{
            type: Input
        }], monAriaButtonText: [{
            type: Input
        }], allowDecimal: [{
            type: Input
        }], onClick: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(NotificationComponent, { className: "NotificationComponent" }); })();

const _c0$r = (a0, a1) => ({ "dashboard-progress-decreased": a0, "dashboard-progress-increased": a1 });
class MonDashboardProgressBarComponent {
    ngOnInit() {
        this.changes = parseInt(this.changes, 10);
    }
    changesValue(input) {
        return Math.abs(Number(input));
    }
    static { this.ɵfac = function MonDashboardProgressBarComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MonDashboardProgressBarComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MonDashboardProgressBarComponent, selectors: [["mon-dashboard-progress-bar"]], inputs: { current: "current", changes: "changes" }, decls: 3, vars: 10, consts: [[1, "progress", "dashboard-progress-bar"], ["role", "progressbar", 1, "progress-bar", "progress-bar-success", "dashboard-progress-current"], ["role", "progressbar", 1, "progress-bar", "progress-bar-warning", 3, "ngClass"]], template: function MonDashboardProgressBarComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵelement(1, "div", 1)(2, "div", 2);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵstyleMapInterpolate1("width: ", ctx.current, "%");
            i0.ɵɵadvance();
            i0.ɵɵstyleMapInterpolate1("width: ", ctx.changesValue(ctx.changes), "%");
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(7, _c0$r, +ctx.changes < 0, +ctx.changes > 0));
        } }, dependencies: [i1$2.NgClass], styles: [".dashboard-progress-current[_ngcontent-%COMP%]{background-color:#3a853a}.dashboard-progress-increased[_ngcontent-%COMP%]{background-color:#274e6e;border-left:1px solid #F4F2F0}.dashboard-progress-decreased[_ngcontent-%COMP%]{background-color:#ff6c00;border-left:1px solid #F4F2F0}.progress.dashboard-progress-bar[_ngcontent-%COMP%]{border-radius:1px;box-shadow:none;height:3px}.progress.dashboard-progress-bar[_ngcontent-%COMP%]   .progress-bar[_ngcontent-%COMP%]{box-shadow:none}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MonDashboardProgressBarComponent, [{
        type: Component,
        args: [{ selector: 'mon-dashboard-progress-bar', template: "<div class=\"progress dashboard-progress-bar\">\n    <div class=\"progress-bar progress-bar-success dashboard-progress-current\" role=\"progressbar\" style=\"width: {{current}}%\">\n    </div>\n    <div class=\"progress-bar progress-bar-warning\" \n         [ngClass]=\"{'dashboard-progress-decreased': +changes < 0, 'dashboard-progress-increased': +changes > 0}\" \n         role=\"progressbar\" \n         style=\"width: {{changesValue(changes)}}%\">\n    </div>\n</div>", styles: [".dashboard-progress-current{background-color:#3a853a}.dashboard-progress-increased{background-color:#274e6e;border-left:1px solid #F4F2F0}.dashboard-progress-decreased{background-color:#ff6c00;border-left:1px solid #F4F2F0}.progress.dashboard-progress-bar{border-radius:1px;box-shadow:none;height:3px}.progress.dashboard-progress-bar .progress-bar{box-shadow:none}\n"] }]
    }], null, { current: [{
            type: Input
        }], changes: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(MonDashboardProgressBarComponent, { className: "MonDashboardProgressBarComponent" }); })();

const _c0$q = ["*"];
const _c1$c = a0 => ({ "pl-4": a0 });
const _c2$7 = (a0, a1) => [a0, a1];
function NotificationTextComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵelement(1, "span", 2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(1, _c2$7, ctx_r0.classColor, ctx_r0.faIcon));
} }
class NotificationTextComponent {
    static { this.ɵfac = function NotificationTextComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || NotificationTextComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: NotificationTextComponent, selectors: [["mon-notification-text"]], inputs: { faIcon: "faIcon", title: "title", text: "text", miniText: "miniText", classColor: "classColor" }, ngContentSelectors: _c0$q, decls: 13, vars: 8, consts: [["tabindex", "0", 1, "notification-text", "d-flex"], ["class", "mt-2", 4, "ngIf"], [3, "ngClass"], [1, "list-unstyled"], [1, "text-secondary-4"], [1, "font-size-1-5", "font-weight-300"], [1, "vtop", "text-secondary-4"], [1, "font-size-0-6", "vtop", "mt-1", "text-secondary-4", 3, "ngClass"], [1, "mt-2"]], template: function NotificationTextComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, NotificationTextComponent_div_1_Template, 2, 4, "div", 1);
            i0.ɵɵelementStart(2, "div", 2)(3, "ul", 3)(4, "li", 4);
            i0.ɵɵtext(5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "li", 5)(7, "span", 6);
            i0.ɵɵtext(8);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "span", 7);
            i0.ɵɵtext(10);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(11, "li", 4);
            i0.ɵɵprojection(12);
            i0.ɵɵelementEnd()()()();
        } if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.faIcon);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c1$c, ctx.faIcon));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.title);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.text);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", ctx.miniText);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", ctx.miniText, " ");
        } }, dependencies: [i1$2.NgClass, i1$2.NgIf], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NotificationTextComponent, [{
        type: Component,
        args: [{ selector: 'mon-notification-text', template: "<div class=\"notification-text d-flex\" tabindex=\"0\">\n    <div class=\"mt-2\" *ngIf=\"faIcon\">\n        <span [ngClass]=\"[classColor, faIcon]\"></span>\n    </div>\n    <div [ngClass]=\"{ 'pl-4': faIcon}\">\n        <ul class=\"list-unstyled\">\n            <li class=\"text-secondary-4\">{{ title }}</li>\n            <li class=\"font-size-1-5 font-weight-300\">\n                <span class=\"vtop text-secondary-4\">{{ text }}</span>\n                <span class=\"font-size-0-6 vtop mt-1 text-secondary-4\" [ngClass]=\"miniText\">\n                {{ miniText }}\n                </span>\n            </li>\n            <li class=\"text-secondary-4\">\n                <ng-content></ng-content>\n            </li>\n        </ul>\n    </div>\n</div>\n" }]
    }], null, { faIcon: [{
            type: Input
        }], title: [{
            type: Input
        }], text: [{
            type: Input
        }], miniText: [{
            type: Input
        }], classColor: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(NotificationTextComponent, { className: "NotificationTextComponent" }); })();

class SpinnerSnakeComponent {
    static { this.ɵfac = function SpinnerSnakeComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SpinnerSnakeComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SpinnerSnakeComponent, selectors: [["mon-spinner-snake"]], decls: 18, vars: 0, consts: [["viewBox", "0 0 64 64", 1, "mon-spinner-snake-svg"], ["stroke-width", "0"], ["cx", "24", "cy", "0", "transform", "translate(32,32)"], ["attributeName", "r", "dur", "750ms", "values", "2;3.5;3;2.5;2;1.5;1;0.5;2", "repeatCount", "indefinite"], ["cx", "16.970562748477143", "cy", "16.97056274847714", "transform", "translate(32,32)"], ["attributeName", "r", "dur", "750ms", "values", "0.5;4;3.5;3;2.5;2;1.5;1;0.5", "repeatCount", "indefinite"], ["cx", "1.4695761589768238e-15", "cy", "24", "transform", "translate(32,32)"], ["attributeName", "r", "dur", "750ms", "values", "1;0.5;4;3.5;3;2.5;2;1.5;1", "repeatCount", "indefinite"], ["cx", "-16.97056274847714", "cy", "16.970562748477143", "transform", "translate(32,32)"], ["attributeName", "r", "dur", "750ms", "values", "1.5;1;0.5;4;3.5;3;2.5;2;1.5", "repeatCount", "indefinite"], ["cx", "-24", "cy", "2.9391523179536475e-15", "transform", "translate(32,32)"], ["attributeName", "r", "dur", "750ms", "values", "2;1.5;1;0.5;4;3.5;3;2.5;2", "repeatCount", "indefinite"], ["cx", "-16.970562748477143", "cy", "-16.97056274847714", "transform", "translate(32,32)"], ["attributeName", "r", "dur", "750ms", "values", "2.5;2;1.5;1;0.5;4;3.5;3;2.5", "repeatCount", "indefinite"], ["cx", "-4.408728476930472e-15", "cy", "-24", "transform", "translate(32,32)"], ["attributeName", "r", "dur", "750ms", "values", "3;2.5;2;1.5;1;0.5;4;3.5;3", "repeatCount", "indefinite"], ["cx", "16.97056274847714", "cy", "-16.970562748477143", "transform", "translate(32,32)"], ["attributeName", "r", "dur", "750ms", "values", "3.5;3;2.5;2;1.5;1;0.5;4;3.5", "repeatCount", "indefinite"]], template: function SpinnerSnakeComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(0, "svg", 0)(1, "g", 1)(2, "circle", 2);
            i0.ɵɵelement(3, "animate", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "circle", 4);
            i0.ɵɵelement(5, "animate", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "circle", 6);
            i0.ɵɵelement(7, "animate", 7);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "circle", 8);
            i0.ɵɵelement(9, "animate", 9);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(10, "circle", 10);
            i0.ɵɵelement(11, "animate", 11);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(12, "circle", 12);
            i0.ɵɵelement(13, "animate", 13);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(14, "circle", 14);
            i0.ɵɵelement(15, "animate", 15);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(16, "circle", 16);
            i0.ɵɵelement(17, "animate", 17);
            i0.ɵɵelementEnd()()();
        } }, styles: [".mon-spinner-snake-svg[_ngcontent-%COMP%]{width:100%;height:100%;min-width:30px;min-height:30px}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SpinnerSnakeComponent, [{
        type: Component,
        args: [{ selector: 'mon-spinner-snake', template: "<svg class=\"mon-spinner-snake-svg\" viewBox=\"0 0 64 64\">\n    <g stroke-width=\"0\">\n        <circle cx=\"24\" cy=\"0\" transform=\"translate(32,32)\">\n            <animate attributeName=\"r\" dur=\"750ms\" values=\"2;3.5;3;2.5;2;1.5;1;0.5;2\" repeatCount=\"indefinite\"></animate>\n        </circle>\n        <circle cx=\"16.970562748477143\" cy=\"16.97056274847714\" transform=\"translate(32,32)\">\n            <animate attributeName=\"r\" dur=\"750ms\" values=\"0.5;4;3.5;3;2.5;2;1.5;1;0.5\" repeatCount=\"indefinite\"></animate>\n        </circle>\n        <circle cx=\"1.4695761589768238e-15\" cy=\"24\" transform=\"translate(32,32)\">\n            <animate attributeName=\"r\" dur=\"750ms\" values=\"1;0.5;4;3.5;3;2.5;2;1.5;1\" repeatCount=\"indefinite\"></animate>\n        </circle>\n        <circle cx=\"-16.97056274847714\" cy=\"16.970562748477143\" transform=\"translate(32,32)\">\n            <animate attributeName=\"r\" dur=\"750ms\" values=\"1.5;1;0.5;4;3.5;3;2.5;2;1.5\" repeatCount=\"indefinite\"></animate>\n        </circle>\n        <circle cx=\"-24\" cy=\"2.9391523179536475e-15\" transform=\"translate(32,32)\">\n            <animate attributeName=\"r\" dur=\"750ms\" values=\"2;1.5;1;0.5;4;3.5;3;2.5;2\" repeatCount=\"indefinite\"></animate>\n        </circle>\n        <circle cx=\"-16.970562748477143\" cy=\"-16.97056274847714\" transform=\"translate(32,32)\">\n            <animate attributeName=\"r\" dur=\"750ms\" values=\"2.5;2;1.5;1;0.5;4;3.5;3;2.5\" repeatCount=\"indefinite\"></animate>\n        </circle>\n        <circle cx=\"-4.408728476930472e-15\" cy=\"-24\" transform=\"translate(32,32)\">\n            <animate attributeName=\"r\" dur=\"750ms\" values=\"3;2.5;2;1.5;1;0.5;4;3.5;3\" repeatCount=\"indefinite\"></animate>\n        </circle>\n        <circle cx=\"16.97056274847714\" cy=\"-16.970562748477143\" transform=\"translate(32,32)\">\n            <animate attributeName=\"r\" dur=\"750ms\" values=\"3.5;3;2.5;2;1.5;1;0.5;4;3.5\" repeatCount=\"indefinite\"></animate>\n        </circle>\n    </g>\n</svg>\n", styles: [".mon-spinner-snake-svg{width:100%;height:100%;min-width:30px;min-height:30px}\n"] }]
    }], null, null); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(SpinnerSnakeComponent, { className: "SpinnerSnakeComponent" }); })();

class UserDatePipe {
    transform(date, format) {
        format = format || 'll';
        return this.amDateFormat(date, this.customFormats(format));
    }
    customFormats(format) {
        switch (format) {
            case 'fullDate':
                return 'dddd, MMMM D, YYYY';
            default:
                return format;
        }
    }
    amDateFormat(date, format) {
        if (!date) {
            return '';
        }
        return moment(date).format(format);
    }
    static { this.ɵfac = function UserDatePipe_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || UserDatePipe)(); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "monUserDate", type: UserDatePipe, pure: true }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UserDatePipe, [{
        type: Pipe,
        args: [{
                name: 'monUserDate',
            }]
    }], null, null); })();

function UserDateComponent_span_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 2);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "monUserDate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(2, 1, ctx_r0.date, "ll LT"));
} }
function UserDateComponent_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "monUserDate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(2, 1, ctx_r0.date, "ll"));
} }
function UserDateComponent_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 2);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "monUserDate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, ctx_r0.date, "LT"), "");
} }
class UserDateComponent {
    constructor() {
        this.twoLines = false;
    }
    static { this.ɵfac = function UserDateComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || UserDateComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: UserDateComponent, selectors: [["mon-user-date"]], inputs: { twoLines: "twoLines", date: "date" }, decls: 3, vars: 3, consts: [["class", "text-nowrap", 4, "ngIf"], ["class", "text-nowrap d-inline-block", 4, "ngIf"], [1, "text-nowrap"], [1, "text-nowrap", "d-inline-block"]], template: function UserDateComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, UserDateComponent_span_0_Template, 3, 4, "span", 0)(1, UserDateComponent_span_1_Template, 3, 4, "span", 1)(2, UserDateComponent_span_2_Template, 3, 4, "span", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.date && !ctx.twoLines);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.date && ctx.twoLines);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.date && ctx.twoLines);
        } }, dependencies: [i1$2.NgIf, UserDatePipe], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UserDateComponent, [{
        type: Component,
        args: [{ selector: 'mon-user-date', template: "<span class=\"text-nowrap\" *ngIf=\"date && !twoLines\">{{ date | monUserDate:'ll LT' }}</span>\n<span class=\"text-nowrap d-inline-block\" *ngIf=\"date && twoLines\">{{ date | monUserDate:'ll' }}</span>\n<span class=\"text-nowrap\" *ngIf=\"date && twoLines\"> {{ date | monUserDate:'LT' }}</span>\n" }]
    }], () => [], { twoLines: [{
            type: Input
        }], date: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(UserDateComponent, { className: "UserDateComponent" }); })();

class PagesButtonComponent {
    constructor(translateService) {
        this.translateService = translateService;
        this.callback = new EventEmitter();
    }
    ngOnInit() {
        this.text = this.text || this.translateService.getString('page');
        this.textPlural = this.textPlural || this.translateService.getString('pages');
        if (this.monAriaLabel) {
            this.label = `${this.monAriaLabel} ${this.parseModel()} ${this.text}`;
        }
    }
    parseModel() {
        return this.pagesAmount?.toLocaleString() || '0';
    }
    clickCallback(e) {
        e.preventDefault();
        this.callback.emit();
    }
    static { this.ɵfac = function PagesButtonComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PagesButtonComponent)(i0.ɵɵdirectiveInject(TranslateServiceInjectionToken)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PagesButtonComponent, selectors: [["mon-pages-button"]], inputs: { pagesAmount: "pagesAmount", monAriaLabel: "monAriaLabel", text: "text", textPlural: "textPlural" }, outputs: { callback: "callback" }, decls: 5, vars: 3, consts: [[1, "btn", "button-monsido-icon", "text-right", 3, "click"], [1, "page-count"], [1, "page-text"]], template: function PagesButtonComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "button", 0);
            i0.ɵɵlistener("click", function PagesButtonComponent_Template_button_click_0_listener($event) { return ctx.clickCallback($event); });
            i0.ɵɵelementStart(1, "div", 1);
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 2);
            i0.ɵɵtext(4);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵattribute("aria-label", ctx.label || ctx.text);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.parseModel());
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.parseModel() === "1" ? ctx.text : ctx.textPlural);
        } }, styles: [".button-monsido-icon[_ngcontent-%COMP%]   .page-count[_ngcontent-%COMP%]{color:#1c86db;font-size:1.3em;font-weight:300}.button-monsido-icon[_ngcontent-%COMP%]   .page-text[_ngcontent-%COMP%]{text-transform:uppercase;font-size:.9em}.button-monsido-icon.text-right[_ngcontent-%COMP%]{text-align:right}.button-monsido-icon[_ngcontent-%COMP%]   .page-count[_ngcontent-%COMP%], .button-monsido-icon[_ngcontent-%COMP%]   .page-text[_ngcontent-%COMP%]{line-height:16px}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PagesButtonComponent, [{
        type: Component,
        args: [{ selector: 'mon-pages-button', template: "<button [attr.aria-label]=\"label || text\"\n   class=\"btn button-monsido-icon text-right\"\n   (click)=\"clickCallback($event)\">\n    <div class=\"page-count\">{{ parseModel() }}</div>\n    <div class=\"page-text\">{{ parseModel() === '1' ? text : textPlural}}</div>\n</button>\n", styles: [".button-monsido-icon .page-count{color:#1c86db;font-size:1.3em;font-weight:300}.button-monsido-icon .page-text{text-transform:uppercase;font-size:.9em}.button-monsido-icon.text-right{text-align:right}.button-monsido-icon .page-count,.button-monsido-icon .page-text{line-height:16px}\n"] }]
    }], () => [{ type: undefined, decorators: [{
                type: Inject,
                args: [TranslateServiceInjectionToken]
            }] }], { pagesAmount: [{
            type: Input
        }], monAriaLabel: [{
            type: Input
        }], text: [{
            type: Input
        }], textPlural: [{
            type: Input
        }], callback: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(PagesButtonComponent, { className: "PagesButtonComponent" }); })();

const _c0$p = ["*"];
const _c1$b = a0 => ({ "mb-1": a0 });
function MonPanelHeaderComponent_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 8);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.faIcon);
} }
function MonPanelHeaderComponent_p_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p", 9);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", ctx_r0.subHeader, i0.ɵɵsanitizeHtml);
} }
class MonPanelHeaderComponent {
    constructor(el) {
        this.el = el;
        this.pHeader = '';
        this.subHeader = '';
        this.faIcon = '';
        this.eClass = '';
        this.transcludeClass = '';
        this.hideHr = '';
    }
    ngOnInit() {
        this.eClass += this.hideHr ? ' no-border' : '';
        this.hideTransclude = !this.showTransclude();
    }
    showTransclude() {
        return (this.el.nativeElement.querySelector('.mon-panel-header-transclude')
            .children.length > 0);
    }
    static { this.ɵfac = function MonPanelHeaderComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MonPanelHeaderComponent)(i0.ɵɵdirectiveInject(i0.ElementRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MonPanelHeaderComponent, selectors: [["mon-panel-header"]], inputs: { pHeader: "pHeader", subHeader: "subHeader", faIcon: "faIcon", eClass: "eClass", transcludeClass: "transcludeClass", hideHr: "hideHr" }, ngContentSelectors: _c0$p, decls: 9, vars: 9, consts: [[1, "mon-panel-header", "panel-heading", 3, "ngClass"], [1, "d-flex", "align-items-center"], ["class", "fa-2x", 3, "ngClass", 4, "ngIf"], [1, "mr-auto", "text-ellipsis"], [1, "font-weight-300", "text-ellipsis", 3, "ngClass"], [3, "innerHTML"], ["class", "text-grey text-ellipsis", 3, "innerHTML", 4, "ngIf"], [1, "mon-panel-header-transclude", 3, "hidden", "ngClass"], [1, "fa-2x", 3, "ngClass"], [1, "text-grey", "text-ellipsis", 3, "innerHTML"]], template: function MonPanelHeaderComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵtemplate(2, MonPanelHeaderComponent_span_2_Template, 1, 1, "span", 2);
            i0.ɵɵelementStart(3, "div", 3)(4, "h2", 4);
            i0.ɵɵelement(5, "span", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, MonPanelHeaderComponent_p_6_Template, 1, 1, "p", 6);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "div", 7);
            i0.ɵɵprojection(8);
            i0.ɵɵelementEnd()()();
        } if (rf & 2) {
            i0.ɵɵproperty("ngClass", ctx.eClass);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.faIcon);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c1$b, ctx.subHeader));
            i0.ɵɵadvance();
            i0.ɵɵproperty("innerHTML", ctx.pHeader, i0.ɵɵsanitizeHtml);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.subHeader);
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.hideTransclude)("ngClass", ctx.transcludeClass);
        } }, dependencies: [i1$2.NgClass, i1$2.NgIf], styles: [".mon-panel-header[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%]{font-size:18px;margin-bottom:0;margin-top:0;line-height:1.4}.mon-panel-header[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding-right:8px}.mon-panel-header.panel-heading.no-border[_ngcontent-%COMP%]{border-color:transparent}.mon-panel-header.panel-heading[_ngcontent-%COMP%]{padding:15px 15px 15px 20px;border-bottom:1px solid #E6E6E6;border-top-right-radius:3px;border-top-left-radius:3px}.mon-panel-header[_ngcontent-%COMP%]   hr[_ngcontent-%COMP%]{color:transparent;border-color:transparent;margin:0;border-width:0}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MonPanelHeaderComponent, [{
        type: Component,
        args: [{ selector: 'mon-panel-header', template: "<div class=\"mon-panel-header panel-heading\" [ngClass]=\"eClass\">\n  <div class=\"d-flex align-items-center\">\n      <span *ngIf=\"faIcon\" class=\"fa-2x\" [ngClass]=\"faIcon\"></span>\n      <div class=\"mr-auto text-ellipsis\">\n          <h2 class=\"font-weight-300 text-ellipsis\" [ngClass]=\"{'mb-1': subHeader}\">\n              <span [innerHTML]=\"pHeader\"></span>\n          </h2>\n          <p class=\"text-grey text-ellipsis\" *ngIf=\"subHeader\" [innerHTML]=\"subHeader\"></p>\n      </div>\n      <div class=\"mon-panel-header-transclude\" [hidden]=\"hideTransclude\" [ngClass]=\"transcludeClass\">\n          <ng-content></ng-content>\n      </div>\n  </div>\n</div>\n", styles: [".mon-panel-header h2{font-size:18px;margin-bottom:0;margin-top:0;line-height:1.4}.mon-panel-header span{padding-right:8px}.mon-panel-header.panel-heading.no-border{border-color:transparent}.mon-panel-header.panel-heading{padding:15px 15px 15px 20px;border-bottom:1px solid #E6E6E6;border-top-right-radius:3px;border-top-left-radius:3px}.mon-panel-header hr{color:transparent;border-color:transparent;margin:0;border-width:0}\n"] }]
    }], () => [{ type: i0.ElementRef }], { pHeader: [{
            type: Input
        }], subHeader: [{
            type: Input
        }], faIcon: [{
            type: Input
        }], eClass: [{
            type: Input
        }], transcludeClass: [{
            type: Input
        }], hideHr: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(MonPanelHeaderComponent, { className: "MonPanelHeaderComponent" }); })();

const _c0$o = [[["", "slot", "mon-panel-tabs"]], [["", "slot", "mon-panel-body"]], [["", "slot", "mon-panel-header"]]];
const _c1$a = ["[slot=mon-panel-tabs]", "[slot=mon-panel-body]", "[slot=mon-panel-header]"];
function MonPanelComponent_mon_panel_header_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mon-panel-header", 3);
    i0.ɵɵprojection(1, 2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("faIcon", ctx_r0.faIcon);
    i0.ɵɵpropertyInterpolate("pHeader", ctx_r0.header);
    i0.ɵɵpropertyInterpolate("subHeader", ctx_r0.subHeader);
    i0.ɵɵproperty("hideHr", ctx_r0.hideHr);
} }
class MonPanelComponent {
    constructor() {
        this.showHeader = true;
        this.onSearch = new EventEmitter();
        this.onStatus = new EventEmitter();
    }
    doSearch(text) {
        this.search = text;
        this.onSearch.emit(this.search);
    }
    doStatus(status) {
        this.activeTab = status;
        this.onStatus.emit(this.activeTab);
    }
    static { this.ɵfac = function MonPanelComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MonPanelComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MonPanelComponent, selectors: [["mon-panel"]], inputs: { header: "header", subHeader: "subHeader", faIcon: "faIcon", panelClass: "panelClass", hideHr: "hideHr", showHeader: "showHeader", tabOptions: "tabOptions", activeTab: "activeTab", maxTabsDisplay: "maxTabsDisplay", search: "search", minSearchLength: "minSearchLength", showSearch: "showSearch" }, outputs: { onSearch: "onSearch", onStatus: "onStatus" }, ngContentSelectors: _c1$a, decls: 5, vars: 8, consts: [[3, "onStatus", "onSearch", "options", "showSearch", "status", "search", "minSearchLength", "maxOptionsDisplay"], [1, "panel", "panel-monsido-card", "mon-panel", 3, "ngClass"], [3, "faIcon", "pHeader", "subHeader", "hideHr", 4, "ngIf"], [3, "faIcon", "pHeader", "subHeader", "hideHr"]], template: function MonPanelComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c0$o);
            i0.ɵɵelementStart(0, "mon-tabs", 0);
            i0.ɵɵlistener("onStatus", function MonPanelComponent_Template_mon_tabs_onStatus_0_listener($event) { return ctx.doStatus($event); })("onSearch", function MonPanelComponent_Template_mon_tabs_onSearch_0_listener($event) { return ctx.doSearch($event); });
            i0.ɵɵprojection(1);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "div", 1);
            i0.ɵɵtemplate(3, MonPanelComponent_mon_panel_header_3_Template, 2, 4, "mon-panel-header", 2);
            i0.ɵɵprojection(4, 1);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("options", ctx.tabOptions)("showSearch", ctx.showSearch)("status", ctx.activeTab)("search", ctx.search)("minSearchLength", ctx.minSearchLength)("maxOptionsDisplay", ctx.maxTabsDisplay);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngClass", ctx.panelClass);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.showHeader);
        } }, dependencies: [i1$2.NgClass, i1$2.NgIf, TabsComponent, MonPanelHeaderComponent], styles: [".panel-monsido-card[_ngcontent-%COMP%]{border-radius:2px;box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}.panel-monsido-card[_ngcontent-%COMP%]   .panel-heading[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%], .panel-monsido-card[_ngcontent-%COMP%]   .panel-heading[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%], .panel-monsido-card[_ngcontent-%COMP%]   .panel-heading[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%], .panel-monsido-card[_ngcontent-%COMP%]   .panel-heading[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%], .panel-monsido-card[_ngcontent-%COMP%]   .panel-heading[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{margin-top:7px}.panel-monsido-card[_ngcontent-%COMP%]   .mon-panel-body[_ngcontent-%COMP%]{padding-top:30px;padding-bottom:30px}.panel-group[_ngcontent-%COMP%]   .panel[_ngcontent-%COMP%]   .panel-heading[_ngcontent-%COMP%]   h4.panel-title[_ngcontent-%COMP%]{font-size:21px}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MonPanelComponent, [{
        type: Component,
        args: [{ selector: 'mon-panel', template: "<mon-tabs\n    [options]=\"tabOptions\"\n    [showSearch]=\"showSearch\"\n    [status]=\"activeTab\"\n    (onStatus)=\"doStatus($event)\"\n    (onSearch)=\"doSearch($event)\"\n    [search]=\"search\"\n    [minSearchLength]=\"minSearchLength\"\n    [maxOptionsDisplay]=\"maxTabsDisplay\">\n    <ng-content select=\"[slot=mon-panel-tabs]\"></ng-content>\n</mon-tabs>\n<div class=\"panel panel-monsido-card mon-panel\" [ngClass]=\"panelClass\">\n    <mon-panel-header faIcon=\"{{faIcon}}\"\n                      pHeader=\"{{header}}\"\n                      subHeader=\"{{subHeader}}\"\n                      [hideHr]=\"hideHr\"\n                      *ngIf=\"showHeader\">\n        <ng-content select=\"[slot=mon-panel-header]\"></ng-content>\n    </mon-panel-header>\n    <ng-content select=\"[slot=mon-panel-body]\"></ng-content>\n</div>\n", styles: [".panel-monsido-card{border-radius:2px;box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}.panel-monsido-card .panel-heading h1,.panel-monsido-card .panel-heading h2,.panel-monsido-card .panel-heading h3,.panel-monsido-card .panel-heading h4,.panel-monsido-card .panel-heading h5{margin-top:7px}.panel-monsido-card .mon-panel-body{padding-top:30px;padding-bottom:30px}.panel-group .panel .panel-heading h4.panel-title{font-size:21px}\n"] }]
    }], null, { header: [{
            type: Input
        }], subHeader: [{
            type: Input
        }], faIcon: [{
            type: Input
        }], panelClass: [{
            type: Input
        }], hideHr: [{
            type: Input
        }], showHeader: [{
            type: Input
        }], tabOptions: [{
            type: Input
        }], activeTab: [{
            type: Input
        }], maxTabsDisplay: [{
            type: Input
        }], search: [{
            type: Input
        }], minSearchLength: [{
            type: Input
        }], showSearch: [{
            type: Input
        }], onSearch: [{
            type: Output
        }], onStatus: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(MonPanelComponent, { className: "MonPanelComponent" }); })();

class DocumentsButtonComponent {
    constructor() { }
    static { this.ɵfac = function DocumentsButtonComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DocumentsButtonComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DocumentsButtonComponent, selectors: [["mon-documents-button"]], inputs: { ngModel: "ngModel", callback: "callback" }, decls: 1, vars: 3, consts: [[3, "callback", "pagesAmount", "text", "textPlural"]], template: function DocumentsButtonComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "mon-pages-button", 0);
            i0.ɵɵlistener("callback", function DocumentsButtonComponent_Template_mon_pages_button_callback_0_listener() { return ctx.callback(); });
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("pagesAmount", ctx.ngModel)("text", "document")("textPlural", "documents");
        } }, dependencies: [PagesButtonComponent], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DocumentsButtonComponent, [{
        type: Component,
        args: [{ selector: 'mon-documents-button', template: "<mon-pages-button [pagesAmount]=\"ngModel\"\n                  [text]=\"'document'\"\n                  (callback)=\"callback()\"\n                  [textPlural]=\"'documents'\">\n</mon-pages-button>" }]
    }], () => [], { ngModel: [{
            type: Input
        }], callback: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DocumentsButtonComponent, { className: "DocumentsButtonComponent" }); })();

class VisitsComponent {
    ngOnInit() {
        this.progress = 0;
        if (this.totalVisits > 0) {
            this.progress = (this.visits / this.totalVisits) * 100;
        }
        if (this.progress > 100) {
            this.progress = 100;
        }
        if (this.progress < 0) {
            this.progress = 0;
        }
    }
    static { this.ɵfac = function VisitsComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || VisitsComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: VisitsComponent, selectors: [["mon-visits"]], inputs: { title: "title", visits: "visits", totalVisits: "totalVisits", removeNumber: "removeNumber" }, decls: 8, vars: 6, consts: [[1, "visits-progress-bar"], ["tabindex", "0", 1, "text-end", 3, "hidden"], ["translate", "", 1, "sr-only"], ["aria-hidden", "true", 1, "progress-xxs", "progress-square"], [3, "value"]], template: function VisitsComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "span", 2);
            i0.ɵɵtext(3, " Visits ");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(4);
            i0.ɵɵpipe(5, "number");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "div", 3);
            i0.ɵɵelement(7, "ngb-progressbar", 4);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.removeNumber);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(5, 3, ctx.visits, "1.0-0"), " ");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("value", ctx.progress);
        } }, dependencies: [TranslateDirective, i1$4.NgbProgressbar, i1$2.DecimalPipe], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VisitsComponent, [{
        type: Component,
        args: [{ selector: 'mon-visits', template: "<div class=\"visits-progress-bar\">\n    <div [hidden]=\"removeNumber\" class=\"text-end\" tabindex=\"0\">\n        <span class=\"sr-only\" translate>\n            Visits\n        </span>\n        {{ visits | number : '1.0-0' }}\n    </div>\n    <div class=\"progress-xxs progress-square\" aria-hidden=\"true\">\n        <ngb-progressbar [value]=\"progress\"></ngb-progressbar>\n    </div>\n\n</div>\n" }]
    }], null, { title: [{
            type: Input
        }], visits: [{
            type: Input
        }], totalVisits: [{
            type: Input
        }], removeNumber: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(VisitsComponent, { className: "VisitsComponent" }); })();

class LayoutModule {
    static { this.ɵfac = function LayoutModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || LayoutModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: LayoutModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, NgbTooltipModule, TranslateModule, TabsModule, IconsModule, NgbProgressbarModule, IconsModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LayoutModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, NgbTooltipModule, TranslateModule, TabsModule, IconsModule, NgbProgressbarModule],
                declarations: [
                    PageHeaderComponent,
                    UrlTitleComponent,
                    MonSpinnerComponent,
                    SpinnerSnakeComponent,
                    PriorityComponent,
                    NotificationChangeComponent,
                    NotificationComponent,
                    MonDashboardProgressBarComponent,
                    NotificationTextComponent,
                    UserDateComponent,
                    UserDatePipe,
                    DocumentsButtonComponent,
                    MonPanelComponent,
                    MonPanelHeaderComponent,
                    PagesButtonComponent,
                    VisitsComponent,
                ],
                exports: [
                    PageHeaderComponent,
                    UrlTitleComponent,
                    MonSpinnerComponent,
                    SpinnerSnakeComponent,
                    PriorityComponent,
                    NotificationChangeComponent,
                    NotificationComponent,
                    MonDashboardProgressBarComponent,
                    NotificationTextComponent,
                    UserDateComponent,
                    UserDatePipe,
                    PagesButtonComponent,
                    MonPanelComponent,
                    MonPanelHeaderComponent,
                    DocumentsButtonComponent,
                    IconsModule,
                    VisitsComponent,
                ],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LayoutModule, { declarations: [PageHeaderComponent,
        UrlTitleComponent,
        MonSpinnerComponent,
        SpinnerSnakeComponent,
        PriorityComponent,
        NotificationChangeComponent,
        NotificationComponent,
        MonDashboardProgressBarComponent,
        NotificationTextComponent,
        UserDateComponent,
        UserDatePipe,
        DocumentsButtonComponent,
        MonPanelComponent,
        MonPanelHeaderComponent,
        PagesButtonComponent,
        VisitsComponent], imports: [CommonModule, NgbTooltipModule, TranslateModule, TabsModule, IconsModule, NgbProgressbarModule], exports: [PageHeaderComponent,
        UrlTitleComponent,
        MonSpinnerComponent,
        SpinnerSnakeComponent,
        PriorityComponent,
        NotificationChangeComponent,
        NotificationComponent,
        MonDashboardProgressBarComponent,
        NotificationTextComponent,
        UserDateComponent,
        UserDatePipe,
        PagesButtonComponent,
        MonPanelComponent,
        MonPanelHeaderComponent,
        DocumentsButtonComponent,
        IconsModule,
        VisitsComponent] }); })();

function ErrorMessagesComponent_div_0_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵtext(1, "This field is required");
    i0.ɵɵelementEnd();
} }
function ErrorMessagesComponent_div_0_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵtext(1, "Too few characters");
    i0.ɵɵelementEnd();
} }
function ErrorMessagesComponent_div_0_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵtext(1, "Too many characters");
    i0.ɵɵelementEnd();
} }
function ErrorMessagesComponent_div_0_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.patternMsg);
} }
function ErrorMessagesComponent_div_0_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵtext(1, "Invalid email");
    i0.ɵɵelementEnd();
} }
function ErrorMessagesComponent_div_0_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵtext(1, "Number too low");
    i0.ɵɵelementEnd();
} }
function ErrorMessagesComponent_div_0_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵtext(1, "Number too high");
    i0.ɵɵelementEnd();
} }
function ErrorMessagesComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, ErrorMessagesComponent_div_0_span_1_Template, 2, 0, "span", 1)(2, ErrorMessagesComponent_div_0_span_2_Template, 2, 0, "span", 1)(3, ErrorMessagesComponent_div_0_span_3_Template, 2, 0, "span", 1)(4, ErrorMessagesComponent_div_0_span_4_Template, 2, 1, "span", 2)(5, ErrorMessagesComponent_div_0_span_5_Template, 2, 0, "span", 1)(6, ErrorMessagesComponent_div_0_span_6_Template, 2, 0, "span", 1)(7, ErrorMessagesComponent_div_0_span_7_Template, 2, 0, "span", 1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate2("invalid-feedback block col-sm-", ctx_r0.gridSize, " col-sm-offset-", ctx_r0.offset, "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.errors.required);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.errors.minlength);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.errors.maxlength);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.errors.pattern);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.errors.email);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.errors.min);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.errors.max);
} }
/**
 *
 * @deprecated Use the {@link ErrorMessagesAcComponent} instead.
 */
class ErrorMessagesComponent {
    constructor() {
        this.offsetValue = 8;
        this.gridSize = 48 - this.offsetValue;
    }
    set offset(offset) {
        this.offsetValue = offset;
        this.gridSize = 48 - this.offsetValue;
    }
    get offset() {
        return this.offsetValue;
    }
    static { this.ɵfac = function ErrorMessagesComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ErrorMessagesComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ErrorMessagesComponent, selectors: [["mon-form-field-errors"]], inputs: { offset: "offset", patternMsg: "patternMsg", showError: "showError", errors: "errors" }, decls: 1, vars: 1, consts: [[3, "class", 4, "ngIf"], ["class", "help-block", "translate", "", 4, "ngIf"], ["class", "help-block", 4, "ngIf"], ["translate", "", 1, "help-block"], [1, "help-block"]], template: function ErrorMessagesComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ErrorMessagesComponent_div_0_Template, 8, 11, "div", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.showError);
        } }, dependencies: [i1$2.NgIf], styles: [".invalid-feedback[_ngcontent-%COMP%]{display:flex;flex-direction:column}.invalid-feedback[_ngcontent-%COMP%]   .help-block[_ngcontent-%COMP%]{color:#ba322d}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ErrorMessagesComponent, [{
        type: Component,
        args: [{ selector: 'mon-form-field-errors', template: "<div class=\"invalid-feedback block col-sm-{{ gridSize }} col-sm-offset-{{ offset }}\" *ngIf=\"showError\">\n    <span class=\"help-block\" *ngIf=\"errors.required\" translate>This field is required</span>\n    <span class=\"help-block\" *ngIf=\"errors.minlength\" translate>Too few characters</span>\n    <span class=\"help-block\" *ngIf=\"errors.maxlength\" translate>Too many characters</span>\n    <span class=\"help-block\" *ngIf=\"errors.pattern\">{{ patternMsg }}</span>\n    <span class=\"help-block\" *ngIf=\"errors.email\" translate>Invalid email</span>\n    <span class=\"help-block\" *ngIf=\"errors.min\" translate>Number too low</span>\n    <span class=\"help-block\" *ngIf=\"errors.max\" translate>Number too high</span>\n</div>\n", styles: [".invalid-feedback{display:flex;flex-direction:column}.invalid-feedback .help-block{color:#ba322d}\n"] }]
    }], null, { offset: [{
            type: Input
        }], patternMsg: [{
            type: Input
        }], showError: [{
            type: Input
        }], errors: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ErrorMessagesComponent, { className: "ErrorMessagesComponent" }); })();

class EmailValidatorDirective {
    validate(control) {
        return Validators.email(control);
    }
    static { this.ɵfac = function EmailValidatorDirective_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || EmailValidatorDirective)(); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: EmailValidatorDirective, selectors: [["", "monEmailValidator", ""]], features: [i0.ɵɵProvidersFeature([{ provide: NG_VALIDATORS, useExisting: EmailValidatorDirective, multi: true }])] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EmailValidatorDirective, [{
        type: Directive,
        args: [{
                selector: '[monEmailValidator]',
                providers: [{ provide: NG_VALIDATORS, useExisting: EmailValidatorDirective, multi: true }],
            }]
    }], null, null); })();

class ValidateUrlDirective {
    validate(control) {
        try {
            new URL(control.value);
            return null;
        }
        catch {
            return { invalidUrl: true };
        }
    }
    static { this.ɵfac = function ValidateUrlDirective_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ValidateUrlDirective)(); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: ValidateUrlDirective, selectors: [["", "monValidateUrl", ""]], features: [i0.ɵɵProvidersFeature([{ provide: NG_VALIDATORS, useExisting: ValidateUrlDirective, multi: true }])] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ValidateUrlDirective, [{
        type: Directive,
        args: [{
                selector: '[monValidateUrl]',
                providers: [{ provide: NG_VALIDATORS, useExisting: ValidateUrlDirective, multi: true }],
            }]
    }], null, null); })();

class FormBuilderValidationModule {
    static { this.ɵfac = function FormBuilderValidationModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FormBuilderValidationModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: FormBuilderValidationModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormBuilderValidationModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                exports: [ErrorMessagesComponent, ErrorMessagesAcComponent, EmailValidatorDirective, ValidateUrlDirective],
                declarations: [ErrorMessagesComponent, ErrorMessagesAcComponent, EmailValidatorDirective, ValidateUrlDirective],
                providers: [],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(FormBuilderValidationModule, { declarations: [ErrorMessagesComponent, ErrorMessagesAcComponent, EmailValidatorDirective, ValidateUrlDirective], imports: [CommonModule], exports: [ErrorMessagesComponent, ErrorMessagesAcComponent, EmailValidatorDirective, ValidateUrlDirective] }); })();

class FormBuilderCheckboxModule {
    static { this.ɵfac = function FormBuilderCheckboxModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FormBuilderCheckboxModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: FormBuilderCheckboxModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [FormsModule, CommonModule, FormBuilderValidationModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormBuilderCheckboxModule, [{
        type: NgModule,
        args: [{
                imports: [FormsModule, CommonModule, FormBuilderValidationModule],
                exports: [CheckboxComponent],
                declarations: [CheckboxComponent],
                providers: [],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(FormBuilderCheckboxModule, { declarations: [CheckboxComponent], imports: [FormsModule, CommonModule, FormBuilderValidationModule], exports: [CheckboxComponent] }); })();

class DaterangepickerModule {
    static { this.ɵfac = function DaterangepickerModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DaterangepickerModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: DaterangepickerModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({}); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DaterangepickerModule, [{
        type: NgModule,
        args: [{
                declarations: [DaterangepickerDirective],
                imports: [],
                exports: [DaterangepickerDirective],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(DaterangepickerModule, { declarations: [DaterangepickerDirective], exports: [DaterangepickerDirective] }); })();

class MonDatePickerModule {
    static { this.ɵfac = function MonDatePickerModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MonDatePickerModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: MonDatePickerModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            DaterangepickerModule,
            LayoutModule,
            TranslateModule,
            MonSimpleDateRangeModule,
            IconsModule,
            FormBuilderCheckboxModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MonDatePickerModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    DaterangepickerModule,
                    LayoutModule,
                    TranslateModule,
                    MonSimpleDateRangeModule,
                    IconsModule,
                    FormBuilderCheckboxModule
                ],
                exports: [MonDatePickerComponent],
                declarations: [MonDatePickerComponent],
                providers: [],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(MonDatePickerModule, { declarations: [MonDatePickerComponent], imports: [CommonModule,
        DaterangepickerModule,
        LayoutModule,
        TranslateModule,
        MonSimpleDateRangeModule,
        IconsModule,
        FormBuilderCheckboxModule], exports: [MonDatePickerComponent] }); })();

const ROLLBAR_CONFIGURATION = new InjectionToken('Rollbar Configuration');
/**
 * @deprecated Use mon-services repo instead.
 */
class RollbarService {
    constructor(options) {
        this.rollbar = new Rollbar(options);
    }
    configure(options) {
        return this.rollbar.configure(options);
    }
    handleError(...args) {
        this.rollbar.error(args);
    }
    log(message, error, data, callback) {
        return this.rollbar.log(message, error, data, callback);
    }
    info(message, error, data, callback) {
        return this.rollbar.info(message, error, data, callback);
    }
    warn(message, error, data, callback) {
        return this.rollbar.warn(message, error, data, callback);
    }
    error(message, error, data, callback) {
        return this.rollbar.error(message, error, data, callback);
    }
    critical(message, error, data, callback) {
        return this.rollbar.critical(message, error, data, callback);
    }
    static { this.ɵfac = function RollbarService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || RollbarService)(i0.ɵɵinject(ROLLBAR_CONFIGURATION)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: RollbarService, factory: RollbarService.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RollbarService, [{
        type: Injectable
    }], () => [{ type: undefined, decorators: [{
                type: Inject,
                args: [ROLLBAR_CONFIGURATION]
            }] }], null); })();

class RollbarModule {
    static forRoot(config) {
        return {
            ngModule: RollbarModule,
            providers: [{ provide: ROLLBAR_CONFIGURATION, useValue: config }],
        };
    }
    static { this.ɵfac = function RollbarModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || RollbarModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: RollbarModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [RollbarService] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RollbarModule, [{
        type: NgModule,
        args: [{
                providers: [RollbarService],
            }]
    }], null, null); })();

class MonPromptComponentModule {
    static { this.ɵfac = function MonPromptComponentModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MonPromptComponentModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: MonPromptComponentModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [NgbActiveModal], imports: [TranslateModule, CommonModule, FormsModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MonPromptComponentModule, [{
        type: NgModule,
        args: [{
                imports: [TranslateModule, CommonModule, FormsModule],
                declarations: [MonPromptComponent],
                exports: [MonPromptComponent],
                providers: [NgbActiveModal],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(MonPromptComponentModule, { declarations: [MonPromptComponent], imports: [TranslateModule, CommonModule, FormsModule], exports: [MonPromptComponent] }); })();

class MonPromptComponentsModule {
    static { this.ɵfac = function MonPromptComponentsModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MonPromptComponentsModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: MonPromptComponentsModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, MonPromptComponentModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MonPromptComponentsModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                exports: [MonPromptComponentModule],
                declarations: [],
                providers: [],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(MonPromptComponentsModule, { imports: [CommonModule], exports: [MonPromptComponentModule] }); })();

class MonPromptModule {
    static { this.ɵfac = function MonPromptModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MonPromptModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: MonPromptModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [MonPromptService], imports: [CommonModule, MonPromptComponentsModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MonPromptModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                exports: [MonPromptComponentsModule],
                declarations: [],
                providers: [MonPromptService],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(MonPromptModule, { imports: [CommonModule], exports: [MonPromptComponentsModule] }); })();

/* eslint-disable @typescript-eslint/no-explicit-any */
const _c0$n = ["ngxSelect"];
const _c1$9 = (a0, a1) => ({ "sr-only": a0, "col-sm-8 col-form-label text-bold capitalize-first-letter pt-1 text-right": a1 });
const _c2$6 = a0 => ({ "background-color": a0 });
function SelectComponent_label_1_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function SelectComponent_label_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 6);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, SelectComponent_label_1_span_2_Template, 2, 0, "span", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(4, _c1$9, ctx_r0.monSrOnlyLabel, !ctx_r0.monSrOnlyLabel));
    i0.ɵɵattribute("for", ctx_r0.getLabelForId(ctx_r0.monLabel));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.monLabel, "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.monRequired);
} }
function SelectComponent_ngx_select_3_ng_template_2_span_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 12);
} if (rf & 2) {
    const option_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(1, _c2$6, option_r3.data.color));
} }
function SelectComponent_ngx_select_3_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, SelectComponent_ngx_select_3_ng_template_2_span_0_Template, 1, 3, "span", 10);
    i0.ɵɵelement(1, "span", 11);
} if (rf & 2) {
    const text_r4 = ctx.text;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r0.monShowColors);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHtml", text_r4, i0.ɵɵsanitizeHtml);
} }
function SelectComponent_ngx_select_3_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ngx-select", 8, 0);
    i0.ɵɵlistener("selectionChanges", function SelectComponent_ngx_select_3_Template_ngx_select_selectionChanges_0_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.changeEvent.emit($event)); })("click", function SelectComponent_ngx_select_3_Template_ngx_select_click_0_listener() { i0.ɵɵrestoreView(_r2); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.onSelectClick()); });
    i0.ɵɵtwoWayListener("ngModelChange", function SelectComponent_ngx_select_3_Template_ngx_select_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r0 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r0.model, $event) || (ctx_r0.model = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵtemplate(2, SelectComponent_ngx_select_3_ng_template_2_Template, 2, 2, "ng-template", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("allowClear", ctx_r0.monAllowClear)("autoClearSearch", ctx_r0.monAutoClearSearch)("name", ctx_r0.monName)("required", ctx_r0.monRequired)("disabled", ctx_r0.monDisabled)("placeholder", ctx_r0.monPlaceholder)("multiple", ctx_r0.monMultiple)("optionTextField", ctx_r0.monNameAttr)("optionValueField", ctx_r0.monReturnValue)("items", ctx_r0.monOptions)("size", ctx_r0.monSize)("noAutoComplete", ctx_r0.monNoAutoComplete);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r0.model);
    i0.ɵɵattribute("data-size", ctx_r0.monSize);
} }
function SelectComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.monHelpText);
} }
class SelectComponent extends BaseFieldComponent {
    constructor() {
        super(...arguments);
        this.modelChange = new EventEmitter();
        this.monPlaceholder = '';
        this.monDefaultOptions = 'Choose an option';
        this.monReturnValue = '';
        this.monRequired = false;
        this.monMultiple = false;
        this.monGroup = 'group';
        this.monNameAttr = 'name';
        this.monRemoveButton = false;
        this.monDisabled = false;
        this.monDisableSearch = false;
        this.monSize = 'small';
        this.monShowColors = false;
        this.monAutoClearSearch = true;
        this.changeEvent = new EventEmitter();
    }
    get model() {
        return this.modelValue;
    }
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    set model(val) {
        this.modelValue = val;
        this.modelChange.emit(this.modelValue);
    }
    ngOnInit() {
        this.containerWidth = this.monLabel && !this.monSrOnlyLabel ? 'col-sm-40' : 'col-sm-48';
    }
    onSelectClick() {
        this.ngxSelect.optionsOpen();
    }
    static { this.ɵfac = /*@__PURE__*/ (() => { let ɵSelectComponent_BaseFactory; return function SelectComponent_Factory(__ngFactoryType__) { return (ɵSelectComponent_BaseFactory || (ɵSelectComponent_BaseFactory = i0.ɵɵgetInheritedFactory(SelectComponent)))(__ngFactoryType__ || SelectComponent); }; })(); }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SelectComponent, selectors: [["mon-form-field-select"]], viewQuery: function SelectComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$n, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.ngxSelect = _t.first);
        } }, inputs: { model: "model", monAllowClear: "monAllowClear", monPlaceholder: "monPlaceholder", monSrOnlyLabel: "monSrOnlyLabel", monOptions: "monOptions", monLabel: "monLabel", monHelpText: "monHelpText", monDefaultOptions: "monDefaultOptions", monReturnValue: "monReturnValue", monRequired: "monRequired", monMultiple: "monMultiple", monGroup: "monGroup", monNameAttr: "monNameAttr", monViewTemplate: "monViewTemplate", monDropdownTemplate: "monDropdownTemplate", monGroupTemplate: "monGroupTemplate", monRemoveButton: "monRemoveButton", monDisabled: "monDisabled", monDisableSearch: "monDisableSearch", monName: "monName", monHelpTxt: "monHelpTxt", monNoAutoComplete: "monNoAutoComplete", monSize: "monSize", monShowColors: "monShowColors", monAutoClearSearch: "monAutoClearSearch" }, outputs: { modelChange: "modelChange", changeEvent: "changeEvent" }, features: [i0.ɵɵProvidersFeature([], [{ provide: ControlContainer, useExisting: NgForm }]), i0.ɵɵInheritDefinitionFeature], decls: 5, vars: 4, consts: [["ngxSelect", ""], [1, "form-group", "row", "select-dropdown", "separator"], [3, "ngClass", 4, "ngIf"], [1, "select-grey", 3, "ngClass"], [3, "allowClear", "autoClearSearch", "name", "required", "disabled", "placeholder", "multiple", "optionTextField", "optionValueField", "items", "size", "noAutoComplete", "ngModel", "selectionChanges", "click", "ngModelChange", 4, "ngIf"], ["class", "form-text text-muted", 4, "ngIf"], [3, "ngClass"], [4, "ngIf"], [3, "selectionChanges", "click", "ngModelChange", "allowClear", "autoClearSearch", "name", "required", "disabled", "placeholder", "multiple", "optionTextField", "optionValueField", "items", "size", "noAutoComplete", "ngModel"], ["ngx-select-option", "", "ngx-select-option-selected", ""], ["class", "color-box", 3, "ngStyle", 4, "ngIf"], [3, "innerHtml"], [1, "color-box", 3, "ngStyle"], [1, "form-text", "text-muted"]], template: function SelectComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵtemplate(1, SelectComponent_label_1_Template, 3, 7, "label", 2);
            i0.ɵɵelementStart(2, "div", 3);
            i0.ɵɵtemplate(3, SelectComponent_ngx_select_3_Template, 3, 14, "ngx-select", 4)(4, SelectComponent_span_4_Template, 2, 1, "span", 5);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.monLabel);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", ctx.containerWidth);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.monName);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.monHelpText);
        } }, dependencies: [i1$6.NgxSelectComponent, i1$6.NgxSelectOptionDirective, i1$6.NgxSelectOptionSelectedDirective, i1$5.NgControlStatus, i1$5.RequiredValidator, i1$5.NgModel, i1$2.NgClass, i1$2.NgIf, i1$2.NgStyle], styles: [".select-grey[_ngcontent-%COMP%]   .ngx-select__toggle[_ngcontent-%COMP%]{display:block;margin:0;position:relative;overflow:hidden;cursor:pointer;border:1px solid #bbb;box-shadow:0 1px #0000000d,inset 0 1px #fffc;box-sizing:border-box;border-radius:3px;font-weight:inherit}.form-text[_ngcontent-%COMP%]{display:block;margin-top:5px;color:#9a9d9e}.separator[_ngcontent-%COMP%]{margin-bottom:10px}.col-sm-10[_ngcontent-%COMP%]   .ngx-select__toggle[_ngcontent-%COMP%], .col-sm-12[_ngcontent-%COMP%]   .ngx-select__toggle[_ngcontent-%COMP%]{display:block;margin:0;position:relative;overflow:hidden;cursor:pointer;border:1px solid #bbb;box-shadow:0 1px #0000000d,inset 0 1px #fffc;box-sizing:border-box;border-radius:3px;font-weight:inherit}.color-box[_ngcontent-%COMP%]{display:inline-block;height:14px;width:14px;margin-right:4px}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SelectComponent, [{
        type: Component,
        args: [{ selector: 'mon-form-field-select', viewProviders: [{ provide: ControlContainer, useExisting: NgForm }], template: "<div class=\"form-group row select-dropdown separator\">\n    <label *ngIf=\"monLabel\"\n           [attr.for]=\"getLabelForId(monLabel)\"\n           [ngClass]=\"{'sr-only': monSrOnlyLabel, 'col-sm-8 col-form-label text-bold capitalize-first-letter pt-1 text-right': !monSrOnlyLabel}\"\n    >\n        {{ monLabel }}<span *ngIf=\"monRequired\">*</span>\n    </label>\n    <div class=\"select-grey\" [ngClass]=\"containerWidth\">\n        <ngx-select\n                *ngIf=\"monName\"\n                #ngxSelect\n                (selectionChanges)=\"changeEvent.emit($event)\"\n                (click)=\"onSelectClick()\"\n                [allowClear]=\"monAllowClear\"\n                [autoClearSearch]=\"monAutoClearSearch\"\n                [name]=\"monName\"\n                [required]=\"monRequired\"\n                [disabled]=\"monDisabled\"\n                [placeholder]=\"monPlaceholder\"\n                [multiple]=\"monMultiple\"\n                [optionTextField]=\"monNameAttr\"\n                [optionValueField]=\"monReturnValue\"\n                [items]=\"monOptions\"\n                [size]=\"monSize\"\n                [noAutoComplete]=\"monNoAutoComplete\"\n                [attr.data-size]=\"monSize\"\n                [(ngModel)]=\"model\">\n                <ng-template ngx-select-option ngx-select-option-selected let-option let-text=\"text\">\n                    <span class=\"color-box\" [ngStyle]=\"{'background-color' : option.data.color}\" *ngIf=\"monShowColors\"></span>\n                    <span [innerHtml]=\"text\"></span>\n                </ng-template>\n        </ngx-select>\n        <span *ngIf=\"monHelpText\" class=\"form-text text-muted\">{{ monHelpText }}</span>\n    </div>\n</div>\n", styles: [".select-grey .ngx-select__toggle{display:block;margin:0;position:relative;overflow:hidden;cursor:pointer;border:1px solid #bbb;box-shadow:0 1px #0000000d,inset 0 1px #fffc;box-sizing:border-box;border-radius:3px;font-weight:inherit}.form-text{display:block;margin-top:5px;color:#9a9d9e}.separator{margin-bottom:10px}.col-sm-10 .ngx-select__toggle,.col-sm-12 .ngx-select__toggle{display:block;margin:0;position:relative;overflow:hidden;cursor:pointer;border:1px solid #bbb;box-shadow:0 1px #0000000d,inset 0 1px #fffc;box-sizing:border-box;border-radius:3px;font-weight:inherit}.color-box{display:inline-block;height:14px;width:14px;margin-right:4px}\n"] }]
    }], null, { modelChange: [{
            type: Output
        }], model: [{
            type: Input
        }], monAllowClear: [{
            type: Input
        }], monPlaceholder: [{
            type: Input
        }], monSrOnlyLabel: [{
            type: Input
        }], monOptions: [{
            type: Input
        }], monLabel: [{
            type: Input
        }], monHelpText: [{
            type: Input
        }], monDefaultOptions: [{
            type: Input
        }], monReturnValue: [{
            type: Input
        }], monRequired: [{
            type: Input
        }], monMultiple: [{
            type: Input
        }], monGroup: [{
            type: Input
        }], monNameAttr: [{
            type: Input
        }], monViewTemplate: [{
            type: Input
        }], monDropdownTemplate: [{
            type: Input
        }], monGroupTemplate: [{
            type: Input
        }], monRemoveButton: [{
            type: Input
        }], monDisabled: [{
            type: Input
        }], monDisableSearch: [{
            type: Input
        }], monName: [{
            type: Input
        }], monHelpTxt: [{
            type: Input
        }], monNoAutoComplete: [{
            type: Input
        }], monSize: [{
            type: Input
        }], monShowColors: [{
            type: Input
        }], monAutoClearSearch: [{
            type: Input
        }], changeEvent: [{
            type: Output
        }], ngxSelect: [{
            type: ViewChild,
            args: ['ngxSelect', { static: false }]
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(SelectComponent, { className: "SelectComponent" }); })();

/* eslint-disable @typescript-eslint/quotes */
/* eslint-disable @typescript-eslint/naming-convention */
const TIMEZONES = {
    'Europe/Andorra': {
        name: 'Europe/Andorra',
        lat: 42.5,
        long: 1.5167,
        countries: ['AD'],
        comments: '',
    },
    'Asia/Dubai': {
        name: 'Asia/Dubai',
        lat: 25.3,
        long: 55.3,
        countries: ['AE', 'OM'],
        comments: '',
    },
    'Asia/Kabul': {
        name: 'Asia/Kabul',
        lat: 34.5167,
        long: 69.2,
        countries: ['AF'],
        comments: '',
    },
    'Europe/Tirane': {
        name: 'Europe/Tirane',
        lat: 41.3333,
        long: 19.8333,
        countries: ['AL'],
        comments: '',
    },
    'Asia/Yerevan': {
        name: 'Asia/Yerevan',
        lat: 40.1833,
        long: 44.5,
        countries: ['AM'],
        comments: '',
    },
    'Antarctica/Casey': {
        name: 'Antarctica/Casey',
        lat: -65.7167,
        long: 110.5167,
        countries: ['AQ'],
        comments: 'Casey',
    },
    'Antarctica/Davis': {
        name: 'Antarctica/Davis',
        lat: -67.4167,
        long: 77.9667,
        countries: ['AQ'],
        comments: 'Davis',
    },
    'Antarctica/DumontDUrville': {
        name: 'Antarctica/DumontDUrville',
        lat: -65.3333,
        long: 140.0167,
        countries: ['AQ'],
        comments: 'Dumont-d\'Urville',
    },
    'Antarctica/Mawson': {
        name: 'Antarctica/Mawson',
        lat: -66.4,
        long: 62.8833,
        countries: ['AQ'],
        comments: 'Mawson',
    },
    'Antarctica/Palmer': {
        name: 'Antarctica/Palmer',
        lat: -63.2,
        long: -63.9,
        countries: ['AQ'],
        comments: 'Palmer',
    },
    'Antarctica/Rothera': {
        name: 'Antarctica/Rothera',
        lat: -66.4333,
        long: -67.8667,
        countries: ['AQ'],
        comments: 'Rothera',
    },
    'Antarctica/Syowa': {
        name: 'Antarctica/Syowa',
        lat: -68.9939,
        long: 39.59,
        countries: ['AQ'],
        comments: 'Syowa',
    },
    'Antarctica/Troll': {
        name: 'Antarctica/Troll',
        lat: -71.9886,
        long: 2.535,
        countries: ['AQ'],
        comments: 'Troll',
    },
    'Antarctica/Vostok': {
        name: 'Antarctica/Vostok',
        lat: -77.6,
        long: 106.9,
        countries: ['AQ'],
        comments: 'Vostok',
    },
    'America/Argentina/Buenos_Aires': {
        name: 'America/Argentina/Buenos_Aires',
        lat: -33.4,
        long: -57.55,
        countries: ['AR'],
        comments: 'Buenos Aires (BA, CF)',
    },
    'America/Argentina/Cordoba': {
        name: 'America/Argentina/Cordoba',
        lat: -30.6,
        long: -63.8167,
        countries: ['AR'],
        comments: 'Argentina (most areas: CB, CC, CN, ER, FM, MN, SE, SF)',
    },
    'America/Argentina/Salta': {
        name: 'America/Argentina/Salta',
        lat: -23.2167,
        long: -64.5833,
        countries: ['AR'],
        comments: 'Salta (SA, LP, NQ, RN)',
    },
    'America/Argentina/Jujuy': {
        name: 'America/Argentina/Jujuy',
        lat: -23.8167,
        long: -64.7,
        countries: ['AR'],
        comments: 'Jujuy (JY)',
    },
    'America/Argentina/Tucuman': {
        name: 'America/Argentina/Tucuman',
        lat: -25.1833,
        long: -64.7833,
        countries: ['AR'],
        comments: 'Tucumán (TM)',
    },
    'America/Argentina/Catamarca': {
        name: 'America/Argentina/Catamarca',
        lat: -27.5333,
        long: -64.2167,
        countries: ['AR'],
        comments: 'Catamarca (CT); Chubut (CH)',
    },
    'America/Argentina/La_Rioja': {
        name: 'America/Argentina/La_Rioja',
        lat: -28.5667,
        long: -65.15,
        countries: ['AR'],
        comments: 'La Rioja (LR)',
    },
    'America/Argentina/San_Juan': {
        name: 'America/Argentina/San_Juan',
        lat: -30.4667,
        long: -67.4833,
        countries: ['AR'],
        comments: 'San Juan (SJ)',
    },
    'America/Argentina/Mendoza': {
        name: 'America/Argentina/Mendoza',
        lat: -31.1167,
        long: -67.1833,
        countries: ['AR'],
        comments: 'Mendoza (MZ)',
    },
    'America/Argentina/San_Luis': {
        name: 'America/Argentina/San_Luis',
        lat: -32.6833,
        long: -65.65,
        countries: ['AR'],
        comments: 'San Luis (SL)',
    },
    'America/Argentina/Rio_Gallegos': {
        name: 'America/Argentina/Rio_Gallegos',
        lat: -50.3667,
        long: -68.7833,
        countries: ['AR'],
        comments: 'Santa Cruz (SC)',
    },
    'America/Argentina/Ushuaia': {
        name: 'America/Argentina/Ushuaia',
        lat: -53.2,
        long: -67.7,
        countries: ['AR'],
        comments: 'Tierra del Fuego (TF)',
    },
    'Pacific/Pago_Pago': {
        name: 'Pacific/Pago_Pago',
        lat: -13.7333,
        long: -169.3,
        countries: ['AS', 'UM'],
        comments: 'Samoa, Midway',
    },
    'Europe/Vienna': {
        name: 'Europe/Vienna',
        lat: 48.2167,
        long: 16.3333,
        countries: ['AT'],
        comments: '',
    },
    'Australia/Lord_Howe': {
        name: 'Australia/Lord_Howe',
        lat: -30.45,
        long: 159.0833,
        countries: ['AU'],
        comments: 'Lord Howe Island',
    },
    'Antarctica/Macquarie': {
        name: 'Antarctica/Macquarie',
        lat: -53.5,
        long: 158.95,
        countries: ['AU'],
        comments: 'Macquarie Island',
    },
    'Australia/Hobart': {
        name: 'Australia/Hobart',
        lat: -41.1167,
        long: 147.3167,
        countries: ['AU'],
        comments: 'Tasmania (most areas)',
    },
    'Australia/Currie': {
        name: 'Australia/Currie',
        lat: -38.0667,
        long: 143.8667,
        countries: ['AU'],
        comments: 'Tasmania (King Island)',
    },
    'Australia/Melbourne': {
        name: 'Australia/Melbourne',
        lat: -36.1833,
        long: 144.9667,
        countries: ['AU'],
        comments: 'Victoria',
    },
    'Australia/Sydney': {
        name: 'Australia/Sydney',
        lat: -32.1333,
        long: 151.2167,
        countries: ['AU'],
        comments: 'New South Wales (most areas)',
    },
    'Australia/Broken_Hill': {
        name: 'Australia/Broken_Hill',
        lat: -30.05,
        long: 141.45,
        countries: ['AU'],
        comments: 'New South Wales (Yancowinna)',
    },
    'Australia/Brisbane': {
        name: 'Australia/Brisbane',
        lat: -26.5333,
        long: 153.0333,
        countries: ['AU'],
        comments: 'Queensland (most areas)',
    },
    'Australia/Lindeman': {
        name: 'Australia/Lindeman',
        lat: -19.7333,
        long: 149,
        countries: ['AU'],
        comments: 'Queensland (Whitsunday Islands)',
    },
    'Australia/Adelaide': {
        name: 'Australia/Adelaide',
        lat: -33.0833,
        long: 138.5833,
        countries: ['AU'],
        comments: 'South Australia',
    },
    'Australia/Darwin': {
        name: 'Australia/Darwin',
        lat: -11.5333,
        long: 130.8333,
        countries: ['AU'],
        comments: 'Northern Territory',
    },
    'Australia/Perth': {
        name: 'Australia/Perth',
        lat: -30.05,
        long: 115.85,
        countries: ['AU'],
        comments: 'Western Australia (most areas)',
    },
    'Australia/Eucla': {
        name: 'Australia/Eucla',
        lat: -30.2833,
        long: 128.8667,
        countries: ['AU'],
        comments: 'Western Australia (Eucla)',
    },
    'Asia/Baku': {
        name: 'Asia/Baku',
        lat: 40.3833,
        long: 49.85,
        countries: ['AZ'],
        comments: '',
    },
    'America/Barbados': {
        name: 'America/Barbados',
        lat: 13.1,
        long: -58.3833,
        countries: ['BB'],
        comments: '',
    },
    'Asia/Dhaka': {
        name: 'Asia/Dhaka',
        lat: 23.7167,
        long: 90.4167,
        countries: ['BD'],
        comments: '',
    },
    'Europe/Brussels': {
        name: 'Europe/Brussels',
        lat: 50.8333,
        long: 4.3333,
        countries: ['BE'],
        comments: '',
    },
    'Europe/Sofia': {
        name: 'Europe/Sofia',
        lat: 42.6833,
        long: 23.3167,
        countries: ['BG'],
        comments: '',
    },
    'Atlantic/Bermuda': {
        name: 'Atlantic/Bermuda',
        lat: 32.2833,
        long: -63.2333,
        countries: ['BM'],
        comments: '',
    },
    'Asia/Brunei': {
        name: 'Asia/Brunei',
        lat: 4.9333,
        long: 114.9167,
        countries: ['BN'],
        comments: '',
    },
    'America/La_Paz': {
        name: 'America/La_Paz',
        lat: -15.5,
        long: -67.85,
        countries: ['BO'],
        comments: '',
    },
    'America/Noronha': {
        name: 'America/Noronha',
        lat: -2.15,
        long: -31.5833,
        countries: ['BR'],
        comments: 'Atlantic islands',
    },
    'America/Belem': {
        name: 'America/Belem',
        lat: -0.55,
        long: -47.5167,
        countries: ['BR'],
        comments: 'Pará (east); Amapá',
    },
    'America/Fortaleza': {
        name: 'America/Fortaleza',
        lat: -2.2833,
        long: -37.5,
        countries: ['BR'],
        comments: 'Brazil (northeast: MA, PI, CE, RN, PB)',
    },
    'America/Recife': {
        name: 'America/Recife',
        lat: -7.95,
        long: -33.1,
        countries: ['BR'],
        comments: 'Pernambuco',
    },
    'America/Araguaina': {
        name: 'America/Araguaina',
        lat: -6.8,
        long: -47.8,
        countries: ['BR'],
        comments: 'Tocantins',
    },
    'America/Maceio': {
        name: 'America/Maceio',
        lat: -8.3333,
        long: -34.2833,
        countries: ['BR'],
        comments: 'Alagoas, Sergipe',
    },
    'America/Bahia': {
        name: 'America/Bahia',
        lat: -11.0167,
        long: -37.4833,
        countries: ['BR'],
        comments: 'Bahia',
    },
    'America/Sao_Paulo': {
        name: 'America/Sao_Paulo',
        lat: -22.4667,
        long: -45.3833,
        countries: ['BR'],
        comments: 'Brazil (southeast: GO, DF, MG, ES, RJ, SP, PR, SC, RS)',
    },
    'America/Campo_Grande': {
        name: 'America/Campo_Grande',
        lat: -19.55,
        long: -53.3833,
        countries: ['BR'],
        comments: 'Mato Grosso do Sul',
    },
    'America/Cuiaba': {
        name: 'America/Cuiaba',
        lat: -14.4167,
        long: -55.9167,
        countries: ['BR'],
        comments: 'Mato Grosso',
    },
    'America/Santarem': {
        name: 'America/Santarem',
        lat: -1.5667,
        long: -53.1333,
        countries: ['BR'],
        comments: 'Pará (west)',
    },
    'America/Porto_Velho': {
        name: 'America/Porto_Velho',
        lat: -7.2333,
        long: -62.1,
        countries: ['BR'],
        comments: 'Rondônia',
    },
    'America/Boa_Vista': {
        name: 'America/Boa_Vista',
        lat: 2.8167,
        long: -59.3333,
        countries: ['BR'],
        comments: 'Roraima',
    },
    'America/Manaus': {
        name: 'America/Manaus',
        lat: -2.8667,
        long: -59.9833,
        countries: ['BR'],
        comments: 'Amazonas (east)',
    },
    'America/Eirunepe': {
        name: 'America/Eirunepe',
        lat: -5.3333,
        long: -68.1333,
        countries: ['BR'],
        comments: 'Amazonas (west)',
    },
    'America/Rio_Branco': {
        name: 'America/Rio_Branco',
        lat: -8.0333,
        long: -66.2,
        countries: ['BR'],
        comments: 'Acre',
    },
    'America/Nassau': {
        name: 'America/Nassau',
        lat: 25.0833,
        long: -76.65,
        countries: ['BS'],
        comments: '',
    },
    'Asia/Thimphu': {
        name: 'Asia/Thimphu',
        lat: 27.4667,
        long: 89.65,
        countries: ['BT'],
        comments: '',
    },
    'Europe/Minsk': {
        name: 'Europe/Minsk',
        lat: 53.9,
        long: 27.5667,
        countries: ['BY'],
        comments: '',
    },
    'America/Belize': {
        name: 'America/Belize',
        lat: 17.5,
        long: -87.8,
        countries: ['BZ'],
        comments: '',
    },
    'America/St_Johns': {
        name: 'America/St_Johns',
        lat: 47.5667,
        long: -51.2833,
        countries: ['CA'],
        comments: 'Newfoundland; Labrador (southeast)',
    },
    'America/Halifax': {
        name: 'America/Halifax',
        lat: 44.65,
        long: -62.4,
        countries: ['CA'],
        comments: 'Atlantic - NS (most areas); PE',
    },
    'America/Glace_Bay': {
        name: 'America/Glace_Bay',
        lat: 46.2,
        long: -58.05,
        countries: ['CA'],
        comments: 'Atlantic - NS (Cape Breton)',
    },
    'America/Moncton': {
        name: 'America/Moncton',
        lat: 46.1,
        long: -63.2167,
        countries: ['CA'],
        comments: 'Atlantic - New Brunswick',
    },
    'America/Goose_Bay': {
        name: 'America/Goose_Bay',
        lat: 53.3333,
        long: -59.5833,
        countries: ['CA'],
        comments: 'Atlantic - Labrador (most areas)',
    },
    'America/Blanc-Sablon': {
        name: 'America/Blanc-Sablon',
        lat: 51.4167,
        long: -56.8833,
        countries: ['CA'],
        comments: 'AST - QC (Lower North Shore)',
    },
    'America/Toronto': {
        name: 'America/Toronto',
        lat: 43.65,
        long: -78.6167,
        countries: ['CA'],
        comments: 'Eastern - ON, QC (most areas)',
    },
    'America/Nipigon': {
        name: 'America/Nipigon',
        lat: 49.0167,
        long: -87.7333,
        countries: ['CA'],
        comments: 'Eastern - ON, QC (no DST 1967-73)',
    },
    'America/Thunder_Bay': {
        name: 'America/Thunder_Bay',
        lat: 48.3833,
        long: -88.75,
        countries: ['CA'],
        comments: 'Eastern - ON (Thunder Bay)',
    },
    'America/Iqaluit': {
        name: 'America/Iqaluit',
        lat: 63.7333,
        long: -67.5333,
        countries: ['CA'],
        comments: 'Eastern - NU (most east areas)',
    },
    'America/Pangnirtung': {
        name: 'America/Pangnirtung',
        lat: 66.1333,
        long: -64.2667,
        countries: ['CA'],
        comments: 'Eastern - NU (Pangnirtung)',
    },
    'America/Atikokan': {
        name: 'America/Atikokan',
        lat: 48.7586,
        long: -90.3783,
        countries: ['CA'],
        comments: 'EST - ON (Atikokan); NU (Coral H)',
    },
    'America/Winnipeg': {
        name: 'America/Winnipeg',
        lat: 49.8833,
        long: -96.85,
        countries: ['CA'],
        comments: 'Central - ON (west); Manitoba',
    },
    'America/Rainy_River': {
        name: 'America/Rainy_River',
        lat: 48.7167,
        long: -93.4333,
        countries: ['CA'],
        comments: 'Central - ON (Rainy R, Ft Frances)',
    },
    'America/Resolute': {
        name: 'America/Resolute',
        lat: 74.6956,
        long: -93.1708,
        countries: ['CA'],
        comments: 'Central - NU (Resolute)',
    },
    'America/Rankin_Inlet': {
        name: 'America/Rankin_Inlet',
        lat: 62.8167,
        long: -91.9169,
        countries: ['CA'],
        comments: 'Central - NU (central)',
    },
    'America/Regina': {
        name: 'America/Regina',
        lat: 50.4,
        long: -103.35,
        countries: ['CA'],
        comments: 'CST - SK (most areas)',
    },
    'America/Swift_Current': {
        name: 'America/Swift_Current',
        lat: 50.2833,
        long: -106.1667,
        countries: ['CA'],
        comments: 'CST - SK (midwest)',
    },
    'America/Edmonton': {
        name: 'America/Edmonton',
        lat: 53.55,
        long: -112.5333,
        countries: ['CA'],
        comments: 'Mountain - AB; BC (E); SK (W)',
    },
    'America/Cambridge_Bay': {
        name: 'America/Cambridge_Bay',
        lat: 69.1139,
        long: -104.9472,
        countries: ['CA'],
        comments: 'Mountain - NU (west)',
    },
    'America/Yellowknife': {
        name: 'America/Yellowknife',
        lat: 62.45,
        long: -113.65,
        countries: ['CA'],
        comments: 'Mountain - NT (central)',
    },
    'America/Inuvik': {
        name: 'America/Inuvik',
        lat: 68.3497,
        long: -132.2833,
        countries: ['CA'],
        comments: 'Mountain - NT (west)',
    },
    'America/Creston': {
        name: 'America/Creston',
        lat: 49.1,
        long: -115.4833,
        countries: ['CA'],
        comments: 'MST - BC (Creston)',
    },
    'America/Dawson_Creek': {
        name: 'America/Dawson_Creek',
        lat: 59.7667,
        long: -119.7667,
        countries: ['CA'],
        comments: 'MST - BC (Dawson Cr, Ft St John)',
    },
    'America/Fort_Nelson': {
        name: 'America/Fort_Nelson',
        lat: 58.8,
        long: -121.3,
        countries: ['CA'],
        comments: 'MST - BC (Ft Nelson)',
    },
    'America/Vancouver': {
        name: 'America/Vancouver',
        lat: 49.2667,
        long: -122.8833,
        countries: ['CA'],
        comments: 'Pacific - BC (most areas)',
    },
    'America/Whitehorse': {
        name: 'America/Whitehorse',
        lat: 60.7167,
        long: -134.95,
        countries: ['CA'],
        comments: 'Pacific - Yukon (south)',
    },
    'America/Dawson': {
        name: 'America/Dawson',
        lat: 64.0667,
        long: -138.5833,
        countries: ['CA'],
        comments: 'Pacific - Yukon (north)',
    },
    'Indian/Cocos': {
        name: 'Indian/Cocos',
        lat: -11.8333,
        long: 96.9167,
        countries: ['CC'],
        comments: '',
    },
    'Europe/Zurich': {
        name: 'Europe/Zurich',
        lat: 47.3833,
        long: 8.5333,
        countries: ['CH', 'DE', 'LI'],
        comments: 'Swiss time',
    },
    'Africa/Abidjan': {
        name: 'Africa/Abidjan',
        lat: 5.3167,
        long: -3.9667,
        countries: ['CI', 'BF', 'GM', 'GN', 'ML', 'MR', 'SH', 'SL', 'SN', 'ST', 'TG'],
        comments: '',
    },
    'Pacific/Rarotonga': {
        name: 'Pacific/Rarotonga',
        lat: -20.7667,
        long: -158.2333,
        countries: ['CK'],
        comments: '',
    },
    'America/Santiago': {
        name: 'America/Santiago',
        lat: -32.55,
        long: -69.3333,
        countries: ['CL'],
        comments: 'Chile (most areas)',
    },
    'America/Punta_Arenas': {
        name: 'America/Punta_Arenas',
        lat: -52.85,
        long: -69.0833,
        countries: ['CL'],
        comments: 'Region of Magallanes',
    },
    'Pacific/Easter': {
        name: 'Pacific/Easter',
        lat: -26.85,
        long: -108.5667,
        countries: ['CL'],
        comments: 'Easter Island',
    },
    'Asia/Shanghai': {
        name: 'Asia/Shanghai',
        lat: 31.2333,
        long: 121.4667,
        countries: ['CN'],
        comments: 'Beijing Time',
    },
    'Asia/Urumqi': {
        name: 'Asia/Urumqi',
        lat: 43.8,
        long: 87.5833,
        countries: ['CN'],
        comments: 'Xinjiang Time',
    },
    'America/Bogota': {
        name: 'America/Bogota',
        lat: 4.6,
        long: -73.9167,
        countries: ['CO'],
        comments: '',
    },
    'America/Costa_Rica': {
        name: 'America/Costa_Rica',
        lat: 9.9333,
        long: -83.9167,
        countries: ['CR'],
        comments: '',
    },
    'America/Havana': {
        name: 'America/Havana',
        lat: 23.1333,
        long: -81.6333,
        countries: ['CU'],
        comments: '',
    },
    'Atlantic/Cape_Verde': {
        name: 'Atlantic/Cape_Verde',
        lat: 14.9167,
        long: -22.4833,
        countries: ['CV'],
        comments: '',
    },
    'America/Curacao': {
        name: 'America/Curacao',
        lat: 12.1833,
        long: -69,
        countries: ['CW', 'AW', 'BQ', 'SX'],
        comments: '',
    },
    'Indian/Christmas': {
        name: 'Indian/Christmas',
        lat: -9.5833,
        long: 105.7167,
        countries: ['CX'],
        comments: '',
    },
    'Asia/Nicosia': {
        name: 'Asia/Nicosia',
        lat: 35.1667,
        long: 33.3667,
        countries: ['CY'],
        comments: 'Cyprus (most areas)',
    },
    'Asia/Famagusta': {
        name: 'Asia/Famagusta',
        lat: 35.1167,
        long: 33.95,
        countries: ['CY'],
        comments: 'Northern Cyprus',
    },
    'Europe/Prague': {
        name: 'Europe/Prague',
        lat: 50.0833,
        long: 14.4333,
        countries: ['CZ', 'SK'],
        comments: '',
    },
    'Europe/Berlin': {
        name: 'Europe/Berlin',
        lat: 52.5,
        long: 13.3667,
        countries: ['DE'],
        comments: 'Germany (most areas)',
    },
    'Europe/Copenhagen': {
        name: 'Europe/Copenhagen',
        lat: 55.6667,
        long: 12.5833,
        countries: ['DK'],
        comments: '',
    },
    'America/Santo_Domingo': {
        name: 'America/Santo_Domingo',
        lat: 18.4667,
        long: -68.1,
        countries: ['DO'],
        comments: '',
    },
    'Africa/Algiers': {
        name: 'Africa/Algiers',
        lat: 36.7833,
        long: 3.05,
        countries: ['DZ'],
        comments: '',
    },
    'America/Guayaquil': {
        name: 'America/Guayaquil',
        lat: -1.8333,
        long: -78.1667,
        countries: ['EC'],
        comments: 'Ecuador (mainland)',
    },
    'Pacific/Galapagos': {
        name: 'Pacific/Galapagos',
        lat: 0.9,
        long: -88.4,
        countries: ['EC'],
        comments: 'Galápagos Islands',
    },
    'Europe/Tallinn': {
        name: 'Europe/Tallinn',
        lat: 59.4167,
        long: 24.75,
        countries: ['EE'],
        comments: '',
    },
    'Africa/Cairo': {
        name: 'Africa/Cairo',
        lat: 30.05,
        long: 31.25,
        countries: ['EG'],
        comments: '',
    },
    'Africa/El_Aaiun': {
        name: 'Africa/El_Aaiun',
        lat: 27.15,
        long: -12.8,
        countries: ['EH'],
        comments: '',
    },
    'Europe/Madrid': {
        name: 'Europe/Madrid',
        lat: 40.4,
        long: -2.3167,
        countries: ['ES'],
        comments: 'Spain (mainland)',
    },
    'Africa/Ceuta': {
        name: 'Africa/Ceuta',
        lat: 35.8833,
        long: -4.6833,
        countries: ['ES'],
        comments: 'Ceuta, Melilla',
    },
    'Atlantic/Canary': {
        name: 'Atlantic/Canary',
        lat: 28.1,
        long: -14.6,
        countries: ['ES'],
        comments: 'Canary Islands',
    },
    'Europe/Helsinki': {
        name: 'Europe/Helsinki',
        lat: 60.1667,
        long: 24.9667,
        countries: ['FI', 'AX'],
        comments: '',
    },
    'Pacific/Fiji': {
        name: 'Pacific/Fiji',
        lat: -17.8667,
        long: 178.4167,
        countries: ['FJ'],
        comments: '',
    },
    'Atlantic/Stanley': {
        name: 'Atlantic/Stanley',
        lat: -50.3,
        long: -56.15,
        countries: ['FK'],
        comments: '',
    },
    'Pacific/Chuuk': {
        name: 'Pacific/Chuuk',
        lat: 7.4167,
        long: 151.7833,
        countries: ['FM'],
        comments: 'Chuuk/Truk, Yap',
    },
    'Pacific/Pohnpei': {
        name: 'Pacific/Pohnpei',
        lat: 6.9667,
        long: 158.2167,
        countries: ['FM'],
        comments: 'Pohnpei/Ponape',
    },
    'Pacific/Kosrae': {
        name: 'Pacific/Kosrae',
        lat: 5.3167,
        long: 162.9833,
        countries: ['FM'],
        comments: 'Kosrae',
    },
    'Atlantic/Faroe': {
        name: 'Atlantic/Faroe',
        lat: 62.0167,
        long: -5.2333,
        countries: ['FO'],
        comments: '',
    },
    'Europe/Paris': {
        name: 'Europe/Paris',
        lat: 48.8667,
        long: 2.3333,
        countries: ['FR'],
        comments: '',
    },
    'Europe/London': {
        name: 'Europe/London',
        lat: 51.5083,
        long: 0.1253,
        countries: ['GB', 'GG', 'IM', 'JE'],
        comments: '',
    },
    'Asia/Tbilisi': {
        name: 'Asia/Tbilisi',
        lat: 41.7167,
        long: 44.8167,
        countries: ['GE'],
        comments: '',
    },
    'America/Cayenne': {
        name: 'America/Cayenne',
        lat: 4.9333,
        long: -51.6667,
        countries: ['GF'],
        comments: '',
    },
    'Africa/Accra': {
        name: 'Africa/Accra',
        lat: 5.55,
        long: 0.2167,
        countries: ['GH'],
        comments: '',
    },
    'Europe/Gibraltar': {
        name: 'Europe/Gibraltar',
        lat: 36.1333,
        long: -4.65,
        countries: ['GI'],
        comments: '',
    },
    'America/Godthab': {
        name: 'America/Godthab',
        lat: 64.1833,
        long: -50.2667,
        countries: ['GL'],
        comments: 'Greenland (most areas)',
    },
    'America/Danmarkshavn': {
        name: 'America/Danmarkshavn',
        lat: 76.7667,
        long: -17.3333,
        countries: ['GL'],
        comments: 'National Park (east coast)',
    },
    'America/Scoresbysund': {
        name: 'America/Scoresbysund',
        lat: 70.4833,
        long: -20.0333,
        countries: ['GL'],
        comments: 'Scoresbysund/Ittoqqortoormiit',
    },
    'America/Thule': {
        name: 'America/Thule',
        lat: 76.5667,
        long: -67.2167,
        countries: ['GL'],
        comments: 'Thule/Pituffik',
    },
    'Europe/Athens': {
        name: 'Europe/Athens',
        lat: 37.9667,
        long: 23.7167,
        countries: ['GR'],
        comments: '',
    },
    'Atlantic/South_Georgia': {
        name: 'Atlantic/South_Georgia',
        lat: -53.7333,
        long: -35.4667,
        countries: ['GS'],
        comments: '',
    },
    'America/Guatemala': {
        name: 'America/Guatemala',
        lat: 14.6333,
        long: -89.4833,
        countries: ['GT'],
        comments: '',
    },
    'Pacific/Guam': {
        name: 'Pacific/Guam',
        lat: 13.4667,
        long: 144.75,
        countries: ['GU', 'MP'],
        comments: '',
    },
    'Africa/Bissau': {
        name: 'Africa/Bissau',
        lat: 11.85,
        long: -14.4167,
        countries: ['GW'],
        comments: '',
    },
    'America/Guyana': {
        name: 'America/Guyana',
        lat: 6.8,
        long: -57.8333,
        countries: ['GY'],
        comments: '',
    },
    'Asia/Hong_Kong': {
        name: 'Asia/Hong_Kong',
        lat: 22.2833,
        long: 114.15,
        countries: ['HK'],
        comments: '',
    },
    'America/Tegucigalpa': {
        name: 'America/Tegucigalpa',
        lat: 14.1,
        long: -86.7833,
        countries: ['HN'],
        comments: '',
    },
    'America/Port-au-Prince': {
        name: 'America/Port-au-Prince',
        lat: 18.5333,
        long: -71.6667,
        countries: ['HT'],
        comments: '',
    },
    'Europe/Budapest': {
        name: 'Europe/Budapest',
        lat: 47.5,
        long: 19.0833,
        countries: ['HU'],
        comments: '',
    },
    'Asia/Jakarta': {
        name: 'Asia/Jakarta',
        lat: -5.8333,
        long: 106.8,
        countries: ['ID'],
        comments: 'Java, Sumatra',
    },
    'Asia/Pontianak': {
        name: 'Asia/Pontianak',
        lat: 0.0333,
        long: 109.3333,
        countries: ['ID'],
        comments: 'Borneo (west, central)',
    },
    'Asia/Makassar': {
        name: 'Asia/Makassar',
        lat: -4.8833,
        long: 119.4,
        countries: ['ID'],
        comments: 'Borneo (east, south); Sulawesi/Celebes, Bali, Nusa Tengarra; Timor (west)',
    },
    'Asia/Jayapura': {
        name: 'Asia/Jayapura',
        lat: -1.4667,
        long: 140.7,
        countries: ['ID'],
        comments: 'New Guinea (West Papua / Irian Jaya); Malukus/Moluccas',
    },
    'Europe/Dublin': {
        name: 'Europe/Dublin',
        lat: 53.3333,
        long: -5.75,
        countries: ['IE'],
        comments: '',
    },
    'Asia/Jerusalem': {
        name: 'Asia/Jerusalem',
        lat: 31.7806,
        long: 35.2239,
        countries: ['IL'],
        comments: '',
    },
    'Asia/Kolkata': {
        name: 'Asia/Kolkata',
        lat: 22.5333,
        long: 88.3667,
        countries: ['IN'],
        comments: '',
    },
    'Indian/Chagos': {
        name: 'Indian/Chagos',
        lat: -6.6667,
        long: 72.4167,
        countries: ['IO'],
        comments: '',
    },
    'Asia/Baghdad': {
        name: 'Asia/Baghdad',
        lat: 33.35,
        long: 44.4167,
        countries: ['IQ'],
        comments: '',
    },
    'Asia/Tehran': {
        name: 'Asia/Tehran',
        lat: 35.6667,
        long: 51.4333,
        countries: ['IR'],
        comments: '',
    },
    'Atlantic/Reykjavik': {
        name: 'Atlantic/Reykjavik',
        lat: 64.15,
        long: -20.15,
        countries: ['IS'],
        comments: '',
    },
    'Europe/Rome': {
        name: 'Europe/Rome',
        lat: 41.9,
        long: 12.4833,
        countries: ['IT', 'SM', 'VA'],
        comments: '',
    },
    'America/Jamaica': {
        name: 'America/Jamaica',
        lat: 17.9681,
        long: -75.2067,
        countries: ['JM'],
        comments: '',
    },
    'Asia/Amman': {
        name: 'Asia/Amman',
        lat: 31.95,
        long: 35.9333,
        countries: ['JO'],
        comments: '',
    },
    'Asia/Tokyo': {
        name: 'Asia/Tokyo',
        lat: 35.6544,
        long: 139.7447,
        countries: ['JP'],
        comments: '',
    },
    'Africa/Nairobi': {
        name: 'Africa/Nairobi',
        lat: -0.7167,
        long: 36.8167,
        countries: ['KE', 'DJ', 'ER', 'ET', 'KM', 'MG', 'SO', 'TZ', 'UG', 'YT'],
        comments: '',
    },
    'Asia/Bishkek': {
        name: 'Asia/Bishkek',
        lat: 42.9,
        long: 74.6,
        countries: ['KG'],
        comments: '',
    },
    'Pacific/Tarawa': {
        name: 'Pacific/Tarawa',
        lat: 1.4167,
        long: 173,
        countries: ['KI'],
        comments: 'Gilbert Islands',
    },
    'Pacific/Enderbury': {
        name: 'Pacific/Enderbury',
        lat: -2.8667,
        long: -170.9167,
        countries: ['KI'],
        comments: 'Phoenix Islands',
    },
    'Pacific/Kiritimati': {
        name: 'Pacific/Kiritimati',
        lat: 1.8667,
        long: -156.6667,
        countries: ['KI'],
        comments: 'Line Islands',
    },
    'Asia/Pyongyang': {
        name: 'Asia/Pyongyang',
        lat: 39.0167,
        long: 125.75,
        countries: ['KP'],
        comments: '',
    },
    'Asia/Seoul': {
        name: 'Asia/Seoul',
        lat: 37.55,
        long: 126.9667,
        countries: ['KR'],
        comments: '',
    },
    'Asia/Almaty': {
        name: 'Asia/Almaty',
        lat: 43.25,
        long: 76.95,
        countries: ['KZ'],
        comments: 'Kazakhstan (most areas)',
    },
    'Asia/Qyzylorda': {
        name: 'Asia/Qyzylorda',
        lat: 44.8,
        long: 65.4667,
        countries: ['KZ'],
        comments: 'Qyzylorda/Kyzylorda/Kzyl-Orda',
    },
    'Asia/Aqtobe': {
        name: 'Asia/Aqtobe',
        lat: 50.2833,
        long: 57.1667,
        countries: ['KZ'],
        comments: 'Aqtöbe/Aktobe',
    },
    'Asia/Aqtau': {
        name: 'Asia/Aqtau',
        lat: 44.5167,
        long: 50.2667,
        countries: ['KZ'],
        comments: 'Mangghystaū/Mankistau',
    },
    'Asia/Atyrau': {
        name: 'Asia/Atyrau',
        lat: 47.1167,
        long: 51.9333,
        countries: ['KZ'],
        comments: 'Atyraū/Atirau/Gur\'yev',
    },
    'Asia/Oral': {
        name: 'Asia/Oral',
        lat: 51.2167,
        long: 51.35,
        countries: ['KZ'],
        comments: 'West Kazakhstan',
    },
    'Asia/Beirut': {
        name: 'Asia/Beirut',
        lat: 33.8833,
        long: 35.5,
        countries: ['LB'],
        comments: '',
    },
    'Asia/Colombo': {
        name: 'Asia/Colombo',
        lat: 6.9333,
        long: 79.85,
        countries: ['LK'],
        comments: '',
    },
    'Africa/Monrovia': {
        name: 'Africa/Monrovia',
        lat: 6.3,
        long: -9.2167,
        countries: ['LR'],
        comments: '',
    },
    'Europe/Vilnius': {
        name: 'Europe/Vilnius',
        lat: 54.6833,
        long: 25.3167,
        countries: ['LT'],
        comments: '',
    },
    'Europe/Luxembourg': {
        name: 'Europe/Luxembourg',
        lat: 49.6,
        long: 6.15,
        countries: ['LU'],
        comments: '',
    },
    'Europe/Riga': {
        name: 'Europe/Riga',
        lat: 56.95,
        long: 24.1,
        countries: ['LV'],
        comments: '',
    },
    'Africa/Tripoli': {
        name: 'Africa/Tripoli',
        lat: 32.9,
        long: 13.1833,
        countries: ['LY'],
        comments: '',
    },
    'Africa/Casablanca': {
        name: 'Africa/Casablanca',
        lat: 33.65,
        long: -6.4167,
        countries: ['MA'],
        comments: '',
    },
    'Europe/Monaco': {
        name: 'Europe/Monaco',
        lat: 43.7,
        long: 7.3833,
        countries: ['MC'],
        comments: '',
    },
    'Europe/Chisinau': {
        name: 'Europe/Chisinau',
        lat: 47,
        long: 28.8333,
        countries: ['MD'],
        comments: '',
    },
    'Pacific/Majuro': {
        name: 'Pacific/Majuro',
        lat: 7.15,
        long: 171.2,
        countries: ['MH'],
        comments: 'Marshall Islands (most areas)',
    },
    'Pacific/Kwajalein': {
        name: 'Pacific/Kwajalein',
        lat: 9.0833,
        long: 167.3333,
        countries: ['MH'],
        comments: 'Kwajalein',
    },
    'Asia/Yangon': {
        name: 'Asia/Yangon',
        lat: 16.7833,
        long: 96.1667,
        countries: ['MM'],
        comments: '',
    },
    'Asia/Ulaanbaatar': {
        name: 'Asia/Ulaanbaatar',
        lat: 47.9167,
        long: 106.8833,
        countries: ['MN'],
        comments: 'Mongolia (most areas)',
    },
    'Asia/Hovd': {
        name: 'Asia/Hovd',
        lat: 48.0167,
        long: 91.65,
        countries: ['MN'],
        comments: 'Bayan-Ölgii, Govi-Altai, Hovd, Uvs, Zavkhan',
    },
    'Asia/Choibalsan': {
        name: 'Asia/Choibalsan',
        lat: 48.0667,
        long: 114.5,
        countries: ['MN'],
        comments: 'Dornod, Sükhbaatar',
    },
    'Asia/Macau': {
        name: 'Asia/Macau',
        lat: 22.2333,
        long: 113.5833,
        countries: ['MO'],
        comments: '',
    },
    'America/Martinique': {
        name: 'America/Martinique',
        lat: 14.6,
        long: -60.9167,
        countries: ['MQ'],
        comments: '',
    },
    'Europe/Malta': {
        name: 'Europe/Malta',
        lat: 35.9,
        long: 14.5167,
        countries: ['MT'],
        comments: '',
    },
    'Indian/Mauritius': {
        name: 'Indian/Mauritius',
        lat: -19.8333,
        long: 57.5,
        countries: ['MU'],
        comments: '',
    },
    'Indian/Maldives': {
        name: 'Indian/Maldives',
        lat: 4.1667,
        long: 73.5,
        countries: ['MV'],
        comments: '',
    },
    'America/Mexico_City': {
        name: 'America/Mexico_City',
        lat: 19.4,
        long: -98.85,
        countries: ['MX'],
        comments: 'Central Time',
    },
    'America/Cancun': {
        name: 'America/Cancun',
        lat: 21.0833,
        long: -85.2333,
        countries: ['MX'],
        comments: 'Eastern Standard Time - Quintana Roo',
    },
    'America/Merida': {
        name: 'America/Merida',
        lat: 20.9667,
        long: -88.3833,
        countries: ['MX'],
        comments: 'Central Time - Campeche, Yucatán',
    },
    'America/Monterrey': {
        name: 'America/Monterrey',
        lat: 25.6667,
        long: -99.6833,
        countries: ['MX'],
        comments: 'Central Time - Durango; Coahuila, Nuevo León, Tamaulipas (most areas)',
    },
    'America/Matamoros': {
        name: 'America/Matamoros',
        lat: 25.8333,
        long: -96.5,
        countries: ['MX'],
        comments: 'Central Time US - Coahuila, Nuevo León, Tamaulipas (US border)',
    },
    'America/Mazatlan': {
        name: 'America/Mazatlan',
        lat: 23.2167,
        long: -105.5833,
        countries: ['MX'],
        comments: 'Mountain Time - Baja California Sur, Nayarit, Sinaloa',
    },
    'America/Chihuahua': {
        name: 'America/Chihuahua',
        lat: 28.6333,
        long: -105.9167,
        countries: ['MX'],
        comments: 'Mountain Time - Chihuahua (most areas)',
    },
    'America/Ojinaga': {
        name: 'America/Ojinaga',
        lat: 29.5667,
        long: -103.5833,
        countries: ['MX'],
        comments: 'Mountain Time US - Chihuahua (US border)',
    },
    'America/Hermosillo': {
        name: 'America/Hermosillo',
        lat: 29.0667,
        long: -109.0333,
        countries: ['MX'],
        comments: 'Mountain Standard Time - Sonora',
    },
    'America/Tijuana': {
        name: 'America/Tijuana',
        lat: 32.5333,
        long: -116.9833,
        countries: ['MX'],
        comments: 'Pacific Time US - Baja California',
    },
    'America/Bahia_Banderas': {
        name: 'America/Bahia_Banderas',
        lat: 20.8,
        long: -104.75,
        countries: ['MX'],
        comments: 'Central Time - Bahía de Banderas',
    },
    'Asia/Kuala_Lumpur': {
        name: 'Asia/Kuala_Lumpur',
        lat: 3.1667,
        long: 101.7,
        countries: ['MY'],
        comments: 'Malaysia (peninsula)',
    },
    'Asia/Kuching': {
        name: 'Asia/Kuching',
        lat: 1.55,
        long: 110.3333,
        countries: ['MY'],
        comments: 'Sabah, Sarawak',
    },
    'Africa/Maputo': {
        name: 'Africa/Maputo',
        lat: -24.0333,
        long: 32.5833,
        countries: ['MZ', 'BI', 'BW', 'CD', 'MW', 'RW', 'ZM', 'ZW'],
        comments: 'Central Africa Time',
    },
    'Africa/Windhoek': {
        name: 'Africa/Windhoek',
        lat: -21.4333,
        long: 17.1,
        countries: ['NA'],
        comments: '',
    },
    'Pacific/Noumea': {
        name: 'Pacific/Noumea',
        lat: -21.7333,
        long: 166.45,
        countries: ['NC'],
        comments: '',
    },
    'Pacific/Norfolk': {
        name: 'Pacific/Norfolk',
        lat: -28.95,
        long: 167.9667,
        countries: ['NF'],
        comments: '',
    },
    'Africa/Lagos': {
        name: 'Africa/Lagos',
        lat: 6.45,
        long: 3.4,
        countries: ['NG', 'AO', 'BJ', 'CD', 'CF', 'CG', 'CM', 'GA', 'GQ', 'NE'],
        comments: 'West Africa Time',
    },
    'America/Managua': {
        name: 'America/Managua',
        lat: 12.15,
        long: -85.7167,
        countries: ['NI'],
        comments: '',
    },
    'Europe/Amsterdam': {
        name: 'Europe/Amsterdam',
        lat: 52.3667,
        long: 4.9,
        countries: ['NL'],
        comments: '',
    },
    'Europe/Oslo': {
        name: 'Europe/Oslo',
        lat: 59.9167,
        long: 10.75,
        countries: ['NO', 'SJ'],
        comments: '',
    },
    'Asia/Kathmandu': {
        name: 'Asia/Kathmandu',
        lat: 27.7167,
        long: 85.3167,
        countries: ['NP'],
        comments: '',
    },
    'Pacific/Nauru': {
        name: 'Pacific/Nauru',
        lat: 0.5167,
        long: 166.9167,
        countries: ['NR'],
        comments: '',
    },
    'Pacific/Niue': {
        name: 'Pacific/Niue',
        lat: -18.9833,
        long: -168.0833,
        countries: ['NU'],
        comments: '',
    },
    'Pacific/Auckland': {
        name: 'Pacific/Auckland',
        lat: -35.1333,
        long: 174.7667,
        countries: ['NZ', 'AQ'],
        comments: 'New Zealand time',
    },
    'Pacific/Chatham': {
        name: 'Pacific/Chatham',
        lat: -42.05,
        long: -175.45,
        countries: ['NZ'],
        comments: 'Chatham Islands',
    },
    'America/Panama': {
        name: 'America/Panama',
        lat: 8.9667,
        long: -78.4667,
        countries: ['PA', 'KY'],
        comments: '',
    },
    'America/Lima': {
        name: 'America/Lima',
        lat: -11.95,
        long: -76.95,
        countries: ['PE'],
        comments: '',
    },
    'Pacific/Tahiti': {
        name: 'Pacific/Tahiti',
        lat: -16.4667,
        long: -148.4333,
        countries: ['PF'],
        comments: 'Society Islands',
    },
    'Pacific/Marquesas': {
        name: 'Pacific/Marquesas',
        lat: -9,
        long: -138.5,
        countries: ['PF'],
        comments: 'Marquesas Islands',
    },
    'Pacific/Gambier': {
        name: 'Pacific/Gambier',
        lat: -22.8667,
        long: -133.05,
        countries: ['PF'],
        comments: 'Gambier Islands',
    },
    'Pacific/Port_Moresby': {
        name: 'Pacific/Port_Moresby',
        lat: -8.5,
        long: 147.1667,
        countries: ['PG'],
        comments: 'Papua New Guinea (most areas)',
    },
    'Pacific/Bougainville': {
        name: 'Pacific/Bougainville',
        lat: -5.7833,
        long: 155.5667,
        countries: ['PG'],
        comments: 'Bougainville',
    },
    'Asia/Manila': {
        name: 'Asia/Manila',
        lat: 14.5833,
        long: 121,
        countries: ['PH'],
        comments: '',
    },
    'Asia/Karachi': {
        name: 'Asia/Karachi',
        lat: 24.8667,
        long: 67.05,
        countries: ['PK'],
        comments: '',
    },
    'Europe/Warsaw': {
        name: 'Europe/Warsaw',
        lat: 52.25,
        long: 21,
        countries: ['PL'],
        comments: '',
    },
    'America/Miquelon': {
        name: 'America/Miquelon',
        lat: 47.05,
        long: -55.6667,
        countries: ['PM'],
        comments: '',
    },
    'Pacific/Pitcairn': {
        name: 'Pacific/Pitcairn',
        lat: -24.9333,
        long: -129.9167,
        countries: ['PN'],
        comments: '',
    },
    'America/Puerto_Rico': {
        name: 'America/Puerto_Rico',
        lat: 18.4683,
        long: -65.8939,
        countries: ['PR'],
        comments: '',
    },
    'Asia/Gaza': {
        name: 'Asia/Gaza',
        lat: 31.5,
        long: 34.4667,
        countries: ['PS'],
        comments: 'Gaza Strip',
    },
    'Asia/Hebron': {
        name: 'Asia/Hebron',
        lat: 31.5333,
        long: 35.095,
        countries: ['PS'],
        comments: 'West Bank',
    },
    'Europe/Lisbon': {
        name: 'Europe/Lisbon',
        lat: 38.7167,
        long: -8.8667,
        countries: ['PT'],
        comments: 'Portugal (mainland)',
    },
    'Atlantic/Madeira': {
        name: 'Atlantic/Madeira',
        lat: 32.6333,
        long: -15.1,
        countries: ['PT'],
        comments: 'Madeira Islands',
    },
    'Atlantic/Azores': {
        name: 'Atlantic/Azores',
        lat: 37.7333,
        long: -24.3333,
        countries: ['PT'],
        comments: 'Azores',
    },
    'Pacific/Palau': {
        name: 'Pacific/Palau',
        lat: 7.3333,
        long: 134.4833,
        countries: ['PW'],
        comments: '',
    },
    'America/Asuncion': {
        name: 'America/Asuncion',
        lat: -24.7333,
        long: -56.3333,
        countries: ['PY'],
        comments: '',
    },
    'Asia/Qatar': {
        name: 'Asia/Qatar',
        lat: 25.2833,
        long: 51.5333,
        countries: ['QA', 'BH'],
        comments: '',
    },
    'Indian/Reunion': {
        name: 'Indian/Reunion',
        lat: -19.1333,
        long: 55.4667,
        countries: ['RE', 'TF'],
        comments: 'Réunion, Crozet, Scattered Islands',
    },
    'Europe/Bucharest': {
        name: 'Europe/Bucharest',
        lat: 44.4333,
        long: 26.1,
        countries: ['RO'],
        comments: '',
    },
    'Europe/Belgrade': {
        name: 'Europe/Belgrade',
        lat: 44.8333,
        long: 20.5,
        countries: ['RS', 'BA', 'HR', 'ME', 'MK', 'SI'],
        comments: '',
    },
    'Europe/Kaliningrad': {
        name: 'Europe/Kaliningrad',
        lat: 54.7167,
        long: 20.5,
        countries: ['RU'],
        comments: 'MSK-01 - Kaliningrad',
    },
    'Europe/Moscow': {
        name: 'Europe/Moscow',
        lat: 55.7558,
        long: 37.6178,
        countries: ['RU'],
        comments: 'MSK+00 - Moscow area',
    },
    'Europe/Simferopol': {
        name: 'Europe/Simferopol',
        lat: 44.95,
        long: 34.1,
        countries: ['RU'],
        comments: 'MSK+00 - Crimea',
    },
    'Europe/Volgograd': {
        name: 'Europe/Volgograd',
        lat: 48.7333,
        long: 44.4167,
        countries: ['RU'],
        comments: 'MSK+00 - Volgograd',
    },
    'Europe/Kirov': {
        name: 'Europe/Kirov',
        lat: 58.6,
        long: 49.65,
        countries: ['RU'],
        comments: 'MSK+00 - Kirov',
    },
    'Europe/Astrakhan': {
        name: 'Europe/Astrakhan',
        lat: 46.35,
        long: 48.05,
        countries: ['RU'],
        comments: 'MSK+01 - Astrakhan',
    },
    'Europe/Saratov': {
        name: 'Europe/Saratov',
        lat: 51.5667,
        long: 46.0333,
        countries: ['RU'],
        comments: 'MSK+01 - Saratov',
    },
    'Europe/Ulyanovsk': {
        name: 'Europe/Ulyanovsk',
        lat: 54.3333,
        long: 48.4,
        countries: ['RU'],
        comments: 'MSK+01 - Ulyanovsk',
    },
    'Europe/Samara': {
        name: 'Europe/Samara',
        lat: 53.2,
        long: 50.15,
        countries: ['RU'],
        comments: 'MSK+01 - Samara, Udmurtia',
    },
    'Asia/Yekaterinburg': {
        name: 'Asia/Yekaterinburg',
        lat: 56.85,
        long: 60.6,
        countries: ['RU'],
        comments: 'MSK+02 - Urals',
    },
    'Asia/Omsk': {
        name: 'Asia/Omsk',
        lat: 55,
        long: 73.4,
        countries: ['RU'],
        comments: 'MSK+03 - Omsk',
    },
    'Asia/Novosibirsk': {
        name: 'Asia/Novosibirsk',
        lat: 55.0333,
        long: 82.9167,
        countries: ['RU'],
        comments: 'MSK+04 - Novosibirsk',
    },
    'Asia/Barnaul': {
        name: 'Asia/Barnaul',
        lat: 53.3667,
        long: 83.75,
        countries: ['RU'],
        comments: 'MSK+04 - Altai',
    },
    'Asia/Tomsk': {
        name: 'Asia/Tomsk',
        lat: 56.5,
        long: 84.9667,
        countries: ['RU'],
        comments: 'MSK+04 - Tomsk',
    },
    'Asia/Novokuznetsk': {
        name: 'Asia/Novokuznetsk',
        lat: 53.75,
        long: 87.1167,
        countries: ['RU'],
        comments: 'MSK+04 - Kemerovo',
    },
    'Asia/Krasnoyarsk': {
        name: 'Asia/Krasnoyarsk',
        lat: 56.0167,
        long: 92.8333,
        countries: ['RU'],
        comments: 'MSK+04 - Krasnoyarsk area',
    },
    'Asia/Irkutsk': {
        name: 'Asia/Irkutsk',
        lat: 52.2667,
        long: 104.3333,
        countries: ['RU'],
        comments: 'MSK+05 - Irkutsk, Buryatia',
    },
    'Asia/Chita': {
        name: 'Asia/Chita',
        lat: 52.05,
        long: 113.4667,
        countries: ['RU'],
        comments: 'MSK+06 - Zabaykalsky',
    },
    'Asia/Yakutsk': {
        name: 'Asia/Yakutsk',
        lat: 62,
        long: 129.6667,
        countries: ['RU'],
        comments: 'MSK+06 - Lena River',
    },
    'Asia/Khandyga': {
        name: 'Asia/Khandyga',
        lat: 62.6564,
        long: 135.5539,
        countries: ['RU'],
        comments: 'MSK+06 - Tomponsky, Ust-Maysky',
    },
    'Asia/Vladivostok': {
        name: 'Asia/Vladivostok',
        lat: 43.1667,
        long: 131.9333,
        countries: ['RU'],
        comments: 'MSK+07 - Amur River',
    },
    'Asia/Ust-Nera': {
        name: 'Asia/Ust-Nera',
        lat: 64.5603,
        long: 143.2267,
        countries: ['RU'],
        comments: 'MSK+07 - Oymyakonsky',
    },
    'Asia/Magadan': {
        name: 'Asia/Magadan',
        lat: 59.5667,
        long: 150.8,
        countries: ['RU'],
        comments: 'MSK+08 - Magadan',
    },
    'Asia/Sakhalin': {
        name: 'Asia/Sakhalin',
        lat: 46.9667,
        long: 142.7,
        countries: ['RU'],
        comments: 'MSK+08 - Sakhalin Island',
    },
    'Asia/Srednekolymsk': {
        name: 'Asia/Srednekolymsk',
        lat: 67.4667,
        long: 153.7167,
        countries: ['RU'],
        comments: 'MSK+08 - Sakha (E); North Kuril Is',
    },
    'Asia/Kamchatka': {
        name: 'Asia/Kamchatka',
        lat: 53.0167,
        long: 158.65,
        countries: ['RU'],
        comments: 'MSK+09 - Kamchatka',
    },
    'Asia/Anadyr': {
        name: 'Asia/Anadyr',
        lat: 64.75,
        long: 177.4833,
        countries: ['RU'],
        comments: 'MSK+09 - Bering Sea',
    },
    'Asia/Riyadh': {
        name: 'Asia/Riyadh',
        lat: 24.6333,
        long: 46.7167,
        countries: ['SA', 'KW', 'YE'],
        comments: '',
    },
    'Pacific/Guadalcanal': {
        name: 'Pacific/Guadalcanal',
        lat: -8.4667,
        long: 160.2,
        countries: ['SB'],
        comments: '',
    },
    'Indian/Mahe': {
        name: 'Indian/Mahe',
        lat: -3.3333,
        long: 55.4667,
        countries: ['SC'],
        comments: '',
    },
    'Africa/Khartoum': {
        name: 'Africa/Khartoum',
        lat: 15.6,
        long: 32.5333,
        countries: ['SD', 'SS'],
        comments: '',
    },
    'Europe/Stockholm': {
        name: 'Europe/Stockholm',
        lat: 59.3333,
        long: 18.05,
        countries: ['SE'],
        comments: '',
    },
    'Asia/Singapore': {
        name: 'Asia/Singapore',
        lat: 1.2833,
        long: 103.85,
        countries: ['SG'],
        comments: '',
    },
    'America/Paramaribo': {
        name: 'America/Paramaribo',
        lat: 5.8333,
        long: -54.8333,
        countries: ['SR'],
        comments: '',
    },
    'America/El_Salvador': {
        name: 'America/El_Salvador',
        lat: 13.7,
        long: -88.8,
        countries: ['SV'],
        comments: '',
    },
    'Asia/Damascus': {
        name: 'Asia/Damascus',
        lat: 33.5,
        long: 36.3,
        countries: ['SY'],
        comments: '',
    },
    'America/Grand_Turk': {
        name: 'America/Grand_Turk',
        lat: 21.4667,
        long: -70.8667,
        countries: ['TC'],
        comments: '',
    },
    'Africa/Ndjamena': {
        name: 'Africa/Ndjamena',
        lat: 12.1167,
        long: 15.05,
        countries: ['TD'],
        comments: '',
    },
    'Indian/Kerguelen': {
        name: 'Indian/Kerguelen',
        lat: -48.6472,
        long: 70.2175,
        countries: ['TF'],
        comments: 'Kerguelen, St Paul Island, Amsterdam Island',
    },
    'Asia/Bangkok': {
        name: 'Asia/Bangkok',
        lat: 13.75,
        long: 100.5167,
        countries: ['TH', 'KH', 'LA', 'VN'],
        comments: 'Indochina (most areas)',
    },
    'Asia/Dushanbe': {
        name: 'Asia/Dushanbe',
        lat: 38.5833,
        long: 68.8,
        countries: ['TJ'],
        comments: '',
    },
    'Pacific/Fakaofo': {
        name: 'Pacific/Fakaofo',
        lat: -8.6333,
        long: -170.7667,
        countries: ['TK'],
        comments: '',
    },
    'Asia/Dili': {
        name: 'Asia/Dili',
        lat: -7.45,
        long: 125.5833,
        countries: ['TL'],
        comments: '',
    },
    'Asia/Ashgabat': {
        name: 'Asia/Ashgabat',
        lat: 37.95,
        long: 58.3833,
        countries: ['TM'],
        comments: '',
    },
    'Africa/Tunis': {
        name: 'Africa/Tunis',
        lat: 36.8,
        long: 10.1833,
        countries: ['TN'],
        comments: '',
    },
    'Pacific/Tongatapu': {
        name: 'Pacific/Tongatapu',
        lat: -20.8333,
        long: -174.8333,
        countries: ['TO'],
        comments: '',
    },
    'Europe/Istanbul': {
        name: 'Europe/Istanbul',
        lat: 41.0167,
        long: 28.9667,
        countries: ['TR'],
        comments: '',
    },
    'America/Port_of_Spain': {
        name: 'America/Port_of_Spain',
        lat: 10.65,
        long: -60.4833,
        countries: ['TT', 'AG', 'AI', 'BL', 'DM', 'GD', 'GP', 'KN', 'LC', 'MF', 'MS', 'VC', 'VG', 'VI'],
        comments: '',
    },
    'Pacific/Funafuti': {
        name: 'Pacific/Funafuti',
        lat: -7.4833,
        long: 179.2167,
        countries: ['TV'],
        comments: '',
    },
    'Asia/Taipei': {
        name: 'Asia/Taipei',
        lat: 25.05,
        long: 121.5,
        countries: ['TW'],
        comments: '',
    },
    'Europe/Kiev': {
        name: 'Europe/Kiev',
        lat: 50.4333,
        long: 30.5167,
        countries: ['UA'],
        comments: 'Ukraine (most areas)',
    },
    'Europe/Uzhgorod': {
        name: 'Europe/Uzhgorod',
        lat: 48.6167,
        long: 22.3,
        countries: ['UA'],
        comments: 'Ruthenia',
    },
    'Europe/Zaporozhye': {
        name: 'Europe/Zaporozhye',
        lat: 47.8333,
        long: 35.1667,
        countries: ['UA'],
        comments: 'Zaporozh\'ye/Zaporizhia; Lugansk/Luhansk (east)',
    },
    'Pacific/Wake': {
        name: 'Pacific/Wake',
        lat: 19.2833,
        long: 166.6167,
        countries: ['UM'],
        comments: 'Wake Island',
    },
    'America/New_York': {
        name: 'America/New_York',
        lat: 40.7142,
        long: -73.9936,
        countries: ['US'],
        comments: 'Eastern (most areas)',
    },
    'America/Detroit': {
        name: 'America/Detroit',
        lat: 42.3314,
        long: -82.9542,
        countries: ['US'],
        comments: 'Eastern - MI (most areas)',
    },
    'America/Kentucky/Louisville': {
        name: 'America/Kentucky/Louisville',
        lat: 38.2542,
        long: -84.2406,
        countries: ['US'],
        comments: 'Eastern - KY (Louisville area)',
    },
    'America/Kentucky/Monticello': {
        name: 'America/Kentucky/Monticello',
        lat: 36.8297,
        long: -83.1508,
        countries: ['US'],
        comments: 'Eastern - KY (Wayne)',
    },
    'America/Indiana/Indianapolis': {
        name: 'America/Indiana/Indianapolis',
        lat: 39.7683,
        long: -85.8419,
        countries: ['US'],
        comments: 'Eastern - IN (most areas)',
    },
    'America/Indiana/Vincennes': {
        name: 'America/Indiana/Vincennes',
        lat: 38.6772,
        long: -86.4714,
        countries: ['US'],
        comments: 'Eastern - IN (Da, Du, K, Mn)',
    },
    'America/Indiana/Winamac': {
        name: 'America/Indiana/Winamac',
        lat: 41.0514,
        long: -85.3969,
        countries: ['US'],
        comments: 'Eastern - IN (Pulaski)',
    },
    'America/Indiana/Marengo': {
        name: 'America/Indiana/Marengo',
        lat: 38.3756,
        long: -85.6553,
        countries: ['US'],
        comments: 'Eastern - IN (Crawford)',
    },
    'America/Indiana/Petersburg': {
        name: 'America/Indiana/Petersburg',
        lat: 38.4919,
        long: -86.7214,
        countries: ['US'],
        comments: 'Eastern - IN (Pike)',
    },
    'America/Indiana/Vevay': {
        name: 'America/Indiana/Vevay',
        lat: 38.7478,
        long: -84.9328,
        countries: ['US'],
        comments: 'Eastern - IN (Switzerland)',
    },
    'America/Chicago': {
        name: 'America/Chicago',
        lat: 41.85,
        long: -86.35,
        countries: ['US'],
        comments: 'Central (most areas)',
    },
    'America/Indiana/Tell_City': {
        name: 'America/Indiana/Tell_City',
        lat: 37.9531,
        long: -85.2386,
        countries: ['US'],
        comments: 'Central - IN (Perry)',
    },
    'America/Indiana/Knox': {
        name: 'America/Indiana/Knox',
        lat: 41.2958,
        long: -85.375,
        countries: ['US'],
        comments: 'Central - IN (Starke)',
    },
    'America/Menominee': {
        name: 'America/Menominee',
        lat: 45.1078,
        long: -86.3858,
        countries: ['US'],
        comments: 'Central - MI (Wisconsin border)',
    },
    'America/North_Dakota/Center': {
        name: 'America/North_Dakota/Center',
        lat: 47.1164,
        long: -100.7008,
        countries: ['US'],
        comments: 'Central - ND (Oliver)',
    },
    'America/North_Dakota/New_Salem': {
        name: 'America/North_Dakota/New_Salem',
        lat: 46.845,
        long: -100.5892,
        countries: ['US'],
        comments: 'Central - ND (Morton rural)',
    },
    'America/North_Dakota/Beulah': {
        name: 'America/North_Dakota/Beulah',
        lat: 47.2642,
        long: -100.2222,
        countries: ['US'],
        comments: 'Central - ND (Mercer)',
    },
    'America/Denver': {
        name: 'America/Denver',
        lat: 39.7392,
        long: -103.0158,
        countries: ['US'],
        comments: 'Mountain (most areas)',
    },
    'America/Boise': {
        name: 'America/Boise',
        lat: 43.6136,
        long: -115.7975,
        countries: ['US'],
        comments: 'Mountain - ID (south); OR (east)',
    },
    'America/Phoenix': {
        name: 'America/Phoenix',
        lat: 33.4483,
        long: -111.9267,
        countries: ['US'],
        comments: 'MST - Arizona (except Navajo)',
    },
    'America/Los_Angeles': {
        name: 'America/Los_Angeles',
        lat: 34.0522,
        long: -117.7572,
        countries: ['US'],
        comments: 'Pacific',
    },
    'America/Anchorage': {
        name: 'America/Anchorage',
        lat: 61.2181,
        long: -148.0997,
        countries: ['US'],
        comments: 'Alaska (most areas)',
    },
    'America/Juneau': {
        name: 'America/Juneau',
        lat: 58.3019,
        long: -133.5803,
        countries: ['US'],
        comments: 'Alaska - Juneau area',
    },
    'America/Sitka': {
        name: 'America/Sitka',
        lat: 57.1764,
        long: -134.6981,
        countries: ['US'],
        comments: 'Alaska - Sitka area',
    },
    'America/Metlakatla': {
        name: 'America/Metlakatla',
        lat: 55.1269,
        long: -130.4236,
        countries: ['US'],
        comments: 'Alaska - Annette Island',
    },
    'America/Yakutat': {
        name: 'America/Yakutat',
        lat: 59.5469,
        long: -138.2728,
        countries: ['US'],
        comments: 'Alaska - Yakutat',
    },
    'America/Nome': {
        name: 'America/Nome',
        lat: 64.5011,
        long: -164.5936,
        countries: ['US'],
        comments: 'Alaska (west)',
    },
    'America/Adak': {
        name: 'America/Adak',
        lat: 51.88,
        long: -175.3419,
        countries: ['US'],
        comments: 'Aleutian Islands',
    },
    'Pacific/Honolulu': {
        name: 'Pacific/Honolulu',
        lat: 21.3069,
        long: -156.1417,
        countries: ['US', 'UM'],
        comments: 'Hawaii',
    },
    'America/Montevideo': {
        name: 'America/Montevideo',
        lat: -33.1167,
        long: -55.8167,
        countries: ['UY'],
        comments: '',
    },
    'Asia/Samarkand': {
        name: 'Asia/Samarkand',
        lat: 39.6667,
        long: 66.8,
        countries: ['UZ'],
        comments: 'Uzbekistan (west)',
    },
    'Asia/Tashkent': {
        name: 'Asia/Tashkent',
        lat: 41.3333,
        long: 69.3,
        countries: ['UZ'],
        comments: 'Uzbekistan (east)',
    },
    'America/Caracas': {
        name: 'America/Caracas',
        lat: 10.5,
        long: -65.0667,
        countries: ['VE'],
        comments: '',
    },
    'Asia/Ho_Chi_Minh': {
        name: 'Asia/Ho_Chi_Minh',
        lat: 10.75,
        long: 106.6667,
        countries: ['VN'],
        comments: 'Vietnam (south)',
    },
    'Pacific/Efate': {
        name: 'Pacific/Efate',
        lat: -16.3333,
        long: 168.4167,
        countries: ['VU'],
        comments: '',
    },
    'Pacific/Wallis': {
        name: 'Pacific/Wallis',
        lat: -12.7,
        long: -175.8333,
        countries: ['WF'],
        comments: '',
    },
    'Pacific/Apia': {
        name: 'Pacific/Apia',
        lat: -12.1667,
        long: -170.2667,
        countries: ['WS'],
        comments: '',
    },
    'Africa/Johannesburg': {
        name: 'Africa/Johannesburg',
        lat: -25.75,
        long: 28,
        countries: ['ZA', 'LS', 'SZ'],
        comments: '',
    },
};

class TimezonesComponent {
    constructor() {
        this.modelChange = new EventEmitter();
        this.monReturnValue = 'value';
        this.monRequired = false;
        this.monRemoveButton = false;
        this.monDisabled = false;
        this.changeEvent = new EventEmitter();
        this.timeZones = [];
    }
    get model() {
        return this.modelValue;
    }
    set model(val) {
        this.modelValue = val;
        this.modelChange.emit(this.modelValue);
    }
    ngOnInit() {
        this.setupZones();
    }
    setupZones() {
        Object.values(TIMEZONES).forEach(value => {
            this.timeZones.push(value);
        });
        this.timeZones = this.timeZones.sort((a, b) => {
            return (a.long > b.long) ? 1 : -1;
        });
    }
    static { this.ɵfac = function TimezonesComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TimezonesComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TimezonesComponent, selectors: [["mon-form-field-select-timezones"]], inputs: { model: "model", monLabel: "monLabel", monHelpTxt: "monHelpTxt", monDefaultOption: "monDefaultOption", monReturnValue: "monReturnValue", monRequired: "monRequired", monMultiple: "monMultiple", monViewTemplate: "monViewTemplate", monDropdownTemplate: "monDropdownTemplate", monRemoveButton: "monRemoveButton", monDisabled: "monDisabled" }, outputs: { modelChange: "modelChange", changeEvent: "changeEvent" }, features: [i0.ɵɵProvidersFeature([], [{ provide: ControlContainer, useExisting: NgForm }])], decls: 2, vars: 11, consts: [["monName", "timezones", 3, "modelChange", "onChange", "monReturnValue", "model", "monOptions", "monPlaceholder", "monLabel", "monHelpText", "monRemoveButton", "monDisabled", "monRequired"]], template: function TimezonesComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "mon-form-field-select", 0);
            i0.ɵɵpipe(1, "translate");
            i0.ɵɵtwoWayListener("modelChange", function TimezonesComponent_Template_mon_form_field_select_modelChange_0_listener($event) { i0.ɵɵtwoWayBindingSet(ctx.model, $event) || (ctx.model = $event); return $event; });
            i0.ɵɵlistener("onChange", function TimezonesComponent_Template_mon_form_field_select_onChange_0_listener($event) { return ctx.changeEvent.emit($event); });
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵpropertyInterpolate("monPlaceholder", i0.ɵɵpipeBind1(1, 9, "Select timezone"));
            i0.ɵɵproperty("monReturnValue", ctx.monReturnValue);
            i0.ɵɵtwoWayProperty("model", ctx.model);
            i0.ɵɵproperty("monOptions", ctx.timeZones)("monLabel", ctx.monLabel)("monHelpText", ctx.monHelpTxt)("monRemoveButton", ctx.monRemoveButton)("monDisabled", ctx.monDisabled)("monRequired", ctx.monRequired);
        } }, dependencies: [SelectComponent, TranslatePipe], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TimezonesComponent, [{
        type: Component,
        args: [{ selector: 'mon-form-field-select-timezones', viewProviders: [{ provide: ControlContainer, useExisting: NgForm }], template: "<mon-form-field-select\n    monName=\"timezones\"\n    [monReturnValue]=\"monReturnValue\"\n    [(model)]=\"model\"\n    [monOptions]=\"timeZones\"\n    monPlaceholder=\"{{\u00A0'Select timezone' | translate }}\"\n    [monLabel]=\"monLabel\"\n    [monHelpText]=\"monHelpTxt\"\n    (onChange)=\"changeEvent.emit($event)\"\n    [monRemoveButton]=\"monRemoveButton\"\n    [monDisabled]=\"monDisabled\"\n    [monRequired]=\"monRequired\">\n</mon-form-field-select>\n" }]
    }], null, { modelChange: [{
            type: Output
        }], model: [{
            type: Input
        }], monLabel: [{
            type: Input
        }], monHelpTxt: [{
            type: Input
        }], monDefaultOption: [{
            type: Input
        }], monReturnValue: [{
            type: Input
        }], monRequired: [{
            type: Input
        }], monMultiple: [{
            type: Input
        }], monViewTemplate: [{
            type: Input
        }], monDropdownTemplate: [{
            type: Input
        }], monRemoveButton: [{
            type: Input
        }], monDisabled: [{
            type: Input
        }], changeEvent: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(TimezonesComponent, { className: "TimezonesComponent" }); })();

class FormBuilderSelectModule {
    static { this.ɵfac = function FormBuilderSelectModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FormBuilderSelectModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: FormBuilderSelectModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [NgForm], imports: [NgxSelectModule, FormsModule, CommonModule, TranslateModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormBuilderSelectModule, [{
        type: NgModule,
        args: [{
                imports: [NgxSelectModule, FormsModule, CommonModule, TranslateModule],
                exports: [SelectComponent, TimezonesComponent],
                declarations: [SelectComponent, TimezonesComponent],
                providers: [NgForm],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(FormBuilderSelectModule, { declarations: [SelectComponent, TimezonesComponent], imports: [NgxSelectModule, FormsModule, CommonModule, TranslateModule], exports: [SelectComponent, TimezonesComponent] }); })();

class FormBuilderInputModule {
    static { this.ɵfac = function FormBuilderInputModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FormBuilderInputModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: FormBuilderInputModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [FormsModule, CommonModule, FormBuilderValidationModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormBuilderInputModule, [{
        type: NgModule,
        args: [{
                imports: [FormsModule, CommonModule, FormBuilderValidationModule],
                exports: [InputComponent, MonMaxDirective, MonMinDirective],
                declarations: [InputComponent, MonMinDirective, MonMaxDirective],
                providers: [],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(FormBuilderInputModule, { declarations: [InputComponent, MonMinDirective, MonMaxDirective], imports: [FormsModule, CommonModule, FormBuilderValidationModule], exports: [InputComponent, MonMaxDirective, MonMinDirective] }); })();

const _c0$m = (a0, a1) => ({ "col-sm-10": a0, "col-sm-12": a1 });
function DatepickerComponent_label_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 11);
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "span", 12);
    i0.ɵɵtext(3, "*");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("for", ctx_r1.labelAsId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("hidden", !ctx_r1.ngRequired);
} }
/**
 *
 * @deprecated Use the {@link DatepickerAcComponent} instead.
 */
class DatepickerComponent {
    constructor() {
        this.modelChange = new EventEmitter();
        this.monPlaceholder = 'yyyy-mm-dd';
    }
    get model() {
        return this.modelValue;
    }
    set model(val) {
        if (val === null || val === undefined) {
            return;
        }
        if (typeof val === 'string') {
            // This setter part is for the value coming from parent in format of a date string
            // which should not emit the change event after the modelValue is set.
            try {
                // Check if the input string is conformed with date string format: yyyy-mm-dd or yyyy/mm/dd
                if (val.match(/\d{4}[/-]\d{2}[/-]\d{2}/)) {
                    const dateObj = new Date(val);
                    this.modelValue = {
                        year: dateObj.getFullYear(),
                        month: dateObj.getMonth() + 1,
                        day: dateObj.getDate(),
                    };
                }
            }
            catch (e) {
                throw new Error(`Invalid date string input;\nError: ${e}`);
            }
        }
        else if (typeof val === 'object') {
            if (val instanceof Date) {
                // This setter part is for the value coming from parent in format of a Date object
                // which should not emit the change event after the modelValue is set.
                this.modelValue = {
                    year: val.getFullYear(),
                    month: val.getMonth() + 1,
                    day: val.getDate(),
                };
            }
            else {
                // This setter part is for the value coming from ngbDatePicker child
                // which should emit the change event after the modelValue is set
                const isValidDateInputObject = val.hasOwnProperty('year') && val.hasOwnProperty('month') && val.hasOwnProperty('day');
                if (isValidDateInputObject) {
                    this.modelValue = val;
                    this.modelChange.emit(this.formatModelForOutput());
                }
                else {
                    throw new Error(`Invalid date object input: ${val};\n
                    Error: Missing one of the following properties: 'year', 'month', 'day'`);
                }
            }
        }
    }
    get label() {
        return this.labelValue;
    }
    set label(label) {
        this.labelAsId = label.replace(/[\s]/g, '');
        this.labelValue = label;
    }
    formatModelForOutput() {
        return `${this.modelValue.year}-${this.modelValue.month}-${this.modelValue.day}`;
    }
    static { this.ɵfac = function DatepickerComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DatepickerComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DatepickerComponent, selectors: [["mon-form-field-datepicker"]], inputs: { model: "model", label: "label", helpTxt: "helpTxt", monPlaceholder: "monPlaceholder", ngRequired: "ngRequired", datePickerInputName: "datePickerInputName" }, outputs: { modelChange: "modelChange" }, features: [i0.ɵɵProvidersFeature([], [{ provide: ControlContainer, useExisting: NgForm }])], decls: 12, vars: 9, consts: [["d", "ngbDatepicker"], [1, "mon-form-field-datepicker", "form-group", "row", "mb-1"], ["class", "col-sm-2 col-form-label text-bold text-right capitalize-first-letter separator pt-2", 4, "ngIf"], [1, "w-100", 3, "ngClass"], [1, "outer-t-mini"], [1, "input-group"], [1, "input-group-btn"], ["type", "button", 1, "btn", "btn-default", "btn-secondary", "cursor-pointer", 3, "click"], ["aria-hidden", "true", 1, "fas", "fa-calendar-alt"], ["ngbDatepicker", "", 1, "form-control", 3, "ngModelChange", "placeholder", "name", "ngModel"], [1, "form-text", "text-muted"], [1, "col-sm-2", "col-form-label", "text-bold", "text-right", "capitalize-first-letter", "separator", "pt-2"], [3, "hidden"]], template: function DatepickerComponent_Template(rf, ctx) { if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵtemplate(1, DatepickerComponent_label_1_Template, 4, 3, "label", 2);
            i0.ɵɵelementStart(2, "div", 3)(3, "div", 4)(4, "div", 5)(5, "span", 6)(6, "button", 7);
            i0.ɵɵlistener("click", function DatepickerComponent_Template_button_click_6_listener() { i0.ɵɵrestoreView(_r1); const d_r3 = i0.ɵɵreference(9); return i0.ɵɵresetView(d_r3.toggle()); });
            i0.ɵɵelement(7, "span", 8);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(8, "input", 9, 0);
            i0.ɵɵtwoWayListener("ngModelChange", function DatepickerComponent_Template_input_ngModelChange_8_listener($event) { i0.ɵɵrestoreView(_r1); i0.ɵɵtwoWayBindingSet(ctx.model, $event) || (ctx.model = $event); return i0.ɵɵresetView($event); });
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(10, "span", 10);
            i0.ɵɵtext(11);
            i0.ɵɵelementEnd()()();
        } if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.label);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(6, _c0$m, ctx.label, !ctx.label));
            i0.ɵɵadvance(6);
            i0.ɵɵproperty("placeholder", ctx.monPlaceholder)("name", ctx.datePickerInputName);
            i0.ɵɵtwoWayProperty("ngModel", ctx.model);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.helpTxt);
        } }, dependencies: [i1$5.DefaultValueAccessor, i1$5.NgControlStatus, i1$5.NgModel, i1$2.NgClass, i1$2.NgIf, i1$4.NgbInputDatepicker], styles: [".select-grey[_ngcontent-%COMP%]   .ngx-select__toggle[_ngcontent-%COMP%]{display:block;margin:0;position:relative;overflow:hidden;cursor:pointer;border:1px solid #bbb;box-shadow:0 1px #0000000d,inset 0 1px #fffc;box-sizing:border-box;border-radius:3px;font-weight:inherit}.mon-form-field-datepicker[_ngcontent-%COMP%]{color:#555557}.mon-form-field-datepicker[_ngcontent-%COMP%]   .separator[_ngcontent-%COMP%]{margin-bottom:10px}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DatepickerComponent, [{
        type: Component,
        args: [{ selector: 'mon-form-field-datepicker', viewProviders: [{ provide: ControlContainer, useExisting: NgForm }], template: "<div class=\"mon-form-field-datepicker form-group row mb-1\">\n    <label *ngIf=\"label\" [attr.for]=\"labelAsId\" class=\"col-sm-2 col-form-label text-bold text-right capitalize-first-letter separator pt-2\">\n        {{ label }}\n        <span [hidden]=\"!ngRequired\">*</span>\n    </label>\n    <div class=\"w-100\" [ngClass]=\"{'col-sm-10' : label, 'col-sm-12': !label }\">\n        <div class=\"outer-t-mini\">\n            <div class=\"input-group\">\n                <span class=\"input-group-btn\">\n                    <button class=\"btn btn-default btn-secondary cursor-pointer\" type=\"button\" (click)=\"d.toggle()\">\n                    <span class=\"fas fa-calendar-alt\" aria-hidden=\"true\"></span>\n                </button>\n                </span>\n                <input ngbDatepicker\n                       #d=\"ngbDatepicker\"\n                       [placeholder]=\"monPlaceholder\"\n                       class=\"form-control\"\n                       [name]=\"datePickerInputName\"\n                       [(ngModel)]=\"model\">\n            </div>\n        </div>\n        <span class=\"form-text text-muted\">{{ helpTxt }}</span>\n    </div>\n</div>\n", styles: [".select-grey .ngx-select__toggle{display:block;margin:0;position:relative;overflow:hidden;cursor:pointer;border:1px solid #bbb;box-shadow:0 1px #0000000d,inset 0 1px #fffc;box-sizing:border-box;border-radius:3px;font-weight:inherit}.mon-form-field-datepicker{color:#555557}.mon-form-field-datepicker .separator{margin-bottom:10px}\n"] }]
    }], null, { modelChange: [{
            type: Output
        }], model: [{
            type: Input
        }], label: [{
            type: Input
        }], helpTxt: [{
            type: Input
        }], monPlaceholder: [{
            type: Input
        }], ngRequired: [{
            type: Input
        }], datePickerInputName: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DatepickerComponent, { className: "DatepickerComponent" }); })();

class DatepickerModule {
    static { this.ɵfac = function DatepickerModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DatepickerModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: DatepickerModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [FormsModule, FormBuilderValidationModule, CommonModule, NgbDatepickerModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DatepickerModule, [{
        type: NgModule,
        args: [{
                imports: [FormsModule, FormBuilderValidationModule, CommonModule, NgbDatepickerModule],
                exports: [DatepickerComponent],
                declarations: [DatepickerComponent],
                providers: [],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(DatepickerModule, { declarations: [DatepickerComponent], imports: [FormsModule, FormBuilderValidationModule, CommonModule, NgbDatepickerModule], exports: [DatepickerComponent] }); })();

const _c0$l = (a0, a1) => ({ "col-sm-10": a0, "col-sm-12": a1 });
function DatepickerAcComponent_label_1_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function DatepickerAcComponent_label_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 12);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, DatepickerAcComponent_label_1_span_2_Template, 2, 0, "span", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("for", ctx_r1.labelAsId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.required);
} }
class DatepickerAcComponent extends AbstractControlValueAccessor {
    constructor() {
        super(...arguments);
        this.modelChange = new EventEmitter();
        this.monPlaceholder = 'yyyy-mm-dd';
    }
    get model() {
        return this.returnValue;
    }
    set model(val) {
        if (val === null || val === undefined) {
            return;
        }
        if (typeof val === 'string') {
            // This setter part is for the value coming from parent in format of a date string
            // which should not emit the change event after the returnValue is set.
            try {
                // Check if the input string is conformed with date string format: yyyy-mm-dd or yyyy/mm/dd
                if (val.match(/\d{4}[/-]\d{2}[/-]\d{2}/)) {
                    const dateObj = new Date(val);
                    this.returnValue = {
                        year: dateObj.getFullYear(),
                        month: dateObj.getMonth() + 1,
                        day: dateObj.getDate(),
                    };
                }
            }
            catch (e) {
                throw new Error(`Invalid date string input;\nError: ${e}`);
            }
        }
        else if (typeof val === 'object') {
            if (val instanceof Date) {
                // This setter part is for the value coming from parent in format of a Date object
                // which should not emit the change event after the returnValue is set.
                this.returnValue = {
                    year: val.getFullYear(),
                    month: val.getMonth() + 1,
                    day: val.getDate(),
                };
            }
            else {
                // This setter part is for the value coming from ngbDatePicker child
                // which should emit the change event after the returnValue is set
                const isValidDateInputObject = val.hasOwnProperty('year') && val.hasOwnProperty('month') && val.hasOwnProperty('day');
                if (isValidDateInputObject) {
                    this.returnValue = val;
                    this.modelChange.emit(this.formatModelForOutput());
                }
                else {
                    throw new Error(`Invalid date object input: ${val};\n
                    Error: Missing one of the following properties: 'year', 'month', 'day'`);
                }
            }
        }
    }
    get label() {
        return this.labelValue;
    }
    set label(label) {
        this.labelAsId = label.replace(/[\s]/g, '');
        this.labelValue = label;
    }
    ngOnInit() {
        this.computedId = this.getLabelForId(this.labelValue);
    }
    ngOnDestroy() {
        this.computedId = null;
    }
    onModelChange(value) {
        this.onChange(value);
    }
    formatModelForOutput() {
        return `${this.returnValue.year}-${this.returnValue.month}-${this.returnValue.day}`;
    }
    static { this.ɵfac = /*@__PURE__*/ (() => { let ɵDatepickerAcComponent_BaseFactory; return function DatepickerAcComponent_Factory(__ngFactoryType__) { return (ɵDatepickerAcComponent_BaseFactory || (ɵDatepickerAcComponent_BaseFactory = i0.ɵɵgetInheritedFactory(DatepickerAcComponent)))(__ngFactoryType__ || DatepickerAcComponent); }; })(); }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DatepickerAcComponent, selectors: [["mon-form-field-datepicker-ac"]], inputs: { model: "model", label: "label", helpTxt: "helpTxt", monPlaceholder: "monPlaceholder", datePickerInputName: "datePickerInputName" }, outputs: { modelChange: "modelChange" }, features: [i0.ɵɵProvidersFeature([
                {
                    provide: NG_VALUE_ACCESSOR,
                    useExisting: DatepickerAcComponent,
                    multi: true,
                },
            ]), i0.ɵɵInheritDefinitionFeature], decls: 14, vars: 10, consts: [["d", "ngbDatepicker", "datepickerInput", "ngModel"], [1, "mon-form-field-datepicker", "form-group", "row", "mb-1"], ["class", "col-sm-2 col-form-label text-bold text-right capitalize-first-letter separator pt-2", 4, "ngIf"], [1, "w-100", 3, "ngClass"], [1, "outer-t-mini"], [1, "input-group"], [1, "input-group-btn"], ["type", "button", 1, "btn", "btn-default", "btn-secondary", "cursor-pointer", 3, "click"], ["aria-hidden", "true", 1, "fas", "fa-calendar-alt"], ["ngbDatepicker", "", 1, "form-control", 3, "ngModelChange", "placeholder", "ngModel", "required"], [3, "formElementControl"], [1, "form-text", "text-muted"], [1, "col-sm-2", "col-form-label", "text-bold", "text-right", "capitalize-first-letter", "separator", "pt-2"], [4, "ngIf"]], template: function DatepickerAcComponent_Template(rf, ctx) { if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵtemplate(1, DatepickerAcComponent_label_1_Template, 3, 3, "label", 2);
            i0.ɵɵelementStart(2, "div", 3)(3, "div", 4)(4, "div", 5)(5, "span", 6)(6, "button", 7);
            i0.ɵɵlistener("click", function DatepickerAcComponent_Template_button_click_6_listener() { i0.ɵɵrestoreView(_r1); const d_r3 = i0.ɵɵreference(9); return i0.ɵɵresetView(d_r3.toggle()); });
            i0.ɵɵelement(7, "span", 8);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(8, "input", 9, 0);
            i0.ɵɵtwoWayListener("ngModelChange", function DatepickerAcComponent_Template_input_ngModelChange_8_listener($event) { i0.ɵɵrestoreView(_r1); i0.ɵɵtwoWayBindingSet(ctx.returnValue, $event) || (ctx.returnValue = $event); return i0.ɵɵresetView($event); });
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(11, "mon-form-field-errors-ac", 10);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(12, "span", 11);
            i0.ɵɵtext(13);
            i0.ɵɵelementEnd()()();
        } if (rf & 2) {
            const datepickerInput_r4 = i0.ɵɵreference(10);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.label);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(7, _c0$l, ctx.label, !ctx.label));
            i0.ɵɵadvance(6);
            i0.ɵɵproperty("placeholder", ctx.monPlaceholder);
            i0.ɵɵtwoWayProperty("ngModel", ctx.returnValue);
            i0.ɵɵproperty("required", ctx.required);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("formElementControl", datepickerInput_r4.control);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.helpTxt);
        } }, dependencies: [i1$5.DefaultValueAccessor, i1$5.NgControlStatus, i1$5.RequiredValidator, i1$5.NgModel, ErrorMessagesAcComponent, i1$2.NgClass, i1$2.NgIf, i1$4.NgbInputDatepicker], styles: [".select-grey[_ngcontent-%COMP%]   .ngx-select__toggle[_ngcontent-%COMP%]{display:block;margin:0;position:relative;overflow:hidden;cursor:pointer;border:1px solid #bbb;box-shadow:0 1px #0000000d,inset 0 1px #fffc;box-sizing:border-box;border-radius:3px;font-weight:inherit}.mon-form-field-datepicker[_ngcontent-%COMP%]{color:#555557}.mon-form-field-datepicker[_ngcontent-%COMP%]   .separator[_ngcontent-%COMP%]{margin-bottom:10px}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DatepickerAcComponent, [{
        type: Component,
        args: [{ selector: 'mon-form-field-datepicker-ac', providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: DatepickerAcComponent,
                        multi: true,
                    },
                ], template: "<div class=\"mon-form-field-datepicker form-group row mb-1\">\n    <label *ngIf=\"label\" [attr.for]=\"labelAsId\" class=\"col-sm-2 col-form-label text-bold text-right capitalize-first-letter separator pt-2\">\n        {{ label }}\n        <span *ngIf=\"required\">*</span>\n    </label>\n    <div class=\"w-100\" [ngClass]=\"{'col-sm-10' : label, 'col-sm-12': !label }\">\n        <div class=\"outer-t-mini\">\n            <div class=\"input-group\">\n                <span class=\"input-group-btn\">\n                    <button class=\"btn btn-default btn-secondary cursor-pointer\" type=\"button\" (click)=\"d.toggle()\">\n                    <span class=\"fas fa-calendar-alt\" aria-hidden=\"true\"></span>\n                </button>\n                </span>\n                <input ngbDatepicker\n                       [placeholder]=\"monPlaceholder\"\n                       class=\"form-control\"\n                       [(ngModel)]=\"returnValue\"\n                       [required]=\"required\"\n                       #d=\"ngbDatepicker\"\n                       #datepickerInput=\"ngModel\">\n            </div>\n            <mon-form-field-errors-ac\n                [formElementControl]=\"datepickerInput.control\">\n            </mon-form-field-errors-ac>\n        </div>\n        <span class=\"form-text text-muted\" >{{ helpTxt }}</span>\n    </div>\n</div>\n", styles: [".select-grey .ngx-select__toggle{display:block;margin:0;position:relative;overflow:hidden;cursor:pointer;border:1px solid #bbb;box-shadow:0 1px #0000000d,inset 0 1px #fffc;box-sizing:border-box;border-radius:3px;font-weight:inherit}.mon-form-field-datepicker{color:#555557}.mon-form-field-datepicker .separator{margin-bottom:10px}\n"] }]
    }], null, { modelChange: [{
            type: Output
        }], model: [{
            type: Input
        }], label: [{
            type: Input
        }], helpTxt: [{
            type: Input
        }], monPlaceholder: [{
            type: Input
        }], datePickerInputName: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DatepickerAcComponent, { className: "DatepickerAcComponent" }); })();

class DatepickerAcModule {
    static { this.ɵfac = function DatepickerAcModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DatepickerAcModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: DatepickerAcModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [FormsModule, FormBuilderValidationModule, CommonModule, NgbDatepickerModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DatepickerAcModule, [{
        type: NgModule,
        args: [{
                imports: [FormsModule, FormBuilderValidationModule, CommonModule, NgbDatepickerModule],
                exports: [DatepickerAcComponent],
                declarations: [DatepickerAcComponent],
                providers: [],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(DatepickerAcModule, { declarations: [DatepickerAcComponent], imports: [FormsModule, FormBuilderValidationModule, CommonModule, NgbDatepickerModule], exports: [DatepickerAcComponent] }); })();

const _c0$k = (a0, a1) => ({ "col-sm-36": a0, "col-sm-44": a1 });
function DynamicComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8)(1, "div", 9)(2, "mon-table-search", 10);
    i0.ɵɵlistener("getPage", function DynamicComponent_div_0_Template_mon_table_search_getPage_2_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.onSearchChanged($event)); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("model", ctx_r1.search);
} }
function DynamicComponent_div_1_label_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const indexPosition_r4 = i0.ɵɵnextContext().index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("for", ctx_r1.labelText + indexPosition_r4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.label, " ");
} }
function DynamicComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵtemplate(1, DynamicComponent_div_1_label_1_Template, 2, 2, "label", 12);
    i0.ɵɵelementStart(2, "div", 13)(3, "input", 14);
    i0.ɵɵtwoWayListener("ngModelChange", function DynamicComponent_div_1_Template_input_ngModelChange_3_listener($event) { const model_r5 = i0.ɵɵrestoreView(_r3).$implicit; const ctx_r1 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(model_r5[ctx_r1.attrName], $event) || (model_r5[ctx_r1.attrName] = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 15);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 16)(7, "button", 5);
    i0.ɵɵlistener("click", function DynamicComponent_div_1_Template_button_click_7_listener() { const model_r5 = i0.ɵɵrestoreView(_r3).$implicit; const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.removeFromModel(model_r5)); });
    i0.ɵɵelement(8, "span", 17);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const model_r5 = ctx.$implicit;
    const indexPosition_r4 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.label);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(7, _c0$k, ctx_r1.label, !ctx_r1.label));
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("ngModel", model_r5[ctx_r1.attrName]);
    i0.ɵɵproperty("id", ctx_r1.labelText + indexPosition_r4);
    i0.ɵɵattribute("type", ctx_r1.type)("placeholder", ctx_r1.placeholder);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.helpText);
} }
function DynamicComponent_div_9_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0, "\u00AB");
} }
function DynamicComponent_div_9_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0, "\u00BB");
} }
function DynamicComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 19)(1, "ngb-pagination", 20);
    i0.ɵɵtwoWayListener("pageChange", function DynamicComponent_div_9_Template_ngb_pagination_pageChange_1_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r1 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r1.page, $event) || (ctx_r1.page = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵtemplate(2, DynamicComponent_div_9_ng_template_2_Template, 1, 0, "ng-template", 21)(3, DynamicComponent_div_9_ng_template_3_Template, 1, 0, "ng-template", 22);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("page", ctx_r1.page);
    i0.ɵɵproperty("pageSize", ctx_r1.pageSize)("collectionSize", ctx_r1.models.length)("rotate", true);
} }
/**
 *
 * @deprecated Use the {@link DynamicAcComponent} instead.
 */
class DynamicComponent extends BaseFieldComponent {
    get monModel() {
        return this._monModel;
    }
    set monModel(model) {
        this._monModel = model || [];
        this.monModelChange.emit(this._monModel);
        this.updateModels();
    }
    constructor(searchService, translateService) {
        super();
        this.searchService = searchService;
        this.translateService = translateService;
        this.allowSearch = false;
        this.allowPagination = false;
        this.pageSize = 999;
        this.monModelChange = new EventEmitter();
        // Label name for the input fields
        this.label = '';
        // Input type..
        this.type = 'text';
        this.placeholder = '';
        this.confirmMsg = this.translateService.getString('Are you sure you want to remove this?');
        // Property name on the model collection
        this.attrName = 'name';
        this.helpText = '';
        this.textInAddBtn = '';
        this.page = 1;
        this.search = '';
        this.models = [];
        this._monModel = [];
    }
    ngOnInit() {
        if (this.monModel.length === 0) {
            this.monModel.push({});
        }
        this.labelText = this.getLabelForId(this.label) || 'formFieldDynamic';
    }
    onSearchChanged(search) {
        this.search = search;
        this.updateModels();
    }
    updateModels() {
        if (!this.search) {
            this.models = this.monModel;
            return;
        }
        this.models = this.monModel.filter((model) => {
            return !model[this.attrName] || this.searchService.fuzzy(this.search, model[this.attrName]);
        });
    }
    pushToModel() {
        const empty = {
            [this.attrName]: '',
        };
        this.monModel.push(empty);
        this.updateModels();
    }
    removeFromModel(model) {
        // NB! May be necessary to set the indexOf search in a private function for unifying search for model reference on input change.
        const index = this.monModel.indexOf(model);
        if (index !== -1) {
            this.monModel.splice(index, 1);
        }
    }
    static { this.ɵfac = function DynamicComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DynamicComponent)(i0.ɵɵdirectiveInject(SearchService), i0.ɵɵdirectiveInject(TranslateServiceInjectionToken)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DynamicComponent, selectors: [["mon-form-field-dynamic"]], inputs: { allowSearch: "allowSearch", allowPagination: "allowPagination", pageSize: "pageSize", monModel: "monModel", label: "label", type: "type", placeholder: "placeholder", confirmMsg: "confirmMsg", attrName: "attrName", helpText: "helpText", textInAddBtn: "textInAddBtn" }, outputs: { monModelChange: "monModelChange" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 10, vars: 8, consts: [["class", "row mb-2", 4, "ngIf"], ["class", "form-group row mx-auto w-100", 4, "ngFor", "ngForOf"], [1, "row"], [1, "offset-sm-8", "col-sm-48", "d-flex", "align-items-center", "mx-2", "justify-content-between"], [1, "mr-auto"], ["type", "button", 1, "btn", "btn-default", "btn-secondary", 3, "click"], ["aria-hidden", "true", 1, "fas", "fa-plus"], ["class", "pr-2", 4, "ngIf"], [1, "row", "mb-2"], [1, "col-sm-24", "col-sm-offset-22"], ["minSearchLength", "1", 3, "getPage", "model"], [1, "form-group", "row", "mx-auto", "w-100"], ["class", "col-sm-8 text-bold text-right capitalize-first-letter", 4, "ngIf"], [3, "ngClass"], [1, "form-control", 3, "ngModelChange", "ngModel", "id"], [1, "help-block"], [1, "col-sm-4", "text-right"], [1, "fas", "fa-trash-alt"], [1, "col-sm-8", "text-bold", "text-right", "capitalize-first-letter"], [1, "pr-2"], ["maxSize", "7", 3, "pageChange", "page", "pageSize", "collectionSize", "rotate"], ["ngbPaginationPrevious", ""], ["ngbPaginationNext", ""]], template: function DynamicComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, DynamicComponent_div_0_Template, 3, 1, "div", 0)(1, DynamicComponent_div_1_Template, 9, 10, "div", 1);
            i0.ɵɵpipe(2, "slice");
            i0.ɵɵelementStart(3, "div", 2)(4, "div", 3)(5, "div", 4)(6, "button", 5);
            i0.ɵɵlistener("click", function DynamicComponent_Template_button_click_6_listener() { return ctx.pushToModel(); });
            i0.ɵɵelement(7, "span", 6);
            i0.ɵɵtext(8);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(9, DynamicComponent_div_9_Template, 4, 4, "div", 7);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.allowSearch);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind3(2, 4, ctx.models, (ctx.page - 1) * ctx.pageSize, ctx.page * ctx.pageSize));
            i0.ɵɵadvance(7);
            i0.ɵɵtextInterpolate1(" ", ctx.textInAddBtn, " ");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.allowPagination && ctx.models.length > 5);
        } }, dependencies: [i1$5.DefaultValueAccessor, i1$5.NgControlStatus, i1$5.NgModel, i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, TableSearchComponent, i1$4.NgbPagination, i1$4.NgbPaginationNext, i1$4.NgbPaginationPrevious, i1$2.SlicePipe], styles: [".select-grey[_ngcontent-%COMP%]   .ngx-select__toggle[_ngcontent-%COMP%]{display:block;margin:0;position:relative;overflow:hidden;cursor:pointer;border:1px solid #bbb;box-shadow:0 1px #0000000d,inset 0 1px #fffc;box-sizing:border-box;border-radius:3px;font-weight:inherit}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DynamicComponent, [{
        type: Component,
        args: [{ selector: 'mon-form-field-dynamic', template: "<div class=\"row mb-2\" *ngIf=\"allowSearch\">\n    <div class=\"col-sm-24 col-sm-offset-22\">\n        <mon-table-search\n            minSearchLength=\"1\"\n            (getPage)=\"onSearchChanged($event)\"\n            [model]=\"search\">\n        </mon-table-search>\n    </div>\n</div>\n<div class=\"form-group row mx-auto w-100\"\n     *ngFor=\"let model of models | slice: (page-1) * pageSize : page * pageSize; let indexPosition = index;\">\n    <label *ngIf=\"label\"\n           [attr.for]=\"labelText + indexPosition\"\n           class=\"col-sm-8 text-bold text-right capitalize-first-letter\">\n        {{ label }}\n    </label>\n    <div [ngClass]=\"{'col-sm-36' : label, 'col-sm-44': !label }\">\n        <input [(ngModel)]=\"model[attrName]\"\n               [attr.type]=\"type\"\n               class=\"form-control\"\n               [id]=\"labelText + indexPosition\"\n               [attr.placeholder]=\"placeholder\" />\n        <span class=\"help-block\">{{ helpText }}</span>\n    </div>\n    <div class=\"col-sm-4 text-right \">\n        <button type=\"button\"\n                (click)=\"removeFromModel(model)\"\n                class=\"btn btn-default btn-secondary\">\n            <span class=\"fas fa-trash-alt\"></span>\n        </button>\n    </div>\n</div>\n<div class=\"row\">\n    <div class=\"offset-sm-8 col-sm-48 d-flex align-items-center mx-2 justify-content-between\">\n        <div class=\"mr-auto\">\n            <button type=\"button\"\n                    (click)=\"pushToModel()\"\n                    class=\"btn btn-default btn-secondary\">\n                <span class=\"fas fa-plus\" aria-hidden=\"true\"></span>\n                {{textInAddBtn}}\n            </button>\n        </div>\n        <div class=\"pr-2\" *ngIf=\"allowPagination && models.length > 5\">\n            <ngb-pagination\n                [(page)]=\"page\"\n                maxSize=\"7\"\n                [pageSize]=\"pageSize\"\n                [collectionSize]=\"models.length\"\n                [rotate]=\"true\">\n                <ng-template ngbPaginationPrevious>&laquo;</ng-template>\n                <ng-template ngbPaginationNext>&raquo;</ng-template>\n            </ngb-pagination>\n        </div>\n    </div>\n</div>\n", styles: [".select-grey .ngx-select__toggle{display:block;margin:0;position:relative;overflow:hidden;cursor:pointer;border:1px solid #bbb;box-shadow:0 1px #0000000d,inset 0 1px #fffc;box-sizing:border-box;border-radius:3px;font-weight:inherit}\n"] }]
    }], () => [{ type: SearchService }, { type: undefined, decorators: [{
                type: Inject,
                args: [TranslateServiceInjectionToken]
            }] }], { allowSearch: [{
            type: Input
        }], allowPagination: [{
            type: Input
        }], pageSize: [{
            type: Input
        }], monModel: [{
            type: Input
        }], monModelChange: [{
            type: Output
        }], label: [{
            type: Input
        }], type: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], confirmMsg: [{
            type: Input
        }], attrName: [{
            type: Input
        }], helpText: [{
            type: Input
        }], textInAddBtn: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DynamicComponent, { className: "DynamicComponent" }); })();

class FormBuilderDynamicModule {
    static { this.ɵfac = function FormBuilderDynamicModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FormBuilderDynamicModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: FormBuilderDynamicModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [SearchService], imports: [FormsModule,
            CommonModule,
            TableSearchModule,
            NgbPaginationModule,
            TranslateModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormBuilderDynamicModule, [{
        type: NgModule,
        args: [{
                imports: [
                    FormsModule,
                    CommonModule,
                    TableSearchModule,
                    NgbPaginationModule,
                    TranslateModule,
                ],
                exports: [DynamicComponent],
                declarations: [DynamicComponent],
                providers: [SearchService],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(FormBuilderDynamicModule, { declarations: [DynamicComponent], imports: [FormsModule,
        CommonModule,
        TableSearchModule,
        NgbPaginationModule,
        TranslateModule], exports: [DynamicComponent] }); })();

const _c0$j = ["inputLinkController"];
const _c1$8 = (a0, a1) => ({ "col-sm-40": a0, "col-sm-48": a1 });
function TextareaComponent_label_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "span", 7);
    i0.ɵɵtext(3, "*");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("for", ctx_r1.labelAsId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("hidden", !ctx_r1.ngRequired);
} }
/**
 *
 * @deprecated Use the {@link TextareaAcComponent} instead.
 */
class TextareaComponent extends BaseFieldComponent {
    constructor() {
        super(...arguments);
        this.modelChange = new EventEmitter();
    }
    get model() {
        return this.modelValue;
    }
    set model(val) {
        this.modelValue = val;
        this.modelChange.emit(this.modelValue);
    }
    get label() {
        return this.labelValue;
    }
    set label(label) {
        this.labelAsId = label.replace(/[\s]/g, '');
        this.labelValue = label;
    }
    FormFieldInputLinkController() {
        const input = this.el.nativeElement.querySelector('textarea');
        if (!input) {
            return;
        }
        input.addEventListener('focusout', () => {
            if (typeof input.markAsTouched === 'function') {
                input.markAsTouched();
            }
        });
        input.addEventListener('keyup', () => {
            if (typeof input.markAsDirty === 'function') {
                input.markAsDirty();
            }
        });
    }
    ngOnInit() {
        this.ngRequired = this.ngRequired || false;
    }
    ngAfterInit() {
        this.FormFieldInputLinkController();
    }
    static { this.ɵfac = /*@__PURE__*/ (() => { let ɵTextareaComponent_BaseFactory; return function TextareaComponent_Factory(__ngFactoryType__) { return (ɵTextareaComponent_BaseFactory || (ɵTextareaComponent_BaseFactory = i0.ɵɵgetInheritedFactory(TextareaComponent)))(__ngFactoryType__ || TextareaComponent); }; })(); }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TextareaComponent, selectors: [["mon-form-field-textarea"]], viewQuery: function TextareaComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$j, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.el = _t.first);
        } }, inputs: { model: "model", label: "label", ngRequired: "ngRequired", helpTxt: "helpTxt", name: "name", placeholder: "placeholder", rows: "rows" }, outputs: { modelChange: "modelChange" }, features: [i0.ɵɵProvidersFeature([], [{ provide: ControlContainer, useExisting: NgForm }]), i0.ɵɵInheritDefinitionFeature], decls: 8, vars: 12, consts: [["inputLinkController", ""], [1, "form-group", "row"], ["class", "col-sm-8 col-form-label text-bold text-right capitalize-first-letter", 4, "ngIf"], [3, "ngClass"], [1, "form-control", 3, "ngModelChange", "ngModel", "name", "id", "rows", "placeholder", "required"], [1, "form-text", "text-muted"], [1, "col-sm-8", "col-form-label", "text-bold", "text-right", "capitalize-first-letter"], [3, "hidden"]], template: function TextareaComponent_Template(rf, ctx) { if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵtemplate(1, TextareaComponent_label_1_Template, 4, 3, "label", 2);
            i0.ɵɵelementStart(2, "div", 3)(3, "textarea", 4, 0);
            i0.ɵɵtwoWayListener("ngModelChange", function TextareaComponent_Template_textarea_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r1); i0.ɵɵtwoWayBindingSet(ctx.model, $event) || (ctx.model = $event); return i0.ɵɵresetView($event); });
            i0.ɵɵtext(5, "        ");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "span", 5);
            i0.ɵɵtext(7);
            i0.ɵɵelementEnd()()();
        } if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.label);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(9, _c1$8, ctx.label, !ctx.label));
            i0.ɵɵadvance();
            i0.ɵɵtwoWayProperty("ngModel", ctx.model);
            i0.ɵɵproperty("name", ctx.name)("id", ctx.labelAsId)("rows", ctx.rows)("placeholder", ctx.placeholder)("required", ctx.ngRequired);
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(ctx.helpTxt);
        } }, dependencies: [i1$5.DefaultValueAccessor, i1$5.NgControlStatus, i1$5.RequiredValidator, i1$5.NgModel, i1$2.NgClass, i1$2.NgIf], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TextareaComponent, [{
        type: Component,
        args: [{ selector: 'mon-form-field-textarea', viewProviders: [{ provide: ControlContainer, useExisting: NgForm }], template: "<div class=\"form-group row\">\n    <label *ngIf=\"label\" [attr.for]=\"labelAsId\" class=\"col-sm-8 col-form-label text-bold text-right capitalize-first-letter\">\n        {{ label }}\n        <span [hidden]=\"!ngRequired\">*</span>\n    </label>\n    <div [ngClass]=\"{'col-sm-40' : label, 'col-sm-48': !label }\">\n        <textarea #inputLinkController\n                  [(ngModel)]=\"model\"\n                  [name]=\"name\"\n                  class=\"form-control\"\n                  [id]=\"labelAsId\"\n                  [rows]=\"rows\"\n                  [placeholder]=\"placeholder\"\n                  [required]=\"ngRequired\">\n        </textarea>\n        <span class=\"form-text text-muted\">{{ helpTxt }}</span>\n    </div>\n</div>\n" }]
    }], null, { modelChange: [{
            type: Output
        }], model: [{
            type: Input
        }], label: [{
            type: Input
        }], ngRequired: [{
            type: Input
        }], helpTxt: [{
            type: Input
        }], name: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], rows: [{
            type: Input
        }], el: [{
            type: ViewChild,
            args: ['inputLinkController']
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(TextareaComponent, { className: "TextareaComponent" }); })();

class TextareaModule {
    static { this.ɵfac = function TextareaModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TextareaModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: TextareaModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [FormsModule, CommonModule, FormBuilderValidationModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TextareaModule, [{
        type: NgModule,
        args: [{
                imports: [FormsModule, CommonModule, FormBuilderValidationModule],
                exports: [TextareaComponent],
                declarations: [TextareaComponent],
                providers: [],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(TextareaModule, { declarations: [TextareaComponent], imports: [FormsModule, CommonModule, FormBuilderValidationModule], exports: [TextareaComponent] }); })();

const _c0$i = (a0, a1) => ({ "col-sm-40": a0, "col-sm-48": a1 });
function RadioNewLineComponent_label_1_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function RadioNewLineComponent_label_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 5);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, RadioNewLineComponent_label_1_span_2_Template, 2, 0, "span", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.monLabel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.ngRequired);
} }
function RadioNewLineComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7)(1, "label")(2, "input", 8);
    i0.ɵɵlistener("ngModelChange", function RadioNewLineComponent_div_3_Template_input_ngModelChange_2_listener() { const radio_r3 = i0.ɵɵrestoreView(_r2).$implicit; const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.onModelChange(radio_r3[ctx_r0.returnValue])); });
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const radio_r3 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("value", radio_r3[ctx_r0.returnValue])("ngModel", ctx_r0.model)("name", ctx_r0.monName)("disabled", ctx_r0.ngDisabled);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", radio_r3.name, " ");
} }
/**
 *
 * @deprecated Use the {@link RadioNewLineAcComponent} instead.
 */
class RadioNewLineComponent {
    constructor() {
        this.options = [];
        this.modelChange = new EventEmitter();
    }
    ngOnInit() {
        this.returnValue = this.returnValue || 'name';
        this.ngRequired = this.ngRequired || false;
    }
    onModelChange(value) {
        this.model = value;
        this.modelChange.emit(this.model);
    }
    static { this.ɵfac = function RadioNewLineComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || RadioNewLineComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: RadioNewLineComponent, selectors: [["mon-form-field-radio-new-line"]], inputs: { model: "model", monLabel: "monLabel", helpTxt: "helpTxt", options: "options", returnValue: "returnValue", ngRequired: "ngRequired", ngDisabled: "ngDisabled", monName: "monName" }, outputs: { modelChange: "modelChange" }, decls: 7, vars: 8, consts: [[1, "form-group", "outer-b-none"], ["class", "col-sm-8 control-label capitalize-first-letter", 4, "ngIf"], ["class", "radio", 4, "ngFor", "ngForOf"], [1, "help-block"], [1, "clearfix"], [1, "col-sm-8", "control-label", "capitalize-first-letter"], [4, "ngIf"], [1, "radio"], ["type", "radio", 3, "ngModelChange", "value", "ngModel", "name", "disabled"]], template: function RadioNewLineComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, RadioNewLineComponent_label_1_Template, 3, 2, "label", 1);
            i0.ɵɵelementStart(2, "div");
            i0.ɵɵtemplate(3, RadioNewLineComponent_div_3_Template, 4, 5, "div", 2);
            i0.ɵɵelementStart(4, "span", 3);
            i0.ɵɵtext(5);
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(6, "div", 4);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.monLabel);
            i0.ɵɵadvance();
            i0.ɵɵclassMap(i0.ɵɵpureFunction2(5, _c0$i, ctx.monLabel, !ctx.monLabel));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngForOf", ctx.options);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.helpTxt);
        } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, i1$5.DefaultValueAccessor, i1$5.RadioControlValueAccessor, i1$5.NgControlStatus, i1$5.NgModel], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RadioNewLineComponent, [{
        type: Component,
        args: [{ selector: 'mon-form-field-radio-new-line', template: "<div class=\"form-group outer-b-none\">\n    <label *ngIf=\"monLabel\" class=\"col-sm-8 control-label capitalize-first-letter\">{{ monLabel }}<span *ngIf=\"ngRequired\">*</span></label>\n    <div [class]=\"{'col-sm-40' : monLabel, 'col-sm-48': !monLabel }\">\n        <div class=\"radio\" *ngFor=\"let radio of options\">\n            <label>\n                <input [value]=\"radio[returnValue]\" [ngModel]=\"model\" type=\"radio\" [name]=\"monName\" [disabled]=\"ngDisabled\" (ngModelChange)=\"onModelChange(radio[returnValue])\">\n                {{ radio.name }}\n            </label>\n        </div>\n        <span class=\"help-block\">{{ helpTxt }}</span>\n    </div>\n    <div class=\"clearfix\"></div>\n</div>\n" }]
    }], null, { model: [{
            type: Input
        }], monLabel: [{
            type: Input
        }], helpTxt: [{
            type: Input
        }], options: [{
            type: Input
        }], returnValue: [{
            type: Input
        }], ngRequired: [{
            type: Input
        }], ngDisabled: [{
            type: Input
        }], monName: [{
            type: Input
        }], modelChange: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(RadioNewLineComponent, { className: "RadioNewLineComponent" }); })();

class RadioNewLineModule {
    static { this.ɵfac = function RadioNewLineModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || RadioNewLineModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: RadioNewLineModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [NgbTooltipModule, NgbDropdownModule, CommonModule, FormsModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RadioNewLineModule, [{
        type: NgModule,
        args: [{
                imports: [NgbTooltipModule, NgbDropdownModule, CommonModule, FormsModule],
                exports: [RadioNewLineComponent],
                declarations: [RadioNewLineComponent],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(RadioNewLineModule, { declarations: [RadioNewLineComponent], imports: [NgbTooltipModule, NgbDropdownModule, CommonModule, FormsModule], exports: [RadioNewLineComponent] }); })();

class MonSwitchComponent extends AbstractControlValueAccessor {
    ngOnInit() {
        const existingLabel = this.monLabel ? this.monLabel : this.name;
        const label = existingLabel || ('labelID' + Math.random().toString(16)
            .slice(2));
        this.computedId = this.getLabelForId(label);
        this.color = this.color || 'label-primary';
    }
    handleKeyboardEvent(event) {
        const { code } = event;
        if (event.altKey) {
            return;
        }
        switch (code) {
            case 'Enter': {
                this.value = !this.value;
                break;
            }
            default:
                break;
        }
    }
    static { this.ɵfac = /*@__PURE__*/ (() => { let ɵMonSwitchComponent_BaseFactory; return function MonSwitchComponent_Factory(__ngFactoryType__) { return (ɵMonSwitchComponent_BaseFactory || (ɵMonSwitchComponent_BaseFactory = i0.ɵɵgetInheritedFactory(MonSwitchComponent)))(__ngFactoryType__ || MonSwitchComponent); }; })(); }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MonSwitchComponent, selectors: [["mon-switch"]], inputs: { color: "color", name: "name", monLabel: "monLabel" }, features: [i0.ɵɵProvidersFeature([
                {
                    provide: NG_VALUE_ACCESSOR,
                    useExisting: MonSwitchComponent,
                    multi: true,
                },
            ]), i0.ɵɵInheritDefinitionFeature], decls: 5, vars: 7, consts: [[1, "form-group"], ["type", "checkbox", 3, "ngModelChange", "keydown", "ngModel", "id", "disabled", "name"], [1, "handle"], [1, "slide", 3, "ngClass"], [1, "pin", 3, "ngClass"]], template: function MonSwitchComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "label", 0)(1, "input", 1);
            i0.ɵɵtwoWayListener("ngModelChange", function MonSwitchComponent_Template_input_ngModelChange_1_listener($event) { i0.ɵɵtwoWayBindingSet(ctx.value, $event) || (ctx.value = $event); return $event; });
            i0.ɵɵlistener("keydown", function MonSwitchComponent_Template_input_keydown_1_listener($event) { return ctx.handleKeyboardEvent($event); });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "span", 2);
            i0.ɵɵelement(3, "span", 3)(4, "span", 4);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵattribute("for", ctx.computedId);
            i0.ɵɵadvance();
            i0.ɵɵtwoWayProperty("ngModel", ctx.value);
            i0.ɵɵproperty("id", ctx.computedId)("disabled", ctx.disabled)("name", ctx.name);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngClass", ctx.color);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", ctx.color);
        } }, dependencies: [i1$5.CheckboxControlValueAccessor, i1$5.NgControlStatus, i1$5.NgModel, i1$2.NgClass], styles: [".label-primary[_ngcontent-%COMP%]{background:#1c86db}label[_ngcontent-%COMP%]{height:30px;width:60px;padding:5px 10px;display:block;cursor:pointer;position:relative}label[_ngcontent-%COMP%] > input[type=checkbox][_ngcontent-%COMP%]{height:20px;width:40px;position:absolute;opacity:0}label[_ngcontent-%COMP%] > input[type=checkbox][_ngcontent-%COMP%]:disabled + .handle[_ngcontent-%COMP%]{cursor:not-allowed;filter:grayscale(100%);opacity:.6}label[_ngcontent-%COMP%] > input[type=checkbox][_ngcontent-%COMP%]:focus-visible + .handle[_ngcontent-%COMP%]{outline:none;box-shadow:0 0 0 3px #1c86db}label[_ngcontent-%COMP%] > input[type=checkbox][_ngcontent-%COMP%]:checked + .handle[_ngcontent-%COMP%]   .slide[_ngcontent-%COMP%]{opacity:.5}label[_ngcontent-%COMP%] > input[type=checkbox][_ngcontent-%COMP%]:checked + .handle[_ngcontent-%COMP%]   .pin[_ngcontent-%COMP%]{transform:translate(100%)}label[_ngcontent-%COMP%] > input[type=checkbox][_ngcontent-%COMP%]:not(:checked) + .handle[_ngcontent-%COMP%]   .pin[_ngcontent-%COMP%]{background:#fff}label[_ngcontent-%COMP%] > input[type=checkbox][_ngcontent-%COMP%]:not(:checked) + .handle[_ngcontent-%COMP%]   .slide[_ngcontent-%COMP%]{background:#000}label[_ngcontent-%COMP%] > .handle[_ngcontent-%COMP%]{position:absolute;width:40px;height:20px}label[_ngcontent-%COMP%] > .handle[_ngcontent-%COMP%]   .pin[_ngcontent-%COMP%], label[_ngcontent-%COMP%] > .handle[_ngcontent-%COMP%]   .slide[_ngcontent-%COMP%]{transition:all .25s cubic-bezier(.4,0,.2,1)}label[_ngcontent-%COMP%] > .handle[_ngcontent-%COMP%]   .slide[_ngcontent-%COMP%]{opacity:.6;width:40px;height:10px;top:5px;position:absolute;box-shadow:inset 0 0 10px #00000080;border-radius:8px}label[_ngcontent-%COMP%] > .handle[_ngcontent-%COMP%]   .pin[_ngcontent-%COMP%]{position:absolute;height:20px;width:20px;border-radius:16px;box-shadow:0 0 5px #0000004d}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MonSwitchComponent, [{
        type: Component,
        args: [{ selector: 'mon-switch', providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: MonSwitchComponent,
                        multi: true,
                    },
                ], template: "<label class=\"form-group\" [attr.for]=\"computedId\">\n    <input\n        [(ngModel)]=\"value\"\n        type=\"checkbox\"\n        [id]=\"computedId\"\n        (keydown)=\"handleKeyboardEvent($event)\"\n        [disabled]=\"disabled\"\n        [name]=\"name\"/>\n    <span class=\"handle\">\n        <span class=\"slide\" [ngClass]=\"color\"></span>\n        <span class=\"pin\" [ngClass]=\"color\"></span>\n    </span>\n</label>\n", styles: [".label-primary{background:#1c86db}label{height:30px;width:60px;padding:5px 10px;display:block;cursor:pointer;position:relative}label>input[type=checkbox]{height:20px;width:40px;position:absolute;opacity:0}label>input[type=checkbox]:disabled+.handle{cursor:not-allowed;filter:grayscale(100%);opacity:.6}label>input[type=checkbox]:focus-visible+.handle{outline:none;box-shadow:0 0 0 3px #1c86db}label>input[type=checkbox]:checked+.handle .slide{opacity:.5}label>input[type=checkbox]:checked+.handle .pin{transform:translate(100%)}label>input[type=checkbox]:not(:checked)+.handle .pin{background:#fff}label>input[type=checkbox]:not(:checked)+.handle .slide{background:#000}label>.handle{position:absolute;width:40px;height:20px}label>.handle .pin,label>.handle .slide{transition:all .25s cubic-bezier(.4,0,.2,1)}label>.handle .slide{opacity:.6;width:40px;height:10px;top:5px;position:absolute;box-shadow:inset 0 0 10px #00000080;border-radius:8px}label>.handle .pin{position:absolute;height:20px;width:20px;border-radius:16px;box-shadow:0 0 5px #0000004d}\n"] }]
    }], null, { color: [{
            type: Input
        }], name: [{
            type: Input
        }], monLabel: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(MonSwitchComponent, { className: "MonSwitchComponent" }); })();

class MonSwitchModule {
    static { this.ɵfac = function MonSwitchModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MonSwitchModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: MonSwitchModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [FormsModule, CommonModule, FormBuilderValidationModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MonSwitchModule, [{
        type: NgModule,
        args: [{
                imports: [FormsModule, CommonModule, FormBuilderValidationModule],
                exports: [MonSwitchComponent],
                declarations: [MonSwitchComponent],
                providers: [],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(MonSwitchModule, { declarations: [MonSwitchComponent], imports: [FormsModule, CommonModule, FormBuilderValidationModule], exports: [MonSwitchComponent] }); })();

const _c0$h = (a0, a1) => ({ "col-sm-40": a0, "col-sm-48": a1 });
function RadioNewLineAcComponent_label_1_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function RadioNewLineAcComponent_label_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 5);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, RadioNewLineAcComponent_label_1_span_2_Template, 2, 0, "span", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.monLabel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.ngRequired);
} }
function RadioNewLineAcComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7)(1, "label")(2, "input", 8);
    i0.ɵɵtwoWayListener("ngModelChange", function RadioNewLineAcComponent_div_3_Template_input_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r0 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r0.value, $event) || (ctx_r0.value = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("ngModelChange", function RadioNewLineAcComponent_div_3_Template_input_ngModelChange_2_listener() { const radio_r3 = i0.ɵɵrestoreView(_r2).$implicit; const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.onModelChange(radio_r3[ctx_r0.returnValue])); });
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const radio_r3 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r0.value);
    i0.ɵɵproperty("id", ctx_r0.computedId)("value", radio_r3[ctx_r0.returnValue])("name", ctx_r0.name)("disabled", ctx_r0.disabled)("required", ctx_r0.required);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", radio_r3.name, " ");
} }
class RadioNewLineAcComponent extends AbstractControlValueAccessor {
    constructor() {
        super(...arguments);
        this.options = [];
    }
    ngOnInit() {
        this.computedId = this.getLabelForId(this.monLabel);
        this.returnValue = this.returnValue || 'name';
    }
    ngOnDestroy() {
        this.computedId = null;
    }
    onModelChange(value) {
        this.onChange(value);
    }
    static { this.ɵfac = /*@__PURE__*/ (() => { let ɵRadioNewLineAcComponent_BaseFactory; return function RadioNewLineAcComponent_Factory(__ngFactoryType__) { return (ɵRadioNewLineAcComponent_BaseFactory || (ɵRadioNewLineAcComponent_BaseFactory = i0.ɵɵgetInheritedFactory(RadioNewLineAcComponent)))(__ngFactoryType__ || RadioNewLineAcComponent); }; })(); }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: RadioNewLineAcComponent, selectors: [["mon-form-field-radio-new-line-ac"]], inputs: { returnValue: "returnValue", monLabel: "monLabel", helpTxt: "helpTxt", options: "options" }, features: [i0.ɵɵProvidersFeature([
                {
                    provide: NG_VALUE_ACCESSOR,
                    useExisting: RadioNewLineAcComponent,
                    multi: true,
                },
            ]), i0.ɵɵInheritDefinitionFeature], decls: 7, vars: 8, consts: [[1, "form-group", "outer-b-none"], ["class", "col-sm-8 control-label capitalize-first-letter", 4, "ngIf"], ["class", "radio", 4, "ngFor", "ngForOf"], [1, "help-block"], [1, "clearfix"], [1, "col-sm-8", "control-label", "capitalize-first-letter"], [4, "ngIf"], [1, "radio"], ["type", "radio", 3, "ngModelChange", "ngModel", "id", "value", "name", "disabled", "required"]], template: function RadioNewLineAcComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, RadioNewLineAcComponent_label_1_Template, 3, 2, "label", 1);
            i0.ɵɵelementStart(2, "div");
            i0.ɵɵtemplate(3, RadioNewLineAcComponent_div_3_Template, 4, 7, "div", 2);
            i0.ɵɵelementStart(4, "span", 3);
            i0.ɵɵtext(5);
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(6, "div", 4);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.monLabel);
            i0.ɵɵadvance();
            i0.ɵɵclassMap(i0.ɵɵpureFunction2(5, _c0$h, ctx.monLabel, !ctx.monLabel));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngForOf", ctx.options);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.helpTxt);
        } }, dependencies: [i1$5.DefaultValueAccessor, i1$5.RadioControlValueAccessor, i1$5.NgControlStatus, i1$5.RequiredValidator, i1$5.NgModel, i1$2.NgForOf, i1$2.NgIf], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RadioNewLineAcComponent, [{
        type: Component,
        args: [{ selector: 'mon-form-field-radio-new-line-ac', providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: RadioNewLineAcComponent,
                        multi: true,
                    },
                ], template: "<div class=\"form-group outer-b-none\">\n    <label *ngIf=\"monLabel\" class=\"col-sm-8 control-label capitalize-first-letter\">{{ monLabel }}<span *ngIf=\"ngRequired\">*</span></label>\n    <div [class]=\"{'col-sm-40' : monLabel, 'col-sm-48': !monLabel }\">\n        <div class=\"radio\" *ngFor=\"let radio of options\">\n            <label>\n                <input \n                    [(ngModel)]=\"value\"\n                    [id]=\"computedId\"\n                    [value]=\"radio[returnValue]\"\n                    type=\"radio\" \n                    [name]=\"name\" \n                    [disabled]=\"disabled\"\n                    [required]=\"required\"\n                    (ngModelChange)=\"onModelChange(radio[returnValue])\">\n                {{ radio.name }}\n            </label>\n        </div>\n        <span class=\"help-block\">{{ helpTxt }}</span>\n    </div>\n    <div class=\"clearfix\"></div>\n</div>\n" }]
    }], null, { returnValue: [{
            type: Input
        }], monLabel: [{
            type: Input
        }], helpTxt: [{
            type: Input
        }], options: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(RadioNewLineAcComponent, { className: "RadioNewLineAcComponent" }); })();

class RadioNewLineAcModule {
    static { this.ɵfac = function RadioNewLineAcModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || RadioNewLineAcModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: RadioNewLineAcModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [FormsModule, NgbTooltipModule, NgbDropdownModule, CommonModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RadioNewLineAcModule, [{
        type: NgModule,
        args: [{
                imports: [FormsModule, NgbTooltipModule, NgbDropdownModule, CommonModule],
                exports: [RadioNewLineAcComponent],
                declarations: [RadioNewLineAcComponent],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(RadioNewLineAcModule, { declarations: [RadioNewLineAcComponent], imports: [FormsModule, NgbTooltipModule, NgbDropdownModule, CommonModule], exports: [RadioNewLineAcComponent] }); })();

/* eslint-disable @typescript-eslint/no-explicit-any */
const _c0$g = ["ngxSelect"];
const _c1$7 = (a0, a1) => ({ "sr-only": a0, "col-sm-8 col-form-label text-bold capitalize-first-letter pt-1 text-right": a1 });
const _c2$5 = a0 => ({ "background-color": a0 });
function SelectAcComponent_label_1_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function SelectAcComponent_label_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 6);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, SelectAcComponent_label_1_span_2_Template, 2, 0, "span", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(4, _c1$7, ctx_r0.monSrOnlyLabel, !ctx_r0.monSrOnlyLabel));
    i0.ɵɵattribute("for", ctx_r0.getLabelForId(ctx_r0.monLabel));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.monLabel, "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.required);
} }
function SelectAcComponent_ngx_select_3_ng_template_2_span_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 12);
} if (rf & 2) {
    const option_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(1, _c2$5, option_r3.data.color));
} }
function SelectAcComponent_ngx_select_3_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, SelectAcComponent_ngx_select_3_ng_template_2_span_0_Template, 1, 3, "span", 10);
    i0.ɵɵelement(1, "span", 11);
} if (rf & 2) {
    const text_r4 = ctx.text;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r0.monShowColors);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHtml", text_r4, i0.ɵɵsanitizeHtml);
} }
function SelectAcComponent_ngx_select_3_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ngx-select", 8, 0);
    i0.ɵɵlistener("click", function SelectAcComponent_ngx_select_3_Template_ngx_select_click_0_listener() { i0.ɵɵrestoreView(_r2); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.onSelectClick()); });
    i0.ɵɵtwoWayListener("ngModelChange", function SelectAcComponent_ngx_select_3_Template_ngx_select_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r0 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r0.value, $event) || (ctx_r0.value = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵtemplate(2, SelectAcComponent_ngx_select_3_ng_template_2_Template, 2, 2, "ng-template", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("allowClear", ctx_r0.monAllowClear)("autoClearSearch", ctx_r0.monAutoClearSearch)("name", ctx_r0.name)("disabled", ctx_r0.disabled)("required", ctx_r0.required)("placeholder", ctx_r0.monPlaceholder)("multiple", ctx_r0.monMultiple)("optionTextField", ctx_r0.monNameAttr)("optionValueField", ctx_r0.monReturnValue)("items", ctx_r0.monOptions)("size", ctx_r0.monSize)("noAutoComplete", ctx_r0.monNoAutoComplete);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r0.value);
} }
function SelectAcComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.monHelpText);
} }
class SelectAcComponent extends AbstractControlValueAccessor {
    constructor() {
        super(...arguments);
        this.monPlaceholder = '';
        this.monDefaultOptions = 'Choose an option';
        this.monReturnValue = '';
        this.monMultiple = false;
        this.monGroup = 'group';
        this.monNameAttr = 'name';
        this.monRemoveButton = false;
        this.monDisableSearch = false;
        this.monSize = 'small';
        this.monShowColors = false;
        this.monAutoClearSearch = true;
    }
    ngOnInit() {
        this.containerWidth = this.monLabel && !this.monSrOnlyLabel ? 'col-sm-40' : 'col-sm-48';
    }
    onSelectClick() {
        this.ngxSelect.optionsOpen();
    }
    static { this.ɵfac = /*@__PURE__*/ (() => { let ɵSelectAcComponent_BaseFactory; return function SelectAcComponent_Factory(__ngFactoryType__) { return (ɵSelectAcComponent_BaseFactory || (ɵSelectAcComponent_BaseFactory = i0.ɵɵgetInheritedFactory(SelectAcComponent)))(__ngFactoryType__ || SelectAcComponent); }; })(); }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SelectAcComponent, selectors: [["mon-form-field-select-ac"]], viewQuery: function SelectAcComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$g, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.ngxSelect = _t.first);
        } }, inputs: { monAllowClear: "monAllowClear", monPlaceholder: "monPlaceholder", monOptions: "monOptions", monLabel: "monLabel", monHelpText: "monHelpText", monSrOnlyLabel: "monSrOnlyLabel", monDefaultOptions: "monDefaultOptions", monReturnValue: "monReturnValue", monMultiple: "monMultiple", monGroup: "monGroup", monNameAttr: "monNameAttr", monViewTemplate: "monViewTemplate", monDropdownTemplate: "monDropdownTemplate", monGroupTemplate: "monGroupTemplate", monRemoveButton: "monRemoveButton", monDisableSearch: "monDisableSearch", monHelpTxt: "monHelpTxt", monNoAutoComplete: "monNoAutoComplete", monSize: "monSize", monShowColors: "monShowColors", monAutoClearSearch: "monAutoClearSearch" }, features: [i0.ɵɵProvidersFeature([
                {
                    provide: NG_VALUE_ACCESSOR,
                    useExisting: SelectAcComponent,
                    multi: true,
                },
            ], [{ provide: ControlContainer, useExisting: NgForm }]), i0.ɵɵInheritDefinitionFeature], decls: 5, vars: 4, consts: [["ngxSelect", ""], [1, "form-group", "row", "select-dropdown", "separator"], [3, "ngClass", 4, "ngIf"], [1, "select-grey", 3, "ngClass"], [3, "allowClear", "autoClearSearch", "name", "disabled", "required", "placeholder", "multiple", "optionTextField", "optionValueField", "items", "size", "noAutoComplete", "ngModel", "click", "ngModelChange", 4, "ngIf"], ["class", "form-text text-muted", 4, "ngIf"], [3, "ngClass"], [4, "ngIf"], [3, "click", "ngModelChange", "allowClear", "autoClearSearch", "name", "disabled", "required", "placeholder", "multiple", "optionTextField", "optionValueField", "items", "size", "noAutoComplete", "ngModel"], ["ngx-select-option", "", "ngx-select-option-selected", ""], ["class", "color-box", 3, "ngStyle", 4, "ngIf"], [3, "innerHtml"], [1, "color-box", 3, "ngStyle"], [1, "form-text", "text-muted"]], template: function SelectAcComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵtemplate(1, SelectAcComponent_label_1_Template, 3, 7, "label", 2);
            i0.ɵɵelementStart(2, "div", 3);
            i0.ɵɵtemplate(3, SelectAcComponent_ngx_select_3_Template, 3, 13, "ngx-select", 4)(4, SelectAcComponent_span_4_Template, 2, 1, "span", 5);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.monLabel);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", ctx.containerWidth);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.name);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.monHelpText);
        } }, dependencies: [i1$6.NgxSelectComponent, i1$6.NgxSelectOptionDirective, i1$6.NgxSelectOptionSelectedDirective, i1$5.NgControlStatus, i1$5.RequiredValidator, i1$5.NgModel, i1$2.NgClass, i1$2.NgIf, i1$2.NgStyle], styles: [".select-grey[_ngcontent-%COMP%]   .ngx-select__toggle[_ngcontent-%COMP%]{display:block;margin:0;position:relative;overflow:hidden;cursor:pointer;border:1px solid #bbb;box-shadow:0 1px #0000000d,inset 0 1px #fffc;box-sizing:border-box;border-radius:3px;font-weight:inherit}.form-text[_ngcontent-%COMP%]{display:block;margin-top:5px;color:#9a9d9e}.separator[_ngcontent-%COMP%]{margin-bottom:10px}.col-sm-10[_ngcontent-%COMP%]   .ngx-select__toggle[_ngcontent-%COMP%], .col-sm-12[_ngcontent-%COMP%]   .ngx-select__toggle[_ngcontent-%COMP%]{display:block;margin:0;position:relative;overflow:hidden;cursor:pointer;border:1px solid #bbb;box-shadow:0 1px #0000000d,inset 0 1px #fffc;box-sizing:border-box;border-radius:3px;font-weight:inherit}.color-box[_ngcontent-%COMP%]{display:inline-block;height:14px;width:14px;margin-right:4px}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SelectAcComponent, [{
        type: Component,
        args: [{ selector: 'mon-form-field-select-ac', viewProviders: [{ provide: ControlContainer, useExisting: NgForm }], providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: SelectAcComponent,
                        multi: true,
                    },
                ], template: "<div class=\"form-group row select-dropdown separator\">\n    <label *ngIf=\"monLabel\"\n           [attr.for]=\"getLabelForId(monLabel)\"\n           [ngClass]=\"{'sr-only': monSrOnlyLabel, 'col-sm-8 col-form-label text-bold capitalize-first-letter pt-1 text-right': !monSrOnlyLabel}\"\n    >\n        {{ monLabel }}<span *ngIf=\"required\">*</span>\n    </label>\n    <div class=\"select-grey\" [ngClass]=\"containerWidth\">\n        <ngx-select\n                *ngIf=\"name\"\n                #ngxSelect\n                (click)=\"onSelectClick()\"\n                [allowClear]=\"monAllowClear\"\n                [autoClearSearch]=\"monAutoClearSearch\"\n                [name]=\"name\"\n                [disabled]=\"disabled\"\n                [required]=\"required\"\n                [placeholder]=\"monPlaceholder\"\n                [multiple]=\"monMultiple\"\n                [optionTextField]=\"monNameAttr\"\n                [optionValueField]=\"monReturnValue\"\n                [items]=\"monOptions\"\n                [size]=\"monSize\"\n                [noAutoComplete]=\"monNoAutoComplete\"\n                [(ngModel)]=\"value\">\n                <ng-template ngx-select-option ngx-select-option-selected let-option let-text=\"text\">\n                    <span class=\"color-box\" [ngStyle]=\"{'background-color' : option.data.color}\" *ngIf=\"monShowColors\"></span>\n                    <span [innerHtml]=\"text\"></span>\n                </ng-template>\n        </ngx-select>\n        <span *ngIf=\"monHelpText\" class=\"form-text text-muted\">{{ monHelpText }}</span>\n    </div>\n</div>\n", styles: [".select-grey .ngx-select__toggle{display:block;margin:0;position:relative;overflow:hidden;cursor:pointer;border:1px solid #bbb;box-shadow:0 1px #0000000d,inset 0 1px #fffc;box-sizing:border-box;border-radius:3px;font-weight:inherit}.form-text{display:block;margin-top:5px;color:#9a9d9e}.separator{margin-bottom:10px}.col-sm-10 .ngx-select__toggle,.col-sm-12 .ngx-select__toggle{display:block;margin:0;position:relative;overflow:hidden;cursor:pointer;border:1px solid #bbb;box-shadow:0 1px #0000000d,inset 0 1px #fffc;box-sizing:border-box;border-radius:3px;font-weight:inherit}.color-box{display:inline-block;height:14px;width:14px;margin-right:4px}\n"] }]
    }], null, { monAllowClear: [{
            type: Input
        }], monPlaceholder: [{
            type: Input
        }], monOptions: [{
            type: Input
        }], monLabel: [{
            type: Input
        }], monHelpText: [{
            type: Input
        }], monSrOnlyLabel: [{
            type: Input
        }], monDefaultOptions: [{
            type: Input
        }], monReturnValue: [{
            type: Input
        }], monMultiple: [{
            type: Input
        }], monGroup: [{
            type: Input
        }], monNameAttr: [{
            type: Input
        }], monViewTemplate: [{
            type: Input
        }], monDropdownTemplate: [{
            type: Input
        }], monGroupTemplate: [{
            type: Input
        }], monRemoveButton: [{
            type: Input
        }], monDisableSearch: [{
            type: Input
        }], monHelpTxt: [{
            type: Input
        }], monNoAutoComplete: [{
            type: Input
        }], monSize: [{
            type: Input
        }], monShowColors: [{
            type: Input
        }], monAutoClearSearch: [{
            type: Input
        }], ngxSelect: [{
            type: ViewChild,
            args: ['ngxSelect', { static: false }]
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(SelectAcComponent, { className: "SelectAcComponent" }); })();

class TimezonesAcComponent extends AbstractControlValueAccessor {
    constructor() {
        super(...arguments);
        this.monReturnValue = 'value';
        this.monRemoveButton = false;
        this.timeZones = [];
    }
    ngOnInit() {
        this.setupZones();
    }
    setupZones() {
        Object.values(TIMEZONES).forEach(value => {
            this.timeZones.push(value);
        });
        this.timeZones = this.timeZones.sort((a, b) => {
            return (a.long > b.long) ? 1 : -1;
        });
    }
    static { this.ɵfac = /*@__PURE__*/ (() => { let ɵTimezonesAcComponent_BaseFactory; return function TimezonesAcComponent_Factory(__ngFactoryType__) { return (ɵTimezonesAcComponent_BaseFactory || (ɵTimezonesAcComponent_BaseFactory = i0.ɵɵgetInheritedFactory(TimezonesAcComponent)))(__ngFactoryType__ || TimezonesAcComponent); }; })(); }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TimezonesAcComponent, selectors: [["mon-form-field-select-timezones-ac"]], inputs: { monLabel: "monLabel", monHelpTxt: "monHelpTxt", monDefaultOption: "monDefaultOption", monReturnValue: "monReturnValue", monMultiple: "monMultiple", monViewTemplate: "monViewTemplate", monDropdownTemplate: "monDropdownTemplate", monRemoveButton: "monRemoveButton" }, features: [i0.ɵɵProvidersFeature([
                {
                    provide: NG_VALUE_ACCESSOR,
                    useExisting: TimezonesAcComponent,
                    multi: true,
                },
            ], [{ provide: ControlContainer, useExisting: NgForm }]), i0.ɵɵInheritDefinitionFeature], decls: 2, vars: 12, consts: [[3, "ngModelChange", "ngModel", "name", "monReturnValue", "monOptions", "monPlaceholder", "monLabel", "monHelpText", "monRemoveButton", "disabled", "required"]], template: function TimezonesAcComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "mon-form-field-select-ac", 0);
            i0.ɵɵpipe(1, "translate");
            i0.ɵɵtwoWayListener("ngModelChange", function TimezonesAcComponent_Template_mon_form_field_select_ac_ngModelChange_0_listener($event) { i0.ɵɵtwoWayBindingSet(ctx.value, $event) || (ctx.value = $event); return $event; });
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵpropertyInterpolate("monPlaceholder", i0.ɵɵpipeBind1(1, 10, "Select timezone"));
            i0.ɵɵtwoWayProperty("ngModel", ctx.value);
            i0.ɵɵproperty("name", ctx.name)("monReturnValue", ctx.monReturnValue)("monOptions", ctx.timeZones)("monLabel", ctx.monLabel)("monHelpText", ctx.monHelpTxt)("monRemoveButton", ctx.monRemoveButton)("disabled", ctx.disabled)("required", ctx.required);
        } }, dependencies: [i1$5.NgControlStatus, i1$5.RequiredValidator, i1$5.NgModel, SelectAcComponent, TranslatePipe], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TimezonesAcComponent, [{
        type: Component,
        args: [{ selector: 'mon-form-field-select-timezones-ac', viewProviders: [{ provide: ControlContainer, useExisting: NgForm }], providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: TimezonesAcComponent,
                        multi: true,
                    },
                ], template: "<mon-form-field-select-ac\n    [(ngModel)]=\"value\"\n    [name]=\"name\"\n    [monReturnValue]=\"monReturnValue\"\n    [monOptions]=\"timeZones\"\n    monPlaceholder=\"{{ 'Select timezone' | translate }}\"\n    [monLabel]=\"monLabel\"\n    [monHelpText]=\"monHelpTxt\"\n    [monRemoveButton]=\"monRemoveButton\"\n    [disabled]=\"disabled\"\n    [required]=\"required\">\n</mon-form-field-select-ac>\n" }]
    }], null, { monLabel: [{
            type: Input
        }], monHelpTxt: [{
            type: Input
        }], monDefaultOption: [{
            type: Input
        }], monReturnValue: [{
            type: Input
        }], monMultiple: [{
            type: Input
        }], monViewTemplate: [{
            type: Input
        }], monDropdownTemplate: [{
            type: Input
        }], monRemoveButton: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(TimezonesAcComponent, { className: "TimezonesAcComponent" }); })();

class FormBuilderSelectAcModule {
    static { this.ɵfac = function FormBuilderSelectAcModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FormBuilderSelectAcModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: FormBuilderSelectAcModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [NgForm], imports: [NgxSelectModule, FormsModule, CommonModule, TranslateModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormBuilderSelectAcModule, [{
        type: NgModule,
        args: [{
                imports: [NgxSelectModule, FormsModule, CommonModule, TranslateModule],
                exports: [SelectAcComponent, TimezonesAcComponent],
                declarations: [SelectAcComponent, TimezonesAcComponent],
                providers: [NgForm],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(FormBuilderSelectAcModule, { declarations: [SelectAcComponent, TimezonesAcComponent], imports: [NgxSelectModule, FormsModule, CommonModule, TranslateModule], exports: [SelectAcComponent, TimezonesAcComponent] }); })();

const _c0$f = (a0, a1) => ({ "col-sm-40": a0, "col-sm-48": a1 });
function TextareaAcComponent_label_1_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function TextareaAcComponent_label_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 7);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, TextareaAcComponent_label_1_span_2_Template, 2, 0, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("for", ctx_r1.labelAsId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.required);
} }
function TextareaAcComponent_mon_form_field_errors_ac_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mon-form-field-errors-ac", 9);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const inputElement_r3 = i0.ɵɵreference(4);
    i0.ɵɵproperty("offset", ctx_r1.errorMsgOffset)("formElementControl", inputElement_r3.control)("patternMsg", ctx_r1.patternMsg);
} }
function TextareaAcComponent_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.helpTxt);
} }
class TextareaAcComponent extends AbstractControlValueAccessor {
    constructor() {
        super(...arguments);
        this.errorMsgOffset = 8;
        this.useCustomError = true;
    }
    get label() {
        return this.labelValue;
    }
    set label(label) {
        this.labelAsId = label.replace(/[\s]/g, '');
        this.labelValue = label;
    }
    static { this.ɵfac = /*@__PURE__*/ (() => { let ɵTextareaAcComponent_BaseFactory; return function TextareaAcComponent_Factory(__ngFactoryType__) { return (ɵTextareaAcComponent_BaseFactory || (ɵTextareaAcComponent_BaseFactory = i0.ɵɵgetInheritedFactory(TextareaAcComponent)))(__ngFactoryType__ || TextareaAcComponent); }; })(); }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TextareaAcComponent, selectors: [["mon-form-field-textarea-ac"]], inputs: { helpTxt: "helpTxt", name: "name", placeholder: "placeholder", rows: "rows", minlength: "minlength", maxlength: "maxlength", patternMsg: "patternMsg", errorMsgOffset: "errorMsgOffset", useCustomError: "useCustomError", label: "label" }, features: [i0.ɵɵProvidersFeature([{
                    provide: NG_VALUE_ACCESSOR,
                    useExisting: TextareaAcComponent,
                    multi: true,
                }]), i0.ɵɵInheritDefinitionFeature], decls: 8, vars: 16, consts: [["inputElement", "ngModel"], [1, "form-group", "row"], ["class", "col-sm-8 col-form-label text-bold text-right capitalize-first-letter", 4, "ngIf"], [3, "ngClass"], [1, "form-control", 3, "ngModelChange", "ngModel", "name", "id", "rows", "minlength", "maxlength", "placeholder", "required", "disabled"], [3, "offset", "formElementControl", "patternMsg", 4, "ngIf"], ["class", "form-text text-muted", 4, "ngIf"], [1, "col-sm-8", "col-form-label", "text-bold", "text-right", "capitalize-first-letter"], [4, "ngIf"], [3, "offset", "formElementControl", "patternMsg"], [1, "form-text", "text-muted"]], template: function TextareaAcComponent_Template(rf, ctx) { if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵtemplate(1, TextareaAcComponent_label_1_Template, 3, 3, "label", 2);
            i0.ɵɵelementStart(2, "div", 3)(3, "textarea", 4, 0);
            i0.ɵɵtwoWayListener("ngModelChange", function TextareaAcComponent_Template_textarea_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r1); i0.ɵɵtwoWayBindingSet(ctx.value, $event) || (ctx.value = $event); return i0.ɵɵresetView($event); });
            i0.ɵɵtext(5, "        ");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, TextareaAcComponent_mon_form_field_errors_ac_6_Template, 1, 3, "mon-form-field-errors-ac", 5)(7, TextareaAcComponent_span_7_Template, 2, 1, "span", 6);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.label);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(13, _c0$f, ctx.label, !ctx.label));
            i0.ɵɵadvance();
            i0.ɵɵtwoWayProperty("ngModel", ctx.value);
            i0.ɵɵproperty("name", ctx.name)("id", ctx.labelAsId)("rows", ctx.rows)("minlength", ctx.minlength)("maxlength", ctx.maxlength)("placeholder", ctx.placeholder)("required", ctx.ngRequired)("disabled", ctx.disabled);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", !ctx.useCustomError);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.helpTxt);
        } }, dependencies: [i1$5.DefaultValueAccessor, i1$5.NgControlStatus, i1$5.RequiredValidator, i1$5.MinLengthValidator, i1$5.MaxLengthValidator, i1$5.NgModel, i1$2.NgClass, i1$2.NgIf, ErrorMessagesAcComponent], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TextareaAcComponent, [{
        type: Component,
        args: [{ selector: 'mon-form-field-textarea-ac', providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: TextareaAcComponent,
                        multi: true,
                    }], template: "<div class=\"form-group row\">\n    <label *ngIf=\"label\" [attr.for]=\"labelAsId\" class=\"col-sm-8 col-form-label text-bold text-right capitalize-first-letter\">\n        {{ label }}\n        <span *ngIf=\"required\">*</span>\n    </label>\n    <div [ngClass]=\"{'col-sm-40' : label, 'col-sm-48': !label }\">\n        <textarea [(ngModel)]=\"value\"\n                  [name]=\"name\"\n                  class=\"form-control\"\n                  #inputElement=\"ngModel\"\n                  [id]=\"labelAsId\"\n                  [rows]=\"rows\"\n                  [minlength]=\"minlength\"\n                  [maxlength]=\"maxlength\"\n                  [placeholder]=\"placeholder\"\n                  [required]=\"ngRequired\"\n                  [disabled]=\"disabled\">\n        </textarea>\n        <mon-form-field-errors-ac *ngIf=\"!useCustomError\"\n                               [offset]=\"errorMsgOffset\"\n                               [formElementControl]=\"inputElement.control\"\n                               [patternMsg]=\"patternMsg\">\n        </mon-form-field-errors-ac>\n        <span *ngIf=\"helpTxt\" class=\"form-text text-muted\">{{ helpTxt }}</span>\n    </div>\n</div>\n" }]
    }], null, { helpTxt: [{
            type: Input
        }], name: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], rows: [{
            type: Input
        }], minlength: [{
            type: Input
        }], maxlength: [{
            type: Input
        }], patternMsg: [{
            type: Input
        }], errorMsgOffset: [{
            type: Input
        }], useCustomError: [{
            type: Input
        }], label: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(TextareaAcComponent, { className: "TextareaAcComponent" }); })();

class TextareaAcModule {
    static { this.ɵfac = function TextareaAcModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TextareaAcModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: TextareaAcModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [FormsModule, CommonModule, FormBuilderValidationModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TextareaAcModule, [{
        type: NgModule,
        args: [{
                imports: [FormsModule, CommonModule, FormBuilderValidationModule],
                exports: [TextareaAcComponent],
                declarations: [TextareaAcComponent],
                providers: [],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(TextareaAcModule, { declarations: [TextareaAcComponent], imports: [FormsModule, CommonModule, FormBuilderValidationModule], exports: [TextareaAcComponent] }); })();

const _c0$e = ["selectButton"];
const _c1$6 = ["optionsList"];
const _c2$4 = a0 => ({ closed: a0 });
const _c3$2 = a0 => ({ hovered: a0 });
function SelectNextComponent_label_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r1.size);
    i0.ɵɵclassProp("hiddenLabel", ctx_r1.hideLabel);
    i0.ɵɵattribute("id", ctx_r1.labelId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2("", ctx_r1.label, "", ctx_r1.required ? " *" : "", "");
} }
function SelectNextComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("disabled", ctx_r1.disabled);
    i0.ɵɵattribute("aria-placeholder", ctx_r1.placeholder);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.placeholder, " ");
} }
function SelectNextComponent_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    let tmp_3_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("disabled", ctx_r1.disabled);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", (tmp_3_0 = ctx_r1.getSingleValue()) == null ? null : tmp_3_0.name, " ");
} }
function SelectNextComponent_div_6_mon_icon_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mon-icon", 13);
} }
function SelectNextComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵtemplate(1, SelectNextComponent_div_6_mon_icon_1_Template, 1, 0, "mon-icon", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("disabled", ctx_r1.disabled)("opened", ctx_r1.opened.value);
    i0.ɵɵattribute("aria-hidden", true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.opened.value);
} }
function SelectNextComponent_button_7_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 14);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("focus", function SelectNextComponent_button_7_Template_button_focus_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.onFocus()); })("blur", function SelectNextComponent_button_7_Template_button_blur_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.onBlur()); })("click", function SelectNextComponent_button_7_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.clear()); })("keydown", function SelectNextComponent_button_7_Template_button_keydown_0_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.clear($event)); });
    i0.ɵɵelementStart(2, "span", 15);
    i0.ɵɵelement(3, "mon-icon", 16);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("opened", ctx_r1.opened.value)("disabled", ctx_r1.disabled);
    i0.ɵɵproperty("disabled", ctx_r1.disabled);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 6, "Clear the field"));
} }
function SelectNextComponent_div_8_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 19, 1);
    i0.ɵɵlistener("click", function SelectNextComponent_div_8_div_1_Template_div_click_0_listener() { const i_r5 = i0.ɵɵrestoreView(_r4).index; const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.selectOption(i_r5)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r6 = ctx.$implicit;
    const i_r5 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(i0.ɵɵpureFunction1(5, _c3$2, i_r5 === ctx_r1.visualFocusIndex));
    i0.ɵɵattribute("aria-selected", ctx_r1.currentIndex === i_r5)("id", option_r6.id);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", option_r6.name, " ");
} }
function SelectNextComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtemplate(1, SelectNextComponent_div_8_div_1_Template, 3, 7, "div", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("id", ctx_r1.listboxId)("aria-describedby", ctx_r1.describedBy)("aria-labelledby", ctx_r1.labelId);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.options);
} }
const PAGE_SIZE$2 = 10;
class SelectNextComponent extends AbstractControlValueAccessor {
    get value() {
        return this._value;
    }
    set value(val) {
        const isFirstChangeForSingleOption = !this._value && val && !this.changed;
        const optionsExist = this.options.length;
        if (isFirstChangeForSingleOption && optionsExist) {
            this.changed = true;
            this.setDefaultForSingleValue(val);
        }
        if (!val) {
            this.currentIndex = null;
        }
        this._value = val;
        this.onChange(val);
    }
    constructor() {
        super();
        this.options = [];
        this.hideLabel = false;
        this.size = 'small';
        this.allowClear = false;
        this.opened = new BehaviorSubject(false);
        this.visualFocusIndex = null;
        this.labelId = '';
        this.currentInput = '';
        this.timerId = null;
        this.focused = false;
        this.changed = false;
        this.listboxId = `listbox-${UidService.generateUid()}`;
    }
    ngOnChanges(changes) {
        const haveNotIds = changes.options?.currentValue.some((option) => !option.id);
        if (haveNotIds) {
            this.options = changes.options.currentValue.map((option, i) => ({
                ...option,
                id: `${option.name.replace(/\s/, '')}-${UidService.generateUid()}`,
                index: i,
            }));
            if (this.value) {
                this.setDefaultForSingleValue(this.value);
                return;
            }
        }
    }
    ngAfterContentInit() {
        this.labelId = this.getLabelForId(this.label);
    }
    ngOnDestroy() {
        if (this.timerId) {
            clearTimeout(this.timerId);
        }
        this.opened.unsubscribe();
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    writeValue(value) {
        if (value !== null && value !== undefined) {
            this.value = value;
            this.onChange(value);
        }
    }
    clear(event) {
        if (event && (event.code === 'Enter' || event.code === 'Space')) {
            event.preventDefault();
            this.clearValues();
        }
        if (!event) {
            this.clearValues();
        }
    }
    getSingleValue() {
        return this.value;
    }
    handleKeyboard(event) {
        if (this.disabled) {
            return;
        }
        if (this.opened.value) {
            this.handleKeyForOpenedDropdown(event);
        }
        else {
            this.handleKeyForClosedDropdown(event);
        }
    }
    clickOutsideHandler(event) {
        if (!this.options.find(option => option.id === event.target?.id)) {
            this.opened.next(false);
            this.visualFocusIndex = null;
        }
    }
    open() {
        if (this.disabled) {
            return;
        }
        this.opened.next(!this.opened.value);
    }
    selectOption(index) {
        this.selectSingleOption(index);
    }
    onFocus() {
        if (!this.disabled) {
            this.focused = true;
        }
    }
    onBlur() {
        if (!this.disabled) {
            this.focused = false;
            this.onTouch();
        }
    }
    setDefaultForSingleValue(value) {
        this.currentIndex = this.options.findIndex(option => {
            if ('value' in value) {
                return option.value === value.value;
            }
        });
    }
    clearValues() {
        this.currentIndex = undefined;
        this.opened.next(false);
        this.changeVisualFocus(null);
        this.value = undefined;
        this.onChange(this.value);
        this.selectButtonElement?.nativeElement.focus();
    }
    changeVisualFocus(index) {
        this.visualFocusIndex = index;
        if (!this.selectButtonElement) {
            return;
        }
        if (index !== null && index > -1) {
            this.selectButtonElement?.nativeElement.setAttribute('aria-activedescendant', this.options[index]?.id);
            this.scrollToOption();
        }
        else {
            this.selectButtonElement?.nativeElement.removeAttribute('aria-activedescendant');
        }
    }
    scrollToOption() {
        const currentOption = this.nativeOptionsList.get(this.visualFocusIndex)?.nativeElement;
        if (!currentOption) {
            return;
        }
        const { offsetHeight, offsetTop, offsetParent } = currentOption;
        if (!offsetParent) {
            return;
        }
        const { offsetHeight: parentOffsetHeight, scrollTop } = offsetParent;
        const isAbove = offsetTop < scrollTop;
        const isBelow = offsetTop + offsetHeight > scrollTop + parentOffsetHeight;
        if (isAbove) {
            offsetParent.scrollTo(0, offsetTop);
        }
        else if (isBelow) {
            offsetParent.scrollTo(0, offsetTop - parentOffsetHeight + offsetHeight);
        }
    }
    handleKeysEvents(event) {
        if (!(event.key && /^\w$/i.test(event.key))) {
            return;
        }
        if (!this.opened.value) {
            this.opened.next(true);
        }
        this.filterByKey(event);
    }
    filterByKey(event) {
        this.currentInput += event.key.toLowerCase();
        if (this.timerId) {
            clearTimeout(this.timerId);
        }
        this.timerId = setTimeout(() => {
            this.timerId = null;
            const index = this.options.findIndex(option => option.name.toLowerCase().startsWith(this.currentInput));
            if (index > -1) {
                this.changeVisualFocus(index);
                this.currentInput = '';
            }
        }, 300);
    }
    selectSingleOption(index) {
        if (this.disabled) {
            return;
        }
        const initialOptionsIndex = this.options.findIndex(option => option.id === this.options[index].id);
        this.currentIndex = initialOptionsIndex;
        this.opened.next(false);
        this.changeVisualFocus(null);
        this.value = this.options[initialOptionsIndex];
        this.onChange(this.value);
        this.selectButtonElement.nativeElement.focus();
    }
    chooseOptionByKeyboard(event) {
        if (this.visualFocusIndex !== null) {
            event.preventDefault();
            this.selectOption(this.visualFocusIndex);
        }
        this.opened.next(false);
    }
    moveVisualFocusUp(event) {
        event.preventDefault();
        if (this.visualFocusIndex === null) {
            this.changeVisualFocus(0);
        }
        else if (this.visualFocusIndex < this.options.length - 1) {
            this.changeVisualFocus(this.visualFocusIndex + 1);
        }
    }
    moveVisualFocusDown(event) {
        event.preventDefault();
        if (event.altKey) {
            this.selectOption(this.visualFocusIndex);
            return;
        }
        if (this.visualFocusIndex === null) {
            this.changeVisualFocus(0);
        }
        else if (this.visualFocusIndex > 0) {
            this.changeVisualFocus(this.visualFocusIndex - 1);
        }
    }
    moveOnPageUp(event) {
        event.preventDefault();
        const pageUpTarget = this.visualFocusIndex - PAGE_SIZE$2;
        if (pageUpTarget >= 0) {
            this.changeVisualFocus(pageUpTarget);
        }
        else {
            this.changeVisualFocus(0);
        }
    }
    moveOnPageDown(event) {
        event.preventDefault();
        const pageDownTarget = this.visualFocusIndex + PAGE_SIZE$2;
        if (pageDownTarget <= this.options.length - 1) {
            this.changeVisualFocus(pageDownTarget);
        }
        else {
            this.changeVisualFocus(this.options.length - 1);
        }
    }
    handleKeyForOpenedDropdown(event) {
        switch (event.code) {
            case 'ArrowDown':
                this.moveVisualFocusUp(event);
                break;
            case 'ArrowUp':
                this.moveVisualFocusDown(event);
                break;
            case 'Space':
                this.chooseOptionByKeyboard(event);
                break;
            case 'Enter':
                this.chooseOptionByKeyboard(event);
                break;
            case 'Escape':
                event.stopPropagation();
                event.preventDefault();
                this.selectButtonElement?.nativeElement.focus();
                this.opened.next(false);
                this.changeVisualFocus(null);
                break;
            case 'Home':
                event.preventDefault();
                this.changeVisualFocus(0);
                break;
            case 'End':
                event.preventDefault();
                this.changeVisualFocus(this.options.length - 1);
                break;
            case 'PageUp':
                this.moveOnPageUp(event);
                break;
            case 'PageDown':
                this.moveOnPageDown(event);
                break;
            default:
                this.handleKeysEvents(event);
                break;
        }
    }
    handleKeyForClosedDropdown(event) {
        switch (event.code) {
            case 'ArrowDown':
            case 'ArrowUp':
                this.opened.next(true);
                this.changeVisualFocus(0);
                break;
            case 'Enter':
                if (event.target === this.selectButtonElement?.nativeElement) {
                    event.preventDefault();
                    this.opened.next(true);
                    this.changeVisualFocus(0);
                }
                break;
            case 'Space':
                if (event.target === this.selectButtonElement?.nativeElement) {
                    event.preventDefault();
                    this.opened.next(true);
                    this.changeVisualFocus(0);
                }
                break;
            case 'Home':
                this.opened.next(true);
                this.changeVisualFocus(0);
                break;
            case 'End':
                this.opened.next(true);
                this.changeVisualFocus(this.options.length - 1);
                break;
            default:
                this.handleKeysEvents(event);
                break;
        }
    }
    static { this.ɵfac = function SelectNextComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SelectNextComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SelectNextComponent, selectors: [["mon-select-next"]], viewQuery: function SelectNextComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$e, 5);
            i0.ɵɵviewQuery(_c1$6, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.selectButtonElement = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.nativeOptionsList = _t);
        } }, inputs: { options: "options", placeholder: "placeholder", label: "label", hideLabel: "hideLabel", size: "size", allowClear: "allowClear", describedBy: "describedBy", monId: "monId", _value: "_value" }, standalone: true, features: [i0.ɵɵProvidersFeature([{
                    provide: NG_VALUE_ACCESSOR,
                    useExisting: forwardRef(() => SelectNextComponent),
                    multi: true,
                }]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature], decls: 9, vars: 26, consts: [["selectButton", ""], ["optionsList", ""], [3, "class", "hiddenLabel", 4, "ngIf"], [1, "select-container", 3, "clickOutside", "delayClickOutsideInit"], ["role", "combobox", 1, "current-value-box", 3, "focus", "click", "blur", "keydown", "disabled"], ["class", "placeholder-text", 3, "disabled", 4, "ngIf"], [3, "disabled", 4, "ngIf"], ["class", "current-value-box-icon", 3, "disabled", "opened", 4, "ngIf"], ["class", "clear-button", 3, "disabled", "opened", "focus", "blur", "click", "keydown", 4, "ngIf"], ["class", "listbox", "role", "listbox", 4, "ngIf"], [1, "placeholder-text"], [1, "current-value-box-icon"], ["monIconDirect", "faCaretDown", 4, "ngIf"], ["monIconDirect", "faCaretDown"], [1, "clear-button", 3, "focus", "blur", "click", "keydown", "disabled"], [1, "clear-icon"], ["monIconDirect", "faTimes"], ["role", "listbox", 1, "listbox"], ["role", "option", "class", "option", 3, "class", "click", 4, "ngFor", "ngForOf"], ["role", "option", 1, "option", 3, "click"]], template: function SelectNextComponent_Template(rf, ctx) { if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵtemplate(0, SelectNextComponent_label_0_Template, 2, 7, "label", 2);
            i0.ɵɵelementStart(1, "div", 3);
            i0.ɵɵlistener("clickOutside", function SelectNextComponent_Template_div_clickOutside_1_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.clickOutsideHandler($event)); });
            i0.ɵɵelementStart(2, "button", 4, 0);
            i0.ɵɵlistener("focus", function SelectNextComponent_Template_button_focus_2_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.onFocus()); })("click", function SelectNextComponent_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.open()); })("blur", function SelectNextComponent_Template_button_blur_2_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.onBlur()); })("keydown", function SelectNextComponent_Template_button_keydown_2_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.handleKeyboard($event)); });
            i0.ɵɵtemplate(4, SelectNextComponent_span_4_Template, 2, 4, "span", 5)(5, SelectNextComponent_span_5_Template, 2, 3, "span", 6);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, SelectNextComponent_div_6_Template, 2, 6, "div", 7)(7, SelectNextComponent_button_7_Template, 4, 8, "button", 8)(8, SelectNextComponent_div_8_Template, 2, 4, "div", 9);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", !ctx.monId);
            i0.ɵɵadvance();
            i0.ɵɵclassMap(ctx.size);
            i0.ɵɵclassProp("disabled", ctx.disabled)("focused", ctx.focused);
            i0.ɵɵproperty("delayClickOutsideInit", true);
            i0.ɵɵadvance();
            i0.ɵɵclassMap(i0.ɵɵpureFunction1(24, _c2$4, !ctx.opened.value));
            i0.ɵɵclassProp("opened", ctx.opened.value);
            i0.ɵɵproperty("disabled", ctx.disabled);
            i0.ɵɵattribute("aria-controls", ctx.listboxId)("aria-required", ctx.required)("aria-describedby", ctx.describedBy)("aria-labelledby", ctx.labelId)("aria-haspopup", ctx.listboxId)("aria-expanded", ctx.opened.value ? "true" : "false");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.getSingleValue() && ctx.placeholder);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.getSingleValue() || !ctx.placeholder);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.allowClear && !ctx.getSingleValue() || !ctx.allowClear);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.getSingleValue() && ctx.allowClear);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.opened.value);
        } }, dependencies: [CommonModule, i1$2.NgForOf, i1$2.NgIf, IconsModule, IconComponent, NgClickOutsideDirective,
            TranslateModule, TranslatePipe], styles: [".ng-invalid.ng-dirty[_nghost-%COMP%]   .select-container[_ngcontent-%COMP%]{border:1px solid #BA322D;box-shadow:none}[_nghost-%COMP%]{--mon-select-small-size: 12px;--mon-select-medium-size: 14px;--mon-select-large-size: 16px;--mon-select-option-color: #255783;--mon-select-placeholder-text-color: #6c757d;--mon-select-value-box-basic-border-color: #adadad;--mon-select-value-box-focus-border-color: #86b7fe;--mon-select-value-box-focus-border-box-shadow: 0 0 0 .25rem rgba(13, 110, 253, .25);--mon-select-button-background: linear-gradient(#fafafa, #eee);--mon-select-focus-visible: 0 0 0 2px #4976B9;--mon-select-listbox-border: 1px solid #cccccc;--mon-select-current-value-box-border: 1px solid #cccccc;--mon-select-clear-button-color: #595959;--mon-select-disabled-bg-color: #eceeef;--mon-select-disabled-text: rgb(0, 0, 0, .4)}[_nghost-%COMP%]   .select-container[_ngcontent-%COMP%]{position:relative;display:flex;border:var(--mon-select-current-value-box-border);border-radius:4px}[_nghost-%COMP%]   .select-container[_ngcontent-%COMP%]:hover{border:1px solid var(--mon-select-value-box-basic-border-color)}[_nghost-%COMP%]   .select-container.focused[_ngcontent-%COMP%]{border:1px solid var(--mon-select-value-box-focus-border-color);box-shadow:var(--mon-select-value-box-focus-border-box-shadow)}[_nghost-%COMP%]   .select-container.disabled[_ngcontent-%COMP%]{box-shadow:none;border:var(--mon-select-current-value-box-border);cursor:not-allowed}[_nghost-%COMP%]   .clear-button[_ngcontent-%COMP%]{width:28px;border-radius:0 4px 4px 0;background-image:var(--mon-select-button-background);border:none;outline:none}[_nghost-%COMP%]   .clear-button[_ngcontent-%COMP%]:focus-visible{box-shadow:var(--mon-select-focus-visible)}[_nghost-%COMP%]   .clear-button.opened[_ngcontent-%COMP%]{background:#fff none}[_nghost-%COMP%]   .clear-icon[_ngcontent-%COMP%]{position:relative;top:1px}[_nghost-%COMP%]   .hiddenLabel[_ngcontent-%COMP%]{width:0;height:0;position:absolute;overflow:hidden;opacity:0}[_nghost-%COMP%]   .option[_ngcontent-%COMP%]{color:var(--mon-select-option-color);cursor:pointer;padding:5px 20px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}[_nghost-%COMP%]   .option[_ngcontent-%COMP%]:hover, [_nghost-%COMP%]   .hovered[_ngcontent-%COMP%]{color:#fff;background:var(--mon-select-option-color)}[_nghost-%COMP%]   .current-value-box[_ngcontent-%COMP%]{border-radius:4px 0 0 4px;border:none;padding:5px 10px;cursor:pointer;display:flex;justify-content:space-between;align-items:center;width:calc(100% - 28px)}[_nghost-%COMP%]   .current-value-box.opened[_ngcontent-%COMP%]{background:#fff none}[_nghost-%COMP%]   .current-value-box[disabled][_ngcontent-%COMP%]{cursor:not-allowed}[_nghost-%COMP%]   .current-value-box-icon[_ngcontent-%COMP%]{width:28px;border-radius:0 4px 4px 0;background-image:var(--mon-select-button-background);border:none;display:flex;justify-content:center;align-items:center}[_nghost-%COMP%]   .current-value-box-icon.opened[_ngcontent-%COMP%]{background:#fff none}[_nghost-%COMP%]   .placeholder-text[_ngcontent-%COMP%]{color:var(--mon-select-placeholder-text-color)}[_nghost-%COMP%]   .small[_ngcontent-%COMP%]{font-size:var(--mon-select-small-size);min-height:32px}[_nghost-%COMP%]   .medium[_ngcontent-%COMP%]{font-size:var(--mon-select-medium-size);min-height:34px}[_nghost-%COMP%]   .large[_ngcontent-%COMP%]{font-size:var(--mon-select-large-size);min-height:36px}[_nghost-%COMP%]   .closed[_ngcontent-%COMP%]{background-image:var(--mon-select-button-background)}[_nghost-%COMP%]   .current-value-box[_ngcontent-%COMP%]{outline:none}[_nghost-%COMP%]   .listbox[_ngcontent-%COMP%]{background:#fff;position:absolute;width:100%;border-radius:4px;border:var(--mon-select-listbox-border);padding:5px 0;max-height:200px;z-index:3;overflow:auto;top:100%}[_nghost-%COMP%]   .disabled[_ngcontent-%COMP%]{cursor:not-allowed;color:var(--mon-select-disabled-text)}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SelectNextComponent, [{
        type: Component,
        args: [{ selector: 'mon-select-next', providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => SelectNextComponent),
                        multi: true,
                    }], standalone: true, imports: [
                    CommonModule,
                    IconsModule,
                    NgClickOutsideDirective,
                    TranslateModule,
                ], template: "<label *ngIf=\"!monId\" [class]=\"size\" [class.hiddenLabel]=\"hideLabel\" [attr.id]=\"labelId\">{{label}}{{required ? ' *' : ''}}</label>\n<div [delayClickOutsideInit]=\"true\" [class.disabled]=\"disabled\" (clickOutside)=\"clickOutsideHandler($event)\" [class.focused]=\"focused\" class=\"select-container\" [class]=\"size\">\n    <button #selectButton\n         (focus)=\"onFocus()\"\n         [attr.aria-controls]=\"listboxId\"\n         [attr.aria-required]=\"required\"\n         [attr.aria-describedby]=\"describedBy\"\n         [disabled]=\"disabled\"\n         (click)=\"open()\"\n         [class]=\"{closed: !opened.value}\"\n         [attr.aria-labelledby]=\"labelId\"\n         (blur)=\"onBlur()\"\n         [attr.aria-haspopup]=\"listboxId\"\n         [attr.aria-expanded]=\"opened.value ? 'true' : 'false'\"\n         role=\"combobox\"\n         class=\"current-value-box\"\n         [class.opened]=\"opened.value\"\n         (keydown)=\"handleKeyboard($event)\"\n    >\n        <span\n            class=\"placeholder-text\"\n            [attr.aria-placeholder]=\"placeholder\"\n            *ngIf=\"!getSingleValue() && placeholder\"\n            [class.disabled]=\"disabled\"\n        >\n            {{placeholder}}\n        </span>\n        <span [class.disabled]=\"disabled\" *ngIf=\"getSingleValue() || !placeholder\">\n            {{getSingleValue()?.name}}\n        </span>\n    </button>\n    <div *ngIf=\"((allowClear && !getSingleValue()) || !allowClear)\" class=\"current-value-box-icon\" [class.disabled]=\"disabled\" [class.opened]=\"opened.value\" [attr.aria-hidden]=\"true\">\n        <mon-icon monIconDirect=\"faCaretDown\" *ngIf=\"!opened.value\"></mon-icon>\n    </div>\n    <button\n        (focus)=\"onFocus()\"\n        (blur)=\"onBlur()\"\n        (click)=\"clear()\"\n        (keydown)=\"clear($event)\"\n        *ngIf=\"getSingleValue() && allowClear\"\n        [disabled]=\"disabled\"\n        [class.opened]=\"opened.value\"\n        class=\"clear-button\"\n        [attr.aria-label]=\"'Clear the field' | translate\"\n        [class.disabled]=\"disabled\"\n    >\n            <span class=\"clear-icon\">\n                <mon-icon\n                    monIconDirect=\"faTimes\"\n                ></mon-icon>\n            </span>\n    </button>\n    <div\n        class=\"listbox\"\n        role=\"listbox\"\n        *ngIf=\"opened.value\"\n        [attr.id]=\"listboxId\"\n        [attr.aria-describedby]=\"describedBy\"\n        [attr.aria-labelledby]=\"labelId\"\n    >\n        <div\n            role=\"option\"\n            #optionsList\n            class=\"option\"\n            [attr.aria-selected]=\"currentIndex === i\"\n            [attr.id]=\"option.id\"\n            *ngFor=\"let option of options; let i = index\"\n            [class]=\"{hovered: i === visualFocusIndex}\"\n            (click)=\"selectOption(i)\"\n        >\n            {{option.name}}\n        </div>\n    </div>\n</div>\n", styles: [":host.ng-invalid.ng-dirty .select-container{border:1px solid #BA322D;box-shadow:none}:host{--mon-select-small-size: 12px;--mon-select-medium-size: 14px;--mon-select-large-size: 16px;--mon-select-option-color: #255783;--mon-select-placeholder-text-color: #6c757d;--mon-select-value-box-basic-border-color: #adadad;--mon-select-value-box-focus-border-color: #86b7fe;--mon-select-value-box-focus-border-box-shadow: 0 0 0 .25rem rgba(13, 110, 253, .25);--mon-select-button-background: linear-gradient(#fafafa, #eee);--mon-select-focus-visible: 0 0 0 2px #4976B9;--mon-select-listbox-border: 1px solid #cccccc;--mon-select-current-value-box-border: 1px solid #cccccc;--mon-select-clear-button-color: #595959;--mon-select-disabled-bg-color: #eceeef;--mon-select-disabled-text: rgb(0, 0, 0, .4)}:host .select-container{position:relative;display:flex;border:var(--mon-select-current-value-box-border);border-radius:4px}:host .select-container:hover{border:1px solid var(--mon-select-value-box-basic-border-color)}:host .select-container.focused{border:1px solid var(--mon-select-value-box-focus-border-color);box-shadow:var(--mon-select-value-box-focus-border-box-shadow)}:host .select-container.disabled{box-shadow:none;border:var(--mon-select-current-value-box-border);cursor:not-allowed}:host .clear-button{width:28px;border-radius:0 4px 4px 0;background-image:var(--mon-select-button-background);border:none;outline:none}:host .clear-button:focus-visible{box-shadow:var(--mon-select-focus-visible)}:host .clear-button.opened{background:#fff none}:host .clear-icon{position:relative;top:1px}:host .hiddenLabel{width:0;height:0;position:absolute;overflow:hidden;opacity:0}:host .option{color:var(--mon-select-option-color);cursor:pointer;padding:5px 20px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}:host .option:hover,:host .hovered{color:#fff;background:var(--mon-select-option-color)}:host .current-value-box{border-radius:4px 0 0 4px;border:none;padding:5px 10px;cursor:pointer;display:flex;justify-content:space-between;align-items:center;width:calc(100% - 28px)}:host .current-value-box.opened{background:#fff none}:host .current-value-box[disabled]{cursor:not-allowed}:host .current-value-box-icon{width:28px;border-radius:0 4px 4px 0;background-image:var(--mon-select-button-background);border:none;display:flex;justify-content:center;align-items:center}:host .current-value-box-icon.opened{background:#fff none}:host .placeholder-text{color:var(--mon-select-placeholder-text-color)}:host .small{font-size:var(--mon-select-small-size);min-height:32px}:host .medium{font-size:var(--mon-select-medium-size);min-height:34px}:host .large{font-size:var(--mon-select-large-size);min-height:36px}:host .closed{background-image:var(--mon-select-button-background)}:host .current-value-box{outline:none}:host .listbox{background:#fff;position:absolute;width:100%;border-radius:4px;border:var(--mon-select-listbox-border);padding:5px 0;max-height:200px;z-index:3;overflow:auto;top:100%}:host .disabled{cursor:not-allowed;color:var(--mon-select-disabled-text)}\n"] }]
    }], () => [], { selectButtonElement: [{
            type: ViewChild,
            args: ['selectButton']
        }], nativeOptionsList: [{
            type: ViewChildren,
            args: ['optionsList']
        }], options: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], label: [{
            type: Input
        }], hideLabel: [{
            type: Input
        }], size: [{
            type: Input
        }], allowClear: [{
            type: Input
        }], describedBy: [{
            type: Input
        }], monId: [{
            type: Input
        }], _value: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(SelectNextComponent, { className: "SelectNextComponent" }); })();

const _c0$d = ["optionsListBox"];
const _c1$5 = ["multipleSearchField"];
const _c2$3 = ["optionsList"];
const _c3$1 = ["removeOptionButtons"];
const _c4 = a0 => ({ option: a0 });
const _c5 = a0 => ({ name: a0 });
const _c6 = a0 => ({ value: a0 });
function MultiselectNextComponent_label_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r1.size);
    i0.ɵɵclassProp("hiddenLabel", ctx_r1.hideLabel);
    i0.ɵɵattribute("id", ctx_r1.labelId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2("", ctx_r1.label, "", ctx_r1.required ? " *" : "", "");
} }
function MultiselectNextComponent_div_7_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "No results found"));
} }
function MultiselectNextComponent_div_7_div_3_ng_template_2_Template(rf, ctx) { }
function MultiselectNextComponent_div_7_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 20, 4);
    i0.ɵɵlistener("click", function MultiselectNextComponent_div_7_div_3_Template_div_click_0_listener() { const i_r4 = i0.ɵɵrestoreView(_r3).index; const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.selectOption(i_r4)); });
    i0.ɵɵtemplate(2, MultiselectNextComponent_div_7_div_3_ng_template_2_Template, 0, 0, "ng-template", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r5 = ctx.$implicit;
    const i_r4 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(2);
    const defaultOptionTemplate_r6 = i0.ɵɵreference(12);
    i0.ɵɵclassMap(ctx_r1.size);
    i0.ɵɵclassProp("selected", option_r5.selected)("hovered", i_r4 === ctx_r1.visualFocusIndex);
    i0.ɵɵattribute("aria-selected", option_r5.selected)("id", option_r5.id);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.optionTemplate || defaultOptionTemplate_r6)("ngTemplateOutletContext", i0.ɵɵpureFunction1(10, _c4, option_r5));
} }
function MultiselectNextComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16, 3);
    i0.ɵɵtemplate(2, MultiselectNextComponent_div_7_div_2_Template, 3, 3, "div", 17)(3, MultiselectNextComponent_div_7_div_3_Template, 3, 12, "div", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("aria-multiselectable", true)("id", ctx_r1.listboxId)("aria-describedby", ctx_r1.describedBy)("aria-labelledby", ctx_r1.labelId);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.filteredOptions.length === 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.filteredOptions);
} }
function MultiselectNextComponent_button_9_ng_template_3_Template(rf, ctx) { }
function MultiselectNextComponent_button_9_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 22, 5);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("click", function MultiselectNextComponent_button_9_Template_button_click_0_listener($event) { const ctx_r7 = i0.ɵɵrestoreView(_r7); const value_r9 = ctx_r7.$implicit; const i_r10 = ctx_r7.index; const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.removeOptionFromList(value_r9, i_r10, $event)); })("blur", function MultiselectNextComponent_button_9_Template_button_blur_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.handleMultiselectInputBlur()); })("focus", function MultiselectNextComponent_button_9_Template_button_focus_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.handleMultiselectInputFocus()); });
    i0.ɵɵtemplate(3, MultiselectNextComponent_button_9_ng_template_3_Template, 0, 0, "ng-template", 21);
    i0.ɵɵelementStart(4, "span", 23);
    i0.ɵɵtext(5, "\u00D7");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const value_r9 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    const defaultSelectedValueTemplate_r11 = i0.ɵɵreference(14);
    i0.ɵɵclassMap(ctx_r1.size);
    i0.ɵɵproperty("disabled", ctx_r1.disabled);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind3(2, 7, "[[name]] Remove", "", i0.ɵɵpureFunction1(11, _c5, value_r9.name)));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.selectedValueTemplate || defaultSelectedValueTemplate_r11)("ngTemplateOutletContext", i0.ɵɵpureFunction1(13, _c6, value_r9));
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-hidden", true);
} }
function MultiselectNextComponent_button_10_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 24);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("click", function MultiselectNextComponent_button_10_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r12); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.clear()); })("keydown", function MultiselectNextComponent_button_10_Template_button_keydown_0_listener($event) { i0.ɵɵrestoreView(_r12); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.clear($event)); })("blur", function MultiselectNextComponent_button_10_Template_button_blur_0_listener() { i0.ɵɵrestoreView(_r12); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.handleMultiselectInputBlur()); })("focus", function MultiselectNextComponent_button_10_Template_button_focus_0_listener() { i0.ɵɵrestoreView(_r12); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.handleMultiselectInputFocus()); });
    i0.ɵɵelementStart(2, "span", 25);
    i0.ɵɵelement(3, "mon-icon", 26);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r1.size);
    i0.ɵɵproperty("disabled", ctx_r1.disabled);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 4, "Clear the field"));
} }
function MultiselectNextComponent_ng_template_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0);
} if (rf & 2) {
    const option_r13 = ctx.option;
    i0.ɵɵtextInterpolate1(" ", option_r13.name, "\n");
} }
function MultiselectNextComponent_ng_template_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0);
} if (rf & 2) {
    const value_r14 = ctx.value;
    i0.ɵɵtextInterpolate1(" ", value_r14.name, "\n");
} }
const PAGE_SIZE$1 = 10;
class MultiselectNextComponent extends AbstractControlValueAccessor {
    get value() {
        return this._value;
    }
    set value(val) {
        const optionsExist = this.options.length;
        const oldValueIsEmpty = !this._value || this._value.length === 0;
        const newValueNotEmpty = val?.length;
        if (oldValueIsEmpty && newValueNotEmpty && val && !this.changed && optionsExist) {
            this.changed = true;
            this.setDefaultForMultipleValue(val);
        }
        if (!val) {
            this.currentIndex = null;
        }
        else {
            this.valueTextPresentation = val.map(value => value.name).join(', ');
        }
        this._value = val;
        this.onChange(val);
    }
    constructor(searchService) {
        super();
        this.searchService = searchService;
        this.options = [];
        this.hideLabel = false;
        this.size = 'small';
        this.allowClear = false;
        this.endScrollOffset = 0;
        this.disableFuzzySearch = false;
        this.scrollToEnd = new EventEmitter();
        this.searchInput = new EventEmitter();
        this.filteredOptions = [];
        this.multipleValue = [];
        this.multiselectFocused = false;
        this.opened = new BehaviorSubject(false);
        this.visualFocusIndex = null;
        this.labelId = '';
        this.timerId = null;
        this.valueTextPresentation = '';
        this.changed = false;
        this.scrolledToEndObserver = null;
        this.scrolledToEndTargetElement = null;
        // throttle for reducing filtering operations
        this.handleInputWithSearch = throttle((event) => {
            const value = event.target?.value;
            if (!this.opened.value) {
                this.opened.next(true);
            }
            this.searchInput.emit(value);
            if (!this.disableFuzzySearch) {
                this.filteredOptions =
                    this.options.filter(option => value ? this.searchService.fuzzy(value, option.name) : true);
            }
            if (this.filteredOptions.length > 0) {
                this.changeVisualFocus(0);
            }
            else {
                this.changeVisualFocus(null);
            }
        }, 300);
        this.listboxId = `listbox-${UidService.generateUid()}`;
    }
    ngOnChanges(changes) {
        const haveNotIds = changes.options?.currentValue.some((option) => !option.id);
        if (haveNotIds) {
            this.options = changes.options.currentValue.map((option, i) => ({
                ...option,
                id: `${option.name.replace(/\s/, '')}-${UidService.generateUid()}`,
                index: i,
                selected: false,
            }));
            if (this.value?.length) {
                this.setDefaultForMultipleValue(this.value);
            }
            this.filteredOptions = cloneDeep(this.options);
        }
        if (this.opened.value && changes.options) {
            setTimeout(() => {
                this.clearObserveScrolledToEnd();
                this.observeScrolledToEnd();
            });
        }
    }
    ngAfterContentInit() {
        this.labelId = this.getLabelForId(this.label);
        this.opened.subscribe((opened) => {
            this.clearObserveScrolledToEnd();
            if (opened) {
                setTimeout(() => {
                    this.multipleSearchFieldElement?.nativeElement.focus();
                    this.observeScrolledToEnd();
                });
            }
        });
    }
    ngOnDestroy() {
        if (this.timerId) {
            clearTimeout(this.timerId);
        }
        this.opened.unsubscribe();
        this.clearObserveScrolledToEnd();
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    writeValue(value) {
        if (value !== null && value !== undefined) {
            this.value = value;
            this.onChange(value);
        }
    }
    clear(event) {
        if (event && (event.code === 'Enter' || event.code === 'Space')) {
            event.preventDefault();
            this.clearValues();
        }
        if (!event) {
            this.clearValues();
        }
    }
    getMultipleValue() {
        return this.value;
    }
    handleKeyboard(event) {
        if (this.disabled) {
            return;
        }
        if (this.opened.value) {
            this.handleKeyForOpenedDropdown(event);
        }
        else {
            this.handleKeyForClosedDropdown(event);
        }
    }
    handleMultiselectInputBlur() {
        this.multiselectFocused = false;
        this.onTouch();
    }
    handleMultiselectInputFocus() {
        this.multiselectFocused = true;
    }
    clickOutsideHandler(event) {
        if (!this.options.find(option => option.id === event.target?.id)) {
            this.opened.next(false);
            this.visualFocusIndex = null;
        }
    }
    open() {
        if (this.disabled) {
            return;
        }
        this.opened.next(!this.opened.value);
    }
    selectOption(index) {
        this.selectMultipleOption(index);
        this.multipleSearchFieldElement.nativeElement?.focus();
    }
    removeOptionFromList(val, buttonIndex, event) {
        event.stopPropagation();
        event.preventDefault();
        const value = this.options.find(option => val.name === option.name);
        value.selected = false;
        const valueInFilteredList = this.filteredOptions.find(option => val.name === option.name);
        valueInFilteredList.selected = false;
        this.multipleValue = this.value.filter(valueFromList => valueFromList.name !== val.name);
        if (this.multipleValue.length) {
            this.value = this.multipleValue;
        }
        else {
            this.value = undefined;
        }
        setTimeout(() => {
            if (buttonIndex >= this.removeOptionButtons.length) {
                this.removeOptionButtons.last?.nativeElement.focus();
            }
            else {
                this.removeOptionButtons.get(buttonIndex)?.nativeElement.focus();
            }
            if (!this.removeOptionButtons?.length) {
                this.multipleSearchFieldElement?.nativeElement.focus();
            }
        });
        this.onChange(this.value);
    }
    setDefaultForMultipleValue(value) {
        this.multipleValue = value;
        this.options.forEach(option => {
            option.selected = Boolean(this.multipleValue.find(val => option.name === val.name));
        });
    }
    visualFocusIsInOptionsRange() {
        return this.visualFocusIndex < this.filteredOptions.length;
    }
    clearFiltered() {
        this.filteredOptions = this.options.map(option => option);
    }
    clearValues() {
        this.multipleValue = [];
        this.options.forEach(option => {
            option.selected = false;
        });
        this.clearFiltered();
        this.currentIndex = undefined;
        this.opened.next(false);
        this.changeVisualFocus(null);
        this.value = undefined;
        this.onChange(this.value);
        this.multipleSearchFieldElement?.nativeElement.focus();
    }
    changeVisualFocus(index) {
        this.visualFocusIndex = index;
        if (!this.multipleSearchFieldElement) {
            return;
        }
        if (index !== null && index > -1) {
            this.multipleSearchFieldElement?.nativeElement.setAttribute('aria-activedescendant', this.filteredOptions[index]?.id);
            this.scrollToOption();
        }
        else {
            this.multipleSearchFieldElement?.nativeElement.removeAttribute('aria-activedescendant');
        }
    }
    scrollToOption() {
        const currentOption = this.nativeOptionsList.get(this.visualFocusIndex)?.nativeElement;
        if (!currentOption) {
            return;
        }
        const { offsetHeight, offsetTop, offsetParent } = currentOption;
        if (!offsetParent) {
            return;
        }
        const { offsetHeight: parentOffsetHeight, scrollTop } = offsetParent;
        const isAbove = offsetTop < scrollTop;
        const isBelow = offsetTop + offsetHeight > scrollTop + parentOffsetHeight;
        if (isAbove) {
            offsetParent.scrollTo(0, offsetTop);
        }
        else if (isBelow) {
            offsetParent.scrollTo(0, offsetTop - parentOffsetHeight + offsetHeight);
        }
    }
    selectMultipleOption(index) {
        if (this.disabled) {
            return;
        }
        const value = this.filteredOptions[index];
        if (value.selected) {
            value.selected = false;
            this.multipleValue = this.multipleValue.filter(mValue => mValue.name !== value.name);
        }
        else {
            value.selected = true;
            this.multipleValue.push(value);
        }
        this.value = this.multipleValue;
        this.onChange(this.value);
        this.changeVisualFocus(null);
    }
    chooseOptionByKeyboard(event) {
        if (this.visualFocusIndex !== null && this.visualFocusIsInOptionsRange()) {
            event.preventDefault();
            const currentIndex = this.visualFocusIndex;
            this.selectOption(this.visualFocusIndex);
            if (this.visualFocusIsInOptionsRange) {
                this.changeVisualFocus(currentIndex);
            }
        }
    }
    moveVisualFocusUp(event) {
        event.preventDefault();
        if (this.visualFocusIndex === null) {
            this.changeVisualFocus(0);
        }
        else if (this.visualFocusIndex < this.filteredOptions.length - 1) {
            this.changeVisualFocus(this.visualFocusIndex + 1);
        }
    }
    moveVisualFocusDown(event) {
        event.preventDefault();
        if (this.visualFocusIndex === null) {
            this.changeVisualFocus(0);
        }
        else if (this.visualFocusIndex > 0) {
            this.changeVisualFocus(this.visualFocusIndex - 1);
        }
    }
    moveOnPageUp(event) {
        event.preventDefault();
        const pageUpTarget = this.visualFocusIndex - PAGE_SIZE$1;
        if (pageUpTarget >= 0) {
            this.changeVisualFocus(pageUpTarget);
        }
        else {
            this.changeVisualFocus(0);
        }
    }
    moveOnPageDown(event) {
        event.preventDefault();
        const pageDownTarget = this.visualFocusIndex + PAGE_SIZE$1;
        if (pageDownTarget <= this.filteredOptions.length - 1) {
            this.changeVisualFocus(pageDownTarget);
        }
        else {
            this.changeVisualFocus(this.filteredOptions.length - 1);
        }
    }
    preventEnterDefaultBehaviorForForm(event) {
        if (event.target === this.multipleSearchFieldElement?.nativeElement) {
            // it shouldn't trigger sending form https://github.com/angular/angular/issues/12643
            event.preventDefault();
        }
    }
    handleKeyForOpenedDropdown(event) {
        switch (event.code) {
            case 'ArrowDown':
                this.moveVisualFocusUp(event);
                break;
            case 'ArrowUp':
                this.moveVisualFocusDown(event);
                break;
            case 'Space':
                break;
            case 'Enter':
                this.chooseOptionByKeyboard(event);
                break;
            case 'Tab':
                this.opened.next(false);
                break;
            case 'Escape':
                event.stopPropagation();
                event.preventDefault();
                this.multipleSearchFieldElement?.nativeElement.focus();
                this.opened.next(false);
                this.changeVisualFocus(null);
                break;
            case 'Home':
                event.preventDefault();
                this.changeVisualFocus(0);
                break;
            case 'End':
                event.preventDefault();
                this.changeVisualFocus(this.filteredOptions.length - 1);
                break;
            case 'PageUp':
                this.moveOnPageUp(event);
                break;
            case 'PageDown':
                this.moveOnPageDown(event);
                break;
            default:
                break;
        }
    }
    handleKeyForClosedDropdown(event) {
        switch (event.code) {
            case 'ArrowDown':
            case 'ArrowUp':
                this.opened.next(true);
                this.changeVisualFocus(0);
                break;
            case 'Enter':
                if (event.target === this.multipleSearchFieldElement?.nativeElement) {
                    this.preventEnterDefaultBehaviorForForm(event);
                    this.opened.next(true);
                    this.changeVisualFocus(0);
                }
                break;
            case 'Space':
                if (event.target === this.multipleSearchFieldElement?.nativeElement) {
                    this.opened.next(true);
                    this.changeVisualFocus(0);
                }
                break;
            case 'Home':
                this.opened.next(true);
                this.changeVisualFocus(0);
                break;
            case 'End':
                this.opened.next(true);
                this.changeVisualFocus(this.filteredOptions.length - 1);
                break;
            default:
                break;
        }
    }
    clearObserveScrolledToEnd() {
        if (this.scrolledToEndTargetElement) {
            this.scrolledToEndObserver?.unobserve(this.scrolledToEndTargetElement);
        }
        this.scrolledToEndObserver = null;
        this.scrolledToEndTargetElement = null;
    }
    observeScrolledToEnd() {
        if (!this.nativeOptionsList || this.nativeOptionsList.length === 0) {
            return;
        }
        const endScrollOffset = this.endScrollOffset < 0 ? 0 : this.endScrollOffset;
        const targetIndex = this.nativeOptionsList.length - 1 - endScrollOffset;
        this.scrolledToEndTargetElement = this.nativeOptionsList.get(targetIndex > -1 ? targetIndex : this.nativeOptionsList.length - 1)?.nativeElement;
        if (this.scrolledToEndTargetElement) {
            this.scrolledToEndObserver = new IntersectionObserver((entries) => {
                if (entries.some(entry => entry.isIntersecting)) {
                    this.clearObserveScrolledToEnd();
                    this.scrollToEnd.emit();
                }
            }, {
                root: this.nativeOptionsListBox.nativeElement,
            });
            this.scrolledToEndObserver.observe(this.scrolledToEndTargetElement);
        }
    }
    static { this.ɵfac = function MultiselectNextComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MultiselectNextComponent)(i0.ɵɵdirectiveInject(SearchService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MultiselectNextComponent, selectors: [["mon-multiselect-next"]], viewQuery: function MultiselectNextComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$d, 5);
            i0.ɵɵviewQuery(_c1$5, 5);
            i0.ɵɵviewQuery(_c2$3, 5);
            i0.ɵɵviewQuery(_c3$1, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.nativeOptionsListBox = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.multipleSearchFieldElement = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.nativeOptionsList = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.removeOptionButtons = _t);
        } }, inputs: { options: "options", placeholder: "placeholder", label: "label", hideLabel: "hideLabel", size: "size", allowClear: "allowClear", describedBy: "describedBy", monId: "monId", optionTemplate: "optionTemplate", selectedValueTemplate: "selectedValueTemplate", endScrollOffset: "endScrollOffset", disableFuzzySearch: "disableFuzzySearch", _value: "_value" }, outputs: { scrollToEnd: "scrollToEnd", searchInput: "searchInput" }, standalone: true, features: [i0.ɵɵProvidersFeature([
                {
                    provide: NG_VALUE_ACCESSOR,
                    useExisting: forwardRef(() => MultiselectNextComponent),
                    multi: true,
                },
                SearchService,
            ]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature], decls: 15, vars: 21, consts: [["multipleSearchField", ""], ["defaultOptionTemplate", ""], ["defaultSelectedValueTemplate", ""], ["optionsListBox", ""], ["optionsList", ""], ["removeOptionButtons", ""], ["class", "label", 3, "class", "hiddenLabel", 4, "ngIf"], [3, "clickOutside", "delayClickOutsideInit"], [1, "multiselect-box"], [1, "options-container"], ["role", "combobox", 1, "multiple-search", 3, "click", "keydown", "blur", "focus", "input", "disabled", "placeholder"], ["class", "listbox", "role", "listbox", 4, "ngIf"], [1, "values"], ["class", "multiple-value", 3, "class", "disabled", "click", "blur", "focus", 4, "ngFor", "ngForOf"], ["class", "clear-button", 3, "class", "disabled", "click", "keydown", "blur", "focus", 4, "ngIf"], [1, "label"], ["role", "listbox", 1, "listbox"], ["class", "no-result", 4, "ngIf"], ["role", "option", "class", "option", 3, "selected", "hovered", "class", "click", 4, "ngFor", "ngForOf"], [1, "no-result"], ["role", "option", 1, "option", 3, "click"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "multiple-value", 3, "click", "blur", "focus", "disabled"], [1, "remove-value-button"], [1, "clear-button", 3, "click", "keydown", "blur", "focus", "disabled"], [1, "clear-icon"], ["monIconDirect", "faTimes"]], template: function MultiselectNextComponent_Template(rf, ctx) { if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵtemplate(0, MultiselectNextComponent_label_0_Template, 2, 7, "label", 6);
            i0.ɵɵelementStart(1, "div", 7);
            i0.ɵɵlistener("clickOutside", function MultiselectNextComponent_Template_div_clickOutside_1_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.clickOutsideHandler($event)); });
            i0.ɵɵelementStart(2, "div", 8)(3, "div", 9)(4, "input", 10, 0);
            i0.ɵɵpipe(6, "translate");
            i0.ɵɵlistener("click", function MultiselectNextComponent_Template_input_click_4_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.open()); })("keydown", function MultiselectNextComponent_Template_input_keydown_4_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.handleKeyboard($event)); })("blur", function MultiselectNextComponent_Template_input_blur_4_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.handleMultiselectInputBlur()); })("focus", function MultiselectNextComponent_Template_input_focus_4_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.handleMultiselectInputFocus()); })("input", function MultiselectNextComponent_Template_input_input_4_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.handleInputWithSearch($event)); });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(7, MultiselectNextComponent_div_7_Template, 4, 6, "div", 11);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "div", 12);
            i0.ɵɵtemplate(9, MultiselectNextComponent_button_9_Template, 6, 15, "button", 13);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(10, MultiselectNextComponent_button_10_Template, 4, 6, "button", 14);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(11, MultiselectNextComponent_ng_template_11_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(13, MultiselectNextComponent_ng_template_13_Template, 1, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", !ctx.monId);
            i0.ɵɵadvance();
            i0.ɵɵproperty("delayClickOutsideInit", true);
            i0.ɵɵadvance(2);
            i0.ɵɵclassMap(ctx.size);
            i0.ɵɵadvance();
            i0.ɵɵclassMap(ctx.size);
            i0.ɵɵproperty("disabled", ctx.disabled)("placeholder", ctx.placeholder || "");
            i0.ɵɵattribute("aria-required", ctx.required)("aria-description", i0.ɵɵpipeBind1(6, 19, "Search in options"))("aria-disabled", ctx.disabled)("aria-labelledby", ctx.labelId)("aria-controls", ctx.listboxId)("aria-haspopup", "listbox")("aria-expanded", ctx.opened.value ? "true" : "false")("aria-autocomplete", "list");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.opened.value);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.getMultipleValue());
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.multipleValue.length > 0 && ctx.allowClear);
        } }, dependencies: [CommonModule, i1$2.NgForOf, i1$2.NgIf, i1$2.NgTemplateOutlet, IconsModule, IconComponent, NgClickOutsideDirective,
            TranslateModule, TranslatePipe], styles: [".ng-invalid.ng-dirty[_nghost-%COMP%]   .current-value-box[_ngcontent-%COMP%], .ng-invalid.ng-dirty[_nghost-%COMP%]   .multiple-value-box[_ngcontent-%COMP%]{border:1px solid #BA322D}[_nghost-%COMP%]{--mon-select-small-size: 12px;--mon-select-medium-size: 14px;--mon-select-large-size: 16px;--mon-select-option-color: #255783;--mon-select-value-box-basic-border-color: #adadad;--mon-select-value-box-focus-border-color: #86b7fe;--mon-select-value-box-focus-border-box-shadow: 0 0 0 .25rem rgba(13, 110, 253, .25);--mon-select-focus-visible: 0 0 0 2px #4976B9;--mon-select-listbox-border: 1px solid #cccccc;--mon-select-current-value-box-border: 1px solid #cccccc;--mon-select-clear-button-color: #595959;--mon-select-disabled-bg-color: rgba(236, 238, 239, .5)}[_nghost-%COMP%]   .label[_ngcontent-%COMP%]{margin-bottom:5px;font-size:var(--mon-select-small-size)}[_nghost-%COMP%]   .clear-button[_ngcontent-%COMP%]{border:0;background:transparent;padding:0 10px;color:var(--mon-select-clear-button-color);align-self:start;position:relative}[_nghost-%COMP%]   .clear-button[_ngcontent-%COMP%]:disabled{color:#59595980;cursor:not-allowed}[_nghost-%COMP%]   .clear-button.small[_ngcontent-%COMP%]{height:30px}[_nghost-%COMP%]   .clear-button.medium[_ngcontent-%COMP%]{height:32px}[_nghost-%COMP%]   .clear-button.large[_ngcontent-%COMP%]{height:34px}[_nghost-%COMP%]   .clear-icon[_ngcontent-%COMP%]{position:relative;top:1px}[_nghost-%COMP%]   .hiddenLabel[_ngcontent-%COMP%]{width:0;height:0;position:absolute;overflow:hidden;opacity:0}[_nghost-%COMP%]   .option[_ngcontent-%COMP%]{color:var(--mon-select-option-color);cursor:pointer;padding:5px 20px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-size:var(--mon-select-small-size)}[_nghost-%COMP%]   .selected[_ngcontent-%COMP%]{color:#fff;background:#299bf7}[_nghost-%COMP%]   .option[_ngcontent-%COMP%]:hover, [_nghost-%COMP%]   .hovered[_ngcontent-%COMP%]{color:#fff;background:var(--mon-select-option-color)}[_nghost-%COMP%]   .no-result[_ngcontent-%COMP%]{color:var(--mon-select-option-color);padding:5px 20px}[_nghost-%COMP%]   .listbox[_ngcontent-%COMP%]{background:#fff;position:absolute;width:100%;border-radius:4px;border:var(--mon-select-listbox-border);padding:5px 0;max-height:200px;z-index:3;overflow:auto;top:100%}[_nghost-%COMP%]   .values[_ngcontent-%COMP%]{display:flex;flex-flow:row wrap;gap:5px}[_nghost-%COMP%]   .options-container[_ngcontent-%COMP%]{position:relative}[_nghost-%COMP%]   .options-container.small[_ngcontent-%COMP%]{height:30px}[_nghost-%COMP%]   .options-container.small[_ngcontent-%COMP%] + .values[_ngcontent-%COMP%]{width:calc(100% - 205px)}[_nghost-%COMP%]   .options-container.medium[_ngcontent-%COMP%]{height:32px}[_nghost-%COMP%]   .options-container.medium[_ngcontent-%COMP%] + .values[_ngcontent-%COMP%]{width:calc(100% - 215px)}[_nghost-%COMP%]   .options-container.large[_ngcontent-%COMP%]{height:34px}[_nghost-%COMP%]   .options-container.large[_ngcontent-%COMP%] + .values[_ngcontent-%COMP%]{width:calc(100% - 225px)}[_nghost-%COMP%]   .multiselect-box[_ngcontent-%COMP%]{border-radius:4px;background:#fff;display:flex;gap:5px}[_nghost-%COMP%]   .multiselect-box.small[_ngcontent-%COMP%]{height:30px}[_nghost-%COMP%]   .multiselect-box.medium[_ngcontent-%COMP%]{height:32px}[_nghost-%COMP%]   .multiselect-box.large[_ngcontent-%COMP%]{height:34px}[_nghost-%COMP%]   .multiple-value[_ngcontent-%COMP%]{font-size:var(--mon-select-small-size);position:relative;overflow-wrap:anywhere;background:#299bf7;border-radius:20px;color:#fff;padding:2px 5px 2px 7px;font-weight:300;display:inline-flex;align-items:center;border:0;text-align:center;max-width:100%;outline:0}[_nghost-%COMP%]   .multiple-value[_ngcontent-%COMP%]:disabled:after{background-color:var(--mon-select-disabled-bg-color);content:\"\";position:absolute;width:100%;height:100%;top:0;left:0;border-radius:20px;cursor:not-allowed}[_nghost-%COMP%]   .multiple-value.small[_ngcontent-%COMP%]{min-height:30px}[_nghost-%COMP%]   .multiple-value.medium[_ngcontent-%COMP%]{min-height:32px}[_nghost-%COMP%]   .multiple-value.large[_ngcontent-%COMP%]{min-height:34px}[_nghost-%COMP%]   .multiple-value[_ngcontent-%COMP%]:focus-visible{box-shadow:var(--mon-select-focus-visible)}[_nghost-%COMP%]   .remove-value-button[_ngcontent-%COMP%]{font-size:var(--mon-select-small-size);color:#299bf7;border-radius:50%;border:0;background:#fff;min-width:14px;height:14px;margin-left:5px;display:flex;justify-content:center;align-items:center;padding-bottom:2px}[_nghost-%COMP%]   .multiple-search[_ngcontent-%COMP%]{font-size:var(--mon-select-small-size);border:var(--mon-select-listbox-border);border-radius:4px;outline:none;padding:0 10px}[_nghost-%COMP%]   .multiple-search[_ngcontent-%COMP%]:hover{border:1px solid var(--mon-select-value-box-basic-border-color)}[_nghost-%COMP%]   .multiple-search[_ngcontent-%COMP%]:focus{border:1px solid var(--mon-select-value-box-focus-border-color);box-shadow:var(--mon-select-value-box-focus-border-box-shadow)}[_nghost-%COMP%]   .multiple-search[_ngcontent-%COMP%]:disabled{box-shadow:none;border:var(--mon-select-current-value-box-border);cursor:not-allowed}[_nghost-%COMP%]   .multiple-search.small[_ngcontent-%COMP%]{height:30px;min-width:200px}[_nghost-%COMP%]   .multiple-search.medium[_ngcontent-%COMP%]{height:32px;min-width:210px}[_nghost-%COMP%]   .multiple-search.large[_ngcontent-%COMP%]{height:34px;min-width:220px}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MultiselectNextComponent, [{
        type: Component,
        args: [{ selector: 'mon-multiselect-next', providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => MultiselectNextComponent),
                        multi: true,
                    },
                    SearchService,
                ], standalone: true, imports: [
                    CommonModule,
                    IconsModule,
                    NgClickOutsideDirective,
                    TranslateModule,
                ], template: "<label *ngIf=\"!monId\" class=\"label\" [class]=\"size\" [class.hiddenLabel]=\"hideLabel\" [attr.id]=\"labelId\">{{label}}{{required ? ' *' : ''}}</label>\n<div [delayClickOutsideInit]=\"true\" (clickOutside)=\"clickOutsideHandler($event)\">\n    <div class=\"multiselect-box\">\n        <div class=\"options-container\" [class]=\"size\">\n            <input\n                (click)=\"open()\"\n                [attr.aria-required]=\"required\"\n                [attr.aria-description]=\"'Search in options' | translate\"\n                [attr.aria-disabled]=\"disabled\"\n                [disabled]=\"disabled\"\n                [attr.aria-labelledby]=\"labelId\"\n                [class]=\"size\"\n                [placeholder]=\"placeholder || ''\"\n                (keydown)=\"handleKeyboard($event)\"\n                [attr.aria-controls]=\"listboxId\"\n                [attr.aria-haspopup]=\"'listbox'\"\n                [attr.aria-expanded]=\"opened.value ? 'true' : 'false'\"\n                [attr.aria-autocomplete]=\"'list'\"\n                role=\"combobox\"\n                class=\"multiple-search\"\n                (blur)=\"handleMultiselectInputBlur()\"\n                (focus)=\"handleMultiselectInputFocus()\"\n                #multipleSearchField\n                (input)=\"handleInputWithSearch($event)\"\n            />\n            <div\n                #optionsListBox\n                class=\"listbox\"\n                role=\"listbox\"\n                [attr.aria-multiselectable]=\"true\"\n                *ngIf=\"opened.value\"\n                [attr.id]=\"listboxId\"\n                [attr.aria-describedby]=\"describedBy\"\n                [attr.aria-labelledby]=\"labelId\"\n            >\n                <div class=\"no-result\" *ngIf=\"filteredOptions.length === 0\">{{'No results found' | translate}}</div>\n                <div\n                    role=\"option\"\n                    #optionsList\n                    class=\"option\"\n                    [class.selected]=\"option.selected\"\n                    [attr.aria-selected]=\"option.selected\"\n                    [attr.id]=\"option.id\"\n                    *ngFor=\"let option of filteredOptions; let i = index\"\n                    [class.hovered]=\"i === visualFocusIndex\"\n                    [class]=\"size\"\n                    (click)=\"selectOption(i)\"\n                >\n                    <ng-template [ngTemplateOutlet]=\"optionTemplate || defaultOptionTemplate\" [ngTemplateOutletContext]=\"{option: option}\"></ng-template>\n                </div>\n            </div>\n        </div>\n        <div class=\"values\">\n            <button\n                class=\"multiple-value\"\n                [class]=\"size\"\n                *ngFor=\"let value of getMultipleValue(); let i = index\"\n                (click)=\"removeOptionFromList(value, i, $event)\"\n                (blur)=\"handleMultiselectInputBlur()\"\n                (focus)=\"handleMultiselectInputFocus()\"\n                [disabled]=\"disabled\"\n                #removeOptionButtons\n                [attr.aria-label]=\"'[[name]] Remove' | translate:'':{name: value.name}\"\n            >\n                <ng-template [ngTemplateOutlet]=\"selectedValueTemplate || defaultSelectedValueTemplate\" [ngTemplateOutletContext]=\"{value: value}\"></ng-template>\n                <span\n                    [attr.aria-hidden]=\"true\"\n                    class=\"remove-value-button\"\n                >\u00D7</span>\n            </button>\n        </div>\n        <button\n            (click)=\"clear()\"\n            (keydown)=\"clear($event)\"\n            *ngIf=\"multipleValue.length > 0 && allowClear\"\n            class=\"clear-button\"\n            [class]=\"size\"\n            (blur)=\"handleMultiselectInputBlur()\"\n            (focus)=\"handleMultiselectInputFocus()\"\n            [attr.aria-label]=\"'Clear the field' | translate\"\n            [disabled]=\"disabled\"\n        >\n            <span class=\"clear-icon\">\n                <mon-icon\n                    monIconDirect=\"faTimes\"\n                ></mon-icon>\n            </span>\n        </button>\n    </div>\n</div>\n\n<ng-template #defaultOptionTemplate let-option=\"option\">\n    {{ option.name }}\n</ng-template>\n\n<ng-template #defaultSelectedValueTemplate let-value=\"value\">\n    {{ value.name }}\n</ng-template>\n", styles: [":host.ng-invalid.ng-dirty .current-value-box,:host.ng-invalid.ng-dirty .multiple-value-box{border:1px solid #BA322D}:host{--mon-select-small-size: 12px;--mon-select-medium-size: 14px;--mon-select-large-size: 16px;--mon-select-option-color: #255783;--mon-select-value-box-basic-border-color: #adadad;--mon-select-value-box-focus-border-color: #86b7fe;--mon-select-value-box-focus-border-box-shadow: 0 0 0 .25rem rgba(13, 110, 253, .25);--mon-select-focus-visible: 0 0 0 2px #4976B9;--mon-select-listbox-border: 1px solid #cccccc;--mon-select-current-value-box-border: 1px solid #cccccc;--mon-select-clear-button-color: #595959;--mon-select-disabled-bg-color: rgba(236, 238, 239, .5)}:host .label{margin-bottom:5px;font-size:var(--mon-select-small-size)}:host .clear-button{border:0;background:transparent;padding:0 10px;color:var(--mon-select-clear-button-color);align-self:start;position:relative}:host .clear-button:disabled{color:#59595980;cursor:not-allowed}:host .clear-button.small{height:30px}:host .clear-button.medium{height:32px}:host .clear-button.large{height:34px}:host .clear-icon{position:relative;top:1px}:host .hiddenLabel{width:0;height:0;position:absolute;overflow:hidden;opacity:0}:host .option{color:var(--mon-select-option-color);cursor:pointer;padding:5px 20px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-size:var(--mon-select-small-size)}:host .selected{color:#fff;background:#299bf7}:host .option:hover,:host .hovered{color:#fff;background:var(--mon-select-option-color)}:host .no-result{color:var(--mon-select-option-color);padding:5px 20px}:host .listbox{background:#fff;position:absolute;width:100%;border-radius:4px;border:var(--mon-select-listbox-border);padding:5px 0;max-height:200px;z-index:3;overflow:auto;top:100%}:host .values{display:flex;flex-flow:row wrap;gap:5px}:host .options-container{position:relative}:host .options-container.small{height:30px}:host .options-container.small+.values{width:calc(100% - 205px)}:host .options-container.medium{height:32px}:host .options-container.medium+.values{width:calc(100% - 215px)}:host .options-container.large{height:34px}:host .options-container.large+.values{width:calc(100% - 225px)}:host .multiselect-box{border-radius:4px;background:#fff;display:flex;gap:5px}:host .multiselect-box.small{height:30px}:host .multiselect-box.medium{height:32px}:host .multiselect-box.large{height:34px}:host .multiple-value{font-size:var(--mon-select-small-size);position:relative;overflow-wrap:anywhere;background:#299bf7;border-radius:20px;color:#fff;padding:2px 5px 2px 7px;font-weight:300;display:inline-flex;align-items:center;border:0;text-align:center;max-width:100%;outline:0}:host .multiple-value:disabled:after{background-color:var(--mon-select-disabled-bg-color);content:\"\";position:absolute;width:100%;height:100%;top:0;left:0;border-radius:20px;cursor:not-allowed}:host .multiple-value.small{min-height:30px}:host .multiple-value.medium{min-height:32px}:host .multiple-value.large{min-height:34px}:host .multiple-value:focus-visible{box-shadow:var(--mon-select-focus-visible)}:host .remove-value-button{font-size:var(--mon-select-small-size);color:#299bf7;border-radius:50%;border:0;background:#fff;min-width:14px;height:14px;margin-left:5px;display:flex;justify-content:center;align-items:center;padding-bottom:2px}:host .multiple-search{font-size:var(--mon-select-small-size);border:var(--mon-select-listbox-border);border-radius:4px;outline:none;padding:0 10px}:host .multiple-search:hover{border:1px solid var(--mon-select-value-box-basic-border-color)}:host .multiple-search:focus{border:1px solid var(--mon-select-value-box-focus-border-color);box-shadow:var(--mon-select-value-box-focus-border-box-shadow)}:host .multiple-search:disabled{box-shadow:none;border:var(--mon-select-current-value-box-border);cursor:not-allowed}:host .multiple-search.small{height:30px;min-width:200px}:host .multiple-search.medium{height:32px;min-width:210px}:host .multiple-search.large{height:34px;min-width:220px}\n"] }]
    }], () => [{ type: SearchService }], { nativeOptionsList: [{
            type: ViewChildren,
            args: ['optionsList']
        }], removeOptionButtons: [{
            type: ViewChildren,
            args: ['removeOptionButtons']
        }], nativeOptionsListBox: [{
            type: ViewChild,
            args: ['optionsListBox']
        }], multipleSearchFieldElement: [{
            type: ViewChild,
            args: ['multipleSearchField']
        }], options: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], label: [{
            type: Input
        }], hideLabel: [{
            type: Input
        }], size: [{
            type: Input
        }], allowClear: [{
            type: Input
        }], describedBy: [{
            type: Input
        }], monId: [{
            type: Input
        }], optionTemplate: [{
            type: Input
        }], selectedValueTemplate: [{
            type: Input
        }], endScrollOffset: [{
            type: Input
        }], disableFuzzySearch: [{
            type: Input
        }], _value: [{
            type: Input
        }], scrollToEnd: [{
            type: Output
        }], searchInput: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(MultiselectNextComponent, { className: "MultiselectNextComponent" }); })();

const _c0$c = ["searchField"];
const _c1$4 = ["optionsList"];
const _c2$2 = a0 => ({ hovered: a0 });
function SelectNextAcComponent_label_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("hiddenLabel", ctx_r1.hideLabel);
    i0.ɵɵattribute("id", ctx_r1.labelId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2("", ctx_r1.label, "", ctx_r1.required ? " *" : "", "");
} }
function SelectNextAcComponent_button_4_mon_icon_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mon-icon", 11);
} }
function SelectNextAcComponent_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 9);
    i0.ɵɵlistener("click", function SelectNextAcComponent_button_4_Template_button_click_0_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.open($event)); });
    i0.ɵɵtemplate(1, SelectNextAcComponent_button_4_mon_icon_1_Template, 1, 0, "mon-icon", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r1.size);
    i0.ɵɵclassProp("opened", ctx_r1.opened.value || ctx_r1.focused);
    i0.ɵɵproperty("tabIndex", -1)("disabled", ctx_r1.disabled);
    i0.ɵɵattribute("aria-hidden", true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.opened.value && !ctx_r1.focused);
} }
function SelectNextAcComponent_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 12);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("click", function SelectNextAcComponent_button_5_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.clear()); })("keydown", function SelectNextAcComponent_button_5_Template_button_keydown_0_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.clear($event)); });
    i0.ɵɵelementStart(2, "span", 13);
    i0.ɵɵelement(3, "mon-icon", 14);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("opened", ctx_r1.opened.value || ctx_r1.focused);
    i0.ɵɵproperty("disabled", ctx_r1.disabled);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 4, "Clear the field"));
} }
function SelectNextAcComponent_div_6_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "No results found"));
} }
function SelectNextAcComponent_div_6_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 19, 1);
    i0.ɵɵlistener("click", function SelectNextAcComponent_div_6_div_2_Template_div_click_0_listener() { const i_r6 = i0.ɵɵrestoreView(_r5).index; const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.selectOption(i_r6)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r7 = ctx.$implicit;
    const i_r6 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(i0.ɵɵpureFunction1(5, _c2$2, i_r6 === ctx_r1.visualFocusIndex));
    i0.ɵɵattribute("aria-selected", ctx_r1.currentIndex === i_r6)("id", option_r7.id);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", option_r7.name, " ");
} }
function SelectNextAcComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtemplate(1, SelectNextAcComponent_div_6_div_1_Template, 3, 3, "div", 16)(2, SelectNextAcComponent_div_6_div_2_Template, 3, 7, "div", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("id", ctx_r1.listboxId)("aria-describedby", ctx_r1.describedBy)("aria-labelledby", ctx_r1.labelId);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.filteredOptions.length === 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.filteredOptions);
} }
const PAGE_SIZE = 10;
class SelectNextAcComponent extends AbstractControlValueAccessor {
    get value() {
        return this._value;
    }
    set value(val) {
        const isFirstChangeForSingleOption = !this._value && val && !this.changed;
        const optionsExist = this.options.length;
        if (isFirstChangeForSingleOption && optionsExist) {
            this.changed = true;
            this.setDefaultForSingleValue(val);
        }
        if (!val) {
            this.currentIndex = null;
        }
        this._value = val;
        this.onChange(val);
    }
    constructor(searchService) {
        super();
        this.searchService = searchService;
        this.options = [];
        this.hideLabel = false;
        this.size = 'small';
        this.allowClear = false;
        this.filteredOptions = [];
        this.opened = new BehaviorSubject(false);
        this.visualFocusIndex = null;
        this.labelId = '';
        this.timer = 0;
        this.focused = false;
        this.changed = false;
        // throttle for reducing filtering operations
        this.handleInputWithSearch = throttle((event) => {
            if (!this.opened.value) {
                this.opened.next(true);
            }
            const value = event.target?.value;
            this.filteredOptions =
                this.options.filter(option => value ? this.searchService.fuzzy(value, option.name) : true);
            if (this.filteredOptions.length > 0) {
                this.changeVisualFocus(0);
            }
            else {
                this.changeVisualFocus(null);
            }
        }, 300);
        this.listboxId = `listbox-${UidService.generateUid()}`;
        this.searchFieldId = `search-field-${UidService.generateUid()}`;
    }
    ngOnChanges(changes) {
        const haveNotIds = changes.options?.currentValue.some((option) => !option.id);
        if (haveNotIds) {
            this.options = changes.options.currentValue.map((option, i) => ({
                ...option,
                id: `${option.name.replace(/\s/, '')}-${UidService.generateUid()}`,
                index: i,
            }));
            this.options.forEach(option => {
                this.filteredOptions.push(option);
            });
            if (this.value) {
                this.setDefaultForSingleValue(this.value);
                return;
            }
        }
    }
    ngAfterContentInit() {
        this.labelId = this.getLabelForId(this.label);
        this.opened.subscribe((opened) => {
            if (opened) {
                setTimeout(() => {
                    this.searchFieldElement?.nativeElement.focus();
                });
            }
        });
    }
    ngOnDestroy() {
        if (this.timer) {
            clearTimeout(this.timer);
        }
        this.opened.unsubscribe();
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    writeValue(value) {
        if (value !== null && value !== undefined) {
            this.value = value;
            this.onChange(value);
        }
    }
    clear(event) {
        if (event && (event.code === 'Enter' || event.code === 'Space')) {
            event.preventDefault();
            this.clearValues();
        }
        if (!event) {
            this.clearValues();
        }
    }
    getSingleValue() {
        return this.value;
    }
    handleKeyboard(event) {
        if (this.disabled) {
            return;
        }
        if (this.opened.value) {
            this.handleKeyForOpenedDropdown(event);
        }
        else {
            this.handleKeyForClosedDropdown(event);
        }
    }
    clickOutsideHandler(event) {
        if (!this.options.find(option => option.id === event.target?.id)) {
            this.opened.next(false);
            this.visualFocusIndex = null;
            this.clearFiltered();
            if (this.value && this.searchFieldElement && this.searchFieldElement.nativeElement.value !== this.value.name) {
                this.searchFieldElement.nativeElement.value = this.value.name;
            }
            else if (!this.value && this.searchFieldElement?.nativeElement.value) {
                this.searchFieldElement.nativeElement.value = '';
            }
        }
    }
    onFocus() {
        if (this.disabled) {
            return;
        }
        this.focused = true;
        if (this.timer) {
            clearTimeout(this.timer);
        }
    }
    onBlur() {
        if (this.disabled) {
            return;
        }
        this.focused = false;
        // because onblur triggers even when we click by options, we need to handle the event only when we're sure that focus won't return
        this.timer = setTimeout(() => {
            this.opened.next(false);
            this.changeVisualFocus(null);
            this.clearFiltered();
            this.onTouch();
            if (this.value && this.searchFieldElement && this.searchFieldElement.nativeElement.value !== this.value.name) {
                this.searchFieldElement.nativeElement.value = this.value.name;
            }
            else if (!this.value && this.searchFieldElement?.nativeElement.value) {
                this.searchFieldElement.nativeElement.value = '';
            }
        }, 200);
    }
    open(event) {
        event?.stopPropagation();
        event?.preventDefault();
        if (this.disabled) {
            return;
        }
        this.opened.next(!this.opened.value);
    }
    selectOption(index) {
        this.selectSingleOption(index);
    }
    setDefaultForSingleValue(value) {
        this.currentIndex = this.options.findIndex(option => {
            if ('value' in value) {
                return option.value === value.value;
            }
        });
    }
    visualFocusIsInOptionsRange() {
        return this.visualFocusIndex < this.filteredOptions.length;
    }
    clearFiltered() {
        this.filteredOptions = this.options.map(option => option);
    }
    clearValues() {
        this.clearFiltered();
        this.currentIndex = undefined;
        this.opened.next(false);
        this.changeVisualFocus(null);
        this.value = undefined;
        this.onChange(this.value);
        this.searchFieldElement?.nativeElement.focus();
    }
    changeVisualFocus(index) {
        this.visualFocusIndex = index;
        if (!this.searchFieldElement) {
            return;
        }
        if (index !== null && index > -1) {
            setTimeout(() => {
                this.searchFieldElement?.nativeElement.setAttribute('aria-activedescendant', this.filteredOptions[index]?.id);
            });
            this.scrollToOption();
        }
        else {
            this.searchFieldElement?.nativeElement.removeAttribute('aria-activedescendant');
        }
    }
    scrollToOption() {
        const currentOption = this.nativeOptionsList.get(this.visualFocusIndex)?.nativeElement;
        if (!currentOption) {
            return;
        }
        const { offsetHeight, offsetTop, offsetParent } = currentOption;
        if (!offsetParent) {
            return;
        }
        const { offsetHeight: parentOffsetHeight, scrollTop } = offsetParent;
        const isAbove = offsetTop < scrollTop;
        const isBelow = offsetTop + offsetHeight > scrollTop + parentOffsetHeight;
        if (isAbove) {
            offsetParent.scrollTo(0, offsetTop);
        }
        else if (isBelow) {
            offsetParent.scrollTo(0, offsetTop - parentOffsetHeight + offsetHeight);
        }
    }
    selectSingleOption(index) {
        if (this.disabled) {
            return;
        }
        const initialOptionsIndex = this.options.findIndex(option => option.id === this.filteredOptions[index].id);
        this.currentIndex = initialOptionsIndex;
        this.opened.next(false);
        this.changeVisualFocus(null);
        this.clearFiltered();
        this.value = this.options[initialOptionsIndex];
        this.onChange(this.value);
        this.searchFieldElement.nativeElement.focus();
    }
    chooseOptionByKeyboard(event) {
        if (this.visualFocusIndex !== null && this.visualFocusIsInOptionsRange()) {
            event.preventDefault();
            const currentIndex = this.visualFocusIndex;
            this.selectOption(this.visualFocusIndex);
            this.changeVisualFocus(currentIndex);
        }
        this.opened.next(false);
    }
    moveVisualFocusUp(event) {
        event.preventDefault();
        if (this.visualFocusIndex === null) {
            this.changeVisualFocus(0);
        }
        else if (this.visualFocusIndex < this.filteredOptions.length - 1) {
            this.changeVisualFocus(this.visualFocusIndex + 1);
        }
    }
    moveVisualFocusDown(event) {
        event.preventDefault();
        if (event.altKey) {
            this.selectOption(this.visualFocusIndex);
            return;
        }
        if (this.visualFocusIndex === null) {
            this.changeVisualFocus(0);
        }
        else if (this.visualFocusIndex > 0) {
            this.changeVisualFocus(this.visualFocusIndex - 1);
        }
    }
    moveOnPageUp(event) {
        event.preventDefault();
        const pageUpTarget = this.visualFocusIndex - PAGE_SIZE;
        if (pageUpTarget >= 0) {
            this.changeVisualFocus(pageUpTarget);
        }
        else {
            this.changeVisualFocus(0);
        }
    }
    moveOnPageDown(event) {
        event.preventDefault();
        const pageDownTarget = this.visualFocusIndex + PAGE_SIZE;
        if (pageDownTarget <= this.filteredOptions.length - 1) {
            this.changeVisualFocus(pageDownTarget);
        }
        else {
            this.changeVisualFocus(this.filteredOptions.length - 1);
        }
    }
    preventEnterDefaultBehaviorForForm(event) {
        if (event.target === this.searchFieldElement?.nativeElement) {
            // it shouldn't trigger sending form https://github.com/angular/angular/issues/12643
            event.preventDefault();
        }
    }
    handleKeyForOpenedDropdown(event) {
        switch (event.code) {
            case 'ArrowDown':
                this.moveVisualFocusUp(event);
                break;
            case 'ArrowUp':
                this.moveVisualFocusDown(event);
                break;
            case 'Space':
                break;
            case 'Enter':
                this.chooseOptionByKeyboard(event);
                break;
            case 'Escape':
                event.stopPropagation();
                event.preventDefault();
                this.searchFieldElement?.nativeElement.focus();
                this.opened.next(false);
                this.changeVisualFocus(null);
                break;
            case 'Home':
                event.preventDefault();
                this.changeVisualFocus(0);
                break;
            case 'End':
                event.preventDefault();
                this.changeVisualFocus(this.filteredOptions.length - 1);
                break;
            case 'PageUp':
                this.moveOnPageUp(event);
                break;
            case 'PageDown':
                this.moveOnPageDown(event);
                break;
        }
    }
    handleKeyForClosedDropdown(event) {
        switch (event.code) {
            case 'ArrowDown':
            case 'ArrowUp':
                this.opened.next(true);
                if (!event.altKey) {
                    this.changeVisualFocus(0);
                }
                break;
            case 'Enter':
                if (event.target === this.searchFieldElement?.nativeElement) {
                    this.preventEnterDefaultBehaviorForForm(event);
                    this.opened.next(true);
                    this.changeVisualFocus(0);
                }
                break;
            case 'Space':
                if (event.target === this.searchFieldElement?.nativeElement) {
                    this.opened.next(true);
                    this.changeVisualFocus(0);
                }
                break;
            case 'Home':
                this.opened.next(true);
                this.changeVisualFocus(0);
                break;
            case 'End':
                this.opened.next(true);
                this.changeVisualFocus(this.filteredOptions.length - 1);
                break;
        }
    }
    static { this.ɵfac = function SelectNextAcComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SelectNextAcComponent)(i0.ɵɵdirectiveInject(SearchService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SelectNextAcComponent, selectors: [["mon-select-ac-next"]], viewQuery: function SelectNextAcComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$c, 5);
            i0.ɵɵviewQuery(_c1$4, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.searchFieldElement = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.nativeOptionsList = _t);
        } }, inputs: { options: "options", placeholder: "placeholder", label: "label", hideLabel: "hideLabel", size: "size", allowClear: "allowClear", describedBy: "describedBy", monId: "monId", _value: "_value" }, standalone: true, features: [i0.ɵɵProvidersFeature([{
                    provide: NG_VALUE_ACCESSOR,
                    useExisting: forwardRef(() => SelectNextAcComponent),
                    multi: true,
                }]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature], decls: 7, vars: 26, consts: [["searchField", ""], ["optionsList", ""], ["class", "label", 3, "hiddenLabel", 4, "ngIf"], [1, "select-container", 3, "clickOutside", "delayClickOutsideInit"], ["role", "combobox", 1, "search-field", 3, "focus", "blur", "input", "click", "keydown", "disabled", "required", "placeholder", "value"], ["class", "button", 3, "tabIndex", "class", "opened", "disabled", "click", 4, "ngIf"], ["class", "button", 3, "opened", "disabled", "click", "keydown", 4, "ngIf"], ["class", "listbox", "role", "listbox", 4, "ngIf"], [1, "label"], [1, "button", 3, "click", "tabIndex", "disabled"], ["monIconDirect", "faCaretDown", 4, "ngIf"], ["monIconDirect", "faCaretDown"], [1, "button", 3, "click", "keydown", "disabled"], [1, "clear-icon"], ["monIconDirect", "faTimes"], ["role", "listbox", 1, "listbox"], ["tabindex", "-1", "class", "no-result", 4, "ngIf"], ["role", "option", "class", "option", 3, "class", "click", 4, "ngFor", "ngForOf"], ["tabindex", "-1", 1, "no-result"], ["role", "option", 1, "option", 3, "click"]], template: function SelectNextAcComponent_Template(rf, ctx) { if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵtemplate(0, SelectNextAcComponent_label_0_Template, 2, 5, "label", 2);
            i0.ɵɵelementStart(1, "div", 3);
            i0.ɵɵlistener("clickOutside", function SelectNextAcComponent_Template_div_clickOutside_1_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.clickOutsideHandler($event)); });
            i0.ɵɵelementStart(2, "input", 4, 0);
            i0.ɵɵlistener("focus", function SelectNextAcComponent_Template_input_focus_2_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.onFocus()); })("blur", function SelectNextAcComponent_Template_input_blur_2_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.onBlur()); })("input", function SelectNextAcComponent_Template_input_input_2_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.handleInputWithSearch($event)); })("click", function SelectNextAcComponent_Template_input_click_2_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.open()); })("keydown", function SelectNextAcComponent_Template_input_keydown_2_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.handleKeyboard($event)); });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, SelectNextAcComponent_button_4_Template, 2, 8, "button", 5)(5, SelectNextAcComponent_button_5_Template, 4, 6, "button", 6)(6, SelectNextAcComponent_div_6_Template, 3, 5, "div", 7);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", !ctx.monId);
            i0.ɵɵadvance();
            i0.ɵɵclassMap(ctx.size);
            i0.ɵɵclassProp("disabled", ctx.disabled)("focused", ctx.focused || ctx.opened.value);
            i0.ɵɵproperty("delayClickOutsideInit", true);
            i0.ɵɵadvance();
            i0.ɵɵclassMap(ctx.size);
            i0.ɵɵclassProp("closed", !ctx.opened.value && !ctx.focused);
            i0.ɵɵproperty("disabled", ctx.disabled)("required", ctx.required)("placeholder", ctx.placeholder || "")("value", ctx.value == null ? null : ctx.value.name);
            i0.ɵɵattribute("id", ctx.searchFieldId)("aria-controls", ctx.listboxId)("aria-required", ctx.required)("aria-labelledby", ctx.labelId)("aria-haspopup", true)("aria-expanded", ctx.opened.value ? "true" : "false")("aria-autocomplete", "list");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.allowClear && !ctx.getSingleValue() || !ctx.allowClear);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.getSingleValue() && ctx.allowClear);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.opened.value);
        } }, dependencies: [CommonModule, i1$2.NgForOf, i1$2.NgIf, IconsModule, IconComponent, NgClickOutsideDirective,
            TranslateModule, TranslatePipe], styles: [".ng-invalid.ng-dirty[_nghost-%COMP%]   .select-container[_ngcontent-%COMP%]{border:1px solid #BA322D;box-shadow:none}[_nghost-%COMP%]{--mon-select-small-size: 12px;--mon-select-option-color: #255783;--mon-select-placeholder-text-color: #6c757d;--mon-select-value-box-basic-border-color: #adadad;--mon-select-value-box-focus-border-color: #86b7fe;--mon-select-value-box-focus-border-box-shadow: 0 0 0 .25rem rgba(13, 110, 253, .25);--mon-select-focus-visible: 0 0 0 2px #4976B9;--mon-select-listbox-border: 1px solid #cccccc;--mon-select-current-value-box-border: 1px solid #cccccc;--mon-select-clear-button-color: #595959;--mon-select-disabled-bg-color: #eceeef;--mon-select-button-background: linear-gradient(#fafafa, #eee);--mon-select-button-width: 28px}[_nghost-%COMP%]   .select-container[_ngcontent-%COMP%]{position:relative;display:flex;border:var(--mon-select-current-value-box-border);border-radius:4px}[_nghost-%COMP%]   .select-container[_ngcontent-%COMP%]:hover:not(.disabled){border:1px solid var(--mon-select-value-box-basic-border-color)}[_nghost-%COMP%]   .select-container.disabled[_ngcontent-%COMP%]{cursor:not-allowed;box-shadow:none}[_nghost-%COMP%]   .closed[_ngcontent-%COMP%]{background-image:var(--mon-select-button-background)}[_nghost-%COMP%]   .search-field[_ngcontent-%COMP%]{width:calc(100% - var(--mon-select-button-width));padding:4px 10px;cursor:pointer;height:100%;outline:none;border:none;border-radius:4px 0 0 4px}[_nghost-%COMP%]   .search-field[disabled][_ngcontent-%COMP%]{cursor:not-allowed;color:#0006}[_nghost-%COMP%]   .focused[_ngcontent-%COMP%]{box-shadow:var(--mon-select-value-box-focus-border-box-shadow);border-radius:4px;border:1px solid var(--mon-select-value-box-focus-border-color)}[_nghost-%COMP%]   .disabled[_ngcontent-%COMP%]{cursor:not-allowed}[_nghost-%COMP%]   .clear-icon[_ngcontent-%COMP%]{position:relative;top:1px}[_nghost-%COMP%]   .label[_ngcontent-%COMP%]{font-size:var(--mon-select-small-size);margin-bottom:5px}[_nghost-%COMP%]   .hiddenLabel[_ngcontent-%COMP%]{width:0;height:0;position:absolute;overflow:hidden;opacity:0}[_nghost-%COMP%]   .option[_ngcontent-%COMP%]{font-size:var(--mon-select-small-size);color:var(--mon-select-option-color);cursor:pointer;padding:5px 20px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}[_nghost-%COMP%]   .option[_ngcontent-%COMP%]:hover, [_nghost-%COMP%]   .hovered[_ngcontent-%COMP%]{color:#fff;background:var(--mon-select-option-color)}[_nghost-%COMP%]   .no-result[_ngcontent-%COMP%]{color:var(--mon-select-option-color);padding:5px 20px}[_nghost-%COMP%]   .current-value-box[_ngcontent-%COMP%]{font-size:var(--mon-select-small-size);border-radius:4px;padding:5px 10px;cursor:pointer;display:flex;justify-content:space-between;align-items:center}[_nghost-%COMP%]   .placeholder-text[_ngcontent-%COMP%]{font-size:var(--mon-select-small-size);color:var(--mon-select-placeholder-text-color)}[_nghost-%COMP%]   .button[_ngcontent-%COMP%]{font-size:var(--mon-select-small-size);width:var(--mon-select-button-width);border-radius:0 4px 4px 0;background-image:var(--mon-select-button-background);border:none;outline:none}[_nghost-%COMP%]   .button[_ngcontent-%COMP%]:focus-visible{box-shadow:var(--mon-select-focus-visible)}[_nghost-%COMP%]   .button.opened[_ngcontent-%COMP%]{background:#fff none}[_nghost-%COMP%]   .button[disabled][_ngcontent-%COMP%]{cursor:not-allowed}[_nghost-%COMP%]   .small[_ngcontent-%COMP%]{min-height:30px;color:#000}[_nghost-%COMP%]   .medium[_ngcontent-%COMP%]{min-height:32px;color:#000}[_nghost-%COMP%]   .large[_ngcontent-%COMP%]{min-height:34px;color:#000}[_nghost-%COMP%]   .current-value-box[_ngcontent-%COMP%]:focus-visible{box-shadow:var(--mon-select-focus-visible)}[_nghost-%COMP%]   .current-value-box.disabled[_ngcontent-%COMP%]{box-shadow:none;border:var(--mon-select-current-value-box-border);cursor:not-allowed}[_nghost-%COMP%]   .current-value-box.disabled[_ngcontent-%COMP%]:after{content:\"\";position:absolute;width:100%;height:100%;top:0;left:0;background-color:var(--mon-select-disabled-bg-color);opacity:.6}[_nghost-%COMP%]   .listbox[_ngcontent-%COMP%]{background:#fff;position:absolute;width:100%;border-radius:4px;border:var(--mon-select-listbox-border);padding:5px 0;max-height:200px;z-index:3;overflow:auto;top:100%}[_nghost-%COMP%]   .search-input[_ngcontent-%COMP%]{border:0;font-size:var(--mon-select-small-size)}[_nghost-%COMP%]   .transparent[_ngcontent-%COMP%]{background:transparent;color:transparent}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SelectNextAcComponent, [{
        type: Component,
        args: [{ selector: 'mon-select-ac-next', providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => SelectNextAcComponent),
                        multi: true,
                    }], imports: [
                    CommonModule,
                    IconsModule,
                    NgClickOutsideDirective,
                    TranslateModule,
                ], standalone: true, template: "<label *ngIf=\"!monId\" class=\"label\" [class.hiddenLabel]=\"hideLabel\" [attr.id]=\"labelId\">{{label}}{{required ? ' *' : ''}}</label>\n<div [delayClickOutsideInit]=\"true\" (clickOutside)=\"clickOutsideHandler($event)\" class=\"select-container\" [class.disabled]=\"disabled\" [class]=\"size\" [class.focused]=\"focused || opened.value\">\n    <input\n        #searchField\n        class=\"search-field\"\n        [class.closed]=\"!opened.value && !focused\"\n        [disabled]=\"disabled\"\n        [class]=\"size\"\n        [attr.id]=\"searchFieldId\"\n        (focus)=\"onFocus()\"\n        (blur)=\"onBlur()\"\n        (input)=\"handleInputWithSearch($event)\"\n        (click)=\"open()\"\n        [attr.aria-controls]=\"listboxId\"\n        [attr.aria-required]=\"required\"\n        [required]=\"required\"\n        [placeholder]=\"placeholder || ''\"\n        [value]=\"value?.name\"\n        [attr.aria-labelledby]=\"labelId\"\n        [attr.aria-haspopup]=\"true\"\n        [attr.aria-expanded]=\"opened.value ? 'true' : 'false'\"\n        [attr.aria-autocomplete]=\"'list'\"\n        role=\"combobox\"\n        (keydown)=\"handleKeyboard($event)\" />\n    <button *ngIf=\"(allowClear && !getSingleValue()) || !allowClear\"\n            (click)=\"open($event)\"\n            [tabIndex]=\"-1\"\n            [attr.aria-hidden]=\"true\"\n            [class]=\"size\"\n            [class.opened]=\"opened.value || focused\"\n            [disabled]=\"disabled\"\n            class=\"button\">\n        <mon-icon *ngIf=\"!opened.value && !focused\" monIconDirect=\"faCaretDown\"></mon-icon>\n    </button>\n    <button\n        (click)=\"clear()\"\n        (keydown)=\"clear($event)\"\n        *ngIf=\"getSingleValue() && allowClear\"\n        [class.opened]=\"opened.value || focused\"\n        class=\"button\"\n        [attr.aria-label]=\"'Clear the field' | translate\"\n        [disabled]=\"disabled\"\n    >\n            <span class=\"clear-icon\">\n                <mon-icon\n                    monIconDirect=\"faTimes\"\n                ></mon-icon>\n            </span>\n    </button>\n\n    <div\n        class=\"listbox\"\n        role=\"listbox\"\n        *ngIf=\"opened.value\"\n        [attr.id]=\"listboxId\"\n        [attr.aria-describedby]=\"describedBy\"\n        [attr.aria-labelledby]=\"labelId\"\n    >\n        <div tabindex=\"-1\" class=\"no-result\" *ngIf=\"filteredOptions.length === 0\">{{'No results found' | translate}}</div>\n        <div\n            role=\"option\"\n            #optionsList\n            class=\"option\"\n            [attr.aria-selected]=\"currentIndex === i\"\n            [attr.id]=\"option.id\"\n            *ngFor=\"let option of filteredOptions; let i = index\"\n            [class]=\"{hovered: i === visualFocusIndex}\"\n            (click)=\"selectOption(i)\"\n        >\n            {{option.name}}\n        </div>\n    </div>\n</div>\n", styles: [":host.ng-invalid.ng-dirty .select-container{border:1px solid #BA322D;box-shadow:none}:host{--mon-select-small-size: 12px;--mon-select-option-color: #255783;--mon-select-placeholder-text-color: #6c757d;--mon-select-value-box-basic-border-color: #adadad;--mon-select-value-box-focus-border-color: #86b7fe;--mon-select-value-box-focus-border-box-shadow: 0 0 0 .25rem rgba(13, 110, 253, .25);--mon-select-focus-visible: 0 0 0 2px #4976B9;--mon-select-listbox-border: 1px solid #cccccc;--mon-select-current-value-box-border: 1px solid #cccccc;--mon-select-clear-button-color: #595959;--mon-select-disabled-bg-color: #eceeef;--mon-select-button-background: linear-gradient(#fafafa, #eee);--mon-select-button-width: 28px}:host .select-container{position:relative;display:flex;border:var(--mon-select-current-value-box-border);border-radius:4px}:host .select-container:hover:not(.disabled){border:1px solid var(--mon-select-value-box-basic-border-color)}:host .select-container.disabled{cursor:not-allowed;box-shadow:none}:host .closed{background-image:var(--mon-select-button-background)}:host .search-field{width:calc(100% - var(--mon-select-button-width));padding:4px 10px;cursor:pointer;height:100%;outline:none;border:none;border-radius:4px 0 0 4px}:host .search-field[disabled]{cursor:not-allowed;color:#0006}:host .focused{box-shadow:var(--mon-select-value-box-focus-border-box-shadow);border-radius:4px;border:1px solid var(--mon-select-value-box-focus-border-color)}:host .disabled{cursor:not-allowed}:host .clear-icon{position:relative;top:1px}:host .label{font-size:var(--mon-select-small-size);margin-bottom:5px}:host .hiddenLabel{width:0;height:0;position:absolute;overflow:hidden;opacity:0}:host .option{font-size:var(--mon-select-small-size);color:var(--mon-select-option-color);cursor:pointer;padding:5px 20px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}:host .option:hover,:host .hovered{color:#fff;background:var(--mon-select-option-color)}:host .no-result{color:var(--mon-select-option-color);padding:5px 20px}:host .current-value-box{font-size:var(--mon-select-small-size);border-radius:4px;padding:5px 10px;cursor:pointer;display:flex;justify-content:space-between;align-items:center}:host .placeholder-text{font-size:var(--mon-select-small-size);color:var(--mon-select-placeholder-text-color)}:host .button{font-size:var(--mon-select-small-size);width:var(--mon-select-button-width);border-radius:0 4px 4px 0;background-image:var(--mon-select-button-background);border:none;outline:none}:host .button:focus-visible{box-shadow:var(--mon-select-focus-visible)}:host .button.opened{background:#fff none}:host .button[disabled]{cursor:not-allowed}:host .small{min-height:30px;color:#000}:host .medium{min-height:32px;color:#000}:host .large{min-height:34px;color:#000}:host .current-value-box:focus-visible{box-shadow:var(--mon-select-focus-visible)}:host .current-value-box.disabled{box-shadow:none;border:var(--mon-select-current-value-box-border);cursor:not-allowed}:host .current-value-box.disabled:after{content:\"\";position:absolute;width:100%;height:100%;top:0;left:0;background-color:var(--mon-select-disabled-bg-color);opacity:.6}:host .listbox{background:#fff;position:absolute;width:100%;border-radius:4px;border:var(--mon-select-listbox-border);padding:5px 0;max-height:200px;z-index:3;overflow:auto;top:100%}:host .search-input{border:0;font-size:var(--mon-select-small-size)}:host .transparent{background:transparent;color:transparent}\n"] }]
    }], () => [{ type: SearchService }], { nativeOptionsList: [{
            type: ViewChildren,
            args: ['optionsList']
        }], searchFieldElement: [{
            type: ViewChild,
            args: ['searchField']
        }], options: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], label: [{
            type: Input
        }], hideLabel: [{
            type: Input
        }], size: [{
            type: Input
        }], allowClear: [{
            type: Input
        }], describedBy: [{
            type: Input
        }], monId: [{
            type: Input
        }], _value: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(SelectNextAcComponent, { className: "SelectNextAcComponent" }); })();

class FormsBuilderModule {
    static { this.ɵfac = function FormsBuilderModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FormsBuilderModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: FormsBuilderModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [FormsModule,
            CommonModule,
            DatepickerModule,
            DatepickerAcModule,
            FormBuilderInputModule,
            FormBuilderSelectModule,
            FormBuilderSelectAcModule,
            FormBuilderCheckboxModule,
            RemovePlaceholderModule,
            TableSearchModule,
            FormBuilderDynamicModule,
            MonSwitchModule,
            TextareaModule,
            TextareaAcModule,
            FormBuilderValidationModule,
            RadioNewLineModule,
            RadioNewLineAcModule,
            SelectNextComponent,
            MultiselectNextComponent,
            SelectNextAcComponent, FormsModule,
            CommonModule,
            DatepickerModule,
            DatepickerAcModule,
            FormBuilderInputModule,
            FormBuilderSelectModule,
            FormBuilderSelectAcModule,
            FormBuilderCheckboxModule,
            RemovePlaceholderModule,
            TableSearchModule,
            FormBuilderDynamicModule,
            MonSwitchModule,
            TextareaModule,
            TextareaAcModule,
            FormBuilderValidationModule,
            RadioNewLineModule,
            RadioNewLineAcModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormsBuilderModule, [{
        type: NgModule,
        args: [{
                imports: [
                    FormsModule,
                    CommonModule,
                    DatepickerModule,
                    DatepickerAcModule,
                    FormBuilderInputModule,
                    FormBuilderSelectModule,
                    FormBuilderSelectAcModule,
                    FormBuilderCheckboxModule,
                    RemovePlaceholderModule,
                    TableSearchModule,
                    FormBuilderDynamicModule,
                    MonSwitchModule,
                    TextareaModule,
                    TextareaAcModule,
                    FormBuilderValidationModule,
                    RadioNewLineModule,
                    RadioNewLineAcModule,
                    SelectNextComponent,
                    MultiselectNextComponent,
                    SelectNextAcComponent,
                ],
                exports: [
                    FormsModule,
                    CommonModule,
                    DatepickerModule,
                    DatepickerAcModule,
                    FormBuilderInputModule,
                    FormBuilderSelectModule,
                    FormBuilderSelectAcModule,
                    FormBuilderCheckboxModule,
                    RemovePlaceholderModule,
                    TableSearchModule,
                    FormBuilderDynamicModule,
                    MonSwitchModule,
                    TextareaModule,
                    TextareaAcModule,
                    FormBuilderValidationModule,
                    RadioNewLineModule,
                    RadioNewLineAcModule,
                    SelectNextComponent,
                    MultiselectNextComponent,
                    SelectNextAcComponent,
                ],
                providers: [],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(FormsBuilderModule, { imports: [FormsModule,
        CommonModule,
        DatepickerModule,
        DatepickerAcModule,
        FormBuilderInputModule,
        FormBuilderSelectModule,
        FormBuilderSelectAcModule,
        FormBuilderCheckboxModule,
        RemovePlaceholderModule,
        TableSearchModule,
        FormBuilderDynamicModule,
        MonSwitchModule,
        TextareaModule,
        TextareaAcModule,
        FormBuilderValidationModule,
        RadioNewLineModule,
        RadioNewLineAcModule,
        SelectNextComponent,
        MultiselectNextComponent,
        SelectNextAcComponent], exports: [FormsModule,
        CommonModule,
        DatepickerModule,
        DatepickerAcModule,
        FormBuilderInputModule,
        FormBuilderSelectModule,
        FormBuilderSelectAcModule,
        FormBuilderCheckboxModule,
        RemovePlaceholderModule,
        TableSearchModule,
        FormBuilderDynamicModule,
        MonSwitchModule,
        TextareaModule,
        TextareaAcModule,
        FormBuilderValidationModule,
        RadioNewLineModule,
        RadioNewLineAcModule,
        SelectNextComponent,
        MultiselectNextComponent,
        SelectNextAcComponent] }); })();

class PromptDirective {
    constructor(monPromptService) {
        this.monPromptService = monPromptService;
        this.monPromptAction = new EventEmitter();
    }
    async go(event) {
        event.preventDefault();
        return this.monPromptService.prompt(this.monPrompt, this.monPromptOptions)
            .then(result => this.monPromptAction.emit(result))
            .catch(() => { });
    }
    static { this.ɵfac = function PromptDirective_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PromptDirective)(i0.ɵɵdirectiveInject(MonPromptService)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: PromptDirective, selectors: [["", "monPrompt", ""]], hostBindings: function PromptDirective_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("click", function PromptDirective_click_HostBindingHandler($event) { return ctx.go($event); });
        } }, inputs: { monPrompt: "monPrompt", monPromptOptions: "monPromptOptions" }, outputs: { monPromptAction: "monPromptAction" } }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PromptDirective, [{
        type: Directive,
        args: [{ selector: '[monPrompt]' }]
    }], () => [{ type: MonPromptService }], { monPrompt: [{
            type: Input
        }], monPromptOptions: [{
            type: Input
        }], monPromptAction: [{
            type: Output
        }], go: [{
            type: HostListener,
            args: ['click', ['$event']]
        }] }); })();

class PromptModule {
    static { this.ɵfac = function PromptModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PromptModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: PromptModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({}); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PromptModule, [{
        type: NgModule,
        args: [{
                imports: [],
                exports: [PromptDirective],
                declarations: [PromptDirective],
                providers: [],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(PromptModule, { declarations: [PromptDirective], exports: [PromptDirective] }); })();

/**
 *
 * @deprecated Use mon-services repo instead.
 */
class EventsService {
    constructor() {
        this.internalIds = 0;
        this.listeners = {};
    }
    addListener(type, fn) {
        if (this.listeners[type]) {
            this.listeners[type].push({ id: this.internalIds, fn });
        }
        else {
            this.listeners[type] = [{ id: this.internalIds, fn }];
        }
        this.internalIds++;
        return this.internalIds - 1;
    }
    remove(id) {
        for (const key in this.listeners) {
            if (this.listeners[key]) {
                for (let u = 0; u < this.listeners[key].length; u++) {
                    if (this.listeners[key][u] &&
                        id === this.listeners[key][u].id) {
                        this.listeners[key].splice(u, 1);
                    }
                }
            }
        }
    }
    run(...args) {
        const type = args[0];
        args.shift();
        if (this.listeners[type]) {
            return this.runEvent(this.listeners[type], args);
        }
        return Promise.resolve();
    }
    runEvent(listeners, params) {
        const promises = [];
        let fn;
        for (const listener of listeners) {
            if (listener !== undefined) {
                fn = listener.fn;
                promises.push(fn.apply(fn, params));
            }
        }
        return Promise.all(promises);
    }
    static { this.ɵfac = function EventsService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || EventsService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: EventsService, factory: EventsService.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EventsService, [{
        type: Injectable
    }], () => [], null); })();

/**
 *
 * @deprecated Use mon-services repo instead.
 */
class MonEventService {
    constructor() {
        this.monEvents = MonEventsServiceFactory();
    }
    addListener(type, fn) {
        this.monEvents.addListener(type, fn);
    }
    run(...args) {
        this.monEvents.run(args);
    }
    remove(id) {
        if (id != null && this.monEvents) {
            this.monEvents.remove(id);
        }
    }
    static { this.ɵfac = function MonEventService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MonEventService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MonEventService, factory: MonEventService.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MonEventService, [{
        type: Injectable
    }], null, null); })();

class EventsModule {
    static { this.ɵfac = function EventsModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || EventsModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: EventsModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [
            EventsService,
            {
                provide: MonEventServiceInjectionToken,
                // Replace with MockMonEventService
                // When these 2 tasks are released https://acquia.atlassian.net/browse/MON-7612?jql=issueKey%20in%20(MON-7611%2CMON-7612)
                useClass: MonEventService,
            },
        ] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EventsModule, [{
        type: NgModule,
        args: [{
                providers: [
                    EventsService,
                    {
                        provide: MonEventServiceInjectionToken,
                        // Replace with MockMonEventService
                        // When these 2 tasks are released https://acquia.atlassian.net/browse/MON-7612?jql=issueKey%20in%20(MON-7611%2CMON-7612)
                        useClass: MonEventService,
                    },
                ],
            }]
    }], null, null); })();

class MonEventTriggerModule {
    static { this.ɵfac = function MonEventTriggerModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MonEventTriggerModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: MonEventTriggerModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [EventsModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MonEventTriggerModule, [{
        type: NgModule,
        args: [{
                imports: [
                    EventsModule,
                ],
                declarations: [EventTriggerDirective],
                exports: [
                    EventTriggerDirective,
                ],
                providers: [],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(MonEventTriggerModule, { declarations: [EventTriggerDirective], imports: [EventsModule], exports: [EventTriggerDirective] }); })();

class ColorPickerModule {
    static { this.ɵfac = function ColorPickerModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ColorPickerModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ColorPickerModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, ColorChromeModule, FormsModule, TranslateModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ColorPickerModule, [{
        type: NgModule,
        args: [{
                declarations: [ColorPickerComponent],
                imports: [CommonModule, ColorChromeModule, FormsModule, TranslateModule],
                exports: [ColorPickerComponent],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ColorPickerModule, { declarations: [ColorPickerComponent], imports: [CommonModule, ColorChromeModule, FormsModule, TranslateModule], exports: [ColorPickerComponent] }); })();

/**
 * Currently this class is used by SessionStorageService and LocalStorageService which are singletons
 */
class MonStorage {
    /**
     * property that returns the number of items stored
     */
    get length() {
        return this.tempStorage.length;
    }
    constructor() {
        this.tempStorage = {};
    }
    getItem(key) {
        return this.tempStorage[key]
            ? this.tempStorage[key]
            : null;
    }
    setItem(key, data) {
        this.tempStorage[key] = data;
    }
    key(index) {
        return Object.keys(this.tempStorage)[index]
            ? Object.keys(this.tempStorage)[index]
            : null;
    }
    clear() {
        for (const key in this.tempStorage) {
            if (this.tempStorage.hasOwnProperty(key)) {
                delete this.tempStorage[key];
            }
        }
    }
    removeItem(key) {
        if (this.tempStorage[key]) {
            delete this.tempStorage[key];
        }
    }
}

class LocalStorageService {
    get length() {
        return this.tempStorage.length;
    }
    constructor() {
        try {
            // trying to see if we have access to window.localStorage
            this.tempStorage = window.localStorage;
        }
        catch (e) {
            // otherwise create a local object that implements Storage interface
            this.tempStorage = new MonStorage();
        }
    }
    getItem(key) {
        return this.tempStorage.getItem(key);
    }
    setItem(key, data) {
        this.tempStorage.setItem(key, data);
    }
    key(index) {
        return this.tempStorage.key(index);
    }
    clear() {
        this.tempStorage.clear();
    }
    removeItem(key) {
        this.tempStorage.removeItem(key);
    }
    static { this.ɵfac = function LocalStorageService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || LocalStorageService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: LocalStorageService, factory: LocalStorageService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LocalStorageService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], () => [], null); })();

class SessionStorageService {
    get length() {
        return this.tempStorage.length;
    }
    constructor() {
        try {
            // trying to see if we have access to window.sessionStorage
            this.tempStorage = window.sessionStorage;
        }
        catch (e) {
            // otherwise create a local object that implements Storage interface
            this.tempStorage = new MonStorage();
        }
    }
    // we do not know what kind of object we will store here; unknown does not work as expected
    // eslint-disable-next-line
    getItem(key) {
        try {
            return JSON.parse(this.tempStorage.getItem(key));
        }
        catch (e) {
            throw new Error(`Could not parse ${this.tempStorage.getItem(key)}; \n Error: ${e}`);
        }
    }
    setItem(key, data) {
        try {
            this.tempStorage.setItem(key, JSON.stringify(data));
        }
        catch (e) {
            throw new Error(`Could not stringify ${data}; \n Error: ${e}`);
        }
    }
    removeItem(key) {
        this.tempStorage.removeItem(key);
    }
    clear() {
        this.tempStorage.clear();
    }
    key(index) {
        return this.tempStorage.key(index);
    }
    static { this.ɵfac = function SessionStorageService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SessionStorageService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SessionStorageService, factory: SessionStorageService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SessionStorageService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], () => [], null); })();

class StorageModule {
    static { this.ɵfac = function StorageModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || StorageModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: StorageModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [LocalStorageService, SessionStorageService] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StorageModule, [{
        type: NgModule,
        args: [{
                imports: [],
                exports: [],
                declarations: [],
                providers: [LocalStorageService, SessionStorageService],
            }]
    }], null, null); })();

const _c0$b = ["monTableSort", ""];
const _c1$3 = ["*"];
function MonTableSortComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 6);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r0.monTooltipClass);
    i0.ɵɵproperty("ngbTooltip", ctx_r0.monTooltipText);
} }
function MonTableSortComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 7);
} }
function MonTableSortComponent_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 8);
} }
function MonTableSortComponent_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 9);
} }
class MonTableSortComponent {
    constructor(translateService) {
        this.translateService = translateService;
        this.monThTitle = '';
        this.monStartAsc = false;
        this.monDescription = this.translateService.getString('Sort column');
        // former "getItems"
        this.monOnSorted = new EventEmitter();
        this.customId = 'mon-sort-' + (Math.random() + 1).toString(36).substring(7);
        this.constant = {
            asc: 'asc',
            desc: 'desc',
        };
        this.clickHandler = () => {
            if (this.monCurrentlySortedBy === this.monSortBy) {
                if (this.monSortDirection === this.constant.asc) {
                    if (this.monStartAsc) {
                        this.descending();
                    }
                    else {
                        this.deactivate();
                    }
                }
                else {
                    if (this.monStartAsc) {
                        this.deactivate();
                    }
                    else {
                        this.ascending();
                    }
                }
            }
            else {
                this.activate();
            }
        };
    }
    ngOnInit() {
        if (this.monCurrentlySortedBy === this.monSortBy) {
            this.activate();
        }
        this.update();
    }
    ngOnChanges() {
        this.update();
    }
    activate() {
        if (this.monStartAsc) {
            this.ascending();
        }
        else {
            this.descending();
        }
    }
    deactivate() {
        this.onGetItems(null, null);
    }
    ascending() {
        this.onGetItems(this.constant.asc, this.monSortBy);
    }
    descending() {
        this.onGetItems(this.constant.desc, this.monSortBy);
    }
    onGetItems(direction, by) {
        this.monSortDirection = direction;
        this.monOnSorted.emit({ direction, by });
        this.update();
    }
    update() {
        if (this.monCurrentlySortedBy === this.monSortBy) {
            if (this.monSortDirection === this.constant.asc) {
                this.monDescription = this.translateService.getString('Sort column ascending');
            }
            else if (this.monSortDirection === this.constant.desc) {
                this.monDescription = this.translateService.getString('Sort column descending');
            }
            else {
                this.monDescription = this.translateService.getString('Sort column');
            }
        }
    }
    static { this.ɵfac = function MonTableSortComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MonTableSortComponent)(i0.ɵɵdirectiveInject(TranslateServiceInjectionToken)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MonTableSortComponent, selectors: [["", "monTableSort", ""]], inputs: { monThTitle: "monThTitle", monSortBy: "monSortBy", monSortDirection: "monSortDirection", monStartAsc: "monStartAsc", monTooltipClass: "monTooltipClass", monTooltipText: "monTooltipText", monDescription: "monDescription", monCurrentlySortedBy: "monCurrentlySortedBy" }, outputs: { monOnSorted: "monOnSorted" }, features: [i0.ɵɵNgOnChangesFeature], attrs: _c0$b, ngContentSelectors: _c1$3, decls: 9, vars: 8, consts: [[1, "sort", 3, "click"], ["class", "ml-1", "aria-hidden", "true", "tooltip-trigger", "focus mouseenter", 3, "class", "ngbTooltip", 4, "ngIf"], ["class", "inner-l-smurf fas fa-sort", 4, "ngIf"], ["class", "inner-l-smurf fas fa-sort-up", 4, "ngIf"], ["class", "inner-l-smurf fas fa-sort-down", 4, "ngIf"], [1, "sr-only", 3, "id"], ["aria-hidden", "true", "tooltip-trigger", "focus mouseenter", 1, "ml-1", 3, "ngbTooltip"], [1, "inner-l-smurf", "fas", "fa-sort"], [1, "inner-l-smurf", "fas", "fa-sort-up"], [1, "inner-l-smurf", "fas", "fa-sort-down"]], template: function MonTableSortComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "button", 0);
            i0.ɵɵlistener("click", function MonTableSortComponent_Template_button_click_0_listener() { return ctx.clickHandler(); });
            i0.ɵɵtext(1);
            i0.ɵɵprojection(2);
            i0.ɵɵtemplate(3, MonTableSortComponent_span_3_Template, 1, 4, "span", 1)(4, MonTableSortComponent_span_4_Template, 1, 0, "span", 2)(5, MonTableSortComponent_span_5_Template, 1, 0, "span", 3)(6, MonTableSortComponent_span_6_Template, 1, 0, "span", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "span", 5);
            i0.ɵɵtext(8);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵattribute("aria-describedby", ctx.customId);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", ctx.monThTitle, " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.monTooltipClass && ctx.monTooltipText);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.monCurrentlySortedBy !== ctx.monSortBy);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.monCurrentlySortedBy === ctx.monSortBy && ctx.monSortDirection === ctx.constant.asc);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.monCurrentlySortedBy === ctx.monSortBy && ctx.monSortDirection === ctx.constant.desc);
            i0.ɵɵadvance();
            i0.ɵɵpropertyInterpolate("id", ctx.customId);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.monDescription);
        } }, dependencies: [i1$4.NgbTooltip, i1$2.NgIf], styles: [".fw-bold[_nghost-%COMP%]   button[_ngcontent-%COMP%], .fw-bold   [_nghost-%COMP%]   button[_ngcontent-%COMP%]{font-weight:700}button.sort[_ngcontent-%COMP%]{background-color:transparent;border:0;padding:0}button.sort[_ngcontent-%COMP%]:focus-visible{outline:none;box-shadow:0 0 0 1px #4976b9}"], changeDetection: 0 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MonTableSortComponent, [{
        type: Component,
        args: [{ selector: '[monTableSort]', changeDetection: ChangeDetectionStrategy.OnPush, template: "<button (click)=\"this.clickHandler()\" attr.aria-describedby=\"{{this.customId}}\" class=\"sort\">\n    {{this.monThTitle}}\n    <ng-content></ng-content>\n    <span *ngIf=\"this.monTooltipClass && this.monTooltipText\" class=\"ml-1\" class=\"{{this.monTooltipClass}}\" aria-hidden=\"true\" [ngbTooltip]=\"this.monTooltipText\" tooltip-trigger=\"focus mouseenter\"></span>\n    <span class=\"inner-l-smurf fas fa-sort\" *ngIf=\"this.monCurrentlySortedBy !== this.monSortBy\"></span>\n    <span class=\"inner-l-smurf fas fa-sort-up\" *ngIf=\"this.monCurrentlySortedBy === this.monSortBy && this.monSortDirection === this.constant.asc\"></span>\n    <span class=\"inner-l-smurf fas fa-sort-down\" *ngIf=\"this.monCurrentlySortedBy === this.monSortBy && this.monSortDirection === this.constant.desc\"></span>\n</button>\n<span id=\"{{this.customId}}\" class=\"sr-only\">{{this.monDescription}}</span>\n", styles: [":host-context(.fw-bold) button{font-weight:700}button.sort{background-color:transparent;border:0;padding:0}button.sort:focus-visible{outline:none;box-shadow:0 0 0 1px #4976b9}\n"] }]
    }], () => [{ type: undefined, decorators: [{
                type: Inject,
                args: [TranslateServiceInjectionToken]
            }] }], { monThTitle: [{
            type: Input
        }], monSortBy: [{
            type: Input
        }], monSortDirection: [{
            type: Input
        }], monStartAsc: [{
            type: Input
        }], monTooltipClass: [{
            type: Input
        }], monTooltipText: [{
            type: Input
        }], monDescription: [{
            type: Input
        }], monCurrentlySortedBy: [{
            type: Input
        }], monOnSorted: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(MonTableSortComponent, { className: "MonTableSortComponent" }); })();

class MonTableSortModule {
    static { this.ɵfac = function MonTableSortModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MonTableSortModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: MonTableSortModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [NgbTooltipModule, BrowserModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MonTableSortModule, [{
        type: NgModule,
        args: [{
                imports: [NgbTooltipModule, BrowserModule],
                exports: [MonTableSortComponent],
                declarations: [MonTableSortComponent],
                providers: [],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(MonTableSortModule, { declarations: [MonTableSortComponent], imports: [NgbTooltipModule, BrowserModule], exports: [MonTableSortComponent] }); })();

class FormLabelModule {
    static { this.ɵfac = function FormLabelModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FormLabelModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: FormLabelModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [LayoutModule,
            FormsBuilderModule,
            ColorPickerModule,
            PipesModule,
            MonEventTriggerModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormLabelModule, [{
        type: NgModule,
        args: [{
                imports: [
                    LayoutModule,
                    FormsBuilderModule,
                    ColorPickerModule,
                    PipesModule,
                    MonEventTriggerModule,
                ],
                exports: [FormLabelComponent],
                declarations: [FormLabelComponent],
                providers: [],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(FormLabelModule, { declarations: [FormLabelComponent], imports: [LayoutModule,
        FormsBuilderModule,
        ColorPickerModule,
        PipesModule,
        MonEventTriggerModule], exports: [FormLabelComponent] }); })();

class MonSelectAllCheckboxDirective {
    constructor(element) {
        this.element = element;
    }
    go(event) {
        const element = this.element.nativeElement;
        const target = event?.target;
        if (target.type === 'checkbox') {
            let iterateEl = event.target;
            let uncheckedFields = [];
            let isHeaderCheckbox;
            let headerCheckbox;
            const checkboxes = [];
            do {
                iterateEl = iterateEl.parentNode;
                isHeaderCheckbox = iterateEl.nodeName === 'TH';
            } while (typeof iterateEl.cellIndex === 'undefined');
            const tableCell = iterateEl;
            const tableCells = element.querySelectorAll('tbody td');
            tableCells.forEach((el) => {
                if (el.cellIndex === tableCell.cellIndex) {
                    const inputWithoutDisabledEl = el.querySelector('input[type="checkbox"]:not(:disabled)');
                    if (inputWithoutDisabledEl) {
                        checkboxes.push(inputWithoutDisabledEl);
                    }
                }
            });
            if (isHeaderCheckbox) {
                checkboxes.forEach(el => {
                    if (el.checked !== target.checked) {
                        el.click();
                    }
                });
            }
            else {
                uncheckedFields = checkboxes.filter(el => !el.checked);
                headerCheckbox = element.querySelector(`th:nth-child(${tableCell.cellIndex + 1}) input[type="checkbox"]`);
                if (uncheckedFields.length === 0) {
                    headerCheckbox.checked = true;
                    headerCheckbox.indeterminate = false;
                }
                else if (uncheckedFields.length > 0 && uncheckedFields.length < checkboxes.length) {
                    headerCheckbox.indeterminate = true;
                }
                else {
                    headerCheckbox.checked = false;
                    headerCheckbox.indeterminate = false;
                }
            }
        }
    }
    static { this.ɵfac = function MonSelectAllCheckboxDirective_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MonSelectAllCheckboxDirective)(i0.ɵɵdirectiveInject(i0.ElementRef)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: MonSelectAllCheckboxDirective, selectors: [["", "monSelectAllCheckbox", ""]], hostBindings: function MonSelectAllCheckboxDirective_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("click", function MonSelectAllCheckboxDirective_click_HostBindingHandler($event) { return ctx.go($event); });
        } } }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MonSelectAllCheckboxDirective, [{
        type: Directive,
        args: [{ selector: '[monSelectAllCheckbox]' }]
    }], () => [{ type: i0.ElementRef }], { go: [{
            type: HostListener,
            args: ['click', ['$event']]
        }] }); })();

class MonSelectAllCheckboxModule {
    static { this.ɵfac = function MonSelectAllCheckboxModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MonSelectAllCheckboxModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: MonSelectAllCheckboxModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({}); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MonSelectAllCheckboxModule, [{
        type: NgModule,
        args: [{
                imports: [],
                exports: [MonSelectAllCheckboxDirective],
                declarations: [MonSelectAllCheckboxDirective],
                providers: [],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(MonSelectAllCheckboxModule, { declarations: [MonSelectAllCheckboxDirective], exports: [MonSelectAllCheckboxDirective] }); })();

class MonHttpPrefixDirective {
    onChange(evt) {
        const el = evt.target;
        if (el?.tagName !== 'INPUT' || el?.type !== 'text') {
            return;
        }
        const { value } = el;
        if (!value) {
            return;
        }
        const prefix = 'http';
        let matchPrefixPattern = true;
        const iterationLength = value.length > prefix.length ? prefix.length : value.length;
        for (let i = 0; i < iterationLength; i++) {
            if (value[i] !== prefix[i]) {
                matchPrefixPattern = false;
                break;
            }
        }
        if (!matchPrefixPattern) {
            el.value = `http://${value}`;
        }
        else {
            el.value = value;
        }
    }
    static { this.ɵfac = function MonHttpPrefixDirective_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MonHttpPrefixDirective)(); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: MonHttpPrefixDirective, selectors: [["", "monHttpPrefix", ""]], hostBindings: function MonHttpPrefixDirective_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("keyup", function MonHttpPrefixDirective_keyup_HostBindingHandler($event) { return ctx.onChange($event); });
        } } }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MonHttpPrefixDirective, [{
        type: Directive,
        args: [{ selector: '[monHttpPrefix]' }]
    }], null, { onChange: [{
            type: HostListener,
            args: ['keyup', ['$event']]
        }] }); })();

class MonHttpPrefixModule {
    static { this.ɵfac = function MonHttpPrefixModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MonHttpPrefixModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: MonHttpPrefixModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({}); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MonHttpPrefixModule, [{
        type: NgModule,
        args: [{
                imports: [],
                exports: [MonHttpPrefixDirective],
                declarations: [MonHttpPrefixDirective],
                providers: [],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(MonHttpPrefixModule, { declarations: [MonHttpPrefixDirective], exports: [MonHttpPrefixDirective] }); })();

class MonChartCustomTooltipDirective {
    constructor(el, renderer) {
        this.el = el;
        this.renderer = renderer;
        this.monTooltipOffsetY = 0;
        this.monTooltipOffsetX = 0;
    }
    ngOnInit() {
        this.tooltipModel$ = this.tooltipModel.asObservable();
        this.tooltipModel$.subscribe((changedTooltipModel) => {
            if (!changedTooltipModel) {
                return;
            }
            this._tooltipModel = changedTooltipModel;
            this.createTooltip();
            if (this._tooltipModel.opacity === 0) {
                this.renderer.setStyle(this.tooltip, 'opacity', 0);
                this.renderer.setAttribute(this.tooltip, 'hidden', '');
                this.renderer.setAttribute(this.tooltip, 'aria-hidden', 'true');
                return;
            }
            this.setStyle();
            if (this._tooltipModel.body) {
                this.setTooltipBody(this._tooltipModel);
            }
            this.setPosition();
        });
    }
    createTooltip() {
        if (!this.tooltip) {
            this.tooltip = this.renderer.createElement('div');
            this.table = this.renderer.createElement('table');
            this.renderer.setAttribute(this.tooltip, 'role', 'tooltip');
            this.renderer.addClass(this.tooltip, 'mon-tooltip');
            this.renderer.appendChild(this.tooltip, this.table);
            this.renderer.appendChild(this.el.nativeElement, this.tooltip);
        }
    }
    setTooltipBody(tooltipModel) {
        const titleLines = tooltipModel.title || [];
        const bodyLines = tooltipModel.body.map((b) => b.lines);
        const [thead, tbody] = ['thead', 'tbody'].map((el) => this.renderer.createElement(el));
        titleLines.forEach(title => {
            const text = this.renderer.createText(title);
            const [th, tr] = ['th', 'tr'].map((el) => this.renderer.createElement(el));
            this.renderer.appendChild(th, text);
            this.renderer.appendChild(tr, th);
            this.renderer.appendChild(thead, tr);
        });
        bodyLines.forEach((body, i) => {
            const { backgroundColor, borderColor } = tooltipModel.labelColors[i];
            const [span, tr, td] = ['span', 'tr', 'td'].map((el) => this.renderer.createElement(el));
            this.renderer.setStyle(span, 'background', backgroundColor);
            this.renderer.setStyle(span, 'border-color', borderColor);
            this.renderer.appendChild(td, span);
            body.forEach(part => {
                const textPart = this.renderer.createText(part);
                this.renderer.appendChild(td, textPart);
            });
            this.renderer.appendChild(tr, td);
            this.renderer.appendChild(tbody, tr);
        });
        this.removeTableChildren();
        this.renderer.appendChild(this.table, thead);
        this.renderer.appendChild(this.table, tbody);
    }
    setPosition() {
        let offsetLeft = 0;
        let offsetTop = 0;
        if (this.monTooltipChartRef?.chart?.canvas) {
            offsetLeft = this.monTooltipChartRef.chart.canvas.offsetLeft;
            offsetTop = this.monTooltipChartRef.chart.canvas.offsetTop;
        }
        const top = offsetTop + this.el.nativeElement.offsetTop + this._tooltipModel.caretY + this.monTooltipOffsetY + 'px';
        const left = offsetLeft + this.el.nativeElement.offsetLeft + this._tooltipModel.caretX + this.monTooltipOffsetX + 'px';
        const styles = {
            opacity: 1,
            left,
            top,
        };
        this.renderer.removeAttribute(this.tooltip, 'hidden');
        this.renderer.removeAttribute(this.tooltip, 'aria-hidden');
        for (const key of Object.keys(styles)) {
            this.renderer.setStyle(this.tooltip, key, styles[key]);
        }
    }
    setStyle() {
        ['above', 'below', 'no-transform'].forEach(cssClass => {
            this.renderer.removeClass(this.tooltip, cssClass);
        });
        if (this._tooltipModel.yAlign) {
            this.renderer.addClass(this.tooltip, this._tooltipModel.yAlign);
        }
        else {
            this.renderer.addClass(this.tooltip, 'no-transform');
        }
    }
    removeTableChildren() {
        this.table.innerHTML = '';
    }
    static { this.ɵfac = function MonChartCustomTooltipDirective_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MonChartCustomTooltipDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: MonChartCustomTooltipDirective, selectors: [["", "monTooltipModel", ""]], inputs: { tooltipModel: [0, "monTooltipModel", "tooltipModel"], monTooltipChartRef: "monTooltipChartRef", monTooltipOffsetY: "monTooltipOffsetY", monTooltipOffsetX: "monTooltipOffsetX" } }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MonChartCustomTooltipDirective, [{
        type: Directive,
        args: [{
                selector: '[monTooltipModel]',
            }]
    }], () => [{ type: i0.ElementRef }, { type: i0.Renderer2 }], { tooltipModel: [{
            type: Input,
            args: ['monTooltipModel']
        }], monTooltipChartRef: [{
            type: Input
        }], monTooltipOffsetY: [{
            type: Input
        }], monTooltipOffsetX: [{
            type: Input
        }] }); })();

class MonChartCustomTooltipModule {
    static { this.ɵfac = function MonChartCustomTooltipModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MonChartCustomTooltipModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: MonChartCustomTooltipModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MonChartCustomTooltipModule, [{
        type: NgModule,
        args: [{
                declarations: [MonChartCustomTooltipDirective],
                imports: [CommonModule],
                exports: [MonChartCustomTooltipDirective],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(MonChartCustomTooltipModule, { declarations: [MonChartCustomTooltipDirective], imports: [CommonModule], exports: [MonChartCustomTooltipDirective] }); })();

function SwitchButtonComponent_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 4);
    i0.ɵɵlistener("click", function SwitchButtonComponent_button_4_Template_button_click_0_listener() { const i_r2 = i0.ɵɵrestoreView(_r1).index; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.setFocus(i_r2)); })("keydown", function SwitchButtonComponent_button_4_Template_button_keydown_0_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.onKeydown($event)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r4 = ctx.$implicit;
    i0.ɵɵattribute("aria-checked", option_r4.selected)("tabindex", option_r4.selected ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", option_r4.value, " ");
} }
class SwitchButtonComponent extends BaseFieldComponent {
    constructor(elementRef) {
        super();
        this.elementRef = elementRef;
        this.options = [];
        this.label = 'Radio button group';
        this.defaultIndex = 0;
        this.onSelected = new EventEmitter();
        this.selectedIndex = 0;
        this.optionsDisplay = [];
    }
    ngOnInit() {
        this.selectedIndex = this.defaultIndex;
        this.initOptions(this.defaultIndex);
        this.buttonGroup = this.elementRef.nativeElement.querySelector('[role="radiogroup"]');
        this.labelId = this.getLabelForId(this.label);
    }
    ngOnChanges() {
        this.initOptions(this.defaultIndex);
    }
    onKeydown(event) {
        const arrowKeys = ['ArrowLeft', 'ArrowUp', 'ArrowRight', 'ArrowDown'];
        const key = event.key;
        if (arrowKeys.indexOf(key) > -1) {
            event.preventDefault();
            event.stopPropagation();
            switch (key) {
                case 'ArrowRight':
                case 'ArrowDown':
                    this.setFocusNext();
                    break;
                case 'ArrowLeft':
                case 'ArrowUp':
                    this.setFocusPrevious();
                    break;
                default:
                    break;
            }
        }
    }
    setFocus(index) {
        this.selectedIndex = index;
        this.selectNew(index);
        const button = this.buttonGroup.children.item(index);
        button.focus();
    }
    initOptions(selectedIndex) {
        this.optionsDisplay = this.options.map((option) => {
            return {
                value: option,
                selected: false,
            };
        });
        if (this.optionsDisplay.length > 0) {
            this.optionsDisplay[selectedIndex].selected = true;
        }
    }
    setFocusNext() {
        this.selectedIndex += 1;
        if (this.selectedIndex >= this.options.length) {
            this.selectedIndex = 0;
        }
        this.setFocus(this.selectedIndex);
    }
    setFocusPrevious() {
        this.selectedIndex -= 1;
        if (this.selectedIndex < 0) {
            this.selectedIndex = this.options.length - 1;
        }
        this.setFocus(this.selectedIndex);
    }
    selectNew(index) {
        this.optionsDisplay.forEach((option) => {
            option.selected = false;
        });
        this.optionsDisplay[index].selected = true;
        this.onSelected.emit(index);
    }
    static { this.ɵfac = function SwitchButtonComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SwitchButtonComponent)(i0.ɵɵdirectiveInject(i0.ElementRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SwitchButtonComponent, selectors: [["mon-switch-button"]], inputs: { options: "options", label: "label", defaultIndex: "defaultIndex" }, outputs: { onSelected: "onSelected" }, features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature], decls: 5, vars: 4, consts: [["translate", "", 1, "sr-only"], [1, "switch-button-container"], ["role", "radiogroup", 1, "btn-group"], ["role", "radio", 3, "click", "keydown", 4, "ngFor", "ngForOf"], ["role", "radio", 3, "click", "keydown"]], template: function SwitchButtonComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "label", 0);
            i0.ɵɵtext(1);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "div", 1)(3, "div", 2);
            i0.ɵɵtemplate(4, SwitchButtonComponent_button_4_Template, 2, 3, "button", 3);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵattribute("id", ctx.labelId);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.label);
            i0.ɵɵadvance(2);
            i0.ɵɵattribute("aria-labelledby", ctx.labelId);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngForOf", ctx.optionsDisplay);
        } }, dependencies: [i1$2.NgForOf], styles: ["[_nghost-%COMP%]{--mon-switch-button-border-radius: 3px}[_nghost-%COMP%]   .btn-group[_ngcontent-%COMP%]{padding:0}[_nghost-%COMP%]   .btn-group[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{display:inline-block;box-sizing:border-box;margin:0;padding:6px 10px;font-size:12px;font-weight:400;text-align:center;vertical-align:middle;color:#299bf7;background-color:#fff;border:1px solid #E6E6E6;border-right:1px solid transparent;cursor:pointer}[_nghost-%COMP%]   .btn-group[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:first-child{border-left:1px solid #E6E6E6;border-top-left-radius:var(--mon-switch-button-border-radius);border-bottom-left-radius:var(--mon-switch-button-border-radius)}[_nghost-%COMP%]   .btn-group[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:last-child{border-right:1px solid #E6E6E6;border-top-right-radius:var(--mon-switch-button-border-radius);border-bottom-right-radius:var(--mon-switch-button-border-radius)}[_nghost-%COMP%]   .btn-group[_ngcontent-%COMP%]   button[aria-checked=true][_ngcontent-%COMP%]{color:#fff;background-color:#299bf7;border-color:#299bf7;cursor:default}[_nghost-%COMP%]   .btn-group[_ngcontent-%COMP%]   button[aria-checked=true][_ngcontent-%COMP%]:focus-visible{outline:none;border:1px solid #0F368B}[_nghost-%COMP%]   .btn-group[_ngcontent-%COMP%]   button[aria-checked=true][_ngcontent-%COMP%]:hover{background-color:#1c86db;border-color:#1c86db}[_nghost-%COMP%]   .btn-group[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:hover{background-color:#f3f5f7}[_nghost-%COMP%]   .btn-group[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:focus-visible{outline:none;border:1px solid #4976B9}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SwitchButtonComponent, [{
        type: Component,
        args: [{ selector: 'mon-switch-button', template: "<label [attr.id]=labelId class=\"sr-only\" translate>{{ label }}</label>\n\n<div class=\"switch-button-container\">\n    <div class=\"btn-group\" role=\"radiogroup\"\n        [attr.aria-labelledby]=labelId\n    >\n        <button role=\"radio\"\n            *ngFor=\"let option of optionsDisplay; let i = index\"\n            [attr.aria-checked]=\"option.selected\"\n            [attr.tabindex]=\"(option.selected) ? 0 : -1\"\n            (click)=\"setFocus(i)\"\n            (keydown)=\"onKeydown($event)\">\n            {{option.value}}\n        </button>\n    </div>\n</div>", styles: [":host{--mon-switch-button-border-radius: 3px}:host .btn-group{padding:0}:host .btn-group button{display:inline-block;box-sizing:border-box;margin:0;padding:6px 10px;font-size:12px;font-weight:400;text-align:center;vertical-align:middle;color:#299bf7;background-color:#fff;border:1px solid #E6E6E6;border-right:1px solid transparent;cursor:pointer}:host .btn-group button:first-child{border-left:1px solid #E6E6E6;border-top-left-radius:var(--mon-switch-button-border-radius);border-bottom-left-radius:var(--mon-switch-button-border-radius)}:host .btn-group button:last-child{border-right:1px solid #E6E6E6;border-top-right-radius:var(--mon-switch-button-border-radius);border-bottom-right-radius:var(--mon-switch-button-border-radius)}:host .btn-group button[aria-checked=true]{color:#fff;background-color:#299bf7;border-color:#299bf7;cursor:default}:host .btn-group button[aria-checked=true]:focus-visible{outline:none;border:1px solid #0F368B}:host .btn-group button[aria-checked=true]:hover{background-color:#1c86db;border-color:#1c86db}:host .btn-group button:hover{background-color:#f3f5f7}:host .btn-group button:focus-visible{outline:none;border:1px solid #4976B9}\n"] }]
    }], () => [{ type: i0.ElementRef }], { options: [{
            type: Input
        }], label: [{
            type: Input
        }], defaultIndex: [{
            type: Input
        }], onSelected: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(SwitchButtonComponent, { className: "SwitchButtonComponent" }); })();

class SwitchButtonModule {
    static { this.ɵfac = function SwitchButtonModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SwitchButtonModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: SwitchButtonModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SwitchButtonModule, [{
        type: NgModule,
        args: [{
                declarations: [SwitchButtonComponent],
                imports: [CommonModule],
                exports: [SwitchButtonComponent],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SwitchButtonModule, { declarations: [SwitchButtonComponent], imports: [CommonModule], exports: [SwitchButtonComponent] }); })();

const handledKeys = ['Enter', ' '];
const monTableSpoilerAccordionActive = 'mon-table-spoiler-accordion-active';
const dataMonTableSpoilerAccordion = 'data-mon-table-spoiler-accordion';
const monTableSpoilerAccordionHide = 'monTableSpoilerAccordionHide';
const directSpinning = [
    { transform: 'rotate(180deg)' },
];
const reverseSpinning = [
    { transform: 'rotate(0deg)' },
];
const directOpacity = [
    { opacity: 1 },
];
const reverseOpacity = [
    { opacity: 0 },
];
class TableSpoilerAccordionDirective {
    constructor(element, translateService) {
        this.element = element;
        this.translateService = translateService;
        this.monSpoilerAccordionAnimationTime = 100;
        this.animationOptions = {
            duration: this.monSpoilerAccordionAnimationTime,
            iterations: 1,
        };
    }
    ngOnInit() {
        const animationDuration = Number(this.monSpoilerAccordionAnimationTime);
        if (!isNaN(animationDuration)) {
            this.animationOptions.duration = animationDuration;
        }
        this.toggle = debounce(() => {
            this.toggleRows();
        }, this.animationOptions.duration, {
            leading: true,
        });
        this.element.nativeElement.addEventListener('click', () => {
            this.toggle();
        });
        this.element.nativeElement.addEventListener(monTableSpoilerAccordionHide, (e) => {
            e.stopImmediatePropagation();
            this.hide();
        });
        this.element.nativeElement.addEventListener('keydown', (e) => this.toggleByKeydown(e));
        this.turnElementIntoButton();
    }
    ngAfterViewInit() {
        this.getRows().forEach(row => row.setAttribute('hidden', ''));
    }
    toggleRows() {
        const table = this.element.nativeElement.closest('table');
        if (table) {
            if (this.element.nativeElement.getAttribute('aria-expanded') === 'true') {
                this.hide();
            }
            else {
                this.show();
            }
        }
    }
    toggleByKeydown(e) {
        if (handledKeys.includes(e.key)) {
            e.preventDefault();
            this.toggle();
        }
    }
    hide() {
        const element = this.element.nativeElement;
        element.animate(reverseSpinning, this.animationOptions).finished.finally(() => {
            element.style.transform = '';
        });
        this.getRows().forEach(row => {
            row.animate(reverseOpacity, this.animationOptions).finished.finally(() => {
                row.setAttribute('hidden', '');
            });
        });
        element.setAttribute('aria-expanded', 'false');
        this.toggleParentRowActiveClass(false);
    }
    show() {
        const element = this.element.nativeElement;
        this.toggleParentRowActiveClass(true);
        this.getRows().forEach(row => {
            row.removeAttribute('hidden');
            row.style.opacity = '0';
            row.animate(directOpacity, this.animationOptions).finished.finally(() => {
                row.style.opacity = '';
            });
        });
        element.setAttribute('aria-expanded', 'true');
        element.animate(directSpinning, this.animationOptions).finished.finally(() => {
            element.style.transform = 'rotate(180deg)';
        });
        this.closeAllOtherElements();
    }
    toggleParentRowActiveClass(on) {
        const parentRow = this.element.nativeElement.closest('tr');
        if (parentRow) {
            if (on) {
                parentRow.classList.add(monTableSpoilerAccordionActive);
            }
            else {
                parentRow.classList.remove(monTableSpoilerAccordionActive);
            }
        }
    }
    closeAllOtherElements() {
        const element = this.element.nativeElement;
        const table = element.closest('table');
        if (table) {
            Array.from(table.querySelectorAll(`[${dataMonTableSpoilerAccordion}]`)).forEach((button) => {
                if (button !== element) {
                    button.dispatchEvent(new CustomEvent(monTableSpoilerAccordionHide));
                }
            });
        }
    }
    getRows() {
        const table = this.element.nativeElement.closest('table');
        if (table) {
            return Array.from(table.querySelectorAll(`[data-hidden-row="${this.monTableSpoilerAccordion}"]`));
        }
        return [];
    }
    turnElementIntoButton() {
        const element = this.element.nativeElement;
        element.style.display = 'inline-block';
        element.setAttribute(dataMonTableSpoilerAccordion, '');
        element.setAttribute('role', 'button');
        element.setAttribute('tabindex', '0');
        element.setAttribute('aria-haspopup', 'grid');
        element.setAttribute('aria-expanded', 'false');
        element.setAttribute('aria-label', this.translateService.getString('Press to toggle additional rows.'));
    }
    static { this.ɵfac = function TableSpoilerAccordionDirective_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TableSpoilerAccordionDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(TranslateServiceInjectionToken)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: TableSpoilerAccordionDirective, selectors: [["", "monTableSpoilerAccordion", ""]], inputs: { monTableSpoilerAccordion: "monTableSpoilerAccordion", monSpoilerAccordionAnimationTime: "monSpoilerAccordionAnimationTime" } }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TableSpoilerAccordionDirective, [{
        type: Directive,
        args: [{
                selector: '[monTableSpoilerAccordion]',
            }]
    }], () => [{ type: i0.ElementRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [TranslateServiceInjectionToken]
            }] }], { monTableSpoilerAccordion: [{
            type: Input
        }], monSpoilerAccordionAnimationTime: [{
            type: Input
        }] }); })();

class MonTableSpoilerAccordionModule {
    static { this.ɵfac = function MonTableSpoilerAccordionModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MonTableSpoilerAccordionModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: MonTableSpoilerAccordionModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({}); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MonTableSpoilerAccordionModule, [{
        type: NgModule,
        args: [{
                imports: [],
                exports: [TableSpoilerAccordionDirective],
                declarations: [TableSpoilerAccordionDirective],
                providers: [],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(MonTableSpoilerAccordionModule, { declarations: [TableSpoilerAccordionDirective], exports: [TableSpoilerAccordionDirective] }); })();

const _c0$a = (a0, a1) => ({ "col-sm-36": a0, "col-sm-44": a1 });
function DynamicAcComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8)(1, "div", 9)(2, "mon-table-search", 10);
    i0.ɵɵlistener("getPage", function DynamicAcComponent_div_0_Template_mon_table_search_getPage_2_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.onSearchChanged($event)); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("model", ctx_r1.search);
} }
function DynamicAcComponent_div_1_label_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 20);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const indexPosition_r4 = i0.ɵɵnextContext().index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("for", ctx_r1.labelText + indexPosition_r4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.label, " ");
} }
function DynamicAcComponent_div_1_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 21)(2, "span", 22);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "button", 23);
    i0.ɵɵlistener("click", function DynamicAcComponent_div_1_ng_container_5_Template_button_click_4_listener() { i0.ɵɵrestoreView(_r7); const indexPosition_r4 = i0.ɵɵnextContext().index; const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.onMonLabelDeleteButtonClick(indexPosition_r4)); });
    i0.ɵɵtext(5, "x");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const indexPosition_r4 = i0.ɵɵnextContext().index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngbTooltip", ctx_r1.rightItemLabelsPerPage[indexPosition_r4].tooltipText || ctx_r1.monRightItemLabelsTooltip);
    i0.ɵɵattribute("class", ctx_r1.rightItemLabelsPerPage[indexPosition_r4].class || ctx_r1.monRightItemLabelsClass);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.rightItemLabelsPerPage[indexPosition_r4].name, " ");
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-label", ctx_r1.monLabelDeleteButtonLabel)("class", ctx_r1.monLabelDeleteButtonClass);
} }
function DynamicAcComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵtemplate(1, DynamicAcComponent_div_1_label_1_Template, 2, 2, "label", 12);
    i0.ɵɵelementStart(2, "div", 13)(3, "div", 14)(4, "mon-form-field-input", 15);
    i0.ɵɵlistener("ngModelChange", function DynamicAcComponent_div_1_Template_mon_form_field_input_ngModelChange_4_listener($event) { const ctx_r4 = i0.ɵɵrestoreView(_r3); const model_r6 = ctx_r4.$implicit; const indexPosition_r4 = ctx_r4.index; const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.inputChangeRegisterBeforeModelChange(indexPosition_r4, $event, model_r6[ctx_r1.attrName])); });
    i0.ɵɵtwoWayListener("ngModelChange", function DynamicAcComponent_div_1_Template_mon_form_field_input_ngModelChange_4_listener($event) { const model_r6 = i0.ɵɵrestoreView(_r3).$implicit; const ctx_r1 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(model_r6[ctx_r1.attrName], $event) || (model_r6[ctx_r1.attrName] = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, DynamicAcComponent_div_1_ng_container_5_Template, 6, 5, "ng-container", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span", 17);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div", 18)(9, "button", 5);
    i0.ɵɵlistener("click", function DynamicAcComponent_div_1_Template_button_click_9_listener() { const model_r6 = i0.ɵɵrestoreView(_r3).$implicit; const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.removeFromModel(model_r6)); });
    i0.ɵɵelement(10, "mon-icon", 19);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const model_r6 = ctx.$implicit;
    const indexPosition_r4 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.label);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(11, _c0$a, ctx_r1.label, !ctx_r1.label));
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", model_r6[ctx_r1.attrName]);
    i0.ɵɵproperty("type", ctx_r1.type)("name", ctx_r1.labelText + indexPosition_r4)("id", ctx_r1.labelText + indexPosition_r4)("monPlaceholder", ctx_r1.placeholder);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.rightItemLabelsPerPage && ctx_r1.rightItemLabelsPerPage[indexPosition_r4]);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.helpText);
    i0.ɵɵadvance(2);
    i0.ɵɵattributeInterpolate1("aria-label", "Remove ", ctx_r1.label, "");
} }
function DynamicAcComponent_div_9_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0, "\u00AB");
} }
function DynamicAcComponent_div_9_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0, "\u00BB");
} }
function DynamicAcComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 24)(1, "ngb-pagination", 25);
    i0.ɵɵtwoWayListener("pageChange", function DynamicAcComponent_div_9_Template_ngb_pagination_pageChange_1_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r1 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r1.page, $event) || (ctx_r1.page = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("pageChange", function DynamicAcComponent_div_9_Template_ngb_pagination_pageChange_1_listener() { i0.ɵɵrestoreView(_r8); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.onPageParamsChange()); });
    i0.ɵɵtemplate(2, DynamicAcComponent_div_9_ng_template_2_Template, 1, 0, "ng-template", 26)(3, DynamicAcComponent_div_9_ng_template_3_Template, 1, 0, "ng-template", 27);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("page", ctx_r1.page);
    i0.ɵɵproperty("pageSize", ctx_r1.pageSize)("collectionSize", ctx_r1.models.length)("rotate", true);
} }
class DynamicAcComponent extends AbstractControlValueAccessor {
    set ngModel(value) {
        this.value = value;
        if (value && value.length === 0) {
            this.pushToModel();
        }
        else {
            this.updateModels();
        }
    }
    get ngModel() {
        return this.value;
    }
    set monDynamicComponentRightItemLabels(value) {
        this._monDynamicComponentRightItemLabels = value;
        this.updateRightLabels();
    }
    get monDynamicComponentRightItemLabels() {
        return this._monDynamicComponentRightItemLabels;
    }
    constructor(searchService, translateService) {
        super();
        this.searchService = searchService;
        this.translateService = translateService;
        this.allowSearch = false;
        this.allowPagination = false;
        this.pageSize = 999;
        // Label name for the input fields
        this.label = '';
        // Input type..
        this.type = 'text';
        this.placeholder = '';
        this.confirmMsg = this.translateService.getString('Are you sure you want to remove this?');
        // Property name on the model collection
        this.attrName = 'name';
        this.helpText = '';
        this.textInAddBtn = '';
        this.monRightItemLabelsTooltip = '';
        this.monRightItemLabelsClass = 'label label-info';
        this.monLabelDeleteButtonClass = 'mon-dynamic-label-delete-button';
        this.monLabelDeleteButtonLabel = this.translateService.getString('Press to remove the label.');
        this.monLabelDeleteButtonClick = new EventEmitter();
        this.inputValueChanged = new EventEmitter();
        this.page = 1;
        this.search = '';
        this.models = [];
    }
    ngOnInit() {
        this.labelText = this.getLabelForId(this.label) || 'formFieldDynamic';
    }
    onSearchChanged(search) {
        this.search = search;
        this.updateModels();
        if (search.length) {
            this.page = 1;
        }
    }
    pushToModel() {
        let valueLength = 0;
        if (Array.isArray(this.value)) {
            this.value.push({
                [this.attrName]: '',
            });
            valueLength = this.value.length;
        }
        if (Array.isArray(this._monDynamicComponentRightItemLabels)) {
            this._monDynamicComponentRightItemLabels.push(undefined);
            this.updateRightLabels();
        }
        const newPage = Math.ceil(valueLength / this.pageSize) || 1;
        if (newPage !== this.page) {
            this.page = newPage;
            this.onPageParamsChange();
        }
        this.updateModels();
    }
    removeFromModel(model) {
        // NB! May be necessary to set the indexOf search in a private function for unifying search for model reference on input change.
        if (Array.isArray(this.value)) {
            const index = this.value.indexOf(model);
            if (index !== -1) {
                this.value.splice(index, 1);
                if (this.value.length <= this.pageSize) {
                    if (this.page !== 1) {
                        this.page = 1;
                        this.onPageParamsChange();
                    }
                }
                if (Array.isArray(this._monDynamicComponentRightItemLabels)) {
                    this._monDynamicComponentRightItemLabels.splice((this.page - 1) * this.pageSize + index, 1);
                    this.updateRightLabels();
                }
            }
        }
    }
    onMonLabelDeleteButtonClick(index) {
        this.monLabelDeleteButtonClick.emit(index);
    }
    /*
        It is crucial, that in the template this method is located before ngModel.
        Otherwise it does not get the previous value.
        It must be
        (ngModelChange)="inputChangeRegisterBeforeModelChange(indexPosition, $event, model[attrName])"
        [(ngModel)]="model[attrName]"
    */
    inputChangeRegisterBeforeModelChange(currentIndex, value, previousValue) {
        if (value !== previousValue) {
            let index = currentIndex;
            if (this.allowPagination) {
                index = (this.page - 1) * this.pageSize + currentIndex;
            }
            this.inputValueChanged.emit({
                index,
                value,
            });
        }
    }
    onPageParamsChange() {
        this.updateRightLabels();
    }
    updateRightLabels() {
        if (Array.isArray(this._monDynamicComponentRightItemLabels)) {
            this.rightItemLabelsPerPage = this._monDynamicComponentRightItemLabels.slice((this.page - 1) * this.pageSize, this.page * this.pageSize);
        }
    }
    updateModels() {
        if (Array.isArray(this.value)) {
            if (!this.search) {
                this.models = this.value;
                return;
            }
            this.models = this.value.filter((model) => {
                return !model[this.attrName] || this.searchService.fuzzy(this.search, model[this.attrName]);
            });
        }
        else {
            this.models = [];
        }
    }
    static { this.ɵfac = function DynamicAcComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DynamicAcComponent)(i0.ɵɵdirectiveInject(SearchService), i0.ɵɵdirectiveInject(TranslateServiceInjectionToken)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DynamicAcComponent, selectors: [["mon-form-field-dynamic-ac"]], inputs: { ngModel: "ngModel", allowSearch: "allowSearch", allowPagination: "allowPagination", pageSize: "pageSize", label: "label", type: "type", placeholder: "placeholder", confirmMsg: "confirmMsg", attrName: "attrName", helpText: "helpText", textInAddBtn: "textInAddBtn", monRightItemLabelsTooltip: "monRightItemLabelsTooltip", monRightItemLabelsClass: "monRightItemLabelsClass", monLabelDeleteButtonClass: "monLabelDeleteButtonClass", monLabelDeleteButtonLabel: "monLabelDeleteButtonLabel", monDynamicComponentRightItemLabels: "monDynamicComponentRightItemLabels" }, outputs: { monLabelDeleteButtonClick: "monLabelDeleteButtonClick", inputValueChanged: "inputValueChanged" }, features: [i0.ɵɵProvidersFeature([{
                    provide: NG_VALUE_ACCESSOR,
                    useExisting: DynamicAcComponent,
                    multi: true,
                }]), i0.ɵɵInheritDefinitionFeature], decls: 10, vars: 9, consts: [["class", "row mb-2", 4, "ngIf"], ["class", "form-group row mx-auto w-100", 4, "ngFor", "ngForOf"], [1, "row"], [1, "offset-sm-8", "col-sm-40", "d-flex", "align-items-center", "pr-5"], [1, "mr-auto"], ["type", "button", 1, "btn", "btn-default", "btn-secondary", 3, "click"], ["monIconDirect", "faPlus"], ["class", "pr-2", 4, "ngIf"], [1, "row", "mb-2"], [1, "ml-auto", "col-auto", "pr-4"], ["minSearchLength", "1", 3, "getPage", "model"], [1, "form-group", "row", "mx-auto", "w-100"], ["class", "col-sm-8 text-bold text-right capitalize-first-letter pt-1", 4, "ngIf"], [1, "px-1", 3, "ngClass"], [1, "mon-dynamic-form-field-wrapper"], [3, "ngModelChange", "ngModel", "type", "name", "id", "monPlaceholder"], [4, "ngIf"], [1, "help-block"], [1, "col-sm-4", "text-right", "pr-1"], ["monIconDirect", "faTrashAlt"], [1, "col-sm-8", "text-bold", "text-right", "capitalize-first-letter", "pt-1"], [1, "mon-dynamic-label-wrapper"], [3, "ngbTooltip"], ["type", "button", 3, "click"], [1, "pr-2"], ["maxSize", "7", 3, "pageChange", "page", "pageSize", "collectionSize", "rotate"], ["ngbPaginationPrevious", ""], ["ngbPaginationNext", ""]], template: function DynamicAcComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, DynamicAcComponent_div_0_Template, 3, 1, "div", 0)(1, DynamicAcComponent_div_1_Template, 11, 14, "div", 1);
            i0.ɵɵpipe(2, "slice");
            i0.ɵɵelementStart(3, "div", 2)(4, "div", 3)(5, "div", 4)(6, "button", 5);
            i0.ɵɵlistener("click", function DynamicAcComponent_Template_button_click_6_listener() { return ctx.pushToModel(); });
            i0.ɵɵelement(7, "mon-icon", 6);
            i0.ɵɵtext(8);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(9, DynamicAcComponent_div_9_Template, 4, 4, "div", 7);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.allowSearch);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind3(2, 5, ctx.models, (ctx.page - 1) * ctx.pageSize, ctx.page * ctx.pageSize));
            i0.ɵɵadvance(5);
            i0.ɵɵattribute("aria-label", ctx.textInAddBtn ? null : "Add " + ctx.label);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.textInAddBtn, " ");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.allowPagination && ctx.models.length > 5);
        } }, dependencies: [i1$5.NgControlStatus, i1$5.NgModel, i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, TableSearchComponent, i1$4.NgbTooltip, i1$4.NgbPagination, i1$4.NgbPaginationNext, i1$4.NgbPaginationPrevious, InputComponent, IconComponent, i1$2.SlicePipe], styles: [".select-grey[_ngcontent-%COMP%]   .ngx-select__toggle[_ngcontent-%COMP%]{display:block;margin:0;position:relative;overflow:hidden;cursor:pointer;border:1px solid #bbb;box-shadow:0 1px #0000000d,inset 0 1px #fffc;box-sizing:border-box;border-radius:3px;font-weight:inherit}[_nghost-%COMP%]{--mon-form-field-dynamic-input-width: 100%;--mon-form-field-dynamic-input-display: inline}[_nghost-%COMP%]   mon-form-field-input[_ngcontent-%COMP%]{display:var(--mon-form-field-dynamic-input-display);width:var(--mon-form-field-dynamic-input-width)}[_nghost-%COMP%]   .mon-dynamic-label-wrapper[_ngcontent-%COMP%]{cursor:default;text-transform:capitalize}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DynamicAcComponent, [{
        type: Component,
        args: [{ selector: 'mon-form-field-dynamic-ac', providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: DynamicAcComponent,
                        multi: true,
                    }], template: "<div class=\"row mb-2\" *ngIf=\"allowSearch\">\n    <div class=\"ml-auto col-auto pr-4\">\n        <mon-table-search\n            minSearchLength=\"1\"\n            (getPage)=\"onSearchChanged($event)\"\n            [model]=\"search\">\n        </mon-table-search>\n    </div>\n</div>\n<div class=\"form-group row mx-auto w-100\"\n     *ngFor=\"let model of models | slice: (page-1) * pageSize : page * pageSize; let indexPosition = index;\">\n    <label *ngIf=\"label\"\n           [attr.for]=\"labelText + indexPosition\"\n           class=\"col-sm-8 text-bold text-right capitalize-first-letter pt-1\">\n        {{ label }}\n    </label>\n    <div class=\"px-1\" [ngClass]=\"{'col-sm-36' : label, 'col-sm-44': !label }\">\n        <div class=\"mon-dynamic-form-field-wrapper\">\n            <mon-form-field-input\n                    (ngModelChange)=\"inputChangeRegisterBeforeModelChange(indexPosition, $event, model[attrName])\"\n                    [(ngModel)]=\"model[attrName]\"\n                    [type]=\"type\"\n                    [name]=\"labelText + indexPosition\"\n                    [id]=\"labelText + indexPosition\"\n                    [monPlaceholder]=\"placeholder\">\n            </mon-form-field-input>\n            <ng-container *ngIf=\"rightItemLabelsPerPage && rightItemLabelsPerPage[indexPosition]\">\n                <div class=\"mon-dynamic-label-wrapper\">\n                    <span\n                        [ngbTooltip]=\"rightItemLabelsPerPage[indexPosition].tooltipText || monRightItemLabelsTooltip\"\n                        [attr.class]=\"rightItemLabelsPerPage[indexPosition].class || monRightItemLabelsClass\">\n                        {{ rightItemLabelsPerPage[indexPosition].name }}\n                    </span>\n                    <button\n                        type=\"button\"\n                        (click)=\"onMonLabelDeleteButtonClick(indexPosition)\"\n                        [attr.aria-label]=\"monLabelDeleteButtonLabel\"\n                        [attr.class]=\"monLabelDeleteButtonClass\"\n                    >x</button>\n                </div>\n            </ng-container>\n        </div>\n        <span class=\"help-block\">{{ helpText }}</span>\n    </div>\n    <div class=\"col-sm-4 text-right pr-1\">\n        <button type=\"button\"\n                (click)=\"removeFromModel(model)\"\n                attr.aria-label=\"Remove {{ label }}\"\n                class=\"btn btn-default btn-secondary\">\n            <mon-icon monIconDirect=\"faTrashAlt\"></mon-icon>\n        </button>\n    </div>\n</div>\n<div class=\"row\">\n    <div class=\"offset-sm-8 col-sm-40 d-flex align-items-center pr-5\">\n        <div class=\"mr-auto\">\n            <button type=\"button\"\n                    [attr.aria-label]=\"textInAddBtn ? null : 'Add ' + label\"\n                    (click)=\"pushToModel()\"\n                    class=\"btn btn-default btn-secondary\">\n                <mon-icon monIconDirect=\"faPlus\"></mon-icon>\n                {{textInAddBtn}}\n            </button>\n        </div>\n        <div class=\"pr-2\" *ngIf=\"allowPagination && models.length > 5\">\n            <ngb-pagination\n                [(page)]=\"page\"\n                (pageChange)=\"onPageParamsChange()\"\n                maxSize=\"7\"\n                [pageSize]=\"pageSize\"\n                [collectionSize]=\"models.length\"\n                [rotate]=\"true\">\n                <ng-template ngbPaginationPrevious>&laquo;</ng-template>\n                <ng-template ngbPaginationNext>&raquo;</ng-template>\n            </ngb-pagination>\n        </div>\n    </div>\n</div>\n", styles: [".select-grey .ngx-select__toggle{display:block;margin:0;position:relative;overflow:hidden;cursor:pointer;border:1px solid #bbb;box-shadow:0 1px #0000000d,inset 0 1px #fffc;box-sizing:border-box;border-radius:3px;font-weight:inherit}:host{--mon-form-field-dynamic-input-width: 100%;--mon-form-field-dynamic-input-display: inline}:host mon-form-field-input{display:var(--mon-form-field-dynamic-input-display);width:var(--mon-form-field-dynamic-input-width)}:host .mon-dynamic-label-wrapper{cursor:default;text-transform:capitalize}\n"] }]
    }], () => [{ type: SearchService }, { type: undefined, decorators: [{
                type: Inject,
                args: [TranslateServiceInjectionToken]
            }] }], { ngModel: [{
            type: Input
        }], allowSearch: [{
            type: Input
        }], allowPagination: [{
            type: Input
        }], pageSize: [{
            type: Input
        }], label: [{
            type: Input
        }], type: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], confirmMsg: [{
            type: Input
        }], attrName: [{
            type: Input
        }], helpText: [{
            type: Input
        }], textInAddBtn: [{
            type: Input
        }], monRightItemLabelsTooltip: [{
            type: Input
        }], monRightItemLabelsClass: [{
            type: Input
        }], monLabelDeleteButtonClass: [{
            type: Input
        }], monLabelDeleteButtonLabel: [{
            type: Input
        }], monDynamicComponentRightItemLabels: [{
            type: Input
        }], monLabelDeleteButtonClick: [{
            type: Output
        }], inputValueChanged: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DynamicAcComponent, { className: "DynamicAcComponent" }); })();

class FormBuilderDynamicAcModule {
    static { this.ɵfac = function FormBuilderDynamicAcModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FormBuilderDynamicAcModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: FormBuilderDynamicAcModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [SearchService], imports: [FormsModule,
            CommonModule,
            TableSearchModule,
            NgbTooltipModule,
            NgbPaginationModule,
            TranslateModule,
            FormBuilderInputModule,
            IconsModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormBuilderDynamicAcModule, [{
        type: NgModule,
        args: [{
                imports: [
                    FormsModule,
                    CommonModule,
                    TableSearchModule,
                    NgbTooltipModule,
                    NgbPaginationModule,
                    TranslateModule,
                    FormBuilderInputModule,
                    IconsModule,
                ],
                exports: [DynamicAcComponent],
                declarations: [DynamicAcComponent],
                providers: [SearchService],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(FormBuilderDynamicAcModule, { declarations: [DynamicAcComponent], imports: [FormsModule,
        CommonModule,
        TableSearchModule,
        NgbTooltipModule,
        NgbPaginationModule,
        TranslateModule,
        FormBuilderInputModule,
        IconsModule], exports: [DynamicAcComponent] }); })();

const _c0$9 = ["footerInner"];
const _c1$2 = [[["", "mon-popup-header", ""]], "*", [["", "mon-popup-footer", ""]]];
const _c2$1 = ["[mon-popup-header]", "*", "[mon-popup-footer]"];
const _c3 = a0 => ({ disabled: a0 });
function MonPopupComponent_ng_container_9_button_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 11);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c3, ctx_r2.submitDisabled))("type", ctx_r2.submitDisabled ? "button" : "submit");
    i0.ɵɵattribute("form", ctx_r2.formId)("aria-disabled", ctx_r2.submitDisabled);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r2.submitButtonText);
} }
function MonPopupComponent_ng_container_9_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 12);
    i0.ɵɵlistener("click", function MonPopupComponent_ng_container_9_button_5_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.onSubmitClick()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", ctx_r2.submitDisabled);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r2.submitButtonText);
} }
function MonPopupComponent_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 7)(2, "button", 8);
    i0.ɵɵlistener("click", function MonPopupComponent_ng_container_9_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r2); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.onCancelClick()); });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, MonPopupComponent_ng_container_9_button_4_Template, 2, 7, "button", 9)(5, MonPopupComponent_ng_container_9_button_5_Template, 2, 2, "button", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r2.cancelButtonText);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.formId);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.formId);
} }
class MonPopupComponent {
    constructor(translateService, configFocusTrap, elRef) {
        this.translateService = translateService;
        this.configFocusTrap = configFocusTrap;
        this.elRef = elRef;
        this.submitDisabled = false;
        this.submitButtonText = '';
        this.cancelButtonText = '';
        this.formId = '';
        this.ariaLabelledBy = 'mon-popup';
        this.closeOnOutsideClick = false;
        this.cancelClicked = new EventEmitter();
        this.submitClicked = new EventEmitter();
        this.showDefaultFooter = true;
        this.focusTrap = null;
        this.previouslyFocusedElement = null;
    }
    onKeydownHandler() {
        this.cancelClicked.emit();
    }
    ngOnInit() {
        if (!this.submitButtonText) {
            this.submitButtonText = this.translateService.getString('Save');
        }
        if (!this.cancelButtonText) {
            this.cancelButtonText = this.translateService.getString('Cancel');
        }
    }
    async ngAfterViewInit() {
        setTimeout(async () => {
            this.showDefaultFooter = this.shouldShowDefaultFooter();
            this.focusTrap = this.configFocusTrap.create(this.elRef.nativeElement, { defer: true });
            this.focusTrap.attachAnchors();
            this.previouslyFocusedElement = document.activeElement;
            await this.focusTrap.focusInitialElementWhenReady();
        });
    }
    ngOnDestroy() {
        if (this.focusTrap) {
            this.focusTrap.destroy();
        }
        if (this.previouslyFocusedElement) {
            this.previouslyFocusedElement.focus();
            this.previouslyFocusedElement = null;
        }
    }
    onBackdropClick() {
        if (this.closeOnOutsideClick) {
            this.cancelClicked.emit();
        }
    }
    onCancelClick() {
        this.cancelClicked.emit();
    }
    onSubmitClick() {
        this.submitClicked.emit();
    }
    shouldShowDefaultFooter() {
        return !this.footerInner?.nativeElement?.hasChildNodes();
    }
    static { this.ɵfac = function MonPopupComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MonPopupComponent)(i0.ɵɵdirectiveInject(TranslateServiceInjectionToken), i0.ɵɵdirectiveInject(i3.ConfigurableFocusTrapFactory), i0.ɵɵdirectiveInject(i0.ElementRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MonPopupComponent, selectors: [["mon-popup"]], viewQuery: function MonPopupComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$9, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.footerInner = _t.first);
        } }, hostBindings: function MonPopupComponent_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("keydown.escape", function MonPopupComponent_keydown_escape_HostBindingHandler($event) { return ctx.onKeydownHandler($event); }, false, i0.ɵɵresolveDocument);
        } }, inputs: { submitDisabled: "submitDisabled", submitButtonText: "submitButtonText", cancelButtonText: "cancelButtonText", formId: "formId", ariaLabelledBy: "ariaLabelledBy", closeOnOutsideClick: "closeOnOutsideClick" }, outputs: { cancelClicked: "cancelClicked", submitClicked: "submitClicked" }, ngContentSelectors: _c2$1, decls: 11, vars: 3, consts: [["footerInner", ""], ["role", "dialog", "aria-modal", "true", 1, "mon-popup-content"], [1, "mon-popup-content-header"], [1, "mon-popup-content-body"], [1, "mon-popup-content-footer"], [4, "ngIf"], [1, "mon-popup-backdrop", 3, "click"], [1, "mon-popup-default-content-footer"], ["type", "button", 1, "btn", "btn-default", "btn-secondary", "mon-popup-cancel-button", 3, "click"], ["class", "btn btn-primary mon-popup-submit-button", 3, "ngClass", "type", 4, "ngIf"], ["class", "btn btn-primary mon-popup-submit-button", "type", "button", 3, "disabled", "click", 4, "ngIf"], [1, "btn", "btn-primary", "mon-popup-submit-button", 3, "ngClass", "type"], ["type", "button", 1, "btn", "btn-primary", "mon-popup-submit-button", 3, "click", "disabled"]], template: function MonPopupComponent_Template(rf, ctx) { if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef(_c1$2);
            i0.ɵɵelementStart(0, "div", 1)(1, "div", 2);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 3);
            i0.ɵɵprojection(4, 1);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "div", 4)(6, "div", null, 0);
            i0.ɵɵprojection(8, 2);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(9, MonPopupComponent_ng_container_9_Template, 6, 3, "ng-container", 5);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(10, "div", 6);
            i0.ɵɵlistener("click", function MonPopupComponent_Template_div_click_10_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.onBackdropClick()); });
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵattribute("aria-labelledby", ctx.ariaLabelledBy);
            i0.ɵɵadvance();
            i0.ɵɵattribute("id", ctx.ariaLabelledBy);
            i0.ɵɵadvance(8);
            i0.ɵɵproperty("ngIf", ctx.showDefaultFooter);
        } }, dependencies: [i1$2.NgClass, i1$2.NgIf], styles: ["[_nghost-%COMP%]{--content-z-index: 1;position:fixed;top:0;left:0;width:100%;height:100%;display:flex;justify-content:center}[_nghost-%COMP%]   .mon-popup-content[_ngcontent-%COMP%]{margin-top:30px;position:absolute;background-color:#fff;border:1px solid #000;border-radius:3px;box-shadow:0 5px 15px #00000080;z-index:var(--content-z-index)}[_nghost-%COMP%]   .mon-popup-content[_ngcontent-%COMP%]   .mon-popup-content-header[_ngcontent-%COMP%], [_nghost-%COMP%]   .mon-popup-content[_ngcontent-%COMP%]   .mon-popup-content-body[_ngcontent-%COMP%], [_nghost-%COMP%]   .mon-popup-content[_ngcontent-%COMP%]   .mon-popup-content-footer[_ngcontent-%COMP%]{padding:15px}[_nghost-%COMP%]   .mon-popup-content[_ngcontent-%COMP%]   .mon-popup-content-header[_ngcontent-%COMP%]{border-bottom:1px solid #e5e5e5}[_nghost-%COMP%]   .mon-popup-content[_ngcontent-%COMP%]   .mon-popup-content-footer[_ngcontent-%COMP%]{border-top:1px solid #e5e5e5}[_nghost-%COMP%]   .mon-popup-content[_ngcontent-%COMP%]   .mon-popup-default-content-footer[_ngcontent-%COMP%]{display:flex;width:100%;justify-content:flex-end}[_nghost-%COMP%]   .mon-popup-content[_ngcontent-%COMP%]   .mon-popup-submit-button[aria-disabled=true][_ngcontent-%COMP%]{cursor:not-allowed;pointer-events:all}[_nghost-%COMP%]   .mon-popup-content[_ngcontent-%COMP%]   .mon-popup-cancel-button[_ngcontent-%COMP%]{margin-right:5px}[_nghost-%COMP%]   .mon-popup-backdrop[_ngcontent-%COMP%]{position:absolute;inset:0;background-color:#000;opacity:.5;z-index:0}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MonPopupComponent, [{
        type: Component,
        args: [{ selector: 'mon-popup', template: "<div class=\"mon-popup-content\" role=\"dialog\" aria-modal=\"true\" [attr.aria-labelledby]=\"ariaLabelledBy\">\n    <div class=\"mon-popup-content-header\" [attr.id]=\"ariaLabelledBy\">\n        <ng-content select=\"[mon-popup-header]\"></ng-content>\n    </div>\n    <div class=\"mon-popup-content-body\">\n        <ng-content></ng-content>\n    </div>\n    <div class=\"mon-popup-content-footer\">\n        <div #footerInner>\n            <ng-content select=\"[mon-popup-footer]\"></ng-content>\n        </div>\n        <ng-container *ngIf=\"showDefaultFooter\">\n            <div class=\"mon-popup-default-content-footer\">\n                <button class=\"btn btn-default btn-secondary mon-popup-cancel-button\"\n                        type=\"button\"\n                        (click)=\"onCancelClick()\">{{ cancelButtonText }}</button>\n                <button *ngIf=\"formId\"\n                    class=\"btn btn-primary mon-popup-submit-button\"\n                    [ngClass]=\"{disabled: submitDisabled}\"\n                    [type]=\"submitDisabled ? 'button' : 'submit'\"\n                    [attr.form]=\"formId\"\n                    [attr.aria-disabled]=\"submitDisabled\">{{ submitButtonText }}</button>\n                <button *ngIf=\"!formId\"\n                    class=\"btn btn-primary mon-popup-submit-button\"\n                    type=\"button\"\n                    (click)=\"onSubmitClick()\"\n                    [disabled]=\"submitDisabled\">{{ submitButtonText }}</button>\n            </div>\n        </ng-container>\n    </div>\n</div>\n<div class=\"mon-popup-backdrop\" (click)=\"onBackdropClick()\"></div>\n", styles: [":host{--content-z-index: 1;position:fixed;top:0;left:0;width:100%;height:100%;display:flex;justify-content:center}:host .mon-popup-content{margin-top:30px;position:absolute;background-color:#fff;border:1px solid #000;border-radius:3px;box-shadow:0 5px 15px #00000080;z-index:var(--content-z-index)}:host .mon-popup-content .mon-popup-content-header,:host .mon-popup-content .mon-popup-content-body,:host .mon-popup-content .mon-popup-content-footer{padding:15px}:host .mon-popup-content .mon-popup-content-header{border-bottom:1px solid #e5e5e5}:host .mon-popup-content .mon-popup-content-footer{border-top:1px solid #e5e5e5}:host .mon-popup-content .mon-popup-default-content-footer{display:flex;width:100%;justify-content:flex-end}:host .mon-popup-content .mon-popup-submit-button[aria-disabled=true]{cursor:not-allowed;pointer-events:all}:host .mon-popup-content .mon-popup-cancel-button{margin-right:5px}:host .mon-popup-backdrop{position:absolute;inset:0;background-color:#000;opacity:.5;z-index:0}\n"] }]
    }], () => [{ type: undefined, decorators: [{
                type: Inject,
                args: [TranslateServiceInjectionToken]
            }] }, { type: i3.ConfigurableFocusTrapFactory }, { type: i0.ElementRef }], { submitDisabled: [{
            type: Input
        }], submitButtonText: [{
            type: Input
        }], cancelButtonText: [{
            type: Input
        }], formId: [{
            type: Input
        }], ariaLabelledBy: [{
            type: Input
        }], closeOnOutsideClick: [{
            type: Input
        }], cancelClicked: [{
            type: Output
        }], submitClicked: [{
            type: Output
        }], footerInner: [{
            type: ViewChild,
            args: ['footerInner']
        }], onKeydownHandler: [{
            type: HostListener,
            args: ['document:keydown.escape', ['$event']]
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(MonPopupComponent, { className: "MonPopupComponent" }); })();

class MonPopupModule {
    static { this.ɵfac = function MonPopupModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MonPopupModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: MonPopupModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, TranslateModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MonPopupModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, TranslateModule],
                declarations: [MonPopupComponent],
                exports: [MonPopupComponent],
                providers: [],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(MonPopupModule, { declarations: [MonPopupComponent], imports: [CommonModule, TranslateModule], exports: [MonPopupComponent] }); })();

const _c0$8 = [[["", "chart-option", ""]], [["", "table-option", ""]]];
const _c1$1 = ["[chart-option]", "[table-option]"];
function AccessibleChartWrapperComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
} }
function AccessibleChartWrapperComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵprojection(1, 1);
    i0.ɵɵelementEnd();
} }
class AccessibleChartWrapperComponent {
    constructor(translateService) {
        this.translateService = translateService;
        this.categories = [];
        this.categoryLabel = '';
        this.category = 0;
    }
    ngOnInit() {
        this.categories = [this.translateService.getString('Chart'), this.translateService.getString('Table')];
        this.category = 0;
        this.categoryLabel = this.translateService.getString('Switch between chart and table');
    }
    categoryChange(i) {
        this.category = i;
    }
    static { this.ɵfac = function AccessibleChartWrapperComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AccessibleChartWrapperComponent)(i0.ɵɵdirectiveInject(TranslateServiceInjectionToken)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AccessibleChartWrapperComponent, selectors: [["mon-accessible-chart-wrapper"]], ngContentSelectors: _c1$1, decls: 5, vars: 4, consts: [[1, "accessible-chart-wrapper"], [1, "switch-area"], [3, "onSelected", "options", "label"], ["class", "chart-area", 4, "ngIf"], ["class", "table-area", 4, "ngIf"], [1, "chart-area"], [1, "table-area"]], template: function AccessibleChartWrapperComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c0$8);
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "mon-switch-button", 2);
            i0.ɵɵlistener("onSelected", function AccessibleChartWrapperComponent_Template_mon_switch_button_onSelected_2_listener($event) { return ctx.categoryChange($event); });
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(3, AccessibleChartWrapperComponent_div_3_Template, 2, 0, "div", 3)(4, AccessibleChartWrapperComponent_div_4_Template, 2, 0, "div", 4);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("options", ctx.categories)("label", ctx.categoryLabel);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.category === 0);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.category === 1);
        } }, dependencies: [i1$2.NgIf, SwitchButtonComponent], styles: [".accessible-chart-wrapper[_ngcontent-%COMP%]{width:100%}.accessible-chart-wrapper[_ngcontent-%COMP%]   .switch-area[_ngcontent-%COMP%]{display:flex;justify-content:flex-end;margin-bottom:10px}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AccessibleChartWrapperComponent, [{
        type: Component,
        args: [{ selector: 'mon-accessible-chart-wrapper', template: "<div class=\"accessible-chart-wrapper\">\n    <div class=\"switch-area\">\n        <mon-switch-button\n            [options]=categories\n            [label]=categoryLabel\n            (onSelected)=\"categoryChange($event)\"\n        >\n        </mon-switch-button>\n    </div>\n    <div\n        *ngIf=\"category === 0\"\n        class=\"chart-area\">\n        <!-- Slot \"chart-option\" -->\n        <ng-content select=\"[chart-option]\"></ng-content>\n\n    </div>\n    <div\n        *ngIf=\"category === 1\"\n        class=\"table-area\">\n        <!-- Slot \"table-option\" -->\n        <ng-content select=\"[table-option]\"></ng-content>\n    </div>\n</div>\n", styles: [".accessible-chart-wrapper{width:100%}.accessible-chart-wrapper .switch-area{display:flex;justify-content:flex-end;margin-bottom:10px}\n"] }]
    }], () => [{ type: undefined, decorators: [{
                type: Inject,
                args: [TranslateServiceInjectionToken]
            }] }], null); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(AccessibleChartWrapperComponent, { className: "AccessibleChartWrapperComponent" }); })();

class AccessibleChartWrapperModule {
    static { this.ɵfac = function AccessibleChartWrapperModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AccessibleChartWrapperModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: AccessibleChartWrapperModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, TranslateModule, SwitchButtonModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AccessibleChartWrapperModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, TranslateModule, SwitchButtonModule],
                exports: [AccessibleChartWrapperComponent],
                declarations: [AccessibleChartWrapperComponent],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(AccessibleChartWrapperModule, { declarations: [AccessibleChartWrapperComponent], imports: [CommonModule, TranslateModule, SwitchButtonModule], exports: [AccessibleChartWrapperComponent] }); })();

const exportASCModules = [
    FormBuilderDynamicModule,
    FormBuilderDynamicAcModule,
    TableModule,
    TableSearchModule,
    FilterButtonModule,
    MonAvatarModule,
    LayoutModule,
    LabelModule,
    FormLabelModule,
    MonTableSortModule,
    ToastModule,
    TabsModule,
    ConfirmModule,
    MonDatePickerModule,
    RollbarModule,
    DialogModule,
    FormsBuilderModule,
    EventsModule,
    MonEventTriggerModule,
    PromptModule,
    ColorPickerModule,
    TranslateModule,
    StorageModule,
    MonSelectAllCheckboxModule,
    MonHttpPrefixModule,
    MonChartCustomTooltipModule,
    SwitchButtonModule,
    PipesModule,
    MonPromptModule,
    MonTableSpoilerAccordionModule,
    MonSimpleDateRangeModule,
    MonPopupModule,
    AccessibleChartWrapperModule,
    TableFiltersModule,
];
class AngularSharedComponentsModule {
    static { this.ɵfac = function AngularSharedComponentsModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AngularSharedComponentsModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: AngularSharedComponentsModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [MonPromptModule, TranslateModule, FormBuilderDynamicModule,
            FormBuilderDynamicAcModule,
            TableModule,
            TableSearchModule,
            FilterButtonModule,
            MonAvatarModule,
            LayoutModule,
            LabelModule,
            FormLabelModule,
            MonTableSortModule,
            ToastModule,
            TabsModule,
            ConfirmModule,
            MonDatePickerModule,
            RollbarModule,
            DialogModule,
            FormsBuilderModule,
            EventsModule,
            MonEventTriggerModule,
            PromptModule,
            ColorPickerModule,
            TranslateModule,
            StorageModule,
            MonSelectAllCheckboxModule,
            MonHttpPrefixModule,
            MonChartCustomTooltipModule,
            SwitchButtonModule,
            PipesModule,
            MonPromptModule,
            MonTableSpoilerAccordionModule,
            MonSimpleDateRangeModule,
            MonPopupModule,
            AccessibleChartWrapperModule,
            TableFiltersModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AngularSharedComponentsModule, [{
        type: NgModule,
        args: [{
                imports: [MonPromptModule, TranslateModule],
                exports: [...exportASCModules],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(AngularSharedComponentsModule, { imports: [MonPromptModule, TranslateModule], exports: [FormBuilderDynamicModule,
        FormBuilderDynamicAcModule,
        TableModule,
        TableSearchModule,
        FilterButtonModule,
        MonAvatarModule,
        LayoutModule,
        LabelModule,
        FormLabelModule,
        MonTableSortModule,
        ToastModule,
        TabsModule,
        ConfirmModule,
        MonDatePickerModule,
        RollbarModule,
        DialogModule,
        FormsBuilderModule,
        EventsModule,
        MonEventTriggerModule,
        PromptModule,
        ColorPickerModule,
        TranslateModule,
        StorageModule,
        MonSelectAllCheckboxModule,
        MonHttpPrefixModule,
        MonChartCustomTooltipModule,
        SwitchButtonModule,
        PipesModule,
        MonPromptModule,
        MonTableSpoilerAccordionModule,
        MonSimpleDateRangeModule,
        MonPopupModule,
        AccessibleChartWrapperModule,
        TableFiltersModule] }); })();

class ChartService {
    areAllDataRowsEmpty(data) {
        if (!Array.isArray(data)) {
            return true;
        }
        for (const el of data) {
            if (Array.isArray(el)) {
                if (Array.isArray(el.data) && el.data.length > 0) {
                    return false;
                }
            }
            else {
                return false;
            }
        }
        return true;
    }
    getNewDataSeriesColor(oldData, colors) {
        if (colors?.length && Array.isArray(oldData)) {
            return oldData.map((data, index) => {
                if (colors[index]) {
                    return {
                        ...data,
                        backgroundColor: colors[index],
                        borderColor: colors[index],
                        pointBorderColor: colors[index],
                        pointBackgroundColor: colors[index],
                    };
                }
                return data;
            });
        }
        return oldData;
    }
    getNewSingleDataSeriesColors(oldData, colors) {
        if (colors?.length) {
            const newData = {
                ...oldData,
                backgroundColor: colors,
            };
            return newData;
        }
        return oldData;
    }
    getNewDataseriesLabel(oldData, series) {
        if (series && series.length && Array.isArray(oldData)) {
            return oldData.map((data, index) => {
                if (series[index]) {
                    return {
                        ...data,
                        label: series[index],
                    };
                }
                return data;
            });
        }
        return oldData;
    }
    getNewOverrideDataseries(oldData, override) {
        if (override?.length && Array.isArray(oldData)) {
            return oldData.map((data, index) => {
                if (override[index]) {
                    return {
                        ...data,
                        ...override[index],
                    };
                }
                return data;
            });
        }
        return oldData;
    }
    isTextOutOfContainer(ctx, text, chart) {
        const innerRadius = chart.getDatasetMeta(0)?.data[0]?.innerRadius;
        const outerRadius = chart.getDatasetMeta(0)?.data[0]?.outerRadius;
        const radiusLength = outerRadius - innerRadius;
        return (ctx.measureText(text).width >
            chart.width - 2 * radiusLength - chart.height / 10);
    }
    calculateScale(ctx, centerLineLength, text) {
        return centerLineLength / ctx.measureText(text).width;
    }
    scaledX(chart, centerLineLength, text) {
        const ctx = chart.ctx;
        const width = chart.width;
        return ((width -
            (ctx.measureText(text).width * centerLineLength) /
                ctx.measureText(text).width) /
            2 /
            (centerLineLength / ctx.measureText(text).width));
    }
    scaledY(chart, centerLineLength, text, baseY) {
        const ctx = chart.ctx;
        const height = chart.height;
        return ((baseY * height) / (centerLineLength / ctx.measureText(text).width));
    }
    drawText(chart, ctx, text, textSize, fontWeight, topPercentage, centerLineLength) {
        let textX;
        let textY;
        let scale;
        const width = chart.width;
        const height = chart.height;
        ctx.font = fontWeight + ' ' + textSize + 'em Roboto';
        if (centerLineLength && this.isTextOutOfContainer(ctx, text, chart)) {
            scale = this.calculateScale(ctx, centerLineLength, text);
            ctx.scale(scale, scale);
            textX = this.scaledX(chart, centerLineLength, text);
            textY = this.scaledY(chart, centerLineLength, text, topPercentage);
        }
        else {
            textX = Math.round((width - ctx.measureText(text).width) / 2);
            textY = height * topPercentage;
        }
        ctx.fillText(text, textX, textY);
    }
    drawLine(ctx, startX, startY, endX, endY, color = '#eeeeee', width = 1) {
        ctx.beginPath();
        ctx.moveTo(startX, startY);
        ctx.lineTo(endX, endY);
        ctx.strokeStyle = color;
        ctx.lineWidth = width;
        ctx.stroke();
    }
    removeDecimals(str) {
        const regex = /\d*\.\d*/;
        let num;
        if (str.indexOf('/') !== -1) {
            const res = str.split('/');
            for (let i = 0; i < res.length; i++) {
                if (res[i].indexOf('.') !== -1) {
                    num = parseFloat(res[i].match(regex)[0]).toString();
                    if (num === '100' || num === '0') {
                        res[i] = res[i].replace(regex, parseInt(num, 10).toString());
                    }
                }
            }
            return res.join('/');
        }
        else {
            if (str.indexOf('.') !== -1) {
                num = parseFloat(str.match(regex)[0]).toString();
                if (num === '100' || num === '0') {
                    return str.replace(regex, parseInt(num, 10).toString());
                }
            }
            return str;
        }
    }
    static { this.ɵfac = function ChartService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ChartService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ChartService, factory: ChartService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ChartService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], null, null); })();

const chartService = new ChartService();
const CHART = {
    HEIGHT: 340,
    CUTOUT: '70%',
    COLORS: {
        LIGHT_BLUE: '#299bf7',
        PEACH: '#ff9879',
        DARK_GREEN_BLUE: '#052942',
        YELLOW: '#fdc50d',
        PURPLE: '#5e3ea8',
        LIGHT_TURQUOISE: '#7beaf3',
        ORANGE: '#ff6c00',
        GREEN_BLUE: '#007a9e',
        LIGHT_PURPLE: '#837bc1',
        CERISE: '#d6347b',
        DARK_BLUE: '#004ac1',
        TURQUOISE: '#00dedb',
        RED: '#ba322d',
        LIGHT_YELLOW: '#efc271',
        PINK: '#f398c4',
        GRAY: '#9a9d9e',
        DARK_GRAY: '#555557',
        GREEN: '#26ff5c',
        LIGHT_GRAY: '#dfdfde',
        BLUE: '#205c9e',
    },
    PLUGINS: {
        beforeDraw: (chart) => {
            let width;
            let height;
            let ctx;
            if (chart.config.options.chartArea) {
                const chartArea = chart.chartArea;
                const chatAreaWidth = chartArea.right - chartArea.left;
                const backgroundAreas = chart.config.options.backgroundAreas;
                const yScale = chart.scales.y;
                ctx = chart.ctx;
                ctx.save();
                for (const el of backgroundAreas) {
                    const area = el;
                    const top = yScale.getPixelForValue(Number(area.range[1]));
                    height = yScale.getPixelForValue(Number(area.range[0])) - top;
                    ctx.fillStyle = area.color;
                    ctx.fillRect(chartArea.left, top, chatAreaWidth, height);
                    ctx.restore();
                }
            }
            if (chart.config.type === 'doughnut' ||
                chart.config.type === 'pie') {
                // Draw square doughnut chart canvas container
                chart.config.options.maintainAspectRatio = true;
            }
            if (chart.config.type === 'doughnut' &&
                chart.config.options.centerText) {
                const innerRadius = chart.getDatasetMeta(0)?.data[0]?.innerRadius;
                const outerRadius = chart.getDatasetMeta(0)?.data[0]?.outerRadius;
                const radiusLength = outerRadius - innerRadius;
                // Draw text inside doughnut chart
                width = chart.width;
                height = chart.height;
                ctx = chart.ctx;
                const lowestRange = width > height ? height : width;
                const centerText = chart.config.options.centerText;
                const totalFontSize = centerText.totalFontSize
                    ? parseInt((lowestRange / centerText.totalFontSize).toFixed(2), 10)
                    : parseInt((lowestRange / 250).toFixed(2), 10);
                const percentageFontSize = centerText.percentageFontSize
                    ? (lowestRange / centerText.percentageFontSize).toFixed(2)
                    : (lowestRange / 100).toFixed(2);
                const subFontSize = centerText.subFontSize
                    ? parseInt((lowestRange / centerText.subFontSize).toFixed(2), 10)
                    : parseInt((lowestRange / 250).toFixed(2), 10);
                const totalFontWeight = centerText.totalFontWeight || '300';
                const percentageFontWeight = centerText.percentageFontWeight || '400';
                const subFontWeight = centerText.subFontWeight || '300';
                let hasPercentage = false;
                let hasTotalLabel = false;
                let hasSubLabel = false;
                let percentageLabel;
                let totalLabel;
                let subLabel;
                if (centerText.percentageLabel) {
                    hasPercentage = true;
                    percentageLabel = chartService.removeDecimals(centerText.percentageLabel);
                }
                if (centerText.totalLabel) {
                    hasTotalLabel = true;
                    totalLabel = centerText.totalLabel;
                }
                if (centerText.subLabel) {
                    hasSubLabel = true;
                    subLabel = centerText.subLabel;
                }
                const centerLineLength = width - 2 * radiusLength - height / 10;
                // Draw only percentage label
                if (hasPercentage && !hasTotalLabel && !hasSubLabel) {
                    ctx.restore();
                    ctx.textBaseline = 'middle';
                    chartService.drawText(chart, ctx, percentageLabel, percentageFontSize, percentageFontWeight, 0.5, 0);
                    ctx.save();
                }
                // Draw only total (main) label
                if (!hasPercentage && hasTotalLabel && !hasSubLabel) {
                    ctx.restore();
                    ctx.textBaseline = 'middle';
                    chartService.drawText(chart, ctx, totalLabel, totalFontSize, totalFontWeight, 0.5, centerLineLength);
                    ctx.save();
                }
                if (hasPercentage && hasTotalLabel && !hasSubLabel) {
                    ctx.restore();
                    ctx.textBaseline = 'middle';
                    chartService.drawText(chart, ctx, percentageLabel, percentageFontSize, percentageFontWeight, 0.4, 0);
                    ctx.save();
                    chartService.drawText(chart, ctx, totalLabel, totalFontSize, totalFontWeight, 0.505 + (totalFontSize * 10) / height, centerLineLength);
                    ctx.restore();
                    // Draw horizontal line
                    chartService.drawLine(ctx, radiusLength + height / 20, height / 2, width - radiusLength - height / 20, height / 2);
                    ctx.save();
                }
                // Draw all labels and horizontal line
                if (hasPercentage && hasTotalLabel && hasSubLabel) {
                    ctx.restore();
                    ctx.textBaseline = 'middle';
                    chartService.drawText(chart, ctx, percentageLabel, percentageFontSize, percentageFontWeight, 0.4, 0);
                    ctx.save();
                    chartService.drawText(chart, ctx, totalLabel, totalFontSize, totalFontWeight, 0.505 + (totalFontSize * 10) / height, centerLineLength);
                    ctx.restore();
                    chartService.drawText(chart, ctx, subLabel, subFontSize, subFontWeight, 0.515 +
                        (totalFontSize * 15) / height +
                        (subFontSize * 10) / height, centerLineLength);
                    ctx.restore();
                    // Draw horizontal line
                    chartService.drawLine(ctx, radiusLength + height / 20, height / 2, width - radiusLength - height / 20, height / 2);
                    ctx.save();
                }
            }
        },
        beforeDatasetsDraw: (chart) => {
            const ctx = chart.ctx;
            if (chart.config.options.horizontalLines &&
                chart.config.options.horizontalLines.length > 0) {
                const yScale = chart.scales.y;
                const xScale = chart.scales.x;
                let yValue;
                let line;
                for (const el of chart.config.options.horizontalLines) {
                    line = el;
                    ctx.save();
                    yValue = yScale.getPixelForValue(Number(line.value));
                    chartService.drawLine(ctx, xScale.getPixelForTick(0), yValue, chart.chartArea.right, yValue, line.style, line.width);
                    ctx.restore();
                }
            }
        },
        afterDatasetsDraw: (chart) => {
            const ctx = chart.ctx;
            const options = chart.config.options;
            if (options.drawLabelOnChart) {
                chart.data.datasets.forEach((dataset, i) => {
                    const meta = chart.getDatasetMeta(i);
                    if (!meta.hidden) {
                        meta.data.forEach((element, index) => {
                            const dataString = dataset.data[index].toString();
                            const padding = 5;
                            const position = element.tooltipPosition(true);
                            ctx.font = '400 1.1em Roboto';
                            ctx.textAlign = 'center';
                            ctx.textBaseline = 'middle';
                            ctx.fillStyle = 'rgb(166,166,166)';
                            ctx.fillText(dataString, position.x, position.y - 8 - padding);
                        });
                    }
                });
            }
        },
        afterDraw: (chart) => {
            const ctx = chart.ctx;
            if (chart.data) {
                const horizontalLinesToDraw = [];
                const hiddenLines = [];
                chart.legend.legendItems.forEach((legendItem, index) => {
                    if (legendItem.hidden === true) {
                        hiddenLines.push(index);
                    }
                });
                chart.data.datasets.forEach((dataset, index) => {
                    if (dataset.data.length === 1 &&
                        dataset.type === 'line' &&
                        hiddenLines.indexOf(index) === -1) {
                        horizontalLinesToDraw.push({
                            value: dataset.data[0].toString(),
                            xScale: dataset.xAxisID || 'x',
                            yScale: dataset.yAxisID || 'y',
                            color: dataset.borderColor.toString(),
                        });
                    }
                });
                horizontalLinesToDraw.forEach((line) => {
                    ctx.save();
                    chartService.drawLine(ctx, chart.scales[line.xScale].left, chart.scales[line.yScale].getPixelForValue(Number(line.value)), chart.scales[line.xScale].right, chart.scales[line.yScale].getPixelForValue(Number(line.value)), line.color);
                    ctx.restore();
                });
            }
        },
    },
};

class BaseChart {
    getOptions(newOptions) {
        const defaultOptions = {
            plugins: {
                legend: {
                    display: false,
                    onHover: (event) => {
                        event.native.target.style.cursor = 'pointer';
                    },
                    onLeave: (event) => {
                        event.native.target.style.cursor = 'default';
                    },
                },
            },
            transitions: {
                active: {
                    animation: {
                        duration: 0,
                    },
                },
            },
            responsive: true,
            maintainAspectRatio: false,
        };
        return merge(defaultOptions, newOptions);
    }
}

const _c0$7 = a0 => ({ "height.px": a0 });
function BarComponent_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4)(1, "span", 5);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.emptyDataMessage, " ");
} }
function BarComponent_div_0_canvas_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "canvas", 6);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("height", ctx_r0.height);
    i0.ɵɵproperty("type", ctx_r0.barChartType)("data", ctx_r0.barChartData)("options", ctx_r0.options)("plugins", ctx_r0.plugins)("labels", ctx_r0.labels);
    i0.ɵɵattribute("aria-label", ctx_r0.ariaLabel);
} }
function BarComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 1);
    i0.ɵɵtemplate(2, BarComponent_div_0_div_2_Template, 3, 1, "div", 2)(3, BarComponent_div_0_canvas_3_Template, 1, 7, "canvas", 3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(3, _c0$7, ctx_r0.height));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.emptyDataMessage.length > 0 && ctx_r0.areDataRowsEmpty);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.areDataRowsEmpty);
} }
class BarComponent extends BaseChart {
    set data(newData) {
        this._datasets = this.chartService.getNewDataseriesLabel(newData, this.series);
        this._datasets = this.chartService.getNewDataSeriesColor(newData, this.colors);
        this._datasets = this.chartService.getNewOverrideDataseries(this._datasets, this.override);
        this.areDataRowsEmpty = this.chartService.areAllDataRowsEmpty(this._datasets);
    }
    get data() {
        return this._datasets;
    }
    constructor(translateService, chartService) {
        super();
        this.translateService = translateService;
        this.chartService = chartService;
        this.height = CHART.HEIGHT;
        this.emptyDataMessage = this.translateService.getString('No data present');
        this.loading = false;
        this.ariaLabel = this.translateService.getString('Bar chart representing data');
        this.chartRefChange = new EventEmitter();
        this.areDataRowsEmpty = true;
        this.plugins = [CHART.PLUGINS];
        this.barChartType = 'bar';
    }
    ngAfterViewInit() {
        setTimeout(() => {
            if (this.chartRef) {
                this.chartRefChange.emit(this.chartRef);
            }
        });
    }
    ngOnInit() {
        this.colors = this.colors || [
            CHART.COLORS.LIGHT_BLUE,
            CHART.COLORS.BLUE,
            CHART.COLORS.LIGHT_GRAY,
            CHART.COLORS.GREEN,
            CHART.COLORS.ORANGE,
            CHART.COLORS.GRAY,
            CHART.COLORS.DARK_GRAY,
        ];
        this.options = {
            ...this.options,
            ...{
                plugins: {
                    legend: this.options?.plugins?.legend
                        ? this.options.plugins.legend
                        : { display: false },
                },
                maintainAspectRatio: false,
                transitions: {
                    active: {
                        animation: {
                            duration: 0,
                        },
                    },
                },
            },
        };
        this.data = this.chartService.getNewDataseriesLabel(this.data, this.series);
        this.data = this.chartService.getNewDataSeriesColor(this.data, this.colors);
        this.data = this.chartService.getNewOverrideDataseries(this.data, this.override);
        this.barChartData = {
            labels: this.labels,
            datasets: this._datasets,
        };
    }
    static { this.ɵfac = function BarComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || BarComponent)(i0.ɵɵdirectiveInject(TranslateServiceInjectionToken), i0.ɵɵdirectiveInject(ChartService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BarComponent, selectors: [["mon-bar-chart"]], viewQuery: function BarComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(BaseChartDirective, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chartRef = _t.first);
        } }, inputs: { data: "data", options: "options", override: "override", labels: "labels", series: "series", colors: "colors", height: "height", emptyDataMessage: "emptyDataMessage", loading: "loading", ariaLabel: "ariaLabel" }, outputs: { chartRefChange: "chartRefChange" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[4, "ngIf"], [1, "position-relative", 3, "ngStyle"], ["class", "charts-overlay", 4, "ngIf"], ["baseChart", "", "class", "chart-bar", "role", "img", 3, "type", "data", "options", "plugins", "labels", "height", 4, "ngIf"], [1, "charts-overlay"], [1, "charts-overlay-text"], ["baseChart", "", "role", "img", 1, "chart-bar", 3, "type", "data", "options", "plugins", "labels", "height"]], template: function BarComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, BarComponent_div_0_Template, 4, 5, "div", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", !ctx.loading);
        } }, dependencies: [i1$2.NgIf, i1$2.NgStyle, i3$1.BaseChartDirective], styles: [".charts-overlay[_ngcontent-%COMP%]{height:100%;width:100%;padding:0;margin:0;display:flex;align-items:center;justify-content:center;position:absolute}.charts-overlay[_ngcontent-%COMP%]   .charts-overlay-text[_ngcontent-%COMP%]{opacity:.8;background-color:#e6e6e6;padding:5px;border-radius:5px;color:#000;text-align:center}.mon-tooltip[_ngcontent-%COMP%]{background:#000000b3;border-radius:5px;color:#fff;opacity:1;pointer-events:none;position:absolute;transform:translate(-50%);transition:all .1s ease;padding:2px 5px;font-size:12px;font-style:normal;font-family:inherit;overflow:auto;line-height:1.5}.mon-tooltip[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]{margin:0}.mon-tooltip[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%], .mon-tooltip[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{border-width:0}.mon-tooltip[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]{background-color:inherit;border-width:0}.mon-tooltip[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{padding:0}.mon-tooltip[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{border-width:1px;border-style:solid;margin-right:1px;height:10px;width:10px;display:inline-block}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BarComponent, [{
        type: Component,
        args: [{ selector: 'mon-bar-chart', template: "<div *ngIf=\"!loading\">\n    <div class=\"position-relative\" [ngStyle]=\"{'height.px': height}\">\n        <div *ngIf=\"emptyDataMessage.length > 0 && areDataRowsEmpty\"\n             class=\"charts-overlay\">\n            <span class=\"charts-overlay-text\">\n                {{ emptyDataMessage }}\n            </span>\n        </div>\n        <canvas *ngIf=\"!areDataRowsEmpty\"\n                baseChart\n                [type]=\"barChartType\"\n                [data]=\"barChartData\"\n                [options]=\"options\"\n                [plugins]=\"plugins\"\n                [labels]=\"labels\"\n                height=\"{{ height }}\"\n                class=\"chart-bar\"\n                [attr.aria-label]=\"ariaLabel\"\n                role=\"img\">\n        </canvas>\n    </div>\n</div>\n", styles: [".charts-overlay{height:100%;width:100%;padding:0;margin:0;display:flex;align-items:center;justify-content:center;position:absolute}.charts-overlay .charts-overlay-text{opacity:.8;background-color:#e6e6e6;padding:5px;border-radius:5px;color:#000;text-align:center}.mon-tooltip{background:#000000b3;border-radius:5px;color:#fff;opacity:1;pointer-events:none;position:absolute;transform:translate(-50%);transition:all .1s ease;padding:2px 5px;font-size:12px;font-style:normal;font-family:inherit;overflow:auto;line-height:1.5}.mon-tooltip table{margin:0}.mon-tooltip table thead tr,.mon-tooltip table thead th{border-width:0}.mon-tooltip table tbody tr{background-color:inherit;border-width:0}.mon-tooltip table tbody tr td{padding:0}.mon-tooltip table tbody tr td span{border-width:1px;border-style:solid;margin-right:1px;height:10px;width:10px;display:inline-block}\n"] }]
    }], () => [{ type: undefined, decorators: [{
                type: Inject,
                args: [TranslateServiceInjectionToken]
            }] }, { type: ChartService }], { data: [{
            type: Input
        }], options: [{
            type: Input
        }], override: [{
            type: Input
        }], labels: [{
            type: Input
        }], series: [{
            type: Input
        }], colors: [{
            type: Input
        }], height: [{
            type: Input
        }], emptyDataMessage: [{
            type: Input
        }], loading: [{
            type: Input
        }], ariaLabel: [{
            type: Input
        }], chartRef: [{
            type: ViewChild,
            args: [BaseChartDirective]
        }], chartRefChange: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(BarComponent, { className: "BarComponent" }); })();

const _c0$6 = a0 => ({ "height.px": a0 });
class BubbleComponent extends BaseChart {
    set data(newData) {
        this._datasets = this.chartService.getNewDataseriesLabel(newData, this.series);
        this._datasets = this.chartService.getNewDataSeriesColor(newData, this.colors);
        this._datasets = this.chartService.getNewOverrideDataseries(this._datasets, this.override);
    }
    get data() {
        return this._datasets;
    }
    constructor(translateService, chartService) {
        super();
        this.translateService = translateService;
        this.chartService = chartService;
        this.height = CHART.HEIGHT;
        this.emptyDataMessage = this.translateService.getString('No data present');
        this.ariaLabel = this.translateService.getString('Bubble chart representing data');
        this.chartRefChange = new EventEmitter();
        this.plugins = [CHART.PLUGINS];
        this.bubbleChartType = 'bubble';
    }
    ngAfterViewInit() {
        setTimeout(() => {
            if (this.chartRef) {
                this.chartRefChange.emit(this.chartRef);
            }
        });
    }
    ngOnInit() {
        this.colors = this.colors || [
            CHART.COLORS.LIGHT_BLUE,
            CHART.COLORS.BLUE,
            CHART.COLORS.LIGHT_GRAY,
            CHART.COLORS.GREEN,
            CHART.COLORS.ORANGE,
            CHART.COLORS.GRAY,
            CHART.COLORS.DARK_GRAY,
        ];
        this.plugins = [CHART.PLUGINS];
        this.options = {
            ...this.options,
            ...{
                plugins: {
                    legend: this.options?.plugins?.legend
                        ? this.options.plugins.legend
                        : { display: false },
                },
            },
            maintainAspectRatio: false,
            transitions: {
                active: {
                    animation: {
                        duration: 0,
                    },
                },
            },
        };
        this.options = this.getOptions(this.options);
        this._datasets = this.chartService.getNewDataseriesLabel(this._datasets, this.series);
        this._datasets[0] = this.chartService.getNewSingleDataSeriesColors(this._datasets[0], this.colors);
        this._datasets = this.chartService.getNewOverrideDataseries(this._datasets, this.override);
        this.bubbleChartData = {
            labels: this.labels,
            datasets: this._datasets,
        };
    }
    static { this.ɵfac = function BubbleComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || BubbleComponent)(i0.ɵɵdirectiveInject(TranslateServiceInjectionToken), i0.ɵɵdirectiveInject(ChartService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BubbleComponent, selectors: [["mon-bubble-chart"]], viewQuery: function BubbleComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(BaseChartDirective, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chartRef = _t.first);
        } }, inputs: { data: "data", options: "options", override: "override", labels: "labels", series: "series", colors: "colors", height: "height", emptyDataMessage: "emptyDataMessage", ariaLabel: "ariaLabel" }, outputs: { chartRefChange: "chartRefChange" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 2, vars: 10, consts: [[1, "mon-chart-bubble", "position-relative", 3, "ngStyle"], ["baseChart", "", "role", "img", 1, "chart-bubble", 3, "type", "data", "options", "plugins", "labels", "height"]], template: function BubbleComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵelement(1, "canvas", 1);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(8, _c0$6, ctx.height));
            i0.ɵɵadvance();
            i0.ɵɵpropertyInterpolate("height", ctx.height);
            i0.ɵɵproperty("type", ctx.bubbleChartType)("data", ctx.bubbleChartData)("options", ctx.options)("plugins", ctx.plugins)("labels", ctx.labels);
            i0.ɵɵattribute("aria-label", ctx.ariaLabel);
        } }, dependencies: [i1$2.NgStyle, i3$1.BaseChartDirective], styles: [".charts-overlay[_ngcontent-%COMP%]{height:100%;width:100%;padding:0;margin:0;display:flex;align-items:center;justify-content:center;position:absolute}.charts-overlay[_ngcontent-%COMP%]   .charts-overlay-text[_ngcontent-%COMP%]{opacity:.8;background-color:#e6e6e6;padding:5px;border-radius:5px;color:#000;text-align:center}.mon-tooltip[_ngcontent-%COMP%]{background:#000000b3;border-radius:5px;color:#fff;opacity:1;pointer-events:none;position:absolute;transform:translate(-50%);transition:all .1s ease;padding:2px 5px;font-size:12px;font-style:normal;font-family:inherit;overflow:auto;line-height:1.5}.mon-tooltip[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]{margin:0}.mon-tooltip[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%], .mon-tooltip[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{border-width:0}.mon-tooltip[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]{background-color:inherit;border-width:0}.mon-tooltip[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{padding:0}.mon-tooltip[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{border-width:1px;border-style:solid;margin-right:1px;height:10px;width:10px;display:inline-block}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BubbleComponent, [{
        type: Component,
        args: [{ selector: 'mon-bubble-chart', template: "<div class=\"mon-chart-bubble position-relative\" [ngStyle]=\"{'height.px': height}\">\n    <canvas baseChart\n            [type]=\"bubbleChartType\"\n            [data]=\"bubbleChartData\"\n            [options]=\"options\"\n            [plugins]=\"plugins\"\n            [labels]=\"labels\"\n            class=\"chart-bubble\"\n            height=\"{{ height }}\"\n            [attr.aria-label]=\"ariaLabel\"\n            role=\"img\">\n    </canvas>\n</div>\n", styles: [".charts-overlay{height:100%;width:100%;padding:0;margin:0;display:flex;align-items:center;justify-content:center;position:absolute}.charts-overlay .charts-overlay-text{opacity:.8;background-color:#e6e6e6;padding:5px;border-radius:5px;color:#000;text-align:center}.mon-tooltip{background:#000000b3;border-radius:5px;color:#fff;opacity:1;pointer-events:none;position:absolute;transform:translate(-50%);transition:all .1s ease;padding:2px 5px;font-size:12px;font-style:normal;font-family:inherit;overflow:auto;line-height:1.5}.mon-tooltip table{margin:0}.mon-tooltip table thead tr,.mon-tooltip table thead th{border-width:0}.mon-tooltip table tbody tr{background-color:inherit;border-width:0}.mon-tooltip table tbody tr td{padding:0}.mon-tooltip table tbody tr td span{border-width:1px;border-style:solid;margin-right:1px;height:10px;width:10px;display:inline-block}\n"] }]
    }], () => [{ type: undefined, decorators: [{
                type: Inject,
                args: [TranslateServiceInjectionToken]
            }] }, { type: ChartService }], { data: [{
            type: Input
        }], options: [{
            type: Input
        }], override: [{
            type: Input
        }], labels: [{
            type: Input
        }], series: [{
            type: Input
        }], colors: [{
            type: Input
        }], height: [{
            type: Input
        }], emptyDataMessage: [{
            type: Input
        }], ariaLabel: [{
            type: Input
        }], chartRef: [{
            type: ViewChild,
            args: [BaseChartDirective]
        }], chartRefChange: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(BubbleComponent, { className: "BubbleComponent" }); })();

const DOUGHNUT_CHART = {
    DEFAULT_OPTIONS: {
        cutout: CHART.CUTOUT,
    },
};

const _c0$5 = (a0, a1) => ({ "height.px": a0, "width.px": a1 });
class DoughnutComponent extends BaseChart {
    constructor(translateService, chartService) {
        super();
        this.translateService = translateService;
        this.chartService = chartService;
        this.size = CHART.HEIGHT;
        this.emptyDataMessage = this.translateService.getString('No data present');
        this.ariaLabel = this.translateService.getString('Doughnut chart representing data');
        this.chartRefChange = new EventEmitter();
        this.doughnutChartType = 'doughnut';
        this.plugins = [CHART.PLUGINS];
    }
    ngOnInit() {
    }
    ngAfterViewInit() {
        setTimeout(() => {
            if (this.chartRef) {
                this.chartRefChange.emit(this.chartRef);
            }
        });
    }
    ngOnChanges(changes) {
        if (changes) {
            this.update();
        }
    }
    initBaseOptions() {
        this.colors = this.colors || [CHART.COLORS.GREEN_BLUE, CHART.COLORS.LIGHT_GRAY];
        this.options = {
            ...DOUGHNUT_CHART.DEFAULT_OPTIONS,
            ...this.options,
        };
        this.options = this.getOptions(this.options);
        this.data = this.chartService.getNewSingleDataSeriesColors(this.data, this.colors);
        this.doughnutChartData = {
            labels: this.labels,
            datasets: [this.data],
        };
    }
    /**
     * update function called onChanges
     *
     * @private
     */
    update() {
        if (!this.data) {
            return;
        }
        if (!(this.options !== null && typeof this.options === 'object')) {
            this.options = {};
        }
        if (!(this.options.centerText !== null && typeof this.options.centerText === 'object')) {
            this.options.centerText = {};
        }
        if (!this.isChartPointType(this.data.data)) {
            const newData = this.data.data.filter((data) => data > 0);
            if (newData && newData.length === 0) {
                this.data.data = [0, 1];
                this.options.centerText = {
                    totalFontSize: 150,
                    totalLabel: this.emptyDataMessage,
                };
            }
        }
        this.initBaseOptions();
    }
    /**
     * Typescript way of checking if an object is of a specific type.
     * https://www.typescriptlang.org/docs/handbook/2/narrowing.html#using-type-predicates
     *
     * @param value union of potential types
     * @private
     */
    isChartPointType(value) {
        return (value[0]?.x !== undefined ||
            value[0]?.y !== undefined ||
            value[0]?.r !== undefined ||
            value[0]?.t !== undefined);
    }
    static { this.ɵfac = function DoughnutComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DoughnutComponent)(i0.ɵɵdirectiveInject(TranslateServiceInjectionToken), i0.ɵɵdirectiveInject(ChartService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DoughnutComponent, selectors: [["mon-doughnut-chart"]], viewQuery: function DoughnutComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(BaseChartDirective, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chartRef = _t.first);
        } }, inputs: { size: "size", emptyDataMessage: "emptyDataMessage", labels: "labels", data: "data", options: "options", colors: "colors", ariaLabel: "ariaLabel" }, outputs: { chartRefChange: "chartRefChange" }, features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature], decls: 3, vars: 9, consts: [[1, "mon-chart"], [1, "doughnut", "position-relative", 3, "ngStyle"], ["baseChart", "", "role", "img", 1, "chart", "chart-doughnut", 3, "options", "data", "type", "plugins"]], template: function DoughnutComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵelement(2, "canvas", 2);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction2(6, _c0$5, ctx.size, ctx.size));
            i0.ɵɵadvance();
            i0.ɵɵproperty("options", ctx.options)("data", ctx.doughnutChartData)("type", ctx.doughnutChartType)("plugins", ctx.plugins);
            i0.ɵɵattribute("aria-label", ctx.ariaLabel);
        } }, dependencies: [i1$2.NgStyle, i3$1.BaseChartDirective], styles: [".charts-overlay[_ngcontent-%COMP%]{height:100%;width:100%;padding:0;margin:0;display:flex;align-items:center;justify-content:center;position:absolute}.charts-overlay[_ngcontent-%COMP%]   .charts-overlay-text[_ngcontent-%COMP%]{opacity:.8;background-color:#e6e6e6;padding:5px;border-radius:5px;color:#000;text-align:center}.mon-tooltip[_ngcontent-%COMP%]{background:#000000b3;border-radius:5px;color:#fff;opacity:1;pointer-events:none;position:absolute;transform:translate(-50%);transition:all .1s ease;padding:2px 5px;font-size:12px;font-style:normal;font-family:inherit;overflow:auto;line-height:1.5}.mon-tooltip[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]{margin:0}.mon-tooltip[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%], .mon-tooltip[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{border-width:0}.mon-tooltip[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]{background-color:inherit;border-width:0}.mon-tooltip[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{padding:0}.mon-tooltip[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{border-width:1px;border-style:solid;margin-right:1px;height:10px;width:10px;display:inline-block}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DoughnutComponent, [{
        type: Component,
        args: [{ selector: 'mon-doughnut-chart', template: "<div class=\"mon-chart\">\n    <div class=\"doughnut position-relative\" [ngStyle]=\"{'height.px': size, 'width.px': size}\">\n        <canvas baseChart\n                class=\"chart chart-doughnut\"\n                [options]=\"options\"\n                [data]=\"doughnutChartData\"\n                [type]=\"doughnutChartType\"\n                [plugins]=\"plugins\"\n                [attr.aria-label]=\"ariaLabel\"\n                role=\"img\">\n        </canvas>\n    </div>\n</div>\n", styles: [".charts-overlay{height:100%;width:100%;padding:0;margin:0;display:flex;align-items:center;justify-content:center;position:absolute}.charts-overlay .charts-overlay-text{opacity:.8;background-color:#e6e6e6;padding:5px;border-radius:5px;color:#000;text-align:center}.mon-tooltip{background:#000000b3;border-radius:5px;color:#fff;opacity:1;pointer-events:none;position:absolute;transform:translate(-50%);transition:all .1s ease;padding:2px 5px;font-size:12px;font-style:normal;font-family:inherit;overflow:auto;line-height:1.5}.mon-tooltip table{margin:0}.mon-tooltip table thead tr,.mon-tooltip table thead th{border-width:0}.mon-tooltip table tbody tr{background-color:inherit;border-width:0}.mon-tooltip table tbody tr td{padding:0}.mon-tooltip table tbody tr td span{border-width:1px;border-style:solid;margin-right:1px;height:10px;width:10px;display:inline-block}\n"] }]
    }], () => [{ type: undefined, decorators: [{
                type: Inject,
                args: [TranslateServiceInjectionToken]
            }] }, { type: ChartService }], { size: [{
            type: Input
        }], emptyDataMessage: [{
            type: Input
        }], labels: [{
            type: Input
        }], data: [{
            type: Input
        }], options: [{
            type: Input
        }], colors: [{
            type: Input
        }], ariaLabel: [{
            type: Input
        }], chartRef: [{
            type: ViewChild,
            args: [BaseChartDirective]
        }], chartRefChange: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DoughnutComponent, { className: "DoughnutComponent" }); })();

const _c0$4 = a0 => ({ "height.px": a0 });
class PieComponent extends BaseChart {
    constructor(translateService, chartService) {
        super();
        this.translateService = translateService;
        this.chartService = chartService;
        this.emptyDataMessage = this.translateService.getString('No data present');
        this.size = CHART.HEIGHT;
        this.ariaLabel = this.translateService.getString('Pie chart representing data');
        this.chartRefChange = new EventEmitter();
        this.plugins = [CHART.PLUGINS];
        this.pieChartType = 'pie';
    }
    ngAfterViewInit() {
        setTimeout(() => {
            if (this.chartRef) {
                this.chartRefChange.emit(this.chartRef);
            }
        });
    }
    ngOnInit() {
        this.colors = this.colors || [
            CHART.COLORS.LIGHT_BLUE,
            CHART.COLORS.BLUE,
            CHART.COLORS.LIGHT_GRAY,
            CHART.COLORS.GREEN,
            CHART.COLORS.ORANGE,
            CHART.COLORS.GRAY,
            CHART.COLORS.DARK_GRAY,
        ];
        this.plugins = [CHART.PLUGINS];
        const defaultOptions = {
            plugins: {
                legend: this.options?.plugins?.legend
                    ? this.options.plugins.legend
                    : { display: false },
            },
            maintainAspectRatio: false,
            transitions: {
                active: {
                    animation: {
                        duration: 0,
                    },
                },
            },
        };
        this.options = merge(this.options, defaultOptions);
        this.options = this.getOptions(this.options);
        this.data = this.chartService.getNewSingleDataSeriesColors(this.data, this.colors);
        this.pieChartData = {
            labels: this.labels,
            datasets: [this.data],
        };
    }
    static { this.ɵfac = function PieComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PieComponent)(i0.ɵɵdirectiveInject(TranslateServiceInjectionToken), i0.ɵɵdirectiveInject(ChartService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PieComponent, selectors: [["mon-pie-chart"]], viewQuery: function PieComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(BaseChartDirective, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chartRef = _t.first);
        } }, inputs: { data: "data", options: "options", labels: "labels", colors: "colors", emptyDataMessage: "emptyDataMessage", size: "size", ariaLabel: "ariaLabel" }, outputs: { chartRefChange: "chartRefChange" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 4, vars: 10, consts: [[1, "mon-chart"], [1, "pie", "position-relative", 3, "ngStyle"], [1, "pie", "position-relative"], ["baseChart", "", "role", "img", 1, "chart", "chart-pie", 3, "height", "width", "options", "data", "type", "plugins"]], template: function PieComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
            i0.ɵɵelement(3, "canvas", 3);
            i0.ɵɵelementEnd()()();
        } if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(8, _c0$4, ctx.size));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("height", ctx.size)("width", ctx.size)("options", ctx.options)("data", ctx.pieChartData)("type", ctx.pieChartType)("plugins", ctx.plugins);
            i0.ɵɵattribute("aria-label", ctx.ariaLabel);
        } }, dependencies: [i1$2.NgStyle, i3$1.BaseChartDirective], styles: [".charts-overlay[_ngcontent-%COMP%]{height:100%;width:100%;padding:0;margin:0;display:flex;align-items:center;justify-content:center;position:absolute}.charts-overlay[_ngcontent-%COMP%]   .charts-overlay-text[_ngcontent-%COMP%]{opacity:.8;background-color:#e6e6e6;padding:5px;border-radius:5px;color:#000;text-align:center}.mon-tooltip[_ngcontent-%COMP%]{background:#000000b3;border-radius:5px;color:#fff;opacity:1;pointer-events:none;position:absolute;transform:translate(-50%);transition:all .1s ease;padding:2px 5px;font-size:12px;font-style:normal;font-family:inherit;overflow:auto;line-height:1.5}.mon-tooltip[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]{margin:0}.mon-tooltip[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%], .mon-tooltip[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{border-width:0}.mon-tooltip[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]{background-color:inherit;border-width:0}.mon-tooltip[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{padding:0}.mon-tooltip[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{border-width:1px;border-style:solid;margin-right:1px;height:10px;width:10px;display:inline-block}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PieComponent, [{
        type: Component,
        args: [{ selector: 'mon-pie-chart', template: "<div class=\"mon-chart\">\n    <div class=\"pie position-relative\" [ngStyle]=\"{'height.px': size}\">\n    <div class=\"pie position-relative\">\n        <canvas baseChart\n                class=\"chart chart-pie\"\n                [height]=\"size\"\n                [width]=\"size\"\n                [options]=\"options\"\n                [data]=\"pieChartData\"\n                [type]=\"pieChartType\"\n                [plugins]=\"plugins\"\n                [attr.aria-label]=\"ariaLabel\"\n                role=\"img\">\n        </canvas>\n    </div>\n</div>\n", styles: [".charts-overlay{height:100%;width:100%;padding:0;margin:0;display:flex;align-items:center;justify-content:center;position:absolute}.charts-overlay .charts-overlay-text{opacity:.8;background-color:#e6e6e6;padding:5px;border-radius:5px;color:#000;text-align:center}.mon-tooltip{background:#000000b3;border-radius:5px;color:#fff;opacity:1;pointer-events:none;position:absolute;transform:translate(-50%);transition:all .1s ease;padding:2px 5px;font-size:12px;font-style:normal;font-family:inherit;overflow:auto;line-height:1.5}.mon-tooltip table{margin:0}.mon-tooltip table thead tr,.mon-tooltip table thead th{border-width:0}.mon-tooltip table tbody tr{background-color:inherit;border-width:0}.mon-tooltip table tbody tr td{padding:0}.mon-tooltip table tbody tr td span{border-width:1px;border-style:solid;margin-right:1px;height:10px;width:10px;display:inline-block}\n"] }]
    }], () => [{ type: undefined, decorators: [{
                type: Inject,
                args: [TranslateServiceInjectionToken]
            }] }, { type: ChartService }], { data: [{
            type: Input
        }], options: [{
            type: Input
        }], labels: [{
            type: Input
        }], colors: [{
            type: Input
        }], emptyDataMessage: [{
            type: Input
        }], size: [{
            type: Input
        }], ariaLabel: [{
            type: Input
        }], chartRef: [{
            type: ViewChild,
            args: [BaseChartDirective]
        }], chartRefChange: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(PieComponent, { className: "PieComponent" }); })();

const _c0$3 = a0 => ({ "height.px": a0 });
function BarlineComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "span", 4);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.emptyDataMessage, " ");
} }
function BarlineComponent_canvas_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "canvas", 5);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("data", ctx_r0.barlineChartData)("type", ctx_r0.barlineChartType)("plugins", ctx_r0.plugins)("options", ctx_r0.options)("height", ctx_r0.height);
    i0.ɵɵattribute("aria-label", ctx_r0.ariaLabel);
} }
class BarlineComponent extends BaseChart {
    set data(newData) {
        this._datasets = this.chartService.getNewDataseriesLabel(newData, this.series);
        this._datasets = this.chartService.getNewDataSeriesColor(this._datasets, this.colors);
        this._datasets = this.chartService.getNewOverrideDataseries(this._datasets, this.override);
        this.areDataRowsEmpty = this.chartService.areAllDataRowsEmpty(this._datasets);
    }
    get data() {
        return this._datasets;
    }
    constructor(translateService, chartService) {
        super();
        this.translateService = translateService;
        this.chartService = chartService;
        this.height = CHART.HEIGHT;
        this.emptyDataMessage = this.translateService.getString('No data present');
        this.ariaLabel = this.translateService.getString('Bar line chart representing');
        this.chartRefChange = new EventEmitter();
        this.areDataRowsEmpty = true;
        this.plugins = [CHART.PLUGINS];
        this.barlineChartType = 'bar';
    }
    ngAfterViewInit() {
        setTimeout(() => {
            if (this.chartRef) {
                this.chartRefChange.emit(this.chartRef);
            }
        });
    }
    ngOnInit() {
        this.initBaseOptions();
        this.setupBarLineChart();
        this._datasets = this.chartService.getNewDataseriesLabel(this._datasets, this.series);
        this._datasets = this.chartService.getNewDataSeriesColor(this._datasets, this.colors);
        this._datasets = this.chartService.getNewOverrideDataseries(this._datasets, this.override);
        this.areDataRowsEmpty = this.chartService.areAllDataRowsEmpty(this._datasets);
        this.barlineChartData = {
            labels: this.labels,
            datasets: this._datasets,
        };
    }
    chartDataSet(ID, color) {
        return {
            yAxisID: ID,
            fill: false,
            borderWidth: 2.5,
            pointHoverRadius: 6,
            pointRadius: 4,
            pointBackgroundColor: '#fff',
            pointHoverBorderColor: '#fff',
            backgroundColor: 'rgba(' + color + ', 0.2)',
            borderColor: 'rgba(' + color + ', 1)',
            pointBorderColor: 'rgba(' + color + ', 1)',
            pointHoverBackgroundColor: 'rgba(' + color + ', 1)',
            pointHitRadius: 15,
            tension: 0.1,
        };
    }
    setupBarLineChart() {
        const pushToOverride = this.override?.length === 0;
        if (this.options?.scales && pushToOverride) {
            const scalesValues = Object.values(this.options.scales);
            for (let i = 0; i < scalesValues.length; i++) {
                const scale = scalesValues[i];
                if (scale.position === 'left' || scale.position === 'right') {
                    this.override.push(this.chartDataSet(Object.keys(this.options.scales)[i], this.colors[(i % this.colors.length)]));
                }
            }
        }
        else if (!this.options?.scales) {
            if (!this.options.scales) {
                this.options.scales = {};
            }
            if (!Object.values(this.options.scales)
                .find(s => (s.position === 'left') || s.position === 'right')) {
                this.series?.forEach((data, index) => {
                    const id = data;
                    this.options.scales[id] = {
                        type: 'linear',
                        display: (index === 0),
                        position: 'left',
                        beginAtZero: true,
                        suggestedMax: 4,
                        ticks: {
                            maxTicksLimit: 5,
                        },
                    };
                    if (pushToOverride) {
                        this.override.push(this.chartDataSet(id, this.colors[(index % this.colors.length)]));
                    }
                });
            }
        }
    }
    initBaseOptions() {
        this.colors = this.colors || [
            CHART.COLORS.LIGHT_BLUE,
            CHART.COLORS.BLUE,
            CHART.COLORS.LIGHT_GRAY,
            CHART.COLORS.GREEN,
            CHART.COLORS.ORANGE,
            CHART.COLORS.GRAY,
            CHART.COLORS.DARK_GRAY,
        ];
        this.options = this.options || {
            scales: {
                x: {
                    grid: {
                        display: false,
                    },
                },
                y: {
                    grid: {
                        display: true,
                    },
                },
            },
            plugins: {
                legend: {
                    display: true,
                    position: 'bottom',
                    labels: {
                        boxWidth: 20,
                        padding: 5,
                    },
                },
                tooltip: {
                    enabled: true,
                    mode: 'x',
                    bodySpacing: 5,
                },
            },
            hover: {
                mode: 'x',
            },
        };
        this.options = {
            ...this.options,
            maintainAspectRatio: false,
            transitions: {
                active: {
                    animation: {
                        duration: 0,
                    },
                },
            },
        };
        this.options = this.getOptions(this.options);
    }
    static { this.ɵfac = function BarlineComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || BarlineComponent)(i0.ɵɵdirectiveInject(TranslateServiceInjectionToken), i0.ɵɵdirectiveInject(ChartService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BarlineComponent, selectors: [["mon-barline-chart"]], viewQuery: function BarlineComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(BaseChartDirective, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chartRef = _t.first);
        } }, inputs: { data: "data", options: "options", override: "override", labels: "labels", series: "series", colors: "colors", height: "height", emptyDataMessage: "emptyDataMessage", ariaLabel: "ariaLabel" }, outputs: { chartRefChange: "chartRefChange" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 5, consts: [[1, "mon-chart", "position-relative", 3, "ngStyle"], ["class", "charts-overlay", 4, "ngIf"], ["baseChart", "", "class", "chart-bar", "role", "img", 3, "data", "type", "plugins", "options", "height", 4, "ngIf"], [1, "charts-overlay"], [1, "charts-overlay-text"], ["baseChart", "", "role", "img", 1, "chart-bar", 3, "data", "type", "plugins", "options", "height"]], template: function BarlineComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, BarlineComponent_div_1_Template, 3, 1, "div", 1)(2, BarlineComponent_canvas_2_Template, 1, 6, "canvas", 2);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(3, _c0$3, ctx.height));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.emptyDataMessage.length > 0 && ctx.areDataRowsEmpty);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.areDataRowsEmpty);
        } }, dependencies: [i1$2.NgIf, i1$2.NgStyle, i3$1.BaseChartDirective], styles: [".charts-overlay[_ngcontent-%COMP%]{height:100%;width:100%;padding:0;margin:0;display:flex;align-items:center;justify-content:center;position:absolute}.charts-overlay[_ngcontent-%COMP%]   .charts-overlay-text[_ngcontent-%COMP%]{opacity:.8;background-color:#e6e6e6;padding:5px;border-radius:5px;color:#000;text-align:center}.mon-tooltip[_ngcontent-%COMP%]{background:#000000b3;border-radius:5px;color:#fff;opacity:1;pointer-events:none;position:absolute;transform:translate(-50%);transition:all .1s ease;padding:2px 5px;font-size:12px;font-style:normal;font-family:inherit;overflow:auto;line-height:1.5}.mon-tooltip[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]{margin:0}.mon-tooltip[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%], .mon-tooltip[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{border-width:0}.mon-tooltip[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]{background-color:inherit;border-width:0}.mon-tooltip[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{padding:0}.mon-tooltip[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{border-width:1px;border-style:solid;margin-right:1px;height:10px;width:10px;display:inline-block}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BarlineComponent, [{
        type: Component,
        args: [{ selector: 'mon-barline-chart', template: "<div class=\"mon-chart position-relative\" [ngStyle]=\"{'height.px': height}\">\n    <div *ngIf=\"emptyDataMessage.length > 0 && areDataRowsEmpty\"\n         class=\"charts-overlay\">\n        <span class=\"charts-overlay-text\">\n            {{ emptyDataMessage }}\n        </span>\n    </div>\n    <canvas baseChart\n            *ngIf=\"!areDataRowsEmpty\"\n            [data]=\"barlineChartData\"\n            [type]=\"barlineChartType\"\n            [plugins]=\"plugins\"\n            [options]=\"options\"\n            class=\"chart-bar\"\n            [height]=\"height\"\n            [attr.aria-label]=\"ariaLabel\"\n            role=\"img\">\n    </canvas>\n</div>\n", styles: [".charts-overlay{height:100%;width:100%;padding:0;margin:0;display:flex;align-items:center;justify-content:center;position:absolute}.charts-overlay .charts-overlay-text{opacity:.8;background-color:#e6e6e6;padding:5px;border-radius:5px;color:#000;text-align:center}.mon-tooltip{background:#000000b3;border-radius:5px;color:#fff;opacity:1;pointer-events:none;position:absolute;transform:translate(-50%);transition:all .1s ease;padding:2px 5px;font-size:12px;font-style:normal;font-family:inherit;overflow:auto;line-height:1.5}.mon-tooltip table{margin:0}.mon-tooltip table thead tr,.mon-tooltip table thead th{border-width:0}.mon-tooltip table tbody tr{background-color:inherit;border-width:0}.mon-tooltip table tbody tr td{padding:0}.mon-tooltip table tbody tr td span{border-width:1px;border-style:solid;margin-right:1px;height:10px;width:10px;display:inline-block}\n"] }]
    }], () => [{ type: undefined, decorators: [{
                type: Inject,
                args: [TranslateServiceInjectionToken]
            }] }, { type: ChartService }], { data: [{
            type: Input
        }], options: [{
            type: Input
        }], override: [{
            type: Input
        }], labels: [{
            type: Input
        }], series: [{
            type: Input
        }], colors: [{
            type: Input
        }], height: [{
            type: Input
        }], emptyDataMessage: [{
            type: Input
        }], ariaLabel: [{
            type: Input
        }], chartRef: [{
            type: ViewChild,
            args: [BaseChartDirective]
        }], chartRefChange: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(BarlineComponent, { className: "BarlineComponent" }); })();

const _c0$2 = a0 => ({ "height.px": a0 });
class HorizontalBarComponent extends BaseChart {
    set data(newData) {
        this._datasets = this.chartService.getNewDataseriesLabel(newData, this.series);
        this._datasets = this.chartService.getNewDataSeriesColor(this._datasets, this.colors);
        this._datasets = this.chartService.getNewOverrideDataseries(this._datasets, this.override);
    }
    get data() {
        return this._datasets;
    }
    constructor(translateService, chartService) {
        super();
        this.translateService = translateService;
        this.chartService = chartService;
        this.height = CHART.HEIGHT;
        this.emptyDataMessage = this.translateService.getString('No data present');
        this.chartRefChange = new EventEmitter();
        this.plugins = [CHART.PLUGINS];
        this.barChartType = 'bar';
    }
    ngAfterViewInit() {
        setTimeout(() => {
            if (this.chartRef) {
                this.chartRefChange.emit(this.chartRef);
            }
        });
    }
    ngOnInit() {
        this.colors = this.colors || [
            CHART.COLORS.LIGHT_BLUE,
            CHART.COLORS.BLUE,
            CHART.COLORS.LIGHT_GRAY,
            CHART.COLORS.GREEN,
            CHART.COLORS.ORANGE,
            CHART.COLORS.GRAY,
            CHART.COLORS.DARK_GRAY,
        ];
        this.plugins = [CHART.PLUGINS];
        this.options = {
            ...this.options,
            ...{
                indexAxis: 'y',
                plugins: {
                    legend: this.options?.plugins?.legend
                        ? this.options.plugins.legend
                        : { display: false },
                },
                maintainAspectRatio: false,
            },
            transitions: {
                active: {
                    animation: {
                        duration: 0,
                    },
                },
            },
        };
        this.options = this.getOptions(this.options);
        this._datasets = this.chartService.getNewDataseriesLabel(this._datasets, this.series);
        this._datasets = this.chartService.getNewDataSeriesColor(this._datasets, this.colors);
        this._datasets = this.chartService.getNewOverrideDataseries(this._datasets, this.override);
        this.barChartData = {
            labels: this.labels,
            datasets: this._datasets,
        };
    }
    static { this.ɵfac = function HorizontalBarComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || HorizontalBarComponent)(i0.ɵɵdirectiveInject(TranslateServiceInjectionToken), i0.ɵɵdirectiveInject(ChartService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HorizontalBarComponent, selectors: [["mon-horizontal-bar-chart"]], viewQuery: function HorizontalBarComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(BaseChartDirective, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chartRef = _t.first);
        } }, inputs: { data: "data", options: "options", override: "override", labels: "labels", series: "series", colors: "colors", height: "height", emptyDataMessage: "emptyDataMessage", ariaLabel: "ariaLabel" }, outputs: { chartRefChange: "chartRefChange" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 2, vars: 9, consts: [[1, "mon-chart", "position-relative", 3, "ngStyle"], ["baseChart", "", "role", "img", 1, "chart-horizontal-bar", 3, "height", "data", "type", "plugins", "options"]], template: function HorizontalBarComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵelement(1, "canvas", 1);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(7, _c0$2, ctx.height));
            i0.ɵɵadvance();
            i0.ɵɵpropertyInterpolate("height", ctx.height);
            i0.ɵɵproperty("data", ctx.barChartData)("type", ctx.barChartType)("plugins", ctx.plugins)("options", ctx.options);
            i0.ɵɵattribute("aria-label", ctx.ariaLabel);
        } }, dependencies: [i1$2.NgStyle, i3$1.BaseChartDirective], styles: [".charts-overlay[_ngcontent-%COMP%]{height:100%;width:100%;padding:0;margin:0;display:flex;align-items:center;justify-content:center;position:absolute}.charts-overlay[_ngcontent-%COMP%]   .charts-overlay-text[_ngcontent-%COMP%]{opacity:.8;background-color:#e6e6e6;padding:5px;border-radius:5px;color:#000;text-align:center}.mon-tooltip[_ngcontent-%COMP%]{background:#000000b3;border-radius:5px;color:#fff;opacity:1;pointer-events:none;position:absolute;transform:translate(-50%);transition:all .1s ease;padding:2px 5px;font-size:12px;font-style:normal;font-family:inherit;overflow:auto;line-height:1.5}.mon-tooltip[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]{margin:0}.mon-tooltip[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%], .mon-tooltip[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{border-width:0}.mon-tooltip[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]{background-color:inherit;border-width:0}.mon-tooltip[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{padding:0}.mon-tooltip[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{border-width:1px;border-style:solid;margin-right:1px;height:10px;width:10px;display:inline-block}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HorizontalBarComponent, [{
        type: Component,
        args: [{ selector: 'mon-horizontal-bar-chart', template: "<div class=\"mon-chart position-relative\" [ngStyle]=\"{'height.px': height}\">\n    <canvas baseChart\n            height=\"{{ height }}\"\n            class=\"chart-horizontal-bar\"\n            [data]=\"barChartData\"\n            [type]=\"barChartType\"\n            [plugins]=\"plugins\"\n            [options]=\"options\"\n            [attr.aria-label]=\"ariaLabel\"\n            role=\"img\">\n    </canvas>\n</div>\n", styles: [".charts-overlay{height:100%;width:100%;padding:0;margin:0;display:flex;align-items:center;justify-content:center;position:absolute}.charts-overlay .charts-overlay-text{opacity:.8;background-color:#e6e6e6;padding:5px;border-radius:5px;color:#000;text-align:center}.mon-tooltip{background:#000000b3;border-radius:5px;color:#fff;opacity:1;pointer-events:none;position:absolute;transform:translate(-50%);transition:all .1s ease;padding:2px 5px;font-size:12px;font-style:normal;font-family:inherit;overflow:auto;line-height:1.5}.mon-tooltip table{margin:0}.mon-tooltip table thead tr,.mon-tooltip table thead th{border-width:0}.mon-tooltip table tbody tr{background-color:inherit;border-width:0}.mon-tooltip table tbody tr td{padding:0}.mon-tooltip table tbody tr td span{border-width:1px;border-style:solid;margin-right:1px;height:10px;width:10px;display:inline-block}\n"] }]
    }], () => [{ type: undefined, decorators: [{
                type: Inject,
                args: [TranslateServiceInjectionToken]
            }] }, { type: ChartService }], { data: [{
            type: Input
        }], options: [{
            type: Input
        }], override: [{
            type: Input
        }], labels: [{
            type: Input
        }], series: [{
            type: Input
        }], colors: [{
            type: Input
        }], height: [{
            type: Input
        }], emptyDataMessage: [{
            type: Input
        }], ariaLabel: [{
            type: Input
        }], chartRef: [{
            type: ViewChild,
            args: [BaseChartDirective]
        }], chartRefChange: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(HorizontalBarComponent, { className: "HorizontalBarComponent" }); })();

// interface ChartEventInterface {
//     type: string;
//     chart: Chart;
//     native: MouseEvent;
//     x: number;
//     y: number;
// }
const pluginState = {
    verticalLines: {
        currentLinesPosition: [],
        lastLinesPosition: [],
        lastLinesTextBox: [],
    },
};
const verticalLinePluginInit = (chartInstance) => {
    // Add padding to the top of the chart
    // To have more space to render the vertical line label
    chartInstance.options.layout.padding.top += verticalLinePlugin.DEFAULT_VALUES.ADDITION_PADDING_TOP;
};
const verticalLinePluginDraw = (chartInstance) => {
    const ctx = chartInstance.ctx;
    const verticalLines = chartInstance.config.options.verticalLines;
    let firstXScale;
    for (const id in chartInstance.scales) {
        if (chartInstance.scales.hasOwnProperty(id)) {
            const s = chartInstance.scales[id];
            if (s.isHorizontal() === true || s.position === 'bottom') {
                firstXScale = s;
                break;
            }
        }
    }
    verticalLines.lines.forEach((line, index) => {
        let xScale;
        if (line.xAxisID) {
            xScale = chartInstance.scales[line.xAxisID];
        }
        else {
            // If xAxisID is not defined, use the first x axis scale
            xScale = firstXScale;
        }
        // Render line
        const verticalLineTimestamp = new Date(line.x).valueOf();
        const lineX = xScale.getPixelForValue(verticalLineTimestamp);
        const originalStyle = (line.style || {});
        const lineStyle = {
            lineDash: originalStyle.lineDash || verticalLinePlugin.DEFAULT_VALUES.LINE_DASH,
            color: originalStyle.color || verticalLinePlugin.DEFAULT_VALUES.LINE_COLOR,
            width: originalStyle.width || verticalLinePlugin.DEFAULT_VALUES.LINE_WIDTH,
        };
        const start = {
            x: lineX,
            y: xScale.top,
        };
        const end = {
            x: lineX,
            y: chartInstance.chartArea.top,
        };
        ctx.save();
        ctx.beginPath();
        ctx.setLineDash(lineStyle.lineDash);
        ctx.moveTo(start.x, start.y);
        ctx.lineTo(end.x, end.y);
        ctx.strokeStyle = lineStyle.color;
        ctx.lineWidth = lineStyle.width;
        ctx.stroke();
        ctx.restore();
        // Render label
        if (line.label && line.label.text) {
            const textStyle = {
                fill: line.label.color || lineStyle.color || verticalLinePlugin.DEFAULT_VALUES.LINE_COLOR,
                fontWeight: line.label.fontWeight || 400,
                fontSize: line.label.fontSize || '1em',
                fontFamily: line.label.fontFamily || 'Roboto',
            };
            const textPosition = line.label.position || 'top';
            let shouldForceRenderTextOnTop = false;
            for (const scaleId in chartInstance.scales) {
                if (chartInstance.scales.hasOwnProperty(scaleId)) {
                    const scale = chartInstance.scales[scaleId];
                    if (scale.position === 'right' && scale.left <= lineX + 20) {
                        shouldForceRenderTextOnTop = true;
                    }
                }
            }
            ctx.save();
            ctx.fillStyle = textStyle.fill;
            ctx.font = textStyle.fontWeight + ' ' + textStyle.fontSize + ' ' + textStyle.fontFamily;
            const measuredText = ctx.measureText(line.label.text);
            const textHeight = measuredText.actualBoundingBoxDescent + measuredText.actualBoundingBoxAscent;
            const padding = {
                x: 2,
                y: 4,
            };
            let textBox;
            if (textPosition === 'top' || shouldForceRenderTextOnTop) {
                const textBaselineY = end.y - 15;
                textBox = {
                    x: lineX - measuredText.width / 2 - padding.x,
                    y: textBaselineY - textHeight / 2 - padding.y,
                    width: measuredText.width + padding.x * 2,
                    height: textHeight + padding.y * 2,
                };
                ctx.fillText(line.label.text, textBox.x, textBaselineY);
            }
            else if (textPosition === 'right') {
                ctx.save();
                const originX = lineX + padding.y + textHeight / 2 + 5;
                const originY = (start.y - end.y) / 2 + measuredText.width / 2 + verticalLinePlugin.DEFAULT_VALUES.ADDITION_PADDING_TOP;
                // Move origin to center of the line and set offset between the text and the line
                ctx.translate(originX, originY);
                ctx.rotate(-Math.PI / 2);
                textBox = {
                    x: lineX,
                    y: originY - measuredText.width - padding.x,
                    // swap width and height since the text is rotated
                    width: textHeight + padding.y * 2 + 5,
                    height: measuredText.width + padding.x * 2,
                };
                ctx.fillText(line.label.text, 0, 0);
                ctx.restore();
            }
            pluginState.verticalLines.lastLinesTextBox[index] = textBox;
            ctx.restore();
        }
        pluginState.verticalLines.currentLinesPosition[index] = {
            start,
            end,
        };
    });
};
const verticalLinePluginAfterDraw = (chartInstance) => {
    const verticalLines = chartInstance.config.options.verticalLines;
    pluginState.verticalLines.currentLinesPosition.forEach((linePosition, index) => {
        const start = linePosition.start;
        const end = linePosition.end;
        const lineX = start.x;
        // Rendered hook
        if (verticalLines.events && verticalLines.events.rendered) {
            const lastLinePosition = pluginState.verticalLines.lastLinesPosition[index];
            if (lastLinePosition === undefined || lastLinePosition === null || lineX !== lastLinePosition) {
                verticalLines.events.rendered({
                    start,
                    end,
                }, index);
            }
        }
        pluginState.verticalLines.lastLinesPosition[index] = lineX;
    });
};
let labelLeave = false;
const verticalLinePluginEventHandler = (chartInstance, event) => {
    const verticalLines = chartInstance.config.options.verticalLines;
    const verticalLinesEvents = verticalLines.events;
    const allowedEvents = ['click', 'mousemove'];
    if (allowedEvents.indexOf(event.type) === -1) {
        return;
    }
    pluginState.verticalLines.lastLinesTextBox.forEach((textBox, index) => {
        const line = verticalLines.lines[index];
        if (isInRect(event.x, event.y, textBox.x, textBox.y, textBox.width, textBox.height)) {
            labelLeave = true;
            if (event.type === 'click' && verticalLinesEvents && verticalLinesEvents.click) {
                verticalLinesEvents.click(line.data, index);
            }
            if (event.type === 'mousemove') {
                event.native.target.style.cursor = 'pointer';
                if (verticalLinesEvents && verticalLinesEvents.mouseover) {
                    verticalLinesEvents.mouseover(line.data, index);
                }
            }
        }
    });
};
const hasVerticalLinePlugin = (chartInstance) => {
    return chartInstance.config.options.verticalLines;
};
const isInRect = (targetX, targetY, x, y, width, height) => {
    return (targetX >= x && targetX <= x + width && targetY >= y && targetY <= y + height);
};
const verticalLinePlugin = {
    id: 'VerticalLine',
    DEFAULT_VALUES: {
        LINE_DASH: [5, 5],
        LINE_COLOR: '#000000',
        LINE_WIDTH: 3,
        ADDITION_PADDING_TOP: 20,
    },
    afterInit: (chart) => {
        if (hasVerticalLinePlugin(chart)) {
            verticalLinePluginInit(chart);
        }
    },
    afterDatasetsDraw: (chart) => {
        if (hasVerticalLinePlugin(chart)) {
            verticalLinePluginDraw(chart);
            verticalLinePluginAfterDraw(chart);
        }
    },
    stop: () => {
        pluginState.verticalLines.currentLinesPosition = [];
        pluginState.verticalLines.lastLinesPosition = [];
        pluginState.verticalLines.lastLinesTextBox = [];
    },
    beforeEvent: (chart, args) => {
        if (labelLeave) {
            args.event.native.target.style.cursor = 'default';
            labelLeave = false;
        }
    },
    afterEvent: (chart, args) => {
        if (hasVerticalLinePlugin(chart)) {
            verticalLinePluginEventHandler(chart, args.event);
        }
    },
};

const _c0$1 = a0 => ({ "height.px": a0 });
function LineComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4)(1, "span", 5);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.emptyDataMessage, " ");
} }
function LineComponent_canvas_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "canvas", 6);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("height", ctx_r0.height);
    i0.ɵɵproperty("data", ctx_r0.lineChartData)("options", ctx_r0.options)("type", ctx_r0.lineChartType)("plugins", ctx_r0.plugins);
    i0.ɵɵattribute("aria-label", ctx_r0.ariaLabel);
} }
class LineComponent extends BaseChart {
    set data(newData) {
        this._datasets = this.chartService.getNewDataseriesLabel(newData, this.series);
        this._datasets = this.chartService.getNewDataSeriesColor(this._datasets, this.colors);
        this._datasets = this.chartService.getNewOverrideDataseries(this._datasets, this.override);
        this.areDataRowsEmpty = this.chartService.areAllDataRowsEmpty(this._datasets);
    }
    get data() {
        return this._datasets;
    }
    get progress() {
        return this._progress;
    }
    set progress(progress) {
        this._progress = progress;
        this.isProgressRunning();
    }
    constructor(translateService, chartService) {
        super();
        this.translateService = translateService;
        this.chartService = chartService;
        this.series = [];
        this.height = CHART.HEIGHT;
        this.emptyDataMessage = this.translateService.getString('No data present');
        this.ariaLabel = this.translateService.getString('Line chart representing data');
        this.chartRefChange = new EventEmitter();
        this._progress = false;
        this.lineChartType = 'line';
        this.plugins = [CHART.PLUGINS];
        this.getDataComplete = true;
        this.areDataRowsEmpty = true;
    }
    ngAfterViewInit() {
        setTimeout(() => {
            if (this.chartRef) {
                this.chartRefChange.emit(this.chartRef);
            }
        });
    }
    ngOnInit() {
        this.options = {
            ...this.options,
            ...{
                plugins: {
                    legend: this.options?.plugins?.legend
                        ? this.options.plugins.legend
                        : { display: false },
                },
                maintainAspectRatio: false,
                transitions: {
                    active: {
                        animation: {
                            duration: 0,
                        },
                    },
                },
            },
        };
        this.options = this.getOptions(this.options);
        this.isProgressRunning();
        this.setupLineChart();
        this._datasets = this.chartService.getNewDataseriesLabel(this._datasets, this.series);
        this._datasets = this.chartService.getNewDataSeriesColor(this._datasets, this.colors);
        this._datasets = this.chartService.getNewOverrideDataseries(this._datasets, this.override);
        this.areDataRowsEmpty = this.chartService.areAllDataRowsEmpty(this._datasets);
        this.lineChartData = {
            labels: this.labels,
            datasets: this._datasets,
        };
    }
    setupLineChart() {
        this.colors = this.colors || [
            CHART.COLORS.LIGHT_BLUE,
            CHART.COLORS.BLUE,
            CHART.COLORS.LIGHT_GRAY,
            CHART.COLORS.GREEN,
            CHART.COLORS.ORANGE,
            CHART.COLORS.GRAY,
            CHART.COLORS.DARK_GRAY,
        ];
        this.override = this.override || [];
        Chart.register(verticalLinePlugin);
        this.options = this.options || {
            scales: {
                x: {
                    grid: {
                        display: false,
                    },
                },
            },
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    display: true,
                    position: 'bottom',
                    labels: {
                        color: '#A6A6A6',
                        boxWidth: 10,
                        padding: 5,
                        font: {
                            size: 11,
                            family: 'Roboto',
                        },
                    },
                },
                tooltip: {
                    enabled: true,
                    mode: 'x',
                    bodySpacing: 5,
                },
            },
            hover: { mode: 'x' },
        };
        if (this.options?.plugins?.legend) {
            this.options.plugins.legend.labels = {
                boxWidth: 15,
                padding: 15,
                font: {
                    size: 11,
                },
            };
        }
        const pushToOverride = this.override?.length === 0;
        if (this.options.scales && pushToOverride) {
            const scalesValues = Object.values(this.options.scales);
            for (let i = 0; i < scalesValues.length; i++) {
                if (scalesValues[i].position === 'left' ||
                    scalesValues[i].position === 'right') {
                    this.override.push(this.chartDataSet(Object.keys(this.options.scales)[i], this.toRgb(this.colors[i % this.colors.length])));
                }
            }
        }
        else if (this.options) {
            if (!this.options.scales) {
                this.options.scales = {};
            }
            if (!Object.values(this.options.scales)
                .find(s => (s.position === 'left') || s.position === 'right')) {
                this.series?.forEach((data, index) => {
                    const id = (index === 0) ? data : data + index;
                    this.options.scales[id] = {
                        type: 'linear',
                        display: index === 0,
                        position: 'left',
                        beginAtZero: true,
                        suggestedMax: 4,
                        ticks: {
                            maxTicksLimit: 5,
                        },
                    };
                    if (pushToOverride) {
                        this.override.push(this.chartDataSet(id, this.toRgb(this.colors[index % this.colors.length])));
                    }
                });
            }
        }
    }
    toRgb(color) {
        if (/^#[0-9A-F]{6}$/i.test(color)) {
            let c = color.substring(1).split('');
            if (c.length === 3) {
                c = [c[0], c[0], c[1], c[1], c[2], c[2]];
            }
            c = '0x' + c.join('');
            // eslint-disable-next-line
            // @ts-ignore
            // eslint-disable-next-line no-bitwise
            return [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',');
        }
        return color;
    }
    chartDataSet(ID, color) {
        return {
            yAxisID: ID,
            fill: false,
            borderWidth: 0,
            pointHoverRadius: 4,
            pointRadius: 3,
            pointBackgroundColor: '#fff',
            pointHoverBorderColor: '#fff',
            backgroundColor: 'rgba(' + color + ', 1)',
            borderColor: 'rgba(' + color + ', 1)',
            pointBorderColor: 'rgba(' + color + ', 1)',
            pointHoverBackgroundColor: 'rgba(' + color + ', 1)',
            pointHitRadius: 15,
            tension: 0.1,
        };
    }
    isProgressRunning() {
        if (typeof this.progress === 'boolean') {
            return;
        }
        if (this.progress !== undefined && this.progress !== null) {
            this.getDataComplete = false;
            Promise.resolve(this.progress).finally(() => {
                this.getDataComplete = true;
            });
        }
    }
    static { this.ɵfac = function LineComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || LineComponent)(i0.ɵɵdirectiveInject(TranslateServiceInjectionToken), i0.ɵɵdirectiveInject(ChartService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LineComponent, selectors: [["mon-line-chart"]], viewQuery: function LineComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(BaseChartDirective, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chartRef = _t.first);
        } }, inputs: { data: "data", options: "options", override: "override", labels: "labels", series: "series", colors: "colors", height: "height", emptyDataMessage: "emptyDataMessage", ariaLabel: "ariaLabel", progress: "progress" }, outputs: { chartRefChange: "chartRefChange" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 4, vars: 5, consts: [[1, "row"], [1, "col-48", "position-relative", 3, "ngStyle"], ["class", "charts-overlay", 4, "ngIf"], ["baseChart", "", "class", "chart-line", "role", "img", 3, "height", "data", "options", "type", "plugins", 4, "ngIf"], [1, "charts-overlay"], [1, "charts-overlay-text"], ["baseChart", "", "role", "img", 1, "chart-line", 3, "height", "data", "options", "type", "plugins"]], template: function LineComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵtemplate(2, LineComponent_div_2_Template, 3, 1, "div", 2)(3, LineComponent_canvas_3_Template, 1, 6, "canvas", 3);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(3, _c0$1, ctx.height));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.areDataRowsEmpty && ctx.emptyDataMessage.length > 0 && ctx.getDataComplete);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.areDataRowsEmpty);
        } }, dependencies: [i1$2.NgIf, i1$2.NgStyle, i3$1.BaseChartDirective], styles: [".charts-overlay[_ngcontent-%COMP%]{height:100%;width:100%;padding:0;margin:0;display:flex;align-items:center;justify-content:center;position:absolute}.charts-overlay[_ngcontent-%COMP%]   .charts-overlay-text[_ngcontent-%COMP%]{opacity:.8;background-color:#e6e6e6;padding:5px;border-radius:5px;color:#000;text-align:center}.mon-tooltip[_ngcontent-%COMP%]{background:#000000b3;border-radius:5px;color:#fff;opacity:1;pointer-events:none;position:absolute;transform:translate(-50%);transition:all .1s ease;padding:2px 5px;font-size:12px;font-style:normal;font-family:inherit;overflow:auto;line-height:1.5}.mon-tooltip[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]{margin:0}.mon-tooltip[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%], .mon-tooltip[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{border-width:0}.mon-tooltip[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]{background-color:inherit;border-width:0}.mon-tooltip[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{padding:0}.mon-tooltip[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{border-width:1px;border-style:solid;margin-right:1px;height:10px;width:10px;display:inline-block}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LineComponent, [{
        type: Component,
        args: [{ selector: 'mon-line-chart', template: "<div class=\"row\">\n    <div class=\"col-48 position-relative\" [ngStyle]=\"{'height.px': height}\">\n        <div *ngIf=\"areDataRowsEmpty && emptyDataMessage.length > 0 && getDataComplete\"\n             class=\"charts-overlay\"\n        >\n            <span class=\"charts-overlay-text\">\n                {{ emptyDataMessage }}\n            </span>\n        </div>\n        <canvas baseChart\n            height=\"{{ height }}\"\n            class=\"chart-line\"\n            *ngIf=\"!areDataRowsEmpty\"\n            [data]=\"lineChartData\"\n            [options]=\"options\"\n            [type]=\"lineChartType\"\n            [plugins]=\"plugins\"\n            [attr.aria-label]=\"ariaLabel\"\n            role=\"img\">\n        </canvas>\n    </div>\n\n</div>\n", styles: [".charts-overlay{height:100%;width:100%;padding:0;margin:0;display:flex;align-items:center;justify-content:center;position:absolute}.charts-overlay .charts-overlay-text{opacity:.8;background-color:#e6e6e6;padding:5px;border-radius:5px;color:#000;text-align:center}.mon-tooltip{background:#000000b3;border-radius:5px;color:#fff;opacity:1;pointer-events:none;position:absolute;transform:translate(-50%);transition:all .1s ease;padding:2px 5px;font-size:12px;font-style:normal;font-family:inherit;overflow:auto;line-height:1.5}.mon-tooltip table{margin:0}.mon-tooltip table thead tr,.mon-tooltip table thead th{border-width:0}.mon-tooltip table tbody tr{background-color:inherit;border-width:0}.mon-tooltip table tbody tr td{padding:0}.mon-tooltip table tbody tr td span{border-width:1px;border-style:solid;margin-right:1px;height:10px;width:10px;display:inline-block}\n"] }]
    }], () => [{ type: undefined, decorators: [{
                type: Inject,
                args: [TranslateServiceInjectionToken]
            }] }, { type: ChartService }], { data: [{
            type: Input
        }], options: [{
            type: Input
        }], override: [{
            type: Input
        }], labels: [{
            type: Input
        }], series: [{
            type: Input
        }], colors: [{
            type: Input
        }], height: [{
            type: Input
        }], emptyDataMessage: [{
            type: Input
        }], ariaLabel: [{
            type: Input
        }], progress: [{
            type: Input
        }], chartRef: [{
            type: ViewChild,
            args: [BaseChartDirective]
        }], chartRefChange: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(LineComponent, { className: "LineComponent" }); })();

class MonChartsModule {
    static { this.ɵfac = function MonChartsModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MonChartsModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: MonChartsModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [ChartService], imports: [CommonModule, NgChartsModule, TranslateModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MonChartsModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, NgChartsModule, TranslateModule],
                exports: [
                    BarComponent,
                    LineComponent,
                    BubbleComponent,
                    DoughnutComponent,
                    PieComponent,
                    BarlineComponent,
                    HorizontalBarComponent,
                ],
                declarations: [
                    BarComponent,
                    LineComponent,
                    BubbleComponent,
                    DoughnutComponent,
                    PieComponent,
                    BarlineComponent,
                    HorizontalBarComponent,
                ],
                providers: [ChartService],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(MonChartsModule, { declarations: [BarComponent,
        LineComponent,
        BubbleComponent,
        DoughnutComponent,
        PieComponent,
        BarlineComponent,
        HorizontalBarComponent], imports: [CommonModule, NgChartsModule, TranslateModule], exports: [BarComponent,
        LineComponent,
        BubbleComponent,
        DoughnutComponent,
        PieComponent,
        BarlineComponent,
        HorizontalBarComponent] }); })();

Injectable();
class MockChartService {
    constructor() {
        this.getNewDataseriesLabel = () => [{
                label: 'Pages crawled',
                borderWidth: 2,
                type: 'line',
                fill: false,
                yAxisID: 'y',
                xAxisID: 'x',
                backgroundColor: 'rgb(77, 192, 189)',
                borderColor: 'rgb(77, 192, 189)',
                pointRadius: 3,
                data: [],
            }];
        this.getNewOverrideDataseries = () => [{
                label: 'Pages crawled',
                borderWidth: 2,
                type: 'line',
                fill: false,
                yAxisID: 'y',
                xAxisID: 'x',
                backgroundColor: 'rgb(77, 192, 189)',
                borderColor: 'rgb(77, 192, 189)',
                pointRadius: 3,
                data: [],
            }];
        this.getNewDataSeriesColor = () => [{
                label: 'Pages crawled',
                borderWidth: 2,
                type: 'line',
                fill: false,
                yAxisID: 'y',
                xAxisID: 'x',
                backgroundColor: 'rgb(77, 192, 189)',
                borderColor: 'rgb(77, 192, 189)',
                pointRadius: 3,
                data: [],
            }];
        this.getNewSingleDataSeriesColors = () => {
            return {
                label: 'Pages crawled',
                borderWidth: 2,
                type: 'line',
                fill: false,
                yAxisID: 'y',
                xAxisID: 'x',
                backgroundColor: 'rgb(77, 192, 189)',
                borderColor: 'rgb(77, 192, 189)',
                pointRadius: 3,
                data: [],
            };
        };
        this.areAllDataRowsEmpty = () => false;
    }
}

const _c0 = a0 => ({ "button-background-color": a0 });
const _c1 = a0 => ({ "button-icon": a0 });
const _c2 = a0 => ({ "button-name": a0 });
function MonCopyComponent_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c2, ctx_r0.buttonName));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.buttonName);
} }
class MonCopyComponent {
    constructor(translateService, deviceDetectorService) {
        this.translateService = translateService;
        this.deviceDetectorService = deviceDetectorService;
        this.tooltip = this.translateService.getString('Copied!');
    }
    onError() {
        if (this.deviceDetectorService.isMobile()) {
            this.tooltip = this.translateService.getString('No support');
        }
        else if (this.deviceDetectorService.os === 'mac') {
            this.tooltip = this.translateService.getString('Press ⌘-C');
        }
        else {
            this.tooltip = this.translateService.getString('Press Ctrl-C');
        }
    }
    static { this.ɵfac = function MonCopyComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MonCopyComponent)(i0.ɵɵdirectiveInject(TranslateServiceInjectionToken), i0.ɵɵdirectiveInject(i1$7.DeviceDetectorService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MonCopyComponent, selectors: [["mon-copy"]], inputs: { tooltip: "tooltip", target: "target", buttonName: "buttonName" }, decls: 3, vars: 9, consts: [["triggers", "click", "ngxClipboard", "", 1, "btn", "btn-default", "btn-light", 3, "cbOnError", "ngbTooltip", "cbContent", "ngClass"], ["aria-hidden", "true", 1, "fas", "fa-copy", "text-primary", 3, "ngClass"], ["translate", "", 3, "ngClass", 4, "ngIf"], ["translate", "", 3, "ngClass"]], template: function MonCopyComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "button", 0);
            i0.ɵɵlistener("cbOnError", function MonCopyComponent_Template_button_cbOnError_0_listener() { return ctx.onError(); });
            i0.ɵɵelement(1, "span", 1);
            i0.ɵɵtemplate(2, MonCopyComponent_span_2_Template, 2, 4, "span", 2);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("ngbTooltip", ctx.tooltip)("cbContent", ctx.target)("ngClass", i0.ɵɵpureFunction1(5, _c0, ctx.buttonName));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c1, ctx.buttonName));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.buttonName);
        } }, dependencies: [i1$4.NgbTooltip, i3$2.ClipboardDirective, i1$2.NgClass, i1$2.NgIf], styles: [".button-background-color[_ngcontent-%COMP%]{background-color:#299bf7}.button-background-color[_ngcontent-%COMP%]   .button-icon[_ngcontent-%COMP%]{color:#fff!important}.button-background-color[_ngcontent-%COMP%]   .button-name[_ngcontent-%COMP%]{padding-left:5px;color:#fff}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MonCopyComponent, [{
        type: Component,
        args: [{ selector: 'mon-copy', template: "<button class=\"btn btn-default btn-light\"\n        [ngbTooltip]=\"tooltip\"\n        triggers=\"click\"\n        ngxClipboard\n        [cbContent]=\"target\"\n        (cbOnError)=\"onError()\"\n        [ngClass]=\"{'button-background-color': buttonName}\">\n        <span class=\"fas fa-copy text-primary\" [ngClass]=\"{'button-icon': buttonName}\" aria-hidden=\"true\"></span>\n        <span *ngIf=\"buttonName\" [ngClass]=\"{'button-name': buttonName}\" translate>{{buttonName}}</span>\n</button>\n", styles: [".button-background-color{background-color:#299bf7}.button-background-color .button-icon{color:#fff!important}.button-background-color .button-name{padding-left:5px;color:#fff}\n"] }]
    }], () => [{ type: undefined, decorators: [{
                type: Inject,
                args: [TranslateServiceInjectionToken]
            }] }, { type: i1$7.DeviceDetectorService }], { tooltip: [{
            type: Input
        }], target: [{
            type: Input
        }], buttonName: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(MonCopyComponent, { className: "MonCopyComponent" }); })();

class CopyModule {
    static { this.ɵfac = function CopyModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CopyModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: CopyModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [NgbTooltipModule, ClipboardModule, CommonModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CopyModule, [{
        type: NgModule,
        args: [{
                imports: [NgbTooltipModule, ClipboardModule, CommonModule],
                exports: [MonCopyComponent],
                declarations: [MonCopyComponent],
                providers: [],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(CopyModule, { declarations: [MonCopyComponent], imports: [NgbTooltipModule, ClipboardModule, CommonModule], exports: [MonCopyComponent] }); })();

class CopyDialogComponent {
    constructor(translateService, activeModal) {
        this.translateService = translateService;
        this.activeModal = activeModal;
    }
    ngOnInit() {
        this.headline = this.headline || this.translateService.getString('Copy');
    }
    close() {
        this.activeModal.close();
    }
    static { this.ɵfac = function CopyDialogComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CopyDialogComponent)(i0.ɵɵdirectiveInject(TranslateServiceInjectionToken), i0.ɵɵdirectiveInject(i1$4.NgbActiveModal)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CopyDialogComponent, selectors: [["mon-copy-dialog"]], inputs: { copyString: "copyString", headline: "headline" }, decls: 12, vars: 3, consts: [[1, "modal-header", "text-center"], [1, "d-flex", "align-items-start"], [1, "mr-auto"], ["id", "modal-title", 1, "modal-title"], ["id", "modal-body", 1, "modal-body", "pb-5", "text-multiline"], [1, "float-right", 3, "target"], [1, "modal-footer", "text-left"], ["translate", "", 1, "btn", "btn-primary", 3, "click"]], template: function CopyDialogComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "h3", 3);
            i0.ɵɵtext(4);
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(5, "div", 4)(6, "span");
            i0.ɵɵtext(7);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(8, "mon-copy", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "div", 6)(10, "button", 7);
            i0.ɵɵlistener("click", function CopyDialogComponent_Template_button_click_10_listener() { return ctx.close(); });
            i0.ɵɵtext(11, "Close");
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(ctx.headline);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.copyString);
            i0.ɵɵadvance();
            i0.ɵɵproperty("target", ctx.copyString);
        } }, dependencies: [MonCopyComponent], styles: [".text-multiline[_ngcontent-%COMP%]{-ms-word-wrap:break-word;word-wrap:break-word}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CopyDialogComponent, [{
        type: Component,
        args: [{ selector: 'mon-copy-dialog', template: "<div class=\"modal-header text-center\">\n    <div class=\"d-flex align-items-start\">\n        <div class=\"mr-auto\">\n            <h3 class=\"modal-title\" id=\"modal-title\">{{ headline }}</h3>\n        </div>\n    </div>\n</div>\n<div class=\"modal-body pb-5 text-multiline\" id=\"modal-body\">\n    <span>{{ copyString }}</span>\n    <mon-copy class=\"float-right\" [target]=\"copyString\"></mon-copy>\n</div>\n<div class=\"modal-footer text-left\">\n    <button class=\"btn btn-primary\" (click)=\"close()\" translate>Close</button>\n</div>\n", styles: [".text-multiline{-ms-word-wrap:break-word;word-wrap:break-word}\n"] }]
    }], () => [{ type: undefined, decorators: [{
                type: Inject,
                args: [TranslateServiceInjectionToken]
            }] }, { type: i1$4.NgbActiveModal }], { copyString: [{
            type: Input
        }], headline: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(CopyDialogComponent, { className: "CopyDialogComponent" }); })();

class CopyDialogService {
    constructor(ngbModal) {
        this.ngbModal = ngbModal;
    }
    open(copyString, headline) {
        const modalRef = this.ngbModal.open(CopyDialogComponent, { size: 'lg' });
        modalRef.componentInstance.copyString = copyString;
        modalRef.componentInstance.headline = headline;
    }
    static { this.ɵfac = function CopyDialogService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CopyDialogService)(i0.ɵɵinject(i1$4.NgbModal)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: CopyDialogService, factory: CopyDialogService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CopyDialogService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], () => [{ type: i1$4.NgbModal }], null); })();

class CopyDialogModule {
    static { this.ɵfac = function CopyDialogModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CopyDialogModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: CopyDialogModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [NgbActiveModal], imports: [CopyModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CopyDialogModule, [{
        type: NgModule,
        args: [{
                imports: [CopyModule],
                exports: [CopyDialogComponent],
                declarations: [CopyDialogComponent],
                providers: [NgbActiveModal],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(CopyDialogModule, { declarations: [CopyDialogComponent], imports: [CopyModule], exports: [CopyDialogComponent] }); })();

const fakeTranslateService$2 = {
    getString: (text) => text,
};
const monCompareRangeUpdateEvent = 'monCompareRangeUpdateEvent';
const emptyRange = () => ({ startDate: null, endDate: null });
let MonDatePickerRange = class MonDatePickerRange extends LitElement {
    static { this.styles = css `

:host {
    --MonDatePickerRangeErrorColor: #ff0000;
    --MonDatePickerRangeInputBorderColor: #E6E6E6;
}

.date-range-container .date-range-row {
    display: flex;
}

.date-range-container .date-range-date {
    margin-right: 20px;
}

.date-range-container .date-range-input {
    display: block;
}

.date-range-container .date-range-label {
    display: block;
}

.date-range-container .date-range-error {
    color: var(--MonDatePickerRangeErrorColor);
    white-space: pre;
}

.date-range-container .date-range-input {
    width: 180px;
    border-top: none;
    border-left: none;
    border-right: none;
    border-radius: 0;
    line-height: 1em;
    border-bottom: 1px solid var(--MonDatePickerRangeInputBorderColor);
}

.date-range-container .date-range-input::placeholder {
    color: #9A9D9E;
    opacity: 1;
}

.sr-only {
    border: 0;
    clip: rect(0, 0, 0, 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
}
    `; }
    get model() {
        return this._model;
    }
    set model(value) {
        this._model = value;
        this.updateDates();
    }
    get translateService() {
        return this._translateService;
    }
    set translateService(value) {
        if (value && value.getString) {
            this._translateService = value;
            this.monText = {};
            this.setTexts();
            this.updateTexts();
        }
    }
    get customNotValidDateText() {
        return this._customNotValidDateText;
    }
    set customNotValidDateText(value) {
        this._customNotValidDateText = value;
        this.updateTexts();
    }
    get customNotValidRangeText() {
        return this._customNotValidRangeText;
    }
    set customNotValidRangeText(value) {
        this._customNotValidRangeText = value;
        this.updateTexts();
    }
    constructor() {
        super();
        this._model = emptyRange();
        this._translateService = fakeTranslateService$2;
        this.monText = {};
        this.range = emptyRange();
        this.dateFormat = 'DD-MM-YYYY';
        this.startDateError = '';
        this.endDateError = '';
        this.startDate = '';
        this.endDate = '';
        this.setTexts();
    }
    connectedCallback() {
        super.connectedCallback();
        this.updateTexts();
        this.updateDates();
    }
    onChange(event) {
        const input = event.target;
        const isDelete = event.inputType === 'deleteContentBackward';
        let newValue = input.value;
        let start = input.selectionStart;
        let end = input.selectionEnd;
        const [prevDay, prevMonth, prevYear] = newValue.split('-');
        let newDay = '';
        let newMonth = '';
        let newYear = '';
        newDay = prevDay;
        if (newDay?.length > 2) {
            newMonth = newDay.substring(2);
            newDay = newDay.substring(0, 2);
        }
        if (prevMonth?.length > 0) {
            newMonth += prevMonth;
        }
        if (newMonth?.length > 2) {
            newYear += newMonth.substring(2);
            newMonth = newMonth.substring(0, 2);
        }
        if (prevYear?.length > 0) {
            newYear += prevYear;
        }
        newValue = newDay;
        if (newMonth || newYear) {
            newValue += '-';
            newValue += newMonth;
        }
        if (newYear) {
            newValue += '-';
            newValue += newYear;
        }
        if (start === 3 && !isDelete) {
            start++;
            end++;
        }
        if (start === 6 && !isDelete) {
            start++;
            end++;
        }
        input.value = newValue;
        input.selectionStart = start;
        input.selectionEnd = end;
    }
    onBlur(event, type) {
        const input = event.target;
        const value = input.value;
        const parsedDate = this.dateFromString(value);
        if (type === 'startdate') {
            this.model.startDate = parsedDate;
        }
        if (type === 'enddate') {
            this.model.endDate = parsedDate;
        }
        this.updateDates();
    }
    setTexts() {
        if (!Object.keys(this.monText).length) {
            this.monText = {
                startDate: this.translateService.getString('Start date'),
                endDate: this.translateService.getString('End date'),
                invalidDate: this.translateService.getString('Please enter a valid date!'),
                invalidEndDate: this.translateService.getString('The end date cannot be before the start date'),
            };
        }
    }
    updateDates() {
        const newStartDate = this.dateToString(this.model.startDate);
        if (newStartDate !== null) {
            this.startDate = newStartDate;
            this.setInputValue(newStartDate, '.date-range-input-start');
        }
        const endDate = this.dateToString(this.model.endDate);
        if (endDate !== null) {
            this.endDate = endDate;
            this.setInputValue(endDate, '.date-range-input-end');
        }
        this.validateDates();
    }
    setInputValue(value, selector) {
        if (this.shadowRoot) {
            const input = this.shadowRoot.querySelector(selector);
            if (input) {
                input.value = value;
            }
        }
    }
    updateTexts() {
        this.notValidDateText = this.customNotValidDateText || this.monText.invalidDate;
        this.notValidRangeText = this.customNotValidRangeText || this.monText.invalidEndDate;
    }
    validateDates() {
        let isValid = this.checkRangeValidity();
        const startDateError = this.isValidDate(this.model.startDate) &&
            this.validateStartDateCb &&
            this.validateStartDateCb(this.model.startDate);
        const endDateError = this.isValidDate(this.model.endDate) &&
            this.validateEndDateCb &&
            this.validateEndDateCb(this.model.endDate);
        if (startDateError || endDateError) {
            isValid = false;
        }
        this.setErrorMessages(startDateError, endDateError);
        this.setDateRange(isValid);
    }
    setErrorMessages(startDateError, endDateError) {
        if (this.startDate && !this.isValidDate(this.model.startDate)) {
            this.startDateError = this.notValidDateText;
        }
        else if (startDateError) {
            this.startDateError = startDateError;
        }
        else {
            this.startDateError = '';
        }
        if (this.endDate && !this.isValidDate(this.model.endDate)) {
            this.endDateError = this.notValidDateText;
        }
        else if (endDateError) {
            this.endDateError = endDateError;
        }
        else {
            this.endDateError = '';
        }
        if (this.model.startDate && this.model.endDate && !this.checkRangeValidity()) {
            if (this.endDateError) {
                this.endDateError = `${this.endDateError}\r\n${this.notValidRangeText}`;
            }
            else {
                this.endDateError = this.notValidRangeText;
            }
        }
    }
    setDateRange(valid) {
        if (valid) {
            this.range.startDate = this.model.startDate;
            this.range.endDate = this.model.endDate;
        }
        else {
            this.range.startDate = null;
            this.range.endDate = null;
        }
        this.dispatchEvent(new CustomEvent(monCompareRangeUpdateEvent, {
            bubbles: true,
            composed: true,
            detail: this.range,
        }));
    }
    dateFromString(value) {
        const match = /^(\d{1,2})-(\d{1,2})-(\d{4,})$/.exec(value);
        if (!match) {
            return null;
        }
        const day = Number(match[1]);
        const month = Number(match[2]);
        const year = Number(match[3]);
        return new Date(year, month - 1, day);
    }
    dateToString(date) {
        if (!this.isValidDate(date)) {
            return null;
        }
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    }
    isValidDate(date) {
        return date instanceof Date && isFinite(date.getTime());
    }
    checkRangeValidity() {
        if (!this.model.startDate || !this.model.endDate) {
            return false;
        }
        return this.model.endDate.getTime() >= this.model.startDate.getTime();
    }
    render() {
        return html `
            <div class="date-range-container">
                <div class="date-range-row">
                    <div class="date-range-date">
                        <label class="date-range-label">${this.monText.startDate}
                            <input
                                type="text"
                                .value=${this.startDate}
                                @blur=${(event) => this.onBlur(event, 'startdate')}
                                @input=${this.onChange}
                                class="date-range-input date-range-input-start"
                                placeholder=${this.dateFormat}
                                autocomplete="off"
                                aria-labelledby="date-range-description-startdate"
                            />
                            <span class="sr-only" id="date-range-description-startdate">(date format: ${this.dateFormat})</span>
                        </label>
                        <span class="date-range-error">${this.startDateError}</span>
                    </div>
                    <div class="date-range-date">
                        <label class="date-range-label">${this.monText.endDate}
                            <input
                                type="text"
                                .value=${this.endDate}
                                @blur=${(event) => this.onBlur(event, 'enddate')}
                                @input=${this.onChange}
                                class="date-range-input date-range-input-end"
                                placeholder=${this.dateFormat}
                                autocomplete="off"
                                aria-labelledby="date-range-description-enddate"
                            />
                            <span class="sr-only" id="date-range-description-enddate">(date format: ${this.dateFormat})</span>
                        </label>
                        <span class="date-range-error">${this.endDateError}</span>
                    </div>
                </div>
            </div>
            <div class="sr-only" aria-live="polite" aria-atomic="true">
                ${this.startDateError} ${this.endDateError}
            </div>
        `;
    }
};
__decorate([
    property({ type: Object })
], MonDatePickerRange.prototype, "model", null);
__decorate([
    property({ type: Object })
], MonDatePickerRange.prototype, "translateService", null);
__decorate([
    property()
], MonDatePickerRange.prototype, "customNotValidDateText", null);
__decorate([
    property()
], MonDatePickerRange.prototype, "customNotValidRangeText", null);
__decorate([
    property({ type: Object })
], MonDatePickerRange.prototype, "validateStartDateCb", void 0);
__decorate([
    property({ type: Object })
], MonDatePickerRange.prototype, "validateEndDateCb", void 0);
__decorate([
    property({ type: Object })
], MonDatePickerRange.prototype, "monText", void 0);
__decorate([
    state$1()
], MonDatePickerRange.prototype, "startDateError", void 0);
__decorate([
    state$1()
], MonDatePickerRange.prototype, "endDateError", void 0);
__decorate([
    state$1()
], MonDatePickerRange.prototype, "startDate", void 0);
__decorate([
    state$1()
], MonDatePickerRange.prototype, "endDate", void 0);
MonDatePickerRange = __decorate([
    customElement('mon-date-picker-range')
], MonDatePickerRange);

// language=CSS
var Styles$1 = css `
        :host {
            --MonCalendarFontSize: 12px;
            --MonDatepickerWidth: 500px;
            --MonDatepickerMainDaysColor: #0A0921;
            --MonDatepickerArrowColor: #000000;
            --MonDatepickerMainButtonHoverColor: #eee;
            --MonDatepickerDateRangeButtonColor: #ffffff;
            --MonDatepickerDateRangeButtonBgColor: #357ebd;
            --MonDatepickerDateInRangeBgColor: #ebf4f8;
            --MonDatepickerButtonOutOfRangeColor: #999;
        }

        .mon-datepicker-main-wrapper {
            width: var(--MonDatepickerWidth);
        }

        .mon-datepicker-main-month-scroll {
            display: grid;
            font-size: var(--MonCalendarFontSize);
            font-weight: 600;
            grid-template-columns: 50px 150px 50px 50px 150px 50px;
            width: 100%;
        }

        .text-center {
            display: flex;
            align-self: center;
            justify-content: center;
        }

        .mon-datepicker-main-calendars-wrapper {
            display: grid;
            grid-template-columns: 1fr 1fr;
            width: 100%;
        }

        .mon-datepicker-main {
            font-size: var(--MonCalendarFontSize);
            margin: 0 10px;
        }

        .mon-datepicker-main button {
            font-size: var(--MonCalendarFontSize);
        }

        .mon-datepicker-main-week-days {
            display: grid;
            grid-template-columns: repeat(7, 1fr);
            font-weight: 600;
            color: rgb(104, 104, 104);
            padding: 6px 0;
        }

        .mon-datepicker-main-days {
            display: grid;
            grid-template-columns: repeat(7, 1fr);
            color: var(--MonDatepickerMainDaysColor);
        }

        .mon-datepicker-main-week-days div,
        .mon-datepicker-main-days div {
            text-align: center;
        }

        .mon-datepicker-main-day-in-range,
        .mon-datepicker-main-day-in-range-alike {
            background-color: var(--MonDatepickerDateInRangeBgColor);
        }

        .arrow {
            color: #fff;
            border: solid var(--MonDatepickerArrowColor);
            border-width: 0 2px 2px 0;
            border-radius: 0;
            display: inline-block;
            padding: 3px;
        }

        .arrow-right {
            transform: rotate(-45deg);
        }

        .arrow-left {
            transform: rotate(135deg);
        }

        button {
            appearance: none;
            background: none;
            border: none;

            width: 100%;
            padding: 6px 0;
        }
        button:not(.ignore-default-radius) {
            border-radius: 4px;
        }

        button:hover {
            background-color: var(--MonDatepickerMainButtonHoverColor);
            cursor: pointer;
        }

        button[disabled] {
            cursor: not-allowed;
        }

        .scroll-button-inactive {
            opacity: 0.5;
        }
        .scroll-button-inactive:hover {
            background-color: transparent;
            cursor: not-allowed;
        }

        .date-range-from button {
            background-color: var(--MonDatepickerDateRangeButtonBgColor);
            border-top-left-radius: 4px;
            border-bottom-left-radius: 4px;
            color: var(--MonDatepickerDateRangeButtonColor);
        }
        .date-range-to button {
            background-color: var(--MonDatepickerDateRangeButtonBgColor);
            border-top-right-radius: 4px;
            border-bottom-right-radius: 4px;
            color: var(--MonDatepickerDateRangeButtonColor);
        }

        .previous-month-day button {
            color: var(--MonDatepickerButtonOutOfRangeColor);
        }
        .next-month-day button {
            color: var(--MonDatepickerButtonOutOfRangeColor);
        }
        .future-month-day button {
            text-decoration: line-through;
        }
`;

const fakeTranslateService$1 = {
    getString: (value) => value,
};
const monDatepickerMainDatesUpdate = 'monDatepickerMainDatesUpdate';
let MonDatePickerMain = class MonDatePickerMain extends LitElement {
    static { this.styles = Styles$1; }
    set dateFrom(value) {
        this._dateFrom = value;
        this.init();
    }
    get dateFrom() {
        return this._dateFrom;
    }
    set dateTo(value) {
        this._dateTo = value;
        this.init();
    }
    get dateTo() {
        return this._dateTo;
    }
    set translateService(value) {
        if (value && value.getString) {
            this._translateService = value;
            this.monText = {};
            this.setTexts();
        }
    }
    get translateService() {
        return this._translateService;
    }
    set monLocale(value) {
        this._monLocale = value || 'default';
        this.calculateLocalised();
    }
    get monLocale() {
        return this._monLocale;
    }
    constructor() {
        super();
        this.monText = {};
        this._monLocale = 'default';
        this._translateService = fakeTranslateService$1;
        this.firstDayIndex = 1; // Monday === 1, Sunday === 0
        this.init = debounce(() => {
            if (this._dateFrom) {
                this.dateForFromPanel = undefined;
            }
            if (this._dateTo) {
                this.dateForToPanel = undefined;
            }
            this.setPanelsDates();
            this.calculateLocalised();
        });
        this.dayButtonHover = debounce((button) => {
            if (this.dateFrom && !this.dateTo) {
                const calendarGrid = button.closest('.mon-datepicker-main-calendars-wrapper');
                const cells = Array.from(calendarGrid
                    .querySelectorAll('.mon-datepicker-main-days div:not(.previous-month-day):not(.future-month-day)'));
                const cellsAmount = cells.length;
                cells.forEach(cell => {
                    cell.classList.remove('mon-datepicker-main-day-in-range-alike');
                });
                if (button.parentElement.classList.contains('previous-month-day')) {
                    return;
                }
                let index1 = cells.indexOf(calendarGrid.querySelector('.date-range-from'));
                if (index1 < 0) {
                    index1 = 0;
                }
                const index2 = cells.indexOf(button.parentElement);
                const cellsToIterate = cells.slice(index1, index2);
                for (let i = 0; i < cellsAmount; i += 1) {
                    const cell = cellsToIterate[i];
                    if (cell && !cell.classList.contains('next-month-day')) {
                        cell.classList.add('mon-datepicker-main-day-in-range-alike');
                    }
                }
            }
        });
        this.setTexts();
    }
    setTexts() {
        if (!Object.keys(this.monText).length) {
            this.monText = {
                oneMonthBack: this.translateService.getString('One month back'),
                oneMonthForward: this.translateService.getString('One month forward'),
                cannotForwardMore: this.translateService.getString('Cannot forward more'),
                pressToChooseStart: this.translateService.getString('Press to choose the start day'),
                pressToChooseEnd: this.translateService.getString('Press to choose the end day'),
            };
        }
    }
    calculateLocalised() {
        this.daysNames = Array.from({ length: 7 }).map((_v, i) => new Date(`1978-01-${i + 1}`)
            .toLocaleString(this.monLocale, { weekday: 'short' }));
        this.monthNames = Array.from({ length: 12 }).map((_v, i) => new Date(`1978-${i + 1}-01`)
            .toLocaleString(this.monLocale, { month: 'short' }));
        const weekInfo = new Intl.Locale(this.monLocale).weekInfo;
        if (weekInfo) {
            this.firstDayIndex = weekInfo.firstDay === 1 ? 0 : 1;
        }
        if (this.firstDayIndex === 1) {
            this.daysNames.push(this.daysNames.shift());
        }
    }
    emitDates(from, to) {
        let dateFrom;
        let dateTo;
        if (from) {
            dateFrom = this.dateToString(from);
        }
        if (to) {
            dateTo = this.dateToString(to);
        }
        this.dispatchEvent(new CustomEvent(monDatepickerMainDatesUpdate, {
            detail: {
                dateFrom,
                dateTo,
            },
            composed: true,
            bubbles: true,
        }));
    }
    dateToString(date) {
        return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    }
    setPanelsDates() {
        if (!this.dateForToPanel) {
            if (this.dateTo) {
                this.dateForToPanel = new Date(this.dateTo.getTime());
            }
            else if (this.dateFrom) {
                this.dateForToPanel = new Date(this.dateFrom.getFullYear(), this.dateFrom.getMonth() + 1, 1);
                // No need to set this.dateForFromPanel
                return;
            }
            else {
                this.dateForToPanel = new Date();
            }
        }
        if (!this.dateForFromPanel) {
            if (this.dateForToPanel) {
                this.dateForFromPanel = new Date(this.dateForToPanel.getTime());
                this.dateForFromPanel.setDate(0);
            }
            else if (this.dateFrom) {
                this.dateForFromPanel = new Date(this.dateTo.getTime());
            }
            else if (this.dateTo) {
                this.dateForFromPanel = new Date(this.dateTo.getTime());
                this.dateForFromPanel.setDate(0);
            }
        }
    }
    constructMonth(date) {
        const month = date.getMonth();
        const year = date.getFullYear();
        const currentTime = date.getTime();
        const nextMonthDate = new Date(year, month + 1, 1);
        const prevMonthDate = new Date(currentTime);
        prevMonthDate.setDate(0);
        const prevMonthYear = prevMonthDate.getFullYear();
        const nextMonthYear = nextMonthDate.getFullYear();
        const prevMonthMonth = prevMonthDate.getMonth();
        const nextMonthMonth = nextMonthDate.getMonth();
        const daysInMonth = this.daysInMonth(month, year);
        let daysInPrevMonthPlusOne = this.daysInMonth(prevMonthMonth, prevMonthYear) + 1;
        let firstWeekday = (new Date(year, month)).getDay() - this.firstDayIndex;
        if (firstWeekday < 0) {
            firstWeekday = 6;
        }
        const lastMonthLastWeek = Array.from({ length: 7 }).map(() => daysInPrevMonthPlusOne -= 1)
            .slice(0, firstWeekday || 7).toReversed();
        let nextMonthDays = 1;
        let d = 1;
        let maxRows = 6;
        let monthArray = [];
        const currentDate = new Date();
        const dateYear = date.getFullYear();
        const currentYear = currentDate.getFullYear();
        const dateMonth = date.getMonth();
        const currentMonth = currentDate.getMonth();
        const isCurrentYear = dateYear === currentYear;
        const isNextYear = dateYear === currentYear + 1;
        const isMonthNow = isCurrentYear && dateMonth === currentMonth;
        const isNextMonth = (isCurrentYear && dateMonth === currentMonth - 1) || (isNextYear && dateMonth === 0);
        const todayDate = currentDate.getDate();
        let dateFromTime = 0;
        let dateToTime = 0;
        let dateDayFromTime = '';
        let dateDayToTime = '';
        if (this.dateFrom instanceof Date) {
            dateFromTime = this.dateFrom.getTime();
            dateDayFromTime = this.getDayPrecise(this.dateFrom);
        }
        if (this.dateTo instanceof Date) {
            dateToTime = this.dateTo.getTime();
            dateDayToTime = this.getDayPrecise(this.dateTo);
        }
        if (firstWeekday === 0) {
            maxRows = 5;
            monthArray = monthArray.concat(lastMonthLastWeek.map(n => {
                const firstWeekDayDate = new Date(`${prevMonthYear}-${prevMonthMonth + 1}-${d}`);
                return {
                    nr: n,
                    fromPreviousMonth: true,
                    ...this.computeRangeData(firstWeekDayDate, dateFromTime, dateToTime, dateDayFromTime, dateDayToTime),
                };
            }));
        }
        for (let i = 0; i < maxRows; i += 1) {
            for (let j = 0; j < 7; j += 1) {
                if (i === 0 && j < firstWeekday) {
                    const day = lastMonthLastWeek[j];
                    const prevMonthDayDate = new Date(`${prevMonthYear}-${prevMonthMonth + 1}-${day}`);
                    monthArray.push({
                        nr: day,
                        fromPreviousMonth: true,
                        ...this.computeRangeData(prevMonthDayDate, dateFromTime, dateToTime, dateDayFromTime, dateDayToTime),
                    });
                }
                else if (d > daysInMonth) {
                    const nextMonthDayDate = new Date(`${nextMonthYear}-${nextMonthMonth + 1}-${nextMonthDays}`);
                    monthArray.push({
                        nr: nextMonthDays,
                        fromNextMonth: true,
                        ...this.computeRangeData(nextMonthDayDate, dateFromTime, dateToTime, dateDayFromTime, dateDayToTime),
                        isFromFuture: ((isMonthNow && todayDate < d) || (isNextMonth && todayDate < nextMonthDays)),
                    });
                    nextMonthDays += 1;
                }
                else {
                    const dayDate = new Date(`${year}-${month + 1}-${d}`);
                    monthArray.push({
                        nr: d,
                        ...this.computeRangeData(dayDate, dateFromTime, dateToTime, dateDayFromTime, dateDayToTime),
                        isFromFuture: (isMonthNow && todayDate < d),
                    });
                    d += 1;
                }
            }
        }
        return monthArray;
    }
    computeRangeData(date, dateFromTime, dateToTime, dateDayFromTime, dateDayToTime) {
        let isSelected = false;
        let isFromDate = false;
        let isToDate = false;
        const time = date.getTime();
        if (dateDayFromTime) {
            isFromDate = this.getDayPrecise(date) === dateDayFromTime;
        }
        if (dateDayToTime) {
            isToDate = this.getDayPrecise(date) === dateDayToTime;
        }
        isSelected = !isFromDate && !isToDate && (time > dateFromTime) && (time < dateToTime);
        return {
            date,
            isSelected,
            isFromDate,
            isToDate,
        };
    }
    getDayPrecise(date) {
        return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    }
    daysInMonth(month, year) {
        return 32 - new Date(year, month, 32).getDate();
    }
    renderDaysNames() {
        return this.daysNames.map(name => {
            return html `
                <div>${name}</div>
            `;
        });
    }
    renderCalendarDays(date) {
        const result = [];
        const days = this.constructMonth(date);
        let describedBy = 'textPressToChooseStart';
        let ariaLabel = '';
        if (this.dateFrom && !this.dateTo) {
            describedBy = 'textPressToChooseEnd';
        }
        for (const day of days) {
            ariaLabel = day.date.toLocaleDateString(this.monLocale, {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric',
            });
            let styleValue = 'current-month-day';
            let buttonStyle = '';
            if (day.fromPreviousMonth) {
                styleValue = 'previous-month-day';
            }
            else if (day.fromNextMonth) {
                styleValue = 'next-month-day';
            }
            if (day.isFromFuture) {
                styleValue = 'future-month-day';
            }
            if (day.isSelected) {
                if (!day.fromNextMonth && !day.fromPreviousMonth) {
                    styleValue += ' mon-datepicker-main-day-in-range';
                }
            }
            else {
                if (day.isFromDate) {
                    if (!day.fromPreviousMonth && !day.isFromFuture && !day.fromNextMonth) {
                        styleValue += ' date-range-from';
                        buttonStyle += 'ignore-default-radius';
                    }
                }
                if (day.isToDate) {
                    if (!day.fromPreviousMonth && !day.isFromFuture && !day.fromNextMonth) {
                        styleValue += ' date-range-to ignore-default-radius';
                        buttonStyle += 'ignore-default-radius';
                    }
                }
            }
            result.push(html `
                <div class="${styleValue}">
                    <button class="${buttonStyle}"
                        @mouseover=${(e) => this.dayButtonHover(e.target)}
                        type="button"
                        aria-describedby=${describedBy}
                        aria-label=${ariaLabel}
                        .disabled=${day.isFromFuture}
                        @click=${() => {
                this.processDayClick(day);
            }}>
                        ${day.nr}
                    </button>
                </div>
            `);
        }
        return result;
    }
    removeRangeAlike() {
        Array.from(this.shadowRoot?.querySelectorAll('.mon-datepicker-main-day-in-range-alike'))
            .forEach(element => element.classList.remove('mon-datepicker-main-day-in-range-alike'));
    }
    decreaseMonth() {
        this.dateForToPanel.setDate(0);
        this.dateForFromPanel = new Date(this.dateForToPanel.getTime());
        this.dateForFromPanel.setDate(0);
        this.requestUpdate();
    }
    increaseMonth() {
        this.dateForToPanel.setDate(32);
        this.dateForFromPanel = new Date(this.dateForToPanel.getTime());
        this.dateForFromPanel.setDate(0);
        this.requestUpdate();
    }
    processDayClick(day) {
        if (day.isFromFuture) {
            return;
        }
        let dateFrom = this.dateFrom;
        let dateTo = this.dateTo;
        this.removeRangeAlike();
        if (day.isFromDate && this.dateTo) {
            dateTo = undefined;
            this.emitDates(dateFrom, dateTo);
            return;
        }
        if (this.dateFrom && !this.dateTo) {
            const newTime = day.date.getTime();
            if (this.dateFrom.getTime() <= newTime) {
                dateTo = new Date(newTime);
                if (day.fromNextMonth) {
                    this.dateForFromPanel = new Date(day.date.getFullYear(), day.date.getMonth() - 1, 1);
                    this.dateForToPanel = new Date(day.date.getFullYear(), day.date.getMonth(), 1);
                }
                this.emitDates(dateFrom, dateTo);
                return;
            }
        }
        dateFrom = new Date(day.date.getTime());
        dateTo = undefined;
        if (day.fromPreviousMonth) {
            this.dateForFromPanel = new Date(day.date.getFullYear(), day.date.getMonth(), 1);
            this.dateForToPanel = new Date(day.date.getFullYear(), day.date.getMonth() + 1, 1);
        }
        else if (day.fromNextMonth) {
            this.dateForFromPanel = new Date(day.date.getFullYear(), day.date.getMonth() - 1, 1);
            this.dateForToPanel = new Date(day.date.getFullYear(), day.date.getMonth(), 1);
        }
        this.emitDates(dateFrom, dateTo);
    }
    canScrollFurther() {
        const currentDate = new Date();
        const nextPossibleDate = new Date(this.dateForToPanel.getFullYear(), this.dateForToPanel.getMonth() + 1, 1);
        return currentDate.getTime() > nextPossibleDate.getTime();
    }
    render() {
        if (!this.dateForFromPanel || !this.dateForToPanel) {
            return html ``;
        }
        const lastMonthIndex = this.dateForToPanel.getMonth();
        const lastYear = this.dateForToPanel.getFullYear();
        const rightButtonInactive = !this.canScrollFurther();
        return html `
        <div class="mon-datepicker-main-wrapper">
            <div class="mon-datepicker-main-month-scroll">
                <div>
                    <button @click=${() => this.decreaseMonth()} aria-label=${this.monText.oneMonthBack}>
                        <span class="arrow arrow-left"></span>
                    </button>
                </div>
                <div class="text-center">
                    ${this.monthNames[this.dateForFromPanel.getMonth()]} ${this.dateForFromPanel.getFullYear()}
                </div>
                <div></div>
                <div></div>
                <div class="text-center">
                    ${this.monthNames[lastMonthIndex]} ${lastYear}
                </div>
                <div>
                    <button class=${rightButtonInactive ? 'scroll-button-inactive' : ''}
                        aria-label=${rightButtonInactive ? this.monText.cannotForwardMore : this.monText.oneMonthForward}
                        @click=${() => !rightButtonInactive && this.increaseMonth()}>
                        <span class="arrow arrow-right"></span>
                    </button>
                </div>
            </div>
            <div class="mon-datepicker-main-calendars-wrapper" @mouseleave=${() => this.removeRangeAlike()}>
                <div class="mon-datepicker-main">
                    <div class="mon-datepicker-main-body">
                        <div class="mon-datepicker-main-week-days">
                            ${this.renderDaysNames()}
                        </div>
                        <div class="mon-datepicker-main-days">
                            ${this.renderCalendarDays(this.dateForFromPanel)}
                        </div>
                    </div>
                </div>
                <div class="mon-datepicker-main">
                    <div class="mon-datepicker-main-body">
                        <div class="mon-datepicker-main-week-days">
                            ${this.renderDaysNames()}
                        </div>
                        <div class="mon-datepicker-main-days">
                            ${this.renderCalendarDays(this.dateForToPanel)}
                        </div>
                    </div>
                </div>
            </div>
            <div hidden>
                <span id="textPressToChooseStart">${this.monText.pressToChooseStart}</span>
                <span id="textPressToChooseEnd">${this.monText.pressToChooseEnd}</span>
            </div>
        </div>
    `;
    }
};
__decorate([
    property({ type: Object })
], MonDatePickerMain.prototype, "dateFrom", null);
__decorate([
    property({ type: Object })
], MonDatePickerMain.prototype, "dateTo", null);
__decorate([
    property({ type: Object })
], MonDatePickerMain.prototype, "translateService", null);
__decorate([
    property()
], MonDatePickerMain.prototype, "monLocale", null);
__decorate([
    state$1()
], MonDatePickerMain.prototype, "dateForFromPanel", void 0);
__decorate([
    state$1()
], MonDatePickerMain.prototype, "dateForToPanel", void 0);
__decorate([
    state$1()
], MonDatePickerMain.prototype, "monText", void 0);
MonDatePickerMain = __decorate([
    customElement('mon-date-picker-main')
], MonDatePickerMain);

// language=CSS
var Styles = css `
    :host {
        --MonDatepickerApplyButtonColor: #ffffff;
        --MonDatepickerApplyButtonBgColor: #299bf7;
        --MonDatePickerFontSize: 16px;
        --MonTogglePickerHoverBackground: #E6E6E6;
        --MonTogglePickerActiveBorderColor: #212529;
        --MonTogglePickerActiveSvgColor: #212529;
        --MonDatePickerErrorColor: #ff0000;
        --MonDatePickerBordersColor: #dddddd;
        --MonDatepickerButtonHoverColor: #eeeeee;
        --MonDatePickerDateButtonsActiveColor: #08c;

        --MonArrowLeft: 130px;

        font-size: var(--MonDatePickerFontSize);
    }

    mon-date-picker-range {
        --MonDatePickerRangeErrorColor: var(--MonDatePickerErrorColor);
        --MonDatePickerRangeInputBorderColor: var(--MonDatePickerBordersColor);
    }

    mon-date-picker-main {
        --MonDatepickerMainButtonHoverColor: var(--MonDatepickerButtonHoverColor);
        --MonDatepickerDateRangeButtonBgColor: var(--MonDatePickerDateButtonsActiveColor);
    }

    button {
        appearance: none;
        border: none;
        background-color: transparent;
        cursor: pointer;
    }

    .generalWrapper {
        position: relative;
    }

    .pickerSelection {
        align-items: center;
        display: flex;
    }

    .togglePickerButton {
        border-radius: 50%;
        height: 30px;
        width: 32px;
        border: 1px solid transparent;
        margin-left: 5px;

    }
    .togglePickerButton:hover {
        background-color: var(--MonTogglePickerHoverBackground);
    }
    .togglePickerButton:active {
        border-color: var(--MonTogglePickerActiveBorderColor);
    }
    .togglePickerButton:active svg {
        color: var(--MonTogglePickerActiveSvgColor);
    }

    svg {
        width: 0.875em;
        vertical-align: -0.225em;
        font-size: 1.33333em;
        line-height: 0.75em;
        color: var(--MonDatepickerApplyButtonBgColor);
    }

    .compareRangeIcon {
        height: 1em;
        width: 1.4em;
        color: inherit;
    }

    .wrapper {
        display: inline-block;
        background-color: #ffffff;
        border: 1px solid var(--MonDatePickerBordersColor);
        border-radius: 4px;
        position: absolute;
        z-index: 1000000;
    }
    .wrapper[hidden] {
        display: none;
    }

    .wrapper:before {
        left : calc(var(--MonArrowLeft) - 1px);
        top: -7px;
        border-right: 7px solid transparent;
        border-left: 7px solid transparent;
        border-bottom: 7px solid #ccc;
        position: absolute;
        display: inline-block;
        content: '';
    }
    .wrapper:after {
        content: ' ';
        position: absolute;
        top: -6px;
        left: var(--MonArrowLeft);
        border-right: 6px solid transparent;
        border-bottom: 6px solid #fff;
        border-left: 6px solid transparent;
    }

    .main {
        display: flex;
        border-bottom: 1px solid var(--MonDatePickerBordersColor);
    }

    mon-date-picker-main {
        padding: 5px 0;
    }

    .rangeButttons {
        box-sizing: border-box;
        width: 145px;
        border-right: 1px solid var(--MonDatePickerBordersColor);
        padding: 5px 0;
    }

    .rangeButttons button {
        box-sizing: border-box;
        width: 100%;
        appearance: none;
        border: none;
        background-color: transparent;
        margin: 0;
        text-align: left;
        padding: 8px 12px;
    }
    .rangeButttons button.active,
    .rangeButttons button[data-selected] {
        background-color: var(--MonDatePickerDateButtonsActiveColor);
        color: #ffffff;
    }
    .rangeButttons button[data-selected]:hover {
        background-color: var(--MonDatePickerDateButtonsActiveColor);
        color: #ffffff;
        filter: brightness(1.25);
    }
    .rangeButttons button:hover {
        background-color: var(--MonDatepickerButtonHoverColor);
        cursor: pointer;
    }

    .compareRangeWrapper {
        padding: 12px;
    }

    .compareRangeWrapper label {
        margin-bottom: 7px;
    }

    .compareRangeWrapper label input {
        margin-left: 0;
    }

    .footerButtons {
        display: flex;
        padding: 8px;
        justify-content: end;
    }

    .footerButtons button {
        padding: 8px;
        margin-left: 8px;
        font-weight: 600;
        font-size: 12px;
        border-radius: 3px;
        border: 1px solid transparent;
    }
    .footerButtons button:active {
        border: 1px solid #000000;
    }
    .footerButtons button.apply {
        background-color: var(--MonDatepickerApplyButtonBgColor);
        color: var(--MonDatepickerApplyButtonColor);
    }
    .footerButtons button.apply:hover {
        filter: brightness(1.25);
    }
    .footerButtons button.apply[aria-disabled="true"] {
        opacity: 0.75;
        cursor: not-allowed;
    }

    .footerButtons .rangeBlock {
        display: flex;
        align-items: center;
    }

    .pickerCompareSelection {
        display: inline-block;
        background-color: var(--MonDatepickerApplyButtonBgColor);
        border-radius: var(--MonDatePickerFontSize);
        color: var(--MonDatepickerApplyButtonColor);
        padding: 0 0.5em;
        margin-left: 0.4em;
    }

    .pickerCompareSelection button {
        padding: 0;
    }

    .pickerCompareSelection button svg {
        color: var(--MonDatepickerApplyButtonColor);
        font-size: 1.7em;
    }

`;

const rangeService = {
    // // Previous week
    lastWeek(d) {
        const to = new Date(d);
        to.setDate(to.getDate() - to.getDay() - 1);
        const from = new Date(to);
        from.setDate(from.getDate() - 6);
        return {
            from,
            to,
        };
    },
    // Previous month
    lastMonth(d) {
        return {
            from: new Date(d.getFullYear(), d.getMonth() - 1, 1),
            to: new Date(d.getFullYear(), d.getMonth() - 1 + 1, 0),
        };
    },
    // Previous quarter
    lastQuarter(d) {
        let year = d.getFullYear();
        let monthFrom = Math.ceil((d.getMonth() + 1) / 3) - 1;
        if (monthFrom === 0) {
            year = year - 1;
            monthFrom = 3;
        }
        return {
            from: new Date(year, monthFrom - 1, 1),
            to: new Date(year, monthFrom + 2, 0),
        };
    },
    // Previous two quarters
    lastHalfYear(d) {
        let year = d.getFullYear();
        let monthFrom = Math.ceil((d.getMonth() + 1) / 6) - 2;
        if (monthFrom < 1) {
            year = year - 1;
            monthFrom = 4 + monthFrom;
        }
        return {
            from: new Date(year, monthFrom * 3, 1),
            to: new Date(year, monthFrom * 3 + 6, 0),
        };
    },
    lastYear(d) {
        const previousYear = d.getFullYear() - 1;
        return {
            from: new Date(previousYear, 0, 1),
            to: new Date(previousYear, 12, 0),
        };
    },
};

/* eslint-disable max-len */
const arrowsRotateSvg = '<svg class="compareRangeIcon" role="img" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M464 16c-17.67 0-32 14.31-32 32v74.09C392.1 66.52 327.4 32 256 32C161.5 32 78.59 92.34 49.58 182.2c-5.438 16.81 3.797 34.88 20.61 40.28c16.89 5.5 34.88-3.812 40.3-20.59C130.9 138.5 189.4 96 256 96c50.5 0 96.26 24.55 124.4 64H336c-17.67 0-32 14.31-32 32s14.33 32 32 32h128c17.67 0 32-14.31 32-32V48C496 30.31 481.7 16 464 16zM441.8 289.6c-16.92-5.438-34.88 3.812-40.3 20.59C381.1 373.5 322.6 416 256 416c-50.5 0-96.25-24.55-124.4-64H176c17.67 0 32-14.31 32-32s-14.33-32-32-32h-128c-17.67 0-32 14.31-32 32v144c0 17.69 14.33 32 32 32s32-14.31 32-32v-74.09C119.9 445.5 184.6 480 255.1 480c94.45 0 177.4-60.34 206.4-150.2C467.9 313 458.6 294.1 441.8 289.6z"></path></svg>';
const calendarSvg = `<svg role="img" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
<path fill="currentColor" d="M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm320-196c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM192 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM64 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"></path>
</svg>`;
const closeSvg = '<svg role="img" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="times-circle" class="svg-inline--fa fa-times-circle fa-w-16 fa-lg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"></path></svg>';

const monDatepickerDatesUpdate = 'monDatepickerDatesUpdate';
const monDatepickerCompareDatesUpdate = 'monDatepickerCompareDatesUpdate';
const fakeTranslateService = {
    getString: (value) => value,
};
let MonDatePickerCustom = class MonDatePickerCustom extends LitElement {
    static { this.styles = Styles; }
    set translateService(value) {
        if (value && value.getString) {
            this._translateService = value;
            this.setTexts();
        }
    }
    get translateService() {
        return this._translateService;
    }
    set dateFrom(value) {
        this._dateFrom = new Date(value);
        if (this.selectedFrom.toLocaleDateString() !== value.toLocaleDateString()) {
            this.selectedFrom = new Date(value);
        }
    }
    get dateFrom() {
        return this._dateFrom;
    }
    set dateTo(value) {
        this._dateTo = new Date(value);
        if (this.selectedTo.toLocaleDateString() !== value.toLocaleDateString()) {
            this.selectedTo = new Date(value);
        }
    }
    get dateTo() {
        return this._dateTo;
    }
    set compareDateFrom(value) {
        this._compareDateFrom = value ? new Date(value) : undefined;
        this._compareSelectedFrom = value ? new Date(value) : undefined;
        this.showRangeInputs = Boolean(this.monEnableComparisonRange && this._compareDateFrom && this._compareDateTo);
        this.compareRange = {
            ...this.compareRange,
            ...{ startDate: this._compareSelectedFrom },
        };
    }
    get compareDateFrom() {
        return this._compareDateFrom;
    }
    set compareDateTo(value) {
        this._compareDateTo = value ? new Date(value) : undefined;
        this._compareSelectedTo = value ? new Date(value) : undefined;
        this.showRangeInputs = Boolean(this.monEnableComparisonRange && this._compareDateFrom && this._compareDateTo);
        this.compareRange = {
            ...this.compareRange,
            ...{ endDate: this._compareSelectedTo },
        };
    }
    get compareDateTo() {
        return this._compareDateTo;
    }
    set selectedFrom(value) {
        this._selectedFrom = value;
        this.selectedRange = '';
    }
    get selectedFrom() {
        return this._selectedFrom;
    }
    set selectedTo(value) {
        this._selectedTo = value;
        this.selectedRange = '';
    }
    get selectedTo() {
        return this._selectedTo;
    }
    constructor() {
        super();
        this.applyButton = createRef();
        this.monEnableComparisonRange = false;
        this.monText = {};
        this.showRangeInputs = false;
        this.pickerShown = false;
        this.selectedRange = '';
        this.compareRange = {};
        this.formValid = true;
        this._selectedTo = new Date();
        this._selectedFrom = new Date();
        this._initialFocusApplyBtn = true;
        this._translateService = fakeTranslateService;
        this.documentClickListener = () => {
            this.pickerShown = false;
        };
        this.documentKeydownListener = (e) => {
            if (e.key === 'Escape') {
                this.pickerShown = false;
            }
        };
        this.setTexts();
        this.addEventListener(monDatepickerMainDatesUpdate, (e) => {
            this.selectedFrom = e.detail.dateFrom ? new Date(e.detail.dateFrom) : undefined;
            this.selectedTo = e.detail.dateTo ? new Date(e.detail.dateTo) : undefined;
            this.updateFormValidity();
        });
    }
    firstUpdated() {
        this.addEventListener('click', (e) => {
            e.stopImmediatePropagation();
        });
    }
    updated() {
        if (this.applyButton.value && this._initialFocusApplyBtn) {
            this.applyButton.value.focus();
            this._initialFocusApplyBtn = false;
        }
    }
    setTexts() {
        if (!Object.keys(this.monText).length) {
            this.monText = {
                lastWeek: this.translateService.getString('Last Week'),
                lastMonth: this.translateService.getString('Last Month'),
                lastQuarter: this.translateService.getString('Last Quarter'),
                lastHalfYear: this.translateService.getString('Last Half Year'),
                lastYear: this.translateService.getString('Last Year'),
                compare: this.translateService.getString('Compare'),
                cancel: this.translateService.getString('Cancel'),
                apply: this.translateService.getString('Apply'),
                chooseDateLabel: this.translateService.getString('Choose Date'),
                removeCompareRange: this.translateService.getString('Remove compare range dates'),
                toggleDatePicker: this.translateService.getString('Toggle the datepicker'),
                noDateInFuture: this.translateService.getString('The date cannot be in the future.'),
                /* date-picker-main */
                oneMonthBack: this.translateService.getString('One month back'),
                oneMonthForward: this.translateService.getString('One month forward'),
                cannotForwardMore: this.translateService.getString('Cannot forward more'),
                pressToChooseStart: this.translateService.getString('Press to choose the start day'),
                pressToChooseEnd: this.translateService.getString('Press to choose the end day'),
                /* date-picker-range */
                startDate: this.translateService.getString('Start date'),
                endDate: this.translateService.getString('End date'),
                invalidDate: this.translateService.getString('Please enter a valid date!'),
                invalidEndDate: this.translateService.getString('The end date cannot be before the start date'),
            };
        }
    }
    togglePicker() {
        this.computeArrowPosition();
        this.pickerShown = !this.pickerShown;
        if (this.pickerShown) {
            document.addEventListener('click', this.documentClickListener);
            document.addEventListener('keydown', this.documentKeydownListener);
            this._initialFocusApplyBtn = true;
        }
        else {
            document.removeEventListener('click', this.documentClickListener);
            document.removeEventListener('keydown', this.documentKeydownListener);
        }
    }
    computeArrowPosition() {
        const button = this.shadowRoot.querySelector('button.togglePickerButton');
        if (button) {
            this.style.setProperty('--MonArrowLeft', (button.offsetLeft + button.offsetWidth / 2 - 7) + 'px');
        }
    }
    setRange(range) {
        const method = rangeService[range];
        if (method) {
            const { to, from } = method(new Date());
            this.selectedTo = to;
            this.selectedFrom = from;
            this.selectedRange = range;
        }
    }
    onCompareRangeUpdate(e) {
        const { startDate, endDate } = e.detail;
        this._compareSelectedFrom = startDate ? new Date(startDate) : undefined;
        this._compareSelectedTo = endDate ? new Date(endDate) : undefined;
        this.updateFormValidity();
    }
    cancel() {
        this.selectedFrom = new Date(this._dateFrom);
        this.selectedTo = new Date(this._dateTo);
        this._compareSelectedFrom = this._compareDateFrom;
        this._compareSelectedTo = this._compareDateTo;
        this.compareRange = {
            startDate: this._compareDateFrom,
            endDate: this._compareDateTo,
        };
        this.togglePicker();
    }
    apply(toggle = true) {
        if (this.formValid) {
            this.dispatchEvent(new CustomEvent(monDatepickerDatesUpdate, {
                detail: {
                    dateFrom: new Date(this.selectedFrom).toISOString(),
                    dateTo: new Date(this.selectedTo).toISOString(),
                },
                composed: true,
                bubbles: true,
            }));
            if (this.monEnableComparisonRange) {
                this.dispatchEvent(new CustomEvent(monDatepickerCompareDatesUpdate, {
                    detail: {
                        dateFrom: this.showRangeInputs ? new Date(this._compareSelectedFrom).toISOString() : undefined,
                        dateTo: this.showRangeInputs ? new Date(this._compareSelectedTo).toISOString() : undefined,
                    },
                    composed: true,
                    bubbles: true,
                }));
            }
            if (toggle) {
                this.togglePicker();
            }
        }
    }
    updateFormValidity() {
        if (!this.selectedFrom || !this.selectedTo) {
            this.formValid = false;
            return;
        }
        if (this.monEnableComparisonRange && this.showRangeInputs && (!this._compareSelectedFrom || !this._compareSelectedTo)) {
            this.formValid = false;
            return;
        }
        this.formValid = true;
    }
    handleCompareDate(date) {
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        tomorrow.setHours(0, 0, 0, 0);
        if (date && (date.getTime() >= tomorrow.getTime())) {
            return this.monText.noDateInFuture;
        }
        return '';
    }
    render() {
        return html `
        <div class="generalWrapper">
            <div class="pickerSelection">
                ${this.dateFrom && this.dateTo ? html `
                <div>
                    ${this.dateFrom.toLocaleDateString()} - ${this.dateTo.toLocaleDateString()}

                    ${this.monEnableComparisonRange && this.showRangeInputs && this.compareDateFrom && this.compareDateTo ? html `

                    ${unsafeHTML(arrowsRotateSvg)}
                    <div class="pickerCompareSelection">
                        ${this.compareDateFrom.toLocaleDateString()} - ${this.compareDateTo.toLocaleDateString()}
                        <button type="button" aria-label=${this.monText.removeCompareRange} @click=${() => {
            this.showRangeInputs = false;
            this.updateFormValidity();
            this.apply(false);
        }}>${unsafeHTML(closeSvg)}</button>
                    </div>

                    ` : ''}
                </div>
                ` : ''}
                <button type="button"
                    class="togglePickerButton"
                    @click=${this.togglePicker}
                    aria-label=${this.monText.toggleDatePicker}>
                    ${unsafeHTML(calendarSvg)}
                </button>
            </div>
            <div role="dialog" aria-modal="true" aria-label=${this.monText.chooseDateLabel} class="wrapper" ?hidden=${!this.pickerShown}>
                <focus-trap>
                    <div class="main">
                        <div class="rangeButttons">
                            <button role="button"
                                ?data-selected=${this.selectedRange === 'lastWeek'}
                                @click=${() => this.setRange('lastWeek')}>${this.monText.lastWeek}</button>
                            <button role="button"
                                ?data-selected=${this.selectedRange === 'lastMonth'}
                                @click=${() => this.setRange('lastMonth')}>${this.monText.lastMonth}</button>
                            <button role="button"
                                ?data-selected=${this.selectedRange === 'lastQuarter'}
                                @click=${() => this.setRange('lastQuarter')}>${this.monText.lastQuarter}</button>
                            <button role="button"
                                ?data-selected=${this.selectedRange === 'lastHalfYear'}
                                @click=${() => this.setRange('lastHalfYear')}>${this.monText.lastHalfYear}</button>
                            <button role="button"
                                ?data-selected=${this.selectedRange === 'lastYear'}
                                @click=${() => this.setRange('lastYear')}>${this.monText.lastYear}</button>
                        </div>
                        <mon-date-picker-main
                            .dateFrom=${this.selectedFrom}
                            .dateTo=${this.selectedTo}
                            .monText=${this.monText}
                        ></mon-date-picker-main>
                    </div>
                ${this.monEnableComparisonRange ? html `
                    <div class="compareRangeWrapper">
                        <label>
                            <input
                                type="checkbox"
                                .checked=${this.showRangeInputs}
                                @change="${() => {
            this.showRangeInputs = !this.showRangeInputs;
            this.updateFormValidity();
        }}">${this.monText.compare}</label>
                    ${this.showRangeInputs ? html `
                        <mon-date-picker-range
                            .monText=${this.monText}
                            .model=${this.compareRange}
                            @monCompareRangeUpdateEvent=${this.onCompareRangeUpdate}
                            .validateStartDateCb=${this.handleCompareDate}
                            .validateEndDateCb=${this.handleCompareDate}
                        >
                        </mon-date-picker-range>
                    ` : ''}
                    </div>
                ` : ''}
                    <div class="footerButtons">
                        <div class="rangeBlock">${this.selectedFrom?.toLocaleDateString()} - ${this.selectedTo?.toLocaleDateString()}</div>
                        <button type="button" @click=${this.cancel}>${this.monText.cancel}</button>
                        <button ${ref(this.applyButton)}
                            class="apply"
                            type="button"
                            @click=${this.apply}
                            aria-disabled=${this.formValid ? 'false' : 'true'}
                        >${this.monText.apply}</button>
                    </div>
                </focus-trap>
            </div>
        </div>
    `;
    }
};
__decorate([
    property({ type: Object })
], MonDatePickerCustom.prototype, "translateService", null);
__decorate([
    property({ type: Object })
], MonDatePickerCustom.prototype, "dateFrom", null);
__decorate([
    property({ type: Object })
], MonDatePickerCustom.prototype, "dateTo", null);
__decorate([
    property({ type: Object })
], MonDatePickerCustom.prototype, "compareDateFrom", null);
__decorate([
    property({ type: Object })
], MonDatePickerCustom.prototype, "compareDateTo", null);
__decorate([
    property({ type: Boolean })
], MonDatePickerCustom.prototype, "monEnableComparisonRange", void 0);
__decorate([
    property({ type: Object })
], MonDatePickerCustom.prototype, "monText", void 0);
__decorate([
    state$1()
], MonDatePickerCustom.prototype, "showRangeInputs", void 0);
__decorate([
    state$1()
], MonDatePickerCustom.prototype, "selectedFrom", null);
__decorate([
    state$1()
], MonDatePickerCustom.prototype, "selectedTo", null);
__decorate([
    state$1()
], MonDatePickerCustom.prototype, "pickerShown", void 0);
__decorate([
    state$1()
], MonDatePickerCustom.prototype, "selectedRange", void 0);
__decorate([
    state$1()
], MonDatePickerCustom.prototype, "compareRange", void 0);
__decorate([
    state$1()
], MonDatePickerCustom.prototype, "formValid", void 0);
MonDatePickerCustom = __decorate([
    customElement('mon-date-picker-custom')
], MonDatePickerCustom);

class MockMonEventService {
    // eslint-disable-next-line
    addListener(_type, _fn) {
        return 1;
    }
    // eslint-disable-next-line
    run(..._args) {
        return Promise.resolve();
    }
    // eslint-disable-next-line
    remove(_id) { }
}

class MockLabelTableService {
    constructor() {
        this.hideLabelTxt = () => Promise.resolve();
        this.showLabelTxt = () => Promise.resolve();
        this.setEditable = () => Promise.resolve();
    }
}

// not sure why eslint complains here about shadow-variable
// eslint-disable-next-line no-shadow
var ACCOUNT_TYPE;
(function (ACCOUNT_TYPE) {
    ACCOUNT_TYPE["customer"] = "Customer";
    ACCOUNT_TYPE["reseller"] = "Reseller";
})(ACCOUNT_TYPE || (ACCOUNT_TYPE = {}));

class User {
    constructor(user) {
        Object.assign(this, user);
    }
    isEditable() {
        let agreements = this.user_agreements;
        if (Array.isArray(agreements) && agreements.length > 0) {
            agreements = agreements.filter((agreement) => agreement.account.type === ACCOUNT_TYPE.customer);
            return agreements.length > 0;
        }
        return false;
    }
    getResellerAgreementName() {
        if (Array.isArray(this.user_agreements)) {
            const agreement = this.user_agreements.find((dataAgreement) => dataAgreement.account.type === ACCOUNT_TYPE.reseller);
            if (agreement) {
                return agreement.account.name;
            }
        }
        return null;
    }
    getCustomerCount() {
        if (this.user_agreements) {
            return this.user_agreements.reduce((num, agreement) => {
                if (agreement.account.type === ACCOUNT_TYPE.customer) {
                    num++;
                }
                return num;
            }, 0);
        }
        return 0;
    }
    getFirstCustomerId() {
        const agreement = this.user_agreements.find((dataAgreement) => dataAgreement.account.type === ACCOUNT_TYPE.customer);
        if (agreement) {
            return agreement.account.id;
        }
        else {
            return null;
        }
    }
    getAvatarInitials() {
        let name = StringService.capitalize(this.first_name || '').split(' ')[0];
        if (this.last_name) {
            name +=
                ' ' + StringService.capitalize(this.last_name).split(' ')[0];
        }
        return [name].join(' ').trim();
    }
}

class NgbdModalComponent {
    constructor(activeModal) {
        this.activeModal = activeModal;
    }
    static { this.ɵfac = function NgbdModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || NgbdModalComponent)(i0.ɵɵdirectiveInject(i1$4.NgbActiveModal)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: NgbdModalComponent, selectors: [["mon-ngbd-modal-content"]], inputs: { text: "text" }, decls: 5, vars: 1, consts: [[1, "text-center"], [1, "my-4"], ["aria-hidden", "true", 1, "fa", "fa-spinner", "fa-spin", "fa-3x", "fa-fw"]], template: function NgbdModalComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "h2", 0);
            i0.ɵɵtext(1);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "div", 1)(3, "div", 0);
            i0.ɵɵelement(4, "span", 2);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", ctx.text, " ");
        } }, encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NgbdModalComponent, [{
        type: Component,
        args: [{ selector: 'mon-ngbd-modal-content', template: "<h2 class=\"text-center\"> {{text}} </h2>\n<div class=\"my-4\">\n    <div class=\"text-center\">\n        <span class=\"fa fa-spinner fa-spin fa-3x fa-fw\"\n            aria-hidden=\"true\"></span>\n    </div>\n</div>" }]
    }], () => [{ type: i1$4.NgbActiveModal }], { text: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(NgbdModalComponent, { className: "NgbdModalComponent" }); })();

class LoadingService {
    constructor(modalService, translateService) {
        this.modalService = modalService;
        this.translateService = translateService;
    }
    service(text) {
        this.createdModal = this.modalService.open(NgbdModalComponent, {
            backdrop: 'static',
        });
        this.createdModal.componentInstance.text = text || this.translateService.getString('Please wait - loading');
        return this.createdModal;
    }
    close() {
        if (this.createdModal) {
            this.createdModal.close();
        }
    }
    static { this.ɵfac = function LoadingService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || LoadingService)(i0.ɵɵinject(i1$4.NgbModal), i0.ɵɵinject(TranslateServiceInjectionToken)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: LoadingService, factory: LoadingService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoadingService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], () => [{ type: i1$4.NgbModal }, { type: undefined, decorators: [{
                type: Inject,
                args: [TranslateServiceInjectionToken]
            }] }], null); })();

class MockStorageService {
    constructor() {
        this.getItem = () => '';
        this.setItem = () => Promise.resolve();
        this.removeItem = () => Promise.resolve();
        this.clear = () => Promise.resolve();
        this.key = () => '';
    }
}

class MockToastService {
    constructor() {
        this.success = () => Promise.resolve();
        this.warning = () => Promise.resolve();
        this.error = () => Promise.resolve();
        this.info = () => Promise.resolve();
    }
}

class MockTranslateService {
    constructor() {
        this.getString = (input) => input;
        this.onLanguageChange$ = () => new Observable();
    }
    setCurrentLanguage(_lang) { }
    setStrings(_language, _strings) { }
    static { this.ɵfac = function MockTranslateService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MockTranslateService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MockTranslateService, factory: MockTranslateService.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MockTranslateService, [{
        type: Injectable
    }], () => [], null); })();

class MockSearchService {
    constructor() {
        this.fuzzy = () => true;
    }
}

// Main module

/**
 * Generated bundle index. Do not edit.
 */

export { AccessibleChartWrapperComponent, AccessibleChartWrapperModule, ActiveDialog, AngularSharedComponentsModule, AvatarEmailComponent, BackdropComponent, BarComponent, BarlineComponent, BaseFieldComponent, BubbleComponent, CHART, CUSTOM_ICONS, CapitalizePipe, ChartService, CheckboxComponent, ColorPickerComponent, ColorPickerModule, ConfirmDirective, ConfirmModule, ContainerComponent, ContainerPagerComponent, ContentRef, CopyDialogComponent, CopyDialogModule, CopyDialogService, CopyModule, DIALOG_STATE, DatepickerAcComponent, DatepickerAcModule, DatepickerComponent, DatepickerModule, DialogComponent, DialogModule, DialogRef, DialogService, DocumentsButtonComponent, DoughnutComponent, DynamicAcComponent, DynamicComponent, EmailValidatorDirective, ErrorMessagesAcComponent, ErrorMessagesComponent, EscapeRegExpPipe, EventTriggerDirective, EventsModule, EventsService, FallbackLanguageService, FilterButtonComponent, FilterButtonModule, FilterByStringPipe, FiltersDropdownComponent, FiltersDropdownModule, FormBuilderCheckboxModule, FormBuilderDynamicAcModule, FormBuilderDynamicModule, FormBuilderInputModule, FormBuilderSelectAcModule, FormBuilderSelectModule, FormBuilderValidationModule, FormLabelComponent, FormLabelModule, FormStyledDialogComponent, FormsBuilderModule, GettextPluralsService, HorizontalBarComponent, IconCircleComponent, IconComponent, IconsModule, IconsService, InputComponent, InverseColorCode, LabelContainerComponent, LabelContainerSelectorComponent, LabelModule, LabelTableComponent, LayoutModule, LineComponent, LoadingService, LocalStorageService, MON_DIRECT_ICONS, MON_ICONS, MockActiveDialogService, MockChartService, MockDialogService, MockLabelTableService, MockMonEventService, MockSearchService, MockStorageService, MockToastService, MockTranslateService, MonAvatarModule, MonChartCustomTooltipDirective, MonChartCustomTooltipModule, MonChartsModule, MonCopyComponent, MonDashboardProgressBarComponent, MonDatePickerComponent, MonDatePickerCustom, MonDatePickerMain, MonDatePickerModule, MonDatePickerRange, MonEventService, MonEventTriggerModule, MonHttpPrefixDirective, MonHttpPrefixModule, MonMaxDirective, MonMinDirective, MultiselectNextComponent as MonMultiselectNextComponent, MonPanelComponent, MonPanelHeaderComponent, MonPopupComponent, MonPopupModule, MonPromptComponent, MonPromptComponentModule, MonPromptComponentsModule, MonPromptModule, MonPromptService, MonSelectAllCheckboxDirective, MonSelectAllCheckboxModule, SelectNextAcComponent as MonSelectNextAcComponent, SelectNextComponent as MonSelectNextComponent, MonSimpleDateRangeComponent, MonSimpleDateRangeModule, MonSpinnerComponent, MonSwitchComponent, MonSwitchModule, MonTableSortComponent, MonTableSortModule, MonTableSpoilerAccordionModule, MultiselectNextComponent, NotificationChangeComponent, NotificationComponent, NotificationTextComponent, PRO_ICONS, PageHeaderComponent, PageSizeComponent, PagesButtonComponent, PieComponent, PipesModule, PriorityComponent, PromptDirective, PromptModule, ROLLBAR_CONFIGURATION, RadioNewLineAcComponent, RadioNewLineAcModule, RadioNewLineComponent, RadioNewLineModule, RemovePlaceholderDirective, RemovePlaceholderModule, RollbarModule, RollbarService, SelectAcComponent, SelectComponent, SelectItemAllComponent, SelectItemComponent, SelectNextAcComponent, SelectNextComponent, SessionStorageService, SpinnerSnakeComponent, StackedIconComponent, StorageModule, SwitchButtonComponent, SwitchButtonModule, TableComplianceComponent, TableDateComponent, TableDropdownComponent, TableFiltersComponent, TableFiltersModule, TableFiltersSelectorComponent, TableFiltersSelectorModule, TableModule, TableSearchComponent, TableSearchModule, TableSpoilerAccordionDirective, TabsComponent, TabsModule, TextareaAcComponent, TextareaAcModule, TextareaComponent, TextareaModule, TimezonesAcComponent, TimezonesComponent, ToastModule, ToastService, TranslateDirective, TranslateModule, TranslatePipe, TranslateService, TranslateServiceInjectionToken, UrlTitleComponent, User, UserDateComponent, UserDatePipe, ValidateUrlDirective, VisitsComponent, dialogAnimations };
